(function() {
    'use strict';

    angular
        .module('gwApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ui.select2',
            'ja.qr',
            // 'easypiechart',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.rCalendar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserPasswordController', UserPasswordController);

    UserPasswordController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','$uibModal','$uibModalInstance','MessageService','$timeout', 'entity'];

    function UserPasswordController ($scope, Principal, LoginService,$state,User,$uibModal,$uibModalInstance,MessageService,$timeout, entity) {
        var vm = this;
        vm.user = entity;


        $scope.save = function() {
            if(vm.user.password == "" || vm.user.password == null){
                MessageService.error("旧密码不能为空");
                return;
            }
            if (vm.user.password.length<4 || vm.user.password.length >100) {
                MessageService.error("旧密码长度在4-100位之间");
                return false;
            }
            if(vm.user.password2 == "" || vm.user.password2 == null){
                MessageService.error("新密码不能为空");
                return;
            }
            if (vm.user.password2.length<4 || vm.user.password2.length >100) {
                MessageService.error("新密码长度在4-100位之间");
                return false;
            }
            if (vm.user.confirmPassword == null || vm.user.confirmPassword == "") {
                MessageService.error("确认密码不能为空");
                return false;
            }
            if (vm.user.confirmPassword != vm.user.password2) {
                MessageService.error("确认密码与新密码不一致");
                return false;
            }
            if (vm.user.confirmPassword.length<4 || vm.user.confirmPassword.length >100) {
                MessageService.error("确认密码长度在4-100位之间");
                return false;
            }
            vm.isSaving = true;
            User.reset2({
                id: vm.user.id,
                username: vm.user.username,
                password: vm.user.password,
                password2: vm.user.password2
            }, function (res) {
                vm.isSaving = false;
                if(res.state == "201"){
                    MessageService.error('旧密码不正确');
                    return
                }
                if(res.state == "200"){
                    MessageService.success('重置密码成功');
                    $uibModalInstance.close(vm.user);
                }
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("重置密码失败");
            });
        };
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserEditController', UserEditController);

    UserEditController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Role', 'entity', '$stateParams'];

    function UserEditController ($scope, Principal, LoginService, $state,User,MessageService,Role, entity, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_USER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有用户访问的权限！");
                $state.go("home");
            }
        });
        vm.user = entity;

        init();
        function init(){
            Role.query({type:"内部"},function(data){
                vm.role = data;
                for(var i=0;i<vm.role.length;i++){
                    if(vm.role[i].id==entity.roleId){
                        vm.user.role = vm.role[i].id;
                    }
                }
                vm.roleList = data;
                vm.role = [];
                if(vm.roleList.length>0){
                    for(var i=0;i<vm.roleList.length;i++){
                        if(vm.roleList[i].enabled){
                            vm.role.push(vm.roleList[i]);
                        }
                    }
                }
            });
        }

        // Role.query({},function(data){
        //     vm.roleList = data;
        //     vm.role = [];
        //     if(vm.roleList.length>0){
        //         for(var i=0;i<vm.roleList.length;i++){
        //             if(vm.roleList[i].enabled){
        //                 vm.role.push(vm.roleList[i]);
        //             }
        //         }
        //     }
        // });

        $scope.save = function () {
            if(!vm.user.username){
                MessageService.error("用户名不能为空");
                return;
            }
            if(!vm.user.role){
                MessageService.error("角色不能为空");
                return;
            }

            if (vm.user.phone == null || vm.user.phone == "") {
                MessageService.error("联系方式不能为空");
                return false;
            }
            // if(!(/^1[345678]\d{9}$/.test(vm.user.phone))){
            //     MessageService.error("请输入正确的手机号");
            //     return;
            // }
            vm.isSaving = true;
            for(var i=0;i<vm.role.length;i++){
                if(vm.role[i].id == vm.user.role){
                    vm.user.roleId = vm.role[i].id;
                    vm.user.roleName = vm.role[i].name;
                }
            }
            User.update(vm.user, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("user",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("user",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserAddController', UserAddController);

    UserAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Role'];

    function UserAddController ($scope, Principal, LoginService, $state,User,MessageService,Role) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_USER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有用户访问的权限！");
                $state.go("home");
            }
        });

        init();
        function init(){
            vm.user = {
                username: '',
                role: '',
                password: '',
                confirmpassword: '',
                fullname: '',
                phone: '',
            };
        }

        Role.query({type:"内部"},function(data){
            vm.roleList = data;
            vm.role = [];
            if(vm.roleList.length>0){
                for(var i=0;i<vm.roleList.length;i++){
                    if(vm.roleList[i].enabled){
                        vm.role.push(vm.roleList[i]);
                    }
                }
            }
        });

        $scope.save = function () {
            if(!vm.user.username){
                MessageService.error("用户名不能为空");
                return;
            }
            if(!vm.user.role){
                MessageService.error("角色不能为空");
                return;
            }
            if(!vm.user.password){
                MessageService.error("密码不能为空");
                return;
            }
            if(vm.user.confirmpassword!=vm.user.password){
                MessageService.error("两次输入的密码不匹配");
                return;
            }
            if (vm.user.phone == null || vm.user.phone == "") {
                MessageService.error("联系方式不能为空");
                return false;
            }
            // if(!(/^1[345678]\d{9}$/.test(vm.user.phone))){
            //     MessageService.error("请输入正确的手机号");
            //     return;
            // }
            vm.isSaving = true;
            for(var i=0;i<vm.role.length;i++){
                if(vm.role[i].id == vm.user.role){
                    vm.user.roleId = vm.role[i].id;
                    vm.user.roleName = vm.role[i].name;
                }
            }
            vm.user.name = vm.user.username;
            User.validate({name:vm.user.name},function (res) {
                vm.isSaving = false;
                if (res.message) {
                    User.save(vm.user, onSaveSuccess, onSaveError);
                } else {
                    MessageService.error("系统存在重复的用户名");
                }
            },function (error) {
                vm.isSaving = false;
                MessageService.error("操作失败");
            });
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("用户添加成功");
                $state.go("user");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("系统存在重复的用户名");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user', {
            parent: 'module',
            url: '/user',
            params:{page: null},
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content': {
                    templateUrl: 'app/user/user.html',
                    controller: 'UserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('user');
                    $translatePartialLoader.addPart('role');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
            .state('userAdd', {
                parent: 'module',
                url: '/userAdd',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/user/user-add.html',
                        controller: 'UserAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('user');
                        return $translate.refresh();
                    }]
                }
            })
            .state('userEdit', {
                parent: 'module',
                url: '/userEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/user/user-edit.html',
                        controller: 'UserEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('user');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'User', function ($stateParams, User) {
                        return User.id({id: $stateParams.id});
                    }]
                }
            })
            .state('role', {
                parent: 'module',
                url: '/role',
                params:{page: null},
                data: {
                    authorities: ['ROLE_ROLE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/user/role.html',
                        controller: 'RoleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('user');
                        $translatePartialLoader.addPart('role');
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('roleAdd', {
                parent: 'module',
                url: '/roleAdd',
                data: {
                    authorities: ['ROLE_ROLE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/user/role-add.html',
                        controller: 'RoleAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        return $translate.refresh();
                    }]
                }
            })
            .state('roleEdit', {
                parent: 'module',
                url: '/roleEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_ROLE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/user/role-edit.html',
                        controller: 'RoleEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Role', function($stateParams, Role) {
                        return Role.get({id : $stateParams.id});
                    }],
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserController', UserController);

    UserController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', '$uibModal', '$stateParams'];

    function UserController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, $uibModal, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_USER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有用户访问的权限！");
                $state.go("home");
            }
        });
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            key:''
        };

        init()
        function init() {
            vm.tableList = [];
            User.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该用户？", function () {
                User.delete({id: data.id}, function () {
                    init();
                    MessageService.success("用户删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
        //重置密码
        $scope.modifyContent = function(data){

            vm.user=data;
            $uibModal.open({
                templateUrl: 'app/user/user-password.html',
                controller: 'UserPasswordController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return vm.user;
                    }
                }
            }).result.then(function(result){
                if(result){
                    init()
                }
            });

        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RoleEditController', RoleEditController);

    RoleEditController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Permission', 'Role', 'entity', '$stateParams','$q'];

    function RoleEditController ($scope, Principal, LoginService, $state,User,MessageService, Permission, Role, entity, $stateParams,$q) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_ROLE').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有角色访问的权限！");
                $state.go("home");
            }
        });

        vm.role = entity;
        vm.permissions = Permission.getAllByScope({permissionScope:'MAINEND'});

        $q.all([vm.role.$promise,vm.permissions.$promise]).then(function(){
            if(vm.permissions.length>0){
                $scope.groupBy(vm.permissions);
            }
        });

        $scope.groupBy = function(list){
            if(list == null){
                return null;
            }
            vm.finalList = [];
            for(var j=0;j<list.length;j++){
                vm.pushFlag = false;
                if(vm.finalList.length<=0){
                    vm.finalList.push({module:list[j].module,names:[]});
                    vm.finalList[0].names.push({name:list[j].name,authority:list[j].authority,id:list[j].id});
                }else{
                    for(var k=0;k<vm.finalList.length;k++){
                        if(vm.finalList[k].module==list[j].module&&vm.finalList[k].names.indexOf(list[j].name)<0){
                            vm.finalList[k].names.push({name:list[j].name,authority:list[j].authority,id:list[j].id});
                            vm.pushFlag = true;
                        }
                    }
                    if(!vm.pushFlag){
                        vm.finalList.push({module:list[j].module,names:[{name:list[j].name,authority:list[j].authority,id:list[j].id}]});
                    }
                }
            }

            for(var a=0; a<vm.finalList.length; a++){
                var _selected = true;
                for(var b=0; b<vm.finalList[a].names.length; b++){
                    for(var c=0; c<vm.role.permissions.length; c++){
                        if(vm.role.permissions[c].id === vm.finalList[a].names[b].id){
                            vm.finalList[a].names[b].selected = true;
                        }
                    }
                    if(!vm.finalList[a].names[b].selected){
                        _selected = false;
                    }
                }
                vm.finalList[a].selected = _selected;
            }
            console.log(vm.finalList)
        };
        $scope.permissionsSelect = function(data){
            for(var i=0; i<data.names.length; i++){
                data.names[i].selected = data.selected;
            }
        };
        $scope.permissionsRoleSelect = function(data){
            var _selected = true;
            for(var i=0; i<data.names.length; i++){
                if(!data.names[i].selected){
                    _selected = false;
                }
            }
            data.selected = _selected;
        };
        $scope.save = function() {
            vm.role.permissions = [];
            for(var i=0;i<vm.finalList.length;i++){
                for(var j=0;j<vm.finalList[i].names.length;j++){
                    if(vm.finalList[i].names[j].selected==true){
                        vm.role.permissions.push({id:vm.finalList[i].names[j].id,name:vm.finalList[i].names[j].name,
                            authority:vm.finalList[i].names[j].authority,module:vm.finalList[i].module
                        });
                    }
                }
            }
            if(!vm.role.name){
                MessageService.error("角色名称不能为空");
                return;
            }
            vm.isSaving = true;
            Role.update(vm.role, function (res) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("role",{page: $stateParams.page});
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试!");
            });
        };
        //返回
        $scope.goBack = function () {
            $state.go("role",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RoleAddController', RoleAddController);

    RoleAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Permission', 'Role'];

    function RoleAddController ($scope, Principal, LoginService, $state,User,MessageService, Permission, Role) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_ROLE').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有角色访问的权限！");
                $state.go("home");
            }
        });
        vm.typeList = [
            {name:'内部', value:'内部'},
            {name:'供应商', value: '供应商'}
        ];
        vm.role = {
            enabled: true,
            type:'内部'
        }

        init();
        function init() {

            Permission.getAllByScope({permissionScope:'MAINEND'},function(result) {
                vm.permissions = result;
                if(vm.permissions.length>0){
                    $scope.groupBy(vm.permissions);
                }
            });
        }
        $scope.groupBy = function(list){
            if(list == null){
                return null;
            }
            vm.finalList = [];
            for(var j=0;j<list.length;j++){
                vm.pushFlag = false;
                if(vm.finalList.length<=0){
                    vm.finalList.push({module:list[j].module,names:[]});
                    vm.finalList[0].names.push({name:list[j].name,authority:list[j].authority,id:list[j].id});
                }else{
                    for(var k=0;k<vm.finalList.length;k++){
                        if(vm.finalList[k].module==list[j].module&&vm.finalList[k].names.indexOf(list[j].name)<0){
                            vm.finalList[k].names.push({name:list[j].name,authority:list[j].authority,id:list[j].id});
                            vm.pushFlag = true;
                        }
                    }
                    if(!vm.pushFlag){
                        vm.finalList.push({module:list[j].module,names:[{name:list[j].name,authority:list[j].authority,id:list[j].id}]});
                    }
                }
            }
        };
        $scope.permissionsSelect = function(data){
            for(var i=0; i<data.names.length; i++){
                data.names[i].selected = data.selected;
            }
        };
        $scope.permissionsRoleSelect = function(data){
            var _selected = true;
            for(var i=0; i<data.names.length; i++){
                if(!data.names[i].selected){
                    _selected = false;
                }
            }
            data.selected = _selected;
        };
        $scope.save = function() {
            vm.role.permissions = [];
            for(var i=0;i<vm.finalList.length;i++){
                for(var j=0;j<vm.finalList[i].names.length;j++){
                    if(vm.finalList[i].names[j].selected==true){
                        vm.role.permissions.push({id:vm.finalList[i].names[j].id,name:vm.finalList[i].names[j].name,
                            authority:vm.finalList[i].names[j].authority,module:vm.finalList[i].module
                        });
                    }
                }
            }
            if(!vm.role.name){
                MessageService.error("角色名称不能为空");
                return;
            }
            vm.isSaving = true;
            Role.validate({name:vm.role.name},function (res) {
                vm.isSaving = false;
                Role.save(vm.role, function (res) {
                    vm.isSaving = false;
                    MessageService.success("保存成功");
                    $state.go("role");
                }, function (error) {
                    vm.isSaving = false;
                    MessageService.error("修改失败，请稍后重试!");
                });
            },function (error) {
                vm.isSaving = false;
                MessageService.error("系统存在重复的用户名");
            });
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Role', Role);

    Role.$inject = ['$resource'];

    function Role ($resource) {
        var resourceUrl =  'api/roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                    params: {
                        id: 'page'
                    },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'update': { method:'PUT' } ,
            'validate': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RoleController', RoleController);

    RoleController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','Role', 'ParseLinks', '$stateParams'];

    function RoleController ($scope, Principal, LoginService, $state,User,MessageService, Role, ParseLinks, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_ROLE').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有角色访问的权限！");
                $state.go("home");
            }
        });
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: '内部',
            sort: ['createdDate,DESC'],
            key: ''
        };
        // vm.typeList = [
        //     {name:'内部', value:'内部'},
        //     {name:'供应商', value: '供应商'}
        // ];
        init()
        function init() {
            vm.tableList = [];
            Role.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.roleDelete = function (data) {
            MessageService.confirm("确认要删除该角色？", function () {
                Role.delete({id: data.id}, function () {
                    init();
                    MessageService.success("角色删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('TaskAllocationController', TaskAllocationController);

    TaskAllocationController.$inject = ['$scope', 'Principal', '$state','User','MessageService','Product', 'ParseLinks', '$uibModal', 'SalesOrder', '$timeout', '$stateParams'];

    function TaskAllocationController ($scope, Principal, $state,User,MessageService, Product, ParseLinks, $uibModal, SalesOrder, $timeout, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PRODUCT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有商品访问的权限！");
                $state.go("home");
            }
        });

        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.selection = [
            {name:'全部', value:'all'},
            {name:'待分配', value:'ToAssigned'},
            {name:'已分配', value:'Assigned'},
            {name:'已回传', value:'Uploaded'}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: '',
            status:'all'
        };

        //获取选中的数组
        $scope.checked =[];
        $scope.selectOne = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.tableList.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
        };

        //点击分配 可多选 最终只取待分配的订单
        $scope.distribute = function(){
            var existing = $scope.checked.filter(function(item){
                return item.composingStatus =='Assigned'|| item.composingStatus =='Uploaded';
            });
            if(existing.length >0){
                MessageService.error('请选择待分配的订单分配！')
            }else if($scope.checked.length==0){
                MessageService.error('请选择列表项');
            }else{
                $uibModal.open({
                    templateUrl: 'app/task/task-distribute.html',
                    controller: 'TaskDistributeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            return $translate.refresh();
                        }],
                        msgdata: function() {
                            return $scope.checked;
                        }
                    }
                }).result.then(function(result){
                    angular.forEach(vm.tableList, function (item) {
                        item.checked = false;
                    });
                    init();
                });
            }
        };


        //点击备注  单选
        $scope.addRemark = function(){
            if($scope.checked.length==0){
                MessageService.error('请选择列表项');
            }else if($scope.checked.length>1){
                MessageService.error('请选择一项添加备注');
            }else{
                $uibModal.open({
                    templateUrl: 'app/task/remark.html',
                    controller: 'RemarkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            return $translate.refresh();
                        }],
                        msgdata: function() {
                            return $scope.checked;
                        }
                    }
                }).result.then(function(result){
                    angular.forEach(vm.tableList, function (item) {
                        item.checked = false;
                    });
                    init();
                });
            }
        };


        var _h = angular.element(".table-top").find(".table-state").height();
        if(_h > 40){
            vm.isTableState = true;
        }else {
            vm.isTableState = false;
        }

        init();
        function init() {
            vm.tableList = [];
            $scope.checked = [];
            $scope.select_all = false;
            SalesOrder.getOrderTask(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.conditionSelect = function(data){
            vm.tableData.status = data.value;
            vm.tableData.page = 0;
            init();
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                angular.element(".table-top").height("40");
                angular.element(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                angular.element(".table-top").height("auto");
                angular.element(".table-state-btn").addClass("table-state-btnOn");
            }
        };

        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('TaskDistributeController', TaskDistributeController);

    TaskDistributeController.$inject = ['$scope','$state','User','msgdata','$uibModal','SalesOrder','$uibModalInstance','MessageService'];

    function TaskDistributeController ($scope, $state,User,msgdata,$uibModal,SalesOrder,$uibModalInstance,MessageService) {
        var vm = this;

        init();
        function init() {
            vm.tableList = User.getEmployee();
        }

        $scope.taskOne = function(data){
            if(data.selected){
                angular.forEach(vm.tableList,function(item){
                    if(item.selected && item == data){

                    }else{
                        item.selected = false;
                    }
                })
            }
        };

        var id;
        $scope.assignTask = function(){
            if(vm.tableList.filter(function(item){return item.selected;}).length >0){
                angular.forEach(vm.tableList,function(item){
                    if(item.selected){
                        id = item.id;
                    }
                });
                SalesOrder.taskAssigned({
                    ids:msgdata.map(function(item){return item.id}).join(','),
                    userId:id
                },function(res){
                    MessageService.success('分配成功！');
                    $uibModalInstance.close();
                },function(error){
                    MessageService.error('分配失败');
                });
            }else{
                MessageService.error('请选择分配员工');
            }
        };

        $scope.cancelTask = function(){
            angular.forEach(vm.tableList,function(item){
                item.selected = false;
            });
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('taskAllocation', {
                parent: 'module',
                url: '/taskAllocation',
                data: {
                    authorities: ["ROLE_TASK_ALLOCATION"]
                },
                views: {
                    'content': {
                        templateUrl: 'app/task/taskAllocation.html',
                        controller: 'TaskAllocationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('myTasks', {
                parent: 'module',
                url: '/myTasks',
                params:{page: null},
                data: {
                    authorities: ["ROLE_MY_TASK"]
                },
                views: {
                    'content': {
                        templateUrl: 'app/task/myTask.html',
                        controller: 'MyTaskController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

//(function() {
//    'use strict';
//    angular
//        .module('gwApp')
//        .factory('Product', Product)
//        .factory('ProductCategory', ProductCategory);
//
//    Product.$inject = ['$resource'];
//    ProductCategory.$inject = ['$resource'];
//
//    function Product ($resource) {
//        var resourceUrl =  'api/products/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true,
//                params: {
//                    id: 'page'
//                },
//            },
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'getAll': {
//                method:'GET',
//                isArray: true,
//                params: {
//                    path: 'getAll'
//                }
//            } ,
//            'delete':{
//                method:'DELETE',
//                params: {
//                    id: 'id'
//                }
//            },
//            'save': { method:'POST' } ,
//            'update': { method:'PUT' } ,
//            'validate': {method:'GET',
//                params:{
//                    id:'exists'
//                }
//            }
//        });
//    };
//    function ProductCategory ($resource) {
//        var resourceUrl =  'api/product-category/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true,
//                params: {
//                    id: 'pages'
//                },
//            },
//            'getAll': {
//                method:'GET',
//                isArray: true,
//            } ,
//            'get': {
//                method: 'GET',
//                isArray: true,
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'gets': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'delete':{
//                method:'DELETE',
//                params: {
//                    id: 'id'
//                }
//            },
//            'save': { method:'POST' } ,
//            'update': { method:'PUT' } ,
//            'validate': {method:'GET',
//                params:{
//                    id:'exists'
//                }
//            }
//        });
//    };
//})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RemarkController', RemarkController);

    RemarkController.$inject = ['$scope','$state','msgdata','SalesOrder','$uibModalInstance','MessageService'];

    function RemarkController ($scope,$state,msgdata,SalesOrder,$uibModalInstance,MessageService) {
        var vm = this;

        console.log(msgdata);
        vm.remark =msgdata[0].serviceRemarks;

        $scope.assignRemark = function(){
            if(!vm.remark){
                MessageService.error('备注不能为空');
                return;
            }
            SalesOrder.addRemarks({
                orderId:msgdata[0].id,
                remarks:vm.remark
            },function(res){
                MessageService.success('添加备注成功！');
                $uibModalInstance.close();
            },function(error){
                MessageService.error('添加备注失败');
            });
        };

        $scope.cancelRemark = function(){
            $uibModalInstance.close();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MyTaskController', MyTaskController);

    MyTaskController.$inject = ['$scope', 'Principal', '$state','User','MessageService','$sessionStorage','$localStorage','$location','ParseLinks', 'SalesOrder', '$timeout', '$stateParams'];

    function MyTaskController ($scope, Principal, $state,User,MessageService, $sessionStorage,$localStorage,$location, ParseLinks, SalesOrder, $timeout, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PRODUCT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有商品访问的权限！");
                $state.go("home");
            }
        });
        vm.isTableState = false;
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.selection = [
            {name:'全部', value:'all'},
            {name:'已分配', value:'Assigned'},
            {name:'已回传', value:'Uploaded'}
        ];
        vm.user = $sessionStorage.user;
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: '',
            username:vm.user.username,
            status:'all'
        };
        $scope.checked =[];
        $scope.selectOne = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if(vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            }else{
                $scope.select_all = false;
            }
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.tableList.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
        };

        //回传  传的是zip格式的文件 只能选一个
        $scope.reloadUp = function(){
            if($scope.checked.length==0){
                MessageService.error('请选择列表项！');
            }else if($scope.checked.length>1){
                MessageService.error('请选择一项进行回传！');
            }else{
                angular.element('#uploads').modal('show');
                console.log($scope.checked);
                if($scope.checked[0].postbackFile !=null){
                    vm.fileName = $scope.checked[0].postbackFile.split("\\")[2];
                }
            }
        };

        //文件上传  二次上传覆盖之前上传的文件
        window.upladFile = function($event) {
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'zip'){
                angular.element("#file").val("");
                MessageService.error("只能上传.zip类型的文件!");
                return;
            }
            var url =  $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/sales_order/postback";

            var formData = new FormData();
            formData.append('file', fileObj);
            formData.append('orderId', $scope.checked[0].id);

            $.ajax({
                cache: true,
                type: "POST",
                url: url,
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                headers: {
                    Authorization: "Bearer " + vm.token
                },
                accept: 'file',
                success: function (data) {
                    angular.element("#file").val("");
                    MessageService.success("文件上传成功");
                    if(data.message == "回传成功"){
                        vm.fileName = fileObj.name;
                        $scope.$apply();
                        init();
                    }
                },
                error: function (error) {
                    angular.element("#file").val("");
                    MessageService.error("文件上传失败，请稍后重试！");
                }
            });
        };


        //下载  可以选多个
        $scope.downloadFile = function(){
            if($scope.checked.length==0){
                MessageService.error('请选择列表项');
            }else{



            }
        };

        $scope.uploadHide = function(){
            angular.element('#uploads').modal('hide');
            angular.forEach(vm.tableList, function (item) {
                item.checked = false;
            });
        };

        var _h = angular.element(".table-top").find(".table-state").height();
        if(_h > 40){
            vm.isTableState = true;
        }else {
            vm.isTableState = false;
        }

        init();
        function init() {
            vm.tableList = [];
            $scope.select_all = false;
            $scope.checked =[];
            SalesOrder.getOrderTask(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.conditionSelect = function(data){
            vm.tableData.status = data.value;
            vm.tableData.page = 0;
            init();
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                angular.element(".table-top").height("40");
                angular.element(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                angular.element(".table-top").height("auto");
                angular.element(".table-state-btn").addClass("table-state-btnOn");
            }
        };

        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplyApiDetailsController', SupplyApiDetailsController);

    SupplyApiDetailsController.$inject = ['$scope', '$state','MessageService', 'SupplierAbutSettings','ProductCategory','Supplier','$q', '$stateParams','entity'];

    function SupplyApiDetailsController ($scope, $state,MessageService,SupplierAbutSettings,ProductCategory,Supplier,$q, $stateParams,entity) {
        var vm = this;
        vm.data = entity;
        vm.outwardMerchants=[
            {name:'亮丽',id:'LIANGLI'},
            {name:'天意有福',id:'TIANYIYOUFU'},
            {name:'goflow',id:'GOFLOW'}
        ];

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.data.outwardMerchant){
                MessageService.error("接口类型不能为空");
                return;
            }
            if(!vm.data.factorySecret){
                MessageService.error("appSecret不能为空");
                return;
            }
            if(!vm.data.factoryId){
                MessageService.error("appid不能为空");
                return;
            }
            if(!vm.data.domain){
                MessageService.error("第三方域名不能为空");
                return;
            }
             
            vm.isSaving = true;
            if($stateParams.id){
                SupplierAbutSettings.update(vm.data, onSaveSuccess, onSaveError);
            }else {
                SupplierAbutSettings.save(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("成功");
                $state.go("supplyApi");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('supplyApi', {
            parent: 'module',
            url: '/supplyApi',
            params:{page: null},
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/supplyApi/supplyApi.html',
                    controller: 'SupplyApiController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('supplyApiAdd', {
            parent: 'module',
            url: '/add',
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/supplyApi/supplyApi-details.html',
                    controller: 'SupplyApiDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SupplierAbutSettings', function ($stateParams, SupplierAbutSettings) {
                    return
                }]
            }
        })
        .state('supplyApiEdit', {
            parent: 'module',
            url: '/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/supplyApi/supplyApi-details.html',
                    controller: 'SupplyApiDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SupplierAbutSettings', function ($stateParams, SupplierAbutSettings) {
                    return SupplierAbutSettings.get({id: $stateParams.id});
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('SupplierAbutSettings', SupplierAbutSettings);

    SupplierAbutSettings.$inject = ['$resource'];

    function SupplierAbutSettings ($resource) {
        var resourceUrl =  'api/supplier-abut-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'create': {
                method: 'POST',
                params: {
                    path: 'create'
                }
            },
            'createBatch': {
                method: 'POST',
                isArray: true,
                params: {
                    path: 'create-batch'
                }
            },
            'getAll': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{method:'DELETE'},
            'update': { method:'PUT' },
            'detail': {method:'GET'},
            'save': {method:'POST'},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplyApiController', SupplyApiController);

    SupplyApiController.$inject = ['$scope','SupplierAbutSettings','MessageService', 'ParseLinks', '$stateParams'];

    function SupplyApiController ($scope,SupplierAbutSettings,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            pageable: 20,
            keyword: ''
        };


        init();
        function init() {
            vm.tableList = [];
            SupplierAbutSettings.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.pageable); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.delete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                SupplierAbutSettings.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };

        vm.outwardMerchantInfo = outwardMerchantInfo;
        function outwardMerchantInfo(item) {
            switch (item) {
                case 'LIANGLI':
                    return "亮丽";
                    break;
                case 'TIANYIYOUFU':
                    return "天意有福";
                case 'GOFLOW':
                    return "goflow";
                    break;
                default:
                    return ""
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ZoneDetailController', ZoneDetailController);

    ZoneDetailController.$inject = ['$scope','msgdata','$uibModalInstance','MessageService','Provinces','$q','LocationProvice'];

    function ZoneDetailController ($scope,msgdata,$uibModalInstance,MessageService,Provinces,$q,LocationProvice) {
        var vm = this;
        vm.clear = clear;
        vm.areas =[];

        loadData();
        function loadData() {
            // Provinces.getAll({},function(res){
            //     vm.areas = res;
            //     $q.all([vm.areas.$promise]).then(function(){
            //         if(msgdata == null || msgdata.length ==0){
            //             angular.forEach(vm.areas,function(item){
            //                 item.selected = false;
            //                 angular.forEach(item.provinces,function(value){
            //                     value.selected = false;
            //                 })
            //             })
            //         }else{
            //             angular.forEach(vm.areas,function(item){
            //                 angular.forEach(msgdata,function(value){
            //                     if(item.area == value.area && item.provinces.length == value.provinces.length){
            //                         item.selected = true;
            //                     }
            //                     angular.forEach(item.provinces,function(item1){
            //                         angular.forEach(value.provinces,function(value2){
            //                             if(item1.name == value2.name){
            //                                 item1.selected = true;
            //                             }
            //                         })
            //                     })
            //                 })
            //             });
            //             console.log(vm.areas)
            //         }
            //     })
            // });

            LocationProvice.query({},function (data) {
                vm.areas = arrInit(data);
                $q.all([vm.areas.$promise]).then(function(){
                    if(msgdata == null || msgdata.length ==0){
                        angular.forEach(vm.areas,function(item){
                            item.selected = false;
                            angular.forEach(item.provinces,function(value){
                                value.selected = false;
                            })
                        })
                    }else{
                        angular.forEach(vm.areas,function(item){
                            angular.forEach(msgdata,function(value){
                                if(item.area == value.area && item.provinces.length == value.provinces.length){
                                    item.selected = true;
                                }
                                angular.forEach(item.provinces,function(item1){
                                    angular.forEach(value.provinces,function(value2){
                                        if(item1.name == value2.name){
                                            item1.selected = true;
                                        }
                                    })
                                })
                            })
                        });
                    }
                    console.log(vm.areas)
                })
            });
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        function arrInit(data){
            var map = {},
                provinces = [];
            for(var i = 0; i < data.length; i++){
                var ai = data[i];
                if(!map[ai.area]){
                    provinces.push({
                        area: ai.area,
                        provinces: [ai]
                    });
                    map[ai.area] = ai;
                }else{
                    for(var j = 0; j < provinces.length; j++){
                        var dj = provinces[j];
                        if(dj.area == ai.area){
                            dj.provinces.push(ai);
                            break;
                        }
                    }
                }
            }
            return provinces;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ZoneController', ZoneController);

    ZoneController.$inject = ['$scope','msgdata','$uibModalInstance','MessageService','Provinces','$q', 'LocationProvice'];

    function ZoneController ($scope,msgdata,$uibModalInstance,MessageService,Provinces,$q, LocationProvice) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.areas =[];

        loadData();
        function loadData() {
            // Provinces.getAll({},function(res){
            //     vm.areas = res;
            //     $q.all([vm.areas.$promise]).then(function(){
            //         if(msgdata == null || msgdata.length ==0){
            //             angular.forEach(vm.areas,function(item){
            //                 item.selected = false;
            //                 angular.forEach(item.provinces,function(value){
            //                     value.selected = false;
            //                 })
            //             })
            //         }else{
            //             angular.forEach(vm.areas,function(item){
            //                 angular.forEach(msgdata,function(value){
            //                     if(item.area == value.area && item.provinces.length == value.provinces.length){
            //                         item.selected = true;
            //                     }
            //                     angular.forEach(item.provinces,function(item1){
            //                         angular.forEach(value.provinces,function(value2){
            //                             if(item1.name == value2.name){
            //                                 item1.selected = true;
            //                             }
            //                         })
            //                     })
            //                 })
            //             });
            //             console.log(vm.areas)
            //         }
            //     })
            // });

            LocationProvice.query({},function (data) {
                vm.areas = arrInit(data);
                $q.all([vm.areas.$promise]).then(function(){
                    if(msgdata == null || msgdata.length ==0){
                        angular.forEach(vm.areas,function(item){
                            item.selected = false;
                            angular.forEach(item.provinces,function(value){
                                value.selected = false;
                            })
                        })
                    }else{
                        angular.forEach(vm.areas,function(item){
                            angular.forEach(msgdata,function(value){
                                if(item.area == value.area && item.provinces.length == value.provinces.length){
                                    item.selected = true;
                                }
                                angular.forEach(item.provinces,function(item1){
                                    angular.forEach(value.provinces,function(value2){
                                        if(item1.name == value2.name){
                                            item1.selected = true;
                                        }
                                    })
                                })
                            })
                        });
                    }
                    console.log(vm.areas)
                })
            });
        }

        function arrInit(data){
            var map = {},
                provinces = [];
            for(var i = 0; i < data.length; i++){
                var ai = data[i];
                if(!map[ai.area]){
                    provinces.push({
                        area: ai.area,
                        provinces: [ai]
                    });
                    map[ai.area] = ai;
                }else{
                    for(var j = 0; j < provinces.length; j++){
                        var dj = provinces[j];
                        if(dj.area == ai.area){
                            dj.provinces.push(ai);
                            break;
                        }
                    }
                }
            }
            return provinces;
        }

        $scope.isSelected = function(province,area){
            console.log(province);
            console.log(area);
            province.selected = !province.selected;
            area.selected = area.provinces.every(function(item){return item.selected;})
        };

        $scope.isSelectedAll = function(area){
            area.selected = !area.selected;
            angular.forEach(area.provinces,function(item){
                item.selected = area.selected;
            })
        };

        vm.provinces =[];
        $scope.validate = function() {
            angular.forEach(vm.areas,function(item){
                angular.forEach(item.provinces,function(value){
                    if(value.selected){
                        vm.provinces.push(value);
                    }
                });
            });
            if(vm.provinces.length ==0 || vm.provinces == null){
                MessageService.error("请设置区域！");
                return false;
            }
            return true;
        };


        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;

            vm.areasList =[];
            for(var i=0;i<vm.areas.length;i++){
                var provinces = [];
                for(var j=0;j<vm.areas[i].provinces.length;j++){
                    if(vm.areas[i].provinces[j].selected){
                        provinces.push(vm.areas[i].provinces[j]);
                    }
                }
                if(provinces.length >0){
                    vm.areasList.push({area:vm.areas[i].area,provinces:provinces,selected:vm.areas[i].selected})
                }
            }
            console.log(vm.areasList);
            $uibModalInstance.close(vm.areasList);
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('TransactionDetailController', TransactionDetailController);

    TransactionDetailController.$inject = ['$scope', 'Principal', 'LoginService','$state','Supplier','$stateParams','msgdata','$uibModal','$uibModalInstance','ParseLinks','MessageService', '$localStorage', '$http'];

    function TransactionDetailController ($scope, Principal, LoginService,$state,Supplier,$stateParams,msgdata,$uibModal,$uibModalInstance,ParseLinks,MessageService, $localStorage, $http) {
        var vm = this;
        vm.clear = clear;
        vm.supply= msgdata;
        vm.token = $localStorage.authenticationToken;

        vm.loadAll = loadAll;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            supId:vm.supply.id,
            sort: ['createdDate,DESC'],
            startDate:GetDateStr(-31),
            endDate:GetDateStr(0),
            type:''
        };
        // angular.element("#startDate").val(GetDateStr(-31));
        // angular.element("#endDate").val(GetDateStr(0));

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.types =[
            {name:'plus', value:'充值'},
            {name:'minus', value:'消费'},
            {name:'refund', value:'退款'}];


        loadAll();
        function loadAll() {
            vm.records = [];
            if(angular.element("#startDate").val()){
                vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            }
            if(angular.element("#endDate").val()){
                vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            }
            Supplier.getTransactionRecord(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.records = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.type = '';
            vm.tableData.page = 0;
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            $uibModalInstance.close();
        }
        //下载
        $scope.export = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            // if(vm.tableData.startDate == ""){
            //     MessageService.error("开始时间不能为空");
            //     return
            // }
            // if(vm.tableData.endDate == ""){
            //     MessageService.error("结束时间不能为空");
            //     return
            // }
            $http({
                url: 'api/suppliers/downloadTransactionRecord',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = '交易明细' + Date.now() + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplyNewController', SupplyNewController);

    SupplyNewController.$inject = ['$scope','entity','$state','User','$uibModal','MessageService', 'Supplier','$q', '$stateParams','Product','Machine','Makeups', 'SupplierAbutSetting'];

    function SupplyNewController ($scope,entity,$state,User,$uibModal,MessageService,Supplier,$q, $stateParams,Product,Machine,Makeups,SupplierAbutSetting) {
        var vm = this;
        vm.save= save;
        vm.supply = entity;
        vm.multimediaGroups =[
            {
                name:'outsource',
                value:'委外'
            },{
                name:'SourceMaterials',
                value:'原辅材料'
            }];
        vm.cashiers =[
            {name:'CashSettlement',value:'现结'},
            {name:'MonthlyKnots',value:'月结'}
        ];
        vm.payTypes =[
            {name:'InvoicePayment',value:'开票付款'},
            {name:'CashDelivery',value:'货到付款'}
        ];
        vm.settlementTypes =[
            {name:'DownLoad',value:'下载结算'},
            {name:'Delivered',value:'发货结算'}
        ];


        Product.getAllByCondition({items:[{key:"category",op:"=",value:'OrderingProduct'}]},function(res){
            vm.products = res.filter(function(item){return item.enable});
        });

        Machine.getAll({},function(res){
            vm.machines = res.filter(function(item){return item.enable});
        });

        vm.supplierAbutSettings = SupplierAbutSetting.getAll({});

        $scope.chooseMachine = function(data){
            if(data.deviceId==null){
            }else{
                Machine.detail({id:data.deviceId},function(res){
                    data.makeups = res.makeups;
                    data.capacity = res.capacity;
                })
            }
        };


        $scope.productionDelete = function(index){
            vm.supply.productionManages.splice(index,1);
        };

        //设置区域
        $scope.productionEdit = function(data){
            console.log(data);
            $uibModal.open({
                templateUrl: 'app/supply/zone.html',
                controller: 'ZoneController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data.areaList;
                    }
                }
            }).result.then(function(result){
                data.areaList = result;
            });
        };

        // 设置价格
        $scope.priceEdit = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-price.html',
                controller: 'SkuPriceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                data.propertyPriceList = result;
            });
        };

        $scope.skuFileDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-file.html',
                controller: 'SkuFileController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result);
                // data.skuManageList = result;
                //data.areaList = result;
            });
        };

        $scope.skuMakeupDetail = function(data){
            data.abutType == null;
            data.supplierAbutSettingId = null;
            if (vm.supply.supplierAbutSettingId && vm.supplierAbutSettings) {
                for (var i = vm.supplierAbutSettings.length - 1; i >= 0; i--) {
                    var abut = vm.supplierAbutSettings[i];
                    if (abut.id == vm.supply.supplierAbutSettingId ) {
                        data.abutType = abut.outwardMerchant;
                        data.supplierAbutSettingId = vm.supply.supplierAbutSettingId
                        break;
                    }
                }
            }
            $uibModal.open({
                templateUrl: 'app/supply/sku-makeup.html',
                controller: 'SkuMakeupController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result);
                data.skuManageList = result;
                //data.areaList = result;
            });
        };

        $q.all([vm.supply.$promise,vm.supplierAbutSettings.$promise]).then(function(){
            if(vm.supply.id!=''){
                $scope.titleContent = '编辑供应商';
                angular.forEach(vm.multimediaGroups,function(item){
                    if(vm.supply.category == item.name){
                        vm.category = item;
                        if(vm.category.name == 'SourceMaterials'){
                            $('.special').attr('disabled',true);
                            if(vm.supply.username =='' || vm.supply.username == null){
                                $('.special2').hide();
                            }
                        }
                    }
                });
                vm.user={
                    username:vm.supply.username,
                    password:null,
                    confirmPassword:null,
                    userId:vm.supply.userId
                };

                vm.supply.locations = vm.supply.locations || [];
                // 发货信息：shipperInfo 对象（地址 + 备注），允许只填备注
                vm.supply.shipperInfo = vm.supply.shipperInfo || {
                    province:'',
                    city:'',
                    district:'',
                    address:'',
                    contact:'',
                    phone:'',
                    remarks:''
                };

                angular.forEach(vm.supply.productionManages,function(data){
                    if (data.deviceId) {
                        Machine.detail({id:data.deviceId},function(res){
                            data.makeups = res.makeups;
                        })
                    }else{
                        data.makeups =[];
                    }

                })
            }else{
                $scope.titleContent = '新建供应商';
                vm.supply =[];
                vm.supply.locations =[];
                vm.supply.shipperInfo = {
                    province:'',
                    city:'',
                    district:'',
                    address:'',
                    contact:'',
                    phone:'',
                    remarks:''
                };
                vm.supply.makeups =[];
                vm.supply.productionManages =[];
                vm.user =null;
                $('.special').attr('disabled',false);
                $('.special2').show();
            }
        });

        //添加商品管理
        $scope.addproduction = function(){
            var productionManage ={
                productId:'',
                productName:'',
                deviceId:'',
                deviceType:'',
                makeupId:'',
                makeupName:'',
                capacity:'',
                imgDpi:300,
                areaList:[],
                propertyPriceList: []
            };

            vm.flag = false;
            angular.forEach(vm.supply.productionManages,function(item){
                if(item.areaList ==null || item.areaList.length ==0 || !item.productId){
                    vm.flag = true;
                }
            });
            if(vm.flag){
                MessageService.error("请完善空白项，再追加");
            }else{
                vm.supply.productionManages.push(angular.copy(productionManage));
            }
        };


        //新建 or 编辑 用户名
        $scope.modifyContent = function(userInfo){
            if(!vm.supply.id){
                $uibModal.open({
                    templateUrl: 'app/supply/create-user.html',
                    controller: 'CreateUserController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('supplier');
                            return $translate.refresh();
                        }],
                        msgdata: function () {
                            return userInfo;
                        },
                        entity: function () {
                            return null;
                        }
                    }
                }).result.then(function(result){
                    if(result){
                        vm.user = result;
                        vm.supply.username = result.name;
                        console.log(vm.user);
                    }
                });
            }else{
                $uibModal.open({
                    templateUrl: 'app/user/user-password.html',
                    controller: 'UserPasswordController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('supplier');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return userInfo;
                        }
                    }
                }).result.then(function(result){
                    if(result){
                        vm.user = result;
                        vm.supply.username = result.username;
                        console.log(vm.user);
                    }
                });
            }

        };
        //设置拼版
        $scope.setImposition = function(pins){
            $uibModal.open({
                templateUrl: 'app/supply/set-imposition.html',
                controller: 'SetImpositionController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return pins;
                    },
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function(result){
                vm.supply.makeups = result;
            });
        };

        //添加地址
        $scope.addAddress = function(data){
            var _data = angular.copy(data)
            $uibModal.open({
                templateUrl: 'app/supply/address-new.html',
                controller: 'AddressNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return _data;
                    }
                }
            }).result.then(function(result){
                vm.supply.locations = vm.supply.locations || [];
                vm.supply.locations.push(result);
            });
        };

        //编辑地址
        $scope.addressEdit = function(data,index,listKey){
            listKey = listKey || 'locations';
            var _data = angular.copy(data)
            $uibModal.open({
                templateUrl: 'app/supply/address-new.html',
                controller: 'AddressNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return _data;
                    }
                }
            }).result.then(function(result){
                console.log(result);
                if(listKey === 'shipperInfo'){
                    var prevRemarks = vm.supply.shipperInfo && vm.supply.shipperInfo.remarks;
                    vm.supply.shipperInfo = result;
                    if (prevRemarks !== undefined && prevRemarks !== null && prevRemarks !== '') {
                        vm.supply.shipperInfo.remarks = prevRemarks;
                    }
                }else{
                    vm.supply.locations[index] = result;
                }
            });
        };

        //删除地址
        $scope.addressDelete = function(index){
            vm.supply.locations.splice(index,1);
        };

        $scope.validate = function () {
            if(vm.supply.name =='' || vm.supply.name == null){
                MessageService.error("供应商简称不能为空");
                return;
            }
            if(vm.supply.name.length >20){
                MessageService.error("供应商简称不能超过20位");
                return;
            }
            if(vm.supply.fullname =='' || vm.supply.fullname == null){
                MessageService.error("供应商全称不能为空");
                return;
            }
            if(vm.supply.fullname.length >30){
                MessageService.error("供应商全称不能超过30位");
                return;
            }
            if(vm.category =='' || vm.category == null){
                MessageService.error("分类不能为空");
                return;
            }
            if(vm.category.name =='outsource'){
                if(vm.supply.username =='' || vm.supply.username == null){
                    MessageService.error("用户名不能为空");
                    return;
                }
            }

            if(vm.supply.taxRate < 0 && vm.supply.taxRate > 100 || vm.supply.taxRate == undefined){
                MessageService.error("税率只能为0-100的整数");
                return;
            }

            // if(!vm.supply.settlementMethod){
            //     MessageService.error("结算方式不能为空");
            //     return;
            // }
            // if(!vm.supply.paymentTerm){
            //     MessageService.error("付款条件不能为空");
            //     return;
            // }
            // if(!vm.supply.taxCode){
            //     MessageService.error("纳税登记编码不能为空");
            //     return;
            // }
            // if(!vm.supply.registeredAddress){
            //     MessageService.error("注册地址不能为空");
            //     return;
            // }
            // if(!vm.supply.remarks){
            //     MessageService.error("备注不能为空");
            //     return;
            // }

            vm.flag = false;
            angular.forEach(vm.supply.productionManages,function(item){
                if(item.areaList ==null || item.areaList.length ==0 || !item.productId){
                    vm.flag = true;
                }
            });
            if(vm.flag){
                MessageService.error("生产管理存在空值，请检查修改");
                return;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;

            var shipperInfo = vm.supply.shipperInfo;
            if (shipperInfo) {
                var hasShipperInfoValue = !!(
                    shipperInfo.province ||
                    shipperInfo.city ||
                    shipperInfo.district ||
                    shipperInfo.address ||
                    shipperInfo.contact ||
                    shipperInfo.phone ||
                    shipperInfo.remarks
                );
                if (!hasShipperInfoValue) {
                    shipperInfo = null;
                }
            }

            var obj={
                name:vm.supply.name,
                fullname:vm.supply.fullname,
                category:vm.category.name,
                username:vm.supply.username,
                userId:vm.supply.userId,
                enable:vm.supply.enable,
                //makeups:vm.supply.makeups,
                locations:vm.supply.locations,
                shipperInfo:shipperInfo,
                taxRate:vm.supply.taxRate,
                settlementMethod:vm.supply.settlementMethod,
                settlementType:vm.supply.settlementType,
                paymentTerm:vm.supply.paymentTerm,
                taxCode:vm.supply.taxCode,
                warnBalance:vm.supply.warnBalance,
                registeredAddress:vm.supply.registeredAddress,
                remarks:vm.supply.remarks,
                productionManages:vm.supply.productionManages,
                balance: vm.supply.balance,
                outward: vm.supply.outward,
                outwardType: vm.supply.outwardType,
                supplierAbutSettingId: vm.supply.supplierAbutSettingId,
            };
            console.log(obj);
            if(vm.supply.id){
                obj.id=vm.supply.id;
                Supplier.update(obj,function (res) {
                    MessageService.success("更新成功！");
                    $state.go('supplyManagement',{page: $stateParams.page});
                },function (error) {
                    vm.isSaving = false;
                    MessageService.error("更新失败！");
                });
            }else{
                if(obj.userId ==  undefined && obj.username == undefined && obj.category == 'SourceMaterials'){
                    Supplier.create(obj,function (res) {
                        MessageService.success("供应商新建成功！");
                        $state.go('supplyManagement',{page: $stateParams.page});
                    },function (error) {
                        vm.isSaving = false;
                        MessageService.error("供应商新建失败！");
                    });
                }else{
                    User.saveSupply({username:vm.user.name,password:vm.user.password, admin: vm.user.admin}, onSaveSuccess, onSaveError);
                }
            }

            function onSaveSuccess (result) {
                obj.userId =result.id;
                Supplier.create(obj,function (res) {
                    MessageService.success("供应商新建成功！");
                    $state.go('supplyManagement',{page: $stateParams.page});
                },function (error) {
                    vm.isSaving = false;
                    MessageService.error("供应商新建失败！");
                });
            }
            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("用户名添加失败");
            }

        }
        //返回
        $scope.goBack = function () {
            $state.go("supplyManagement",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplyDetailController', SupplyDetailController);

    SupplyDetailController.$inject = ['$scope', 'Principal','entity', '$stateParams', '$state','$uibModal'];

    function SupplyDetailController ($scope, Principal, entity, $stateParams, $state,$uibModal) {
        var vm = this;

        vm.supply = entity;
        vm.supply.shipperInfo = vm.supply.shipperInfo || {
            province:'',
            city:'',
            district:'',
            address:'',
            contact:'',
            phone:'',
            remarks:''
        };
        //返回
        $scope.goBack = function () {
            $state.go("supplyManagement",{page: $stateParams.page});
        };

        $scope.productionDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/zone-detail.html',
                controller: 'ZoneDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data.areaList;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        $scope.propertyPrice = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-price-page.html',
                controller: 'SkuPricePageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        $scope.skuFileDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-file-detail.html',
                controller: 'SkuFileDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        $scope.skuMakeupDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-makeup-detail.html',
                controller: 'SkuMakeupDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        //充值
        $scope.recharge = function(){
            $uibModal.open({
                templateUrl: 'app/supply/recharge-amount.html',
                controller: 'RechargeAmountController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.supply;
                    }
                }
            }).result.then(function(result){
                vm.supply.balance = result.balance;
            });
        };

        //交易明细
        $scope.transactionDetail = function(){
            $uibModal.open({
                templateUrl: 'app/supply/transaction-detail.html',
                controller: 'TransactionDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.supply;
                    }
                }
            }).result.then(function(result){
                // vm.supply.balance = result.balance;
            });
        };

    }
})();

/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('supplyManagement', {
                parent: 'module',
                url: '/supplyManagement',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/supply/supply.html',
                        controller: 'SupplyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplyNew', {
                parent: 'module',
                url: '/supply-new',
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/supply/supply-dialog.html',
                        controller: 'SupplyNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {
                            id:''
                        };
                    }
                }
            })
            .state('supplyEdit', {
                parent: 'module',
                url: '/supply-edit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/supply/supply-dialog.html',
                        controller: 'SupplyNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Supplier', function ($stateParams, Supplier) {
                        return Supplier.get({id: $stateParams.id});
                    }]
                }
            })
            .state('supplyDetail', {
                parent: 'module',
                url: '/supply-detail/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/supply/supply-detail.html',
                        controller: 'SupplyDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Supplier', function ($stateParams, Supplier) {
                        return Supplier.get({id: $stateParams.id});
                    }]
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Supplier', Supplier)
        .factory('Makeups', Makeups)
        .factory('Provinces', Provinces);

    Supplier.$inject = ['$resource'];
    Makeups.$inject = ['$resource'];
    Provinces.$inject = ['$resource'];

    function Supplier ($resource) {
        var resourceUrl =  'api/suppliers/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false,
                params: {
                    path: 'create'
                }
            },
            'update': {
                method:'POST',
                isArray: false,
                params: {
                    path: 'update'
                }
            } ,
            'changeBalance': {
                method:'GET',
                params: {
                    path: 'changeBalance'
                }
            } ,
            'getTransactionRecord': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getTransactionRecord'
                }
            } ,
            'deleteSupplier': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            } ,
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'getHomePageData': {
                method:'GET',
                params: {
                    path: 'getHomePageData'
                }
            } ,
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }


    function Makeups ($resource) {
        var resourceUrl =  'api/makeups/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAllMakeups': {
                method:'GET',
                isArray: true
            }
        });
    }


    function Provinces ($resource) {
        var resourceUrl = 'api/provinces/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAll":{
                method:"GET",
                isArray: true,
                params: {
                    path: 'area'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplyController', SupplyController);

    SupplyController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Supplier','MessageService', 'ParseLinks', '$stateParams'];

    function SupplyController ($scope, Principal, LoginService, $state,Supplier,MessageService, ParseLinks, $stateParams) {
        var vm = this;

        vm.categories =[{
            name:'outsource',
            value:'委外'
        },{
            name:'SourceMaterials',
            value:'原辅材料'
        }];
        vm.loadAll = loadAll;
        vm.clear =clear;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            keyword:'',
            category:''
        };

        loadAll();
        function loadAll() {
            vm.suppliers = [];
            Supplier.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.suppliers = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.keyword = null;
            vm.tableData.page = 0;
            loadAll();
        }

        $scope.deleteSupplier = function(id){
            MessageService.confirm("确认要删除该供应商？", function () {
                Supplier.deleteSupplier({id: id}, function () {
                    loadAll();
                    MessageService.success("供应商删除成功");
                }, function (error) {
                    MessageService.error("供应商删除失败，请重试！");
                });
            });
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SkuPricePageController', SkuPricePageController);

    SkuPricePageController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService', 'Product', '$q'];

    function SkuPricePageController ($scope, msgdata, $uibModalInstance, MessageService, Product, $q) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;

        vm.propertyPriceList = [];
        vm.product = Product.get({id: msgdata.productId});
        $q.all([vm.product.$promise]).then(function(){

            // console.log(vm.product);

            if (msgdata.propertyPriceList == null || msgdata.propertyPriceList.length == 0) {
                console.log(vm.product.propertyConfigs);
                for (var i = vm.product.propertyConfigs.length - 1; i >= 0; i--) {
                    var propertyPrice = {
                        propertyConfigId: vm.product.propertyConfigs[i].id, 
                        propertyConfigSku: vm.product.propertyConfigs[i].sku, 
                        price: 0.00,
                        productionManageId: msgdata.id};

                    vm.propertyPriceList.push(propertyPrice);
                }
            } else {
                vm.propertyPriceList = msgdata.propertyPriceList;
            }
        });

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            vm.isSaving = true;

            $uibModalInstance.close(vm.propertyPriceList);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SkuPriceController', SkuPriceController);

    SkuPriceController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService', 'Product', '$q'];

    function SkuPriceController ($scope, msgdata, $uibModalInstance, MessageService, Product, $q) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;

        vm.propertyPriceList = [];
        vm.product = Product.get({id: msgdata.productId});
        $q.all([vm.product.$promise]).then(function(){

            for (var i = vm.product.propertyConfigs.length - 1; i >= 0; i--) {
                var propertyPrice = {
                    propertyConfigId: vm.product.propertyConfigs[i].id, 
                    propertyConfigSku: vm.product.propertyConfigs[i].sku, 
                    price: 0.00,
                    productionManageId: msgdata.id};

                if (msgdata.propertyPriceList != null && msgdata.propertyPriceList.length != 0) {
                    for (var j = msgdata.propertyPriceList.length - 1; j >= 0; j--) {
                        if (vm.product.propertyConfigs[i].id == msgdata.propertyPriceList[j].propertyConfigId) {
                            propertyPrice.price = msgdata.propertyPriceList[j].price;
                        }
                    }
                }
                vm.propertyPriceList.push(propertyPrice);
            }
        });

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            vm.isSaving = true;

            $uibModalInstance.close(vm.propertyPriceList);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SkuMakeupDetailController', SkuMakeupDetailController);

    SkuMakeupDetailController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'Product', '$q', 'Machine'];

    function SkuMakeupDetailController ($scope, msgdata, $uibModalInstance, Product, $q, Machine) {
        var vm = this;
        vm.clear = clear;

        vm.skuManages = [];
        if (!!msgdata.skuManageList) {
            for (var i = msgdata.skuManageList.length - 1; i >= 0; i--) {
                vm.skuManages.push(msgdata.skuManageList[i]);
            }
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SkuMakeupController', SkuMakeupController);

    SkuMakeupController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService', 'Product', '$q', 'Machine', '$uibModal', 'PrePressFlow'];

    function SkuMakeupController ($scope, msgdata, $uibModalInstance, MessageService, Product, $q, Machine,  $uibModal, PrePressFlow) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;

        vm.skuManages = [];
        vm.product = Product.get({id: msgdata.productId});
        vm.abutType = msgdata.abutType;
        vm.supplierAbutSettingId = msgdata.supplierAbutSettingId;
        vm.prePressFlowList = PrePressFlow.getAll();

        vm.machineList = Machine.getAll();
        $q.all([vm.product.$promise, vm.machineList.$promise, vm.prePressFlowList.$promise]).then(function(){
            vm.product.propertyConfigs.sort(function(a, b) {
                return a.sort - b.sort
            })
            vm.propertyList = vm.product.propertyConfigs;
            vm.prePressFlowList = vm.prePressFlowList.filter(function(item) {
                return item.enable;
            });

            if (!!msgdata.skuManageList) {
                for (var i = msgdata.skuManageList.length - 1; i >= 0; i--) {
                    var skuM = msgdata.skuManageList[i];
                    for (var j = vm.machineList.length - 1; j >= 0; j--) {
                        if (vm.machineList[j].id == skuM.deviceId) {
                            var skuManage ={
                                propertyId: skuM.propertyId,
                                sku: skuM.sku,
                                deviceId: skuM.deviceId,
                                deviceType: skuM.deviceType,
                                makeupId: skuM.makeup.id,
                                makeupName: skuM.makeup.name,
                                capacity: skuM.capacity,
                                price: skuM.price,
                                maxBoxing: skuM.maxBoxing,
                                makeupList: vm.machineList[j].makeups,
                                outId: skuM.outId,
                                prePress:skuM.prePress,
                                prePressFlowId:skuM.prePressFlowId

                            };
                            vm.skuManages.push(skuManage);
                        }
                    }
                }
            }
        });

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            vm.isSaving = true;
            var skuManageList = [];
            for (var i = vm.skuManages.length - 1; i >= 0; i--) {
                var skuM = vm.skuManages[i];
                var skuManageObj ={
                    propertyId: skuM.propertyId,
                    sku:skuM.sku,
                    maxBoxing:skuM.maxBoxing,
                    deviceId: skuM.deviceId,
                    deviceType: skuM.deviceType,
                    capacity: skuM.capacity,
                    price: skuM.price,
                    outId: skuM.outId,
                    prePress:skuM.prePress,
                    prePressFlowId:skuM.prePressFlowId
                };
                if (skuM.makeupId) {
                    skuManageObj.makeup ={id: skuM.makeupId}
                }
                skuManageList.push(skuManageObj);
            }

            $uibModalInstance.close(skuManageList);
        }

        //添加商品管理
        $scope.addSkuManage = function(){
            vm.flag = false;
            angular.forEach(vm.skuManages, function(item){
                if(!item.makeupId || !item.capacity || !item.propertyId || !item.deviceId){
                    vm.flag = true;
                }
            });
            if(vm.flag){
                MessageService.error("请完善空白项，再追加");
            }else{
                angular.forEach(vm.propertyList , function(p){
                    p.selected = false;
                })
                for(var j = 0; j< vm.skuManages.length; j++){
                    var sku = vm.skuManages[j];
                    if (sku.cancelled) {
                        continue;
                    }
                    for(var i = 0; i< vm.propertyList.length; i++){
                        var property= vm.propertyList[i];
                        if (property.id == sku.propertyId) {
                            property.selected = true;
                        }
                    }
                }

                angular.forEach(vm.propertyList , function(p){
                    if (!p.selected) {
                        var skuManage ={
                            propertyId:p.id,
                            sku:p.sku,
                            deviceId:'',
                            deviceType:'',
                            makeupId:'',
                            makeupName:'',
                            maxBoxing:0,
                            capacity:'',
                            price: 0,
                            prePress:false,
                            prePressFlowId:null,
                            makeupList: [],
                        };
                        vm.skuManages.push(angular.copy(skuManage));
                    }
                })
            }
        };

        $scope.chooseMachine = function(skuManage) {
            for (var i = vm.machineList.length - 1; i >= 0; i--) {
                if (vm.machineList[i].id == skuManage.deviceId) {
                    skuManage.capacity = vm.machineList[i].capacity;
                    skuManage.makeupList = vm.machineList[i].makeups;
                }
            }
        }

        $scope.skuDelete = function(index){
            vm.skuManages.splice(index,1);
        };


        $scope.selectOutId = function(data){
            if (vm.supplierAbutSettingId == null) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/supply/out-id-select.html',
                controller: 'OutIdSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    abutId : function () {
                        return vm.supplierAbutSettingId;
                    }
                }
            }).result.then(function(result){
                data.outId = result;
            });
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SkuFileDetailController', SkuFileDetailController);

    SkuFileDetailController.$inject = ['$scope', 'msgdata', '$uibModalInstance'];

    function SkuFileDetailController ($scope, msgdata, $uibModalInstance) {
        var vm = this;
        vm.clear = clear;
        vm.data = msgdata;

        function clear(){
            $uibModalInstance.dismiss();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SkuFileController', SkuFileController);

    SkuFileController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService'];

    function SkuFileController ($scope, msgdata, $uibModalInstance, MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.data = msgdata;

        vm.inputFileFormats = [
            {name:'zip',selected:false},
            {name:'jpg',selected:false},
            {name:'pdf',selected:false},
            {name:'png',selected:false},
        ]

        if(vm.data.inputFileFormat){
            angular.forEach(vm.inputFileFormats,function(item){
                if(vm.data.inputFileFormat.indexOf(item.name)!=-1){
                    item.selected = true;
                }
            });
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.fileFormatChange = function () {
            if(vm.data.outFileFormat=='PDF'){
                vm.data.outFileType = null;
                vm.data.crossPageType = null;
            }else{
                vm.data.flatten = false;
            }
        }

        $scope.outFileTypeChange = function () {
            if(vm.data.outFileType=='Only'){
                vm.data.crossPageType = null;
            }
        }

        $scope.validate = function () {
            vm.data.inputFileFormat = null;
            angular.forEach(vm.inputFileFormats,function(item){
                if(item.selected){
                    if(vm.data.inputFileFormat == null){
                        vm.data.inputFileFormat = item.name;
                    }else{
                        vm.data.inputFileFormat=vm.data.inputFileFormat+','+item.name;
                    }
                }
            });
            if(vm.data.inputFileFormat == null){
                MessageService.error("输入文件类型不能为空");
                return;
            }

            if(vm.data.outFileFormat =='' || vm.data.outFileFormat == null){
                MessageService.error("输出文件类型不能为空");
                return;
            }

            if(vm.data.outFileFormat == 'PNG'||vm.data.outFileFormat == 'JPG'){
                vm.data.flatten = false;
                if(vm.data.outFileType =='' || vm.data.outFileType == null){
                    MessageService.error("图片文件样式不能为空");
                    return;
                }
                if(vm.data.imgDpi =='' || vm.data.imgDpi == null){
                    MessageService.error("图片dpi尺寸不能为空");
                    return;
                }
                if(vm.data.outFileType == 'Page'&&(vm.data.crossPageType =='' || vm.data.crossPageType == null)){
                    MessageService.error("跨页方式不能为空");
                    return;
                }
            }else{
                vm.data.crossPageType = null;
                vm.data.outFileType = null;
            }

            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            $uibModalInstance.close(vm.data);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SetImpositionController', SetImpositionController);

    SetImpositionController.$inject = ['$scope', 'entity','Principal', 'LoginService','$state','User','$uibModal','$uibModalInstance','MessageService', 'msgdata','Makeups'];

    function SetImpositionController ($scope, entity,Principal, LoginService,$state,User,$uibModal,$uibModalInstance,MessageService,msgdata,Makeups) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        loadAll();
        vm.items=[];

        function loadAll(){
            Makeups.getAllMakeups({},function(data){
                vm.items = data.filter(function(item){
                    return item.enable == true;
                });
                repeat(vm.items,msgdata);
            },function(error){
            });
        };

        //获取选中状态
        function repeat(items,list){
            if(list == null || list.length == 0){
                angular.forEach(items,function(item){
                    item.selected = false;
                })
            }else {
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].name;
                    for (var j = 0; j < list.length; j++) {
                        if (item == list[j].name) {
                            items[i].selected = true;
                        }
                    }
                }
            }
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.chooseItem = function(item){
            item.selected = !item.selected;
        };

        function save () {
            vm.selectedItems = vm.items.filter(function(item){
                return item.selected;
            });
            $uibModalInstance.close(vm.selectedItems);
        }




    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RechargeAmountController', RechargeAmountController);

    RechargeAmountController.$inject = ['$scope', 'Principal', 'LoginService','$state','Supplier','msgdata','$uibModal','$uibModalInstance','MessageService'];

    function RechargeAmountController ($scope, Principal, LoginService,$state,Supplier,msgdata,$uibModal,$uibModalInstance,MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        console.log(msgdata)

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.validate = function () {
            if (vm.balance == null || vm.balance == "") {
                MessageService.error("充值金额不能为空");
                return false;
            }
            return true;
        };

        function save () {
            if (!$scope.validate()) {
                return;
            }

            //plus充值/minus消费
            Supplier.changeBalance({
                supId: msgdata.id,
                balance: vm.balance,
                type: 'plus'
            }, function (res) {
                vm.isSaving = false;
                    MessageService.success("充值金额成功");
                    $uibModalInstance.close(res);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("充值金额失败");
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutIdSelectController', OutIdSelectController);

    OutIdSelectController.$inject = ['$scope', 'abutId', '$uibModalInstance', 'MessageService', 'Product', '$q'];

    function OutIdSelectController ($scope, abutId, $uibModalInstance, MessageService, Product, $q) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.abutId = abutId;

        $scope.suplierProductsHide = function () {
            vm.suplierProducts = false;
            if (vm.suplierProductsApex) {
                for (var i = vm.suplierProductsApex.length - 1; i >= 0; i--) {
                    var left = vm.suplierProductsApex[i];
                    for (var j = left.specs.length - 1; j >= 0; j--) {
                        var product = left.specs [j];
                        if (product.selected) {
                            product.selected = false;
                        }
                    }
                }
            }
            vm.currentItemValueLine = {};
        }

        $scope.suplierProductsSearch = function () {
            if (!!vm.originSupplerProductsApex && !!vm.suplierProductsSearchQuery) {
                vm.suplierProductsApex = angular.copy(vm.originSupplerProductsApex);
                for(var i = 0 ; i< vm.suplierProductsApex.length; i++){
                    var apex = vm.suplierProductsApex[i];
                    if (apex.specs) {
                        apex.specs =  apex.specs.filter(function(p) {
                            if (p.specName.indexOf(vm.suplierProductsSearchQuery)>=0 || p.skuNumber.indexOf(vm.suplierProductsSearchQuery)>=0) {
                                return p;
                            }
                        });
                    }
                }
            }
            if (!vm.suplierProductsSearchQuery) {
                vm.suplierProductsApex = angular.copy(vm.originSupplerProductsApex );
            }
        }

        $scope.showTree = function (tree) {
            tree.show = !tree.show;
        }

        $scope.showLeft = function (left) {
            left.show = !left.show;
        }

        $scope.selectApex = function (apex) {
            for (var i = vm.suplierProductsApex.length - 1; i >= 0; i--) {
                var ap = vm.suplierProductsApex[i];
                if (ap.productName == apex.productName) {
                    ap.hide = false;
                } else {
                    ap.hide = true;
                }

            }
        }

         $scope.productChooseOne = function (p) {
            if (!p.selected) {
                for (var i = vm.suplierProductsApex.length - 1; i >= 0; i--) {
                    var apex = vm.suplierProductsApex[i];
                    for (var j = apex.specs.length - 1; j >= 0; j--) {
                        var product = apex.specs[j];
                        if (product.skuNumber != p.skuNumber) {
                            product.selected = false;
                        }
                    }
                }
            }
            p.selected = !p.selected;
        }

        $scope.suplierProductsConfirm = function () {
            vm.suplierProducts = false;
            for (var i = vm.suplierProductsApex.length - 1; i >= 0; i--) {
                var left = vm.suplierProductsApex[i];
                for (var j = left.specs.length - 1; j >= 0; j--) {
                    var product = left.specs[j];
                    if (product.selected) {
                        product.selected = false;
                        vm.currentItemValueLine.supNumber = product.skuNumber;
                        return;
                    }
                }
            }
        }

        $scope.suplierProductsHide = function () {
            vm.suplierProducts = false;
            if (vm.suplierProductsApex) {
                for (var i = vm.suplierProductsApex.length - 1; i >= 0; i--) {
                    var left = vm.suplierProductsApex[i];
                    for (var j = left.specs.length - 1; j >= 0; j--) {
                        var product = left.specs [j];
                        if (product.selected) {
                            product.selected = false;
                        }
                    }
                }
            }
            vm.currentItemValueLine = {};
        }


        Product.getCategoryAndProductDetails({supplierAbutSettingId: vm.abutId},function (res) {
            if(res.state==200  ){
                //左侧导航栏   Tree -- > categories --> products
                vm.supplierProductsTree = res.message;
                var data = res.message;
                vm.suplierProductsApex = []; //右侧表格
                angular.forEach(data,function (item) {
                    angular.forEach(item.categories,function (ca) {
                        angular.forEach(ca.products,function (pro,i) {
                            vm.suplierProductsApex.push(pro);
                        })
                    })
                })
                vm.originSupplerProductsApex = angular.copy(vm.suplierProductsApex);
            }
        }, function () {

        })
        

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            for (var i = vm.suplierProductsApex.length - 1; i >= 0; i--) {
                var left = vm.suplierProductsApex[i];
                for (var j = left.specs.length - 1; j >= 0; j--) {
                    var product = left.specs[j];
                    if (product.selected) {
                        $uibModalInstance.close(product.skuNumber);
                        return;
                    }
                }
            }
            $uibModalInstance.close();
            return;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CreateUserController', CreateUserController);

    CreateUserController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','msgdata','$uibModal','$uibModalInstance','MessageService','entity'];

    function CreateUserController ($scope, Principal, LoginService,$state,User,msgdata,$uibModal,$uibModalInstance,MessageService,entity) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.user={
            name:'',
            password:'',
            confirmPassword:'',
            admin:true
        };
        $scope.userTitle='新建用户名';
        console.log(entity)
        console.log(vm.user)

        if(entity=='customerHub'){
            vm.isCustomerHub = true;
            vm.user={
                name:'',
                password:'',
                confirmPassword:'',
                fullname:'',
                phone:''
            };
        }else{
            vm.user={
                name:'',
                password:'',
                confirmPassword:'',
                admin:true
            };
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.validate = function () {
             if (vm.user.name == null || vm.user.name == "") {
                 MessageService.error("用户名不能为空");
                 return false;
             }
             if (vm.user.name.match(/[\u4E00-\u9FA5]/g,'')) {
                 MessageService.error("用户名不能输入中文");
                 return false;
             }
             if (vm.user.name.length >20) {
                 MessageService.error("用户名不能大于20位");
                 return false;
             }
             if (vm.user.password == null || vm.user.password == "") {
                 MessageService.error("密码不能为空");
                 return false;
             }
             if (vm.user.password.length<4 || vm.user.password.length >20) {
                 MessageService.error("密码长度在4-20位之间");
                 return false;
             }
             if (vm.user.confirmPassword == null || vm.user.confirmPassword == "") {
                 MessageService.error("确认密码不能为空");
                 return false;
             }
             if (vm.user.confirmPassword != vm.user.password) {
                 MessageService.error("确认密码与密码不一致");
                 return false;
             }
            if (vm.user.confirmPassword.length<4 || vm.user.confirmPassword.length >20) {
                 MessageService.error("确认密码长度在4-20位之间");
                 return false;
             }
            if(vm.isCustomerHub){
                if (vm.user.fullname == null || vm.user.fullname == "") {
                    MessageService.error("姓名不能为空");
                    return false;
                }
                if (vm.user.phone == null || vm.user.phone == "") {
                    MessageService.error("联系方式不能为空");
                    return false;
                }
                // var myreg=/^[1][3,4,5,6,7,8][0-9]{9}$/;
                // if (!myreg.test(vm.user.phone)) {
                //     MessageService.error("请输入11位符合要求的电话号码");
                //     return;
                // };
            }
            return true;
        };

        function save () {
            if (!$scope.validate()) {
                return;
            }

            //判断用户名是否存在
            User.validate({name: vm.user.name}, function (res) {
                vm.isSaving = false;
                if (!res.message) {
                    MessageService.error("系统存在重复的用户名");
                } else {
                    $uibModalInstance.close(vm.user);
                }
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("系统存在重复的用户名");
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AddressNewController', AddressNewController);

    AddressNewController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','msgdata','$uibModal','$uibModalInstance','MessageService','LocationProvice', 'LocationCity', 'LocationDistrict'];

    function AddressNewController ($scope, Principal, LoginService,$state,User,msgdata,$uibModal,$uibModalInstance,MessageService,LocationProvice, LocationCity, LocationDistrict) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.supply= msgdata;
        if(msgdata == '' || msgdata == null){
            $scope.addressTitle ='新建地址';
            vm.flag = false;
        }else{
            $scope.addressTitle ='编辑地址';
            vm.flag = true;
        }

        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.validate = function() {
            if (vm.province == null || vm.province == "") {
                MessageService.error("请选择省份");
                return false;
            };

            if (vm.city == null || vm.city == '') {
                MessageService.error('请选择城市');
                return false;
            }

            if (vm.district == null || vm.district == "") {
                MessageService.error("请选择区县");
                return false;
            };

            if (vm.supply.address == null || vm.supply.address == "") {
                MessageService.error("请输入详细地址");
                return false;
            };

            if (vm.supply.address.length >50) {
                MessageService.error("详细地址不能大于50位");
                return false;
            };

            if (vm.supply.contact == null || vm.supply.contact == "") {
                MessageService.error("请输入联系人姓名");
                return false;
            };
            if (vm.supply.contact.length >20) {
                MessageService.error("联系人姓名不能超过20位");
                return false;
            };

            if (vm.supply.phone == null || vm.supply.phone == "") {
                MessageService.error("请输入联系方式");
                return false;
            };
            // var myreg=/^[1][3,4,5,6,7,8][0-9]{9}$/;
            // var myreg=/^[1][0-9][0-9]{9}$/;
            // if (!myreg.test(vm.supply.phone)) {
            //     MessageService.error("请输入11位符合要求的电话号码");
            //     return false;
            // };
            return true;
        };


        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                province:vm.province.name,
                city:vm.city.name,
                district:vm.district.name,
                address:vm.supply.address,
                contact:vm.supply.contact,
                phone:vm.supply.phone,
                postCode:''
            };
            $uibModalInstance.close(obj);
        }

        loadData();
        function loadData() {
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                if(vm.flag) {
                    for (var i = vm.provinces.length - 1; i >= 0; i--) {
                        var p = vm.provinces[i];
                        if (p.name == vm.supply.province) {
                            vm.province = p;
                            break;
                        }
                    }
                    if (vm.supply.city != '') {
                        vm.districts = [];
                        LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                            vm.citys = data;
                            for (var i = vm.citys.length - 1; i >= 0; i--) {
                                var c = vm.citys[i];
                                if (c.name == vm.supply.city) {
                                    vm.city = c;
                                    break;
                                }
                            }
                            if (vm.city != null) {
                                LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                                    vm.districts = data;
                                    for (var i = vm.districts.length - 1; i >= 0; i--) {
                                        var di = vm.districts[i];
                                        if (di.name == vm.supply.district) {
                                            vm.district = di;
                                        }
                                    }
                                });
                            }
                        });
                    }
                }
            });

        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('StockEditController', StockEditController);

    StockEditController.$inject = ['$scope','$state', '$q', 'MessageService', '$stateParams', '$sessionStorage', 'Supplier', 'Depository', 'Reserves', 'Product', 'PurchaseOrder', 'StockManagement','$uibModal','$http','$localStorage','DateUtils'];

    function StockEditController ($scope, $state, $q, MessageService, $stateParams, $sessionStorage, Supplier, Depository, Reserves, Product, PurchaseOrder, StockManagement,$uibModal,$http,$localStorage,DateUtils) {
        var vm = this;
        vm.types = [
            {name:'成品采购', value:'Outsourcing'},
            {name:'材料采购', value:'RawMaterial'}
        ];
        vm.keyword = ''
        vm.data = {
            lines : []
        }
        vm.warehouse = {}
        init()
        vm.token = $localStorage.authenticationToken;

        function init(){
            // 有仓库id是新建
            if($stateParams.warehouseId){
                vm.data.status = 'INPROGRESS'
                vm.data.warehouseId = $stateParams.warehouseId
                vm.data.operator = $sessionStorage.user.fullname
                vm.data.cancelled = false

                Depository.detail({id : $stateParams.warehouseId},function(res){
                    vm.warehouse = res
                Reserves.page({
                    page:  0,
                    size: 9999999,
                    type: res.type,// 类型。accessories 辅料 / product 成品
                    state:'all',
                    sort: ['createdDate,DESC'],
                    warehouseId: $stateParams.warehouseId
                },function(res1){
                    res1.forEach(function(item){
                        var obj = {
                            // MaterialProduct 辅料 / GeneralProduct 成品
                            productType:item.type === 'product' ? 'GeneralProduct' : 'MaterialProduct',
                            productName:item.productName,
                            productNumber:item.propertyConfig.number,
                            unit:item.measurement.name,
                            sku:item.propertyConfig.sku,
                            quantity:'',
                            beforeQuantity:item.availableQuantity,
                            price:item.price,
                            cancelled:false,
                            remarks:'',
                            skuNumber:item.propertyConfig.skuNumber,
                            reserveId:item.id,
                            propertyConfigId:item.propertyConfig.id,
                            stockTakingOrderId:'',
                            operator:$sessionStorage.user.fullname,

                        }
                        vm.data.lines.push(obj)
                    })
                })
                })
            }else{
                StockManagement.get({id:$stateParams.id},function(res){
                    vm.data = res
                    vm.warehouse.type = res.warehouseType
                    vm.warehouse.name = res.warehouseName
                })
            }
        }

        // vm.suppliers = Supplier.getAll();

        $scope.productAdd = function() {
            var _selectedSku = []
            vm.data.lines.forEach(function(item){
                _selectedSku.push(item.propertyConfigId)

            })
            $uibModal.open({
                templateUrl: 'app/stockManagement/components/product-add-dialog.html',
                controller: 'ProductAddDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return _selectedSku;
                    },
                    productType: function() {
                        return vm.warehouse.type == 'product' ? 'GeneralProduct' : 'MaterialProduct';
                    },
                }
            }).result.then(function(result){
                if(result && result.length){
                    vm.data.lines = result.concat(vm.data.lines)
                }
            });
        }

        $scope.productDelete = function(index) {
                vm.data.lines.splice(index, 1);
        }

        $scope.export = function (){
            $http({
                url: 'api/stock-taking-orders/exportDetail/' + vm.data.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = vm.warehouse.name + "盘点记录_" + DateUtils.convertLocalDateToServer(Date.now()) + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        }

        $scope.search = function(index) {
            if(vm.keyword == '' || vm.keyword == null ){
                vm.keyword = ''
                return
            }
            vm.searchSkuNumer = vm.data.lines.findIndex(function(item){
                return item.skuNumber == vm.keyword
            })
            var dom = document.getElementsByClassName('productItem-' + vm.searchSkuNumer)
            var contentDom = document.getElementsByClassName('shell-content scrollbar-main')
            if(!dom.length || !vm.keyword) return
            contentDom[0].scrollTop = dom[0].offsetTop
        }

        $scope.reset = function(index) {
            vm.keyword= ''
            vm.searchSkuNumer = null
            var contentDom = document.getElementsByClassName('shell-content scrollbar-main')
            contentDom[0].scrollTop = 0
        }

        $scope.save = function(submit){

            if(vm.isSaving){
                return
            }

           if(submit){
            var flag = true
            vm.data.lines.forEach(function(item){
                if(flag){
                    if(item.quantity === '' || item.quantity === undefined){
                        MessageService.error('有商品未填写盘点数量，无法确认!');
                        flag = false
                        return
                    }
                    if(item.quantity < 0){
                        MessageService.error("数量不可为负数");
                        flag = false
                        return
                    }
                }
            })
            if(!flag) return
           }

            vm.isSaving = true;
            if(submit){
                StockManagement.submit(vm.data, function(res){
                    vm.isSaving = false;
                    MessageService.success('盘点确认成功！');
                    $scope.clear()
                    },function(error){
                    vm.isSaving = false;
                    MessageService.error('盘点确认失败');
                });
            }else{
                if($stateParams.id){
                    vm.data.lines.forEach(function(item){
                        item.stockTakingOrderId = $stateParams.id
                    })
                    StockManagement.update(vm.data, function(res){
                        vm.isSaving = false;
                        MessageService.success('保存盘点成功');
                        $scope.clear()
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('保存盘点失败');
                    });
                }else{
                    StockManagement.create(vm.data, function(res){
                        vm.isSaving = false;
                        MessageService.success('保存盘点成功');
                        $scope.clear()
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('保存盘点失败');
                    });
                }
            }
        }

        $scope.clear = function() {
            history.back();
        }

        //关闭
        $scope.close = function (){
            MessageService.confirm("确认关闭当前盘点", function () {
                StockManagement.close({id:vm.data.id}, function(res){
                    MessageService.success('关闭成功');
                    $scope.clear()
                },function(error){
                    MessageService.error('拒绝失败');
                });
            });
        }

        $scope.getStatus = function(item){
            switch (item) {
                case 'INPROGRESS':
                    return '盘点中';
                case 'FINISHED':
                    return '已完成';
                case 'COLSED':
                    return '已关闭';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stockManagement', {
                parent: 'module',
                url: '/stock',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/stockManagement/stock.html',
                        controller: 'StockController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('stockAdd', {
                parent: 'module',
                url: '/stock/add?warehouseId',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/stockManagement/stock-edit.html',
                        controller: 'StockEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {}
                    }]
                }
            })
            .state('stockEdit', {
                parent: 'module',
                url: '/stock/edit/{id}',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/stockManagement/stock-edit.html',
                        controller: 'StockEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {}
                    }]
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('StockManagement', StockManagement)

    StockManagement.$inject = ['$resource'];

    function StockManagement ($resource) {
        var resourceUrl =  'api/stock-taking-orders/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'submit': {
                method: 'POST',
                params:{
                    path:"submit"
                },
            },
            'close': {
                method: 'GET',
                params:{
                    path:"close"
                },
            },
            "byCondition":{
                method:"POST",
                params:{
                    id:"byCondition"
                },
                isArray: true
            },
            'get': { method: 'GET'},
            'getWarehouseStatus': {
                method: 'GET',
                params:{
                    path:"warehouse-taking"
                },
            },

        });
    };
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('StockController', StockController);

    StockController.$inject = ['$scope', 'Principal', '$state', 'StockManagement', 'MessageService', 'PurchaseOrder', 'ParseLinks', '$uibModal', '$timeout', '$stateParams',
        'Supplier','Depository','DateUtils'];

    function StockController ($scope, Principal, $state, StockManagement, MessageService, PurchaseOrder, ParseLinks, $uibModal, $timeout, $stateParams,
                                 Supplier,Depository,DateUtils) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_STOCK_TAKING_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有访问的权限！");
                $state.go("home");
            }
        });

        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.selection = [
            {name:'全部', value:''},
            {name:'盘点中', value:'INPROGRESS'},
            {name:'已完成', value:'FINISHED'},
            {name:'已关闭', value:'COLSED'}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            type:''
        };
        vm.suppliers = Supplier.getAll();
        Depository.getAll({},function(res){
            vm.warehouses = res.filter(function(item){return item.defaulted && item.houseSource === 'Internal'});
        });


        // 新建时打开选择仓库的弹框
        $scope.openChooseWarehouseDialog = function(record) {
            $uibModal.open({
                templateUrl: 'app/stockManagement/components/choose-warehouse-dialog.html',
                controller: 'ChooseWarehouseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                }
            }).result.then(function(result){
            });
        };

        init();
        function init() {
            vm.tableList = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            var items = [];
            var _p = {
                items:items,
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
            }
            if(vm.tableData.type){
                items.push({key:"status",op:"=",value:vm.tableData.type})
            }
            if(vm.tableData.number){
                items.push({key:"number",op:"=",value:vm.tableData.number})
            }
            if(vm.tableData.supplierId){
                items.push({key:"supplier.id",op:"=",value:vm.tableData.supplierId})
            }
            if(vm.tableData.warehouseId){
                items.push({key:"warehouse.id",op:"=",value:vm.tableData.warehouseId})
            }
            if(vm.tableData.startDate){
                items.push({
                    "key": "createdDate",
                    "op": ">=",
                    "value": DateUtils.dayStart(vm.tableData.startDate)
                })
            }
            if(vm.tableData.endDate){
                items.push({
                    "key": "createdDate",
                    "op": "<=",
                    "value": DateUtils.dayEnd(vm.tableData.endDate)
                })
            }
            _p.items = items;
            StockManagement.byCondition(_p, function (res, headers) {
                // console.log(res)
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                // laypage({
                //     cont: 'paging',
                //     curr: (vm.tableData.page + 1), //初始化当前页
                //     pages: pages,
                //     skip: true, //是否开启跳页
                //     first: false,
                //     last: false,
                //     limit: true,
                //     jump: function(obj, first){
                //         if (!first) {
                //             vm.tableData.page = obj.curr - 1;
                //             init();
                //         }
                //     }
                // });
            }, function (error) {
                console.log(error)
            });
        }

        $scope.conditionSelect = function(data){
            vm.tableData.type = data.value;
            vm.tableData.page = 0;
            init();
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                page: Number($stateParams.page) || 0,
                size: 20,
                sort: ['createdDate,DESC'],
                type:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        };

        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                angular.element(".table-top").height("40");
                angular.element(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                angular.element(".table-top").height("auto");
                angular.element(".table-state-btn").addClass("table-state-btnOn");
            }
        };

        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }


        $scope.purchaseOrderType = function (item){
            switch (item) {
                case 'INPROGRESS':
                    return {
                        text:'盘点中',
                        color:'#333'
                    };
                case 'FINISHED':
                    return {
                        text:'已完成',
                        color:'#005eff'
                    };
                case 'COLSED':
                    return {
                        text:'已关闭',
                        color:'#333'
                    };
                default:
                    return {
                        text:item,
                        color:'#333'
                    };
            }
        }
    }

})();

(function () {
    "use strict";

    angular
        .module("gwApp")
        .controller("ProductAddDialogController", ProductAddDialogController);

    ProductAddDialogController.$inject = [
        "$q",
        "$scope",
        "productType",
        "MessageService",
        "$sessionStorage",
        "entity",
        "$uibModalInstance",
        "Product",
    ];

    function ProductAddDialogController(
        $q,
        $scope,
        productType,
        MessageService,
        $sessionStorage,
        entity,
        $uibModalInstance,
        Product
    ) {
        var vm = this;
        // vm.data = entity;
        vm.products = vm.data = [];
        // console.log('已选商品',entity);
        // console.log('productType',productType);
        // console.log('products',vm.products);

        $q.all([vm.products.$promise]).then();
        init();
        function init() {
            Product.getAllByCondition(
                { items: [{ key: "category", op: "=", value: productType }] },
                function (res) {
                    res.forEach(function (item) {
                        item.propertyConfigs.forEach(function (
                            property,
                            index
                        ) {
                            entity.forEach(function (itm) {
                                if (property.id == itm) {
                                    item.propertyConfigs.splice(index, 1);
                                }
                            });
                        });
                        item.propertyConfigs = item.propertyConfigs.filter(function(config){
                            return !config.cancelled
                        })
                    });
                    vm.products = res;
                }
            );
        }

        // 添加商品
        $scope.productAdd = function (index) {
            vm.data.push({});
        };

        // 删除商品
        $scope.productDelete = function (index) {
            vm.data.splice(index, 1);
        };

        //商品选择框change事件
        $scope.selectPurchaseProduct = function (data) {
            data.propertyConfigs = [];
            data.propertyConfigId = null;
            if (data.productId) {
                for (var i = 0; i < vm.products.length; i++) {
                    if (data.productId == vm.products[i].id) {
                        data.propertyConfigs = vm.products[i].propertyConfigs;
                        data.measurementName = vm.products[i].measurementName;
                        data.measurementId = vm.products[i].measurementId;
                        data.productName = vm.products[i].name;
                        data.productNumber = vm.products[i].number;
                        break;
                    }
                }
            }
        };

        //sku选择框change事件
        $scope.selectPurchaseProductSku = function (data, index, item) {
            var selectedSku = vm.data.findIndex(function (item) {
                return item.propertyConfigId === data.propertyConfigId;
            });
            if (selectedSku > -1 && index !== selectedSku) {
                MessageService.error("该sku已存在 请重新选择 ");
                data.propertyConfigId = "";
                return;
            }

            if (data.propertyConfigId) {
                for (var i = 0; i < data.propertyConfigs.length; i++) {
                    if (data.propertyConfigId == data.propertyConfigs[i].id) {
                        data.sku = data.propertyConfigs[i].sku;
                        data.skuNumber = data.propertyConfigs[i].skuNumber;
                        data.unit = data.measurementName;
                        data.beforeQuantity = 0;
                        data.cancelled = false;
                        data.operator = $sessionStorage.user.fullname;
                        data.productType = productType;
                        data.remarks = "";
                        break;
                    }
                }
            }
        };

        // 保存
        $scope.save = function () {
            if (validData(vm.data)) {
                $uibModalInstance.close(vm.data);
            }
        };

        function validData(data) {
            var flag = true;
            data.forEach(function (item) {
                if (flag) {
                    if (
                        !item.productId ||
                        item.productId == null ||
                        item.productId == ""
                    ) {
                        flag = false;
                        MessageService.error("请选择商品!");
                        return;
                    }
                    if (
                        item.propertyConfigId == null ||
                        item.propertyConfigId == ""
                    ) {
                        flag = false;
                        MessageService.error("有商品未选择sku，无法确定!");
                        return;
                    }
                    if (
                        item.price == null ||
                        item.price == "" ||
                        item.price == undefined
                    ) {
                        flag = false;
                        MessageService.error("有商品未设置单价，无法确定!");
                        return;
                    }
                }
            });
            return flag;
        }
        //取消
        $scope.cancelRecord = function () {
            $uibModalInstance.close();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChooseWarehouseDialogController', ChooseWarehouseDialogController);

    ChooseWarehouseDialogController.$inject = ['$q', '$scope', '$state', 'MessageService', 'Depository', '$uibModalInstance', 'StockManagement'];

    function ChooseWarehouseDialogController ($q, $scope, $state, MessageService, Depository, $uibModalInstance, StockManagement) {
        var vm = this;
        Depository.getAll({},function(res){
            // 仅展示有效的 内部仓库
            vm.warehouseList = res.filter(function(item){return item.defaulted && item.houseSource == 'Internal'});
        });

        $scope.cancelRecord = function () {
            $uibModalInstance.close();
        }

        $scope.save = function () {
            if(!vm.warehouseId){
                MessageService.error('请选择仓库');
                return
            }
            StockManagement.getWarehouseStatus({warehouseId:vm.warehouseId},function(res){
                console.log(res);
                if(res.stockTaking){
                    MessageService.error('该仓库已在盘点中，请勿重复操作。')
                }else{
                    $state.go('stockAdd',{warehouseId: vm.warehouseId});
                    $uibModalInstance.close(true);
                }
            },function(error){

            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UnitMeasurementEditController', UnitMeasurementEditController);

    UnitMeasurementEditController.$inject = ['$scope', '$state','MessageService', 'UnitMeasurement', 'entity', '$stateParams'];

    function UnitMeasurementEditController ($scope,$state,MessageService,UnitMeasurement, entity, $stateParams) {
        var vm = this;
        vm.unitMeasurement = entity;
        vm.typeList =['数量','重量','长度','面积','体积','密度'];

        $scope.save = function () {
            if(!vm.unitMeasurement.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.unitMeasurement.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.unitMeasurement.type){
                MessageService.error("类型不能为空");
                return;
            }
            if(vm.unitMeasurement.accuracy =='' || vm.unitMeasurement.accuracy ==null){
                vm.unitMeasurement.accuracy = 0;
            }

            if(!vm.unitMeasurement.number){
                MessageService.error("编码不能为空");
                return;
            }
            if (vm.unitMeasurement.number.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("编码不能输入中文");
                return false;
            }
            vm.isSaving = true;
            UnitMeasurement.update(vm.unitMeasurement, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("unitMeasurement",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("unitMeasurement",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UnitMeasurementAddController', UnitMeasurementAddController);

    UnitMeasurementAddController.$inject = ['$scope','$state','MessageService', 'UnitMeasurement'];

    function UnitMeasurementAddController ($scope, $state,MessageService,UnitMeasurement) {
        var vm = this;
        init();
        function init(){
            vm.unitMeasurement = {
                name: '',
                defaulted: true,
                type:'',
                accuracy:'',
                number: ''
            };
        }
        vm.typeList =['数量','重量','长度','面积','体积','密度'];

        $scope.save = function () {
            if(!vm.unitMeasurement.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.unitMeasurement.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.unitMeasurement.type){
                MessageService.error("类型不能为空");
                return;
            }
            if(vm.unitMeasurement.accuracy ==''){
                vm.unitMeasurement.accuracy = 0;
            }
            if(!vm.unitMeasurement.number){
                MessageService.error("编码不能为空");
                return;
            }
            if (vm.unitMeasurement.number.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("编码不能输入中文");
                return false;
            }
            vm.isSaving = true;
            UnitMeasurement.add(vm.unitMeasurement, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("unitMeasurement");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('unitMeasurement', {
                parent: 'module',
                url: '/unitMeasurement',
                params:{page: null},
                data: {
                    authorities: ['ROLE_UNIT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/unitMeasurement/unitMeasurement.html',
                        controller: 'UnitMeasurementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('unitMeasurementAdd', {
                parent: 'module',
                url: '/unitMeasurementAdd',
                data: {
                    authorities: ['ROLE_UNIT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/unitMeasurement/unitMeasurement-add.html',
                        controller: 'UnitMeasurementAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('unitMeasurementEdit', {
                parent: 'module',
                url: '/unitMeasurementEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_UNIT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/unitMeasurement/unitMeasurement-edit.html',
                        controller: 'UnitMeasurementEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UnitMeasurement', function($stateParams, UnitMeasurement) {
                        return UnitMeasurement.detail({id : $stateParams.id});
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('UnitMeasurement', UnitMeasurement)
        .factory('UnitMeasurementList', UnitMeasurementList);

    UnitMeasurement.$inject = ['$resource'];
    UnitMeasurementList.$inject = ['$resource'];

    function UnitMeasurement ($resource) {
        var resourceUrl =  'api/measurement/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'pages'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {
                method:'GET',
                params: {
                    path: 'getOne'
                }
            }
        });
    }
    function UnitMeasurementList ($resource) {
        var resourceUrl =  'api/measurementList/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UnitMeasurementController', UnitMeasurementController);

    UnitMeasurementController.$inject = ['$scope', 'Principal', 'LoginService', '$state','UnitMeasurement','MessageService', 'ParseLinks', '$stateParams'];

    function UnitMeasurementController ($scope, Principal, LoginService, $state,UnitMeasurement,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            UnitMeasurement.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.unitMeasurementDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                UnitMeasurement.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('TagDetailController', TagDetailController);

    TagDetailController.$inject = ['$scope', '$state','MessageService', 'MetaTags', 'entity', '$stateParams','LocationProvice', 'LocationCity', 'LocationDistrict','Supplier','Qinius','$q','$sce'];

    function TagDetailController ($scope,$state,MessageService,MetaTags, entity, $stateParams,LocationProvice, LocationCity, LocationDistrict,Supplier,Qinius, $q,$sce) {
        var vm = this;
        vm.ratio = 0;
        js_getDPI();
        if(!$stateParams.id){
            vm.data = {
                tags:[],
                width:100,
                height:100
            };
            initTags();
        }else {
            vm.data = entity;
            $q.all([vm.data.$promise]).then(function () {
                ratioInfo();
                initTags();
            })
        }
        function initTags() {
            var _tags = [];
            // _tags.push(getTag('altek'))
            _tags.push(getTag('articleName'))
            _tags.push(getTag('barCode'))
            // _tags.push(getTag('customer'))
            _tags.push(getTag('orderNumber'))
            _tags.push(getTag('phone'))
            _tags.push(getTag('productName'))
            _tags.push(getTag('quantity'))
            _tags.push(getTag('recipients'))
            _tags.push(getTag('sourceOrderNumber'))
            _tags.push(getTag('storeName'))
            vm.data.tags.forEach(function(tag){
                tag.enabled = true;
                tag.type1= 'enable' + tag.type.charAt(0).toUpperCase() + tag.type.slice(1);
                if(!tag.fontsize){tag.fontsize = 9}
                if(!tag.fontColor){tag.fontColor = "#000000"}
                tag.name = getName(tag.type);
                _tags.forEach(function(tag1,index){
                    if(tag.type == tag1.type){
                        _tags[index] = angular.copy(tag);
                    }
                })
            })
            vm.data.tags = _tags;
            console.log(vm.data.tags)
        }
        function getTag(type){
            var _data = {
                fontColor: "#000000", 
                text: true,
                x: 0,
                y: 0, 
                enabled: false, 
                fontsize: 9, 
                bold: false, 
                type:type, 
                type1: 'enable' + type.charAt(0).toUpperCase() + type.slice(1), 
                width: 100, 
                height: 8, 
                name: getName(type)
            }
            if(type == 'altek'){ _data.width = 19; _data.height = 4; _data.name = '客户简介' };
            if(type == 'customer'){  _data.width = 37; _data.height = 4; _data.name = '客户全名' };
            if(type == 'recipients'){  _data.width = 11; _data.height = 4; _data.name = '收件人' };
            if(type == 'quantity'){  _data.width = 9; _data.height = 4; _data.name = '份数' };
            if(type == 'productName'){  _data.width = 45; _data.height = 4; _data.name = '商品名称'};
            if(type == 'barCode'){  _data.width = 40; _data.height = 14; _data.name = '来源单号条码', _data.img=true};
            if(type == 'sourceOrderNumber'){  _data.width = 18; _data.height = 4; _data.name = '来源单号'};
            if(type == 'phone'){  _data.width = 18; _data.height = 4; _data.name = '收件人电话'};
            if(type == 'articleName'){  _data.width = 18; _data.height = 4; _data.name = '作品名'};
            if(type == 'storeName'){  _data.width = 18; _data.height = 4; _data.name = '店铺名称'};
            if(type == 'orderNumber'){  _data.width = 18; _data.height = 4; _data.name = '订单号'};
            return _data
        }
        $scope.getName = getName;
        function getName(type){
            if(type == 'altek'){ return '客户简介' };
            if(type == 'customer'){  return '客户全名' };
            if(type == 'recipients'){  return '收件人' };
            if(type == 'quantity'){ return '份数' };
            if(type == 'productName'){ return '商品名称'};
            if(type == 'barCode'){ return '来源单号条码'};
            if(type == 'sourceOrderNumber'){ return '来源单号'};
            if(type == 'phone'){ return '收件人电话'};
            if(type == 'articleName'){ return '作品名'};
            if(type == 'storeName'){ return '店铺名称'};
            if(type == 'orderNumber'){ return '订单号'};
        }
        Supplier.getAll({}, function (res) {
            vm.suppliers =res.filter(function(item){return item.enable == true;});
        })

        $scope.$watch("vm.data.width",function(newValue,oldValue){
            if(newValue > 0){
                ratioInfo()
            }
        })
        $scope.$watch("vm.data.height",function(newValue,oldValue){
            if(newValue > 0){
                ratioInfo()
            }
        })
        function ratioInfo(){
            if(vm.data.width <= 0 && vm.data.height <= 0){
                return
            }
            vm.windowWidth = 500;
            vm.windowHeight = 500;
            var ratio = vm.data.width / vm.data.height;
            var ratio1 = vm.windowWidth / vm.windowHeight;
            if (ratio >= ratio1) {
                vm.ratio = vm.windowWidth / vm.data.width;
            } else {
                vm.ratio = vm.windowHeight / vm.data.height;
            }
        }

        vm.isDown = false;
        $scope.tagdown = function ($event, item) {
            fn($event)
            vm.tagChartlet = {};
            vm.tagChartlet.x = $event.clientX;
            vm.tagChartlet.y = $event.clientY;
            vm.tagChartlet.l = angular.copy(item.x * vm.ratio);
            vm.tagChartlet.t = angular.copy(item.y * vm.ratio);
            vm.tagChartlet.r = angular.copy((vm.data.width - item.width) * vm.ratio);
            vm.tagChartlet.b = angular.copy((vm.data.height - item.height) * vm.ratio);
            vm.isDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (!vm.isDown) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - (vm.tagChartlet.x - vm.tagChartlet.l);
                var nt = ny - (vm.tagChartlet.y - vm.tagChartlet.t);
                if(nl<0){ nl = 0};
                if(nl > vm.tagChartlet.r){ nl = vm.tagChartlet.r};
                if(nt < 0){ nt = 0};
                if(nt > vm.tagChartlet.b){ nt = vm.tagChartlet.b};

                item.x = nl / vm.ratio;
                item.y = nt / vm.ratio;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                vm.isDown = false;
                $event.stopPropagation();
            }
        }
        $scope.save = function () {
            var _data = angular.copy(vm.data);
            if(!_data.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(!_data.supplierId){
                MessageService.error("供应商不能为空");
                return;
            }
            if(!_data.width){
                MessageService.error("尺寸宽不能为空");
                return;
            }
            if(!_data.height){
                MessageService.error("尺寸高不能为空");
                return;
            }
            _data.tags = [];
            vm.data.tags.forEach(function (item) {
                _data[item.type1] = false;
                if(item.enabled){
                    _data[item.type1] = true;
                    _data.tags.push(item);
                }
            });
            vm.isSaving = true;
            if(!$stateParams.id){
                MetaTags.add(_data, onSaveSuccess, onSaveError);
            }else {
                MetaTags.update(_data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("成功");
                $state.go("tag",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("tag",{page: $stateParams.page});
        };


        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            } else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[1];
            return arrDPI;
        }
        //cm转px
        function cmTransitionPx(item) {
            return parseFloat((item * vm.windowDpi / 25.4 * 10).toFixed(2));
        }

        //px转cm
        function pxTransitionCm(item) {
            return parseFloat((item * 25.4 / vm.windowDpi / 10).toFixed(2));
        }
        //mm转px
        function mmTransitionPx(item) {
            return parseFloat((item * vm.windowDpi / 25.4));
        }

        //px转mm
        function pxTransitionMm(item) {
            return parseFloat((item * 25.4 / vm.windowDpi));
        }
        var a = null;
        $scope.fongsizeChange = function(item){
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                if(item){
                    if(!item.fontsize || item.fontsize<9){
                        item.fontsize = 9;
                    }
                }
                $scope.$apply();
            },1000)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tag', {
                parent: 'module',
                url: '/tag',
                params:{page: null},
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/tag/tag.html',
                        controller: 'TagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('tagAdd', {
                parent: 'module',
                url: '/tagAdd',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/tag/tag-detail.html',
                        controller: 'TagDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ReplenishmentReason', function($stateParams, ReplenishmentReason) {
                        return null;
                    }],
                }
            })
            .state('tagEdit', {
                parent: 'module',
                url: '/tagEdit/{id}/{page}',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/tag/tag-detail.html',
                        controller: 'TagDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MetaTags', function($stateParams, MetaTags) {
                        return MetaTags.get({id : $stateParams.id});
                    }],
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('MetaTags', MetaTags);

    MetaTags.$inject = ['$resource'];

    function MetaTags ($resource) {
        var resourceUrl =  'api/meta-tags/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {
                    path: 'pages'
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                params:{
                    path: 'list'
                },
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {
                method: 'GET',
                params: {
                    path: 'getOne'
                }
            },
            'getAllByCondition': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                },
                isArray:true
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray:true
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('TagController', TagController);

    TagController.$inject = ['$scope', 'Principal', 'LoginService', '$state','MetaTags','MessageService', 'ParseLinks', '$stateParams'];

    function TagController($scope, Principal, LoginService, $state,MetaTags,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.keyword = "";
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['id,DESC'],
            items: [{key: "cancelled", op: "=", value: false}]
        };
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            if(vm.keyword){
                vm.tableData.items.push({key: "name", op: "like", value: vm.keyword});
            }
            MetaTags.byCondition(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.depositoryDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                MetaTags.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('systemLog', {
            parent: 'module',
            url: '/systemLog',
            data: {
                authorities: ['ROLE_SYSTEM_LOG']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/systemLog/systemLog.html',
                    controller: 'SystemLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SystemLogController', SystemLogController);

    SystemLogController.$inject = ['$scope','SystemLog','MessageService', 'ParseLinks', '$stateParams'];

    function SystemLogController ($scope,SystemLog,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword:'',
            start:'',
            end:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        init();
        function init() {
            vm.tableList = [];
            vm.tableData.start = angular.copy(angular.element("#startDate").val());
            vm.tableData.end = angular.copy(angular.element("#endDate").val());
            SystemLog.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                keyword:'',
                start:'',
                end:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('system', {
            parent: 'module',
            url: '/system',
            data: {
                authorities: ['ROLE_SYSTEM_SETTING']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/system/system.html',
                    controller: 'SystemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('System', System)
        .factory('Qinius', Qinius)
        .factory('SystemLog', SystemLog);

    System.$inject = ['$resource'];
    SystemLog.$inject = ['$resource'];
    Qinius.$inject = ['$resource'];

    function Qinius($resource) {
        var resourceUrl = 'api/qiniu/:path/:storeId';
        var service = $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'upload-token'
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getDomain': {
                method: 'GET',
                params: {
                    path: 'bucket-domains'
                }
            }
        });
        return service;
    }


    function System ($resource) {
        var resourceUrl =  'api/system-settings/:id';

        return $resource(resourceUrl, {}, {
            'getAll':{
                method:'GET', isArray: true,
                params: {
                    id: 'getAll'
                }
            },
            'update': { method:'PUT' }
        });
    }

    function SystemLog ($resource) {
        var resourceUrl =  'api/operation-logs/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll':{
                method:'GET',
                isArray: true
            },
            page:{
                method:'GET',
                params: {
                    path: 'page'
                },
                isArray: true
            },
            'update': { method:'PUT' },
            'create': { method:'POST' },
            'detail': { method:'GET' },
            'delete': { method:'DELETE'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SystemController', SystemController);

    SystemController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'System', 'Qinius', '$q', '$timeout','ExpressApiSetting'];

    function SystemController ($scope, Principal, LoginService, $state,User,MessageService,System, Qinius, $q, $timeout,ExpressApiSetting) {
        var vm = this;
        vm.tokens = Qinius.get();
        vm.domains = Qinius.getDomain();
        vm.ffc_url = {};
        vm.procurementWarning = {};
        vm.orderDays = {};
        vm.kdnUserid = {};
        vm.kdnAppkey = {};
        vm.prePressFlowUrl ={};
        vm.defaultProductImg ={};
        vm.downloadWarning ={};
        vm.projectExamineSwitch = {};
        vm.autoBoxing = {};
        vm.projectFileUrlPrefix = {};


        $q.all([vm.tokens.$promise, vm.domains.$promise]).then(function(){
            vm.token = vm.tokens.token;
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
        })

         $scope.removeFile = function () {
            vm.defaultProductImg.value = null;
        };

        //产品 coverImg更改
        window.updateImgFile1 = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.defaultProductImg.value = $scope.domain + data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        System.getAll({}, function (res) {
            console.log(res);
            for(var i=0; i<res.length; i++){
                // if(res[i].key == 'warning_time'){
                //     vm.warningTime = res[i];
                // }
                if (res[i].key == 'ffc_url') {
                    vm.ffc_url = res[i];
                }
                if (res[i].key == 'warning_procurement') {
                    vm.procurementWarning = res[i];
                }
                if (res[i].key == 'order_days') {
                    vm.orderDays = res[i];
                }
                if (res[i].key == 'kdn_userid') {
                    vm.kdnUserid = res[i];
                }
                if (res[i].key == 'kdn_appkey') {
                    vm.kdnAppkey = res[i];
                }
                if (res[i].key == 'pre_press_flow_url') {
                    vm.prePressFlowUrl = res[i];
                }
                if (res[i].key == 'default_product_img') {
                    vm.defaultProductImg = res[i];
                }
                if (res[i].key == 'download_warning') {
                    vm.downloadWarning = res[i];
                }
                if (res[i].key == 'project_examine_switch') {
                    vm.projectExamineSwitch = res[i];
                    if (vm.projectExamineSwitch.value == 'true') {
                        vm.projectExamineSwitch.value = true;
                    } else {
                        vm.projectExamineSwitch.value = false;
                    }
                }
                if (res[i].key == 'auto_boxing') {
                    vm.autoBoxing = res[i];
                    if (vm.autoBoxing.value == 'true') {
                        vm.autoBoxing.value = true;
                    } else {
                        vm.autoBoxing.value = false;
                    }
                }
                if (res[i].key == 'project_file_url_prefix') {
                    vm.projectFileUrlPrefix = res[i];
                }
            }
        });

        $scope.save = function () {
            // if(!vm.warningTime.value){
            //     MessageService.error("预警时间不能为空");
            //     return;
            // }
            // if(isNaN(vm.warningTime.value) || vm.warningTime.value < 0){
            //     MessageService.error("预警时间只能输入大于0的数字");
            //     return;
            // }
            if (vm.kdnUserid == undefined || !vm.kdnUserid.value) {
                MessageService.error("快递鸟客户号不能为空");
                return;
            }
            if (vm.kdnAppkey == undefined || !vm.kdnAppkey.value) {
                MessageService.error("快递鸟密码不能为空");
                return;
            }
            if(vm.orderDays == undefined || !vm.orderDays.value) {
                MessageService.error("订单显示范围不能为空");
                return;
            }
            if(vm.procurementWarning == undefined || !vm.procurementWarning.value){
                MessageService.error("采购预警时间不能为空");
                return;
            }
            if (vm.downloadWarning == undefined || !vm.downloadWarning.value) {
                MessageService.error("下载预警时间不能为空");
                return;
            }
            if(vm.ffc_url == undefined || !vm.ffc_url.value){
                MessageService.error("接口url不能为空");
                return;
            }
            if(!vm.projectFileUrlPrefix || !vm.projectFileUrlPrefix.value){
                MessageService.error("接口url不能为空");
                return;
            }

            vm.isSaving = true;
            // vm.warningTime.key = 'warning_time';
            // System.update(vm.warningTime, function onSaveSuccess () {
            vm.procurementWarning.key = 'warning_procurement';
            vm.ffc_url.key = 'ffc_url';
            vm.orderDays.key = 'order_days';
            vm.kdnUserid.key = 'kdn_userid';
            vm.kdnAppkey.key = 'kdn_appkey';
            vm.downloadWarning.key = "download_warning";
            vm.projectFileUrlPrefix.key = "project_file_url_prefix";
            vm.projectExamineSwitch.key = "project_examine_switch";
            vm.autoBoxing.key = "auto_boxing";
            vm.prePressFlowUrl.key = "pre_press_flow_url";
            vm.defaultProductImg.key = "default_product_img";
            if (vm.projectExamineSwitch.value == null) {
                vm.projectExamineSwitch.value = "false";
            }
            if (vm.autoBoxing.value == null) {
                vm.autoBoxing.value = "false";
            }

            var list = [];
            list.push(vm.procurementWarning);
            list.push(vm.ffc_url);
            list.push(vm.orderDays);
            list.push(vm.kdnUserid);
            list.push(vm.kdnAppkey);
            list.push(vm.downloadWarning);
            list.push(vm.projectExamineSwitch);
            list.push(vm.autoBoxing);
            list.push(vm.projectFileUrlPrefix);
            list.push(vm.prePressFlowUrl);
            list.push(vm.defaultProductImg);

            System.update(list, function onSaveSuccess () {
                vm.isSaving = false;
                MessageService.success("保存成功");
            }, function onSaveError () {
                vm.isSaving = false;
                MessageService.error("保存失败，请稍后重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SortingEditController', SortingEditController);

    SortingEditController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Sorting','entity', '$stateParams', 'Channels'];

    function SortingEditController ($scope, Principal, LoginService, $state,User,MessageService,Sorting,entity, $stateParams, Channels) {
        var vm = this;
        vm.data = entity;
        console.log(vm.data)
        Channels.getAll({}, function(res) {
            vm.channelList = res;
            for(var i=0; i<res.length; i++){
                if(res[i].id == vm.data.channelId){
                    vm.channel = res[i];
                }
            }
        });
        $scope.channelSelect = function () {
            vm.data.channelId = vm.channel.id;
            vm.data.channelName = vm.channel.name;
        }
        $scope.save = function () {
            if(!vm.data.merchantId){
                MessageService.error("所属渠道不能为空");
                return;
            }
            if(!vm.data.channelName){
                MessageService.error("商户唯一标识不能为空");
                return;
            }
            if(vm.data.channelName.length >20){
                MessageService.error("商户唯一标识不能大于20位");
                return;
            }
            vm.isSaving = true;
            Sorting.update(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("编辑成功");
                $state.go("sorting",{page: $stateParams.page});
            }

            function onSaveError (error) {
                vm.isSaving = false;
                MessageService.error(error.data.message);
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("sorting",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SortingAddController', SortingAddController);

    SortingAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Sorting', 'entity'];

    function SortingAddController ($scope, Principal, LoginService, $state,User,MessageService,Sorting, entity) {
        var vm = this;
        vm.channelList = entity;
        vm.channel = "";
        vm.data = {
            merchantId: '',
            channelName: '',
            enable: true
        };
        vm.isSaving = false;

        $scope.save = function () {
            if(!vm.data.merchantId){
                MessageService.error("所属渠道不能为空");
                return;
            }
            if(!vm.data.channelName){
                MessageService.error("商户唯一标识不能为空");
                return;
            }
            if(vm.data.channelName.length >20){
                MessageService.error("商户唯一标识不能大于20位");
                return;
            }
            vm.isSaving = true;
            Sorting.add(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("sorting");
            }

            function onSaveError (error) {
                vm.isSaving = false;
                MessageService.error(error.data.message);
            }
        };

        $scope.channelSelect = function () {
            vm.data.channelId = vm.channel.id;
            vm.data.channelName = vm.channel.name;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sorting', {
            parent: 'module',
            url: '/sorting',
            data: {
                authorities: ['ROLE_ITEM']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/sorting/sorting.html',
                    controller: 'SortingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('sortingAdd', {
            parent: 'module',
            url: '/sortingAdd',
            data: {
                authorities: ['ROLE_ITEM']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/sorting/sorting-add.html',
                    controller: 'SortingAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Channels', function ($stateParams, Channels) {
                    return Channels.getAll();
                }]
            }
        })
        .state('sortingEdit', {
            parent: 'module',
            url: '/sortingEdit/{id}',
            params:{page: null},
            data: {
                authorities: ['ROLE_ITEM']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/sorting/sorting-edit.html',
                    controller: 'SortingEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sorting', function ($stateParams, Sorting) {
                    return Sorting.detail({id: $stateParams.id});
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Sorting', Sorting);

    Sorting.$inject = ['$resource'];

    function Sorting ($resource) {
        var resourceUrl =  'api/sorting-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                params: {
                    id: 'page'
                },
            },
            'getAll': { method: 'GET', isArray: true,
                params: {
                    id: 'getAll'
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    id: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SortingController', SortingController);

    SortingController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Sorting','MessageService', 'ParseLinks', '$stateParams'];

    function SortingController ($scope, Principal, LoginService, $state,Sorting,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            Sorting.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Sorting.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ShelfManagementEditController', ShelfManagementEditController);

    ShelfManagementEditController.$inject = ['$scope','$state','MessageService', 'GoodsShelves','entity', '$stateParams','ProductCategory','Supplier','$q'];

    function ShelfManagementEditController ($scope,$state,MessageService,GoodsShelves,entity, $stateParams,ProductCategory,Supplier,$q) {
        var vm = this;
        vm.data = entity;
        vm.productTypes = ProductCategory.getAll();
        vm.supplier = Supplier.getAll();
        $q.all([vm.productTypes.$promise,vm.supplier.$promise]).then(function() {
            vm.typeList =vm.productTypes.filter(function(item){return item.enable == true;});
            vm.suppliers =vm.supplier.filter(function(item){return item.enable == true;});
        });

        $scope.save = function () {
            if(!vm.data.supplierId){
                MessageService.error("供应商不能为空");
                return;
            }
            vm.isSaving = true;
            GoodsShelves.update(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("编辑成功");
                $state.go("shelfManagement",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("编辑失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("shelfManagement",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ShelfManagementAddsController', ShelfManagementAddsController);

    ShelfManagementAddsController.$inject = ['$scope','$state','MessageService', 'GoodsShelves','ProductCategory','Supplier','$q'];

    function ShelfManagementAddsController ($scope, $state,MessageService,GoodsShelves,ProductCategory,Supplier,$q) {
        var vm = this;
        vm.data = {
            prefix: '',
            beginNumber: '',
            quantity: '',
            productCategoryId: '',
            supplierId:''
        };
        vm.productTypes = ProductCategory.getAll();
        vm.supplier = Supplier.getAll();
        $q.all([vm.productTypes.$promise,vm.supplier.$promise]).then(function() {
            vm.typeList =vm.productTypes.filter(function(item){return item.enable == true;});
            vm.suppliers =vm.supplier.filter(function(item){return item.enable == true;});
        });

        $scope.save = function () {
            if(!vm.data.quantity){
                MessageService.error("货架数量不能为空");
                return;
            }
            if(vm.data.quantity >999){
                MessageService.error("货架数量不能超过999");
                return;
            }
            if(!vm.data.supplierId){
                MessageService.error("供应商不能为空");
                return;
            }
            vm.isSaving = true;
            GoodsShelves.createBatch(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("shelfManagement");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ShelfManagementAddController', ShelfManagementAddController);

    ShelfManagementAddController.$inject = ['$scope', '$state','MessageService', 'GoodsShelves','ProductCategory','Supplier','$q'];

    function ShelfManagementAddController ($scope, $state,MessageService,GoodsShelves,ProductCategory,Supplier,$q) {
        var vm = this;
        vm.data = {
            name: '',
            productCategoryId: '',
            supplierId:''
        };
        vm.productTypes = ProductCategory.getAll();
        vm.supplier = Supplier.getAll();
        $q.all([vm.productTypes.$promise,vm.supplier.$promise]).then(function() {
            vm.typeList =vm.productTypes.filter(function(item){return item.enable == true;});
            vm.suppliers =vm.supplier.filter(function(item){return item.enable == true;});
        });

        $scope.save = function () {
            if(!vm.data.supplierId){
                MessageService.error("供应商不能为空");
                return;
            }
            vm.isSaving = true;
            GoodsShelves.create(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("shelfManagement");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('shelfManagement', {
            parent: 'module',
            url: '/shelfManagement',
            params:{page: null},
            data: {
                authorities: ['ROLE_GOODS_SHELVES']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/shelfManagement/shelfManagement.html',
                    controller: 'ShelfManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('shelfManagementAdd', {
            parent: 'module',
            url: '/shelfManagementAdd',
            data: {
                authorities: ['ROLE_GOODS_SHELVES']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/shelfManagement/shelfManagement-add.html',
                    controller: 'ShelfManagementAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('shelfManagementAdds', {
            parent: 'module',
            url: '/shelfManagementAdds',
            data: {
                authorities: ['ROLE_GOODS_SHELVES']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/shelfManagement/shelfManagement-adds.html',
                    controller: 'ShelfManagementAddsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('shelfManagementEdit', {
            parent: 'module',
            url: '/shelfManagementEdit/{id}',
            params:{page: null},
            data: {
                authorities: ['ROLE_GOODS_SHELVES']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/shelfManagement/shelfManagement-edit.html',
                    controller: 'ShelfManagementEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GoodsShelves', function ($stateParams, GoodsShelves) {
                    return GoodsShelves.detail({id: $stateParams.id});
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('GoodsShelves', GoodsShelves);

    GoodsShelves.$inject = ['$resource'];

    function GoodsShelves ($resource) {
        var resourceUrl =  'api/goods-shelves/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'create': {
                method: 'POST',
                params: {
                    path: 'create'
                }
            },
            'createBatch': {
                method: 'POST',
                isArray: true,
                params: {
                    path: 'create-batch'
                }
            },
            'getAll': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{method:'DELETE'},
            'update': { method:'PUT' },
            'detail': {method:'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ShelfManagementController', ShelfManagementController);

    ShelfManagementController.$inject = ['$scope','GoodsShelves','MessageService', 'ParseLinks', '$stateParams'];

    function ShelfManagementController ($scope,GoodsShelves,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };


        init();
        function init() {
            vm.tableList = [];
            GoodsShelves.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.shelfDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                GoodsShelves.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReplenishmentReasonEditController', ReplenishmentReasonEditController);

    ReplenishmentReasonEditController.$inject = ['$scope', '$state','MessageService', 'ReplenishmentReason', 'entity', '$stateParams'];

    function ReplenishmentReasonEditController ($scope,$state,MessageService,ReplenishmentReason, entity, $stateParams) {
        var vm = this;
        vm.replenishmentReason = entity;
        vm.belongs =[
            {name:'平台',value:'platform'},
            {name:'供应商',value:'supplier'}
        ];

        $scope.save = function () {
            if(!vm.replenishmentReason.reason){
                MessageService.error("原因不能为空");
                return;
            }
            if(vm.replenishmentReason.reason.length >20){
                MessageService.error("原因不能大于20位");
                return;
            }
            if(!vm.replenishmentReason.remarks){
                MessageService.error("描述不能为空");
                return;
            }
            if(vm.replenishmentReason.remarks >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            if(!vm.replenishmentReason.type){
                MessageService.error("所属不能为空");
                return;
            }
            vm.isSaving = true;
            ReplenishmentReason.update(vm.replenishmentReason, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("replenishmentReason",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("replenishmentReason",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReplenishmentReasonAddController', ReplenishmentReasonAddController);

    ReplenishmentReasonAddController.$inject = ['$scope','$state','MessageService', 'ReplenishmentReason'];

    function ReplenishmentReasonAddController ($scope, $state,MessageService,ReplenishmentReason) {
        var vm = this;
        init();
        function init(){
            vm.replenishmentReason = {
                reason: '',
                enable: true,
                remarks: '',
                type: ''
            };
        }

        vm.belongs =[
            {name:'平台',value:'platform'},
            {name:'供应商',value:'supplier'}
        ];

        $scope.save = function () {
            if(!vm.replenishmentReason.reason){
                MessageService.error("原因不能为空");
                return;
            }
            if(vm.replenishmentReason.reason.length >20){
                MessageService.error("原因不能大于20位");
                return;
            }
            if(!vm.replenishmentReason.remarks){
                MessageService.error("描述不能为空");
                return;
            }
            if(vm.replenishmentReason.remarks >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            if(!vm.replenishmentReason.type){
                MessageService.error("所属不能为空");
                return;
            }
            vm.isSaving = true;
            ReplenishmentReason.add(vm.replenishmentReason, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("replenishmentReason");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('replenishmentReason', {
            parent: 'module',
            url: '/replenishmentReason',
            params:{page: null},
            data: {
                authorities: ['ROLE_REPLENISH_REASON']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/replenishment/replenishmentReason.html',
                    controller: 'ReplenishmentReasonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
            .state('replenishmentReasonAdd', {
                parent: 'module',
                url: '/replenishmentReasonAdd',
                data: {
                    authorities: ['ROLE_REPLENISH_REASON']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/replenishment/replenishmentReason-add.html',
                        controller: 'ReplenishmentReasonAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('replenishmentReasonEdit', {
                parent: 'module',
                url: '/replenishmentReasonEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_REPLENISH_REASON']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/replenishment/replenishmentReason-edit.html',
                        controller: 'ReplenishmentReasonEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ReplenishmentReason', function($stateParams, ReplenishmentReason) {
                        return ReplenishmentReason.detail({id : $stateParams.id});
                    }],
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('ReplenishmentReason', ReplenishmentReason);

    ReplenishmentReason.$inject = ['$resource'];

    function ReplenishmentReason ($resource) {
        var resourceUrl =  'api/replenishment-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    id: 'getAll'
                }
            } ,
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReplenishmentReasonController', ReplenishmentReasonController);

    ReplenishmentReasonController.$inject = ['$scope', 'Principal', 'LoginService', '$state','ReplenishmentReason','MessageService', 'ParseLinks', '$stateParams'];

    function ReplenishmentReasonController ($scope, Principal, LoginService, $state,ReplenishmentReason,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };
        vm.clear =clear;
        init()
        function init() {
            vm.tableList = [];
            ReplenishmentReason.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.replenishmentReasonDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                ReplenishmentReason.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SizeProofEditController', SizeProofEditController);

    SizeProofEditController.$inject = ['$scope','$state','MessageService', 'entity', '$uibModalInstance'];

    function SizeProofEditController ($scope, $state,MessageService,  entity, $uibModalInstance) {
        var vm = this;
 
        vm.sizeProof = entity;
        vm.save = save;
        vm.clear = clear;
        vm.applyAllPages = [{value:true, name:"所有页"},{value: false, name:"部分页"}]
        

        $scope.save = function () {
            if(!vm.proofRule.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.proofRule.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
        };

        function clear(){
            $uibModalInstance.dismiss();
        }
        
        function save() {
            $uibModalInstance.close(vm.sizeProof);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProofRuleEditController', ProofRuleEditController);

    ProofRuleEditController.$inject = ['$scope','$state','MessageService', 'ProofRule', 'entity', '$stateParams', '$uibModal', 'UidService'];

    function ProofRuleEditController ($scope, $state,MessageService,ProofRule, entity, $stateParams, $uibModal, UidService) {
        var vm = this;
 
        vm.proofRule = entity;

        $scope.proofAdd = function(){
            var data = {applyAllPage:true, uuid:UidService.get(), added:true};
            if (vm.proofRule.sizeProofs == null) {
                vm.proofRule.sizeProofs = [];
            };
            // vm.proofRule.sizeProofs.push(data);
            $scope.proofEdit(data);
        }

        $scope.proofCopy = function(data){
            var proof = angular.copy(data);
            proof.id = null;
            if (vm.proofRule.sizeProofs == null) {
                vm.proofRule.sizeProofs = [];
            };
            proof.id = null;
            proof.uuid = UidService.get();
            vm.proofRule.sizeProofs.push(proof);
        }

        $scope.proofDelete = function(data, index){
            if (data.id == null) {
                vm.proofRule.sizeProofs.splice(index,1);
            }else{
               data.cancelled = true; 
            }
        }

        //设置区域
        $scope.proofEdit = function(data){
            $uibModal.open({
                templateUrl: 'app/setting/proofRule/sizeProof-edit.html',
                controller: 'SizeProofEditController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                if (vm.proofRule.sizeProofs == null) {
                    vm.proofRule.sizeProofs = [];
                };
                if (result.added) {
                    result.added = false;
                    vm.proofRule.sizeProofs.push(result);
                }else{
                    if (result.id == null) {
                        for (var i = vm.proofRule.sizeProofs.length - 1; i >= 0; i--) {
                            var p = vm.proofRule.sizeProofs[i];
                            if (p.uuid == result.uuid) {
                                p = result;
                                break;
                            }
                        }
                    }else{
                        for (var i = vm.proofRule.sizeProofs.length - 1; i >= 0; i--) {
                            var p = vm.proofRule.sizeProofs[i];
                            if (p.id == result.id) {
                                p = result;
                                break;
                            }
                        }
                    }
                }
            });
        };


        $scope.save = function () {
            if(!vm.proofRule.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.proofRule.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
             
  
            vm.isSaving = true;
            if (vm.proofRule.id) {
                ProofRule.update(vm.proofRule, onSaveSuccess, onSaveError);
            }else{
                ProofRule.save(vm.proofRule, onSaveSuccess, onSaveError);
            }

            $scope.addproof =function (){

            }

            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("proofRule",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("proofRule",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('proofRule', {
                parent: 'module',
                url: '/proofRule',
                params:{page: null},
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/proofRule/proofRule.html',
                        controller: 'ProofRuleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('proofRuleAdd', {
                parent: 'module',
                url: '/proofRuleAdd',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/proofRule/proofRule-edit.html',
                        controller: 'ProofRuleEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity:  function(){
                        return {
                            dpi:300
                        };
                    }
                }
            })
            .state('proofRuleEdit', {
                parent: 'module',
                url: '/proofRuleEdit/{id}',
                params:{page: null},
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/proofRule/proofRule-edit.html',
                        controller: 'ProofRuleEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ProofRule', function($stateParams, ProofRule) {
                        return ProofRule.get({id : $stateParams.id});
                    }],
                }
            })

        ;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('ProofRule', ProofRule);

    ProofRule.$inject = ['$resource'];

    function ProofRule ($resource) {
        var resourceUrl =  'api/proof-rules/:path/:id';

        return $resource(resourceUrl, {}, {
            'page': { 
                method: 'GET', 
                isArray: true,
                params: {
                    path: 'page'
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'delete':{
                method:'DELETE',
            },
            'enable': { 
                method:'GET',
                params:{
                    path:"enable"
                },
             } ,
            'update': { method:'PUT' },
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProofRuleController', ProofRuleController);

    ProofRuleController.$inject = ['$scope', 'Principal', 'LoginService', '$state','ProofRule','MessageService', 'ParseLinks', '$stateParams'];

    function ProofRuleController ($scope, Principal, LoginService, $state, ProofRule, MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            ProofRule.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                ProofRule.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SetStandardPriceController', SetStandardPriceController);

    SetStandardPriceController.$inject = ['$scope','$uibModalInstance','MessageService', 'msgdata','Makeups'];

    function SetStandardPriceController ($scope,$uibModalInstance,MessageService,msgdata,Makeups) {
        var vm = this;
        vm.save = save;
        console.log(msgdata);
        vm.addPage = msgdata.addPage;
        vm.price = angular.copy(msgdata.data)

        $scope.cancel =function(){
            $uibModalInstance.dismiss();
        };

        function save () {
            if(vm.price.priceNum === '' || vm.price.priceNum === null){
                MessageService.error("标准价格不能为空！");
                return;
            }
            if(vm.addPage&&(vm.price.piecePrice == '' || vm.price.piecePrice == null)){
                MessageService.error("每加1P（标准价）不能为空！");
                return;
            }
            if(vm.price.vipPrice === '' || vm.price.vipPrice === null){
                MessageService.error("会员价不能为空！");
                return;
            }
            if(vm.addPage&&(vm.price.vipPiecePrice == '' || vm.price.vipPiecePrice == null)){
                MessageService.error("每加1P（会员价）不能为空！");
                return;
            }

            $uibModalInstance.close(vm.price);

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SetPriceController', SetPriceController);

    SetPriceController.$inject = ['$scope','$uibModalInstance','MessageService', 'msgdata','Makeups'];

    function SetPriceController ($scope,$uibModalInstance,MessageService,msgdata,Makeups) {
        var vm = this;
        vm.save = save;
        vm.addPage = msgdata.addPage;
        console.log(msgdata)
        vm.priceTypes=[
            {name:'单价',value:'UNITPRICE'},
            {name:'一口价',value:'PRICE'}
        ];

        if(msgdata.data.ladderSetups.length>0){
            vm.ladderSetups=msgdata.data.ladderSetups;
        }else{
            vm.ladderSetups=[];
        }

        var obj={
            quantityMin:'',
            quantityMax:'',
            priceType:'UNITPRICE',
            price:'',
            vipPrice:""
        };

        //新增
        $scope.priceNew =function(){
            var flag = false;
            if(vm.ladderSetups.length >0){
                angular.forEach(vm.ladderSetups,function(item){
                    if(!item.quantityMin || !item.quantityMax || !item.priceType || !item.price){
                        flag = true;
                    }
                });
            }
            if(flag){
                MessageService.error('请将空白项填写完整再添加！！！！');
            }else {
                vm.ladderSetups.push(angular.copy(obj));
            }
        };


        $scope.cancel =function(){
            $uibModalInstance.dismiss();
        };

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        $scope.validate = function(){
            if(vm.ladderSetups&&vm.ladderSetups.length){
                vm.ladderSetups.sort(compare('quantityMin'))
            }else{
                MessageService.error("请添加价格行");
                return false;
            }

            for (var i = vm.ladderSetups.length - 1; i >= 0; i--) {
                var cond =  vm.ladderSetups[i];
                if (!cond.quantityMin) {
                    MessageService.error("数量最小值不能为空");
                    return false;
                }
                if (!cond.quantityMax) {
                    MessageService.error("数量最大值不能为空");
                    return false;
                }
                if (cond.priceType == null||cond.priceType == '') {
                    MessageService.error("请选择价格类型")
                    return false;
                }

                if (cond.price == null||cond.price == '') {
                    MessageService.error("请录入价格")
                    return false;
                }
                if (cond.vipPrice == null||cond.vipPrice == '') {
                    MessageService.error("请录入会员价")
                    return false;
                }
                if(cond.quantityMax <= cond.quantityMin){
                    MessageService.error("请录入正确的阶梯数量")
                    return
                }
                if(vm.addPage&&(cond.piecePrice == '' || cond.piecePrice == null)){
                    MessageService.error("每加1P（标准价）不能为空！");
                    return;
                }
                if(vm.addPage&&(cond.vipPiecePrice == '' || cond.vipPiecePrice == null)){
                    MessageService.error("每加1P（标准价）不能为空！");
                    return;
                }

            }
            return true;
        }


        function save () {
            if (!$scope.validate()) {
                return;
            }
            for (var i = 0; i < vm.ladderSetups.length-1; i++) {
                var cond =  vm.ladderSetups[i];
                var cond2 =  vm.ladderSetups[i+1];
                if(cond.quantityMax <= cond.quantityMin){
                    MessageService.error("请录入正确的阶梯数量")
                    return
                }
                if(cond.quantityMax+1!=cond2.quantityMin){
                    MessageService.error("请录入正确的阶梯数量")
                    return
                }
            }
            $uibModalInstance.close(vm.ladderSetups);
        }

        $scope.defaultDelete =function(index){
            vm.ladderSetups.splice(index,1);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PriceListSkuController', PriceListSkuController);

    PriceListSkuController.$inject = ['$scope','$uibModalInstance','MessageService', 'msgdata','$uibModal','Product','$q'];

    function PriceListSkuController ($scope,$uibModalInstance,MessageService,msgdata,$uibModal,Product,$q) {
        var vm = this;
        vm.save = save;
        vm.skuManages = [];
        vm.delSku = [];
        vm.addSku = [];
        console.log(msgdata)
        vm.product = Product.get({id: msgdata.productId});

        vm.priceTypes=[
            {name:'单价',value:'UNITPRICE'},
            {name:'一口价',value:'PRICE'}
        ];

        vm.pricingStrategy =[
            {name:'标准定价',value:'STANDARD'},
            {name:'阶梯定价',value:'LADDER'},
            // {name:'梯度定价',value:'GRADIENT'}
        ];

        vm.choices =[
            {name:'订单数',value:'NUMBER'},
            {name:'张数',value:'PAPER'}
        ];

        $scope.search = function(){
            angular.forEach(  vm.skuManages , function(sku){
                sku.hide = false
                if (vm.name != null && vm.name != "") {
                    if (sku.propertyConfig.sku.indexOf(vm.name)<0) {
                        sku.hide = true;
                    }
                }
            })
        }

        $scope.cancelSearch = function(){
            vm.name = null;
            angular.forEach(  vm.skuManages , function(sku){
                sku.hide = false
            })
        }

        $q.all([vm.product.$promise]).then(function(){
            vm.product.propertyConfigs.sort(function(a, b) {
                return a.sort - b.sort
            })
            vm.propertyList = vm.product.propertyConfigs;
            vm.addSku = angular.copy(vm.propertyList);
            if(msgdata.priceRules&&msgdata.priceRules.length){
                vm.skuManages = angular.copy(msgdata.priceRules);

                for (var x = vm.skuManages.length - 1; x >= 0; x--) {
                    for (var y = vm.propertyList.length - 1; y >= 0; y--) {
                        if (vm.propertyList[y].id == vm.skuManages[x].propertyConfigId) {
                            vm.skuManages[x].propertyConfig = vm.propertyList[y];
                            vm.propertyList[y].isAdd = true;
                        }
                    }
                    if(vm.skuManages[x].cancelled){
                        if (vm.skuManages[x].propertyConfigCancelled) {
                            continue;
                        }
                        vm.delSku.push(vm.skuManages[x])
                    }
                }

                for (var y = vm.propertyList.length - 1; y >= 0; y--) {
                    if(vm.propertyList[y].isAdd){
                        vm.addSku.splice(y, 1);
                    }
                }
                if (vm.addSku.length) {
                    angular.forEach(vm.addSku, function (sku) {
                        var sku2 = {
                            propertyConfigId: sku.id,
                            propertyConfigNumber: sku.number,
                            propertyConfigSku: sku.sku,
                            propertyConfig:sku,
                            cancelled:true,
                            type:'STANDARD',
                            baseOn:'NUMBER',
                            ladderSetups:[],
                            priceNum:null,
                            vipPrice:null,
                            piecePrice:null,
                            vipPiecePrice:null,
                        }
                        vm.skuManages.push(sku2);
                        vm.delSku.push(sku2);
                    })
                }
            }else{
                // angular.forEach(vm.propertyList,function (p) {
                //     var skuManage = {
                //         propertyConfigId: p.id,
                //         propertyConfig:p,
                //         type:'STANDARD',
                //         baseOn:'NUMBER',
                //         ladderSetups:[],
                //         priceNum:null,
                //         vipPrice:null,
                //         piecePrice:null,
                //         vipPiecePrice:null,
                //     }
                //     vm.skuManages.push(skuManage);
                // })
            }
            angular.forEach(  vm.skuManages , function(sku){
                sku.hide = false
            })
        })

        $scope.changePropertyConfig = function(data){
            // data.propertyConfigId = data.propertyConfig.id;
            // data.propertyConfigSku = data.propertyConfig.sku;
        };



        //梯度/阶梯弹窗
        $scope.setLadderSetups = function (data) {
            $uibModal.open({
                templateUrl: 'app/setting/priceList/set-price.html',
                controller: 'SetPriceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return {
                            addPage:msgdata.addPage,
                            data:data
                        }
                    }
                }
            }).result.then(function(result){
                data.ladderSetups = result;
            });
        }

        //标准定价弹窗
        $scope.setStandardPrice = function(data){
            $uibModal.open({
                templateUrl: 'app/setting/priceList/set-standard-price.html',
                controller: 'SetStandardPriceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'mg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return {
                            addPage:msgdata.addPage,
                            data:data
                        }
                    }
                }
            }).result.then(function(result){
                data.priceNum = result.priceNum;
                data.piecePrice = result.piecePrice;
                data.vipPrice = result.vipPrice;
                data.vipPiecePrice = result.vipPiecePrice;
            });
        }

        //定价策略修改后
        $scope.changeType = function(data){
            data.ladderSetups = [];
            data.priceNum = null;
            data.piecePrice = null;
            data.vipPrice = null;
            data.vipPiecePrice = null;
        }


        //复制
        $scope.skuCopy = function(data){
            $uibModal.open({
                templateUrl: 'app/customerHub/customerHub-copy.html',
                controller: 'CustomerHubCopyController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return {
                            skuManages:vm.skuManages,
                            data:data,
                            tag:'priceListSku'
                        }
                    }
                }
            }).result.then(function(result){
                angular.forEach(result.skuManages,function(item,i){
                    if(item.selected){
                        // vm.skuManages[i].prePressFlow = angular.copy(item.prePressFlow);
                        vm.skuManages[i].type = angular.copy(item.type);
                        vm.skuManages[i].baseOn = angular.copy(item.baseOn);
                        vm.skuManages[i].ladderSetups = angular.copy(item.ladderSetups);
                        vm.skuManages[i].priceNum = angular.copy(item.priceNum);
                        vm.skuManages[i].piecePrice = angular.copy(item.piecePrice);
                        vm.skuManages[i].vipPrice = angular.copy(item.vipPrice);
                        vm.skuManages[i].vipPiecePrice = angular.copy(item.vipPiecePrice);
                    }
                });
                console.log(vm.skuManages);
            });
        };

        //删除sku
        $scope.skuDelete = function(index){
            vm.delSku.push(vm.skuManages[index]);
            // vm.skuManages.splice(index,1);
            vm.skuManages[index].cancelled = true;
        };

        // 添加sku
        $scope.addSkuManage = function () {
            for(var i = 0;i<vm.skuManages.length;i++){
                var sku = vm.skuManages[i];
                if (sku.propertyConfigCancelled) {
                    continue;
                }
                if(sku.propertyConfigId==vm.delSku[vm.delSku.length-1].propertyConfigId){
                    sku.cancelled = false;
                    sku.type = 'STANDARD';
                    sku.baseOn = 'NUMBER';
                    sku.ladderSetups = [];
                    sku.priceNum = null;
                    sku.vipPrice = null;
                    sku.piecePrice = null;
                    sku.vipPiecePrice = null;
                    vm.delSku.splice(vm.delSku.length-1,1);
                    break
                }
            }
        }

        $scope.cancel =function(){
            $uibModalInstance.dismiss();
        };

        function save () {
            console.log(vm.skuManages);
            // return;
            var ccFlag = true;
            if (vm.skuManages != null && vm.skuManages.length > 0) {
                angular.forEach(vm.skuManages, function (item) {
                    if (!item.propertyConfigId) {
                        MessageService.error("销售商品不能为空！");
                        ccFlag = false;
                        return;
                    }
                    if (!item.type) {
                        MessageService.error("定价策略不能为空");
                        ccFlag = false;
                        return;
                    }
                    if (!item.baseOn) {
                        MessageService.error("基于不能为空");
                        ccFlag = false;
                        return;
                    }
                    // {name:'标准定价',value:'STANDARD'},
                    // {name:'阶梯定价',value:'LADDER'},
                    // {name:'梯度定价',value:'GRADIENT'}
                    if (item.type!='STANDARD'&&!item.ladderSetups.length) {
                        MessageService.error("阶梯设置不能为空");
                        ccFlag = false;
                        return;
                    }
                });
            }else{
                MessageService.error("价格梯度设置不能为空");
                return;
            }

            if(ccFlag){
                $uibModalInstance.close(vm.skuManages);
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PriceListEditController', PriceListEditController);

    PriceListEditController.$inject = ['$http', '$scope','$state','MessageService', 'entity','$uibModal','Channels','Product','Prices','Supplier','ProductCategory','CustomerHub','$q'];

    function PriceListEditController ($http, $scope, $state,MessageService,entity,$uibModal,Channels,Product,Prices,Supplier,ProductCategory,CustomerHub,$q) {
        var vm = this;

        vm.priceTypes =[
            {name:'供应商价目表',value:'supplier'},
            // {name:'客户价目表',value:'customer'},
            {name:'渠道价目表',value:'channel'}
        ];

        vm.price = entity;
        // 获取商品
        vm.allProducts = Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]});
        // 获取渠道
        vm.allChannels = Channels.getAll();
        // 供应商
        vm.allSuppliers = Supplier.getAll();
        // 客户
        vm.allCustomerHubs = CustomerHub.getAll();
        // 一级分类
        vm.productCategoryFirst = ProductCategory.byCondition({items: [{key: 'subordinate', op: '=', value: false}, {key: 'enable', op: '=', value: true}]})
        vm.productCategorySecond = [];
        vm.products = [];

        $scope.search = function(){
            angular.forEach(vm.price.priceLines , function(line){
                line.hide = false;
                if (vm.productCategoryFirstId != null && line.productCategoryFirstId != vm.productCategoryFirstId) {
                    line.hide = true;
                }
                if (vm.productCategorySecondId != null && line.productCategorySecondId != vm.productCategorySecondId) {
                    line.hide = true;
                }
                if (vm.productName != null && line.productName.indexOf(vm.productName) <0) {
                    line.hide = true;
                }
            });
        };

        $scope.cancelSearch = function(){
            vm.productCategoryFirstId = null;
            vm.productCategorySecondId = null;
            vm.productId = null;
            vm.productName = null;
            angular.forEach(vm.price.priceLines , function(line){
                line.hide = false;
            });
        }

        $q.all([vm.price.$promise,vm.allProducts.$promise,vm.allChannels.$promise,vm.allSuppliers.$promise,vm.allCustomerHubs.$promise,vm.productCategoryFirst.$promise]).then(function(){
            vm.products = vm.allProducts.filter(function(item){return item.enable;});
            vm.channels = vm.allChannels.filter(function(item){return item.enable;});
            vm.suppliers = vm.allSuppliers.filter(function(item){return item.enable;});
            vm.customerHubs = vm.allCustomerHubs.filter(function(item){return item.enable;});

            // angular.forEach(vm.productCategoryFirst, function(c){
            //     //获取二级分类
            //     ProductCategory.byCondition({items:
            //         [{key: 'subordinate', op: '=', value: true},
            //         {key: 'enable', op: '=', value: true},{key: 'productCategory.id', op: '=', value: c.id}]
            //     }, function (res) {
            //         c.productCategorySecond = res;
            //         if(res.length>0){
            //             for (var i = vm.price.priceLines.length - 1; i >= 0; i--) {
            //                 var line = vm.price.priceLines[i];
            //                 if (line.productCategoryFirstId == c.id ) {
            //                     line.productCategorySecond = res;
            //                 }
            //             }
            //             angular.forEach(c.productCategorySecond, function(sc){
            //                 //获取商品
            //                 Product.byProductCategoryId({productCategoryId:sc.id},function (data) {
            //                     sc.products = data.filter(function (item) {
            //                         return item.enable;
            //                     });
            //                     for (var i = vm.price.priceLines.length - 1; i >= 0; i--) {
            //                         var line = vm.price.priceLines[i];
            //                         if (line.productCategorySecondId == sc.id ) {
            //                             line.products = data.filter(function (item) {
            //                                 return item.enable;
            //                             });
            //                         }
            //                     }
            //                 });
            //             });
            //         }
            //     });
            // });

        })


        $scope.choosePriceType = function () {
            vm.price.supplierId = null;
            vm.price.customerHubId = null;
            vm.price.channelId = null;
        }

        //新增规则
        var priceLine ={
            addPage:false,
            productCategoryFirstId:null,//一级分类
            // productCategoryFirstName:null,
            productCategorySecondId:null,//二级分类
            // productCategorySecondName:null,
            productId:null,
            // productName:null,
            // priceId:null,
            priceRules:[]
        };

        $scope.priceLineNew = function(){
            var flag = false;
            if(vm.price.priceLines.length >0){
                angular.forEach(vm.price.priceLines,function(item){
                    if(!item.cancelled&&(!item.productCategoryFirstId || !item.productId)){
                        flag = true;
                    }
                });
            }
            if(flag){
                MessageService.error('请将空白项填写完整再添加！！！！');
            }else {
                vm.price.priceLines.push(angular.copy(priceLine));
            }
        }

        // 设置sku
        $scope.defaultSet = function(data){
            console.log(data)
            $uibModal.open({
                templateUrl: 'app/setting/priceList/priceList-sku.html',
                controller: 'PriceListSkuController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'mg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                data.priceRules =result;
            });
        }

        $scope.changeSearchCategoryFirst = function(){
            vm.productCategorySecond = [];
            vm.products = [];
            if (vm.productCategoryFirstId == null) {
                return;
            }
            ProductCategory.byCondition({items:
                [{key: 'subordinate', op: '=', value: true},
                {key: 'enable', op: '=', value: true},
                {key: 'productCategory.id', op: '=', value: vm.productCategoryFirstId}]
            }, function(res){
                 vm.productCategorySecond = res;
            });
        }

        $scope.changeSearchCategorySecond = function(){
            vm.products = [];
            if (vm.productCategorySecondId == null) {
                return;
            }
            Product.byProductCategoryId({productCategoryId:vm.productCategorySecondId},function (data) {
                vm.products = data.filter(function (item) {
                    return item.enable;
                });
            });
        }


        $scope.changeCategoryFirst = function(priceLine){
            priceLine.productCategorySecondId = null;
            priceLine.products = [];
            priceLine.productCategorySecond = null;
            if (priceLine.productCategoryFirstId == null) {
                return;
            }
           ProductCategory.byCondition({items:
                [{key: 'subordinate', op: '=', value: true},
                {key: 'enable', op: '=', value: true},
                {key: 'productCategory.id', op: '=', value: priceLine.productCategoryFirstId}]
            }, function(res){
                 priceLine.productCategorySecond = res;
            });
        }


        $scope.changeCategorySecond = function(priceLine){

            priceLine.productId = null;
            priceLine.products = [];
            if (priceLine.productCategorySecondId == null) {
                return;
            }
            Product.byProductCategoryId({productCategoryId:priceLine.productCategorySecondId},function (data) {
                priceLine.products = data.filter(function (item) {
                    return item.enable;
                });
            });
        }

        $scope.changeProduct = function (priceLine,index) {
           var productLs =  vm.price.priceLines.filter(function(item){
                return item.productId === priceLine.productId && !item.cancelled
            }) || []

            if(productLs.length > 1){
                MessageService.error("该商品已存在，请重新选择");
                vm.price.priceLines[index].productId = ''
                return;
            }

            for(var i = priceLine.priceRules.length-1; i >= 0; i--){
                var rule = priceLine.priceRules[i];
                if(rule.id){
                    rule.cancelled = true;
                }else{
                    priceLine.priceRules.splice(i,1)
                }
            }
            angular.forEach(priceLine.products,function (pro) {
                if(priceLine.productId==pro.id){
                    if(pro.category!="OrderingProduct"){
                        priceLine.pageCount = null;
                        priceLine.addPage = false;
                    }else{
                        priceLine.pageCount = pro.pageCount;
                    }
                    priceLine.category = pro.category;
                    angular.forEach(pro.propertyConfigs,function (p) {
                        if(!p.cancelled){
                            var rule = {
                                propertyConfigId: p.id,
                                propertyConfigNumber: p.number,
                                propertyConfigSku: p.sku,
                                propertyConfig:p,
                                type:'STANDARD',
                                baseOn:'NUMBER',
                                ladderSetups:[],
                                priceNum:null,
                                vipPrice:null,
                                piecePrice:null,
                                vipPiecePrice:null,
                            }
                            priceLine.priceRules.push(rule);
                        }
                    })
                }
            })
        }

        $scope.defaultDelete =function(index){
            // vm.price.priceLines.splice(index,1);
            vm.price.priceLines[index].cancelled = true;
        };

        $scope.save = function () {
            if(!vm.price.name){
                MessageService.error("价目表名称不能为空");
                return;
            }
            if(vm.price.name.length >20){
                MessageService.error("价目表名称不能大于20位");
                return;
            }
            if(!vm.price.priceType){
                MessageService.error("请选择类型");
                return;
            }
            if(vm.price.priceType=='supplier'&&(vm.price.supplierId==null||vm.price.supplierId=='')){
                MessageService.error("请选择所属供应商");
                return;
            }
            if(vm.price.priceType=='customer'&&(vm.price.customerHubId==null||vm.price.customerHubId=='')){
                MessageService.error("请选择所属客户");
                return;
            }
            if(vm.price.priceType=='channel'&&(vm.price.channelId==null||vm.price.channelId=='')){
                MessageService.error("请选择所属渠道");
                return;
            }

            var ccFlag = true;
            if (vm.price.priceLines != null && vm.price.priceLines.length > 0) {
                angular.forEach(vm.price.priceLines, function (item,i) {
                    if(!item.cancelled){
                        if (!item.productCategoryFirstId) {
                            MessageService.error("一级分类不能为空！");
                            ccFlag = false;
                            return;
                        }
                        if (!item.productId) {
                            MessageService.error("请选择第"+(i-0+1)+"行商品");
                            ccFlag = false;
                            return;
                        }
                        if (vm.price.priceRules == null && vm.price.priceLines.length == 0) {
                            MessageService.error("商品SKU不能为空");
                            ccFlag = false;
                            return;
                        }
                    }
                });
            }else{
                MessageService.error("价目规则不能为空");
                return;
            }

            if(!ccFlag){
                return;
            }
            console.log(vm.price);
            // return
            vm.isSaving = true;
            Prices.update(vm.price, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("priceList");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };

        //导出
        $scope.export = function () {
            $http({
                url: 'api/prices/export/' + vm.price.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "价目表" +".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");

            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PriceListCopyController', PriceListCopyController);

    PriceListCopyController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService', 'Channels', 'Supplier', 'CustomerHub','Prices'];

    function PriceListCopyController ($scope, msgdata, $uibModalInstance, MessageService, Channels, Supplier, CustomerHub,Prices) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        init();

        vm.priceTypes = [
            {name: '供应商价目表', value: 'supplier'},
            // {name: '客户价目表', value: 'customer'},
            {name: '渠道价目表', value: 'channel'}
        ];

        $scope.choosePriceType = function () {
            vm.data.supplierId = null;
            vm.data.customerHubId = null;
            vm.data.channelId = null;
        }

        function init() {
            vm.data = angular.copy(msgdata);
            console.log(vm.data)
            vm.data.id = null;
            angular.forEach(vm.data.priceLines,function (item) {
                item.priceId=null;
                item.id=null;
                angular.forEach(item.priceRules,function (rule) {
                    rule.priceLineId=null;
                    rule.id=null;
                })
            })
            //获取渠道
            Channels.getAll(function (res) {
                vm.channels = res.filter(function (item) {
                    return item.enable;
                });
            });

            //供应商
            Supplier.getAll("", function (res) {
                vm.suppliers = res.filter(function (item) {
                    return item.enable;
                });
            });

            //客户
            CustomerHub.getAll("", function (res) {
                vm.customerHubs = res.filter(function (item) {
                    return item.enable;
                });
            });
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            vm.isSaving = true;
            console.log(vm.data)
            // return
            Prices.create(vm.data, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $uibModalInstance.close(vm.data);
            }

            function onSaveError() {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .controller('PriceListAddController', PriceListAddController);

    PriceListAddController.$inject = ['$scope', '$state', 'MessageService', 'Machine', '$uibModal', 'Channels', 'Product', 'Prices', 'Supplier', 'CustomerHub', 'ProductCategory'];

    function PriceListAddController($scope, $state, MessageService, Machine, $uibModal, Channels, Product, Prices, Supplier, CustomerHub, ProductCategory) {
        var vm = this;
        init();

        function init() {
            vm.price = {
                name: '',
                priceType: 'channel',
                supplierId: null,
                customerHubId: null,
                channelId: null,
                priceLines: [],
                enabled: true
            };
            //获取渠道
            Channels.getAll(function (res) {
                vm.channels = res.filter(function (item) {
                    return item.enable;
                });
            });

            //供应商
            Supplier.getAll("", function (res) {
                vm.suppliers = res.filter(function (item) {
                    return item.enable;
                });
            });

            //客户
            CustomerHub.getAll("", function (res) {
                vm.customerHubs = res.filter(function (item) {
                    return item.enable;
                });
            });

            // 一级分类
            ProductCategory.byCondition({
                items: [{key: 'subordinate', op: '=', value: false}, {
                    key: 'enable',
                    op: '=',
                    value: true
                }]
            }, function (res) {
                vm.productCategoryFirst = res;
            });
        }

        vm.priceTypes = [
            {name: '供应商价目表', value: 'supplier'},
            // {name: '客户价目表', value: 'customer'},
            {name: '渠道价目表', value: 'channel'}
        ];

        $scope.choosePriceType = function () {
            vm.price.supplierId = null;
            vm.price.customerHubId = null;
            vm.price.channelId = null;
        }

        //新增规则
        var priceLine = {
            addPage: false,
            productCategoryFirstId: null,//一级分类
            // productCategoryFirstName:null,
            productCategorySecondId: null,//二级分类
            // productCategorySecondName:null,
            productId: null,
            // productName:null,
            // priceId:null,
            priceRules: []
        };

        $scope.priceLineNew = function () {
            var flag = false;
            if(vm.price.priceLines.length >0){
                angular.forEach(vm.price.priceLines,function(item){
                    if(!item.productCategoryFirstId || !item.productId){
                        flag = true;
                    }
                });
            }
            if(flag){
                MessageService.error('请将空白项填写完整再添加！！！！');
            }else {
                vm.price.priceLines.push(angular.copy(priceLine));
            }
        }

        // 设置sku
        $scope.defaultSet = function (data) {
            $uibModal.open({
                templateUrl: 'app/setting/priceList/priceList-sku.html',
                controller: 'PriceListSkuController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'mg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function (result) {
                data.priceRules = result;
            });
        }

        $scope.changeCategoryFirst = function (priceLine, index) {
            priceLine.productCategorySecondId = null;
            priceLine.products = [];

            ProductCategory.byCondition({
                items: [{key: 'subordinate', op: '=', value: true},
                    {key: 'enable', op: '=', value: true},
                    {key: 'productCategory.id', op: '=', value: priceLine.productCategoryFirstId}]
            }, function (res) {
                priceLine.productCategorySecond = res;
                if(!res.length){
                    //获取商品
                    Product.byProductCategoryId({productCategoryId:priceLine.productCategoryFirstId},function (res) {
                        priceLine.products = res.filter(function (item) {
                            return item.enable;
                        });
                    });
                }
            });
        }
        $scope.changeCategorySecond = function (priceLine, data) {
            Product.byProductCategoryId({productCategoryId:priceLine.productCategorySecondId},function (res) {
                priceLine.products = res.filter(function (item) {
                    return item.enable;
                });
            });
        }

        $scope.changeProduct = function (priceLine) {
            priceLine.priceRules = [];
            angular.forEach(priceLine.products,function (pro) {
                if(priceLine.productId==pro.id){
                    angular.forEach(pro.propertyConfigs,function (p) {
                        var rule = {
                            propertyConfigId: p.id,
                            propertyConfig:p,
                            type:'STANDARD',
                            baseOn:'NUMBER',
                            ladderSetups:[],
                            priceNum:null,
                            vipPrice:null,
                            propertyConfigSku:null,
                            piecePrice:null,
                            vipPiecePrice:null,
                        }
                        priceLine.priceRules.push(rule);
                    })
                }
            })
            // priceLine.productId = priceLine.product.id;
        }


        $scope.defaultDelete = function (index) {
            vm.price.priceLines.splice(index, 1);
        };

        $scope.save = function () {
            if(!vm.price.name){
                MessageService.error("价目表名称不能为空");
                return;
            }
            if(vm.price.name.length >20){
                MessageService.error("价目表名称不能大于20位");
                return;
            }
            if(!vm.price.priceType){
                MessageService.error("请选择类型");
                return;
            }
            if(vm.price.priceType=='supplier'&&(vm.price.supplierId==null||vm.price.supplierId=='')){
                MessageService.error("请选择所属供应商");
                return;
            }
            if(vm.price.priceType=='customer'&&(vm.price.customerHubId==null||vm.price.customerHubId=='')){
                MessageService.error("请选择所属客户");
                return;
            }
            if(vm.price.priceType=='channel'&&(vm.price.channelId==null||vm.price.channelId=='')){
                MessageService.error("请选择所属渠道");
                return;
            }
            var ccFlag = true;
            if (vm.price.priceLines != null && vm.price.priceLines.length > 0) {
                angular.forEach(vm.price.priceLines, function (item,i) {
                    if (!item.productCategoryFirstId) {
                        MessageService.error("一级分类不能为空！");
                        ccFlag = false;
                        return;
                    }
                    if (!item.productId) {
                        MessageService.error("请选择第"+(i-0+1)+"行商品");
                        ccFlag = false;
                        return;
                    }
                    if (vm.price.priceRules == null && vm.price.priceLines.length == 0) {
                        MessageService.error("商品SKU不能为空");
                        ccFlag = false;
                        return;
                    }
                });
            }else{
                MessageService.error("价目规则不能为空");
                return;
            }
            if(!ccFlag){
                return;
            }
            console.log(vm.price);
            // return
            vm.isSaving = true;
            Prices.create(vm.price, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("priceList");
            }

            function onSaveError() {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('priceList', {
                parent: 'module',
                url: '/priceList',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRICE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/priceList/priceList.html',
                        controller: 'PriceListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('priceListAdd', {
                parent: 'module',
                url: '/priceListAdd',
                data: {
                    authorities: ['ROLE_PRICE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/priceList/priceList-edit.html',
                        controller: 'PriceListEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            name: '',
                            customerHubId: null,
                            priceLines: [],
                            enabled: true,
                            base: false
                        };
                    }
                }
            })
            .state('priceListEdit', {
                parent: 'module',
                url: '/priceListEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRICE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/priceList/priceList-edit.html',
                        controller: 'PriceListEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Prices', function($stateParams, Prices) {
                        return Prices.detail({id : $stateParams.id});
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Prices', Prices);

    Prices.$inject = ['$resource'];

    function Prices ($resource) {
        var resourceUrl =  'api/prices/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'create': { method:'POST'} ,
            'update': { method:'PUT'},
            'detail': {method:'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PriceListController', PriceListController);

    PriceListController.$inject = ['$scope','Prices','MessageService', 'ParseLinks', '$stateParams', '$uibModal'];

    function PriceListController ($scope, Prices,MessageService, ParseLinks, $stateParams, $uibModal) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            key: ''
        };
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            Prices.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };


        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.key = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.priceDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Prices.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };

        // 复制
        $scope.priceCopy = function (data) {
            $uibModal.open({
                templateUrl: 'app/setting/priceList/priceList-copy.html',
                controller: 'PriceListCopyController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'mg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                init();
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PrePressFlowEditController', PrePressFlowEditController);

    PrePressFlowEditController.$inject = ['$scope','$state','MessageService', 'PrePressFlow', 'entity', '$stateParams'];

    function PrePressFlowEditController ($scope, $state,MessageService,PrePressFlow, entity, $stateParams) {
        var vm = this;
 
        vm.prePressFlow = entity;

        $scope.save = function () {
            if(!vm.prePressFlow.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.prePressFlow.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.prePressFlow.codeName){
                MessageService.error("印前流程名称不能为空");
                return;
            }
  
            vm.isSaving = true;
            if (vm.prePressFlow.id) {
                PrePressFlow.update(vm.prePressFlow, onSaveSuccess, onSaveError);
            }else{
                PrePressFlow.save(vm.prePressFlow, onSaveSuccess, onSaveError);
            }

            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("prePressFlow",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("prePressFlow",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prePressFlow', {
                parent: 'module',
                url: '/prePressFlow',
                params:{page: null},
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/prepressflow/prepressflow.html',
                        controller: 'PrePressFlowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('prePressFlowAdd', {
                parent: 'module',
                url: '/prePressFlowAdd',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/prepressflow/prepressflow-edit.html',
                        controller: 'PrePressFlowEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity:  function(){
                        return {};
                    }
                }
            })
            .state('prePressFlowEdit', {
                parent: 'module',
                url: '/prePressFlowEdit/{id}',
                params:{page: null},
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/prepressflow/prepressflow-edit.html',
                        controller: 'PrePressFlowEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PrePressFlow', function($stateParams, PrePressFlow) {
                        return PrePressFlow.get({id : $stateParams.id});
                    }],
                }
            })

        ;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('PrePressFlow', PrePressFlow);

    PrePressFlow.$inject = ['$resource'];

    function PrePressFlow ($resource) {
        var resourceUrl =  'api/pre-press-flows/:path/:id';

        return $resource(resourceUrl, {}, {
            'page': { 
                method: 'GET', 
                isArray: true,
                params: {
                    path: 'page'
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'delete':{
                method:'DELETE',
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PrePressFlowController', PrePressFlowController);

    PrePressFlowController.$inject = ['$scope', 'Principal', 'LoginService', '$state','PrePressFlow','MessageService', 'ParseLinks', '$stateParams'];

    function PrePressFlowController ($scope, Principal, LoginService, $state, PrePressFlow, MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            PrePressFlow.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                PrePressFlow.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .controller('PaymentSettingsDialogController', PaymentSettingsDialogController);

    PaymentSettingsDialogController.$inject = ['$timeout', '$scope', '$state', 'entity', 'PaymentSettings', 'MessageService'];

    function PaymentSettingsDialogController($timeout, $scope, $state, entity, PaymentSettings, MessageService) {
        var vm = this;

        vm.paymentSettings = entity;
        vm.clear = clear;
        vm.save = save;

        if(vm.paymentSettings==null){
            vm.paymentSettings={
                'weChatKey': null,
                'weChatAppid': null,
                'weChatMchid': null,
                'weChatNotifyUrl': null,
                'weChatCertificatePath': null,
                'id': null
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('payment-settings', null, { reload: 'payment-settings' });
        }

        function save() {
            vm.isSaving = true;
            PaymentSettings.update(vm.paymentSettings, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(res) {
            if(res.id){
                $state.go('payment-settings', null, { reload: 'payment-settings' });
            }else {
                MessageService.error(res.message);
            }
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PaymentSettingsDetailController', PaymentSettingsDetailController);

    PaymentSettingsDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function PaymentSettingsDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.paymentSettings = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gwApp:paymentSettingsUpdate', function(event, result) {
            vm.paymentSettings = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('payment-settings', {
                parent: 'module',
                url: '/payment-settings',
                data: {
                    authorities: [],
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/payment-settings/payment-settings-detail.html',
                        controller: 'PaymentSettingsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['PaymentSettings', function(PaymentSettings) {
                        return PaymentSettings.getOne().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'payment-settings',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('payment-settings.new', {
                parent: 'module',
                url: '/payment-settings/new',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/payment-settings/payment-settings-dialog.html',
                        controller: 'PaymentSettingsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['PaymentSettings', function(PaymentSettings) {
                        return {
                            weChatKey: null,
                            weChatAppid: null,
                            weChatMchid: null,
                            weChatNotifyUrl: null,
                            weChatCertificatePath: null,
                            id: null
                        };
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'payment-settings',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('payment-settings.edit', {
                parent: 'module',
                url: '/payment-settings/{id}/edit',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/payment-settings/payment-settings-dialog.html',
                        controller: 'PaymentSettingsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['PaymentSettings', function(PaymentSettings) {
                        return PaymentSettings.getOne().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'payment-settings',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('PaymentSettings', PaymentSettings);

    PaymentSettings.$inject = ['$resource'];

    function PaymentSettings($resource) {
        var resourceUrl = 'api/payment-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET' },
            'getOne': {
                method: 'GET',
                params:{
                    path:"getOne"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MerchantEditController', MerchantEditController);

    MerchantEditController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Merchant', 'entity', '$stateParams',
     'Channels', 'CustomerHub', 'LocationProvice', 'LocationCity', 'LocationDistrict', '$q' ];

    function MerchantEditController ($scope, Principal, LoginService, $state,User,MessageService,Merchant, entity, $stateParams,
     Channels, CustomerHub, LocationProvice, LocationCity, LocationDistrict, $q) {
        var vm = this;
        vm.merchant = entity;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        Channels.getAll({}, function(res) {
            vm.channelList = res;
        });

        CustomerHub.getAll({}, function(res) {
            vm.customerHubList = res;
        });

        $q.all([vm.merchant.$promise]).then(function(){
            loadData();
        })

        
        
        function loadData() {
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                if(vm.merchant.province) {
                    for (var i = vm.provinces.length - 1; i >= 0; i--) {
                        var p = vm.provinces[i];
                        if (p.name == vm.merchant.province) {
                            vm.province = p;
                            break;
                        }
                    }
                    if (vm.merchant.city != '') {
                        vm.districts = [];
                        LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                            vm.citys = data;
                            for (var i = vm.citys.length - 1; i >= 0; i--) {
                                var c = vm.citys[i];
                                if (c.name == vm.merchant.city) {
                                    vm.city = c;
                                    break;
                                }
                            }
                            if (vm.city != null) {
                                LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                                    vm.districts = data;
                                    for (var i = vm.districts.length - 1; i >= 0; i--) {
                                        var di = vm.districts[i];
                                        if (di.name == vm.merchant.district) {
                                            vm.district = di;
                                        }
                                    }
                                });
                            }
                        });
                    }
                }
            });

        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }
        $scope.save = function () {
            if (vm.merchant.shipment) {
                if (vm.province == null || vm.province == "") {
                    MessageService.error("请选择省份");
                    return false;
                };
                vm.merchant.province = vm.province.name;

                if (vm.city == null || vm.city == '') {
                    MessageService.error('请选择城市');
                    return false;
                }
                vm.merchant.city = vm.city.name;

                if (vm.district == null || vm.district == "") {
                    MessageService.error("请选择区县");
                    return false;
                };
                vm.merchant.district = vm.district.name;

                if (vm.merchant.address == null || vm.merchant.address == "") {
                    MessageService.error("请输入详细地址");
                    return false;
                };

                if (vm.merchant.address.length >50) {
                    MessageService.error("详细地址不能大于50位");
                    return false;
                };

                if (vm.merchant.contact == null || vm.merchant.contact == "") {
                    MessageService.error("请输入联系人姓名");
                    return false;
                };
                if (vm.merchant.contact.length >20) {
                    MessageService.error("联系人姓名不能超过20位");
                    return false;
                };
                if (vm.merchant.phone == null || vm.merchant.phone == "") {
                    MessageService.error("请输入联系方式");
                    return false;
                };

            }
            if(!vm.merchant.name){
                MessageService.error("商户名不能为空");
                return;
            }
            if(vm.merchant.name.length >20){
                MessageService.error("商户名不能超过20位");
                return;
            }
            if(!vm.merchant.number){
                MessageService.error("商户号不能为空");
                return;
            }
            if(vm.merchant.number.length >20){
                MessageService.error("商户号不能超过20位");
                return;
            }
            if(!vm.merchant.sortingTips){
                MessageService.error("分拣提示不能为空");
                return;
            }
            if(vm.merchant.sortingTips.length >20){
                MessageService.error("分拣提示不能超过20位");
                return;
            }
            if (!vm.merchant.channelId && !vm.merchant.customerHubId) {
                MessageService.error("请选择所属对象，至少选一个");
                return;
            }
            vm.isSaving = true; 
            Merchant.update(vm.merchant, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("merchant",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("merchant",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MerchantAddController', MerchantAddController);

    MerchantAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Merchant', 'Channels', 'CustomerHub',
     'LocationProvice', 'LocationCity', 'LocationDistrict'];

    function MerchantAddController ($scope, Principal, LoginService, $state,User,MessageService,Merchant, Channels, CustomerHub,
     LocationProvice, LocationCity, LocationDistrict) {
        var vm = this;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        vm.channelList = Channels.getAll();

        vm.customerHubList = CustomerHub.getAll();

        init();
        function init(){
            vm.merchant = {
                name: '',
                number: '',
                sortingTips: '',
                enable: true,
                channel: {
                    id: '',
                    name: ''
                },
                customerHub: {
                    id: '',
                    name: ''
                },
            };
        }

       loadData();
        
        function loadData() {
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
            });

        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

        $scope.save = function () {

             if (vm.merchant.shipment) {
                if (vm.province == null || vm.province == "") {
                    MessageService.error("请选择省份");
                    return false;
                };
                vm.merchant.province = vm.province.name;

                if (vm.city == null || vm.city == '') {
                    MessageService.error('请选择城市');
                    return false;
                }
                vm.merchant.city = vm.city.name;

                if (vm.district == null || vm.district == "") {
                    MessageService.error("请选择区县");
                    return false;
                };
                vm.merchant.district = vm.district.name;

                if (vm.merchant.address == null || vm.merchant.address == "") {
                    MessageService.error("请输入详细地址");
                    return false;
                };

                if (vm.merchant.address.length >50) {
                    MessageService.error("详细地址不能大于50位");
                    return false;
                };

                if (vm.merchant.contact == null || vm.merchant.contact == "") {
                    MessageService.error("请输入联系人姓名");
                    return false;
                };
                if (vm.merchant.contact.length >20) {
                    MessageService.error("联系人姓名不能超过20位");
                    return false;
                };
                if (vm.merchant.phone == null || vm.merchant.phone == "") {
                    MessageService.error("请输入联系方式");
                    return false;
                };

            }

            if(!vm.merchant.name){
                MessageService.error("商户名不能为空");
                return;
            }
            if(vm.merchant.name.length >20){
                MessageService.error("商户名不能超过20位");
                return;
            }
            if(!vm.merchant.number){
                MessageService.error("商户号不能为空");
                return;
            }
            if(vm.merchant.number.length >20){
                MessageService.error("商户号不能超过20位");
                return;
            }
            if(!vm.merchant.sortingTips){
                MessageService.error("分拣提示不能为空");
                return;
            }
            if(vm.merchant.sortingTips.length >20){
                MessageService.error("分拣提示不能超过20位");
                return;
            }
            if (!vm.merchant.channelId && !vm.merchant.customerHubId) {
                MessageService.error("请选择所属对象，至少选一个");
                return;
            }
            vm.isSaving = true;
            Merchant.add(vm.merchant, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("merchant");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('merchant', {
            parent: 'module',
            url: '/merchant',
            params:{page: null},
            data: {
                authorities: ['ROLE_SET_SUP']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/merchant/merchant.html',
                    controller: 'MerchantController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
            .state('merchantAdd', {
                parent: 'module',
                url: '/merchantAdd',
                data: {
                    authorities: ['ROLE_SET_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/merchant/merchant-add.html',
                        controller: 'MerchantAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('merchantEdit', {
                parent: 'module',
                url: '/merchantEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SET_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/merchant/merchant-edit.html',
                        controller: 'MerchantEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Merchant', function($stateParams, Merchant) {
                        return Merchant.detail({id : $stateParams.id});
                    }],
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Merchant', Merchant);

    Merchant.$inject = ['$resource'];

    function Merchant ($resource) {
        var resourceUrl =  'api/merchants/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'getAll': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            },
            'getListByChannel': {
                method: 'GET',
                params: {
                    path: 'getListByChannel'
                },
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MerchantController', MerchantController);

    MerchantController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Merchant','MessageService', 'ParseLinks', '$localStorage', '$location', '$stateParams'];

    function MerchantController ($scope, Principal, LoginService, $state,Merchant,MessageService, ParseLinks, $localStorage, $location, $stateParams) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            Merchant.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Merchant.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };

        //批量上传
        window.upladFile = function($event) {
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'xlsx' && ext != 'xls' && ext != 'csv'){
                angular.element("#file").val("");
                MessageService.error("只能上传.xlsx  .xls类型的文件!");
                return;
            }
            var url =  $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/merchants/importData"; // 接收上传文件的后台地址

            var formData = new FormData();
            formData.append('file', fileObj);
            $.ajax({
                cache: true,
                type: "POST",
                url: url,
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                headers: {
                    Authorization: "Bearer " + vm.token
                },
                accept: 'file',
                success: function (data) {
                    angular.element("#file").val("");
                    MessageService.success("批量上传成功");
                    init();
                },
                error: function (error) {
                    angular.element("#file").val("");
                    MessageService.error("文件导入失败，请稍后重试！");
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MaterialsEditController', MaterialsEditController);

    MaterialsEditController.$inject = ['$scope','$state','MessageService', 'MaterialTemplates', 'Items', 'entity', '$stateParams', 'ProductCategory','$timeout'];

    function MaterialsEditController ($scope,$state,MessageService,MaterialTemplates, Items, entity, $stateParams, ProductCategory,$timeout) {
        var vm = this;
        vm.data = entity;
        vm.itemsList = Items.getAll();

        // accessories 辅料 / product 成品
        vm.typeList = [
            {name:'商品类', value: 'product'},
            {name:'辅材类', value: 'accessories'}
        ];

        //商品品类
        $timeout(function () {
            //商品品类
            ProductCategory.getAll({type: vm.data.type}, function (res) {
                vm.productCategoryList = res;
                vm.superiorName = null;
                for(var i=0; i<vm.productCategoryList.length; i++){
                    if(vm.productCategoryList[i].id == vm.data.productCategoryId && vm.productCategoryList[i].superiorId != "") {
                        vm.superiorName = vm.productCategoryList[i].superiorName;
                    }
                }
            });
            vm.superiorName = null;
        },100);

        $scope.typeSelect = function(value){
            if(!value){
                vm.productCategoryList = [];
            }else {
                vm.productCategoryList = ProductCategory.getAll({type: value, subordinate: "0"});
            }
        };

        //商品品类选择
        $scope.productCategorySelect = function(){
            vm.superiorName = null;
            for(var i=0; i<vm.productCategoryList.length; i++){
                if(vm.productCategoryList[i].id == vm.data.productCategoryId){
                    vm.data.productCategoryName = vm.productCategoryList[i].name;
                    if(vm.productCategoryList[i].superiorId){
                        vm.superiorName = vm.productCategoryList[i].superiorName;
                    }
                }
            }
        }

        //属性删除
        $scope.propertyDelete = function(index){
            vm.data.items.splice(index,1);
        };
        //属性新增
        $scope.propertyAdd = function(){
            vm.data.items.push({id: null});
        };
        $scope.itemSelect = function(data, index){
            for(var i=0; i<vm.itemsList.length; i++){
                if(data.id == vm.itemsList[i].id){
                    vm.data.items[index] = vm.itemsList[i];
                }
            }
        }

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.data.type){
                MessageService.error("类型不能为空");
                return;
            }
            if(!vm.data.productCategoryId){
                MessageService.error("商品品类不能为空");
                return;
            }
            if(vm.data.description.length >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            for(var i=0; i<vm.data.items.length; i++){
                if(!vm.data.items[i].id){
                    MessageService.error("属性不能为空");
                    return;
                }
            }
            vm.isSaving = true;
            MaterialTemplates.update(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("编辑成功");
                $state.go("materials",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("编辑失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("materials",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MaterialsAddController', MaterialsAddController);

    MaterialsAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'MaterialTemplates', 'Items', 'ProductCategory'];

    function MaterialsAddController ($scope, Principal, LoginService, $state,User,MessageService,MaterialTemplates, Items, ProductCategory) {
        var vm = this;
        vm.data = {
            name: '',
            type: '',
            enable: true,
            description: '',
            productCategoryId: '',
            productCategoryName: '',
            items: []
        };
        vm.propertyList = [];
        vm.itemsList = Items.getAll();

        // accessories 辅料 / product 成品
        vm.typeList = [
            {name:'商品类', value: 'product'},
            {name:'辅材类', value: 'accessories'}
        ];

        //商品分类一级
        vm.superiorName = null;
        //商品品类
        vm.productCategoryList = [];

        $scope.typeSelect = function(value){
            if(!value){
                vm.productCategoryList = [];
            }else {
                vm.productCategoryList = ProductCategory.getAll({type: value, subordinate: "0"});
            }
        };

        //商品品类选择
        $scope.productCategorySelect = function(){
            vm.superiorName = null;
            for(var i=0; i<vm.productCategoryList.length; i++){
                if(vm.productCategoryList[i].id == vm.data.productCategoryId){
                    vm.data.productCategoryName = vm.productCategoryList[i].name;
                    if(vm.productCategoryList[i].superiorId){
                        vm.superiorName = vm.productCategoryList[i].superiorName;
                    }
                }
            }
        }

        //属性删除
        $scope.propertyDelete = function(index){
            vm.propertyList.splice(index,1);
        };
        //属性新增
        $scope.propertyAdd = function(){
            vm.propertyList.push({
                property: ""
            });
        };

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.data.type){
                MessageService.error("类型不能为空");
                return;
            }
            if(!vm.data.productCategoryId){
                MessageService.error("商品品类不能为空");
                return;
            }
            if(vm.data.description.length >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            for(var i=0; i<vm.propertyList.length; i++){
                if(vm.propertyList[i].property == ""){
                    MessageService.error("属性不能为空");
                    return;
                }
                var _property = vm.itemsList.find(function(itm){
                    return itm.id == vm.propertyList[i].property
                })
                vm.data.items.push(_property)
            }

            vm.isSaving = true;
            MaterialTemplates.add(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("materials");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('materials', {
            parent: 'module',
            url: '/materials',
            params:{page: null},
            data: {
                authorities: ['ROLE_MATERIALTEMPLATE']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/materials/materials.html',
                    controller: 'MaterialsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('materialsAdd', {
            parent: 'module',
            url: '/materialsAdd',
            data: {
                authorities: ['ROLE_MATERIALTEMPLATE']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/materials/materials-add.html',
                    controller: 'MaterialsAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('materialsEdit', {
            parent: 'module',
            url: '/materialsEdit/{id}',
            params:{page: null},
            data: {
                authorities: ['ROLE_MATERIALTEMPLATE']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/materials/materials-edit.html',
                    controller: 'MaterialsEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MaterialTemplates', function ($stateParams, MaterialTemplates) {
                    return MaterialTemplates.detail({id: $stateParams.id});
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('MaterialTemplates', MaterialTemplates);

    MaterialTemplates.$inject = ['$resource'];

    function MaterialTemplates ($resource) {
        var resourceUrl =  'api/material-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                    params: {
                        id: 'getPage'
                    },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    id: 'getAll'
                }
            } ,
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MaterialsController', MaterialsController);

    MaterialsController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Makeup','MessageService', 'ParseLinks', 'MaterialTemplates', '$stateParams'];

    function MaterialsController ($scope, Principal, LoginService, $state,Makeup,MessageService, ParseLinks, MaterialTemplates, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeList = [
            {name: '全部', value: ''},
            {name: '原材料', value: '原材料'},
            {name: '纸张', value: '纸张'},
            {name: '包材', value: '包材'}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            keyword: '',
            sort: 'lastModifiedDate,DESC',
            type: ''
        };

        init()
        function init() {
            vm.tableList = [];
            MaterialTemplates.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                MaterialTemplates.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MakeupEditController', MakeupEditController);

    MakeupEditController.$inject = ['$scope','$state','MessageService', 'Makeup', 'entity', '$stateParams'];

    function MakeupEditController ($scope, $state,MessageService,Makeup, entity, $stateParams) {
        var vm = this;
        //vm.ffcFileList = [
        //    {name:'13拼', value:'13拼'},
        //    {name:'6拼', value: '6拼'}
        //];
        vm.makeup = entity;

        $scope.save = function () {
            if(!vm.makeup.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.makeup.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.makeup.channel){
                MessageService.error("拼版通道名称不能为空");
                return;
            }
            if(vm.makeup.channel.length >20){
                MessageService.error("拼版通道名称不能大于20位");
                return;
            }
            // if(!vm.makeup.collectionNum){
            //     MessageService.error("收集数量不能为空");
            //     return;
            // }
            if(!vm.makeup.description){
                MessageService.error("描述不能为空");
                return;
            }
            if(vm.makeup.description.length >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            vm.isSaving = true;
            Makeup.update(vm.makeup, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("makeup",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("makeup",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MakeupAddController', MakeupAddController);

    MakeupAddController.$inject = ['$scope','$state','MessageService', 'Makeup'];

    function MakeupAddController ($scope, $state,MessageService,Makeup) {
        var vm = this;
        //vm.ffcFileList = [
        //    {name:'13拼', value:'13拼'},
        //    {name:'6拼', value: '6拼'}
        //];
        init();
        function init(){
            vm.makeup = {
                name: '',
                channel: '',
                collectionNum: '',
                enable: true,
                description: ''
            };
        }

        $scope.save = function () {
            if(!vm.makeup.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.makeup.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(!vm.makeup.channel){
                MessageService.error("拼版通道名称不能为空");
                return;
            }
            if(vm.makeup.channel.length >20){
                MessageService.error("拼版通道名称不能大于20位");
                return;
            }
            // if(!vm.makeup.collectionNum){
            //     MessageService.error("收集数量不能为空");
            //     return;
            // }
            if(!vm.makeup.description){
                MessageService.error("描述不能为空");
                return;
            }
            if(vm.makeup.description.length > 50){
                MessageService.error("描述不能大于50位");
                return;
            }
            vm.isSaving = true;
            Makeup.add(vm.makeup, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("makeup");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('makeup', {
                parent: 'module',
                url: '/makeup',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SET_MAKEUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/makeup/makeup.html',
                        controller: 'MakeupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('makeupAdd', {
                parent: 'module',
                url: '/makeupAdd',
                data: {
                    authorities: ['ROLE_SET_MAKEUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/makeup/makeup-add.html',
                        controller: 'MakeupAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('makeupEdit', {
                parent: 'module',
                url: '/makeupEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SET_MAKEUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/makeup/makeup-edit.html',
                        controller: 'MakeupEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Makeup', function($stateParams, Makeup) {
                        return Makeup.detail({id : $stateParams.id});
                    }],
                }
            })

        ;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Makeup', Makeup);

    Makeup.$inject = ['$resource'];

    function Makeup ($resource) {
        var resourceUrl =  'api/makeups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                params: {
                    id: 'pages'
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MakeupController', MakeupController);

    MakeupController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Makeup','MessageService', 'ParseLinks', '$stateParams'];

    function MakeupController ($scope, Principal, LoginService, $state,Makeup,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            Makeup.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Makeup.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SetPinController', SetPinController);

    SetPinController.$inject = ['$scope','$uibModalInstance','MessageService', 'msgdata','Makeups'];

    function SetPinController ($scope,$uibModalInstance,MessageService,msgdata,Makeups) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        loadAll();
        vm.items=[];

        function loadAll(){
            Makeups.getAllMakeups({},function(data){
                vm.items = data.filter(function(item){
                    return item.enable == true;
                });
                repeat(vm.items,msgdata);
            },function(error){
            });
        };

        //获取选中状态
        function repeat(items,list){
            if(list == null || list.length == 0){
                angular.forEach(items,function(item){
                    item.selected = false;
                })
            }else {
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].name;
                    for (var j = 0; j < list.length; j++) {
                        if (item == list[j].name) {
                            items[i].selected = true;
                        }
                    }
                }
            }
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.chooseItem = function(item){
            item.selected = !item.selected;
        };

        function save () {
            vm.selectedItems = vm.items.filter(function(item){
                return item.selected;
            });
            $uibModalInstance.close(vm.selectedItems);
        }




    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MachineEditController', MachineEditController);

    MachineEditController.$inject = ['$scope', '$state','MessageService', 'Machine', 'entity', '$stateParams','Supplier','$uibModal'];

    function MachineEditController ($scope,$state,MessageService,Machine, entity, $stateParams,Supplier,$uibModal) {
        var vm = this;
        vm.machine = entity;

        Supplier.getAll({},function(res){
            vm.suppliers =res.filter(function(item){
                return item.enable;
            });
        });

        $scope.setImposition = function(){
            $uibModal.open({
                templateUrl: 'app/setting/machineTypes/set-pin.html',
                controller: 'SetPinController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return vm.machine.makeups;
                    }
                }
            }).result.then(function(result){
                if(!result){
                    vm.machine.makeups = [];
                }else{
                    vm.machine.makeups = result;
                }
            });
        };

        $scope.save = function () {
            if(!vm.machine.type){
                MessageService.error("机型名称不能为空");
                return;
            }
            if(vm.machine.type.length >20){
                MessageService.error("机型名称不能大于20位");
                return;
            }
            if(!vm.machine.supplierId){
                MessageService.error("供应商不能为空");
                return;
            }
            if(vm.machine.makeups.length == 0){
                MessageService.error("拼版方式不能为空");
                return;
            }
            if(!vm.machine.capacity){
                MessageService.error("产能不能为空");
                return;
            }
            vm.isSaving = true;
            Machine.update(vm.machine, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("machine",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("machine",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MachineAddController', MachineAddController);

    MachineAddController.$inject = ['$scope','$state','MessageService', 'Machine','Supplier','$uibModal'];

    function MachineAddController ($scope, $state,MessageService,Machine,Supplier,$uibModal) {
        var vm = this;
        init();
        function init(){
            vm.machine = {
                type: '',
                supplierId:'',
                makeups:[],
                capacity:'',
                enable: true
            };

            Supplier.getAll({},function(res){
                vm.suppliers =res.filter(function(item){
                    return item.enable;
                });
            });
        }

        $scope.setImposition = function(){
            $uibModal.open({
                templateUrl: 'app/setting/machineTypes/set-pin.html',
                controller: 'SetPinController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return vm.machine.makeups;
                    }
                }
            }).result.then(function(result){
                if(!result){
                    vm.machine.makeups = [];
                }else{
                    vm.machine.makeups = result;
                }
            });
        };

        $scope.save = function () {
            if(!vm.machine.type){
                MessageService.error("机型名称不能为空");
                return;
            }
            if(vm.machine.type.length >20){
                MessageService.error("机型名称不能大于20位");
                return;
            }
            if(!vm.machine.supplierId){
                MessageService.error("供应商不能为空");
                return;
            }
            if(vm.machine.makeups.length == 0){
                MessageService.error("拼版方式不能为空");
                return;
            }
            if(!vm.machine.capacity){
                MessageService.error("产能不能为空");
                return;
            }
            vm.isSaving = true;
            Machine.create(vm.machine, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("machine");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('machine', {
                parent: 'module',
                url: '/machine',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MACHINE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/machineTypes/machine.html',
                        controller: 'MachineController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('machineAdd', {
                parent: 'module',
                url: '/machineAdd',
                data: {
                    authorities: ['ROLE_MACHINE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/machineTypes/machine-add.html',
                        controller: 'MachineAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('machineEdit', {
                parent: 'module',
                url: '/machineEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MACHINE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/machineTypes/machine-edit.html',
                        controller: 'MachineEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Machine', function($stateParams, Machine) {
                        return Machine.detail({id : $stateParams.id});
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Machine', Machine)
        .factory('SupplierAbutSetting', SupplierAbutSetting);

    Machine.$inject = ['$resource'];
    SupplierAbutSetting.$inject = ['$resource'];

    function Machine ($resource) {
        var resourceUrl =  'api/devices/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'create': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET'}
        });
    }
    function SupplierAbutSetting ($resource) {
        var resourceUrl =  'api/supplier-abut-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            } ,
            'delete':{method:'DELETE'},
            'create': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MachineController', MachineController);

    MachineController.$inject = ['$scope','Machine','MessageService', 'ParseLinks', '$stateParams'];

    function MachineController ($scope, Machine,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            Machine.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.machineDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Machine.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ItemEditController', ItemEditController);

    ItemEditController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Items','entity', '$stateParams'];

    function ItemEditController ($scope, Principal, LoginService, $state,User,MessageService,Items,entity, $stateParams) {
        var vm = this;
        vm.data = entity;
        //vm.typeList = [
        //    {name: '原材料', value: '原材料'},
        //    {name: '纸张', value: '纸张'},
        //    {name: '包材', value: '包材'}
        //];

        //删除属性值
        $scope.itemDelete = function(index){
            vm.data.itemValues.splice(index,1);
        };
        //新增属性值
        $scope.itemAdd = function(){
            var arr =vm.data.itemValues.filter(function(item){
                return item.name=='';
            });
            if(arr.length>0){
                MessageService.error("已存在空属性，请添加！");
            }else{
                vm.data.itemValues.push({name: ''});
            }
        };
        //类型
        // $scope.typeSelect = function(){
        //     vm.data.type = vm.type.name;
        // }

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            //if(!vm.data.type){
            //    MessageService.error("类型不能为空");
            //    return;
            //}
            //if(!vm.data.description){
            //    MessageService.error("描述不能为空");
            //    return;
            //}
            var arr =vm.data.itemValues.filter(function(item){
                return item.name=='';
            });
            if(arr.length>0){
                MessageService.error("存在空属性，请修改！");
                return;
            }
            if(vm.data.description >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            vm.isSaving = true;
            Items.update(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("编辑成功");
                $state.go("item",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("编辑失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("item",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ItemAddController', ItemAddController);

    ItemAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Items'];

    function ItemAddController ($scope, Principal, LoginService, $state,User,MessageService,Items) {
        var vm = this;
        vm.data = {
            name: '',
            //type: '',
            enable: true,
            description: '',
            itemValues: [
                {name: ''}
            ]
        };
        //vm.typeList = [
        //    {name: '原材料', value: '原材料'},
        //    {name: '纸张', value: '纸张'},
        //    {name: '包材', value: '包材'}
        //];

        //删除属性值
        $scope.itemDelete = function(index){
            vm.data.itemValues.splice(index,1);
        };
        //新增属性值
        $scope.itemAdd = function(){
            var arr =vm.data.itemValues.filter(function(item){
                return item.name=='';
            });
            if(arr.length>0){
                MessageService.error("已存在空属性，请添加！");
            }else{
                vm.data.itemValues.push({name: ''});
            }
        };

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            //if(!vm.data.type){
            //    MessageService.error("类型不能为空");
            //    return;
            //}
            //if(!vm.data.description){
            //    MessageService.error("描述不能为空");
            //    return;
            //}
            if(vm.data.description >50){
                MessageService.error("描述不能大于50位");
                return;
            }

            var arr =vm.data.itemValues.filter(function(item){
                return item.name=='';
            });
            if(arr.length>0){
                MessageService.error("存在空属性，请修改！");
                return;
            }
            vm.isSaving = true;
            Items.add(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("item");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('item', {
            parent: 'module',
            url: '/item',
            params:{page: null},
            data: {
                authorities: ['ROLE_ITEM']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/item/item.html',
                    controller: 'ItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('itemAdd', {
            parent: 'module',
            url: '/itemAdd',
            data: {
                authorities: ['ROLE_ITEM']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/item/item-add.html',
                    controller: 'ItemAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('itemEdit', {
            parent: 'module',
            url: '/itemEdit/{id}',
            params:{page: null},
            data: {
                authorities: ['ROLE_ITEM']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/item/item-edit.html',
                    controller: 'ItemEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Items', function ($stateParams, Items) {
                    return Items.detail({id: $stateParams.id});
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Items', Items);

    Items.$inject = ['$resource'];

    function Items ($resource) {
        var resourceUrl =  'api/items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                    params: {
                        id: 'getPage'
                    },
            },
            'getAll': { method: 'GET', isArray: true,
                    params: {
                        id: 'getAll'
                    },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ItemController', ItemController);

    ItemController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Items','MessageService', 'ParseLinks', '$stateParams'];

    function ItemController ($scope, Principal, LoginService, $state,Items,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            Items.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Items.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InterfaceEditController', InterfaceEditController);

    InterfaceEditController.$inject = ['$scope','$state','MessageService', 'ApiSetting', 'entity', 'Channels'];

    function InterfaceEditController ($scope, $state,MessageService,ApiSetting, entity, Channels) {
        var vm = this;
        vm.interface = entity;

        Channels.getAll({}, function(res) {
            vm.channelList = res;
            // for (var i = 0; i < res.length; i ++) {
            //     if (vm.interface.channel != null && res[i].id == vm.interface.channel.id){
            //         vm.channel = res[i];
            //     }
            // }
        });

        $scope.validate = function () {
            if(vm.interface.name =='' || vm.interface.name == null){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.interface.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(vm.interface.description =='' || vm.interface.description == null){
                MessageService.error("描述不能为空");
                return;
            }
            if(vm.interface.description.length >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            if(vm.interface.deliveryChangeApi =='' || vm.interface.deliveryChangeApi == null){
                MessageService.error("发货变更接口不能为空");
                return;
            }
            if(vm.interface.logisticsInformApi =='' || vm.interface.logisticsInformApi == null){
                MessageService.error("物流通知接口不能为空");
                return;
            }
            if(vm.interface.orderTracesApi =='' || vm.interface.orderTracesApi == null){
                MessageService.error("物流轨迹更新接口不能为空");
                return;
            }
            if (vm.interface.oneOrderApi == '' || vm.interface.oneOrderApi == null) {
                MessageService.error("项目获取订单接口不能为空");
                return;
            }
            return true;
        };

        $scope.save = function () {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            ApiSetting.update(vm.interface, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("interface");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InterfaceAddController', InterfaceAddController);

    InterfaceAddController.$inject = ['$scope','$state','MessageService', 'ApiSetting', 'Channels'];

    function InterfaceAddController ($scope, $state,MessageService,ApiSetting, Channels) {
        var vm = this;
        vm.channelList = Channels.getAll();
        init();

        $scope.validate = function () {
            if(vm.interface.name =='' || vm.interface.name == null){
                MessageService.error("名称不能为空");
                return;
            }
            if(vm.interface.name.length >20){
                MessageService.error("名称不能大于20位");
                return;
            }
            if(vm.interface.description =='' || vm.interface.description == null){
                MessageService.error("描述不能为空");
                return;
            }
            if(vm.interface.description.length >50){
                MessageService.error("描述不能大于50位");
                return;
            }
            if(vm.interface.deliveryChangeApi =='' || vm.interface.deliveryChangeApi == null){
                MessageService.error("发货变更接口不能为空");
                return;
            }
            if(vm.interface.logisticsInformApi =='' || vm.interface.logisticsInformApi == null){
                MessageService.error("物流通知接口不能为空");
                return;
            }
            if(vm.interface.orderTracesApi =='' || vm.interface.orderTracesApi == null){
                MessageService.error("物流轨迹更新接口不能为空");
                return;
            }
            if (vm.interface.oneOrderApi == '' || vm.interface.oneOrderApi == null) {
                MessageService.error("项目获取订单接口不能为空");
                return;
            }
            return true;
        };


        function init(){
            vm.interface = {
                name: '',
                description: '',
                enabled: true,
                deliveryChangeApi: '',
                oneOrderApi: '',
                channelId:  '',
                channelName:''
            }
        };

        // $scope.channelSelect = function () {
        //     vm.interface.channel.id = vm.channel.id;
        //     vm.interface.channel.name = vm.channel.name;
        // }

        $scope.save = function () {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            ApiSetting.add(vm.interface, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("interface");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('interface', {
            parent: 'module',
            url: '/interface',
            data: {
                authorities: ['ROLE_SET_INTER']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/interface/interface.html',
                    controller: 'InterfaceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('interfaceAdd', {
            parent: 'module',
            url: '/interfaceAdd',
            data: {
                authorities: ['ROLE_SET_INTER']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/interface/interface-add.html',
                    controller: 'InterfaceAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('interfaceEdit', {
            parent: 'module',
            url: '/interfaceEdit/{id}',
            data: {
                authorities: ['ROLE_SET_INTER']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/interface/interface-edit.html',
                    controller: 'InterfaceEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApiSetting', function($stateParams, ApiSetting) {
                    return ApiSetting.detail({id : $stateParams.id});
                }]
            }
        })
        ;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('ApiSetting', ApiSetting);

    ApiSetting.$inject = ['$resource'];

    function ApiSetting ($resource) {
        var resourceUrl =  'api/api-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
                },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{method:'DELETE'},
            'add': { method:'POST'} ,
            'update': { method:'PUT'},
            'detail': {method:'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InterfaceController', InterfaceController);

    InterfaceController.$inject = ['$scope', 'Principal', 'LoginService', '$state','ApiSetting','MessageService', 'ParseLinks'];

    function InterfaceController ($scope, Principal, LoginService, $state,ApiSetting,MessageService, ParseLinks) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init();
        function init() {
            vm.tableList = [];
            ApiSetting.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.interfaceDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                ApiSetting.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inform', {
                parent: 'module',
                url: '/inform',
                params:{page: null},
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/inform/inform.html',
                        controller: 'InformController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Notices', Notices);

    Notices.$inject = ['$resource'];

    function Notices ($resource) {
        var resourceUrl =  'api/notices/:item/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'pages'
                }
            },
            'getNewest': {
                method: 'GET',
                isArray: true,
                params: {
                    item: 'getNewest'
                }
            },
            'unRead': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'pages/unRead'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            },
            'read': {
                method:'GET',
                params: {
                    item: 'read'
                }
            },
            'readBatch': {
                method:'POST',
                params: {
                    item: 'readBatch'
                }
            },
            'getUnReadCount': {
                method:'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                params: {
                    id: 'getUnReadCount'
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InformController', InformController);

    InformController.$inject = ['$scope','Prices','MessageService', 'ParseLinks', '$stateParams','Notices'];

    function InformController ($scope, Prices,MessageService, ParseLinks, $stateParams,Notices) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: 'id,DESC',
            keyword: ''
        };
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            Notices.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };


        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //标记已读
        $scope.read = function (data) {
            Notices.read({id:data.id}, function (res) {
                data.read = true;
                MessageService.success('已读');
            })
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expressApiConfig', {
            parent: 'module',
            url: '/expressApiConfig',
            data: {
                authorities: ['ROLE_EXPRESS_API']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/expressApiConfig/expressApiConfig.html',
                    controller: 'ExpressApiConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('ExpressApiSetting', ExpressApiSetting)

    ExpressApiSetting.$inject = ['$resource'];

    function ExpressApiSetting ($resource) {
        var resourceUrl =  'api/express-api-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            get:{
                method:'GET',
                params: {
                    path: 'get'
                },
            },
            'update': { method:'POST' },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ExpressApiConfigController', ExpressApiConfigController);

    ExpressApiConfigController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'System', 'Qinius', '$q', '$timeout','ExpressApiSetting'];

    function ExpressApiConfigController ($scope, Principal, LoginService, $state,User,MessageService,System, Qinius, $q, $timeout,ExpressApiSetting) {
        var vm = this;
        vm.tokens = Qinius.get();
        vm.domains = Qinius.getDomain();
        vm.expressApiSettings = {};

        init()

        function init(){
            ExpressApiSetting.get(function(res){
                vm.expressApiSettings = res
            })
        }


        $scope.saveExpress = function(){
            ExpressApiSetting.update(vm.expressApiSettings, function onSaveSuccess () {
                vm.isSaving = false;
                MessageService.success("保存成功");
                init()
            }, function onSaveError () {
                vm.isSaving = false;
                MessageService.error("保存失败，请稍后重试！");
            })

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('Province1Controller', Province1Controller);

    Province1Controller.$inject = ['$scope','$state','MessageService', 'Express', 'msgdata', '$uibModalInstance','LocationProvice','LocationCity'];

    function Province1Controller ($scope, $state,MessageService,Express, msgdata,$uibModalInstance,LocationProvice,LocationCity) {
        var vm = this;
        vm.msgdata0 = msgdata ? msgdata.cities : [];
        vm.msgdata1 = [];
        msgdataInit()
        function msgdataInit(){
            var _data = [];
            for(var i= 0 ; i<vm.msgdata0.length; i++){
                _data.push(vm.msgdata0[i].provinceId);
            }
            var _data1 = uniq(_data);
            for(var i=0; i<_data1.length; i++){
                var _obj={
                    id:_data1[i],
                    name:"",
                    cities:[]
                }
                vm.msgdata1.push(_obj)
            }
            for(var j=0; j<vm.msgdata0.length; j++){
                for(var k=0; k<vm.msgdata1.length; k++){
                    if(vm.msgdata1[k].id == vm.msgdata0[j].provinceId){
                        vm.msgdata1[k].cities.push(vm.msgdata0[j])
                    }
                }
            }
            vm.msgdata = vm.msgdata1;
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                for(var i=0; i<data.length; i++){
                    city(data[i])
                }
            });
        }
        function uniq(array){
            var temp = []; //一个新的临时数组
            for(var i = 0; i < array.length; i++){
                if(temp.indexOf(array[i]) == -1){
                    temp.push(array[i]);
                }
            }
            return temp;
        }

        function city(data){
            LocationCity.findByProvince({provinceId: data.id}, function (res) {
                data.cities = res;
                for (var i = data.cities.length - 1; i >= 0; i--) {
                    var c = data.cities[i];
                    for(var j=0; j<vm.msgdata.length; j++){
                        if(data.id == vm.msgdata[j].id){
                            data.selected = true;
                            for(var k=0; k<vm.msgdata[j].cities.length; k++){
                                if(c.id == vm.msgdata[j].cities[k].id){
                                    c.selected = true;
                                }
                            }
                        }
                    }
                }
            });
        }
        $scope.provinceSelect = function(data,event){
            data.selected = event.target.checked;
            for(var i=0; i<data.cities.length; i++){
                data.cities[i].selected = event.target.checked;
            }
            selectinit()
        };
        $scope.citySelect = function(data,city,event){
            city.selected = event.target.checked;
            var isCity = false;
            for(var i=0; i<data.cities.length; i++){
                if(data.cities[i].selected){
                    isCity = true;
                }
            }
            if(isCity){
                data.selected = true;
            }else {
                data.selected = false;
            }
            selectinit()
        };
        function selectinit(){
            vm.data = [];
            for(var i=0; i<vm.provinces.length; i++){
                if(vm.provinces[i].selected){
                    for(var j=0; j<vm.provinces[i].cities.length; j++){
                        if(vm.provinces[i].cities[j].selected){
                            vm.data.push(vm.provinces[i].cities[j])
                        }
                    }
                }
            }
        }


        $scope.save = function(){
            $uibModalInstance.close(vm.data);
        }
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProvinceController', ProvinceController);

    ProvinceController.$inject = ['$scope','$state','MessageService', 'Express', 'msgdata', '$uibModalInstance','LocationProvice'];

    function ProvinceController ($scope, $state,MessageService,Express, msgdata,$uibModalInstance,LocationProvice) {
        var vm = this;
        vm.msgdata = msgdata || [];
        LocationProvice.query({},function (data) {
            for(var i=0; i<data.length; i++){
                for(var j=0; j<vm.msgdata.length; j++){
                    if(data[i].id == vm.msgdata[j].id){
                        data[i].selected = true
                    }
                }
            }
            vm.provinces =  data;
        });


        $scope.save = function(){
            var _provinces = [];
            for(var i=0; i<vm.provinces.length; i++){
                if(vm.provinces[i].selected){
                    _provinces.push(vm.provinces[i])
                }
            }
            $uibModalInstance.close(_provinces);
        }
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ExpressEditController', ExpressEditController);

    ExpressEditController.$inject = ['$scope', '$state','MessageService', 'Express', 'entity', '$stateParams', 'Supplier', '$uibModal', '$q'];

    function ExpressEditController ($scope,$state,MessageService,Express, entity, $stateParams, Supplier, $uibModal, $q) {
        var vm = this;
        vm.express = entity;

        $q.all([vm.express.$promise]).then(function() {
            Supplier.getAll(function (res) {
                vm.suppliers = res.filter(function (item) {
                    return item.enable;
                });
                for (var i = vm.suppliers.length - 1; i >= 0; i--) {
                    if (vm.suppliers[i].id == vm.express.supplierId) {
                        vm.supplier = vm.suppliers[i];
                    }
                }
            });
        })

        $scope.selectSup = function (sup) {
            vm.express.supplierId = sup.id;
        }

        $scope.save = function () {
            if(!vm.express.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(!vm.express.alias){
                MessageService.error("别名不能为空");
                return;
            }
            if(!vm.express.code){
                MessageService.error("编码不能为空");
                return;
            }
            if (vm.express.code.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("编码不能输入中文");
                return false;
            }
            if(!vm.express.customerId){
                MessageService.error("客户号不能为空");
                return;
            }
            if (vm.express.customerId.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("客户号不能输入中文");
                return false;
            }
            if(!vm.express.customerPassword){
                MessageService.error("客户密码不能为空");
                return;
            }
            if (vm.express.customerPassword.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("客户密码不能输入中文");
                return false;
            }
            if(!vm.express.overweight){
                MessageService.error("超重阈值不能为空");
                return;
            }

            // if(!vm.express.site){
            //     MessageService.error("网点名称不能为空");
            //     return;
            // }
            // if(!vm.express.siteNumber){
            //     MessageService.error("网点编码不能为空");
            //     return;
            // }
            // if (vm.express.siteNumber.match(/[\u4E00-\u9FA5]/g,'')) {
            //     MessageService.error("网点编码不能输入中文");
            //     return false;
            // }
            vm.isSaving = true;
            Express.update(vm.express, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("express",{page: $stateParams.page});
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("express",{page: $stateParams.page});
        }
        //偏远地区
        $scope.productionSet = function(){
            $uibModal.open({
                templateUrl: 'app/setting/express/province/province.html',
                controller: 'ProvinceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.express.remoteProvinces;
                    }
                }
            }).result.then(function(result){
                vm.express.remoteProvinces = result;
            });
        };
        //可发货地区
        $scope.shipments = function(){
            $uibModal.open({
                templateUrl: 'app/setting/express/province/province1.html',
                controller: 'Province1Controller',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.express.deliveryArea;
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.express.deliveryArea={
                        id:vm.express.deliveryArea ? vm.express.deliveryArea.id : "",
                    };
                    vm.express.deliveryArea.cities = result;
                    console.log(vm.express)
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ExpressAddController', ExpressAddController);

    ExpressAddController.$inject = ['$scope','$state','MessageService', 'Express', 'Supplier', '$uibModal'];

    function ExpressAddController ($scope, $state,MessageService,Express, Supplier,$uibModal) {
        var vm = this;
        init();
        function init(){
            vm.express = {
                name: '',
                alias: '',
                code:'',
                enable: true,
                customerId:'',
                customerPassword:'',
                site: '',
                siteNumber: '',
                supplierId: '',
                remoteProvinces: []
            };
        }

        Supplier.getAll(function(res){
            vm.suppliers =res.filter(function(item){return item.enable;})
        });

        $scope.selectSup = function (sup) {
            vm.express.supplierId = sup.id;
        }

        $scope.save = function () {
            console.log(vm.express);
            if(!vm.express.name){
                MessageService.error("名称不能为空");
                return;
            }
            if(!vm.express.alias){
                MessageService.error("别名不能为空");
                return;
            }
            if(!vm.express.code){
                MessageService.error("编码不能为空");
                return;
            }
            if (vm.express.code.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("编码不能输入中文");
                return false;
            }
            if (!vm.express.supplierId) {
                MessageService.error("请选择所属供应商");
                return;
            }
            if(!vm.express.customerId){
                MessageService.error("客户号不能为空");
                return;
            }
            if (vm.express.customerId.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("客户号不能输入中文");
                return false;
            }
            if(!vm.express.customerPassword){
                MessageService.error("客户密码不能为空");
                return;
            }
            if (vm.express.customerPassword.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("客户密码不能输入中文");
                return false;
            }

            if(!vm.express.overweight){
                MessageService.error("超重阈值不能为空");
                return;
            }

            // if(!vm.express.site){
            //     MessageService.error("网点名称不能为空");
            //     return;
            // }
            // if(!vm.express.siteNumber){
            //     MessageService.error("网点编码不能为空");
            //     return;
            // }
            // if (vm.express.siteNumber.match(/[\u4E00-\u9FA5]/g,'')) {
            //     MessageService.error("网点编码不能输入中文");
            //     return false;
            // }
            vm.isSaving = true;
            Express.add(vm.express, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("express");
            }

            function onSaveError () {
                vm.isSaving = false;
                MessageService.error("添加失败，请稍后重试！");
            }
        };


        //偏远地区
        $scope.productionSet = function(){
            $uibModal.open({
                templateUrl: 'app/setting/express/province/province.html',
                controller: 'ProvinceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.express.remoteProvinces;
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.express.remoteProvinces = result;
                }
            });
        };
        //可发货地区
        $scope.shipments = function(){
            $uibModal.open({
                templateUrl: 'app/setting/express/province/province1.html',
                controller: 'Province1Controller',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.express.deliveryArea;
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.express.deliveryArea={
                        id:"",
                    };
                    vm.express.deliveryArea.cities = result;
                    console.log(vm.express)
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('express', {
                parent: 'module',
                url: '/express',
                params:{page: null},
                data: {
                    authorities: ['ROLE_EXPRESS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/express/express.html',
                        controller: 'ExpressController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('expressAdd', {
                parent: 'module',
                url: '/expressAdd',
                data: {
                    authorities: ['ROLE_EXPRESS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/express/express-add.html',
                        controller: 'ExpressAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('expressEdit', {
                parent: 'module',
                url: '/expressEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_EXPRESS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/express/express-edit.html',
                        controller: 'ExpressEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Express', function($stateParams, Express) {
                        return Express.detail({id : $stateParams.id});
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Express', Express);

    Express.$inject = ['$resource'];

    function Express ($resource) {
        var resourceUrl =  'api/express-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'page': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {
                method:'GET'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ExpressController', ExpressController);

    ExpressController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Express','MessageService', 'ParseLinks', '$stateParams'];

    function ExpressController ($scope, Principal, LoginService, $state,Express,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            Express.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.expressDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Express.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DepositoryEditController', DepositoryEditController);

    DepositoryEditController.$inject = ['$scope', '$state','MessageService', 'Depository', 'entity', '$stateParams','LocationProvice', 'LocationCity', 'LocationDistrict','Supplier','$q'];

    function DepositoryEditController ($scope,$state,MessageService,Depository, entity, $stateParams,LocationProvice, LocationCity, LocationDistrict,Supplier,$q) {
        var vm = this;

        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        vm.data = entity;
        vm.typeList=[
            {name:'成品库',value:'product'},
            {name:'原辅材料库',value:'accessories'}
        ];
        vm.houseSourceList=[
            {name:'外部',value:'External'},
            {name:'内部',value:'Internal'}
        ];

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("仓库名称不能为空");
                return;
            }
            if(vm.data.name.length > 20){
                MessageService.error("仓库名称不能大于20位");
                return;
            }
            if(!vm.data.houseSource){
                MessageService.error("仓库属性不能为空");
                return;
            }
            if(!vm.data.type){
                MessageService.error("仓库类型不能为空");
                return;
            }

            if(!vm.data.number){
                MessageService.error("仓库编号不能为空");
                return;
            }
            if (vm.data.number.match(/[\u4E00-\u9FA5]/g,'')) {
                MessageService.error("仓库编号不能输入中文");
                return false;
            }
            if (vm.data.contacts == null || vm.data.contacts == "") {
                MessageService.error("联系人不能为空");
                return false;
            };
            if (vm.data.phone == null || vm.data.phone == "") {
                MessageService.error("联系电话不能为空");
                return false;
            };
            if (vm.province == null || vm.province == "") {
                MessageService.error("请选择省份");
                return false;
            };

            if (vm.city == null || vm.city == '') {
                MessageService.error('请选择城市');
                return false;
            }

            if (vm.district == null || vm.district == "") {
                MessageService.error("请选择区县");
                return false;
            };

            if (vm.data.address == null || vm.address == "") {
                MessageService.error("请输入详细地址");
                return false;
            };
            vm.isSaving = true;
            vm.data.province = vm.province.name;
            vm.data.city = vm.city.name;
            vm.data.district = vm.district.name;
            if(vm.data.id){
                Depository.update(vm.data, onSaveSuccess, onSaveError);
            }else{
                Depository.add(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("修改成功");
                $state.go("depository",{page: $stateParams.page});
            }

            function onSaveError (error) {
                vm.isSaving = false;
                MessageService.error(error.data.message || "修改失败，请稍后重试！");
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("depository",{page: $stateParams.page});
        };
        $scope.houseSourceType = function () {
            vm.data.supplier = null;
        }

        $q.all([vm.data.$promise]).then(function(){
            init()
        })
        function init() {
            Supplier.getAll(function (res) {
                vm.supplierList = res.filter(function(item){return item.enable});
            })
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if (p.name == vm.data.province) {
                        vm.province = p;
                        break;
                    }
                }
                if (vm.data.city != '') {
                    vm.districts = [];
                    LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                        vm.citys = data;
                        for (var i = vm.citys.length - 1; i >= 0; i--) {
                            var c = vm.citys[i];
                            if (c.name == vm.data.city) {
                                vm.city = c;
                                break;
                            }
                        }
                        if (vm.city != null) {
                            LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                                vm.districts = data;
                                for (var i = vm.districts.length - 1; i >= 0; i--) {
                                    var di = vm.districts[i];
                                    if (di.name == vm.data.district) {
                                        vm.district = di;
                                    }
                                }
                            });
                        }
                    });
                }
            });

        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('depository', {
                parent: 'module',
                url: '/depository',
                params:{page: null},
                data: {
                    authorities: ['ROLE_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/depository/depository.html',
                        controller: 'DepositoryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('depositoryAdd', {
                parent: 'module',
                url: '/depositoryAdd',
                data: {
                    authorities: ['ROLE_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/depository/depository-edit.html',
                        controller: 'DepositoryEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity:[function () {
                        return {
                            name:'',
                            type:'',
                            houseSource:'',
                            number:'',
                            province:'',
                            city:'',
                            district:'',
                            address:'',
                            defaulted:true,
                            supplierId:''
                        }
                    }]
                }
            })
            .state('depositoryEdit', {
                parent: 'module',
                url: '/depositoryEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/setting/depository/depository-edit.html',
                        controller: 'DepositoryEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Depository', function($stateParams, Depository) {
                        return Depository.detail({id : $stateParams.id});
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Depository', Depository);

    Depository.$inject = ['$resource'];

    function Depository ($resource) {
        var resourceUrl =  'api/warehouse/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {
                    path: 'pages'
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                params:{
                    path: 'list'
                },
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {
                method: 'GET',
                params: {
                    path: 'getOne'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DepositoryController', DepositoryController);

    DepositoryController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Depository','MessageService', 'ParseLinks', '$stateParams'];

    function DepositoryController ($scope, Principal, LoginService, $state,Depository,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: 'lastModifiedDate,DESC',
            keyword: ''
        };
        vm.clear =clear;
        init()
        function init() {
            vm.tableList = [];
            Depository.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        //删除
        $scope.depositoryDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Depository.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReceiptConfigController', ReceiptConfigController);

    ReceiptConfigController.$inject = ['$scope', 'LocationProvice', 'LocationCity', '$state','LocationDistrict','MessageService', 'System', 'Qinius', '$q', '$timeout','DeliverySettings'];

    function ReceiptConfigController ($scope, LocationProvice, LocationCity, $state,LocationDistrict,MessageService,System, Qinius, $q, $timeout,DeliverySettings) {
        var vm = this;
        vm.tokens = Qinius.get();
        vm.domains = Qinius.getDomain();
        vm.deliveryConfig = {};

        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        init()

        function init(){
            DeliverySettings.get({send:false},function(res){
                vm.deliveryConfig = res
                getAddressData()
            })
        }

        $scope.saveExpress = function(){
            if(vm.province) vm.deliveryConfig.province = vm.province.name
            if(vm.city) vm.deliveryConfig.city = vm.city.name
            if(vm.district) vm.deliveryConfig.district = vm.district.name
            vm.deliveryConfig.send = false
            DeliverySettings.update(vm.deliveryConfig, function onSaveSuccess () {
                vm.isSaving = false;
                MessageService.success("保存成功");
                init()
            }, function onSaveError () {
                vm.isSaving = false;
                MessageService.error("保存失败，请稍后重试！");
            })

        }

        // 获取地址数据
        function getAddressData(){
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if ( vm.deliveryConfig.province && p.name == vm.deliveryConfig.province) {
                        vm.province = p;
                        break;
                    }
                }
                vm.districts = [];
                if(vm.province){
                    LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                        vm.citys = data;
                        console.log(data);
                        for (var i = vm.citys.length - 1; i >= 0; i--) {
                            var c = vm.citys[i];
                            if (vm.deliveryConfig.city&&  c.name == vm.deliveryConfig.city) {
                                vm.city = c;
                                break;
                            }
                        }
                        if(vm.city){
                            LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                                vm.districts = data;
                                for (var i = vm.districts.length - 1; i >= 0; i--) {
                                    var di = vm.districts[i];
                                    if (vm.deliveryConfig.district && di.name == vm.deliveryConfig.district) {
                                        vm.district = di;
                                        // vm.address = res.orderLocation.address.split(vm.district.name+"-")[1];
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('deliveryConfig', {
            parent: 'module',
            url: '/deliveryConfig',
            data: {
                authorities: ['ROLE_DELIVERY_SETTING']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/deliveryConfig/deliveryConfig.html',
                    controller: 'DeliveryConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('receiptConfig', {
            parent: 'module',
            url: '/receiptConfig',
            data: {
                authorities: ['ROLE_DELIVERY_SETTING']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/deliveryConfig/receiptConfig.html',
                    controller: 'ReceiptConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('DeliverySettings', DeliverySettings)

    DeliverySettings.$inject = ['$resource'];

    function DeliverySettings ($resource) {
        var resourceUrl =  'api/delivery-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            get:{
                method:'GET',
                params: {
                    path: 'get'
                },
            },
            'update': { method:'POST' },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryConfigController', DeliveryConfigController);

    DeliveryConfigController.$inject = ['$scope', 'LocationProvice', 'LocationCity', '$state','LocationDistrict','MessageService', 'System', 'Qinius', '$q', '$timeout','DeliverySettings'];

    function DeliveryConfigController ($scope, LocationProvice, LocationCity, $state,LocationDistrict,MessageService,System, Qinius, $q, $timeout,DeliverySettings) {
        var vm = this;
        vm.tokens = Qinius.get();
        vm.domains = Qinius.getDomain();
        vm.deliveryConfig = {};

        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        init()

        function init(){
            DeliverySettings.get({send:true},function(res){
                vm.deliveryConfig = res
                getAddressData()
            })
        }

        $scope.saveExpress = function(){
            if(vm.province) vm.deliveryConfig.province = vm.province.name
            if(vm.city) vm.deliveryConfig.city = vm.city.name
            if(vm.district) vm.deliveryConfig.district = vm.district.name
            vm.deliveryConfig.send = true
            DeliverySettings.update(vm.deliveryConfig, function onSaveSuccess () {
                vm.isSaving = false;
                MessageService.success("保存成功");
                init()
            }, function onSaveError () {
                vm.isSaving = false;
                MessageService.error("保存失败，请稍后重试！");
            })

        }

        // 获取地址数据
        function getAddressData(){
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if ( vm.deliveryConfig.province && p.name == vm.deliveryConfig.province) {
                        vm.province = p;
                        break;
                    }
                }
                vm.districts = [];
                if(vm.province){
                    LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                        vm.citys = data;
                        console.log(data);
                        for (var i = vm.citys.length - 1; i >= 0; i--) {
                            var c = vm.citys[i];
                            if (vm.deliveryConfig.city&&  c.name == vm.deliveryConfig.city) {
                                vm.city = c;
                                break;
                            }
                        }
                        if(vm.city){
                            LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                                vm.districts = data;
                                for (var i = vm.districts.length - 1; i >= 0; i--) {
                                    var di = vm.districts[i];
                                    if (vm.deliveryConfig.district && di.name == vm.deliveryConfig.district) {
                                        vm.district = di;
                                        // vm.address = res.orderLocation.address.split(vm.district.name+"-")[1];
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('client', {
            parent: 'module',
            url: '/client',
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/client/client.html',
                    controller: 'ClientController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ClientController', ClientController);

    ClientController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','$localStorage','$location','System'];

    function ClientController ($scope, Principal, LoginService, $state,User,MessageService,$localStorage,$location,System) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.flag = false;

        System.getAll({}, function (res) {
            for(var i=0; i<res.length; i++){
                if(res[i].key == 'jhi_key'){
                    vm.jhiKey = res[i];
                }
                if (res[i].key == 'flow_file') {
                    vm.flowFile = res[i];
                    vm.flag = true;
                }
            }
        });

        window.uploadExe = function($event) {
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'exe'){
                angular.element("#file").val("");
                MessageService.error("只能上传.exe类型的文件!");
                return;
            }
            var url =  $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/qiniu/upload";

            var formData = new FormData();
            formData.append('file', fileObj);

            $.ajax({
                cache: true,
                type: "POST",
                url: url,
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                headers: {
                    Authorization: "Bearer " + vm.token
                },
                accept: 'file',
                success: function (data) {
                    angular.element("#file").val("");
                    MessageService.success("文件上传成功");
                    vm.flag =true;
                //  这里返回一个key值 可以用来保存
                    console.log(data.key);
                    vm.flowFile={
                        key:'flow_file',
                        value: data.key
                    };
                    $scope.$apply();
                },
                error: function (error) {
                    angular.element("#file").val("");
                    MessageService.error("文件上传失败，请稍后重试！");
                    vm.flag = false;
                }
            });
        };

        $scope.save = function () {
            if(!vm.jhiKey.value){
                MessageService.error("客户端版本号不能为空!");
                return;
            }
            if(!vm.flowFile.value){
                MessageService.error("客户端文件包不能为空!");
                return;
            }
            vm.isSaving = true;
            vm.jhiKey.key = 'jhi_key';
            System.update(vm.jhiKey, function onSaveSuccess () {
                vm.flowFile.key = 'flow_file';
                System.update(vm.flowFile, function onSaveSuccess () {
                    vm.isSaving = false;
                    MessageService.success("保存成功");
                }, function onSaveError () {
                    vm.isSaving = false;
                    MessageService.error("保存失败，请稍后重试！");
                });
            }, function onSaveError () {
                vm.isSaving = false;
                MessageService.error("保存失败，请稍后重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CTransactionDetailController', CTransactionDetailController);

    CTransactionDetailController.$inject = ['$scope', 'Principal', '$state', 'Channels', '$stateParams', 'msgdata', '$uibModalInstance', 'ParseLinks', '$localStorage', 'MessageService', '$http', '$q'];

    function CTransactionDetailController ($scope, Principal, $state, Channels, $stateParams, msgdata, $uibModalInstance, ParseLinks, $localStorage, MessageService, $http, $q) {
        var vm = this;
        vm.clear = clear;
        vm.channel = msgdata;
        vm.token = $localStorage.authenticationToken;

        vm.loadAll = loadAll;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            channelId: vm.channel.id,
            sort: ['createdDate,DESC'],
            startDate:GetDateStr(-31),
            endDate:GetDateStr(0),
            type:''
        };
        loadAll();
        // angular.element("#startDate").val(GetDateStr(-31));
        // angular.element("#endDate").val(GetDateStr(0));

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.types =[
            {name:'plus', value:'充值'},
            {name:'minus', value:'消费'},
            {name:'refund', value:'退款'}];

        function loadAll() {
            vm.records = [];
            if(angular.element("#startDate").val()){
                vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            }
            if(angular.element("#endDate").val()){
                vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            }
            Channels.getTransactionRecord(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.records = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.type = '';
            vm.tableData.page = 0;
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            $uibModalInstance.close();
        }

        //下载
        $scope.export = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            // if(vm.tableData.startDate == ""){
            //     MessageService.error("开始时间不能为空");
            //     return
            // }
            // if(vm.tableData.endDate == ""){
            //     MessageService.error("结束时间不能为空");
            //     return
            // }
            $http({
                url: 'api/downloadTransactionRecord',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = '交易记录' + Date.now() + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CRechargeAmountController', CRechargeAmountController);

    CRechargeAmountController.$inject = ['$scope', 'Principal', 'LoginService','$state','Channels','msgdata','$uibModal','$uibModalInstance','MessageService'];

    function CRechargeAmountController ($scope, Principal, LoginService,$state,Channels,msgdata,$uibModal,$uibModalInstance,MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        console.log(msgdata);

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.validate = function () {
            if (vm.balance == null || vm.balance == "") {
                MessageService.error("充值金额不能为空");
                return false;
            }
            return true;
        };

        function save () {
            if (!$scope.validate()) {
                return;
            }

            //plus充值/minus消费
            Channels.changeBalance({
                channelId: msgdata.id,
                balance: vm.balance,
                type: 'plus'
            }, function (res) {
                vm.isSaving = false;
                    MessageService.success("充值金额成功");
                    $uibModalInstance.close(res);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("充值金额失败");
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CProvinceController', CProvinceController);

    CProvinceController.$inject = ['$scope','$state','MessageService', 'Channels', 'msgdata', '$uibModalInstance','LocationProvice'];

    function CProvinceController ($scope, $state,MessageService,Channels, msgdata,$uibModalInstance,LocationProvice) {
        var vm = this;
        vm.freight = msgdata.freight;
        vm.msgdata = msgdata.remoteProvinces || [];

        LocationProvice.query({},function (data) {
            for(var i=0; i<data.length; i++){
                if(vm.msgdata.length > 0){
                    for(var j=0; j<vm.msgdata.length; j++){
                        if(data[i].id == vm.msgdata[j].id){
                            data[i].selected = true
                        }
                    }
                }
            }
            vm.provinces =  data;
        });


        $scope.save = function(){
            var freight;
            var _provinces = [];
            for(var i=0; i<vm.provinces.length; i++){
                if(vm.provinces[i].selected){
                    _provinces.push(vm.provinces[i])
                }
            }
            freight = vm.freight;
            var data = {
               "remoteProvinces" :_provinces,
               "freight":freight
            };
            $uibModalInstance.close(data);
        }
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CannelChooseProductController', CannelChooseProductController);

    CannelChooseProductController.$inject = ['$q', '$scope','$uibModalInstance','MessageService','Product','$timeout', 'entity'];

    function CannelChooseProductController ($q, $scope, $uibModalInstance,MessageService,Product,$timeout, entity) {
        var vm = this;
        vm.keyword ='';
        vm.selectIndex ='';
        vm.skus = entity;
        vm.first =[];
        vm.tableList =[];
        vm.data=[];
        var tempArr =[];

        var productArr = {key: null, value: null};

        vm.productList = Product.sortByCategory({keyword:vm.keyword});

        $scope.skuInclude = function(sku ){
            for(var i = 0; i< vm.skus.length; i++){
                var s = vm.skus[i];
                if (s.id == sku.id) {
                    return true;
                }
            }
            return false;
        }
        $q.all([vm.productList.$promise]).then(function() {
            if (vm.skus.length> 0 ) {
                for(var k in vm.productList){
                    if (vm.productList[k].length>0) {
                        var catrgories = vm.productList[k];
                        for (var i = catrgories.length - 1; i >= 0; i--) {
                            var category =  catrgories[i];
                            for(var k2 in category){
                                if (category[k2].length > 0) {
                                    for(var j = 0 ; j< category[k2].length; j++){
                                        var p = category[k2][j];
                                        var counts = 0;
                                        for(var k3 in p){
                                            var skus = p[k3];
                                            if (skus.length>0) {
                                                for(var z = 0; z< skus.length; z++){
                                                    var sku = skus[z];
                                                    vm.data.push(sku);
                                                    if ($scope.skuInclude(sku)) {
                                                        sku.checked = true;
                                                        counts++;
                                                    }
                                                }
                                            }
                                            if(counts==skus.length){
                                                skus.select_all = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });

        $timeout(function(){
            angular.element('.firstItem').click(function(){
                if(!$(this).hasClass('on')){
                    $(this).next('.subItems').slideDown(200).parent().siblings('.mainItems').find('.subItems').slideUp(200);
                    $(this).addClass('on').parent().siblings('.mainItems').find('.firstItem').removeClass('on');
                    $(this).find('.plus_first').addClass('rotateIcon').end().parent().siblings('.mainItems').find('.plus_first').removeClass('rotateIcon');
                }else{
                    $(this).removeClass('on');
                    $(this).next('.subItems').slideUp(200).parent().siblings('.mainItems').find('.subItems').slideUp(200);
                    $(this).find('.plus_first').removeClass('rotateIcon');
                }
            });
        },500);

        $scope.selectAll = function(key,data){
            if (data.select_all) {
                for (var i = data.length - 1; i >= 0; i--) {
                    data[i].checked = true;
                }
            }else{
                for (var i = data.length - 1; i >= 0; i--) {
                    data[i].checked = false;
                }
            }
            $scope.getProduct(key,data);
        }

        $scope.getProduct = function(key,data){
            vm.selectIndex =-1;
            vm.tableList=data;
            vm.navKey =key;
        };

        //这里搜索有问题
        $scope.search = function(){
            vm.tableList = vm.data.filter(function(item){
                return item.sku ==vm.keyword ||item.number ==vm.keyword;
            });
            //展开列表收起
            $('.firstItem').removeClass('on');
            $('.firstItem').next('.subItems').slideUp(200).parent().siblings('.mainItems').find('.subItems').slideUp(200);
            $('.firstItem').find('.plus_first').removeClass('rotateIcon');
        };

        $scope.productChoice = function(data, datas){
            for (var i = datas.length - 1; i >= 0; i--) {
                if (!datas[i].checked) {
                    datas.select_all = false;
                    return;
                }
            }
            datas.select_all = true;
        };

        $scope.confirm = function(){
          // if(vm.product==null){
          //     MessageService.error('请选择商品！');
          // }else{

          // }
            vm.skus = [];
            for(var k in vm.productList){
                if (vm.productList[k].length>0) {
                    var catrgories = vm.productList[k];
                    for (var i = catrgories.length - 1; i >= 0; i--) {
                        var category =  catrgories[i];
                        for(var k2 in category){
                            if (category[k2].length > 0) {
                                for(var j = 0 ; j< category[k2].length; j++){
                                    var p = category[k2][j];
                                    for(var k3 in p){
                                        var skus = p[k3];
                                        if (skus.length>0) {
                                            for(var z = 0; z< skus.length; z++){
                                                var sku = skus[z];
                                                if (sku.checked) {
                                                    vm.skus.push(sku);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $uibModalInstance.close(vm.skus);
        };

        $scope.cancel = function(){
            $uibModalInstance.dismiss();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChannelEditController', ChannelEditController);

    ChannelEditController.$inject = ['$scope', 'Principal', '$uibModal', '$state','MessageService', 'Channels','entity', '$stateParams'];

    function ChannelEditController ($scope, Principal, $uibModal, $state,MessageService,Channels,entity, $stateParams) {
        var vm = this;
        vm.data = entity;

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("渠道名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("渠道名称不能大于20位");
                return;
            }
            if(!vm.data.url){
                MessageService.error("渠道url不能为空");
                return;
            }
            if(!vm.data.makeupUrl){
                MessageService.error("拼版url不能为空");
                return;
            }
            vm.isSaving = true;
            Channels.update(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("编辑成功");
                $state.go("channel",{page: $stateParams.page});
            }

            function onSaveError (error) {
                vm.isSaving = false;
                MessageService.error(error.data.message);
            }
        };
        //返回
        $scope.goBack = function () {
            $state.go("channel",{page: $stateParams.page});
        }

        //选择产品
        $scope.chooseProduct = function(){
            $uibModal.open({
                templateUrl: 'app/setting/channel/chooseProduct.html',
                controller: 'CannelChooseProductController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return vm.data.propertyConfigs || [];
                    }]
                }
            }).result.then(function(result){
                console.log(result);
                if(result!=undefined){
                    vm.data.propertyConfigs = result;
                }else{
                    vm.data.propertyConfigs = [];
                }
            });
        };

        //充值
        $scope.recharge = function(){
            $uibModal.open({
                templateUrl: 'app/setting/channel/recharge-amount.html',
                controller: 'CRechargeAmountController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.data;
                    }
                }
            }).result.then(function(result){
                vm.data.balance = result.balance;
            });
        };


        //交易明细
        $scope.transactionDetail = function(){
            $uibModal.open({
                templateUrl: 'app/setting/channel/transaction-detail.html',
                controller: 'CTransactionDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.data;
                    }
                }
            }).result.then(function(result){
            });
        };

        //偏远地区
        $scope.productionSet = function(){
            $uibModal.open({
                templateUrl: 'app/setting/channel/province/province.html',
                controller: 'CProvinceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.data;
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.data.remoteProvinces = result.remoteProvinces;
                    vm.data.freight = result.freight;
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChannelAddController', ChannelAddController);

    ChannelAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'Channels', '$uibModal'];

    function ChannelAddController ($scope, Principal, LoginService, $state,User,MessageService,Channels, $uibModal) {
        var vm = this;
        vm.data = {
            name: '',
            enable: true
        };
        vm.isSaving = false;

        //选择产品
        $scope.chooseProduct = function(){
            $uibModal.open({
                templateUrl: 'app/setting/channel/chooseProduct.html',
                controller: 'CannelChooseProductController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return vm.data.propertyConfigs || [];
                    }]
                }
            }).result.then(function(result){
                console.log(result);
                if(result!=undefined){
                    vm.data.propertyConfigs = result;
                }else{
                    vm.data.propertyConfigs = [];
                }
            });
        };

        $scope.save = function () {
            if(!vm.data.name){
                MessageService.error("渠道名称不能为空");
                return;
            }
            if(vm.data.name.length >20){
                MessageService.error("渠道名称不能大于20位");
                return;
            }
            if(!vm.data.url){
                MessageService.error("渠道url不能为空");
                return;
            }
            if(!vm.data.makeupUrl){
                MessageService.error("拼版url不能为空");
                return;
            }
            vm.isSaving = true;
            Channels.add(vm.data, onSaveSuccess, onSaveError);
            function onSaveSuccess (result) {
                vm.isSaving = false;
                MessageService.success("添加成功");
                $state.go("channel");
            }

            function onSaveError (error) {
                console.log(error)
                vm.isSaving = false;
                MessageService.error(error.data.message);
            }
        };

        //偏远地区
        $scope.productionSet = function(){
            $uibModal.open({
                templateUrl: 'app/setting/channel/province/province.html',
                controller: 'CProvinceController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.data;
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.data.remoteProvinces = result.remoteProvinces;
                    vm.data.freight = result.freight;
                }
            });
        };
        //返回
        $scope.goBack = function () {
            $state.go("channel");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('channel', {
            parent: 'module',
            url: '/channel',
            data: {
                authorities: ['ROLE_CHANNEL']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/channel/channel.html',
                    controller: 'ChannelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('channelAdd', {
            parent: 'module',
            url: '/channelAdd',
            data: {
                authorities: ['ROLE_CHANNEL']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/channel/channel-add.html',
                    controller: 'ChannelAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('channelEdit', {
            parent: 'module',
            url: '/channelEdit/{id}',
            params:{page: null},
            data: {
                authorities: ['ROLE_CHANNEL']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/channel/channel-edit.html',
                    controller: 'ChannelEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Channels', function ($stateParams, Channels) {
                    return Channels.detail({id: $stateParams.id});
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Channels', Channels);

    Channels.$inject = ['$resource'];

    function Channels ($resource) {
        var resourceUrl =  'api/channels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                params: {
                    id: 'page'
                },
            },
            'getAll': { method: 'GET', isArray: true,
                params: {
                    id: 'getAll'
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    id: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            },
            'changeBalance': {
                method: 'GET',
                params: {
                    id: 'changeBalance'
                }
            },
            'getTransactionRecord': {
                method: 'GET',
                params: {
                    id: 'getTransactionRecord'
                },
                isArray: true
            },
            'getHomePageData': {
                method: 'GET',
                params: {
                    id: 'getHomePageData'
                },
            },
            
            'getChannelAndMerchant': {
                method: 'GET',
                params: {
                    id: 'getChannelAndMerchant'
                },
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChannelController', ChannelController);

    ChannelController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Channels','MessageService', 'ParseLinks', '$stateParams'];

    function ChannelController ($scope, Principal, LoginService, $state,Channels,MessageService, ParseLinks, $stateParams) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: ''
        };

        init()
        function init() {
            vm.tableList = [];
            Channels.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.userDelete = function (data) {
            MessageService.confirm("确认要删除该数据？", function () {
                Channels.delete({id: data.id}, function () {
                    init();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User($resource) {
        var service = $resource('api/users/:login/:id', {}, {
            'batchDelete': {
                method: 'GET',
                params: {
                    login: 'batchDelete'
                }
            },
            'batchSave': {
                method:'POST' ,
                params: {
                    login: 'batchSave'
                },
                headers: {
                    scope:'client'
                }
            },
            'getAll': {
                method:'GET',
                params: {
                    login: 'getAll'
                },
                isArray: true
            } ,
            'query': {
                method: 'GET',
                params: {
                    login: 'page'
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'saveSupply': {
                method:'POST' ,
                headers: {
                    scope:'order-end'
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {
                method: 'DELETE',
                params: {
                    login: 'id'
                }
            },
            'reset': {
                method: 'POST',
                params: {
                    login: 'reset'
                }
            },
            'reset2': {
                method: 'POST',
                params: {
                    login: 'reset2'
                }
            },
            'validate': {
                method: 'GET',
                params: {
                    login: 'exists'
                }
            },
            'id': {
                method: 'GET',
                params: {
                    login: 'id'
                }
            },
            'getEmployee': {
                method: 'GET',
                isArray: true,
                params: {
                    login: 'getEmployee'
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Module', Module);

    Module.$inject = ['$resource'];

    function Module ($resource) {
        /*模块的列表配置*/
        var modules = [
            {
                name:"订单中心",
                icon:"lf_1gs.png",
                id:"order",
                auth:['ROLE_SELF_SUPPORT_ORDER', 'ROLE_GENERAL_ORDER', 'ROLE_REPLENISHMENT_ORDER'],
                menus:[
                    {
                        name:"定制订单",
                        id:"orderSelf",
                        auth:["ROLE_SELF_SUPPORT_ORDER"]
                    },
                    {
                        name:"通品订单",
                        id:"orderGeneral",
                        auth:["ROLE_SELF_SUPPORT_ORDER"]
                    },
                    // {
                    //     name: "外部订单",
                    //     id: "orderExternal",
                    //     auth: ["ROLE_SELF_SUPPORT_ORDER"]
                    // },
                    {
                        name:"补货订单",
                        id:"orderReplenish",
                        auth:["ROLE_REPLENISHMENT_ORDER"]
                    },
                    {
                        name:"预警订单",
                        id:"orderWarn",
                        auth:["ROLE_REPLENISHMENT_ORDER"]
                    }
                     //{
                     //    name:"VIP订单",
                     //    id:"orderVip",
                     //    auth:["ROLE_VIP_ORDER"]
                     //},
                     //{
                     //    name:"第三方订单",
                     //    id:"traceOrder",
                     //    auth:["ROLE_THIRD_ORDER"]
                     //}
                ]
            },
            {
                name:"项目中心",
                icon:"lf_4cp.png",
                id:"projectCenter",
                auth:['ROLE_PROJECT'],
                menus:[
                    {
                        name:"项目列表",
                        id:"project",
                        auth:["ROLE_PROJECT"]
                    }
                ]
            },
            // {
            //     name:"人工排版",
            //     icon:"lf_rg.png",
            //     id:"manualTask",
            //     auth:['ROLE_TASK_ALLOCATION','ROLE_MY_TASK'],
            //     menus:[
            //         {
            //             name:"任务分配",
            //             id:"taskAllocation",
            //             auth:["ROLE_TASK_ALLOCATION"]
            //         },
            //         {
            //             name:"我的任务",
            //             id:"myTasks",
            //             auth:["ROLE_MY_TASK"]
            //         }
            //     ]
            // },
            {
                name:"产品中心",
                icon:"lf_4cp.png",
                id:"product",
                auth:['ROLE_CLASSIFY','ROLE_PRODUCT', 'ROLE_MATERIAL', 'ROLE_MATERIALTEMPLATE','ROLE_ITEM'],
                menus:[
                    {
                        name:"分类管理",
                        id:"classify",
                        auth:["ROLE_CLASSIFY"]
                    },
                    {
                        name:"定制品管理",
                        id:"commodity",
                        parameter:{productType:'OrderingProduct'},
                        auth:["ROLE_PRODUCT"]
                    },
                    {
                        name:"成品管理",
                        id:"commodity1",
                        parameter:{productType:'GeneralProduct'},
                        auth:["ROLE_PRODUCT"]
                    },
                    {
                        name:"辅料管理",
                        id:"commodity2",
                        parameter:{productType:'MaterialProduct'},
                        auth:["ROLE_MATERIAL"]
                    },
                    {
                        name:"物料模版",
                        id:"materials",
                        auth:['ROLE_MATERIALTEMPLATE']
                    },
                    {
                        name:"属性管理",
                        id:"item",
                        auth:['ROLE_ITEM']
                    }
                ]
            },
            {
                name:"生产中心",
                icon:"outsourcingTask.png",
                id:"outsourcingCentre",
                auth:['ROLE_ENTRUST','ROLE_IMPOSITION','ROLE_PREPRESS','ROLE_OUTPAINT'],
                menus:[
                    {
                        name:"任务列表",
                        id:"outsourcingTask",
                        auth:["ROLE_ENTRUST"]
                    },
                    {
                        name:"拼版列表",
                        id:"makeUp",
                        auth:["ROLE_IMPOSITION"]
                    },
                    {
                        name:"印前任务列表",
                        id:"prePress",
                        auth:["ROLE_PREPRESS"]
                    },
                    {
                        name:"扩边任务列表",
                        id:"expandTask",
                        auth:["ROLE_OUTPAINT"]
                    }
                ]
            },
            {
                name:"供应商中心",
                icon:"lf_6gy.png",
                id:"supply",
                auth:['ROLE_SUP'],
                menus:[
                    {
                        name:"供应商管理",
                        id:"supplyManagement",
                        auth:["ROLE_SUP"]
                    },
                    {
                        name:"供应商api",
                        id:"supplyApi",
                        auth:["ROLE_SUP"]
                    }
                ]
            },
            // {
            //     name:"客户中心",
            //     icon:"lf_6gy.png",
            //     id:"customerHub",
            //     auth:['ROLE_SUP'],
            //     menus:[
            //         {
            //             name:"客户管理",
            //             id:"customerHub",
            //             auth:["ROLE_SUP"]
            //         },
            //         {
            //             name:"开票申请管理",
            //             id:"invoicing",
            //             auth:["ROLE_SUP"]
            //         }
            //     ]
            // },
            {
                name:"成品仓库",
                icon:"warehouse.png",
                id:"finishedWarehouse",
                auth:['ROLE_PRODUCT_WAREHOUSE', 'ROLE_INVENTORY_WAREHOUSE', 'ROLE_ALLOCATION_WAREHOUSE', 'ROLE_OUTIN_WAREHOUSE'],
                menus:[
                    {
                        name:"库存查询",
                        id:"reserve",
                        auth:["ROLE_PRODUCT_WAREHOUSE"]
                    },
                    {
                        name:"盘点调整记录",
                        id:"inventory",
                        auth:["ROLE_INVENTORY_WAREHOUSE"]
                    },
                    {
                        name:"调拨记录",
                        id:"allocation",
                        auth:["ROLE_ALLOCATION_WAREHOUSE"]
                    },
                    {
                        name:"出入库记录",
                        id:"outgoingAndWarehousing",
                        auth:["ROLE_OUTIN_WAREHOUSE"]
                    }
                ]
            },
            {
                name:"辅料仓库",
                icon:"warehouse.png",
                id:"accessoriesWarehouse",
                auth:['ROLE_MATERIAL_WAREHOUSE', 'ROLE_MATERIAL_INVENTORY', 'ROLE_MATERIAL_ALLOCATION', 'ROLE_MATERIAL_OUTIN'],
                menus:[
                    {
                        name:"库存查询",
                        id:"reserve2",
                        auth:["ROLE_MATERIAL_WAREHOUSE"]
                    },
                    {
                        name:"盘点调整记录",
                        id:"inventory2",
                        auth:["ROLE_MATERIAL_INVENTORY"]
                    },
                    {
                        name:"调拨记录",
                        id:"allocation2",
                        auth:["ROLE_MATERIAL_ALLOCATION"]
                    },
                    {
                        name:"出入库记录",
                        id:"outgoingAndWarehousing2",
                        auth:["ROLE_MATERIAL_OUTIN"]
                    }
                ]
            },
            {
                name:"发货中心",
                icon:"lf_2dd.png",
                id:"invoiceCentre",
                auth:['ROLE_DELIVER'],
                menus:[
                    {
                        name:"发货列表",
                        id:"invoice",
                        auth:["ROLE_DELIVER"]
                    },
                    {
                        name:"发货请求",
                        id:"deliveryRequest",
                        auth:["ROLE_DELIVER"]
                    },
                    {
                        name:"供应商发货记录",
                        id:"supplier-delivery",
                        auth:["ROLE_DELIVER"]
                    },
                    {
                        name:"供应商发货请求",
                        id:"supplierDeliveryRequest",
                        auth:["ROLE_DELIVER"]
                    }
                ]
            },
            {
                name:"采购管理",
                icon:"lf_6gy.png",
                id:"purchase",
                auth:['ROLE_PURCHASE', 'ROLE_PURCHASE_LIST','ROLE_PURCHASE_ORDER_RETURN'],
                menus:[
                    {
                        name:"采购需求",
                        id:"purchasingApplication",
                        auth:["ROLE_PURCHASE"]
                    },
                    {
                        name:"采购单",
                        id:"purchaseProductLine",
                        auth:["ROLE_PURCHASE_LIST"]
                    },
                    {
                        name:"退货单",
                        id:"purchaseReturnOrder",
                        auth:["ROLE_PURCHASE_ORDER_RETURN"]
                    }
                ]
            },
            {
                name:"盘点管理",
                icon:"lf_6gy.png",
                id:"stockManagement",
                auth:[ 'ROLE_STOCK_TAKING_ORDER'],
                menus:[
                    {
                        name:"盘点单",
                        id:"stockManagement",
                        auth:["ROLE_STOCK_TAKING_ORDER"]
                    }
                ]
            },
            {
                name:"数据统计",
                icon:"lf_11sj.png",
                id:"dataChart",
                auth:[ 'ROLE_STOCK_TAKING_ORDER'],
                menus:[
                    {
                        name:"生产统计",
                        id:"orderStatistics",
                        auth:["ROLE_STOCK_TAKING_ORDER"]
                    }
                ]
            },
            {
                name:"数据统计",
                icon:"lf_11sj.png",
                id:"chart",
                auth:['ROLE_DATA_STATISTICS', 'ROLE_MERCHANT_CHART', 'ROLE_SUPPLIER_DOWNLOAD_CHART'],
                menus:[
                    {
                        name:"供应商数据",
                        id:"chart",
                        auth:['ROLE_DATA_STATISTICS']
                    },
                    {
                        name:"商户数据",
                        id:"merchant-chart",
                        auth:['ROLE_MERCHANT_CHART']
                    },
                    {
                        name:"下载数据",
                        id:"supplier-download-chart",
                        auth:['ROLE_SUPPLIER_DOWNLOAD_CHART']
                    },
                    {
                        name:"补货数据",
                        id:"replenishment-chart",
                        auth:['ROLE_SUPPLIER_DOWNLOAD_CHART']
                    },
                    {
                        name:"发货数据",
                        id:"deliver-chart",
                        auth:['ROLE_SUPPLIER_DOWNLOAD_CHART']
                    }
                ]
            },
            {
                name:"用户中心",
                icon:"lf_9yh.png",
                id:"user",
                auth:['ROLE_ROLE','ROLE_USER'],
                menus:[
                    {
                        name:"角色管理",
                        id:"role",
                        auth:['ROLE_ROLE']
                    },
                    {
                        name:"用户管理",
                        id:"user",
                        auth:['ROLE_USER']
                    }
                ]
            },
            {
                name:"设置中心",
                icon:"lf_10ct.png",
                id:"setting",
                auth:['ROLE_GOODS_SHELVES', 'ROLE_SET_SUP', 'ROLE_REPLENISH_REASON', 'ROLE_EXPRESS', 'ROLE_WAREHOUSE', 'ROLE_UNIT', 'ROLE_CHANNEL',
                'ROLE_PRICE', 'ROLE_SET_INTER', 'ROLE_SYSTEM_SETTING',  'ROLE_SYSTEM_LOG', 'ROLE_SET_MAKEUP', 'ROLE_MACHINE', 'ROLE_EXPRESS_API', 'ROLE_DELIVERY_SETTING'],
                menus:[
                    {
                        name:"货架管理",
                        id:"shelfManagement",
                        auth:['ROLE_GOODS_SHELVES']
                    },
                    // {
                    //     name:"商户管理",
                    //     id:"merchant",
                    //     auth:['ROLE_SET_SUP']
                    // },
                    {
                        name:"拼版管理",
                        id:"makeup",
                        auth:['ROLE_SET_MAKEUP']
                    },
                    {
                        name:"补货原因",
                        id:"replenishmentReason",
                        auth:['ROLE_REPLENISH_REASON']
                    },
                    {
                        name:"快递设置",
                        id:"express",
                        auth:['ROLE_EXPRESS']
                    },
                    {
                        name:"快递鸟渠道设置",
                        id:"expressApiConfig",
                        auth:['ROLE_EXPRESS_API']
                    },
                    {
                        name:"发货信息配置",
                        id:"deliveryConfig",
                        auth:['ROLE_DELIVERY_SETTING']
                    },
                    {
                        name:"收货信息配置",
                        id:"receiptConfig",
                        auth:['ROLE_DELIVERY_SETTING']
                    },
                    {
                        name:"仓库管理",
                        id:"depository",
                        auth:['ROLE_WAREHOUSE']
                    },
                    {
                        name:"计量单位",
                        id:"unitMeasurement",
                        auth:['ROLE_UNIT']
                    },
                    {
                        name:"机型管理",
                        id:"machine",
                        auth:['ROLE_MACHINE']
                    },
                    {
                        name:"渠道管理",
                        id:"channel",
                        auth:['ROLE_CHANNEL']
                    },
                    {
                        name:"价目表",
                        id:"priceList",
                        auth:['ROLE_PRICE']
                    },

                    {
                        name:"接口配置",
                        id:"interface",
                        auth:['ROLE_SET_INTER']
                    },
                    {
                        name:"系统设置",
                        id:"system",
                        auth:['ROLE_SYSTEM_SETTING']
                    },
                    {
                        name:"印前管理",
                        id:"prePressFlow",
                        auth:['ROLE_SYSTEM_SETTING']
                    },
                    {
                        name:"文件校验",
                        id:"proofRule",
                        auth:['ROLE_SYSTEM_SETTING']
                    },
                    // {
                    //     name:"支付设置",
                    //     id:"payment-settings",
                    //     auth:['ROLE_SYSTEM_SETTING']
                    // },
                    {
                        name:"系统日志",
                        id:"systemLog",
                        auth:['ROLE_SYSTEM_LOG']
                    },
                    {
                        name:"消息通知",
                        id:"inform",
                        auth:['ROLE_SYSTEM_LOG']
                    },
                    {
                        name:"标签列表",
                        id:"tag",
                        auth:['ROLE_SYSTEM_LOG']
                    }

                ]
            },
            {
                name:"出入库管理",
                icon:"warehouse.png",
                id:"inventoryManagement",
                auth:['ROLE_INVENTORY_STOCK_OUT','ROLE_INVENTORY_STOCK_DIFF','ROLE_INVENTORY_STOCK_RETURN'],
                menus:[
                    {
                        name:"出库管理",
                        id:"outBound",
                        auth:['ROLE_INVENTORY_STOCK_OUT']
                    },
                    {
                        name:"门店入库差异",
                        id:"outBoundDifference",
                        auth:['ROLE_INVENTORY_STOCK_DIFF']
                    },
                    {
                        name:"门店退货管理",
                        id:"storeRefundGoods",
                        auth:['ROLE_INVENTORY_STOCK_RETURN']
                    },
                    // {
                    //     name:"入库管理",
                    //     id:"inBound",
                    //     auth:['ROLE_ROLE']
                    // },
                ]
            },
        ];
        return modules;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('LocationProvice', LocationProvice)
        .factory('LocationCity', LocationCity)
        .factory('LocationDistrict', LocationDistrict);

    LocationProvice.$inject = ['$resource'];

    LocationCity.$inject = ['$resource'];

    LocationDistrict.$inject = ['$resource'];

    function LocationProvice($resource) {
        var resourceUrl = 'api/location-provinces/:path/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            "findByName":{
                method:"GET",
                params:{
                    path:"findByName"
                }
            }
        });
    }

    function LocationCity($resource) {
        var resourceUrl = 'api/location-cities/:path/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            "findByProvince":{
                method:"GET",
                params:{
                    path:"findByProvince"
                },
                isArray: true
            },
            "findByName":{
                method:"GET",
                params:{
                    path:"findByName"
                }
            }
        });
    }

    function LocationDistrict($resource) {
        var resourceUrl = 'api/location-districts/:path/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            "findByCities":{
                method:"GET",
                params:{
                    path:"findByCities"
                },
                isArray: true
            },
            "findByName":{
                method:"GET",
                params:{
                    path:"findByName"
                }
            }

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$sessionStorage'];

    function Principal ($q, Account, $sessionStorage) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                console.log(_identity);
                $sessionStorage.user = _identity;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var resourceUrl =  'api/account/:id';

        return $resource(resourceUrl, {}, {
            'change': { method: 'POST', isArray: true,
                params: {
                    id: 'change_password'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
                else if (isAuthenticated && $rootScope.toState.name === 'login') {
                    $state.go('home');
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('login');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('login').then(function() {
                            // LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q','MessageService'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q,MessageService) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess).error(function(data){
                if(data.message!=null||data.message=="error.validation"||data.AuthenticationException=="Unmatched scope"||data.AuthenticationException=="Bad credentials"){
                    MessageService.error("用户或密码有误!");
                }else if(data.AuthenticationException!=null&&data.AuthenticationException.indexOf("was not activated")>=0){
                    MessageService.error("用户失效!");
                }else{
                    MessageService.error("网络不可用!");
                }
            });

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('importStockUploadList', {
                parent: 'module',
                url: '/importStock/{type}',
                data: {
                    authorities: ['ROLE_PRODUCT_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/reserveUpload/importStock-upload-list.html',
                        controller: 'ImportStockUploadListController',
                        controllerAs: 'vm'
                    }
                }
            })

    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .controller('ImportStockUploadListController', ImportStockUploadListController);

        ImportStockUploadListController.$inject = ['$state','$stateParams','$uibModal','$scope'];

    function ImportStockUploadListController($state,$stateParams,$uibModal,$scope ) {

        var vm = this;
        vm.loadAll = loadAll
        loadAll();
        $scope.goBack = function(){
            history.back();
        }

        function loadAll(){
            $uibModal.open({
                templateUrl: 'app/reserveUpload/importStock-upload.html',
                controller: 'ImportStockUpload',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {
                            quantity: null,
                            status: null,
                            id: null
                        };
                    }
                }
            }).result.then(function(data) {
                vm.branchStores=data
            }, function() {
                // $state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ImportStockUpload', ImportStockUpload);

        ImportStockUpload.$inject = ['$timeout', '$q',  '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ListService',
     'MessageService',  'Upload', ];

    function ImportStockUpload($timeout, $q,  $scope, $stateParams, $uibModalInstance, entity, ListService, MessageService,  Upload) {
        var vm = this;

        vm.coupon = entity;
        console.log(entity,$stateParams.type);
        vm.clear = clear;
        vm.save = save;
        vm.warehouseType=$stateParams.type?$stateParams.type:''
        function clear() {
            $uibModalInstance.close();
        }
        window.updateFile = function ($event) {
        };
        function save() {
            if(vm.isSaving){
                return
            }
            vm.isSaving = true;
            var file = document.getElementById("fileId").files[0];

            var getBase64 = function (file, callback) {
                var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                reader.onload = function () { //  成功读取
                    $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                };
                reader.onerror = function (error) { //  出错
                };
            };
            getBase64(file, function (result) {});
            Upload.upload({
                type: 'POST',
                url: 'api/reserves/import?warehouseType=' + vm.warehouseType, //上传路径
                data: {
                    file: file,
                    name: file.name
                }
            }).then(function successCallback(res) {
                vm.isSaving = false;
                if(res.status && res.status == 200){
                    MessageService.success("操作成功");
                    $uibModalInstance.close(res.data.message);
                }
            }, function errorCallback(response) {
                vm.isSaving = false;
                $uibModalInstance.close();
                MessageService.error(response.data.message || "文件导入失败，请稍后重试");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('WarehousingController', WarehousingController);

    WarehousingController.$inject = ['$scope','$state', 'msgdata', '$uibModal', '$uibModalInstance', 'MessageService', 'PurchaseOrder'];

    function WarehousingController ($scope, $state, msgdata, $uibModal, $uibModalInstance, MessageService, PurchaseOrder) {
        var vm = this;
        vm.purchaseOrderList = msgdata.purchaseOrderList;
        vm.purchaseOrder = msgdata.purchaseOrder;

        $scope.saveNum = function(){
            if(vm.warehousingNum > 0){
                PurchaseOrder.changeWarehousingNum({
                    id: vm.purchaseOrder.id,
                    lineId: vm.purchaseOrderList.id,
                    num: vm.warehousingNum
                },function(res){
                    MessageService.success('入库成功！');
                    $uibModalInstance.close(res);
                },function(error){
                    MessageService.error('入库失败');
                });
            }else{
                MessageService.error('请输入入库数量');
            }
        };

        $scope.cancelTask = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ToExamineController', ToExamineController);

    ToExamineController.$inject = ['$scope','$state', 'msgdata', '$uibModal', '$uibModalInstance', 'MessageService', 'PurchaseProductLine'];

    function ToExamineController ($scope, $state, msgdata, $uibModal, $uibModalInstance, MessageService, PurchaseProductLine) {
        var vm = this;

        init();
        function init() {
            vm.purchaseOrderList = msgdata;
            console.log(vm.purchaseOrderList);
        }

        $scope.confirmBtn = function() {
            console.log(vm.purchaseOrderList)
            var ids = '';
            for (var i = 0; i < vm.purchaseOrderList.length; i++) {
                if (vm.purchaseOrderList[i].state == 'ToBeAudited'||vm.purchaseOrderList[i].state == 'ToBeRevised') {
                    ids += vm.purchaseOrderList[i].id + ",";
                }
            }
            ids = ids.substr(0, ids.length - 1);
            PurchaseProductLine.changeState({ids: ids, state: 'AlreadyIssued'}, function (data) {
                if (data.message == '300') {
                    MessageService.error('采购订单审核失败，因供料不足！');
                } else if(data.message == '404'){
                    MessageService.error('采购订单审核失败，因数据有误！');
                } else if (data.message == '200') {
                    MessageService.success('采购订单已下达！');
                }
                $state.go("purchaseProductLine");
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error('采购订单审核失败！');
            });
        }

        $scope.refuse = function() {
            var ids = '';
            for (var i = 0; i < vm.purchaseOrderList.length; i++) {
                if (vm.purchaseOrderList[i].state == 'ToBeAudited'||vm.purchaseOrderList[i].state == 'ToBeRevised') {
                    ids += vm.purchaseOrderList[i].id + ",";
                }
            }
            ids = ids.substr(0, ids.length - 1);
            PurchaseProductLine.changeState({ids: ids, state: 'ToBeRevised'}, function (data) {
                MessageService.success('采购订单已下达！');
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error('采购订单审核失败！');
            });

        }
        $scope.cancelTask = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchasingApplicationPageController', PurchasingApplicationPageController);

    PurchasingApplicationPageController.$inject = ['$scope','$state', 'entity'];

    function PurchasingApplicationPageController ($scope, $state, entity) {
        var vm = this;

        vm.purchaseOrder = entity;

        $scope.cancelSave = function() {
            $state.go("purchasingApplication");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchasingApplicationController', PurchaseController);

    PurchaseController.$inject = ['$scope', 'Principal', '$state', 'MessageService', 'PurchaseOrder', 'ParseLinks', '$uibModal', '$timeout', '$stateParams','PurchaseProductLine','Depository'];

    function PurchaseController ($scope, Principal, $state, MessageService, PurchaseOrder, ParseLinks, $uibModal, $timeout, $stateParams,PurchaseProductLine,Depository) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PURCHASE').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有访问的权限！");
                $state.go("home");
            }
        });

        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.selection = [
            {name:'全部', value:'all'},
            {name:'待审核', value:'ToBeAudited'},
            {name:'待修订', value:'ToBeRevised'},
            {name:'已下达', value:'AlreadyIssued'},
            {name:'采购预警', value:'Warning'}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            keyword: '',
            type:'all',
            pageType: 'demand'
        };

        Depository.getAll({},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });
        //获取选中的数组
        $scope.checked =[];
        $scope.selectOne1 = function (e,data){
            data.checked = !data.checked;
            fn(e)
            $scope.selectOne(e,data);
        }
        $scope.selectOne = function(e,data){
            fn(e)
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };

        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            // if (e && e.preventDefault) {
            //     e.preventDefault();
            // } else {
            //     // IE中阻止函数器默认动作的方式
            //     window.event.returnValue = false;
            // }
        }
        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.tableList.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
        };

        $scope.cancelModal = function() {
            vm.messageStr = '';
            $('#submitModal').modal('hide');
        };

        $scope.confirmSubmit = function() {
            var ids = '';
            for (var i = $scope.checked.length - 1; i >= 0; i--) {
                ids += $scope.checked[i].id + ",";
            }
            ids = ids.substr(0, ids.length - 1);
            if (vm.messageType == 1) {
                // 审核
                PurchaseProductLine.examineOrder({ids: ids}, function(){
                    MessageService.success('审核成功');
                    $scope.cancelModal();
                    init();
                }, function(){
                    MessageService.error('审核失败');
                });
            }
        };

        // 转采购单
        $scope.submission = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }

            var ids = '';
            var status = ''
            var warehouseId = ''
            var supplierId = ''
            for (var i = $scope.checked.length - 1; i >= 0; i--) {
                if ($scope.checked[i].state != 'Examined') {
                    MessageService.error('存在未审核需求');
                    return;
                }
                if (!$scope.checked[i].status) {
                    MessageService.error('采购类型不能为空');
                    return;
                }
                ids += $scope.checked[i].id + ",";
                if(status && status!=$scope.checked[i].status){
                    MessageService.error('请选择同一采购类型的商品转采购单');
                    return;
                }else{
                    status = $scope.checked[i].status;
                }
                if(warehouseId && warehouseId!=$scope.checked[i].warehouseId){
                    MessageService.error('请选择同一入库仓库的商品转采购单');
                    return;
                }else{
                    warehouseId = $scope.checked[i].warehouseId;
                }
                if(supplierId && supplierId!=$scope.checked[i].supplierId){
                    MessageService.error('请选择同一供应商的商品转采购单');
                    return;
                }else{
                    supplierId = $scope.checked[i].supplierId;
                }
            }
            ids = ids.substr(0, ids.length - 1);
            PurchaseOrder.createOrderByDemand
            $state.go("purchaseProductLineEdit", {id: ids});
        };

        // 审核需求订单
        $scope.toExamine = function() {

            if($scope.checked.length == 0){
                MessageService.error('请选择列表项');
                return;
            }

            vm.messageStr = '审核操作确认。';
            vm.messageType = 1;     // 审核
            $('#submitModal').modal('show');
        }

        // 取消采购需求
        $scope.cancelledBtn = function() {
            if($scope.checked.length == 0){
                MessageService.error('请选择列表项');
                return;
            }

            var ids = '';
            for (var i = $scope.checked.length - 1; i >= 0; i--) {
                ids += $scope.checked[i].id + ",";
            }
            ids = ids.substr(0, ids.length - 1);

            PurchaseProductLine.cancelDemand({ids: ids}, function(){
                MessageService.success('取消成功');
                init();
            }, function(){
                MessageService.error('取消失败');
            });
        }

        init();
        function init() {
            vm.tableList = [];
            $scope.checked = [];
            $scope.select_all = false;
            PurchaseProductLine.demandPage(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.stateInfo = function (item){
            switch (item) {
                case 'New':
                    return '待审核';
                case 'Examined':
                    return '审核通过';
                default:
                    return item
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseReturnOrderPreviewController', PurchaseReturnOrderPreviewController);

    PurchaseReturnOrderPreviewController.$inject = ['$scope','$state', '$q', 'MessageService', 'Reserves', 'PurchaseProductLine', 'Supplier', 'Depository', 'UnitMeasurement', 'Product', 'PurchaseOrder', 'entity','$uibModal'];

    function PurchaseReturnOrderPreviewController ($scope, $state, $q, MessageService, Reserves, PurchaseProductLine, Supplier, Depository, UnitMeasurement, Product, PurchaseOrder, entity,$uibModal) {
        var vm = this;
        vm.purchaseOrder = entity;
        $scope.goback = function (){
            history.back();
        };
        $scope.preview = function (){
            var iframe = document.getElementById('print-frame');
            if (iframe === null || iframe === undefined) {
                iframe = document.createElement('iframe');
                iframe.lang = 'en';
                iframe.style.display = 'none';
                iframe.id = 'print-frame';
                document.body.insertBefore(iframe, document.body.children[0]);
                iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title></title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='content/css/c-bootstrap.css'>";
            }

            setTimeout(function () {
                var changePrint = function (type) {
                    var html = '';
                    type = type?type:1;
                    if(type=='1'){
                        html='<style type="text/css" media="print">\n' + '  @page { size: landscape; }\n' + '</style>';
                    }else{
                        html='<style type="text/css" media="print">\n' + '  @page { size: portrait; }\n' + '</style>';
                    }
                    return html;
                };
                $('#previewId').append(changePrint(1));
                iframe.contentDocument.body.innerHTML = document.getElementById("previewId").innerHTML;
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 300);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseReturnOrderEditController', PurchaseReturnOrderEditController);

    PurchaseReturnOrderEditController.$inject = ['$scope','$state', '$q', 'MessageService', 'DateUtils', 'PurchaseProductLine', 'Supplier', 'Depository', 'PurchaseOrderReturn', 'Product', 'PurchaseOrder', 'entity','$uibModal', '$localStorage','$http'];

    function PurchaseReturnOrderEditController ($scope, $state, $q, MessageService, DateUtils, PurchaseProductLine, Supplier, Depository, PurchaseOrderReturn, Product, PurchaseOrder, entity,$uibModal, $localStorage, $http) {
        var vm = this;
        vm.productDelete = productDelete;
        vm.deletedList = []
        vm.token = $localStorage.authenticationToken;

        vm.purchaseOrder = entity;
        // vm.suppliers = Supplier.getAll();
        vm.update = true;
        $q.all([vm.purchaseOrder.$promise]).then(function(){
            if(vm.purchaseOrder.status != 'New'){
                vm.update = false;
            }
            // init();
        });

        function init() {
            if(vm.purchaseOrder.type =='Outsourcing'){
                vm.warehousis = Depository.getAll({type: 'product'});
            }else if(vm.purchaseOrder.type =='RawMaterial'){
                vm.warehousis = Depository.getAll({type: "accessories"});
            }else{
                vm.warehousis = Depository.getAll({type: null});
            }

            vm.deliveryDate = vm.purchaseOrder.deliveryDate == null ? null : vm.purchaseOrder.deliveryDate.substr(0, 10);
            // $q.all([vm.warehousis.$promise]).then(function(){
            //     getProduct(function (){
            //         if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
            //             // 为了选择sku时的优化  将已删除的商品单拿出来  避免污染正在选择的商品及sku
            //             var _tempList = []
            //             vm.purchaseOrder.purchaseProductLines.forEach(function(itm){
            //                 if(itm.cancelled){
            //                     vm.deletedList.push(itm)
            //                 }else{
            //                     _tempList.push(itm)
            //                 }
            //             })
            //             vm.purchaseOrder.purchaseProductLines = _tempList

            //             var _ids = []
            //             vm.purchaseOrder.purchaseProductLines.forEach(function (line){
            //                 if(vm.purchaseOrder.status == 'AlreadyIssued' && !line.warehousingNum){
            //                     line.warehousingNum = line.num;
            //                 }
            //                 $scope.selectPurchaseProduct(line)
            //                 if(!line.propertyConfigId && line.propertyConfigSku && line.propertyConfigs && line.propertyConfigs.length>0){
            //                     for(var i=0; i<line.propertyConfigs.length; i++){
            //                         if(line.propertyConfigSku == line.propertyConfigs[i].sku){
            //                             line.propertyConfigId=line.propertyConfigs[i].id;
            //                             _ids.push(line.propertyConfigs[i].id)
            //                             break
            //                         }
            //                     }
            //                 }
            //             })
            //             setOptions(_ids)
            //         }
            //     })
            // });
        }

        function productDelete(record,index) {
            var _data = JSON.parse(JSON.stringify(vm.purchaseOrder.returnLines))
            if(_data[index].id){
                _data[index].cancelled = true;
                vm.deletedList.push(_data[index])
                _data.splice(index, 1);
            }else{
                _data.splice(index, 1);
            }
            vm.purchaseOrder.returnLines = _data
        }



        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }

        $scope.save = function(saveAndSubmit,callback){
            if(vm.isSaving){return }
            // if (!vm.purchaseOrder.supplierId) {
            //     MessageService.error("请选择供应商");
            //     return false;
            // }
            // if (vm.purchaseOrder.type == null || vm.purchaseOrder.type == '') {
            //     MessageService.error("请选择退货类型");
            //     return false;
            // }

            // var deliveryDate = getDate($('#startDate').val() + " 23:59:59");
            // vm.purchaseOrder.deliveryDate = deliveryDate;
            // if (vm.purchaseOrder.deliveryDate == null || vm.purchaseOrder.deliveryDate == '') {
            //     MessageService.error("请选择计划交期");
            //     return false;
            // }
            // if (!vm.purchaseOrder.warehouseId) {
            //     MessageService.error("请选择默认入库");
            //     return false;
            // }
            if (vm.purchaseOrder.contact == null || vm.purchaseOrder.contact == '') {
                MessageService.error("请输入联系人");
                return false;
            }
            if (vm.purchaseOrder.phone == null || vm.purchaseOrder.phone == '') {
                MessageService.error("请输入联系电话");
                return false;
            }
            if (vm.purchaseOrder.address == null || vm.purchaseOrder.address == '') {
                MessageService.error("请输入收货地址");
                return false;
            }
            if (vm.purchaseOrder.freight === null || vm.purchaseOrder.freight === '' || vm.purchaseOrder.freight < 0) {
                MessageService.error("请输入运费");
                return false;
            }
            if(vm.purchaseOrder.returnLines && vm.purchaseOrder.returnLines.length>0){
                var returnLines = [];
                vm.deletedList.forEach(function(delItem){
                    vm.purchaseOrder.returnLines.push(delItem)
                })
                var flag =  true
                vm.purchaseOrder.returnLines.forEach(function (item){
                    if(flag){
                        if(!item.cancelled){
                            returnLines.push(item)
                        }
                        if(item.num > item.returnableNum){
                            flag = false
                            MessageService.error(item.productName + " 退货数量不得超过可退数量");
                            return false;
                        }
                        if(item.price > item.purchaseLinePrice){
                            flag = false
                            MessageService.error(item.productName + " 退货单价不得超过采购单价");
                            return false;
                        }
                    }
                })
                if(!flag)return
                if (returnLines.length == 0) {
                    MessageService.error("退货商品信息不能为空");
                    return false;
                }
                for (var i = 0; i < vm.purchaseOrder.returnLines.length; i++) {
                    var purchaseProductLine = vm.purchaseOrder.returnLines[i];
                    if(!purchaseProductLine.cancelled){
                        if (purchaseProductLine.num == null || purchaseProductLine.num < 0) {
                            MessageService.error("请输入商品信息中的数量");
                            return false;
                        }
                        if (purchaseProductLine.price == null) {
                            MessageService.error("请输入商品信息中的单价");
                            return false;
                        }

                        if (purchaseProductLine.tax === null || purchaseProductLine.tax === '' || purchaseProductLine.tax < 0) {
                            MessageService.error("请输入商品信息中的税率");
                            return false;
                        }
                        vm.purchaseOrder.returnLines[i].total = (purchaseProductLine.num * purchaseProductLine.price).toFixed(2);
                        vm.purchaseOrder.returnLines[i].taxPrice = ((purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price).toFixed(4);
                        vm.purchaseOrder.returnLines[i].taxTotal = vm.purchaseOrder.returnLines[i].taxPrice * purchaseProductLine.num;
                    }
                }

            }else {
                MessageService.error("退货商品信息不能为空");
                return false;
            }

            vm.isSaving = true;
            if(saveAndSubmit){
                PurchaseOrderReturn.saveAndSubmit(vm.purchaseOrder, function(res){
                    vm.isSaving = false;
                    MessageService.success('提交退货成功！');
                    $scope.cancelSave();
                },function(error){
                    vm.isSaving = false;
                    MessageService.error('新建退货失败');
                });
            }else{
                if(vm.purchaseOrder.status == 'AlreadyIssued'){
                    PurchaseOrderReturn.changeWarehousingNum(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        MessageService.success('保存成功！');
                        $scope.cancelSave();
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('编辑退货失败');
                    });
                    return
                }
                if(vm.purchaseOrder.id){
                    PurchaseOrderReturn.update(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        if(callback){
                            callback()
                        }else{
                            MessageService.success('编辑退货成功！');
                            $scope.cancelSave();
                        }
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('编辑退货失败');
                    });
                }else{
                    PurchaseOrderReturn.save(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        if(callback){
                            callback()
                        }else{
                            MessageService.success('新建退货成功！');
                            $scope.cancelSave();
                        }
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('新建退货失败');
                    });
                }
            }
        };

        //导出
        $scope.export = function () {
            $http({
                url: 'api/purchase-order-returns/exportDetail/'+vm.purchaseOrder.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "退货单"+ vm.purchaseOrder.number + '_' +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $scope.cancelSave = function() {
            history.back();
        }

        $scope.getSupplier = function() {
            vm.purchaseOrder.supplierName = null;
            vm.taxRate = 0;
            if(vm.purchaseOrder.supplierId){
                vm.suppliers.forEach(function (item){
                    if(item.id == vm.purchaseOrder.supplierId){
                        vm.purchaseOrder.supplierName =item.name;
                        vm.taxRate = item.taxRate;
                    }
                })
            }
            if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
                vm.purchaseOrder.purchaseProductLines.forEach(function (item){
                    item.tax = vm.taxRate;
                })
            }
        }
        //通过或拒绝
        $scope.audit = function (item){
            if(!item){
                MessageService.confirm("是否审核拒绝", function () {
                    PurchaseOrderReturn.reject({id:vm.purchaseOrder.id}, function(res){
                        if(res.state == 400){
                            MessageService.error(res.message || '拒绝失败');
                            return
                        }
                        MessageService.success('已拒绝');
                        $scope.cancelSave();
                    },function(error){
                        MessageService.error(error.data.message || '拒绝失败');
                    });
                });
            }else{
                var flag1 =  true
                vm.purchaseOrder.returnLines.forEach(function (item){
                    if(flag1){
                        if(item.returnableNum <= 0){
                            flag1 = false
                            MessageService.error(item.productName + "可退数量为0,无法通过");
                            return false;
                        }
                    }
                })
                if (flag1){
                    MessageService.confirm("确认审核通过", function () {
                        PurchaseOrderReturn.approve({id:vm.purchaseOrder.id}, function(res){
                            if(res.state == 400){
                                MessageService.error(res.message || '通过失败');
                                return
                            }
                            MessageService.success('已通过');
                            $scope.cancelSave();
                        },function(error){
                            MessageService.error(error.data.message || '通过失败');
                        });
                    });
                }
            }
        }
        //关闭
        $scope.close = function (){
            MessageService.confirm("确认关闭当前退货单", function () {
                PurchaseOrderReturn.close({id:vm.purchaseOrder.id}, function(res){
                    if(res.state == 400){
                        MessageService.error(res.message || '关闭失败');
                        return
                    }
                    MessageService.success('已关闭');
                    $scope.cancelSave();
                },function(error){
                    MessageService.error('关闭失败');
                });
            });
        }
        $scope.numChange = function (purchaseProductLine){
            purchaseProductLine.warehousingNum = purchaseProductLine.num;
            $scope.currentItemChange(purchaseProductLine)
        }
        $scope.currentItemChange = function (purchaseProductLine){
            // 限制用户只能输入两位小数
            if(purchaseProductLine.price){
                var value = purchaseProductLine.price;
                var regex = /^(\d+(\.\d{0,4})?)$/;
                if (!regex.test(value)) {
                    var parts = String(value).split('.')
                    if (parts[1].length > 4) {
                        value = parts[0] + '.' + parts[1].substring(0, 4);
                    }
                    purchaseProductLine.price = Number(value)
                }
            }
            purchaseProductLine.taxPrice = ((purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price).toFixed(4)
            purchaseProductLine.taxTotal = purchaseProductLine.taxPrice * purchaseProductLine.num
        }
        $scope.purchaseOrderType = function (item){
            switch (item) {
                case 'New':
                    return {
                        text:'待提交',
                        color:'#333'
                    };
                case 'ToBeAudited':
                    return {
                        text:'待审核',
                        color:'#ffa037'
                    };
                case 'ToBeRevised':
                    return {
                        text:'已关闭',
                        color:'#333'
                    };
                case 'AlreadyIssued':
                    return {
                        text:'未入库',
                        color:'#ff0000'
                    };
                case 'Store':
                    return {
                        text:'部分入库',
                        color:'#51de37'
                    };
                case 'Finished':
                    return {
                        text:'已完成',
                        color:'#005eff'
                    };
                case 'Examined':
                    return {
                        text:'审核通过',
                        color:'#333'
                    };
                default:
                    return {
                        text:item,
                        color:'#333'
                    };
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseReturnOrderController', PurchaseReturnOrderController);

    PurchaseReturnOrderController.$inject = ['$scope', 'Principal', '$state', '$location', 'MessageService', 'PurchaseOrder', 'ParseLinks', '$uibModal', '$timeout', '$stateParams',
        'Supplier','Depository','DateUtils', '$localStorage','$http','PurchaseOrderReturn'];

    function PurchaseReturnOrderController ($scope, Principal, $state, $location, MessageService, PurchaseOrder, ParseLinks, $uibModal, $timeout, $stateParams,
                                 Supplier,Depository,DateUtils, $localStorage, $http,PurchaseOrderReturn) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PURCHASE_ORDER_RETURN').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;

        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.selection = [
            {name:'全部', value:''},
            {name:'待提交', value:'New'},
            {name:'待审核', value:'ToBeAudited'},
            // {name:'未入库', value:'AlreadyIssued'},
            // {name:'部分入库', value:'Store'},
            {name:'已完成', value:'Finished'},
            {name:'已关闭', value:'Close'}
        ];
        var _startDate = $stateParams.startDate || ''
        var _endDate = $stateParams.endDate || ''
        angular.element("#startDate").val(_startDate);
        angular.element("#endDate").val(_endDate);

        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: Number($stateParams.size) || 20,
            number:Number($stateParams.number) || '',
            orderNumber:Number($stateParams.orderNumber) || '',
            supplierId:Number($stateParams.supplierId) || '',
            warehouseId:Number($stateParams.warehouseId) || '',
            sort: ['createdDate,DESC'],
            status:$stateParams.status || ''
        };
        vm.dateType = $stateParams.dateType || 'purchase'
        vm.suppliers = Supplier.getAll();
        Depository.getAll({},function(res){
            vm.warehouses = res.filter(function(item){return item.defaulted});
        });

        //获取选中的数组
        $scope.checked =[];
        $scope.selectOne = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.tableList.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
        };

        // 提交
        $scope.submission = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }
            var ids = '';
            for (var i = 0; i < $scope.checked.length; i++) {
                if ($scope.checked[i].state == 'New') {
                    ids += $scope.checked[i].id + ",";
                }else{
                    MessageService.error('请选择新建的采购单');
                    return;
                }
            }
            ids = ids.substr(0, ids.length - 1);
            PurchaseProductLine.changeState({ids: ids, state: 'ToBeAudited'}, function (data) {
                MessageService.success('采购订单提交成功！');
                init();
            }, function (error) {
                MessageService.error('采购订单提交失败！');
            });
        }

        $scope.compulsoryWarehousing = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }
            var ids = '';
            for (var i = 0; i < $scope.checked.length; i++) {
                if ($scope.checked[i].state == 'AlreadyIssued') {
                    ids += $scope.checked[i].id + ",";
                }
            }

            ids = ids.substr(0, ids.length - 1);
            PurchaseProductLine.changeState({ids: ids, state: 'compulsoryWarehousing'}, function (data) {
                MessageService.success('采购订单强制入库成功！');
                init();
            }, function (error) {
                MessageService.error('采购订单强制入库失败！');
            });
        }

        //新建
        $scope.newOrder = function(){
            $uibModal.open({
                templateUrl: 'app/purchase/purchaseOrder-add.html',
                controller: 'PurchaseOrderAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return null;
                    }
                }
            }).result.then(function(result){
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                init();
            });
        };


        //入库
        $scope.warehousing = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }
            if ($scope.checked.length > 1) {
                MessageService.error('请选择一项添加入库数量');
                return;
            }
            if ($scope.checked[0].state != 'AlreadyIssued'){
                MessageService.error('请选择一项已下达的订购添加入库数量');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/purchase/warehousing.html',
                controller: 'WarehousingController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return $scope.checked;
                    }
                }
            }).result.then(function(result){
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                init();
            });

        };

        $scope.toExamine = function() {
            if($scope.checked.length == 0){
                MessageService.error('请选择列表项');
                return;
                if (vm.purchaseOrderList[i].state == 'ToBeAudited'||vm.purchaseOrderList[i].state == 'ToBeRevised') {}
            }
            var _data = [];
            for (var i = 0; i < $scope.checked.length; i++) {
                if ($scope.checked[i].state == 'ToBeAudited' || $scope.checked[i].state == 'ToBeRevised') {
                    _data.push($scope.checked[i]);
                }else{
                    MessageService.error('请选择待审核或者待修订的采购单');
                    return;
                }
            }

            $uibModal.open({
                templateUrl: 'app/purchase/toExamine.html',
                controller: 'ToExamineController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return _data;
                    }
                }
            }).result.then(function(result){
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                init();
            });
        }

        $scope.cancelledBtn = function() {
            if($scope.checked.length == 0){
                MessageService.error('请选择列表项');
                return;
            }

            var ids = '';
            for (var i = $scope.checked.length - 1; i >= 0; i--) {
                if ($scope.checked[i].state == 'AlreadyIssued') {
                    MessageService.error('已下达采购不能取消');
                    return;
                }
                ids += $scope.checked[i].id + ",";
            }
            ids = ids.substr(0, ids.length - 1);

            PurchaseProductLine.cancelled({ids:ids}, function(){
                MessageService.success('取消成功');
                init();
            }, function(){
                MessageService.error('取消失败');
            })
        }

        //导出明细表
        $scope.exportDetails = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            var url ='api/purchase-order-returns/exportList?number='+ vm.tableData.number + '&orderNumber=' + vm.tableData.orderNumber + '&available=' + false  + '&supplierId=' + vm.tableData.supplierId + '&warehouseId=' + vm.tableData.warehouseId +  '&status=' + vm.tableData.status + '&startDate=' + vm.tableData.startDate + '&endDate=' + vm.tableData.endDate
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "退货单" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        var _h = angular.element(".table-top").find(".table-state").height();
        if(_h > 40){
            vm.isTableState = true;
        }else {
            vm.isTableState = false;
        }

        init();
        function init() {
            vm.tableList = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $scope.checked = [];
            $scope.select_all = false;
            var items = [];
            var _p = {
                items:items,
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
            }
            if(vm.tableData.status){
                items.push({key:"status",op:"=",value:vm.tableData.status})
            }
            if(vm.tableData.number){
                items.push({key:"number",op:"=",value:vm.tableData.number})
            }
            if(vm.tableData.supplierId){
                items.push({key:"supplier.id",op:"=",value:vm.tableData.supplierId})
            }
            if(vm.tableData.warehouseId){
                items.push({key:"warehouse.id",op:"=",value:vm.tableData.warehouseId})
            }
            if(vm.tableData.startDate){
                items.push({
                    "key": 'startDate',
                    "op": ">=",
                    "value": DateUtils.dayStart(vm.tableData.startDate)
                })
            }
            if(vm.tableData.endDate){
                items.push({
                    "key": 'endDate',
                    "op": "<=",
                    "value": DateUtils.dayEnd(vm.tableData.endDate)
                })
            }
            _p.items = items;
            var _p1 = {
                number:vm.tableData.number,
                orderNumber:vm.tableData.orderNumber,
                supplierId:vm.tableData.supplierId,
                status:vm.tableData.status,
                warehouseId:vm.tableData.warehouseId,
                page:vm.tableData.page,
                size:vm.tableData.size,
                available:false,
                sort:vm.tableData.sort,
                startDate:vm.tableData.startDate,
                endDate:vm.tableData.endDate
            }
            // if(vm.dateType === 'purchase'){
            //     _p1.startDate = vm.tableData.startDate
            //     _p1.endDate = vm.tableData.endDate
            // }else if(vm.dateType === 'store'){
            //     _p1.startStoredDate = vm.tableData.startDate
            //     _p1.endStoredDate = vm.tableData.endDate
            // }
            $location.search({
                number:vm.tableData.number,
                orderNumber:vm.tableData.orderNumber,
                supplierId:vm.tableData.supplierId,
                status:vm.tableData.status,
                warehouseId:vm.tableData.warehouseId,
                page:vm.tableData.page,
                size:vm.tableData.size,
                startDate:vm.tableData.startDate,
                endDate:vm.tableData.endDate,
                dateType:vm.dateType,
                available:false,
                // sort:vm.tableData.sort
            });
            PurchaseOrderReturn.queryTable(_p1, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
                console.log(error)
            });
        }

        var nowTime = new Date().getTime();
        $scope.getWarnTime = function(date){
            var time = getDate(date).getTime();
            var dayNum = (time - nowTime) / (1000 * 60 * 60 * 24) - 1;
            dayNum = Math.ceil(dayNum);
            return dayNum;
        }

        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }


        $scope.conditionSelect = function(data){
            vm.tableData.status = data.value;
            vm.tableData.page = 0;
            init();
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                page: Number($stateParams.page) || 0,
                size: 20,
                sort: ['createdDate,DESC'],
                status:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            vm.dateType =  'purchase'
            init();
        };

        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                angular.element(".table-top").height("40");
                angular.element(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                angular.element(".table-top").height("auto");
                angular.element(".table-state-btn").addClass("table-state-btnOn");
            }
        };

        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }
        $scope.purchaseOrderType = function (item){
            switch (item) {
                case 'New':
                    return {
                        text:'待提交',
                        color:'#333'
                    };
                case 'ToBeAudited':
                    return {
                        text:'待审核',
                        color:'#ffa037'
                    };
                case 'Close':
                    return {
                        text:'已关闭',
                        color:'#333'
                    };
                case 'AlreadyIssued':
                    return {
                        text:'未入库',
                        color:'#ff0000'
                    };
                case 'Store':
                    return {
                        text:'部分入库',
                        color:'#51de37'
                    };
                case 'Finished':
                    return {
                        text:'已完成',
                        color:'#005eff'
                    };
                case 'Examined':
                    return {
                        text:'审核通过',
                        color:'#333'
                    };
                default:
                    return {
                        text:item,
                        color:'#333'
                    };
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseOrderPreviewController', PurchaseOrderPreviewController);

    PurchaseOrderPreviewController.$inject = ['$scope','$state', '$q', 'MessageService', 'Reserves', 'PurchaseProductLine', 'Supplier', 'Depository', 'UnitMeasurement', 'Product', 'PurchaseOrder', 'entity','$uibModal'];

    function PurchaseOrderPreviewController ($scope, $state, $q, MessageService, Reserves, PurchaseProductLine, Supplier, Depository, UnitMeasurement, Product, PurchaseOrder, entity,$uibModal) {
        var vm = this;
        vm.purchaseOrder = entity;
        $scope.goback = function (){
            history.back();
        };
        $scope.preview = function (){
            var iframe = document.getElementById('print-frame');
            if (iframe === null || iframe === undefined) {
                iframe = document.createElement('iframe');
                iframe.lang = 'en';
                iframe.style.display = 'none';
                iframe.id = 'print-frame';
                document.body.insertBefore(iframe, document.body.children[0]);
                iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title></title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'>";
            }

            setTimeout(function () {
                var changePrint = function (type) {
                    var html = '';
                    type = type?type:1;
                    if(type=='1'){
                        html='<style type="text/css" media="print">\n' + '  @page { size: landscape; }\n' + '</style>';
                    }else{
                        html='<style type="text/css" media="print">\n' + '  @page { size: portrait; }\n' + '</style>';
                    }
                    return html;
                };
                $('#previewId').append(changePrint(1));
                iframe.contentDocument.body.innerHTML = document.getElementById("previewId").innerHTML;
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 300);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseOrderEditController', PurchaseOrderEditController);

    PurchaseOrderEditController.$inject = ['$scope','PurchaseOrderReturn', '$q', 'MessageService', 'DateUtils', 'PurchaseProductLine', 'Supplier', 'Depository', 'Principal', 'Product', 'PurchaseOrder', 'entity','$uibModal', '$localStorage','$http'];

    function PurchaseOrderEditController ($scope, PurchaseOrderReturn, $q, MessageService, DateUtils, PurchaseProductLine, Supplier, Depository, Principal, Product, PurchaseOrder, entity,$uibModal, $localStorage, $http) {
        var vm = this;
        vm.productAdd = productAdd;
        vm.productDelete = productDelete;
        vm.getWarehouse = getWarehouse;
        vm.types = [
            {name:'成品采购', value:'Outsourcing'},
            {name:'材料采购', value:'RawMaterial'}
        ];
        vm.deletedList = []
        vm.returnLines = []
        vm.token = $localStorage.authenticationToken;
        // 生成退货单按钮权限
        Principal.hasAuthority('ROLE_PURCHASE_ORDER_RETURN').then(function (data) {
            vm.hasReturnBtnAuth = data
        });
        console.log(vm.hasReturnBtnAuth);
        vm.purchaseOrder = entity;
        vm.suppliers = Supplier.getAll();
        vm.update = true;
        $q.all([vm.purchaseOrder.$promise,vm.suppliers.$promise]).then(function(){
            if(vm.purchaseOrder.status != 'New'){
                vm.update = false;
            }
            init();
        });

        function init() {
            if(vm.purchaseOrder.type =='Outsourcing'){
                vm.warehousis = Depository.getAll({type: 'product'});
            }else if(vm.purchaseOrder.type =='RawMaterial'){
                vm.warehousis = Depository.getAll({type: "accessories"});
            }else{
                vm.warehousis = Depository.getAll({type: null});
            }

            vm.deliveryDate = vm.purchaseOrder.deliveryDate == null ? null : vm.purchaseOrder.deliveryDate.substr(0, 10);
            $q.all([vm.warehousis.$promise]).then(function(){
                vm.warehousis = vm.warehousis.filter(function(item){return item.defaulted}); //仅展示有效仓库
                getProduct(function (){
                    if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
                        // 为了选择sku时的优化  将已删除的商品单拿出来  避免污染正在选择的商品及sku
                        var _tempList = []
                        vm.purchaseOrder.purchaseProductLines.forEach(function(itm){
                            if(itm.cancelled){
                                vm.deletedList.push(itm)
                            }else{
                                _tempList.push(itm)
                            }
                        })
                        vm.purchaseOrder.purchaseProductLines = _tempList

                        var _ids = []
                        vm.purchaseOrder.purchaseProductLines.forEach(function (line){
                            if(vm.purchaseOrder.status == 'AlreadyIssued' && !line.warehousingNum){
                                line.warehousingNum = line.num;
                            }
                            $scope.selectPurchaseProduct(line)
                            if(!line.propertyConfigId && line.propertyConfigSku && line.propertyConfigs && line.propertyConfigs.length>0){
                                for(var i=0; i<line.propertyConfigs.length; i++){
                                    if(line.propertyConfigSku == line.propertyConfigs[i].sku && line.propertyConfigNumber == line.propertyConfigs[i].number){
                                        line.propertyConfigId=line.propertyConfigs[i].id;
                                        _ids.push(line.propertyConfigs[i].id)
                                        break
                                    }
                                }
                            }
                        })
                        setOptions(_ids)
                    }
                })
            });
            // 获取采购单对应的退货单
            if(vm.purchaseOrder.id){
                PurchaseOrderReturn.queryTable({orderNumber:vm.purchaseOrder.number,status:'Finished',available:false,page:0,size:9999},function(res){
                    vm.returnLines = res
                    vm.returnTotalCount = 0
                    vm.returnTotalAmount = 0
                    res.forEach(function(item){
                        vm.returnTotalCount = calcDecimals(vm.returnTotalCount,item.quantity)
                        vm.returnTotalAmount = calcDecimals(vm.returnTotalAmount,item.amount)
                    })
                })
            }
        }
        // 解决小数相加时精度缺失问题
        function calcDecimals(a, b) {
            var c = Math.max(getDecimalLength(a), getDecimalLength(b));
            var d = Math.pow(10, c);
            return (a * d + b * d) / d;
          }

        function getDecimalLength(num) {
            if(num){
                var str = num.toString();
                if (str.indexOf('.') !== -1) {
                return str.length - str.indexOf('.') - 1;
                } else {
                return 0;
                }
            }else{
                return 0
            }
        }

        // 筛选掉选过的option
        function setOptions(propertyConfigIds){
            vm.purchaseOrder.purchaseProductLines.forEach(function(item,idx){
                // 把除当前propertyConfigId的item筛选出来
                var ids1 = propertyConfigIds.filter(function(ids){
                    return ids !== item.propertyConfigId
                })
                // 去掉所有已选择的propertyConfigId 的item
                var _filteredArray = item.propertyConfigs.filter(function(item) {
                    var _idx0 = ids1.findIndex(function (itm){
                        return item.id == itm
                    })
                    return _idx0 == -1 && !item.cancelled
                });
                item.propertyConfigs = _filteredArray
            })
        }

        function getProduct(callback){
            if(vm.purchaseOrder.type == 'Outsourcing'){
                vm.products = Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]});
            }else{
                vm.products = Product.getAllByCondition({items:[{key:"category",op:"=",value:'MaterialProduct'}]});
            }
            if(callback){
                $q.all([vm.products.$promise]).then(function(){
                    callback();
                });
            }
        }


        $scope.selectStatus = function(){
            if(vm.purchaseOrder.type =='Outsourcing'){
                Depository.getAll({type: 'product'},function(res){
                    vm.warehousis =  res.filter(function(item){
                        return item.defaulted
                    })
                });
            }else if(vm.purchaseOrder.type =='RawMaterial'){
                Depository.getAll({type: 'accessories'},function(res){
                    vm.warehousis =  res.filter(function(item){
                        return item.defaulted
                    })
                });
            }else{
                Depository.getAll({type: null},function(res){
                    vm.warehousis =  res.filter(function(item){
                        return item.defaulted
                    })
                });
            }
            getProduct(function (){
                vm.purchaseOrder.purchaseProductLines = [];
            })
        };

        //去掉选中入库之后的sku null
        $scope.selectPurchaseProduct = function(data){
            data.propertyConfigs=[];
            data.propertyConfigId=null;
            if(data.productId){
                for(var i=0; i<vm.products.length; i++){
                    if(data.productId == vm.products[i].id){
                        data.propertyConfigs=vm.products[i].propertyConfigs;
                        data.measurementName=vm.products[i].measurementName;
                        data.measurementId=vm.products[i].measurementId;
                        data.productName=vm.products[i].name;
                        break
                    }
                }
            }
            //筛选出其他行上选择同商品下的sku 并对当前商品的skuList重新赋值
            var arr = []
            vm.purchaseOrder.purchaseProductLines.forEach(function(item){
                if(item.productId == data.productId && item.propertyConfigId){
                    arr.push(item.propertyConfigId)
                }
            })
            var filteredArray = data.propertyConfigs.filter(function(item) {
                var _idx = arr.findIndex(function (itm){
                    return item.id == itm
                })
                return _idx == -1 && !item.cancelled;
            });
            data.propertyConfigs = filteredArray
        };
        // 选择sku时 更新非当前行上的其他同一商品的skuList
        $scope.selectPurchaseProductSku = function(data,index){
            // scm编号赋值
            data.propertyConfigs.forEach(function(cfg){
                if(cfg.id == data.propertyConfigId){
                    data.propertyConfigNumber  = cfg.number
                }
            })
            // 过滤sku下拉选框
            var propertyConfigIds = []
            vm.purchaseOrder.purchaseProductLines.forEach(function(item,idx){
                if(index !== idx){
                    if(item.productId == data.productId){
                        // 收集所有propertyConfigId
                        vm.purchaseOrder.purchaseProductLines.forEach(function(line){
                            propertyConfigIds.push(line.propertyConfigId)
                        })
                        // 赋值赋值全量propertyConfigs
                        for(var i=0; i<vm.products.length; i++){
                            if(item.productId == vm.products[i].id){
                                item.propertyConfigs=vm.products[i].propertyConfigs;
                                break
                            }
                        }
                        // 把除当前propertyConfigId的item筛选出来
                        propertyConfigIds = propertyConfigIds.filter(function(ids){
                            return ids !== item.propertyConfigId
                        })

                        // 去掉所有已选择的propertyConfigId 的item
                        var _filteredArray = item.propertyConfigs.filter(function(item) {
                            var _idx1 = propertyConfigIds.findIndex(function (itm){
                                return item.id == itm
                            })
                            return _idx1 == -1 && !item.cancelled
                        });
                        item.propertyConfigs = _filteredArray
                    }
                }
            })
        };

        function productAdd() {
            if(!vm.purchaseOrder.type){
                MessageService.error("请选择采购类型");
                return
            }
            if (vm.purchaseOrder.purchaseProductLines == undefined) {
                vm.purchaseOrder.purchaseProductLines = [];
            }
            var purchaseProductLine = {
                productId:null,
                num: 0,
                price: 0,
                tax: vm.taxRate || 0,
                propertyConfigId:null,
                propertyConfigs: [],
            };
            vm.purchaseOrder.purchaseProductLines.push(purchaseProductLine);
        }

        function productDelete(record,index) {
            // 删除时如果当前行选择了sku 则把此项sku加入到其他行的skuList中
            if(record.propertyConfigId){
                var currentSku = record.propertyConfigs.find(function(config){
                    return config.id == record.propertyConfigId
                })
                vm.purchaseOrder.purchaseProductLines.forEach(function(item,idx){
                    if(item.productId == record.productId){
                        item.propertyConfigs.push(currentSku)
                    }
                })
            }
            var _data = JSON.parse(JSON.stringify(vm.purchaseOrder.purchaseProductLines))
            if(_data[index].id){
                _data[index].cancelled = true;
                vm.deletedList.push(_data[index])
                _data.splice(index, 1);
            }else{
                _data.splice(index, 1);
            }
            vm.purchaseOrder.purchaseProductLines = _data
        }

        // 默认入库，需要考虑商品的类型
        function getWarehouse() {
            if(vm.purchaseOrder.warehouseId){
                vm.warehousis.forEach(function (item){
                    if(item.id == vm.purchaseOrder.warehouseId){
                        vm.purchaseOrder.warehouseName = item.name;
                        vm.purchaseOrder.warehouseType = item.type;
                        vm.purchaseOrder.contacts = item.contacts;
                        vm.purchaseOrder.phone = item.phone;
                        vm.purchaseOrder.address = item.province + item.city + item.district + item.address;
                    }
                })
            }else{
                vm.purchaseOrder.warehouseName = null;
                vm.purchaseOrder.warehouseType = null;
                vm.purchaseOrder.contacts = null;
                vm.purchaseOrder.phone = null;
                vm.purchaseOrder.address = null;
            }
        }

        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }

        $scope.save = function(saveAndSubmit,callback){
            if(vm.isSaving){return }
            if (!vm.purchaseOrder.supplierId) {
                MessageService.error("请选择供应商");
                return false;
            }
            if (vm.purchaseOrder.type == null || vm.purchaseOrder.type == '') {
                MessageService.error("请选择采购类型");
                return false;
            }

            var deliveryDate = getDate($('#startDate').val() + " 23:59:59");
            vm.purchaseOrder.deliveryDate = deliveryDate;
            if (vm.purchaseOrder.deliveryDate == null || vm.purchaseOrder.deliveryDate == '') {
                MessageService.error("请选择计划交期");
                return false;
            }
            if (!vm.purchaseOrder.warehouseId) {
                MessageService.error("请选择默认入库");
                return false;
            }
            if (vm.purchaseOrder.contacts == null || vm.purchaseOrder.contacts == '') {
                MessageService.error("请输入联系人");
                return false;
            }
            if (vm.purchaseOrder.phone == null || vm.purchaseOrder.phone == '') {
                MessageService.error("请输入联系电话");
                return false;
            }
            if (vm.purchaseOrder.address == null || vm.purchaseOrder.address == '') {
                MessageService.error("请输入收货地址");
                return false;
            }
            if (vm.purchaseOrder.freight === null || vm.purchaseOrder.freight === '' || vm.purchaseOrder.freight < 0) {
                MessageService.error("请输入运费");
                return false;
            }
            if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
                var purchaseProductLines = [];
                vm.deletedList.forEach(function(delItem){
                    vm.purchaseOrder.purchaseProductLines.push(delItem)
                })
                vm.purchaseOrder.purchaseProductLines.forEach(function (item){
                    if(!item.cancelled){
                        purchaseProductLines.push(item)
                    }
                })
                if (purchaseProductLines.length == 0) {
                    MessageService.error("商品信息不能为空");
                    return false;
                }
                for (var i = 0; i < vm.purchaseOrder.purchaseProductLines.length; i++) {
                    var purchaseProductLine = vm.purchaseOrder.purchaseProductLines[i];
                    if(!purchaseProductLine.cancelled){
                        if (!purchaseProductLine.productId || !purchaseProductLine.propertyConfigId) {
                            MessageService.error("商品信息中的商品选择不完整");
                            return false;
                        }
                        if (purchaseProductLine.num == null || purchaseProductLine.num <= 0) {
                            MessageService.error("请输入商品信息中的数量");
                            return false;
                        }
                        if (purchaseProductLine.price == null) {
                            MessageService.error("请输入商品信息中的单价");
                            return false;
                        }

                        if (purchaseProductLine.tax === null || purchaseProductLine.tax === '' || purchaseProductLine.tax < 0) {
                            MessageService.error("请输入商品信息中的税率");
                            return false;
                        }
                        vm.purchaseOrder.purchaseProductLines[i].total = (purchaseProductLine.num * purchaseProductLine.price).toFixed(2);
                        vm.purchaseOrder.purchaseProductLines[i].taxPrice = ((purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price).toFixed(4);
                        vm.purchaseOrder.purchaseProductLines[i].taxTotal = vm.purchaseOrder.purchaseProductLines[i].taxPrice * purchaseProductLine.num;
                    }
                }

            }else {
                MessageService.error("商品信息不能为空");
                return false;
            }

            vm.isSaving = true;
            if(saveAndSubmit){
                PurchaseOrder.saveAndSubmit(vm.purchaseOrder, function(res){
                    vm.isSaving = false;
                    MessageService.success('新建采购成功！');
                    $scope.cancelSave();
                },function(error){
                    vm.isSaving = false;
                    MessageService.error('新建采购失败');
                });
            }else{
                if(vm.purchaseOrder.status == 'AlreadyIssued'){
                    PurchaseOrder.changeWarehousingNum(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        MessageService.success('保存成功！');
                        $scope.cancelSave();
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('编辑采购失败');
                    });
                    return
                }
                if(vm.purchaseOrder.id){
                    PurchaseOrder.update(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        if(callback){
                            callback()
                        }else{
                            MessageService.success('编辑采购成功！');
                            $scope.cancelSave();
                        }
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('编辑采购失败');
                    });
                }else{
                    PurchaseOrder.save(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        if(callback){
                            callback()
                        }else{
                            MessageService.success('新建采购成功！');
                            $scope.cancelSave();
                        }
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('新建采购失败');
                    });
                }
            }
        };

        //导出
        $scope.export = function () {
            $http({
                url: 'api/purchaseOrder/exportDetail/'+vm.purchaseOrder.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "采购单"+ vm.purchaseOrder.number + '_' +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $scope.cancelSave = function() {
            history.back();
        }

        $scope.getSupplier = function() {
            vm.purchaseOrder.supplierName = null;
            vm.taxRate = 0;
            if(vm.purchaseOrder.supplierId){
                vm.suppliers.forEach(function (item){
                    if(item.id == vm.purchaseOrder.supplierId){
                        vm.purchaseOrder.supplierName =item.name;
                        vm.taxRate = item.taxRate;
                    }
                })
            }
            if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
                vm.purchaseOrder.purchaseProductLines.forEach(function (item){
                    item.tax = vm.taxRate;
                })
            }
        }
        //通过或拒绝
        $scope.audit = function (item){
            if(!item){
                MessageService.confirm("是否审核拒绝", function () {
                    PurchaseOrder.changeState({ids:vm.purchaseOrder.id,state:'Close'}, function(res){
                        if(res.state == 400){
                            MessageService.error(res.message || '拒绝失败');
                            return
                        }
                        MessageService.success('已拒绝');
                        $scope.cancelSave();
                    },function(error){
                        MessageService.error('拒绝失败');
                    });
                });
            }else{
                MessageService.confirm("确认审核通过", function () {
                    PurchaseOrder.changeState({ids:vm.purchaseOrder.id,state:'AlreadyIssued'}, function(res){
                        if(res.state == 400){
                            MessageService.error(res.message || '通过失败');
                            return
                        }
                        MessageService.success('已通过');
                        $scope.cancelSave();
                    },function(error){
                        MessageService.error('通过失败');
                    });
                });
            }
        }
        //关闭
        $scope.close = function (){
            MessageService.confirm("确认关闭当前采购单", function () {
                PurchaseOrder.changeState({ids:vm.purchaseOrder.id,state:'Close'}, function(res){
                    if(res.state == 400){
                        MessageService.error(res.message || '拒绝失败');
                        return
                    }
                    MessageService.success('已拒绝');
                    $scope.cancelSave();
                },function(error){
                    MessageService.error('拒绝失败');
                });
            });
        }
        $scope.numChange = function (purchaseProductLine){
            purchaseProductLine.warehousingNum = purchaseProductLine.num;
            $scope.currentItemChange(purchaseProductLine)
        }
        $scope.currentItemChange = function (purchaseProductLine){
            // 限制用户只能输入两位小数
            if(purchaseProductLine.price){
                var value = purchaseProductLine.price;
                var regex = /^(\d+(\.\d{0,4})?)$/;
                if (!regex.test(value)) {
                    var parts = String(value).split('.')
                    if (parts[1].length > 4) {
                        value = parts[0] + '.' + parts[1].substring(0, 4);
                    }
                    purchaseProductLine.price = Number(value)
                }
            }
            purchaseProductLine.taxPrice = ((purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price).toFixed(4)
            purchaseProductLine.taxTotal = purchaseProductLine.taxPrice * purchaseProductLine.num
        }
        //登记入库
        $scope.changeWarehousingNum = function (data){
            $uibModal.open({
                templateUrl: 'app/purchase/warehousing.html',
                controller: 'WarehousingController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return {
                            purchaseOrder:vm.purchaseOrder,
                            purchaseOrderList:data
                        };
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.purchaseOrder = result;
                    init();
                }
            });
        }
        //完成入库
        $scope.constraint = function (){
            MessageService.confirm("确认完成入库", function () {
                vm.isSaving = true;
                PurchaseOrder.changeWarehousingNum(vm.purchaseOrder, function(res){
                    PurchaseOrder.changeState({ids: vm.purchaseOrder.id, state: 'compulsoryWarehousing'}, function (data) {
                        MessageService.success('采购订单完成入库成功！');
                        $scope.cancelSave();
                        vm.isSaving = false;
                    }, function (error) {
                        MessageService.error('采购订单完成入库失败！');
                        vm.isSaving = false;
                    });
                },function(error){
                    vm.isSaving = false;
                    MessageService.error('编辑采购失败');
                });
            });
        }
        $scope.purchaseOrderType = function (item){
            switch (item) {
                case 'New':
                    return {
                        text:'待提交',
                        color:'#333'
                    };
                case 'ToBeAudited':
                    return {
                        text:'待审核',
                        color:'#ffa037'
                    };
                case 'ToBeRevised':
                    return {
                        text:'已关闭',
                        color:'#333'
                    };
                case 'AlreadyIssued':
                    return {
                        text:'未入库',
                        color:'#ff0000'
                    };
                case 'Store':
                    return {
                        text:'部分入库',
                        color:'#51de37'
                    };
                case 'Finished':
                    return {
                        text:'已完成',
                        color:'#005eff'
                    };
                case 'Examined':
                    return {
                        text:'审核通过',
                        color:'#333'
                    };
                default:
                    return {
                        text:item,
                        color:'#333'
                    };
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasingApplication', {
                parent: 'module',
                url: '/purchasingApplication',
                data: {
                    authorities: ['ROLE_PURCHASE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchasingApplication.html',
                        controller: 'PurchasingApplicationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchasingApplicationAdd', {
                parent: 'module',
                url: '/purchasingApplicationPage/{id}',
                data: {
                    authorities: ['ROLE_PURCHASE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchasingApplicationPage.html',
                        controller: 'PurchasingApplicationPageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrder', function($stateParams, PurchaseOrder) {
                        return PurchaseOrder.get({id: $stateParams.id});
                    }]
                }
            })
            .state('purchaseProductLine', {
                parent: 'module',
                url: '/purchaseProductLine?number&supplierId&status&warehouseId&page&size&startDate&endDate&dateType&available',
                data: {
                    authorities: ['ROLE_PURCHASE_LIST']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseOrder.html',
                        controller: 'PurchaseController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchaseProductLineAdd', {
                parent: 'module',
                url: '/purchaseProductLineAdd',
                data: {
                    authorities: ['ROLE_PURCHASE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseOrder-edit.html',
                        controller: 'PurchaseOrderEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            supplier: null,
                            type: '',
                            status: 'New',
                            deliveryDate: null,
                            warehouse: null,
                            contacts: '',
                            phone: '',
                            address: '',
                            freight: '',
                            purchaseProductLines: null
                        };
                    }
                }
            })
            .state('purchaseProductLineEdit', {
                parent: 'module',
                url: '/purchasingApplicationEdit/{id}',
                data: {
                    authorities: ['ROLE_PURCHASE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseOrder-edit.html',
                        controller: 'PurchaseOrderEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrder', function($stateParams, PurchaseOrder) {
                        return PurchaseOrder.constructOrderByDemand({ids: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('purchaseProductLineEdit1', {
                parent: 'module',
                url: '/purchasingApplicationEdit1/{id}',
                data: {
                    authorities: ['ROLE_PURCHASE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseOrder-edit.html',
                        controller: 'PurchaseOrderEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrder', function($stateParams, PurchaseOrder) {
                        return PurchaseOrder.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('purchasePreview', {
                parent: 'module',
                url: '/purchasePreview/{id}',
                data: {
                    authorities: ['ROLE_PURCHASE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseOrder-preview.html',
                        controller: 'PurchaseOrderPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrder', function($stateParams, PurchaseOrder) {
                        return PurchaseOrder.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('purchaseReturnOrder', {
                parent: 'module',
                url: '/purchaseReturnOrder?number&orderNumber&supplierId&status&warehouseId&page&size&startDate&endDate&dateType&available',
                data: {
                    authorities: ['ROLE_PURCHASE_ORDER_RETURN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseReturnOrder/purchaseReturnOrder.html',
                        controller: 'PurchaseReturnOrderController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchaseReturnOrderAdd', {
                parent: 'module',
                url: '/purchaseReturnOrderAdd?purchaseOrderId',
                data: {
                    authorities: ['ROLE_PURCHASE_ORDER_RETURN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseReturnOrder/purchaseReturnOrder-edit.html',
                        controller: 'PurchaseReturnOrderEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrderReturn', function($stateParams, PurchaseOrderReturn) {
                        return PurchaseOrderReturn.constructOrderByPurchaseOrder({id: $stateParams.purchaseOrderId}).$promise;
                    }]
                }
            })
            .state('purchaseReturnOrderEdit', {
                parent: 'module',
                url: '/purchaseReturnOrderEdit/{id}',
                data: {
                    authorities: ['ROLE_PURCHASE_ORDER_RETURN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseReturnOrder/purchaseReturnOrder-edit.html',
                        controller: 'PurchaseReturnOrderEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrderReturn', function($stateParams, PurchaseOrderReturn) {
                        return PurchaseOrderReturn.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('purchaseReturnOrderPreview', {
                parent: 'module',
                url: '/purchaseReturnOrderPreview/{id}',
                data: {
                    authorities: ['ROLE_PURCHASE_ORDER_RETURN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/purchase/purchaseReturnOrder/purchaseReturnOrder-preview.html',
                        controller: 'PurchaseReturnOrderPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchaseOrderReturn', function($stateParams, PurchaseOrderReturn) {
                        return PurchaseOrderReturn.get({id: $stateParams.id}).$promise;
                    }]
                }
            });;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('PurchaseOrder', PurchaseOrder)
        .factory('PurchaseProductLine', PurchaseProductLine)
        .factory('PurchaseOrderReturn', PurchaseOrderReturn);

    PurchaseOrder.$inject = ['$resource'];
    PurchaseProductLine.$inject = ['$resource'];
    PurchaseOrderReturn.$inject = ['$resource'];

    function PurchaseOrder ($resource) {
        var resourceUrl =  'api/purchaseOrder/:path/:id';

        return $resource(resourceUrl, {}, {
            'changeWarehousingNum': {
                method: 'PUT',
                params: {
                    path: 'changeWarehousingNum'
                }
            },
            'saveAndSubmit': {
                method: 'POST',
                params: {
                    path: 'saveAndSubmit'
                }
            },
            'changeState': {
                method: 'GET',
                params: {
                    path: 'changeState'
                }
            },
            'createOrderByDemand': {
                method: 'POST',
                params: {
                    path: 'createOrderByDemand'
                }
            },
            'constructOrderByDemand': { method: 'GET',
                params: {
                    path: 'constructOrderByDemand'
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    id:"byCondition"
                },
                isArray: true
            },
            'query': { method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'queryTable': { method: 'GET',
                isArray: true,
                params: {
                    path: 'query'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'cancelled': {
                method: 'GET',
                params: {
                    path: 'cancelled'
                }
            },
            'changeStatue': {
                method: 'GET',
                params: {
                    path: 'changeStatue'
                }
            },
            'createPurchaseOrder': {
                method: 'GET',
                params: {
                    path: 'createPurchaseOrder'
                }
            }
        });
    };

    function PurchaseProductLine ($resource) {
        var resourceUrl =  'api/purchaseProductLine/:path/:id';

        return $resource(resourceUrl, {}, {
            'cancelDemand': { method: 'GET',
                params: {
                    path: 'cancelDemand'
                }
            },
            'examineOrder': { method: 'GET',
                params: {
                    path: 'examineOrder'
                }
            },
            'demandPage': { method: 'GET',
                isArray: true,
                params: {
                    path: 'demandPage'
                }
            },
            'query': { method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'changeState': {
                method: 'GET',
                params: {
                    path: 'changeState'
                }
            },
            'changeWarehousingNum': {
                method: 'GET',
                params: {
                    path: 'changeWarehousingNum'
                }
            },
            'cancelled': {
                method: 'GET',
                params: {
                    path: 'cancelled'
                }
            }
        });
    };
    function PurchaseOrderReturn ($resource) {
        var resourceUrl =  'api/purchase-order-returns/:path/:id';

        return $resource(resourceUrl, {}, {
            'constructOrderByPurchaseOrder': { method: 'GET',
                params: {
                    path: 'constructOrderByPurchaseOrder'
                }
            },
            'saveAndSubmit': {
                method: 'POST',
                params: {
                    path: 'saveAndSubmit'
                }
            },
            'queryTable': { method: 'GET',
                isArray: true,
                params: {
                    path: 'query'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'approve': { method: 'GET',
                params: {
                    path: 'approve'
                }
            },
            'reject': { method: 'GET',
                params: {
                    path: 'reject'
                }
            },
            'close': { method: 'GET',
                params: {
                    path: 'close'
                }
            },
            'examineOrder': { method: 'GET',
                params: {
                    path: 'examineOrder'
                }
            },
            'demandPage': { method: 'GET',
                isArray: true,
                params: {
                    path: 'demandPage'
                }
            },
            'query': { method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'changeState': {
                method: 'GET',
                params: {
                    path: 'changeState'
                }
            },
            'changeWarehousingNum': {
                method: 'GET',
                params: {
                    path: 'changeWarehousingNum'
                }
            },
            'cancelled': {
                method: 'GET',
                params: {
                    path: 'cancelled'
                }
            }
        });
    };
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseController', PurchaseController);

    PurchaseController.$inject = ['$scope', 'Principal', '$state', '$location', 'MessageService', 'PurchaseOrder', 'ParseLinks', '$uibModal', '$timeout', '$stateParams',
        'Supplier','Depository','DateUtils', '$localStorage','$http'];

    function PurchaseController ($scope, Principal, $state, $location, MessageService, PurchaseOrder, ParseLinks, $uibModal, $timeout, $stateParams,
                                 Supplier,Depository,DateUtils, $localStorage, $http) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PURCHASE_LIST').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;

        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.selection = [
            {name:'全部', value:''},
            {name:'待提交', value:'New'},
            {name:'待审核', value:'ToBeAudited'},
            {name:'未入库', value:'AlreadyIssued'},
            // {name:'部分入库', value:'Store'},
            {name:'已完成', value:'Finished'},
            {name:'已关闭', value:'Close'}
        ];
        var _startDate = $stateParams.startDate || ''
        var _endDate = $stateParams.endDate || ''
        angular.element("#startDate").val(_startDate);
        angular.element("#endDate").val(_endDate);

        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: Number($stateParams.size) || 20,
            number:Number($stateParams.number) || '',
            supplierId:Number($stateParams.supplierId) || '',
            warehouseId:Number($stateParams.warehouseId) || '',
            sort: ['createdDate,DESC'],
            status:$stateParams.status || ''
        };
        vm.dateType = $stateParams.dateType || 'purchase'
        vm.suppliers = Supplier.getAll();
        Depository.getAll({},function(res){
            vm.warehouses = res.filter(function(item){return item.defaulted});
        });

        //获取选中的数组
        $scope.checked =[];
        $scope.selectOne = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.tableList.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
        };

        // 提交
        $scope.submission = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }
            var ids = '';
            for (var i = 0; i < $scope.checked.length; i++) {
                if ($scope.checked[i].state == 'New') {
                    ids += $scope.checked[i].id + ",";
                }else{
                    MessageService.error('请选择新建的采购单');
                    return;
                }
            }
            ids = ids.substr(0, ids.length - 1);
            PurchaseProductLine.changeState({ids: ids, state: 'ToBeAudited'}, function (data) {
                MessageService.success('采购订单提交成功！');
                init();
            }, function (error) {
                MessageService.error('采购订单提交失败！');
            });
        }

        $scope.compulsoryWarehousing = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }
            var ids = '';
            for (var i = 0; i < $scope.checked.length; i++) {
                if ($scope.checked[i].state == 'AlreadyIssued') {
                    ids += $scope.checked[i].id + ",";
                }
            }

            ids = ids.substr(0, ids.length - 1);
            PurchaseProductLine.changeState({ids: ids, state: 'compulsoryWarehousing'}, function (data) {
                MessageService.success('采购订单强制入库成功！');
                init();
            }, function (error) {
                MessageService.error('采购订单强制入库失败！');
            });
        }

        //新建
        $scope.newOrder = function(){
            $uibModal.open({
                templateUrl: 'app/purchase/purchaseOrder-add.html',
                controller: 'PurchaseOrderAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return null;
                    }
                }
            }).result.then(function(result){
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                init();
            });
        };


        //入库
        $scope.warehousing = function() {
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }
            if ($scope.checked.length > 1) {
                MessageService.error('请选择一项添加入库数量');
                return;
            }
            if ($scope.checked[0].state != 'AlreadyIssued'){
                MessageService.error('请选择一项已下达的订购添加入库数量');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/purchase/warehousing.html',
                controller: 'WarehousingController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return $scope.checked;
                    }
                }
            }).result.then(function(result){
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                init();
            });

        };

        $scope.toExamine = function() {
            if($scope.checked.length == 0){
                MessageService.error('请选择列表项');
                return;
                if (vm.purchaseOrderList[i].state == 'ToBeAudited'||vm.purchaseOrderList[i].state == 'ToBeRevised') {}
            }
            var _data = [];
            for (var i = 0; i < $scope.checked.length; i++) {
                if ($scope.checked[i].state == 'ToBeAudited' || $scope.checked[i].state == 'ToBeRevised') {
                    _data.push($scope.checked[i]);
                }else{
                    MessageService.error('请选择待审核或者待修订的采购单');
                    return;
                }
            }

            $uibModal.open({
                templateUrl: 'app/purchase/toExamine.html',
                controller: 'ToExamineController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return _data;
                    }
                }
            }).result.then(function(result){
                angular.forEach(vm.tableList, function (item) {
                    item.checked = false;
                });
                init();
            });
        }

        $scope.cancelledBtn = function() {
            if($scope.checked.length == 0){
                MessageService.error('请选择列表项');
                return;
            }

            var ids = '';
            for (var i = $scope.checked.length - 1; i >= 0; i--) {
                if ($scope.checked[i].state == 'AlreadyIssued') {
                    MessageService.error('已下达采购不能取消');
                    return;
                }
                ids += $scope.checked[i].id + ",";
            }
            ids = ids.substr(0, ids.length - 1);

            PurchaseProductLine.cancelled({ids:ids}, function(){
                MessageService.success('取消成功');
                init();
            }, function(){
                MessageService.error('取消失败');
            })
        }

        //导出明细表
        $scope.exportDetails = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            var url ='api/purchaseOrder/exportList?number='+ vm.tableData.number + '&available=' + false  + '&supplierId=' + vm.tableData.supplierId + '&warehouseId=' + vm.tableData.warehouseId +  '&status=' + vm.tableData.status
            if(vm.dateType === 'purchase'){
                url += '&startDate=' + vm.tableData.startDate + '&endDate=' + vm.tableData.endDate
            }else if(vm.dateType === 'store'){
                url += '&startStoredDate=' + vm.tableData.startDate + '&endStoredDate=' + vm.tableData.endDate
            }
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "采购单" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        //导出统计表
        $scope.export = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            var url ='api/purchaseOrder/exportStatistics?number='+ vm.tableData.number + '&available=' + false  + '&supplierId=' + vm.tableData.supplierId + '&warehouseId=' + vm.tableData.warehouseId +  '&status=' + vm.tableData.status
            if(vm.dateType === 'purchase'){
                url += '&startDate=' + vm.tableData.startDate + '&endDate=' + vm.tableData.endDate
            }else if(vm.dateType === 'store'){
                url += '&startStoredDate=' + vm.tableData.startDate + '&endStoredDate=' + vm.tableData.endDate
            }
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "采购单" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        var _h = angular.element(".table-top").find(".table-state").height();
        if(_h > 40){
            vm.isTableState = true;
        }else {
            vm.isTableState = false;
        }

        init();
        function init() {
            vm.tableList = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $scope.checked = [];
            $scope.select_all = false;
            var items = [];
            var _p = {
                items:items,
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
            }
            if(vm.tableData.status){
                items.push({key:"status",op:"=",value:vm.tableData.status})
                // if(vm.tableData.status != 'Close'){
                //     items.push({key:"status",op:"=",value:vm.tableData.status})
                // }else{
                //     items.push({key:"cancelled",op:"=",value:true})
                //     _p.available = false;
                // }
            }
            if(vm.tableData.number){
                items.push({key:"number",op:"=",value:vm.tableData.number})
            }
            if(vm.tableData.supplierId){
                items.push({key:"supplier.id",op:"=",value:vm.tableData.supplierId})
            }
            if(vm.tableData.warehouseId){
                items.push({key:"warehouse.id",op:"=",value:vm.tableData.warehouseId})
            }
            if(vm.tableData.startDate){
                items.push({
                    "key": 'startDate',
                    "op": ">=",
                    "value": DateUtils.dayStart(vm.tableData.startDate)
                })
            }
            if(vm.tableData.endDate){
                items.push({
                    "key": 'endDate',
                    "op": "<=",
                    "value": DateUtils.dayEnd(vm.tableData.endDate)
                })
            }
            _p.items = items;
            var _p1 = {
                number:vm.tableData.number,
                supplierId:vm.tableData.supplierId,
                status:vm.tableData.status,
                warehouseId:vm.tableData.warehouseId,
                page:vm.tableData.page,
                size:vm.tableData.size,
                available:false,
                sort:vm.tableData.sort
            }
            if(vm.dateType === 'purchase'){
                _p1.startDate = vm.tableData.startDate
                _p1.endDate = vm.tableData.endDate
            }else if(vm.dateType === 'store'){
                _p1.startStoredDate = vm.tableData.startDate
                _p1.endStoredDate = vm.tableData.endDate
            }
            $location.search({
                number:vm.tableData.number,
                supplierId:vm.tableData.supplierId,
                status:vm.tableData.status,
                warehouseId:vm.tableData.warehouseId,
                page:vm.tableData.page,
                size:vm.tableData.size,
                startDate:vm.tableData.startDate,
                endDate:vm.tableData.endDate,
                dateType:vm.dateType,
                available:false,
                // sort:vm.tableData.sort
            });
            PurchaseOrder.queryTable(_p1, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
                console.log(error)
            });
        }

        var nowTime = new Date().getTime();
        $scope.getWarnTime = function(date){
            var time = getDate(date).getTime();
            var dayNum = (time - nowTime) / (1000 * 60 * 60 * 24) - 1;
            dayNum = Math.ceil(dayNum);
            return dayNum;
        }

        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }


        $scope.conditionSelect = function(data){
            vm.tableData.status = data.value;
            vm.tableData.page = 0;
            init();
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                page: Number($stateParams.page) || 0,
                size: 20,
                sort: ['createdDate,DESC'],
                status:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            vm.dateType =  'purchase'
            init();
        };

        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                angular.element(".table-top").height("40");
                angular.element(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                angular.element(".table-top").height("auto");
                angular.element(".table-state-btn").addClass("table-state-btnOn");
            }
        };

        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }
        $scope.purchaseOrderType = function (item){
            switch (item) {
                case 'New':
                    return {
                        text:'待提交',
                        color:'#333'
                    };
                case 'ToBeAudited':
                    return {
                        text:'待审核',
                        color:'#ffa037'
                    };
                case 'Close':
                    return {
                        text:'已关闭',
                        color:'#333'
                    };
                case 'AlreadyIssued':
                    return {
                        text:'未入库',
                        color:'#ff0000'
                    };
                case 'Store':
                    return {
                        text:'部分入库',
                        color:'#51de37'
                    };
                case 'Finished':
                    return {
                        text:'已完成',
                        color:'#005eff'
                    };
                case 'Examined':
                    return {
                        text:'审核通过',
                        color:'#333'
                    };
                default:
                    return {
                        text:item,
                        color:'#333'
                    };
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProjectOrderController', ProjectOrderController);

    ProjectOrderController.$inject = ['$scope', '$state','MessageService','$uibModalInstance','msgdata', 'Project'];

    function ProjectOrderController ($scope, $state,MessageService,$uibModalInstance,msgdata, Project) {
        var vm = this;

        Project.detail({id: msgdata[0]},function(res){
            console.log(res)
            vm.data = res;
        });

        //保存
        $scope.save = function () {
            if(!vm.data.contact){
                MessageService.error("联系人不能为空");
                return
            }
            if(!vm.data.phone){
                MessageService.error("联系方式不能为空");
                return
            }
            // var myreg=/^[1][3,4,5,6,7,8][0-9]{9}$/;
            // if (!myreg.test(vm.data.phone)) {
            //     MessageService.error("请输入11位符合要求的电话号码");
            //     return;
            // };
            if(!vm.data.address){
                MessageService.error("联系地址不能为空");
                return;
            }
            // if(!vm.data.freight){
            //     MessageService.error("运费不能为空");
            //     return;
            // }
            // if(!vm.data.remarks){
            //     MessageService.error("备注不能为空");
            //     return;
            // }

            vm.isSaving = true;
            var obj={
                id:vm.data.id,
                address: vm.data.address,
                contact: vm.data.contact,
                createdDate:vm.data.createdDate,
                expectedDate:vm.data.expectedDate,
                freight: vm.data.freight,
                lastModifiedDate:vm.data.lastModifiedDate,
                merchant:vm.data.merchant,
                name: vm.data.name,
                number:vm.data.number,
                phone: vm.data.phone,
                productLines:vm.data.productLines,
                remarks:vm.data.remarks,
                status:vm.data.status,
                type:vm.data.type
            };

            Project.order(obj,function(res){
                MessageService.success('订购成功！');
                $uibModalInstance.close();
            },function(error){
                MessageService.success('订购失败！');
            });



        };
        //返回
        $scope.canccel = function () {
            $uibModalInstance.close();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProjectEditController', ProjectEditController);

    ProjectEditController.$inject = ['$scope', '$state', 'MessageService', '$uibModal', 'entity', '$location', '$localStorage', 'Project', 'Merchant',
    '$stateParams', '$filter', '$q', 'LocationProvice', 'LocationCity', 'LocationDistrict', '$http', 'Product'];

    function ProjectEditController ($scope, $state, MessageService, $uibModal, entity, $location, $localStorage, Project, Merchant,
        $stateParams, $filter, $q, LocationProvice, LocationCity, LocationDistrict, $http, Product) {
        var vm = this;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;
        vm.getOrder = getOrder;

        vm.data = entity;
        //商户
        $q.all([vm.data.$promise]).then(function(){
            init();
        });
        function init() {
            // 获取地址
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if (p.name == vm.data.address.split("-")[0]) {
                        vm.province = p;
                        break;
                    }
                }
                vm.districts = [];
                LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                    vm.citys = data;
                    for (var i = vm.citys.length - 1; i >= 0; i--) {
                        var c = vm.citys[i];
                        if (c.name == vm.data.address.split("-")[1]) {
                            vm.city = c;
                            break;
                        }
                    }

                    LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                        vm.districts = data;
                        for (var i = vm.districts.length - 1; i >= 0; i--) {
                            var di = vm.districts[i];
                            if (di.name == vm.data.address.split("-")[2]) {
                                vm.district = di;
                                vm.address = vm.data.address.split(vm.district.name+"-")[1];
                            }
                        }
                    });
                });
            });

            Merchant.getAll(function (res) {
                vm.merchants = res.filter(function (item) {
                    return item.enable
                });

                $q.all([vm.merchants.$promise]).then(function(){
                    vm.expectedDate =  $filter('date')(vm.data.expectedDate, "yyyy-MM-dd");
                    angular.element("#startDate").val(vm.expectedDate);
                    angular.forEach(vm.merchants,function(item){
                        if(vm.data.merchant.id == item.id){
                            vm.merchant = item;
                        }
                    })
                })

            });
        }


        //项目类型
        vm.projectTypes =[
            {name:'标准',id:'Standard'},
            {name:'打样',id:'Proofing'}
        ];
        vm.token = $localStorage.authenticationToken;
        //查看直接点编号进去   编辑只能单选  其他是可以多选的

        var productLine ={
            productName:'选择产品',//订购商品
            productNumber:'',//编号
            unit:'',//单位
            quantity:'',//数量
            price:'',//单价
            taxRate:'',//税率
            amount:'',//合计金额
            taxPrice:'',//含税单价
            taxAmount:'',//加税合计
            filePath:''//上传的文件
        };
        //新建生产
        var flag = false;
        $scope.productLineNew = function(){
            var flag = false;
            if(vm.data.productLines.length >0) {
                angular.forEach(vm.data.productLines, function (item) {
                    if (!item.productName || !item.productNumber || !item.unit || !item.quantity ||!item.filePath) {
                        flag = true;
                    }
                });
            }
            if(flag){
                MessageService.error('请将空白项填写完整再添加！！！！');
            }else{
                productLine ={
                    productName:'选择产品',//订购商品
                    productNumber:'',//编号
                    unit:'',//单位
                    quantity:'',//数量
                    price:'',//单价
                    taxRate:'',//税率
                    amount:'',//合计金额
                    taxPrice:'',//含税单价
                    taxAmount:'',//加税合计
                    filePath:''//上传的文件
                };
                vm.data.productLines.push(angular.copy(productLine));
            }
        };

        $scope.productLineDelete = function(index){
            vm.data.productLines.splice(index,1);
        };

        //选择产品
        $scope.chooseProduct = function(index){
            $uibModal.open({
                templateUrl: 'app/project/chooseProduct.html',
                controller: 'ChooseProductController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(result){
                console.log(result);
                if(result!=undefined){
                    vm.data.productLines[index].productName=result.sku;
                    vm.data.productLines[index].productNumber=result.number;
                    vm.data.productLines[index].unit=result.unit;
                }
            });
        };

        //文件上传  二次上传覆盖之前上传的文件  压缩包里面不能文件夹
        window.uploadFile = function($event) {
            var index=$event.currentTarget.dataset.target;
            if(!vm.data.productLines[index].productNumber){
                MessageService.error('请选择商品！');
                return;
            }
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'pdf' && ext != 'zip'){
                angular.element("#file").val("");
                MessageService.error("只能上传.pdf/.zip类型的文件!");
                return;
            }

            if (fileObj.size > 1024 * 1024 * 1024 * 2) {
                MessageService.error("文件不能大于2GB");
                return;
            }

            checkIfUploaded(fileObj, ext, index);
        };

        function checkIfUploaded (file, ext, index_file) {
            var reader = new FileReader();
            // 用来计算fileMd5值的file内容
            var fileToCountMD5 = file;

            if (file.size > 1024*1024*50) {
                var fileStart = file.slice(0, 1024 * 1024);
                var fileEnd = file.slice(file.size - 1024 * 1024, file.size);
                fileToCountMD5 = new Blob([fileStart,fileEnd], { type: "text/plain" });
            }
            reader.readAsBinaryString(fileToCountMD5);

            //绑定读取失败事件
            reader.onerror = function() {
                MessageService.error("文件读取失败");
            };

            //绑定读取成功事件
            reader.onload = function() {
                //需要引入计算MD5的jar包
                var fileMd5 = hex_md5(reader.result);

                var form = new FormData();
                form.append("fileMd5", fileMd5);
                form.append("fileSize", file.size);

                //校验是否上传过该文件，返回上传进度
                console.log("isFileExist");
                $.ajax({
                    url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/isFileExist",
                    type: "POST",
                    data: form,
                    async: true,        //异步
                    processData: false,  //很重要，告诉jquery不要对form进行处理
                    contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                    success: function(data) {
                        if (data.success) {
                            //文件已上传
                            MessageService.success("上传成功！");
                        } else {
                            //文件未上传或者部分上传
                            uploadBySplit(file, fileMd5, 0, ext, index_file);
                        }
                    },
                    error: function() {
                        MessageService.error("服务器出错!");
                    }
                });
            }
        }

        //分片上传
        function uploadBySplit(file, fileMd5, i, ext, index_file) {
            var splitSize = 1024 * 1024 * 20;   //分片大小20M  -- 20M为一段
            var size = file.size;//总大小
            var splitCount = Math.ceil(size / splitSize);  //总片数

            if (i == splitCount) {
                MessageService.success("文件上传成功！");
                return;
            }

            //计算每一片的起始与结束位置
            var start = i * splitSize;
            var end = Math.min(size, start + splitSize);
            var fileData = file.slice(start,end);
            var reader = new FileReader();
            reader.onload = function(){
                var md5 = hex_md5(reader.result);

                var form = new FormData();
                form.append("fileMd5", fileMd5);
                form.append("size", size);  //总大小
                form.append("totalStr", splitCount);   //总片数
                form.append("indexStr", i);    //当前是第几片
                form.append("md5", md5);    //分片md5

                //判断分片是否上传
                $.ajax({
                    url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/isFileSplitExist",
                    type: "POST",
                    data: form,
                    async: true,        //异步
                    processData: false,  //很重要，告诉jquery不要对form进行处理
                    contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                    success: function(data){
                        if (data.code == 1) {//已上传
                            //上传进度
                            var process = Math.round(end/size*100)+"%";
                            i++;
                            uploadBySplit(file, fileMd5, i, ext, index_file);    // 循环上传
                        } else { //未上传
                            form.append("fileData", fileData);
                            form.append("ext", ext);    // 文件后缀
                            //上传分片
                            $.ajax({
                                url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/upload",
                                type: "POST",
                                data: form,
                                async: true,        //异步
                                processData: false,  //很重要，告诉jquery不要对form进行处理
                                contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                                success: function(data) {
                                    if (data.state == 200) {
                                        //上传进度
                                        $('#progress-bar').css('width', (i / splitCount * 100)  +'%');
                                        i++;
                                        uploadBySplit(file, fileMd5, i, ext, index_file);
                                    } else if (data.state == 300) {
                                        $('#progress-bar').css('width', '0%');
                                        console.log(index_file);
                                        vm.data.productLines[index_file].filePath = data.message;
                                        $scope.$apply();
                                    } else {
                                        $('#progress-bar').css('width', '0%');
                                        MessageService.error("分片上传失败");
                                    }
                                },
                                error: function(XMLHttpRequest, textStatus, errorThrown) {
                                    MessageService.error("服务器出错!");
                                }
                            });
                        }
                    },

                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        MessageService.error("服务器出错!");
                    }
                });
            }
            reader.readAsBinaryString(fileData);
        }

        //文件下载
        $scope.downLoadFile = function (data) {
            $http({
                url: 'api/projects/download',
                method: "GET",
                params: {
                    filePath: data.filePath
                },
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "APPLICATION/pdf"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".pdf";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }


        //保存
        $scope.save = function () {
            // if(!vm.data.name){
            //     MessageService.error("项目名称不能为空");
            //     return false;
            // }
            if(!vm.data.type){
                MessageService.error("项目类型不能为空");
                return false;
            }
            vm.data.merchant =vm.merchant;
            if(!vm.data.merchant){
                MessageService.error("商户不能为空");
                return false;
            }
            vm.expectedDate= angular.copy(angular.element("#startDate").val());
            vm.data.expectedDate = getDate($('#startDate').val() + " 23:59:59");
            // if(!vm.expectedDate){
            //     MessageService.error("预期交货时间不能为空");
            //     return false;
            // }
            if(!vm.data.contact){
                MessageService.error("联系人不能为空");
                return false;
            }
            if(!vm.data.phone){
                MessageService.error("联系方式不能为空");
                return
            }
            // var myreg=/^[1][3,4,5,6,7,8][0-9]{9}$/;
            // if (!myreg.test(vm.data.phone)) {
            //     MessageService.error("请输入11位符合要求的电话号码");
            //     return false;
            // };
            // if(!vm.data.address){
            //     MessageService.error("联系地址不能为空");
            //     return false;
            // }
            if (vm.province == null || vm.province == "") {
                MessageService.error("请选择省份");
                return false;
            };

            if (vm.city == null || vm.city == '') {
                MessageService.error('请选择城市');
                return false;
            }

            if (vm.district == null || vm.district == "") {
                MessageService.error("请选择区县");
                return false;
            };

            if (vm.address == null || vm.address == "") {
                MessageService.error("请输入详细地址");
                return false;
            };
            vm.data.address = vm.province.name + "-" + vm.city.name + "-" + vm.district.name + "-" + vm.address;

            if(!vm.data.freight){
                // MessageService.error("运费不能为空");
                // return false;
                vm.data.freight = 0;
            }

            var ccFlag=true;
            if (vm.data.productLines != null && vm.data.productLines.length > 0) {
                angular.forEach(vm.data.productLines,function(item){
                    if(!item.productNumber && item.productName =='选择产品'){
                        MessageService.error("订购商品不能为空！");
                        ccFlag=false;
                        return false;
                    }
                    if(!item.quantity){
                        MessageService.error("数量不能为空");
                        ccFlag=false;
                        return false;
                    }
                    // if(!item.price){
                    //     MessageService.error("价格不能为空");
                    //     ccFlag=false;
                    //     return false;
                    // }
                    // if(!item.taxRate){
                    //     MessageService.error("税率不能为空");
                    //     ccFlag=false;
                    //     return false;
                    // }
                    if(!item.filePath){
                        MessageService.error("上传文件不能为空");
                        ccFlag=false;
                        return false;
                    }

                    item.amount = item.quantity * item.price;
                    item.taxPrice = (item.price * item.taxRate / 100) + item.price;
                    item.taxAmount = ((item.price * item.taxRate / 100) + item.price) * item.quantity;
                });
            }else{
                MessageService.error("商品信息不能为空");
                return false;
            }

            if(!ccFlag){
                return false;
            }

            vm.isSaving = true;
            Project.update(vm.data, function (res) {
                MessageService.success("保存成功");
                $state.go("project");
            }, function (error) {
                vm.isSaving = false;
                MessageService.error(error.data.message);
            });
        };

        //返回
        $scope.goBack = function () {
            $state.go("project",{
                        id: $stateParams.id,
                        page:$stateParams.page,
                        keyword:$stateParams.keyword
                }
            )
        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

        function getOrder() {
            if(!vm.data.merchant){
                MessageService.error("请选择商户");
                return;
            }
            if(!vm.data.number) {
                MessageService.error("请填写项目编号");
                return;
            }
            Project.getThirdPartyProductByNumber({number: vm.data.number, merchantId: vm.data.merchant.id}, function(res) {
                if (res.orderNumber == null) {
                    MessageService.error("获取订单数据错误");
                    return;
                }

                // 地址数据充填
                vm.data.contact = res.contact;
                vm.data.phone = res.phone;
                vm.address = res.address;
                if (res.province.length == 2) {
                    res.province = res.province + "市";
                    res.city = "市辖区";
                }
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if (p.name == res.province) {
                        vm.province = p;
                        break;
                    }
                }
                vm.districts = [];
                LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                    vm.citys = data;
                    for (var i = vm.citys.length - 1; i >= 0; i--) {
                        var c = vm.citys[i];
                        if (c.name == res.city) {
                            vm.city = c;
                            break;
                        }
                    }

                    LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                        vm.districts = data;
                        for (var i = vm.districts.length - 1; i >= 0; i--) {
                            var di = vm.districts[i];
                            if (di.name == res.district) {
                                vm.district = di;
                            }
                        }
                    });
                });

                // 商品充填
                if (res.supNumber != null) {
                    Product.getBySkuNumber({number: res.supNumber}, function(pro) {
                        if (pro.id != null) {

                            productLine.productName = pro.propertyConfigs[0].sku; //订购商品
                            productLine.productNumber = pro.propertyConfigs[0].number;      //编号
                            productLine.unit = pro.measurementName;               //单位
                            productLine.quantity = parseInt(res.quantity);           //数量

                            var date = new Date();
                            date.setHours(date.getHours() + pro.warningTime);
                            vm.expectedDate = angular.copy(angular.element("#startDate").val());
                            if (vm.expectedDate == '') {
                                vm.expectedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                            }

                            var flag = true;
                            for (var i = vm.data.productLines.length - 1; i >= 0; i--) {
                                if (vm.data.productLines[i].productNumber == productLine.productNumber) {
                                    flag = false;
                                }
                            }
                            if (flag) {
                                vm.data.productLines.push(productLine);
                            }
                        }
                    })
                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProjectDetailController', ProjectDetailController);

    ProjectDetailController.$inject = ['$scope', '$state','entity','Project','$stateParams'];

    function ProjectDetailController ($scope, $state,entity,Project,$stateParams) {
        var vm = this;
        vm.data =entity;

        $scope.cancel = function(){
            $state.go('project', {
                    id: $stateParams.id,
                    page: $stateParams.page,
                    keyword: $stateParams.keyword
                }
            )
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProjectAddController', ProjectAddController);

    ProjectAddController.$inject = ['$scope', '$state', 'MessageService', '$uibModal', '$location', '$localStorage', '$http', 'Project', 'Merchant',
    '$stateParams', 'LocationProvice', 'LocationCity', 'LocationDistrict', 'Product'];

    function ProjectAddController ($scope, $state, MessageService, $uibModal, $location, $localStorage, $http, Project, Merchant,
        $stateParams, LocationProvice, LocationCity, LocationDistrict, Product) {
        var vm = this;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;
        vm.getOrder = getOrder;

        //项目类型
        vm.projectTypes =[
            {name:'标准',id:'Standard'},
            {name:'打样',id:'Proofing'}
        ];
        vm.data = {
            name:'',
            type: 'Standard',
            merchant:null,
            expectedDate: '',
            contact: '',
            phone: '',
            freight: '',
            address: '',
            remarks: '',
            productLines: []
        };
        vm.token = $localStorage.authenticationToken;
        //查看直接点编号进去   编辑只能单选  其他是可以多选的
        //商户
        Merchant.getAll(function(res){
            vm.merchants =res.filter(function(item){return item.enable})
        });

        LocationProvice.query({},function (data) {
            vm.provinces =  data;
        });


        var productLine ={
            productName:'选择产品', //订购商品
            productNumber:'',      //编号
            unit:'',               //单位
            quantity:'',           //数量
            price:'',              //单价
            taxRate:'',            //税率
            amount:'',             //合计金额
            taxPrice:'',           //含税单价
            taxAmount:'',          //加税合计
            filePath:''            //上传的文件
        };

        //新建生产
        $scope.productLineNew = function(){
            var flag = false;
            if(vm.data.productLines.length >0) {
                angular.forEach(vm.data.productLines, function (item) {
                    if (!item.productName || !item.productNumber || !item.unit || !item.quantity || !item.filePath) {
                        flag = true;
                    }
                });
            }
            if(flag){
               MessageService.error('请将空白项填写完整再添加！！！！');
            }else{
                productLine ={
                    productName:'选择产品', //订购商品
                    productNumber:'',      //编号
                    unit:'',               //单位
                    quantity:'',           //数量
                    price:'',              //单价
                    taxRate:'',            //税率
                    amount:'',             //合计金额
                    taxPrice:'',           //含税单价
                    taxAmount:'',          //加税合计
                    filePath:''            //上传的文件
                };
                vm.data.productLines.push(angular.copy(productLine));
            }
        };

        $scope.productLineDelete = function(index){
            vm.data.productLines.splice(index,1);
        };

        //选择产品
        $scope.chooseProduct = function(index){
            $uibModal.open({
                templateUrl: 'app/project/chooseProduct.html',
                controller: 'ChooseProductController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(result){
                console.log(result);
                if(result!=undefined){
                    vm.data.productLines[index].productName=result.sku;
                    vm.data.productLines[index].productNumber=result.number;
                    vm.data.productLines[index].unit=result.unit;
                }
            });
        };


        //文件上传  二次上传覆盖之前上传的文件  压缩包里面不能文件夹
        window.uploadFile = function($event) {
            var index=$event.currentTarget.dataset.target;
            if(!vm.data.productLines[index].productNumber){
                MessageService.error('请选择商品！');
                return;
            }
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'pdf' && ext != 'zip'){
                angular.element("#file").val("");
                MessageService.error("只能上传.pdf/.zip类型的文件!");
                return;
            }

            if (fileObj.size > 1024 * 1024 * 1024 * 2) {
                MessageService.error("文件不能大于2GB");
                return;
            }

            checkIfUploaded(fileObj, ext, index);
        };

        function checkIfUploaded (file, ext, index_file) {
            var reader = new FileReader();
            // 用来计算fileMd5值的file内容
            var fileToCountMD5 = file;

            if (file.size > 1024*1024*50) {
                var fileStart = file.slice(0, 1024 * 1024);
                var fileEnd = file.slice(file.size - 1024 * 1024, file.size);
                fileToCountMD5 = new Blob([fileStart,fileEnd], { type: "text/plain" });
            }
            reader.readAsBinaryString(fileToCountMD5);

            //绑定读取失败事件
            reader.onerror = function() {
                MessageService.error("文件读取失败");
            };

            //绑定读取成功事件
            reader.onload = function() {
                //需要引入计算MD5的jar包
                var fileMd5 = hex_md5(reader.result);

                var form = new FormData();
                form.append("fileMd5", fileMd5);
                form.append("fileSize", file.size);

                //校验是否上传过该文件，返回上传进度
                console.log("isFileExist");
                $.ajax({
                    url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/isFileExist",
                    type: "POST",
                    data: form,
                    async: true,        //异步
                    processData: false,  //很重要，告诉jquery不要对form进行处理
                    contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                    success: function(data) {
                        if (data.success) {
                            //文件已上传
                            MessageService.success("上传成功！");
                        } else {
                            //文件未上传或者部分上传
                            uploadBySplit(file, fileMd5, 0, ext, index_file);
                        }
                    },
                    error: function() {
                        MessageService.error("服务器出错!");
                    }
                });
            }
        }

        //分片上传
        function uploadBySplit(file, fileMd5, i, ext, index_file) {
            var splitSize = 1024 * 1024 * 20;   //分片大小20M  -- 20M为一段
            var size = file.size;//总大小
            var splitCount = Math.ceil(size / splitSize);  //总片数

            if (i == splitCount) {
                MessageService.success("文件上传成功！");
                return;
            }

            //计算每一片的起始与结束位置
            var start = i * splitSize;
            var end = Math.min(size, start + splitSize);
            var fileData = file.slice(start,end);
            var reader = new FileReader();
            reader.onload = function(){
                var md5 = hex_md5(reader.result);

                var form = new FormData();
                form.append("fileMd5", fileMd5);
                form.append("size", size);  //总大小
                form.append("totalStr", splitCount);   //总片数
                form.append("indexStr", i);    //当前是第几片
                form.append("md5", md5);    //分片md5

                //判断分片是否上传
                $.ajax({
                    url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/isFileSplitExist",
                    type: "POST",
                    data: form,
                    async: true,        //异步
                    processData: false,  //很重要，告诉jquery不要对form进行处理
                    contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                    success: function(data){
                        if (data.code == 1) {//已上传
                            //上传进度
                            var process = Math.round(end/size*100)+"%";
                            i++;
                            uploadBySplit(file, fileMd5, i, ext, index_file);    // 循环上传
                        } else { //未上传
                            form.append("fileData", fileData);
                            form.append("ext", ext);    // 文件后缀
                            //上传分片
                            $.ajax({
                                url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/upload",
                                type: "POST",
                                data: form,
                                async: true,        //异步
                                processData: false,  //很重要，告诉jquery不要对form进行处理
                                contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                                success: function(data) {
                                    if (data.state == 200) {
                                        //上传进度
                                        $('#progress-bar').css('width', (i / splitCount * 100)  +'%');
                                        i++;
                                        uploadBySplit(file, fileMd5, i, ext, index_file);
                                    } else if (data.state == 300) {
                                        $('#progress-bar').css('width', '0%');
                                        console.log(index_file);
                                        vm.data.productLines[index_file].filePath = data.message;
                                        $scope.$apply();
                                    } else {
                                        $('#progress-bar').css('width', '0%');
                                        MessageService.error("分片上传失败");
                                    }
                                },
                                error: function(XMLHttpRequest, textStatus, errorThrown) {
                                    MessageService.error("服务器出错!");
                                }
                            });
                        }
                    },

                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        MessageService.error("服务器出错!");
                    }
                });
            }
            reader.readAsBinaryString(fileData);
        }

        //文件下载
        $scope.downLoadFile = function (data) {
            $http({
                url: 'api/projects/download',
                method: "GET",
                params: {
                    filePath: data.filePath
                },
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/pdf"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }

        //保存
        $scope.save =function(){
            // if(!vm.data.name){
            //     MessageService.error("项目名称不能为空");
            //     return false;
            // }
            if(!vm.data.type){
                MessageService.error("项目类型不能为空");
                return false;
            }
            if(!vm.data.merchant){
                MessageService.error("商户不能为空");
                return false;
            }
            vm.expectedDate= angular.copy(angular.element("#startDate").val());
            vm.data.expectedDate = getDate($('#startDate').val() + " 23:59:59");
            // if(!vm.expectedDate){
            //     MessageService.error("预期交货时间不能为空");
            //     return false;
            // }
            if(!vm.data.contact){
                MessageService.error("联系人不能为空");
                return false;
            }
            if(!vm.data.phone){
                MessageService.error("联系方式不能为空");
                return
            }
            // var myreg=/^[1][3,4,5,6,7,8][0-9]{9}$/;
            // if (!myreg.test(vm.data.phone)) {
            //     MessageService.error("请输入11位符合要求的电话号码");
            //     return false;
            // };
            // if(!vm.data.address){
            //     MessageService.error("联系地址不能为空");
            //     return false;
            // }
            if (vm.province == null || vm.province == "") {
                MessageService.error("请选择省份");
                return false;
            };

            if (vm.city == null || vm.city == '') {
                MessageService.error('请选择城市');
                return false;
            }

            if (vm.district == null || vm.district == "") {
                MessageService.error("请选择区县");
                return false;
            };

            if (vm.address == null || vm.address == "") {
                MessageService.error("请输入详细地址");
                return false;
            };
            vm.data.address = vm.province.name + "-" + vm.city.name + "-" + vm.district.name + "-" + vm.address;

            if(!vm.data.freight){
                vm.data.freight = 0;
            }
            var ccFlag=true;
            if (vm.data.productLines != null && vm.data.productLines.length > 0) {
                angular.forEach(vm.data.productLines,function(item){
                    if(!item.productNumber && item.productName =='选择产品'){
                        MessageService.error("订购商品不能为空！");
                        ccFlag=false;
                        return false;
                    }
                    if(!item.quantity){
                        MessageService.error("数量不能为空");
                        ccFlag=false;
                        return false;
                    }
                    if(!item.filePath){
                        MessageService.error("上传文件不能为空");
                        ccFlag=false;
                        return false;
                    }

                    item.amount = (item.quantity * item.price).toFixed(2);
                    item.taxPrice = (item.price * item.taxRate / 100) + item.price;
                    item.taxAmount = ((item.price * item.taxRate / 100) + item.price) * item.quantity;
                });
            }else{
                MessageService.error("商品信息不能为空");
                return false;
            }

            if(!ccFlag){
                return false;
            }

            vm.isSaving = true;
            Project.create(vm.data, function (res) {
                MessageService.success("保存成功");
                $state.go("project");
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("保存失败，请检查数据是否正确");
            });
        };


        //返回
        $scope.goBack = function () {
            $state.go("project",{page: $stateParams.page});
        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

        function getOrder() {
            if(!vm.data.merchant){
                MessageService.error("请选择商户");
                return;
            }
            if(!vm.data.number) {
                MessageService.error("请填写项目编号");
                return;
            }
            Project.getThirdPartyProductByNumber({number: vm.data.number, merchantId: vm.data.merchant.id}, function(res) {
                if (res.orderNumber == null) {
                    MessageService.error("获取订单数据错误");
                    return;
                }

                // 地址数据充填
                vm.data.contact = res.contact;
                vm.data.phone = res.phone;
                vm.address = res.address;
                if (res.province.length == 2) {
                    res.province = res.province + "市";
                    res.city = "市辖区";
                }
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if (p.name == res.province) {
                        vm.province = p;
                        break;
                    }
                }
                vm.districts = [];
                LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                    vm.citys = data;
                    for (var i = vm.citys.length - 1; i >= 0; i--) {
                        var c = vm.citys[i];
                        if (c.name == res.city) {
                            vm.city = c;
                            break;
                        }
                    }

                    LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                        vm.districts = data;
                        for (var i = vm.districts.length - 1; i >= 0; i--) {
                            var di = vm.districts[i];
                            if (di.name == res.district) {
                                vm.district = di;
                            }
                        }
                    });
                });

                // 商品充填
                if (res.supNumber != null) {
                    Product.getBySkuNumber({number: res.supNumber}, function(pro) {
                        if (pro.id != null) {

                            productLine.productName = pro.propertyConfigs[0].sku; //订购商品
                            productLine.productNumber = pro.propertyConfigs[0].number;      //编号
                            productLine.unit = pro.measurementName;               //单位
                            productLine.quantity = parseInt(res.quantity);           //数量

                            var date = new Date();
                            date.setHours(date.getHours() + pro.warningTime);
                            vm.expectedDate = angular.copy(angular.element("#startDate").val());
                            if (vm.expectedDate == '') {
                                vm.expectedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                            }

                            var flag = true;
                            for (var i = vm.data.productLines.length - 1; i >= 0; i--) {
                                if (vm.data.productLines[i].productNumber == productLine.productNumber) {
                                    flag = false;
                                }
                            }
                            if (flag) {
                                vm.data.productLines.push(productLine);
                            }
                        }
                    })
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('project', {
                parent: 'module',
                url: '/project',
                params:{page: null,status: null,keyword: null},
                data: {
                    authorities: ['ROLE_PROJECT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/project/project.html',
                        controller: 'ProjectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('projectAdd', {
                parent: 'module',
                url: '/projectAdd',
                data: {
                    authorities: ['ROLE_PROJECT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/project/project-add.html',
                        controller: 'ProjectAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ProductCategory', function($stateParams, ProductCategory) {
                        return ProductCategory.get();
                    }]
                }
            })
            .state('projectEdit', {
                parent: 'module',
                url: '/projectEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PROJECT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/project/project-edit.html',
                        controller: 'ProjectEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Project', function($stateParams, Project) {
                        return Project.detail({id: $stateParams.id,page:$stateParams.page,keyword:$stateParams.keyword});
                    }]
                }
            })
            .state('projectDetail', {
                parent: 'module',
                url: '/projectDetail/{id}',
                params:{page: null,status: null,keyword: null},
                data: {
                    authorities: ['ROLE_PROJECT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/project/project-detail.html',
                        controller: 'ProjectDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Project', function($stateParams, Project) {
                        return Project.detail({id: $stateParams.id,page:$stateParams.page,keyword:$stateParams.keyword});
                    }]
                }
            })
        ;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Project', Project);

    Project.$inject = ['$resource'];

    function Project ($resource) {
        var resourceUrl =  'api/projects/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'create': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET'},
            'submit': {
                method:'GET',
                params: {
                    path: 'submit'
                }
            },
            'approve': {
                method:'GET',
                params: {
                    path: 'approve'
                }
            },
            'reject': {
                method:'GET',
                params: {
                    path: 'reject'
                }
            },
            'cancel': {
                method:'GET',
                params: {
                    path: 'cancel'
                }
            },
            'close': {
                method:'GET',
                params: {
                    path: 'close'
                }
            },
            'order': {
                method:'PUT',
                params: {
                    path: 'order'
                }
            },
            'upload': {
                method:'GET',
                params: {
                    path: 'upload'
                }
            },
            'download': {
                method:'GET',
                params: {
                    path: 'download'
                }
            },
            'getThirdPartyProductByNumber': {
                method: 'GET',
                params: {
                    path: 'getThirdPartyProductByNumber'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['$scope', 'Principal', '$state','MessageService','$uibModal','Product', 'Project','ParseLinks','$timeout', '$stateParams'];

    function ProjectController ($scope, Principal, $state,MessageService, $uibModal,Product,Project, ParseLinks,$timeout, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PRODUCT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有商品访问的权限！");
                $state.go("home");
            }
        });
        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.conditionList = [
            {name:'全部', id:''},
            {name:'未提交', id:'CREATED'},
            {name:'待审核', id: 'SUBMITTED'},
            {name:'审核通过', id: 'APPROVED'},
            {name:'项目关闭', id: 'CLOSED'}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: 'lastModifiedDate,DESC',
            keyword: $stateParams.keyword ||'',
            status: $stateParams.status|| ''
        };

        //获取选中的数组
        $scope.checked =[];
        $scope.checkedList =[];
        vm.isSaving = false;
        $scope.selectOne = function(data){
            var index = $scope.checked.indexOf(data.id);
            if(index == -1 && data.checked){
                $scope.checked.push(data.id);
                $scope.checkedList.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
                $scope.checkedList.splice(index, 1);
            }
            if (vm.projects.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.projects, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.projects.map(function(value){
                    return value.id;
                });
                $scope.checkedList = vm.projects.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.projects, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
                $scope.checkedList = [];
            }
        };

        //编辑项目
        $scope.projectEdit = function(){
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }else if($scope.checked.length>1){
                MessageService.error('请选择其中一项进行订购');
                return;
            }else{
                $state.go('projectEdit',{
                    id:$scope.checked[0],
                    page: vm.tableData.page,
                    keyword:vm.tableData.keyword}
                )
            }
        };

        //提交项目
        $scope.projectSubmit = function(){
            console.log($scope.checkedList);
            var flag =true;
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }else{
                angular.forEach($scope.checkedList,function(item){
                    if(item.status!='CREATED'){
                        flag =false;
                    }
                });
                if(flag){
                    $('#submitModal').modal('show');
                }else{
                    MessageService.error('请选择未提交的项目进行提交！');
                }
            }
        };

        //确认提交
        $scope.confirmSubmit = function(){
            vm.isSaving = true;
            Project.submit({ids:$scope.checked.join(',')},function(res){
                if (res.msg != '200') {
                    MessageService.error(res.msg);
                } else {
                    MessageService.success('提交成功');
                }
                vm.isSaving = false;
                $('#submitModal').modal('hide');
                init();
            })
        };

        //审核项目
        $scope.projectExam = function(){
            var flag =true;
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }else{
                angular.forEach($scope.checkedList,function(item){
                    if(item.status!='SUBMITTED'){
                        flag =false;
                    }
                });
                if(flag){
                    $('#examModal').modal('show');
                }else{
                    MessageService.error('请选择待审核的项目进行提交！');
                }

            }
        };

        //确认审核  -通过
        $scope.confirmExam = function(){
            vm.isSaving = true;
            Project.approve({ids:$scope.checked.join(',')},function(res){
                MessageService.success('已通过');
                $('#examModal').modal('hide');
                init(); 
                vm.isSaving = false;
            })
        };

        //审核  -驳回
        $scope.rejectExam = function(){
            vm.isSaving = true;
            Project.reject({ids:$scope.checked.join(',')},function(res){
                MessageService.success('已驳回');
                $('#examModal').modal('hide');
                init();
                vm.isSaving = false;
            })
        };

        $scope.cancelModal =function(){
            $('#submitModal').modal('hide');
            $('#examModal').modal('hide');
            $('#withdrawModal').modal('hide');
            $scope.checked =[];
            $scope.checkedList =[];
            $scope.select_all = false;
            angular.forEach(vm.projects, function (item) {
                item.checked = false;
            });
        };

        //撤回项目
        $scope.projectWithdraw = function(){
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }else{
                $('#withdrawModal').modal('show');
            }
        };

        //确认撤回  ---已经撤销的项目只在全部里面显示
        $scope.confirmWithdraw = function(){
            vm.isSaving = true;
            Project.cancel({ids:$scope.checked.join(',')},function(res){
                MessageService.success('已撤回');
                $('#withdrawModal').modal('hide');
                init();
                vm.isSaving = false;
            })
        };

        //关闭项目
        $scope.projectClose = function(){
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }else{
                $('#closeModal').modal('show');
            }
        };

        //确认关闭
        $scope.confirmClose = function(){
            Project.close({ids:$scope.checked.join(',')},function(res){
                MessageService.success('订单关闭成功');
                $('#closeModal').modal('hide');
                init();
            })
        };

        //订购项目
        $scope.projectOrder = function(){
            if ($scope.checked.length == 0) {
                MessageService.error('请选择列表项');
                return;
            }else if($scope.checked.length>1){
                MessageService.error('请选择其中一项进行订购');
                return;
            }else{
                Project.detail({id: $scope.checked[0]},function(res){
                    var status =res.status;
                    if(status == 'APPROVED'){
                        $uibModal.open({
                            templateUrl: 'app/project/project-order.html',
                            controller: 'ProjectOrderController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                    return $translate.refresh();
                                }],
                                msgdata: function() {
                                    return $scope.checked;
                                }
                            }
                        }).result.then(function(result){
                            init();
                        });
                    }else{
                        MessageService.error('请选择审核通过的项目订购！');
                    }
                });


            }
        };

        init();
        function init() {
            vm.projects = [];
            $scope.checked =[];
            $scope.checkedList =[];
            $scope.select_all = false;
            angular.forEach(vm.projects, function (item) {
                item.checked = false;
            });
            Project.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.projects = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.conditionSelect = function(data){
            vm.tableData.status = data.id;
            vm.tableData.page = 0;
            init();
        };
        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                $(".table-top").height("40");
                $(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                $(".table-top").height("auto");
                $(".table-state-btn").addClass("table-state-btnOn");
            }
        }
        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChooseProductController', ChooseProductController);

    ChooseProductController.$inject = ['$q', '$scope','$uibModalInstance','MessageService','Product','$timeout'];

    function ChooseProductController ($q, $scope, $uibModalInstance,MessageService,Product,$timeout) {
        var vm = this;
        vm.keyword ='';
        vm.selectIndex ='';
        vm.first =[];
        vm.tableList =[];
        vm.data=[];
        var tempArr =[];

        var productArr = {key: null, value: null};

        vm.productList = Product.sortByCategory({keyword:vm.keyword});
        $q.all([vm.productList.$promise]).then(function() {
            for (var k in vm.productList) {
                if(k == '$promise' || k == '$resolved'|| k == 'toJSON'|| k == '$get'|| k == '$save'|| k == '$query' 
                    || k == '$remove'|| k == '$delete'|| k == '$getAll'|| k == '$getNumber'|| k == '$sortByCategory'
                    || k == '$getAllByCategory'|| k == '$update'|| k == '$validate'){
                } else {
                    console.log('一级 --- '+k);

                    var level_2 = {name: null, product: null};
                    var levels_2 = [];
                    for (var i = vm.productList[k].length - 1; i >= 0; i--) {
                        for (var j in vm.productList[k][i]) {
                            console.log('   二级  ---' + j);

                            level_2 = {name: j, product: []};
                            var product_sku = {pname: null, sku: null};

                            for (var p in vm.productList[k][i][j]) {
                                for (var q in vm.productList[k][i][j][p]) {
                                    // sku
                                    product_sku = {pname: q, sku: vm.productList[k][i][j][p][q]};
                                    level_2.product.push(product_sku);
                                }
                            }
                            level_2.product.push(product_sku);
                            levels_2.push(level_2);
                        }
                    }

                    productArr = {key: k, value: levels_2};
                    vm.data.push(productArr);
                }
            }
            console.log(vm.data);
        });

        $timeout(function(){
            angular.element('.firstItem').click(function(){
                if(!$(this).hasClass('on')){
                    $(this).next('.subItems').slideDown(200).parent().siblings('.mainItems').find('.subItems').slideUp(200);
                    $(this).addClass('on').parent().siblings('.mainItems').find('.firstItem').removeClass('on');
                    $(this).find('.plus_first').addClass('rotateIcon').end().parent().siblings('.mainItems').find('.plus_first').removeClass('rotateIcon');
                }else{
                    $(this).removeClass('on');
                    $(this).next('.subItems').slideUp(200).parent().siblings('.mainItems').find('.subItems').slideUp(200);
                    $(this).find('.plus_first').removeClass('rotateIcon');
                }
            });
        },500);

        $scope.getProduct = function(key,data){
            vm.selectIndex =-1;
            vm.tableList=data;
            vm.navKey =key;
        };

        //这里搜索有问题
        $scope.search = function(){
            vm.tableList = vm.data.filter(function(item){
                return item.sku ==vm.keyword ||item.number ==vm.keyword;
            });
            //展开列表收起
            $('.firstItem').removeClass('on');
            $('.firstItem').next('.subItems').slideUp(200).parent().siblings('.mainItems').find('.subItems').slideUp(200);
            $('.firstItem').find('.plus_first').removeClass('rotateIcon');
        };

        vm.product=null;
        $scope.productChoice = function(data,index){
            vm.selectIndex = index;
            vm.product=data;
        };

        $scope.confirm = function(){
          if(vm.product==null){
              MessageService.error('请选择商品！');
          }else{
              $uibModalInstance.close(vm.product);
          }
        };

        $scope.cancel = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('classify', {
                parent: 'module',
                url: '/classify',
                data: {
                    authorities: ['ROLE_CLASSIFY']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/classify.html',
                        controller: 'ClassifyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('classifyAdd', {
                parent: 'module',
                url: '/classifyAdd',
                data: {
                    authorities: ['ROLE_CLASSIFY']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/classify-add.html',
                        controller: 'ClassifyAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('commodity', {
                parent: 'module',
                url: '/commodity?productType',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/commodity.html',
                        controller: 'CommodityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('commodity1', {
                parent: 'module',
                url: '/commodity1?productType',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/commodity.html',
                        controller: 'CommodityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('commodity2', {
                parent: 'module',
                url: '/commodity2?productType',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/commodity.html',
                        controller: 'CommodityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('commodityAdd', {
                parent: 'module',
                url: '/commodityAdd?productType',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/commodity-edit.html',
                        controller: 'CommodityEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Product', function($stateParams, Product) {
                        return {
                            template: {},
                            name:'',
                            category: $stateParams.productType,
                            productCategoryId:'',
                            productCategoryName:'',
                            measurementId:'',
                            measurementName:'',
                            enable: false,
                            propertyConfigs: [],
                            producible: false,              //可生产
                            warningTime: "",                //预警时间
                            weight: "",                //预警时间
                            imgDpi: "",                     //DPI
                            toning: "",                     //调色
                            autoOutsourcing: false,         //自动流转
                            productCirculations: [],        //流转配置
                        };
                    }],
                }
            })
            .state('commodityEdit', {
                parent: 'module',
                url: '/commodityEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/commodity-edit.html',
                        controller: 'CommodityEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Product', function($stateParams, Product) {
                        return Product.validate({id: $stateParams.id});
                    }],
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Product', Product)
        .factory('PropertyConfigs', PropertyConfigs)
        .factory('ProductCategory', ProductCategory);

    Product.$inject = ['$resource'];
    PropertyConfigs.$inject = ['$resource'];
    ProductCategory.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'getNumber': {
                method:'GET',
                params: {
                    id: 'getNumber'
                }
            },
            'getCategoryAndProductDetails': {
                method:'GET',
                params: {
                    id: 'getCategoryAndProductDetails'
                }
            },
            'getNumber2': {
                method:'GET',
                params: {
                    id: 'getNumber2'
                }
            },
            'sortByCategory': {
                method:'GET',
                params: {
                    id: 'sortByCategory'
                }
            },
            'getAllByCategory': {
                method:'GET',
                isArray: true,
                params: {
                    id: 'getAllByCategory'
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    id: 'id'
                }
            },
            'save': {
                method:'POST'
            },
            'update': {
                method:'PUT'
            },
            'validate': {
                method:'GET',
                params:{
                    id:'exists'
                }
            },
            'getBySkuNumber': {
                method: 'GET',
                params: {
                    id: 'getBySkuNumber'
                }
            },
            'byCondition':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'byCondition'
                }
            },
            'getAllByCondition':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'byAllCondition'
                }
            },
            'byProductCategoryId': {
                method: 'GET',
                params: {
                    id: 'byProductCategoryId'
                },
                isArray: true
            }
        });
    };
    function PropertyConfigs ($resource) {
        var resourceUrl =  'api/property-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'getNumber': {
                method:'GET',
                params: {
                    id: 'getNumber'
                }
            },
            'getCategoryAndProductDetails': {
                method:'GET',
                params: {
                    id: 'getCategoryAndProductDetails'
                }
            },
            'getNumber2': {
                method:'GET',
                params: {
                    id: 'getNumber2'
                }
            },
            'sortByCategory': {
                method:'GET',
                params: {
                    id: 'sortByCategory'
                }
            },
            'getAllByCategory': {
                method:'GET',
                isArray: true,
                params: {
                    id: 'getAllByCategory'
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    id: 'id'
                }
            },
            'save': {
                method:'POST'
            },
            'update': {
                method:'PUT'
            },
            'validate': {
                method:'GET',
                params:{
                    id:'exists'
                }
            },
            'getBySkuNumber': {
                method: 'GET',
                params: {
                    id: 'getBySkuNumber'
                }
            },
            'getPageByCondition':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'getPageByCondition'
                }
            },
            'byCondition':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'byCondition'
                }
            },
            'getAllByCondition':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'byAllCondition'
                }
            },
            'byProductCategoryId': {
                method: 'GET',
                params: {
                    id: 'byProductCategoryId'
                },
                isArray: true
            }
        });
    };
    function ProductCategory ($resource) {
        var resourceUrl =  'api/product-category/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                params: {
                    id: 'pages'
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'gets': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    id: 'id'
                }
            },
            'save': { method:'POST' } ,
            'update': { method:'PUT' } ,
            'validate': {
                method:'GET',
                params:{
                    id:'exists'
                }
            },
            'getAllSuperior': {
                method: 'GET',
                params: {
                    id: 'getAllSuperior'
                },
                isArray: true
            },
            'getAllCategory': {
                method: 'GET',
                params: {
                    id: 'getAllCategory'
                },
                isArray: true
            },
            'byCondition':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'byCondition'
                }
            }
        });
    };
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ModalFlowController', ModalFlowController);

    ModalFlowController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Product','MessageService', 'Permission', 'ProductCategory','entity', 'Supplier', '$uibModalInstance'];

    function ModalFlowController ($scope, Principal, LoginService, $state,Product,MessageService, Permission, ProductCategory, entity, Supplier, $uibModalInstance) {
        var vm = this;
        vm.flowData = {
            supplierName:'',
            supplierId:'',
            makeupId:'',
            makeupName:'',
            packings:'',
            dailyOutput:''
        };
        vm.makeupTypeList = [];
        init();
        function init(){
            Supplier.getAll({}, function (res) {
                vm.supplierList = res;

                if(entity.type == 'add'){
                    vm.type = true;
                }
                if(entity.type == 'edit'){
                    vm.type = false;
                    var data = entity.data;
                    for(var i=0; i<vm.supplierList.length; i++){
                        if(vm.supplierList[i].id == data.supplierId){
                            vm.supplierName = vm.supplierList[i];
                            vm.makeupTypeList = vm.supplierList[i].makeups;
                        }
                    }
                    for(var k=0; k<vm.makeupTypeList.length; k++){
                        if(vm.makeupTypeList[k].id == data.makeupId){
                            vm.makeup = vm.makeupTypeList[k];
                        }
                    }
                    vm.flowData = {
                        supplierName:data.supplierName,
                        supplierId:data.supplierId,
                        makeupName:data.makeupName,
                        makeupId:data.makeupId,
                        packings:data.packings,
                        dailyOutput:data.dailyOutput,
                        defaulted:data.defaulted
                    };
                }
            });
        };
        $scope.supplierSelect = function(data){
            vm.flowData.supplierName = vm.supplierName.name;
            vm.flowData.supplierId = vm.supplierName.id;
            vm.makeupTypeList = vm.supplierName.makeups;
        };
        $scope.makeupSelect = function(){
            vm.flowData.makeupId = (vm.makeup == null) ? "" : vm.makeup.id;
            vm.flowData.makeupName = (vm.makeup == null) ? "" : vm.makeup.name;
        };


        $scope.flowSave = function () {
            if(!vm.flowData.supplierName){
                MessageService.error("生产商不能为空");
                return;
            }
            if(!vm.flowData.makeupName){
                MessageService.error("拼版方式不能为空");
                return;
            }
            if(!vm.flowData.packings){
                MessageService.error("打包数不能为空");
                return;
            }
            if(!vm.flowData.dailyOutput){
                MessageService.error("日产额不能为空");
                return;
            }
            $uibModalInstance.close(vm.flowData);
        };
        $scope.modalHide = function(){
            $uibModalInstance.close();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SuppliesController', SuppliesController);

    SuppliesController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance', 'entity', 'PropertyConfigs'];

    function SuppliesController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance, entity, PropertyConfigs) {
        var vm = this;

        vm.category = entity.category || 'MaterialProduct';
        if(entity){
            vm.data = {
                id: entity.materialSettingId,
            }
        }else {
            vm.data = {}
        }
        vm.tableData = {
            page: 0,
            size: 10,
            sort: ['id,DESC'],
            keyword: '',
            categoryId: ''
        };
        //获取品类
        vm.categoryList = ProductCategory.getAllCategory();

        $scope.categoryTitle = function(data, $event){
            data.open = !data.open ? true : false;
            $event.stopPropagation();
        }
        $scope.categoryOne = function(data){
            vm.tableData.categoryId = data ? data.id : "";
            init()
        }
        $scope.categoryChild = function(data){
            vm.tableData.categoryId = data.id;
            init()
        }

        init();
        function init() {
            vm.tableList = [];
            var items = [{key:"product.category",op:"=",value:vm.category},{key:"product.enable",op:"=",value:true}];
            if(vm.tableData.categoryId){
                items.push({key:'product.productCategory.id',op:'=',value: vm.tableData.categoryId})
            }
            PropertyConfigs.getPageByCondition({
                items: items,
                page: vm.tableData.page,
                size: vm.tableData.size,
                sort: vm.tableData.sort
            }, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.tableList =res;
                vm.queryCount = headers('X-Total-Count');
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        //选择表格
        $scope.tableCb = function(data){
            vm.data = data;
        }

        //确认
        $scope.save = function () {
            $uibModalInstance.close(vm.data);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close(false);
        }
        $scope.categoryInfo = function (item){
            switch (item) {
                case 'OrderingProduct':
                    return '定制品';
                case 'GeneralProduct':
                    return '成品';
                case 'MaterialProduct':
                    return '辅料';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RegulationsController', RegulationsController);

    RegulationsController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance', 'entity'];

    function RegulationsController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance, entity) {
        var vm = this;
        if(typeof entity == "object"){
            vm.data = entity.usingRule;
            if(vm.data.value.split(',').length > 1){
                vm.isOperator = true;
                vm.minValue = vm.data.value.split(',')[0];
                vm.maxValue = vm.data.value.split(',')[1];
            }else {
                vm.isOperator = false;
                vm.minValue = vm.data.value;
            }
        }else {
            vm.data = {
                    key: '',
                    op: '',
                    value: '',
                    quantity:''
                }
            vm.isOperator = false;
            vm.minValue = "";
            vm.maxValue = "";
        }

        //基于
        vm.baseOnList = [
            {name:'订单份数',id:'订单份数'}
        ]
        //运算符
        vm.operatorList = [
            {name:'=',id:'='},
            {name:'>=',id:'>='},
            {name:'<=',id:'<='},
            {name:'>',id:'>'},
            {name:'<',id:'<'},
            {name:'<>',id:'<>'},
            {name:'介于',id:'介于', operator: true}
        ];
        //选择运算符
        $scope.operatorSelect = function(){
            vm.isOperator = false;
            for(var i=0; i<vm.operatorList.length; i++){
                if(vm.operatorList[i].id == vm.data.op){
                    vm.isOperator = vm.operatorList[i].operator;
                }
            }
        }
        

        //确认
        $scope.save = function () {
            if(!vm.data.key){
                MessageService.error("基于不能为空");
                return
            }
            if(!vm.data.op){
                MessageService.error("运算符不能为空");
                return
            }
            if(vm.isOperator){
                if(!vm.minValue || !vm.maxValue){
                    MessageService.error("使用数量不能为空");
                    return
                }
                if(parseInt(vm.minValue) > parseInt(vm.maxValue)){
                    MessageService.error("请正确填写使用数量");
                    return
                }
                vm.data.value = vm.minValue + ',' + vm.maxValue;
            }else {
                if(vm.minValue == ''){
                    MessageService.error("使用数量不能为空");
                    return
                }
                vm.data.value = vm.minValue;
            }
            if(vm.data.value == ''){
                MessageService.error("使用数量不能为空");
                return
            }
            console.log(vm.data)
            $uibModalInstance.close(vm.data);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PropertyController', PropertyController);

    PropertyController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance', 'entity'];

    function PropertyController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance, entity) {
        var vm = this;
        vm.property = entity;
        console.log(vm.property)
        //生成
        $scope.save = function () {
            var _arr = [];
            for(var i=0; i<vm.property.length; i++){
                var _arr1 = [];
                for(var j=0; j<vm.property[i].itemValues.length; j++){
                    if(vm.property[i].itemValues[j].checked){
                        var _obj = vm.property[i].itemValues[j].name;
                        _arr1.push({
                            name: vm.property[i].itemValues[j].name,
                            number: vm.property[i].id + '_' + vm.property[i].itemValues[j].id
                        })
                    }
                }
                if(_arr1.length == 0){
                    MessageService.error("每个属性最少选择一项");
                    return
                }
                _arr.push(_arr1)
            }

            $uibModalInstance.close(_arr);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ProductItemsController', ProductItemsController);

    ProductItemsController.$inject = ['$scope', 'Items', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance', 'entity'];

    function ProductItemsController ($scope, Items, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance, entity) {
        var vm = this;
        vm.items = entity || [];
        console.log(vm.items)
        vm.itemsList = Items.getAll();
        $scope.itemSelect = function(data, index){
            if(data.id){
                if(!itemIndex(data.id,index)){
                    MessageService.error("已存在");
                    vm.items[index] = null;
                    return
                }
                for(var i=0; i<vm.itemsList.length; i++){
                    if(data.id == vm.itemsList[i].id){
                        vm.items[index] = vm.itemsList[i];
                        break
                    }
                }
            }else{
                vm.items[index] = null;
            }
            console.log(vm.items)
        }
        function itemIndex(id,index){
            for(var i=0; i<vm.items.length; i++){
                if(vm.items[i] && id == vm.items[i].id && i!=index){
                    return false
                }
            }
            return true
        }
        //属性删除
        $scope.propertyDelete = function(index){
            vm.items.splice(index,1);
        };
        //属性新增
        $scope.propertyAdd = function(){
            vm.items.push({id: null});
        };
        //生成
        $scope.save = function () {
            if(vm.items.length == 0){
                MessageService.error("请添加属性");
                return
            }
            for(var i=0;i<vm.items.length;i++){
                if(!vm.items[i] || !vm.items[i].id){
                    MessageService.error("请添加属性");
                    return false
                }
            }
            $uibModalInstance.close(vm.items);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PriceController', PriceController);

    PriceController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance'];

    function PriceController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance) {
        var vm = this;

        //渠道
        vm.channelList = [
            {name:'标准',id:'标准'}
        ]
        //定价策略
        vm.pricingList = [
            {name:'标准',id:'标准'}
        ]
        //基于
        vm.baseList = [
            {name:'标准',id:'标准'}
        ]

        vm.data = {
            channel: '',
            price: [
                {
                    minPurchaseQuantity: '',
                    maxPurchaseQuantity: '',
                    pricing: '',
                    base: '',
                    price: '',
                }
            ]
        }
        
        
        //阶梯设置
        $scope.ladderSet = function (data) {
            
        }
        //删除
        $scope.delete = function (index) {

        }
        //新建
        $scope.priceAdd = function (index) {
            var price = {
                    minPurchaseQuantity: '',
                    maxPurchaseQuantity: '',
                    pricing: '',
                    base: '',
                    price: '',
                };
            vm.data.price.push(price)
        }
        //确认
        $scope.save = function () {
            console.log(vm.data)
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MinWarningController', MinWarningController);

    MinWarningController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance', 'entity', 'Depository'];

    function MinWarningController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance, entity, Depository) {
        var vm = this;
        vm.isMaterial = entity.type ? true : false;
        // if(typeof entity == "object"){
            vm.data = {
                minStorage: entity.data ? entity.data.minStorage : '',
                depotsWarning:entity.data ? (entity.data.warehouseConfigs.length > 0 ? true : false) : false,
                warehouseConfigs: entity.data ? entity.data.warehouseConfigs : []
            }
        // }else {
        //     vm.data = {
        //         minStorage:'',
        //         depotsWarning:false,
        //         warehouseConfigs: []
        //     }
        // }
        //仓库列表
        if(vm.isMaterial){
            vm.warehouseList = Depository.getAll({type: "accessories"});
        }else {
            vm.warehouseList = Depository.getAll();
        }

        //新增
        $scope.add = function () {
            var _obj = {
                warehouseId: '',
                warehouseName: '',
                minStorage: ''
            };
            vm.data.warehouseConfigs.push(_obj);
        }
        //选择仓库
        $scope.warehouseSelect = function(data){
            for(var i=0; i<vm.warehouseList.length; i++){
                if(vm.warehouseList[i].id == data.warehouseId){
                    data.warehouseName = vm.warehouseList[i].name;
                }
            }
        }
        //是否启动分库预警
        $scope.depotsWarningCb = function(){
            if(!vm.data.depotsWarning){
                vm.data.warehouseConfigs = [];
            }else{
                vm.data.minStorage = null;
            }
        }

        //删除
        $scope.delete = function (index) {
            vm.data.warehouseConfigs.splice(index, 1)
        };
        //确认
        $scope.save = function () {
            $uibModalInstance.close(vm.data);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MerchantsController', MerchantsController);

    MerchantsController.$inject = ['$scope', 'Merchant', '$q', '$uibModalInstance', 'entity', 'MessageService', 'ListService'];

    function MerchantsController ($scope, Merchant, $q, $uibModalInstance, entity, MessageService, ListService) {
        var vm = this;
        vm.selectAll = false;
        //商户列表
        vm.merchantList =  Merchant.getAll();

        $q.all([vm.merchantList.$promise]).then(function () {
            if(!vm.merchantList||!vm.merchantList.length){
                MessageService.error("merchants为null");
            }
            if(typeof entity == "object"){
                vm.data = entity.merchants||[];
                for (var i = 0; i < vm.data.length; i++) {
                    var da =  vm.data[i];
                    var result = ListService.inList(da, vm.merchantList, ["number"]);
                    if (result) {
                        result.select = true;
                    }
                }
                if(vm.data.length==vm.merchantList.length){
                    vm.selectAll = true;
                }
                console.log(vm.data)
            }else {
                vm.data = [];
            }
        })

        $scope.chooseAll = function () {
            // vm.selectAll = !vm.selectAll;
            if(vm.selectAll){
                vm.data = angular.copy(vm.merchantList);
            }else{
                vm.data = [];
            }
            angular.forEach(vm.merchantList,function (data,i) {
                if(vm.selectAll){
                    data.select = true;
                }else{
                    data.select = false;
                }
            })
        }

        $scope.chooseOne = function (data) {
            // data.select = !data.select;
            // 选中
            if(data.select){
                vm.data.push(data);
            }else{
                // 未选中
                vm.data.some(function (da, i) {
                    if (da.id==data.id) {
                        vm.data.splice(i, 1);
                    }
                })
            }

            // 判断全选按钮
            if(vm.data.length==vm.merchantList.length){
                vm.selectAll = true;
            }else{
                vm.selectAll = false;
            }
            console.log("chooseone");
            console.log(vm.data)
        }

        //确认
        $scope.save = function () {
            console.log(vm.data)
            $uibModalInstance.close(vm.data);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('IngredientsController', IngredientsController);

    IngredientsController.$inject = ['$q', '$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks',
    '$uibModal','$uibModalInstance', 'entity', 'Sorting', 'UnitMeasurement', 'Merchant'];

    function IngredientsController ($q, $scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks,
        $uibModal, $uibModalInstance, entity, Sorting, UnitMeasurement, Merchant) {
        var vm = this;
        //计量单位
        vm.unitList = UnitMeasurement.getAll();
        $q.all([vm.unitList.$promise]).then(function(){
            if(entity){
                vm.data = [];
                for(var i=0; i<entity.length; i++){
                    var _obj = {
                        materialId: entity[i].materialId,
                        materialName: entity[i].materialName,
                        measurementId: entity[i].measurementId,
                        measurementName: entity[i].measurementName,
                        usingRule: entity[i].usingRule,
                        materialSettingSku: entity[i].materialSettingSku,
                        materialSettingId: entity[i].materialSettingId,
                        merchants: entity[i].merchants
                    };
                    vm.data.push(_obj);
                }
            }else {
                vm.data = [{
                    materialId: '',
                    materialName: '',
                    measurementId: '',
                    measurementName: '',
                    usingRule: {},
                    materialSettingSku: '',
                    materialSettingId: '',
                    merchants: []
                }]
            }
        });


        //使用规则
        $scope.regulationsSet = function(index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/regulations.html',
                controller: 'RegulationsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {}]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data[index].usingRule = backData;
                }
            });
        }
        //编辑使用规则
        $scope.regulationsEdit = function(data, index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/regulations.html',
                controller: 'RegulationsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return data;
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data[index].usingRule = backData;
                }
                console.log(backData)
                console.log(vm.data)
                console.log(index)
            });
        }
        //辅料配置新增
        $scope.ingredientAdd = function () {
            var _obj = {
                materialId: '',
                materialName: '',
                measurementId: '',
                measurementName: '',
                usingRule: {},
                materialSettingId: '',
                materialSettingSku: '',
                merchants: []
            };
            vm.data.push(_obj)
        }
        //辅料配置计量单位
        $scope.measurementSelect1 = function(data){
            for(var i=0; i<vm.unitList.length; i++){
                if(data.measurementId == vm.unitList[i].id){
                    data.measurementName = vm.unitList[i].name;
                }
            }
        }
        //辅料配置删除
        $scope.ingredientDelete = function (index) {
            vm.data.splice(index, 1)
        }

        //选择材料
        $scope.materiaSet = function(data, index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/supplies.html',
                controller: 'SuppliesController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return data;
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    vm.data[index].materialName = !backData ? '' : (backData.sku.split('_').length > 0 ? backData.sku.split('_')[0] : "");
                    vm.data[index].materialSettingId = !backData ? "" : backData.id;
                    vm.data[index].materialSettingSku = !backData ? "" : backData.sku;
                }
            });
        }

        //分拣规则设置
        $scope.merchantsSet = function(index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/merchants.html',
                controller: 'MerchantsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {}]
                }
            }).result.then(function (backData) {
                vm.data[index].merchants = backData;
                console.log(vm.data)
            });
        }

        //分拣规则编辑
        $scope.merchantsEdit = function(data,index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/merchants.html',
                controller: 'MerchantsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return data;
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    vm.data[index].merchants = backData;
                }
            });
        }

        //确认
        $scope.save = function () {
            console.log(vm.data);
            $uibModalInstance.close(vm.data);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('FileCheckController', FileCheckController);

    FileCheckController.$inject = ['$scope', '$state','Product','MessageService','entity', '$uibModalInstance'];

    function FileCheckController ($scope, $state,Product,MessageService, entity, $uibModalInstance) {
        var vm = this;
        vm.flowData = {
            fileWidth:'',
            filePageCount:'',
            fileHeight:''
        };
        init();
        function init(){
            vm.type = entity.type;
            if (!vm.type) {
                vm.flowData = {
                    fileWidth: entity.data.fileWidth,
                    filePageCount: entity.data.filePageCount,
                    fileHeight: entity.data.fileHeight
                };
            }
        };

        $scope.flowSave = function () {
            if(!vm.flowData.fileWidth){
                MessageService.error("PDF文件宽度不能为0");
                return;
            }
            if(!vm.flowData.filePageCount){
                MessageService.error("PDF文件总页数不能为0");
                return;
            }
            if(!vm.flowData.fileHeight){
                MessageService.error("PDF文件高度不能为0");
                return;
            }
            $uibModalInstance.close(vm.flowData);
        };
        $scope.modalHide = function(){
            $uibModalInstance.close();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CommodityEditController', CommodityEditController);

    CommodityEditController.$inject = ['$scope', 'Principal', '$q', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks',
    '$uibModal', 'Items', 'UnitMeasurement', 'Depository', 'Supplier', 'Makeup', 'Product', 'Sorting', 'entity', '$stateParams',
    '$timeout', 'MaterialTemplates', 'Qinius'];

    function CommodityEditController ($scope, Principal, $q, LoginService, $state,User,MessageService, ProductCategory, ParseLinks,
        $uibModal, Items, UnitMeasurement, Depository, Supplier, Makeup, Product, Sorting, entity, $stateParams, $timeout, MaterialTemplates, Qinius) {
        var vm = this;
        vm.data = entity;

        //商品类型
        vm.commodityTypes =[
            {name:'定制商品',id:'OrderingProduct'},
            {name:'标准印品',id:'StandardProduct'},
            {name:'标准通品',id:'GeneralProduct'}
        ];

        vm.superiorName = null;
        //计量单位
        vm.unitList = UnitMeasurement.getAll();
        //商品品类
        vm.productCategoryList = ProductCategory.getAll();
       //生产商
        vm.supplierList=Supplier.getAll({});
        $q.all([vm.data.$promise,vm.productCategoryList.$promise ]).then(function(){
            //物料模板
            MaterialTemplates.getAll({type:vm.data.category != 'MaterialProduct' ? 'product' : 'accessories'},function(res){
                vm.materialTemplatesList = res.filter(function(item){return item.enable;})
            });
            if (vm.data.id) {
                for (var i = 0; i < vm.productCategoryList.length; i++) {
                    if (vm.productCategoryList[i].id == vm.data.productCategoryId && vm.productCategoryList[i].superiorId != "") {
                        vm.superiorName = vm.productCategoryList[i].superiorName;
                        break
                    }
                }
                // vm.data.propertyConfigs.sort(function(a, b) {
                //     return a.sort - b.sort
                // })
                //辅料配置开关
                vm.data.ingredientsEnable = (vm.data.materialConfigs.length > 0 || !vm.data.materialConfigs ? true : false);
            }
            //是否定制
            vm.isCustomization = (vm.data.category == 'GeneralProduct' ? false : true);
        });

        //商品类型选择
        $scope.commodityTypeSelect = function(){
            if(vm.data.category == 'GeneralProduct'){
                vm.isCustomization = false;
                vm.data.producible = false;
                vm.data.autoOutsourcing = false;
                warningTime();
                autoOutsourcing();
                for(var i=0; i<vm.data.propertyConfigs.length; i++){
                    vm.data.propertyConfigs[i].warehouseConfigs = null;
                }
            }
            if(vm.data.category == 'OrderingProduct' || vm.data.category == 'StandardProduct'){
                vm.isCustomization = true;
            }
        };

        // 附件PDF文件的校验设定
        $scope.pdfFileEdit = function(data,index){
            $uibModal.open({
                templateUrl: 'app/product/file-check.html',
                controller: 'FileCheckController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {type: false, data: data};
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data.propertyConfigs[index].filePageCount = backData.filePageCount;
                    vm.data.propertyConfigs[index].fileHeight = backData.fileHeight;
                    vm.data.propertyConfigs[index].fileWidth = backData.fileWidth;
                }
            });
        }

        //物料模板选择
        $scope.productCategorySelect = function(){
            var _number1 = "";
            vm.superiorName = null;
            vm.data.propertyConfigs = [];
            //商品属性
            if(!vm.data.templateId){
                vm.data.items =[];
                vm.data.templateId = '';
                vm.data.templateName = '';
                vm.data.productCategoryName ='';
                vm.data.productCategoryId ='';
            }else{
                for(var j=0;j<vm.materialTemplatesList.length;j++){
                    var _template = vm.materialTemplatesList[j];
                    if(vm.data.templateId == _template.id){
                        vm.data.items = _template.items;
                        vm.data.templateId = _template.id;
                        vm.data.templateName = _template.name;
                        vm.data.productCategoryName = _template.productCategoryName;
                        vm.data.productCategoryId = _template.productCategoryId;
                        for(var i=0; i<vm.productCategoryList.length; i++){
                            if(vm.productCategoryList[i].id == _template.productCategoryId){
                                var _number = "";
                                if(vm.productCategoryList[i].superiorId){
                                    vm.superiorName = vm.productCategoryList[i].superiorName;
                                    for(var j=0; j<vm.productCategoryList.length; j++){
                                        if(vm.productCategoryList[i].superiorId == vm.productCategoryList[j].id){
                                            _number = vm.productCategoryList[j].categoryCode;
                                        }
                                    }
                                }
                                _number1 = _number + '-' + vm.productCategoryList[i].categoryCode;
                                break
                            }
                        }
                        //获取订单编号
                        Product.getNumber2({categoryCode:_number1}, function (res) {
                            vm.data.number = res.number;
                        });
                        break
                    }
                }
            }

        }
        //计量单位选择
        $scope.measurementSelect = function(){
            for(var i=0; i<vm.unitList.length; i++){
                if(vm.unitList[i].id == vm.data.measurementId){
                    vm.data.measurementName = vm.unitList[i].name;
                }
            }
        };

        //价格设置
        // $scope.priceSet = function () {
        //     $uibModal.open({
        //         templateUrl: 'app/product/finished/modal/price.html',
        //         controller: 'PriceController',
        //         controllerAs: 'vm',
        //         backdrop: 'static',
        //         resolve: {
        //             entity: [function() {
        //
        //             }]
        //         }
        //     }).result.then(function (backData) {
        //         if(typeof backData == "object"){
        //             vm.data.price = backData;
        //         }
        //     });
        // }
        //流转配置
        $scope.supplierSelect = function(data){
            for(var i=0; i<vm.supplierList.length; i++){
                if(vm.supplierList[i].id == data.supplierId){
                    data.supplierName = vm.supplierList[i].name;
                }
            }
        };
        $scope.defaultFn = function(index){
            for(var i=0; i<vm.data.productCirculations.length; i++){
                if( i == index){
                    vm.data.productCirculations[i].defaulted = true;
                }else {
                    vm.data.productCirculations[i].defaulted = false;
                }
            }
        };
        $scope.defaultDelete = function(index){
            vm.data.productCirculations.splice(index, 1);
        }
        $scope.productCirculationAdd = function(index){
            var _obj = {
                supplierId: '',
                supplierName: '',
                defaulted: false
            };
            vm.data.productCirculations.push(_obj)
        };

        $scope.rapidGenerating = function () {
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/property.html',
                controller: 'PropertyController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return vm.data.items;
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    var day = new Date();
                    var _backData = [];
                    for( var x=0; x<backData.length; x++){
                        if(backData[x].length > 0){
                            _backData.push(backData[x]);
                        }
                    }
                    var _arr = getCombination(_backData);
                    if(typeof _arr == "object") {
                        for (var i = 0; i < _arr.length; i++) {
                            //每次进行求出最大索引
                            var indexEs=[];
                            angular.forEach(vm.data.propertyConfigs,function(item){
                                indexEs.push(item.number.split('-')[(item.number.split('-')).length-1]);
                            });
                            var _sku = vm.data.name + '-' + _arr[i].name;
                            var _isSku = false;
                            for(var j=0; j<vm.data.propertyConfigs.length; j++){
                                if (vm.data.propertyConfigs[j].cancelled) {
                                    continue;
                                }
                                if(_sku == vm.data.propertyConfigs[j].sku){
                                    _isSku = true;
                                }
                            }
                            if(!_isSku){
                                var maxIndex= indexEs.length ==0 ? 0: Math.max.apply(null, indexEs);
                                var _obj = {
                                    sku: vm.data.name + '-' + _arr[i].name,
                                    skuSeq: _arr[i].number,
                                    number: vm.data.number + '-' + (maxIndex + 1),
                                    createdDate: day,
                                    minStorage: 0,
                                    warehouseConfigs: null
                                };
                                vm.data.propertyConfigs.push(_obj);
                            }
                        }
                    }
                    console.log(vm.data.propertyConfigs)
                }
            });
        }
        $scope.itemEdit = function (){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/product-itmes.html',
                controller: 'ProductItemsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return angular.copy(vm.data.items);
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    var _isE=true;
                    if(!vm.data.items){vm.data.items=[]};
                    for(var i=0;i<vm.data.items.length;i++){
                        var _isE1 = false;
                        backData.forEach(function (item){
                            if(vm.data.items[i].id == item.id){
                                _isE1 = true;
                            }
                        })
                        if(!_isE1){
                            _isE = false;
                            break
                        }
                    }
                    if(!_isE || vm.data.items.length != backData.length){
                        vm.data.items = backData;
                        vm.data.propertyConfigs = [];
                    }
                }
            });

        }
        function getCombination (array) {
            if(array.length > 0){
                var _arr = [];
                if (array.length < 2) {
                    for(var j =0; j<array[0].length; j++){
                        _arr.push([{
                            name:array[0][j].name,
                            number:array[0][j].number,
                        }])
                    }
                }else {
                    _arr = [].reduce.call(array, function (col, set) {
                        var res = [];
                        col.forEach(function (c) {
                            set.forEach(function (s) {
                                var t = [].concat(Array.isArray(c) ? c : [c]);
                                t.push(s);
                                res.push(t);
                            })
                        });
                        return res;
                    });
                }
                for(var i=0; i<_arr.length; i++){
                    var _h = '';
                    var _n = '';
                    var _arrI = _arr[i].sort();
                    for(var j=0; j<_arrI.length; j++){
                        _h += '-' + _arrI[j].name;
                        _n += '-' + _arrI[j].number;
                    }
                    _arr[i] = {
                        name:_h.substring(1),
                        number:_n.substring(1),
                    }
                }
                return _arr
            }
        }
        vm.name = "";
        $scope.nameFocus = function (){
            vm.isSaving = true;
            vm.name = angular.copy(vm.data.name);
        }
        $scope.nameBlur = function (){
            if(vm.data.propertyConfigs.length>0 && vm.data.name != vm.name){
                MessageService.confirm("商品名称变更，将同步更新sku名称，是否确认变更？", function () {
                    vm.data.propertyConfigs.forEach(function (propertyConfig){
                        propertyConfig.sku = vm.data.name + removeFirstOccurrence(propertyConfig.sku,vm.name)
                    })
                    vm.isSaving = false;
                },function (){
                    vm.data.name = vm.name;
                    vm.isSaving = false;
                });
            }else{
                vm.isSaving = false;
            }
        }

        function removeFirstOccurrence(str, substr) {
            var regex = new RegExp(substr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), '');
            return str.replace(regex, '');
        }
        $scope.nameKeypress = function ($event){
            if ($event.keyCode === 13) {
                document.getElementById('nameId').blur();
            }
        }
        //商品属性删除
        $scope.propertyDelete = function (data, index) {
            if (!!data.id) {
                data.cancelled = true;
                data.skuNumber = null
            }else{
                vm.data.propertyConfigs.splice(index, 1);
            }
        };

        //设置最小库存预警
        $scope.warningSet = function(index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/minWarning.html',
                controller: 'MinWarningController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {type: vm.data.category == 'MaterialProduct' ? true : false}
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data.propertyConfigs[index].minStorage = backData.minStorage;
                    vm.data.propertyConfigs[index].warehouseConfigs = backData.warehouseConfigs;
                }
            });
        }
        $scope.warningEdit = function(data,index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/minWarning.html',
                controller: 'MinWarningController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {type: false, data: data};
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data.propertyConfigs[index].minStorage = backData.minStorage;
                    vm.data.propertyConfigs[index].warehouseConfigs = backData.warehouseConfigs;
                }
            });
        };
        //辅料设置
        $scope.ingredientsSet = function(index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/ingredients.html',
                controller: 'IngredientsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data.propertyConfigs[index].materialConfigs = backData;
                }
            });
        };
        $scope.ingredientsEdit = function(data, index){
            $uibModal.open({
                templateUrl: 'app/product/finished/modal/ingredients.html',
                controller: 'IngredientsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return data.materialConfigs
                    }]
                }
            }).result.then(function (backData) {
                if(typeof backData == "object"){
                    vm.data.propertyConfigs[index].materialConfigs = backData;
                }
            });
        };

        //保存
        $scope.save = function () {
            if(vm.isSaving){
                return
            }
            if(!vm.data.name){
                MessageService.error("商品名称不能为空");
                return;
            }
            if(!vm.data.category){
                MessageService.error("商品类型不能为空");
                return;
            }
            if(!vm.data.productCategoryId){
                MessageService.error("商品品类不能为空");
                return;
            }
            if(!vm.data.measurementId){
                MessageService.error("计量单位不能为空");
                return;
            }

            if(vm.data.propertyConfigs.length == 0){
                MessageService.error("属性不能为空");
                return;
            }
            vm.isSaving = true;
            if(!vm.data.id){
                var _data = angular.copy(vm.data);
                for(var i=0; i<_data.propertyConfigs.length; i++){
                    _data.propertyConfigs[i].number = _data.number + '-' + (Number(i)+Number(1));
                    _data.propertyConfigs[i].sort = Number(i) + Number(1);
                }
                Product.save(_data, function (res) {
                    MessageService.success("保存成功");
                    window.history.back();
                }, function (error) {
                    vm.isSaving = false;
                    MessageService.error(error.data.message || "保存失败，请检查是否误删使用中的商品SKU");
                });
            }else{
                Product.update(vm.data, function (res) {
                    console.log(vm.data);
                    MessageService.success("保存成功");
                    window.history.back();
                }, function (error) {
                    vm.isSaving = false;
                    MessageService.error(error.data.message || "保存失败，请检查是否误删使用中的商品SKU");
                });
            }
        }

        //验证sku编号是否重复
        $scope.skuNumberChange = function (e, item,index){
            if(!item.skuNumber){
                vm.isSaving = false;
                return
            }
            for(var i=0;i<vm.data.propertyConfigs.length;i++){
                if(i != index && item.skuNumber == vm.data.propertyConfigs[i].skuNumber){
                    MessageService.error('规格【' + item.sku + "】的sku编号已存在");
                    item.skuNumber="";
                    vm.isSaving = false;
                    return false
                }
            }
        }

        //返回
        $scope.goBack = function () {
            window.history.back();
        }


        //清除方法
        $scope.productionCb = function () {
            if(!vm.data.producible){
                warningTime()
            }
        };
        $scope.autoOutsourcingCb = function () {
            if(!vm.data.autoOutsourcing){
                autoOutsourcing()
            }
        };

        vm.tokens = Qinius.get();
        vm.domains = Qinius.getDomain();

        $q.all([vm.tokens.$promise, vm.domains.$promise]).then(function(){
            vm.token = vm.tokens.token;
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
        })

        $scope.removeFile = function () {
            vm.data.previewImg = null;
        };
        window.updateImg = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('token', vm.token);
                $.ajax({


                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.data.previewImg = $scope.domain + data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.removeSkuFile = function (data) {
            data.previewImg = null;
        };
        window.updateSkuImg = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var index = $($event.target).attr('index');
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.data.propertyConfigs[index].previewImg = $scope.domain + data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        //预警时间
        function warningTime() {
            vm.data.warningTime = "";
        }
        //流转配置
        function autoOutsourcing() {
            vm.data.productCirculations = [];
        }
        $scope.categoryInfo = function (item){
            switch (item) {
                case 'OrderingProduct':
                    return '定制品';
                case 'GeneralProduct':
                    return '成品';
                case 'MaterialProduct':
                    return '辅料';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CommodityController', CommodityController);

    CommodityController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','Product', 'ParseLinks', '$uibModal', 'ProductCategory', 'Makeups', '$timeout', '$stateParams'];

    function CommodityController ($scope, Principal, LoginService, $state,User,MessageService, Product, ParseLinks, $uibModal, ProductCategory, Makeups, $timeout, $stateParams) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PRODUCT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有商品访问的权限！");
                $state.go("home");
            }
        });
        vm.productType = $stateParams.productType;
        vm.isTableState = false;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        // vm.conditionList = [{name:'全部', id:''}];
        vm.typeList = [
            {name:'内部', value:'内部'},
            {name:'供应商', value: '供应商'}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ["lastModifiedDate,DESC"],
            keyword: '',
            categoryId: '',
            skuNumber: '',
        };
        vm.productCategorySecond = [];
        ProductCategory.byCondition({items: [{key: 'subordinate', op: '=', value: false}, {key: 'enable', op: '=', value: true},{key: 'sort', op: '=', value: vm.productType === 'GeneralProduct' ? 'product' :vm.productType === 'MaterialProduct' ? 'accessories' :''}]}, function(value){
            vm.productCategoryFirst =  value;

        })

        $scope.changeSearchCategoryFirst = function(){
            vm.productCategorySecond = [];
            if (vm.tableData.parentCategoryId == null) {
                return;
            }
            for(var i = 0 ; i< vm.productCategoryFirst.length; i++){
                var c =  vm.productCategoryFirst[i];
                //获取二级分类
                if (c.id == vm.tableData.parentCategoryId) {
                    ProductCategory.byCondition({items:
                        [{key: 'subordinate', op: '=', value: true}, {key: 'enable', op: '=', value: true},{key: 'productCategory.id', op: '=', value: c.id}]
                    }, function (res) {
                        vm.productCategorySecond = res;
                    });
                }
            }
        }

        init()
        function init() {
            vm.tableList = [];
            var items = [{key:"category",op:"=",value:$stateParams.productType},{key:"propertyConfigs.cancelled",op:"=",value:false}];
            if(vm.tableData.keyword){
                items.push({key:"name",op:"like",value:vm.tableData.keyword})
            }
            if(vm.tableData.skuNumber){
                items.push({key:"propertyConfigs.skuNumber",op:"like",value:vm.tableData.skuNumber})
            }
            if(vm.tableData.categoryId){
                items.push({key:"productCategory.id",op:"=",value:vm.tableData.categoryId})
            }
            if(vm.tableData.parentCategoryId){
                items.push({key:"productCategory.productCategory.id",op:"=",value:vm.tableData.parentCategoryId})
            }
            Product.byCondition({
                items: items,
                page: vm.tableData.page,
                size: vm.tableData.size,
                sort: vm.tableData.sort
            }, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                for(var i=0;i<res.length;i++){
                    for(var j=0;j<res[i].productCirculations.length; j++){
                        if(res[i].productCirculations[j].defaulted){
                            res[i].productCirculationsList = res[i].productCirculations[j];
                        }
                    }
                }
                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.conditionSelect = function(data){
            vm.tableData.categoryId = data.id;
            vm.tableData.page = 0;
            init();
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.clear = function(){
            vm.tableData = {
                page: Number($stateParams.page) || 0,
                size: 20,
                sort: ["lastModifiedDate,DESC"],
                keyword: '',
                categoryId: '',
                skuNumber: '',
            };
            init();
        }
        //删除
        $scope.roleDelete = function (data) {
            MessageService.confirm("确认要删除该商品？", function () {
                Product.delete({id: data.id}, function () {
                    init();
                    MessageService.success("商品删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };

        $scope.tableStateBtn = function () {
            var _h = angular.element(".table-top").height();
            if(_h > 40){
                angular.element(".table-top").height("40");
                angular.element(".table-state-btn").removeClass("table-state-btnOn");
            }else {
                angular.element(".table-top").height("auto");
                angular.element(".table-state-btn").addClass("table-state-btnOn");
            }
        }
        window.onresize = function(){
            var _h = angular.element(".table-top").find(".table-state").height();
            $timeout(function () {
                if(_h > 40){
                    vm.isTableState = true;
                }else {
                    vm.isTableState = false;
                }
            })
        }
        $scope.productTypeInfo = function (item){
            switch (item) {
                case 'OrderingProduct':
                    return '定制品';
                case 'GeneralProduct':
                    return '成品';
                case 'MaterialProduct':
                    return '辅料';
                default:
                    return item
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ClassifyAddController', ClassifyAddController);

    ClassifyAddController.$inject = ['$scope', 'Principal', 'LoginService', '$state','ProductCategory','MessageService', 'Permission', 'entity', '$uibModalInstance'];

    function ClassifyAddController ($scope, Principal, LoginService, $state,ProductCategory,MessageService, Permission, entity, $uibModalInstance) {
        var vm = this;
        vm.getPcgs = getPcgs;
        vm.getPcg2 = getPcg2;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_CLASSIFY').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有分类管理访问的权限！");
                $state.go("home");
            }
        });
        // accessories 辅料 / product 成品
        vm.typeList = [
            {name:'商品类', value: 'product'},
            {name:'辅材类', value: 'accessories'}
        ];

        vm.data = entity;
        if (vm.data.state) {
            vm.saveData = {
                name: "",
                sort: "",
                enable: true,
                subordinate: false
            };
            vm.title = "新建分类";
        }else {
            vm.title = "编辑分类";
            ProductCategory.gets({id: vm.data.data.id}, function (res) {
                vm.saveData = res;
                ProductCategory.getAllSuperior({type: vm.saveData.sort}, function(res) {
                    vm.pcgs = res;

                    for (var i = 0; i < vm.pcgs.length; i++) {
                        if (vm.pcgs[i].id == vm.saveData.superiorId) {
                            vm.pcg = vm.pcgs[i];
                        }
                    }
                });

            });
        }

        function getPcg2(pcg) {
            if (pcg != null) {
                vm.saveData.superiorId = pcg.id;
            }
        }

        function getPcgs() {
            vm.pcgs = ProductCategory.getAllSuperior({type: vm.saveData.sort});
        }

        $scope.subordinateCb = function(){
            if(!vm.saveData.subordinate){
                vm.saveData.superiorId = "";
                vm.saveData.superiorName = "";
                vm.pcg = {}
            }
        }

        $scope.save = function() {
            if(!vm.saveData.name){
                MessageService.error("分类名称不能为空");
                return;
            }
            if(!vm.saveData.name.length>20){
                MessageService.error("分类名称不能超过20位");
                return;
            }
            if(!vm.saveData.sort){
                MessageService.error("类型不能为空");
                return;
            }
            if(!vm.saveData.categoryCode){
                MessageService.error("编码规则不能为空");
                return;
            }
            if(vm.saveData.categoryCode.length>4){
                MessageService.error("编码规则小于等于4位字符");
                return;
            }
            if (vm.saveData.subordinate && !vm.saveData.superiorId) {
                MessageService.error("上级不能为空");
                return;
            }
            vm.isSaving = true;
            ProductCategory.save(vm.saveData, function (res) {
                vm.isSaving = false;
                MessageService.success("保存成功");
                $uibModalInstance.close(true);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("保存失败，请稍后重试!");
            });
        };

        $scope.saveEdit = function(){
            if(!vm.saveData.name){
                MessageService.error("分类名称不能为空");
                return;
            }
            if(vm.saveData.name.length>20){
                MessageService.error("分类名称不能超过20位");
                return;
            }
            if(!vm.saveData.categoryCode){
                MessageService.error("编码规则不能为空");
                return;
            }
            if(vm.saveData.categoryCode.length>4){
                MessageService.error("编码规则小于等于4位字符");
                return;
            }
            if (vm.saveData.subordinate && !vm.saveData.superiorId) {
                MessageService.error("上级不能为空");
                return;
            }
            vm.isSavingEdit = true;
            ProductCategory.update(vm.saveData, function (res) {
                vm.isSavingEdit = false;
                MessageService.success("修改成功");
                $uibModalInstance.close(true);
            }, function (error) {
                vm.isSavingEdit = false;
                MessageService.error("保存失败，请检测数据是否正确!");
            });
        };

        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ClassifyController', ClassifyController);

    ClassifyController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal'];

    function ClassifyController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_CLASSIFY').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有分类管理访问的权限！");
                $state.go("home");
            }
        });
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: 0,
            sort: 'lastModifiedDate,DESC',
            size: 20,
            keyword: ''
        };
        vm.typeList = [
            {name:'内部', value:'内部'},
            {name:'供应商', value: '供应商'}
        ];
        init()
        function init() {
            vm.tableList = [];
            ProductCategory.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        //删除
        $scope.roleDelete = function (data) {
            MessageService.confirm("确认要删除该分类？", function () {
                ProductCategory.delete({id: data.id}, function () {
                    init();
                    MessageService.success("角色删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };
        //新增分类
        $scope.classifyAdd = function (){
            $uibModal.open({
                templateUrl: 'app/product/classify-add.html',
                controller: 'ClassifyAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        var obj = {
                            state: true
                        }
                        return obj;
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        };
        //编辑分类
        $scope.classifyEdit = function (data) {
            $uibModal.open({
                templateUrl: 'app/product/classify-add.html',
                controller: 'ClassifyAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        var obj = {
                            data: data,
                            state: false
                        }
                        return obj;
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PrePressController', PrePressController);

    PrePressController.$inject = ['$scope', 'Principal', 'DateUtils', '$state', 'OrderMakeupFile','$uibModal','MessageService', 'ParseLinks',
    'Supplier','SalesOrder',   '$localStorage','$http', '$location', 'PrePressFlow'];

    function PrePressController ($scope, Principal, DateUtils, $state, OrderMakeupFile,$uibModal,MessageService, ParseLinks,
     Supplier,SalesOrder,  $localStorage, $http, $location, PrePressFlow) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_PREPRESS').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.token = $localStorage.authenticationToken;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tablePitch = '';

        $scope.selectSupplier =function(data){
            vm.tableData.makeupId = "";
            if(data){
                vm.tableData.supId = data.id;
            }else {
                vm.tableData.supId = "";
            }
        };

        PrePressFlow.getAll({},function(res){
            vm.prePressList = res.filter(function(item){return item.enable});
        });


        $scope.view = function(){
            if ($scope.checked.length == 0|| $scope.checked.length>1) {
                MessageService.error("请勾选一个查看详情");
                return;
            }
            $uibModal.open({
                templateUrl: 'app/outsourcing/order-list.html',
                controller: 'MakeUpOrderListController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        var _obg = {
                            sourceId: $scope.checked[0],
                        };
                        return _obg;
                    },
                    entity: ['SalesOrder','$stateParams', function(SalesOrder, $stateParams) {
                        return SalesOrder.getByOrderMakeupFileId({orderMakeupFileId : $scope.checked[0]}).$promise;
                    }]
                }
            }).result.then(function (result) {
            });
        }

        vm.conditionList = [
            {name:'全部', id:""},
            {name: '处理中', id: 'InMakeup'},
            {name: '已处理', id: 'Makeuped'}
        ];
        vm.isFilter = false;

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number($location.search().page) || 0,
            size: 20,
            makeupStatus: $location.search().makeupStatus || '',
            startDate: $location.search().startDate || '',
            endDate: $location.search().endDate || '',
            supId: $location.search().supId || '',
            makeupId: Number($location.search().makeupId) || '',
            keyword: $location.search().keyword || ''
        };
        angular.element("#startDate").val($location.search().startDate || null);
        angular.element("#endDate").val($location.search().endDate || null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.isFilter = vm.tableData.supId || vm.tableData.makeupId || vm.tableData.back ? true : false;

        $scope.selectOne = function () {
            angular.forEach(vm.orderMakeupFiles , function (item) {
                var index = $scope.checked.indexOf(item.id);
                if(item.checked && index === -1) {
                    $scope.checked.push(item.id);
                } else if (!item.checked && index !== -1){
                    $scope.checked.splice(index, 1);
                };
            });
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        init();
        function init() {
            $scope.checked = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());

            $location.search({
                'page':vm.tableData.page,
                'makeupStatus':vm.tableData.makeupStatus,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'makeupType': vm.tableData.prePressId,
                'keyword': vm.tableData.keyword
            });
            var items = [{key:"prePressStatus",op:"in", value:"InMakeup;Makeuped"}];
            if (!!vm.tableData.makeupStatus) {
                items.push({key:"prePressStatus",  op:"=", value:vm.tableData.makeupStatus});
            }
            if (!!vm.tableData.keyword) {
                items.push({key:"prePressFlow.name", op:"like", value:vm.tableData.keyword});
                items.push({key:"sourceOrderNumber", op:"like", value:vm.tableData.keyword});
            }
            if (!!vm.tableData.prePressId) {
                items.push({key:"prePressFlow.id", op:"=", value:vm.tableData.prePressId});
            }
            if (!!vm.tableData.startDate) {//T16:00:00.000Z
                items.push({key:"createdDate", op:">=", value: new Date(vm.tableData.startDate+' 00:00:00') });
            }
            if (!!vm.tableData.endDate) {
                items.push({key:"createdDate", op:"<=", value: new Date(vm.tableData.endDate+' 23:59:59')});
            }
            SalesOrder.byCondition({items:items}, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                angular.forEach(res , function (e) {
                    if (e.filePath) {
                        e.filePath = decodeURI(e.filePath);
                    }
                });
                vm.orderMakeupFiles = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.conditionSelect = function(data){
            vm.tableData.makeupStatus = data.id;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                makeupStatus:'',
                startDate: '',
                endDate: '',
                supId: '',
                makeupId: '',
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            vm.supplier = "";
            init();
        };



        vm.getStatus = getStatus;
         function getStatus(target) {

            // 下面的字段内容与后台枚举[OrderStatus]字段对应
            switch (target) {
                case "Makeuped":
                    return "印前已处理";
                case "InMakeup":
                    return "印前处理中";
                default:
                    return "没有对应的状态";
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutsourcingTaskController', OutsourcingTaskController);

    OutsourcingTaskController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','$uibModal','MessageService', 'ParseLinks', 'Supplier','SalesOrder', 'Product', '$localStorage','$http', '$location'];

    function OutsourcingTaskController ($scope, Principal, LoginService, $state,User,$uibModal,MessageService, ParseLinks, Supplier,SalesOrder, Product, $localStorage, $http, $location) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_ENTRUST').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.token = $localStorage.authenticationToken;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tablePitch = '';
        vm.stateList = [
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'被冻结', value: 'Freeze'},
            {name:'待发货', value: 'ToBeDelviery'},
            {name:'外发失败', value: 'OutFailed'}
        ];

        vm.makeups= [
            {name: '未拼版', id: 'NoMakeup'},
            {name: '拼版中', id: 'InMakeup'},
            {name: '已拼版', id: 'Makeuped'}
        ];
        $scope.selectSupplier =function(data){
            vm.tableData.makeupId = "";
            if(data){
                vm.tableData.supplierId = data.id;
            }else {
                vm.tableData.supplierId = "";
            }
        };
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];

        vm.conditionList = [
            {name:'全部', value:''},
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'外发失败', value: 'OutFailed'},
        ];
        vm.isFilter = false;

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number($location.search().page) || 0,
            size: 20,
            taskList:true,//生产中心默认字段  区别于订单中心的下载
            state: $location.search().state || '',
            startDate: $location.search().startDate || '',
            endDate: $location.search().endDate || '',
            supplierId: $location.search().supplierId || '',
            makeupId: Number($location.search().makeupId) || '',
            back: $location.search().back || '',
            productId: $location.search().productId || '',
            orderType:"Ordering",
            keyword: $location.search().keyword || ''
        };
        angular.element("#startDate").val($location.search().startDate || null);
        angular.element("#endDate").val($location.search().endDate || null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.isFilter = vm.tableData.supplierId || vm.tableData.makeupId || vm.tableData.back ? true : false;
        Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]}, function (res) {
            vm.productList = res.filter(function(item){return item.enable;});
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                    }
                }
            }
        });
        Supplier.getAll("", function (res) {
            vm.suppliers = res.filter(function(item){return item.enable;});
            if(vm.tableData.supplierId != ''){
                for(var i=0; i<vm.suppliers.length; i++ ){
                    if(vm.suppliers[i].id == vm.tableData.supplierId){
                        vm.supplier = vm.suppliers[i];
                        vm.makeups = vm.suppliers[i].makeups;
                        // setTimeout(function () {
                        //     vm.tableData.makeupId = Number($location.search().makeupId) || '';
                        // },200)
                    }
                }
            }
        });

        $scope.selectAll = function () {
            if($scope.select_all) {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = true;
                })
                $scope.checked = vm.salesOrders.map(function(value){
                    return value.id;
                })
            }else {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = false;
                    $scope.checked = [];
                })
            }
        };
        // $scope.selectSupplier =function(data){
        //     if(data){
        //         vm.tableData.supplierId = data.id;
        //     }else {
        //         vm.tableData.supplierId = "";
        //     }
        // };
        $scope.selectProduct =function(data){
            if(data){
                vm.tableData.productId = data.id;
            }else {
                vm.tableData.productId = "";
            }
        };
        $scope.selectOne = function () {
            angular.forEach(vm.salesOrders , function (item) {
                var index = $scope.checked.indexOf(item.id);
                if(item.checked && index === -1) {
                    $scope.checked.push(item.id);
                } else if (!item.checked && index !== -1){
                    $scope.checked.splice(index, 1);
                };
            });

            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };


        // $scope.tableTr = function(data){
        //     vm.tablePitch = data;
        // };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        init();
        function init() {
            $scope.checked = [];
            $scope.select_all = false;
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());

            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'supplierId': vm.tableData.supplierId,
                'makeupId': vm.tableData.makeupId,
                'back': vm.tableData.back,
                'productId': vm.tableData.productId,
                'keyword': vm.tableData.keyword
            });
            SalesOrder.query(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                taskList:true,
                page: 0,
                size: 20,
                state:'',
                startDate: '',
                endDate: '',
                supplierId: '',
                makeupId: '',
                back: '',
                productId: ''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            vm.supplier = "";
            vm.product = "";
            init();
        };
        //查看订单
        //$scope.orderLook = function () {
        //    $state.go('orderDetails',{id:vm.tablePitch.id});
        //};


        // 分配
        $scope.distributeTask = function(){
            if($scope.checked.length >0) {
                var _arr = [];
                for(var i=0; i<vm.salesOrders.length; i++){
                    for(var j=0; j<$scope.checked.length; j++){
                        if($scope.checked[j] == vm.salesOrders[i].id){
                            _arr.push(vm.salesOrders[i])
                        }
                    }
                }
                for(var k=0; k<_arr.length; k++){
                    if(_arr[k].status != "ToBeAssigned"){
                        MessageService.error("该订单不能再分配");
                        return
                    }
                    if(_arr[0].productId != _arr[k].productId){
                        MessageService.error("请选择相同的商品");
                        return
                    }
                }
                $uibModal.open({
                    templateUrl: 'app/outsourcing/distribute.html',
                    controller: 'DistributeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('supplier');
                            return $translate.refresh();
                        }],
                        msgdata: function () {
                            var _obg = {
                                outsources: $scope.checked,
                                productId: _arr[0].productId,
                                propertyId: _arr[0].propertyId
                            };
                            return _obg;
                        },
                        entity: function () {
                            return null;
                        }
                    }
                }).result.then(function (result) {
                    init();
                    $state.go('outsourcingTask');
                });
            }else{
                MessageService.error("请选择未分配的订单");
            }
        };

        //   撤销
        $scope.revoke = function(){
            //获取未分配订单个数
            if($scope.checked.length >0) {
                var _arr = [];
                for(var i=0; i<vm.salesOrders.length; i++){
                    for(var j=0; j<$scope.checked.length; j++){
                        if($scope.checked[j] == vm.salesOrders[i].id){
                            _arr.push(vm.salesOrders[i])
                        }
                    }
                }
                for(var k=0; k<_arr.length; k++){
                    if(_arr[k].makeupStatus == 'InMakeup' || _arr[k].status == "Freeze" ){
                        MessageService.error("该订单不能撤销");
                        return
                    }

                    if(_arr[k].status != "Assigned" && _arr[k].makeupStatus != 'NoMakeup' && _arr[k].makeupStatus != 'NotRequiredMakeup'){
                        MessageService.error("该订单不能撤销");
                        return
                    }
                }
                MessageService.confirm("确认要撤销该订单？", function () {
                    SalesOrder.noAllot({ids: $scope.checked.join(',')}, function () {
                        MessageService.success("撤销成功");
                        init();
                    }, function (error) {
                        MessageService.error("撤销失败，请重试！");
                    });
                });
            }else{
                MessageService.error("请选择已分配的订单撤销");
            }
        }

        vm.makeupStatus = makeupStatus;
        function makeupStatus(target) {

            // 下面的字段内容与后台枚举[OrderStatus]字段对应
            switch (target) {
                case "NoMakeup":
                    return "未拼版";
                case "Makeuped":
                    return "已拼版";
                case "InMakeup":
                    return "拼版中";
                case "NotRequiredMakeup":
                    return "不拼版";
                default:
                    return "没有对应的状态";
            }
        }

        $scope.getPrePressStatus = function(target) {
            if (target == null || target == "") {
                return;
            }
            switch (target) {
                case "Makeuped":
                    return "印前处理完成";
                case "InMakeup":
                    return "印前处理中";
                default:
                    return "没有对应的状态";
            }
        }

        //下载
        $scope.orderExport = function () {
            $http({
                url: 'api/sales_order/exportData1',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (error) {
                MessageService.error(error.data.message || "导出失败，请重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outsourcingTask', {
                parent: 'module',
                url: '/outsourcingTask',
                data: {
                    authorities: ['ROLE_ENTRUST']
                },
                views: {
                    'content': {
                        templateUrl: 'app/outsourcing/outsourcing-task.html',
                        controller: 'OutsourcingTaskController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
            .state('prePress', {
                parent: 'module',
                url: '/prePress',
                data: {
                    authorities: ['ROLE_PREPRESS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/outsourcing/pre-press.html',
                        controller: 'PrePressController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
            .state('makeUp', {
                parent: 'module',
                url: '/makeUp',
                data: {
                    authorities: ['ROLE_IMPOSITION']
                },
                views: {
                    'content': {
                        templateUrl: 'app/outsourcing/make-up.html',
                        controller: 'MakeUpController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
            .state('expandTask', {
                parent: 'module',
                url: '/expandTask',
                data: {
                    authorities: ['ROLE_OUTPAINT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/outsourcing/expand-task.html',
                        controller: 'ExpandTaskController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
        ;

    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('OrderMakeupFile', OrderMakeupFile)
        .factory('OutpaintFileTasks', OutpaintFileTasks)
        .factory('Outsource', Outsource);

    Outsource.$inject = ['$resource'];
    OutpaintFileTasks.$inject = ['$resource'];
    OrderMakeupFile.$inject = ['$resource'];

    function Outsource ($resource) {
        var resourceUrl =  'api/sales_order/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function OutpaintFileTasks ($resource) {
        var resourceUrl =  'api/outpaint-file-tasks/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                isArray: true,
                params: {
                    path: 'byCondition'
                }
            }
        });
    }

    function OrderMakeupFile ($resource) {
        var resourceUrl =  'api/orderMakeupFile/:id';

        return $resource(resourceUrl, {}, {
            'page': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MakeUpOrderListController', MakeUpOrderListController);

    MakeUpOrderListController.$inject = ['$scope', 'Principal', '$state','$uibModalInstance', 'ParseLinks', 'msgdata', 'MessageService', '$localStorage','$http', '$location', 'entity'];

    function MakeUpOrderListController ($scope, Principal, $state, $uibModalInstance, ParseLinks, msgdata, MessageService,  $localStorage, $http, $location, entity) {
        var vm = this;
        vm.orderList = entity;
        vm.source = msgdata;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_ENTRUST').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        $scope.getQuantity = function(data){
            if (data == null || data.orderToMakeupFiles == null) {
                return 0;
            }
            for (var i = data.orderToMakeupFiles.length - 1; i >= 0; i--) {
                var d = data.orderToMakeupFiles[i];
                if (d.cancelled|| d.orderMakeupFile == null) {
                    continue;
                }
                if (d.orderMakeupFile.id == vm.source.sourceId) {
                    return d.quantity;
                }
            }
        }
        vm.token = $localStorage.authenticationToken;

        $scope.back = function(){
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MakeUpController', MakeUpController);

    MakeUpController.$inject = ['$scope', 'Principal', 'Makeup', '$state', 'OrderMakeupFile','$uibModal','MessageService', 'ParseLinks', 'Supplier','SalesOrder',   '$localStorage','$http', '$location'];

    function MakeUpController ($scope, Principal, Makeup, $state, OrderMakeupFile,$uibModal,MessageService, ParseLinks, Supplier,SalesOrder,  $localStorage, $http, $location) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_ENTRUST').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.token = $localStorage.authenticationToken;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tablePitch = '';

        vm.makeupStatusMap = [
            {name: '未拼版', id: 'NoMakeup'},
            {name: '拼版中', id: 'InMakeup'},
            {name: '已拼版', id: 'Makeuped'}
        ];
        $scope.selectSupplier =function(data){
            vm.tableData.makeupId = "";
            if(data){
                vm.tableData.supId = data.id;
            }else {
                vm.tableData.supId = "";
            }
        };


        $scope.view = function(){
            if ($scope.checked.length == 0|| $scope.checked.length>1) {
                MessageService.error("请勾选一个查看详情");
                return;
            }
            $uibModal.open({
                templateUrl: 'app/outsourcing/order-list.html',
                controller: 'MakeUpOrderListController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        var _obg = {
                            sourceId: $scope.checked[0],
                        };
                        return _obg;
                    },
                    entity: ['SalesOrder','$stateParams', function(SalesOrder, $stateParams) {
                        return SalesOrder.getByOrderMakeupFileId({orderMakeupFileId : $scope.checked[0]}).$promise;
                    }]
                }
            }).result.then(function (result) {
            });
        }

        vm.conditionList = [
            {name:'全部', id:""},
            {name: '未拼版', id: 'NoMakeup'},
            {name: '拼版中', id: 'InMakeup'},
            {name: '已拼版', id: 'Makeuped'}
        ];
        vm.isFilter = false;

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number($location.search().page) || 0,
            size: 20,
            makeupStatus: $location.search().makeupStatus || '',
            startDate: $location.search().startDate || '',
            endDate: $location.search().endDate || '',
            supId: $location.search().supId || '',
            makeupId: Number($location.search().makeupId) || '',
            keyword: $location.search().keyword || ''
        };
        angular.element("#startDate").val($location.search().startDate || null);
        angular.element("#endDate").val($location.search().endDate || null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.isFilter = vm.tableData.supId || vm.tableData.makeupId || vm.tableData.back ? true : false;

        Supplier.getAll("", function (res) {
            vm.suppliers = res.filter(function(item){return item.enable;});
        });

        $scope.selectOne = function () {
            angular.forEach(vm.orderMakeupFiles , function (item) {
                var index = $scope.checked.indexOf(item.id);
                if(item.checked && index === -1) {
                    $scope.checked.push(item.id);
                } else if (!item.checked && index !== -1){
                    $scope.checked.splice(index, 1);
                };
            });
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        Makeup.query({}, function (res, headers) {
            vm.makeups = res;
        }, function (error) {
        });



        init();
        function init() {
            $scope.checked = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());


            $location.search({
                'page':vm.tableData.page,
                'makeupStatus':vm.tableData.makeupStatus,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'supId': vm.tableData.supId,
                'makeupType': vm.tableData.makeupId,
                'keyword': vm.tableData.keyword
            });
            OrderMakeupFile.page(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                angular.forEach(res , function (e) {
                    if (e.filePath) {
                        e.filePath = decodeURI(e.filePath);
                        // if (e.filePath.length>20) {
                        //     e.filePathStr = e.filePath.substring(34);
                        // }
                    }
                });
                vm.orderMakeupFiles = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.conditionSelect = function(data){
            vm.tableData.makeupStatus = data.id;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                makeupStatus:'',
                startDate: '',
                endDate: '',
                supId: '',
                makeupId: '',
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            vm.supplier = "";
            init();
        };


        //   撤销
        $scope.revoke = function(){
            //获取未分配订单个数
            if($scope.checked.length >0) {
                var _arr = [];
                for(var i=0; i<vm.orderMakeupFiles.length; i++){
                    for(var j=0; j<$scope.checked.length; j++){
                        if($scope.checked[j] == vm.orderMakeupFiles[i].id){
                            _arr.push(vm.orderMakeupFiles[i])
                        }
                    }
                }
                for(var k=0; k<_arr.length; k++){
                    if(_arr[k].makeupStatus == 'InMakeup'){
                        MessageService.error("该订单不能撤销");
                        return
                    }
                }
                MessageService.confirm("确认要撤销该订单？", function () {
                    SalesOrder.noAllotMakeUpId({makeupFileIds: $scope.checked.join(',')}, function () {
                        MessageService.success("撤销成功");
                        init();
                    }, function (error) {
                        MessageService.error("撤销失败，请重试！");
                    });
                });
            }else{
                MessageService.error("请选择已分配的订单撤销");
            }
        }

        vm.makeupStatus = makeupStatus;
         function makeupStatus(target) {

            // 下面的字段内容与后台枚举[OrderStatus]字段对应
            switch (target) {
                case "NoMakeup":
                    return "未拼版";
                case "Makeuped":
                    return "已拼版";
                case "InMakeup":
                    return "拼版中";
                case "NotRequiredMakeup":
                    return "不拼版";
                default:
                    return "没有对应的状态";
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ExpandTaskController', ExpandTaskController);

        ExpandTaskController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','$uibModal','MessageService', 'ParseLinks', 'Supplier','OutpaintFileTasks', 'Product', '$localStorage','$http', '$location', 'DateUtils'];

    function ExpandTaskController ($scope, Principal, LoginService, $state,User,$uibModal,MessageService, ParseLinks, Supplier,OutpaintFileTasks, Product, $localStorage, $http, $location, DateUtils) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_OUTPAINT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.token = $localStorage.authenticationToken;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        vm.stateList = [
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'被冻结', value: 'Freeze'},
            {name:'外发失败', value: 'OutFailed'}
        ];

        vm.conditionList = [
            {name:'全部', value:''},
            {name:'处理中', value:'PROCESSING'},
            {name:'已处理', value: 'FINISHED'},
            {name:'处理异常', value: 'FAILED'},
        ];
        vm.isFilter = false;

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number($location.search().page) || 0,
            size: 20,
            state: $location.search().state || '',
            startDate: $location.search().startDate || '',
            endDate: $location.search().endDate || '',
            productId: $location.search().productId || '',
            keyword: $location.search().keyword || ''
        };
        angular.element("#startDate").val($location.search().startDate || null);
        angular.element("#endDate").val($location.search().endDate || null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
            vm.productList = res.filter(function(item){return item.enable;});
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                    }
                }
            }
        });

        $scope.selectAll = function () {
            if($scope.select_all) {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = true;
                })
                $scope.checked = vm.salesOrders.map(function(value){
                    return value.id;
                })
            }else {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = false;
                    $scope.checked = [];
                })
            }
        };
        $scope.selectProduct =function(data){
            if(data){
                vm.tableData.productId = data.id;
            }else {
                vm.tableData.productId = "";
            }
        };
        $scope.selectOne = function () {
            angular.forEach(vm.salesOrders , function (item) {
                var index = $scope.checked.indexOf(item.id);
                if(item.checked && index === -1) {
                    $scope.checked.push(item.id);
                } else if (!item.checked && index !== -1){
                    $scope.checked.splice(index, 1);
                };
            });

            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        init();
        function init() {
            $scope.checked = [];
            $scope.select_all = false;
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'makeupId': vm.tableData.makeupId,
                'back': vm.tableData.back,
                'productId': vm.tableData.productId,
                'keyword': vm.tableData.keyword
            });
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            var _data = {
                page: vm.tableData.page,
                size: 20,
                items: [
                    {key: 'createdDate', op: '>', value: DateUtils.dayStart(vm.tableData.startDate)},
                    {key: 'createdDate', op: '<=', value: DateUtils.dayEnd(vm.tableData.endDate)},
                    {key: 'salesOrder.number', op: 'like', value: vm.tableData.keyword},
                    {key: 'salesOrder.propertyConfig.product.id', op: '=', value: vm.tableData.productId},
                    {key: 'status', op: '=', value: vm.tableData.state},
                ]
            }
            OutpaintFileTasks.byCondition(_data, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                startDate: '',
                endDate: '',
                productId: ''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            vm.supplier = "";
            vm.product = "";
            init();
        };

        //下载
        $scope.orderExport = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $http({
                url: 'api/outpaint-file-tasks/exportByCondition',
                method: "POST",
                data: {
                    page: vm.tableData.page,
                    size: 20,
                    items: [
                        {key: 'createdDate', op: '>', value: DateUtils.dayStart(vm.tableData.startDate)},
                        {key: 'createdDate', op: '<=', value: DateUtils.dayEnd(vm.tableData.endDate)},
                        {key: 'salesOrder.number', op: 'like', value: vm.tableData.keyword},
                        {key: 'salesOrder.propertyConfig.product.id', op: '=', value: vm.tableData.productId},
                        {key: 'status', op: '=', value: vm.tableData.state},
                    ]
                },
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = '扩边任务' + Date.now() + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (error) {
                MessageService.error(error.data.message || "导出失败，请重试！");
            });
        };


        $scope.status = function(target) {
            switch (target) {
                case "PENDING":
                    return "待处理";
                case "PROCESSING":
                    return "处理中";
                case "FINISHED":
                    return "已处理";
                case "FAILED":
                    return "处理异常";
                default:
                    return "没有对应的状态";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DistributeController', DistributeController);

    DistributeController.$inject = ['$scope', 'LoginService', '$state', 'msgdata', '$uibModal', '$uibModalInstance', 'MessageService',
    'Supplier','SalesOrder','Product', 'Makeup'];

    function DistributeController ($scope, LoginService, $state, msgdata, $uibModal, $uibModalInstance, MessageService, 
        Supplier, SalesOrder, Product, Makeup) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        Supplier.getAll(function(res){
            vm.suppliers = res.filter(function(item){return item.enable;})
        });

        $scope.selectSupplier =function(data){
            console.log(data.productionManages);
            vm.productionManages = data.productionManages;
            vm.productionManages2 = [];
            for (var i = vm.productionManages.length - 1; i >= 0; i--) {
                if (vm.productionManages[i].productId == msgdata.productId) {
                    for (var j = vm.productionManages[i].skuManageList.length - 1; j >= 0; j--) {
                        if (vm.productionManages[i].skuManageList[j].propertyId == msgdata.propertyId) {
                            vm.makeup = vm.productionManages[i].skuManageList[j].makeup;
                            vm.productionManages2.push(vm.productionManages[i].skuManageList[j].makeup);
                        }
                    }
                }
            }

            // 说明没有配置拼版方式--获取全部拼版方式
            if (vm.makeup == null) {
                // vm.productionManages2 = Makeup.getAll();
            }
        };
        vm.outsources = msgdata.outsources;
        vm.productId = msgdata.productId;

        Product.get({id: vm.productId}, function (res) {
            //    是否拼版    OrderingProduct:定制商品(有拼版)   StandardProduct:标准印品(可能有拼版)   GeneralProduct:标准通品（无拼版）
            if(res.category == 'GeneralProduct'){
                vm.makeupOrNot =false;
            }else{
                vm.makeupOrNot =true;
            }
        });

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.validate = function () {
             if (vm.supplier == null || vm.supplier == "") {
                 MessageService.error("生产商不能为空");
                 return false;
             }
            return true;
        };

        function save () {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj = {
                ids: vm.outsources.join(','),
                supplierId: vm.supplier.id,
                makeupId: vm.makeup == undefined ? '0' : vm.makeup.id
            };

            SalesOrder.allot(obj, function(res) {
                vm.isSaving = false;
                if (res.state == '4000') {
                    MessageService.error("供应商余额不足，分配失败");
                } else if (res.state == '200') {
                    MessageService.success('分配成功');
                    $uibModalInstance.close(res);
                    $state.go('outsourcingTask');
                }
            },function(error){
                vm.isSaving = false;
                MessageService.error("分配失败");
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderVipDetailsController', OrderVipDetailsController);

    OrderVipDetailsController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks'];

    function OrderVipDetailsController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks) {
        var vm = this;

        //打印
        $scope.printpage = function () {
            var iframe = document.getElementById('print-frame');
            if (iframe === null || iframe === undefined) {
                iframe = document.createElement('iframe');
                iframe.lang = 'en';
                iframe.style.display = 'none';
                iframe.id = 'print-frame';
                document.body.insertBefore(iframe,document.body.children[0]);
                iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title>订单</title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'>";
            }

            setTimeout(function () {
                iframe.contentDocument.body.innerHTML = document.getElementById("printPage").innerHTML;
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            },300);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderWarnController', OrderWarnController);

    OrderWarnController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location'];

    function OrderWarnController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value: 10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.stateList = [
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已发货', value: 'Delivered'}
        ];
        vm.conditionList = [
            {name:'分配预警', value: 'allocation'},
            {name:'生产预警', value: 'production'},
            {name:'发货预警', value: 'shipments'},
            {name:'揽件预警', value: 'collect'},
            {name:'签收预警', value: 'sign'},
            {name:'物流异常', value: 'logisticsAbnormal'}
        ];
        vm.condition = 'allocation';

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            keyword: $stateParams.keyword || $location.search().keyword || '',
            state: 'distribution',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            back: $stateParams.back || $location.search().back || '',
            timeWarning: $stateParams.timeWarning || $location.search().timeWarning || '',
            replenishment: $stateParams.replenishment || $location.search().replenishment || '',
            refund: $stateParams.refund || $location.search().refund || '',
            supplierId: $stateParams.supplierId || $location.search().supplierId || '',
            productId: $stateParams.productId || $location.search().productId ||'',
            sku:$stateParams.sku || $location.search().sku ||'',
            orderType: 'Ordering'
        };
        vm.startDate = $stateParams.startDate || $location.search().startDate || null;
        vm.endDate = $stateParams.endDate || $location.search().endDate || null;
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);
        Supplier.getAll("", function (res) {
            vm.suppliers = res;
            if(vm.tableData.supplierId != ''){
                for(var i=0; i<vm.suppliers.length; i++ ){
                    if(vm.suppliers[i].id == vm.tableData.supplierId){
                        vm.supplier = vm.suppliers[i];
                    }
                }
            }
        });
        Product.getAllByCategory({type: 'OrderingProduct'}, function (res) {
            vm.productList = res;
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                        vm.skuList = vm.productList[i].propertyConfigs;
                    }
                }
            }
        });

        //获取选中的数组
        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }

            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.salesOrders.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        $scope.conditionSelect = function(data){
            vm.condition = data;
            vm.tableData.page = 0;

            if(vm.condition === 'allocation'){
                vm.tableData.state = 'ToBeAssigned';
            }
            if(vm.condition === 'production'){
                vm.tableData.state = 'Assigned';
            }
            if(vm.condition === 'shipments'){
                vm.tableData.state = 'Producing';
            }
            if(vm.condition === 'collect'){
                vm.tableData.state = 'Delivered';
            }
            if(vm.condition === 'sign'){
                vm.tableData.state = 'Receiving';
            }
            if(vm.condition === 'logisticsAbnormal'){
                vm.tableData.state = 'Abnormal';
            }
            init()
        };

        $scope.conditionSelect('allocation');
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(new Date(angular.element("#startDate").val()));
            vm.tableData.endDate = angular.copy(new Date(angular.element("#endDate").val()));
            if(vm.condition === 'allocation'){

            }
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'timeWarning':vm.tableData.timeWarning,
                'supplierId':vm.tableData.supplierId,
                'productId':vm.tableData.productId,
                'keyword':vm.tableData.keyword
            });
            var items = [{key:"cancelled",op:"=",value:false}];
            if(vm.tableData.keyword){items.push({key:"sourceOrderNumber,number",op:"like",value:vm.tableData.keyword})}
            if(vm.tableData.startDate){items.push({key:"createdDate",op:">",value:vm.tableData.startDate})}
            if(vm.tableData.endDate){items.push({key:"createdDate",op:"<=",value:vm.tableData.endDate})}
            if(vm.tableData.supplierId){items.push({key:"supplierId",op:"=",value:vm.tableData.supplierId})}
            if(vm.tableData.state){items.push({key:"status",op:"=",value:vm.tableData.state})}
            if(vm.condition === 'allocation'){
            }
            if(vm.condition === 'production'){
                items.push({key:"admeasureDate",op:"<",value:new Date(frontOneHour('yyyy-MM-dd hh:mm:ss',24))})
            }
            //
            if(vm.condition === 'shipments'){
                items.push({key:"admeasureDate",op:"<",value:new Date(frontOneHour('yyyy-MM-dd hh:mm:ss',24))})
            }
            if(vm.condition === 'collect'){
                items.push({key:"deliveryDate",op:"<",value:new Date(frontOneHour('yyyy-MM-dd hh:mm:ss',48))})
            }
            //
            if(vm.condition === 'sign'){
                items.push({key:"pickDate",op:"<",value:new Date(frontOneHour('yyyy-MM-dd hh:mm:ss',120))})
            }
            SalesOrder.byCondition({
                items:items,
                page: vm.tableData.page,
                size: vm.tableData.size,
                sort: vm.tableData.sort
            }, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });

            //获取订单总数和总张数
            $scope.orderNumberTotal = 0;
            $scope.pageCountTotal = 0;
            SalesOrder.pageWarnCount2({
                items:items,
                page: vm.tableData.page,
                size: vm.tableData.size,
                sort: vm.tableData.sort
            }, function(res) {
                $scope.orderNumberTotal = res.count;
                $scope.pageCountTotal = res.pageCount;
            });
        };

        $scope.selectSupplier =function(data){
            if(data){
                vm.tableData.supplierId = data.id;
            }else {
                vm.tableData.supplierId = "";
            }
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'distribution',
                startDate: '',
                endDate: '',
                timeWarning:'',
                replenishment: '',
                refund: '',
                condition: '全部',
                supplierId: '',
                sku:'',
            };
            vm.startDate = "";
            vm.endDate = "";
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            $scope.conditionSelect('allocation');
            localStorage.removeItem('tableData');
        };
        //查看订单
        $scope.orderLook = function () {
            if($scope.checked.length >1){
                MessageService.error('仅能查看一个订单，请选择！');
                return;
            }else{
                $state.go('orderDetails',{
                    id:$scope.checked[0].id,
                    page: vm.tableData.page,
                    state:vm.tableData.state,
                    startDate:vm.tableData.startDate,
                    endDate:vm.tableData.endDate,
                    timeWarning:vm.tableData.timeWarning,
                    supplierId:vm.tableData.supplierId,
                    productId:vm.tableData.productId,
                    keyword:vm.tableData.keyword
                });
            }
        };
        //客户备注
        $scope.orderRemark = function () {
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单 ！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-remark.html',
                    controller: 'OrderRemarkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return
                        }]
                    }
                }).result.then(function (backData) {
                    // console.log(backData);
                });
            }
        };
        //补货订单
        $scope.orderReplenishment = function(){
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-replenishment.html',
                    controller: 'OrderReplenishmentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked[0]
                        }]
                    }
                }).result.then(function (backData) {
                    if (backData) {
                        init()
                    }
                });
            }
        };

        //选择物流公司
        $scope.orderExpress = function(){
            //如果是已发货状态则不能修改物流公司
            var flagExpress =false;
            angular.forEach($scope.checked,function(item){
                if(item.status =="Delivered"){
                    flagExpress =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('存在已发货的订单，不能修改物流公司，请重新选择！');
                return;
            }else{
                $uibModal.open({
                    templateUrl: 'app/order/order-express.html',
                    controller: 'OrderExpressController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function() {
                            return $scope.checked
                        }]
                    }
                }).result.then(function (backData) {
                    if(backData){
                        init()
                    }
                });
            }
        };
        //修改
        $scope.modification = function(){
            var flagExpress =false;
            var isStatus =false;
            var isStatusProducing =false;
            angular.forEach($scope.checked,function(item, index){
                if(item.status !="Assigned" && item.status !="Producing" && item.status !="Delivered"){
                    flagExpress =true;
                    return;
                }
                if(index>0 && item.status != $scope.checked[index-1].status){
                    isStatus =true;
                    return;
                }
                if(item.status == "Producing" && $scope.checked.length>1){
                    isStatusProducing =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('只能修改已分配、生产中、已发货这三个状态的订单');
                return;
            }
            if(isStatus){
                MessageService.error('请选择相同状态下的订单');
                return;
            }
            if(isStatusProducing){
                MessageService.error('生产中的订单只能选择一个');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }

        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/sales_order/exportData1Warn',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });

        vm.makeupStatus = makeupStatus;
        function makeupStatus(item) {
            switch (item) {
                case "NoMakeup":
                    return "未拼版";
                case "Makeuped":
                    return "已拼版";
                case "InMakeup":
                    return "拼版中";
                case "NotRequiredMakeup":
                    return "不拼版";
                default:
                    return "没有对应的状态";
            }
        }
        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function frontOneHour (fmt,h,time) {
            if(time){
                var currentTime = new Date(new Date(time).getTime() - h * 60 * 60 * 1000)
            }else {
                var currentTime = new Date(new Date().getTime() - h * 60 * 60 * 1000)
            }
            console.log(currentTime) // Wed Jun 20 2018 16:12:12 GMT+0800 (中国标准时间)
            var o = {
                'M+': currentTime.getMonth() + 1, // 月份
                'd+': currentTime.getDate(), // 日
                'h+': currentTime.getHours(), // 小时
                'm+': currentTime.getMinutes(), // 分
                's+': currentTime.getSeconds(), // 秒
                'q+': Math.floor((currentTime.getMonth() + 3) / 3), // 季度
                'S': currentTime.getMilliseconds() // 毫秒
            }
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentTime.getFullYear() + '').substr(4 - RegExp.$1.length))
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
            return fmt
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderUploadCsvController', OrderUploadCsvController);

    OrderUploadCsvController.$inject = ['$scope', '$state', '$location', '$localStorage', 'MessageService','$uibModalInstance', 'Channels', 'Merchant'];

    function OrderUploadCsvController ($scope, $state, $location, $localStorage, MessageService, $uibModalInstance, Channels, Merchant) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.channels = Channels.getAll();

        vm.data = {
            description: ''
        };
        vm.isSaving = false;
        vm.fileObj;
        window.upladFile = function ($event) {
            vm.fileObj = $event.target.files[0]; // js 获取文件对象
        }

        $scope.save= function() {
            var formData = new FormData();
            if (!vm.channel) {
                MessageService.error("请选择渠道名");
                return;
            }
            if (!vm.merchant) {
                MessageService.error("请选择商户名");
                return;
            }
            formData.append('file', vm.fileObj);
            formData.append('merchantId', vm.merchant);

            var url =  $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/sales_order/importFile"; // 接收上传文件的后台地址
            vm.isSaving = true;

            $.ajax({
                cache: true,
                type: "POST",
                url: url,
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                headers: {
                    Authorization: "Bearer " + vm.token
                },
                accept: 'file',
                success: function (data) {
                    angular.element("#file").val("");
                    MessageService.success("导入成功");
                    $uibModalInstance.close(true);
                },
                error: function (error) {
                    angular.element("#file").val("");
                    MessageService.error("文件导入失败，请稍后重试！");
                }
            });
            
        }

        $scope.hide = function () {
            $uibModalInstance.close();
        }

        $scope.changeChannel = function () {
            Merchant.getListByChannel({id: vm.channel}, function(data){
                vm.merchants = data;
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderSelfController', OrderSelfController);

    OrderSelfController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'ProductCategory','OrderPack'];

    function OrderSelfController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, ProductCategory,OrderPack) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.selectedList = []
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.stateList = [
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已发货', value: 'Delivered'}
        ];
        vm.sourceList = [
            {name:'自营订单', value:'self'},
            {name:'第三方平台', value: '第三方平台'},
            {name:'外接订单', value: '外接订单'}
        ];
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.replenishmentList = [
            {name:'是', value: "true"},
            {name:'否', value: "false"}
        ];
        vm.refundList = [
            {name:'是', value: "true"},
            {name:'否', value: "false"}
        ];
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'处理中', value:'FileProcessing'},
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已回件', value: 'Collect'},
            {name:'已发货', value: 'Delivered'},
            {name:'已揽件', value: 'Receiving'},
            {name:'已签收', value: 'Received'},
            {name:'物流异常', value: 'Abnormal'},
            {name:'已撤回', value: 'Deleted'}
        ];
        vm.deliveryMethodList = [
            {name:'自提', value: "Self"},
            {name:'快递', value: "Delivery"}
        ];
        //商品品类 一级
        vm.promoteProducts = ProductCategory.getAllCategory();
        vm.productCategoryId = "";
        vm.productCategorySecondId = "";

        vm.predicate = 'createdDate';
        vm.resolve = false;
        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            keyword: $stateParams.keyword || $location.search().keyword || '',
            state:$stateParams.state || $location.search().state || '',
            source:$stateParams.source || $location.search().source || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || GetDateStr(0),
            back: $stateParams.back || $location.search().back || '',
            timeWarning: $stateParams.timeWarning || $location.search().timeWarning || '',
            replenishment: $stateParams.replenishment || $location.search().replenishment || '',
            refund: $stateParams.refund || $location.search().refund || '',
            supplierId: $stateParams.supplierId || $location.search().supplierId || '',
            productId: $stateParams.productId || $location.search().productId ||'',
            productCategoryId: '',
            sku:$stateParams.sku || $location.search().sku ||'',
            orderType: 'Ordering',
            phone: $stateParams.phone || $location.search().phone || '',
            logisticsNumber: $stateParams.logisticsNumber || $location.search().logisticsNumber || '',
            deliveryType: $stateParams.deliveryType || $location.search().deliveryType || '',
            storeName: $stateParams.storeName || $location.search().storeName || '',
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);
        vm.isFilter = vm.tableData.back || vm.tableData.replenishment || vm.tableData.refund ? true : false;
        Supplier.getAll("", function (res) {
            vm.suppliers = res;
            if(vm.tableData.supplierId != ''){
                for(var i=0; i<vm.suppliers.length; i++ ){
                    if(vm.suppliers[i].id == vm.tableData.supplierId){
                        vm.supplier = vm.suppliers[i];
                    }
                }
            }
        });
        Product.getAllByCategory({type: 'OrderingProduct'}, function (res) {
            vm.productList = res;
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                        vm.skuList = vm.productList[i].propertyConfigs;
                    }
                }
            }
        });

        //获取选中的数组
        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }
            vm.selectedList = $scope.checked
            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        // 计算订单份数
        vm.calculateTotalQuantity = function() {
            var total = 0;
            if (vm.selectedList && vm.selectedList.length > 0) {
                angular.forEach(vm.selectedList, function(item) {
                    total += parseInt(item.quantity) || 0;
                });
            }
            return total;
        };

        // 获取当前时间，格式为YYYY/MM/DD HH:MM:SS
        vm.getCurrentTime = function() {
            var now = new Date();
            var year = now.getFullYear();
            var month = (now.getMonth() + 1).toString().padStart(2, '0');
            var day = now.getDate().toString().padStart(2, '0');
            var hours = now.getHours().toString().padStart(2, '0');
            var minutes = now.getMinutes().toString().padStart(2, '0');
            var seconds = now.getSeconds().toString().padStart(2, '0');
            return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes + ':' + seconds;
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.salesOrders.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
            vm.selectedList = $scope.checked
            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };


        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());

            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'source':vm.tableData.source,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back,
                'timeWarning':vm.tableData.timeWarning,
                'replenishment':vm.tableData.replenishment,
                'refund':vm.tableData.refund,
                'supplierId':vm.tableData.supplierId,
                'productId':vm.tableData.productId,
                'keyword':vm.tableData.keyword,
                'productCategoryId':vm.tableData.productCategoryId,
                'sku':vm.tableData.sku,
                'phone':vm.tableData.phone,
                'logisticsNumber':vm.tableData.logisticsNumber,
                'deliveryType':vm.tableData.deliveryType,
                'storeName':vm.tableData.storeName,
            });
            SalesOrder.query(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });

            //获取订单总数和总张数
            $scope.orderNumberTotal = 0;
            $scope.pageCountTotal = 0;
            SalesOrder.getNumByCondition(vm.tableData, function(res) {
                $scope.orderNumberTotal = res.total;
                $scope.pageCountTotal = res.pages == null ? 0 : res.pages;
            });
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        //商品1级品类
        $scope.promoteProductsSelect = function(){
            vm.promoteProductsSecond = [];
            vm.tableData.productCategoryId = vm.productCategoryId;
            for(var i=0; i<vm.promoteProducts.length; i++){
                if(vm.promoteProducts[i].id == vm.productCategoryId){
                    // console.log(vm.promoteProducts[i]);
                    vm.promoteProductsSecond = vm.promoteProducts[i].productCategoryVMS;
                }
            }
        }
        //商品品类 二级
        $scope.promoteProductsSecondSelect = function(){
            if(!vm.productCategorySecondId){
                vm.tableData.productCategoryId = vm.productCategoryId;
            }else {
                vm.tableData.productCategoryId = vm.productCategorySecondId;
            }
        }

        $scope.selectSupplier =function(data){
            if(data){
                vm.tableData.supplierId = data.id;
            }else {
                vm.tableData.supplierId = "";
            }
        };
        $scope.selectProduct =function(data){
            if(data){
                vm.tableData.productId = data.id;
                vm.skuList = data.propertyConfigs;
            }else {
                vm.tableData.productId = "";
                vm.tableData.sku = "";
                vm.skuList = [];
            }
        };
        $scope.filter = function(){
            vm.isFilter = !vm.isFilter;
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.timeWarning = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.warningSelect = function(){
            vm.tableData.state = "";
            vm.tableData.timeWarning = 1;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                source:'',
                startDate: '',
                endDate: '',
                back: '',
                timeWarning:'',
                replenishment: '',
                refund: '',
                condition: '全部',
                supplierId: '',
                productId: '',
                productCategoryId:'',
                sku:'',
                orderType: 'Ordering'
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };

        //查看订单
        $scope.orderLook = function () {
            if($scope.checked.length >1){
                MessageService.error('仅能查看一个订单，请选择！');
                return;
            }else{
                $state.go('orderDetails',{
                    id:$scope.checked[0].id,
                    page: vm.tableData.page,
                    state:vm.tableData.state,
                    source:vm.tableData.source,
                    startDate:vm.tableData.startDate,
                    endDate:vm.tableData.endDate,
                    back:vm.tableData.back,
                    timeWarning:vm.tableData.timeWarning,
                    replenishment:vm.tableData.replenishment,
                    refund:vm.tableData.refund,
                    supplierId:vm.tableData.supplierId,
                    productId:vm.tableData.productId,
                    keyword:vm.tableData.keyword,
                    productCategoryId:vm.tableData.productCategoryId,
                    sku:vm.tableData.sku,
                    phone:vm.tableData.phone,
                    logisticsNumber:vm.tableData.logisticsNumber,
                });
            }
        };

        //客户备注
        $scope.orderRemark = function () {
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单 ！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-remark.html',
                    controller: 'OrderRemarkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked[0]
                        }]
                    }
                }).result.then(function (backData) {
                    // console.log(backData);
                });
            }
        };

        //补货订单
        $scope.orderReplenishment = function(){
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单！');
                return;
            }else {
                if ($scope.checked[0].status == 'ToBeAssigned' || $scope.checked[0].status == 'Assigned'
                 || $scope.checked[0].status == 'Producing' ) {
                    MessageService.error('请选择已发货的订单进行补货！');
                    return;
                }
                if (!!$scope.checked[0].replenishmentBeforeNumber) {
                    MessageService.error('请选择最初订单进行补货！');
                    return;
                } else {
                    $uibModal.open({
                    templateUrl: 'app/order/order-replenishment.html',
                    controller: 'OrderReplenishmentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked[0]
                        }]
                    }
                    }).result.then(function (backData) {
                        if (backData) {
                            init()
                        }
                    });
                }
            }
        };

        //撤回操作
        $scope.orderClose = function(){
            if($scope.checked.length == 0){
                MessageService.error('请选择订单！');
                return;
            }else {
                if($scope.checked.some(function(item){return item.status == 'Delivered' || item.status == 'Receiving' || item.status == 'Received' || item.status == 'Abnormal'})){
                    MessageService.error('只能撤回处理中、待分配、已分配、生产中这四个状态的订单');
                    return;
                }
                var ids = $scope.checked.map(function(item){return item.orderPackId});
                MessageService.confirm("已选中"+ids.length+"条订单，是否确认撤回订单？", function () {
                    OrderPack.revoke(ids, function(res) {
                        MessageService.success("撤回成功");
                        init()
                    }, function (error) {
                        MessageService.error(error.data.message || "撤回失败，请重试！");
                    });
                });
            }
        };

        //选择物流公司
        $scope.orderExpress = function(){

            //如果是已发货状态则不能修改物流公司
            var flagExpress =false;
            angular.forEach($scope.checked,function(item){
                if(item.status =="Delivered"){
                    flagExpress =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('存在已发货的订单，不能修改物流公司，请重新选择！');
                return;
            }else{
                $uibModal.open({
                    templateUrl: 'app/order/order-express.html',
                    controller: 'OrderExpressController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function() {
                            return $scope.checked
                        }]
                    }
                }).result.then(function (backData) {
                    if(backData){
                        init()
                    }
                });
            }
        };

        //修改
        $scope.modification = function(){
            var flagExpress =false;
            var isStatus =false;
            var isStatusProducing =false;
            angular.forEach($scope.checked,function(item, index){
                if(item.status !="Assigned" && item.status !="Producing" && item.status !="Delivered"){
                    flagExpress =true;
                    return;
                }
                if(index>0 && item.status != $scope.checked[index-1].status){
                    isStatus =true;
                    return;
                }
                if(item.status == "Producing" && $scope.checked.length>1){
                    isStatusProducing =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('只能修改已分配、生产中、已发货这三个状态的订单');
                return;
            }
            if(isStatus){
                MessageService.error('请选择相同状态下的订单');
                return;
            }
            if(isStatusProducing){
                MessageService.error('生产中的订单只能选择一个');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }
        $scope.handleDelivery = function(){
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }

        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/sales_order/exportData1',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        $scope.handlePrint = function(){

            // 获取预览区域元素
            var previewElement = document.getElementById('previewId');

            // 保存原始样式
            var originalStyle = previewElement.style.cssText;

            // 临时显示预览区域
            previewElement.style.display = 'block';
            previewElement.style.position = 'relative';
            previewElement.style.visibility = 'visible';

            // 等待更长时间确保内容（特别是条形码）完全加载
            setTimeout(function () {

                // 为预览区域添加打印样式
                var style = document.createElement('style');
                style.type = 'text/css';
                style.innerHTML = '@media print { @page { size: landscape; } }';
                previewElement.appendChild(style);
                // 创建用于打印的iframe
                var printIframe = document.getElementById('print-frame');
                if (printIframe === null || printIframe === undefined) {
                    printIframe = document.createElement('iframe');
                    printIframe.lang = 'en';
                    printIframe.style.display = 'none';
                    printIframe.id = 'print-frame';
                    document.body.insertBefore(printIframe, document.body.children[0]);
                }
                printIframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title></title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'>";
                printIframe.contentDocument.body.innerHTML = previewElement.innerHTML;
                printIframe.contentWindow.focus();
                printIframe.contentWindow.print();

                // 创建用于PDF生成的iframe
                var pdfIframe = document.createElement('iframe');
                pdfIframe.style.display = 'none';
                document.body.appendChild(pdfIframe);

                // 等待iframe加载完成
                pdfIframe.onload = function() {
                    // 向iframe中添加内容
                    pdfIframe.contentDocument.open();
                    pdfIframe.contentDocument.write('<!DOCTYPE html><html><head><meta charset="UTF-8"><title>PDF</title><link rel="stylesheet" href="content/css/main.css"><link rel="stylesheet" href="bower_components/bootstrap/dist/css/bootstrap.css"></head><body>');
                    pdfIframe.contentDocument.write(previewElement.innerHTML);
                    pdfIframe.contentDocument.write('</body></html>');
                    pdfIframe.contentDocument.close();

                    // 等待内容渲染
                    setTimeout(function() {
                        try {
                            // 在iframe中生成PDF
                            var opt = {
                              margin: 10,
                              filename: '订单_' + new Date().getTime() + '.pdf',
                              image: { type: 'jpeg', quality: 0.98 },
                              html2canvas: { scale: 2, useCORS: true, logging: true },
                              jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
                            };

                            // 使用iframe的body作为源
                            html2pdf().set(opt).from(pdfIframe.contentDocument.body).save().then(function() {
                                // 清理
                                document.body.removeChild(pdfIframe);
                                previewElement.style.cssText = originalStyle;
                            }).catch(function(error) {
                                // 清理
                                document.body.removeChild(pdfIframe);
                                previewElement.style.cssText = originalStyle;
                            });
                        } catch (error) {
                            // 清理
                            document.body.removeChild(pdfIframe);
                            previewElement.style.cssText = originalStyle;
                        }
                    }, 1000); // 等待内容渲染
                };

                // 触发iframe加载
                pdfIframe.src = 'about:blank';
            }, 2000); // 增加延迟时间确保内容完全加载，特别是条形码
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderReplenishmentController', OrderReplenishmentController);

    OrderReplenishmentController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder','$uibModalInstance', 'entity', 'LocationCity', 'LocationProvice', 'LocationDistrict','$location','ReplenishmentReason','$localStorage','OrderPack'];

    function OrderReplenishmentController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder, $uibModalInstance, entity, LocationCity, LocationProvice, LocationDistrict,$location,ReplenishmentReason,$localStorage,OrderPack) {
        var vm = this;
        vm.order = entity;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;
        vm.flag = true;
        vm.token = $localStorage.authenticationToken;
        vm.fileResult = "";
        vm.reupload = false;
        vm.makeup = false;
        vm.isSaving = false;

        vm.replenishmentReasonId = "";
        vm.quantity = entity.quantity || 1;
        vm.justifyFile = "";
        vm.remarks = "";
        SalesOrder.get({id : vm.order.id}, function (res) {
            vm.sourceOrderNumber = res.sourceOrderNumber;
            OrderPack.get({id: res.orderPackId}, function (res1) {
                // if(res1.orderLocation){
                    vm._address = res1.orderLocation ? res1.orderLocation.address.split("-") : "";
                    vm.address = vm._address[3] ? vm._address[3] : "";
                    LocationProvice.query({},function (data) {
                        vm.provinces =  data;
                        if(vm._address[0]){
                            for(var i=0; i<data.length; i++){
                                if(vm._address[0] == data[i].name){
                                    vm.province = data[i];
                                    changeProvince()
                                    break;
                                }
                            }
                        }
                    });
                // }
                var _salesOrders = [];
                for(var i=0; i<res1.salesOrders.length; i++){
                    if(res1.salesOrders[i].id == vm.order.id){
                        res1.salesOrders[i].reupload = false;
                        _salesOrders.push(res1.salesOrders[i]);
                        break;
                    }
                }

                vm.orderData = {
                    id:res1.id,
                    number:res1.number,
                    status:res1.status,
                    salesOrders: _salesOrders,
                    merchantNumber: res1.merchantNumber,
                    settleAmount: res1.settleAmount,
                    orderSource: res1.orderSource,
                    orderLocation: {
                        contact:!res1.orderLocation ? "" : res1.orderLocation.contact,
                        phone:!res1.orderLocation ? "" : res1.orderLocation.phone,
                        address:!res1.orderLocation ? "" : res1.orderLocation.address,
                        serviceId:!res1.orderLocation ? "" : res1.orderLocation.serviceId,
                    }
                };
                vm.orderData.salesOrders.number = res.number;
                vm.orderData.salesOrders.sourceOrderNumber = res.sourceOrderNumber;
            });
        }, function (error) {

        });

        ReplenishmentReason.getAll({},function(res){
            vm.reasonList = res.filter(function(item){return item.enable});
        });

        function changeProvince() {
            if(vm.province){
                LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                    vm.citys = data;
                    vm.districts = [];
                    if(vm._address[1]){
                        for(var i=0; i<data.length; i++){
                            if(vm._address[1] == data[i].name){
                                vm.city = data[i];
                                changeCity();
                                break;
                            }
                        }
                    }
                });
            }
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
                if(vm._address[2]){
                    for(var i=0; i<data.length; i++){
                        if(vm._address[2] == data[i].name){
                            vm.district = data[i];
                            break;
                        }
                    }
                }
            });
        }

        window.upladFile1 = function($event) {
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'pdf' && ext != 'zip' && ext != 'rar'){
                angular.element("#file").val("");
                MessageService.error("只能上传.zip  .pdf类型的文件!");
                return;
            }
            var url =  $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/sales_order/uploadFile"; // 接收上传文件的后台地址

            var formData = new FormData();
            formData.append('file', fileObj);
            formData.append('number', vm.orderData.number);

            $.ajax({
                url: url,
                type: "POST",
                data: formData,
                enctype: 'multipart/form-data',
                contentType: false,
                processData: false,
                cache: false,
                async: true,
                timeout: 100000,
                headers: {
                    Authorization: "Bearer " + vm.token
                },
                xhr: function() {        //ajax进度条，直接拿过去就可以用
                    var xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                        xhr.upload.addEventListener("progress", function (e) {
                            var loaded = e.loaded; //已经上传大小情况
                            var tot = e.total; //附件总大小
                            var per = Math.floor(100 * loaded / tot); //已经上传的百分比
                            $('#progress-bar').css('width', per+'%');   //这里指的是进度条的宽度等于完成的百分比
                        }, false);
                        return xhr;
                    }
                },
                success: function (data) {
                    MessageService.success("文件上传成功");
                    $('#progress-bar').css('width', '0%');
                    vm.justifyFile = data.path;
                    vm.orderData.salesOrders.forEach(function (item) {
                        item.justifyFile = data.path;
                        item.reupload = true;
                    })
                    $scope.$apply();    // 数据更新
                },
                error: function (error) {
                    angular.element("#file").val("");
                    MessageService.error("文件上传失败，请稍后重试！");
                    $('#progress-bar').css('width', '0%');
                }
            });
        };


        //文件上传
        window.uploadFile = function($event) {
            var ext,idx;
            var fileObj = $event.target.files[0]; // js 获取文件对象
            idx = fileObj.name.lastIndexOf(".");
            ext = fileObj.name.substr(idx+1).toUpperCase();
            ext = ext.toLowerCase();
            if (ext != 'pdf' && ext != 'zip'){
                angular.element("#file").val("");
                MessageService.error("只能上传.pdf/.zip类型的文件!");
                return;
            }

            if (fileObj.size > 1024 * 1024 * 1024 * 2) {
                MessageService.error("文件不能大于2GB");
                return;
            }

            checkIfUploaded(fileObj, ext);
        };

        function checkIfUploaded (file, ext) {
            var reader = new FileReader();
            // 用来计算fileMd5值的file内容
            var fileToCountMD5 = file;

            if (file.size > 1024*1024*50) {
                var fileStart = file.slice(0, 1024 * 1024);
                var fileEnd = file.slice(file.size - 1024 * 1024, file.size);
                fileToCountMD5 = new Blob([fileStart,fileEnd], { type: "text/plain" });
            }
            reader.readAsBinaryString(fileToCountMD5);

            //绑定读取失败事件
            reader.onerror = function() {
                MessageService.error("文件读取失败");
            };

            //绑定读取成功事件
            reader.onload = function() {
                //需要引入计算MD5的jar包
                var fileMd5 = hex_md5(reader.result);

                var form = new FormData();
                form.append("fileMd5", fileMd5);
                form.append("fileSize", file.size);

                //校验是否上传过该文件，返回上传进度
                console.log("isFileExist");
                $.ajax({
                    url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/isFileExist",
                    type: "POST",
                    data: form,
                    async: true,        //异步
                    processData: false,  //很重要，告诉jquery不要对form进行处理
                    contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                    success: function(data) {
                        if (data.success) {
                            //文件已上传
                            MessageService.success("上传成功！");
                        } else {
                            //文件未上传或者部分上传
                            uploadBySplit(file, fileMd5, 0, ext);
                        }
                    },
                    error: function() {
                        MessageService.error("服务器出错!");
                    }
                });
            }
        }

        //分片上传
        function uploadBySplit(file, fileMd5, i, ext, index_file) {
            var splitSize = 1024 * 1024 * 20;   //分片大小20M  -- 20M为一段
            var size = file.size;//总大小
            var splitCount = Math.ceil(size / splitSize);  //总片数
            console.log("分成"+splitCount+"份文件片");

            if (i == splitCount) {
                MessageService.success("文件上传成功！");
                return;
            }

            //计算每一片的起始与结束位置
            var start = i * splitSize;
            var end = Math.min(size, start + splitSize);
            var fileData = file.slice(start,end);
            var reader = new FileReader();
            reader.onload = function(){
                var md5 = hex_md5(reader.result);

                var form = new FormData();
                form.append("fileMd5", fileMd5);
                form.append("size", size);  //总大小
                form.append("totalStr", splitCount);   //总片数
                form.append("indexStr", i);    //当前是第几片
                form.append("md5", md5);    //分片md5

                //判断分片是否上传
                $.ajax({
                    url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/isFileSplitExist",
                    type: "POST",
                    data: form,
                    async: true,        //异步
                    processData: false,  //很重要，告诉jquery不要对form进行处理
                    contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                    success: function(data){
                        if (data.code == 1) {//已上传
                            //上传进度
                            var process = Math.round(end/size*100)+"%";
                            i++;
                            uploadBySplit(file, fileMd5, i, ext);    // 循环上传
                        } else { //未上传
                            form.append("fileData", fileData);
                            form.append("ext", ext);    // 文件后缀
                            //上传分片
                            $.ajax({
                                url: $location.protocol() + '://' + $location.host() + ':' + $location.port() +  "/api/scm-file/upload",
                                type: "POST",
                                data: form,
                                async: true,        //异步
                                processData: false,  //很重要，告诉jquery不要对form进行处理
                                contentType: false,  //很重要，指定为false才能形成正确的Content-Type
                                success: function(data) {
                                    if (data.state == 200) {
                                        //上传进度
                                        $('#progress-bar').css('width', (i / splitCount * 100)  +'%');
                                        i++;
                                        uploadBySplit(file, fileMd5, i, ext);
                                    } else if (data.state == 300) {
                                        $('#progress-bar').css('width', '0%');
                                        vm.justifyFile = data.message;
                                        vm.orderData.salesOrders.forEach(function (item) {
                                            item.justifyFile = data.message;
                                            item.reupload = true;
                                        })
                                        $scope.$apply();
                                    } else {
                                        $('#progress-bar').css('width', '0%');
                                        MessageService.error("分片上传失败");
                                    }
                                },
                                error: function(XMLHttpRequest, textStatus, errorThrown) {
                                    MessageService.error("服务器出错!");
                                }
                            });
                        }
                    },

                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        MessageService.error("服务器出错!");
                    }
                });
            }
            reader.readAsBinaryString(fileData);
        }

        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        //保存
        $scope.save = function () {
            if(vm.replenishmentReasonId == "" || vm.replenishmentReasonId == null){
                MessageService.error("请选择补货原因");
                return;
            }

            for (var i = vm.reasonList.length - 1; i >= 0; i--) {
                vm.orderData.salesOrders.forEach(function (item) {
                    if (vm.reasonList[i].id == vm.replenishmentReasonId) {
                        item.replenishmentReason = vm.reasonList[i].reason;
                        item.replenishmentReasonId = vm.replenishmentReasonId;
                    }
                })
            }

            if(!vm.quantity || vm.quantity < 1){
                MessageService.error("补货份数不得小于1");
                return;
            }
            if (vm.quantity > vm.order.quantity) {
                MessageService.error("补货份数不得大于订单份数");
                return;
            }
            if(vm.orderData.orderLocation.contact == "" || vm.orderData.orderLocation.contact == null){
                MessageService.error("姓名不能为空");
                return;
            }
            if(vm.orderData.orderLocation.phone == "" || vm.orderData.orderLocation.phone == null){
                MessageService.error("联系电话不能为空");
                return;
            }
            if(vm.province == "" || vm.city == "" || vm.district == ""){
                MessageService.error("收货地址不能为空");
                return;
            }
            if(vm.address == "" || vm.city == null){
                MessageService.error("详细地址不能为空");
                return;
            }

            vm.orderData.orderLocation.address = vm.province.name + '-' + vm.city.name + '-' + vm.district.name + '-' + vm.address;
            // console.log(vm.orderData);

            vm.orderData.salesOrders.forEach(function (item) {
                if (vm.makeup) {
                    item.makeupStatus = 'NoMakeup';
                } else {
                    item.makeupStatus = 'NotRequiredMakeup';
                }
                item.remarks = vm.remarks;
                item.replenishment = true;
                item.replenishmentOrders = [{
                    remarks:vm.remarks,
                    replenishmentReasonId:item.replenishmentReasonId,
                    replenishmentReason:item.replenishmentReason,
                    quantity: vm.quantity
                }]
            })
            vm.isSaving = true;
            OrderPack.replenishment(vm.orderData, function (res) {
                vm.isSaving = false;
                MessageService.success("补单成功");
                $uibModalInstance.close(true);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("补单失败");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderReplenishController', OrderReplenishController);

    OrderReplenishController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
        '$uibModal', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'Supplier', 'ReplenishmentReason'];

    function OrderReplenishController ($scope, Principal, LoginService, $state, User, MessageService, ParseLinks, SalesOrder,
        $uibModal, $localStorage, $http, $stateParams, $rootScope, $location, Supplier, ReplenishmentReason) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tablePitch = '';
        vm.stateList = [
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已发货', value: 'Delivered'}
        ];
        vm.sourceList = [
            {name:'自营订单', value:'self'},
            {name:'第三方平台', value: '第三方平台'},
            {name:'外接订单', value: '外接订单'}
        ];
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'待分配', value:'ToBeAssigned'},
            {name:'已分配', value: 'Assigned'},
            {name:'生产中', value: 'Producing'},
            {name:'已发货', value: 'Delivered'}
        ];
        vm.page = $stateParams.page || $location.search().page;

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            state:$stateParams.state || $location.search().state || '',
            source:$stateParams.source || $location.search().source || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            back: $stateParams.back || $location.search().back || '',
            keyword: $stateParams.keyword || $location.search().keyword || '',
            replenishment: true,
            reasonStr: '',
            supplierId: ''
        };
        vm.isFilter = vm.tableData.back ? true : false;
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        //获取选中的数组
        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }

            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        $scope.selectAll = function(){
            if($scope.select_all) {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = true;
                });
                $scope.checked = vm.salesOrders.map(function(value){
                    return value;
                })
            }else {
                angular.forEach(vm.salesOrders, function (item) {
                    item.checked = false;
                });
                $scope.checked = [];
            }
            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'source':vm.tableData.source,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back,
                'keyword':vm.tableData.keyword
            });
            Supplier.getAll("", function (res) {
                vm.suppliers = res;
            });
            ReplenishmentReason.getAll({}, function(res) {
                vm.replenishmentReasons = res;
            });
            SalesOrder.query(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };


        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        $scope.filter = function(){
            vm.isFilter = !vm.isFilter;
            //vm.tableData.back = '';
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        // $scope.tableTr = function(data){
        //     vm.tablePitch = data;
        //     for(var i=0; i<vm.salesOrders.length; i++){
        //         if(data.id == vm.salesOrders[i].id){
        //             vm.salesOrders[i].pitchOn = true;
        //         }else {
        //             vm.salesOrders[i].pitchOn = false;
        //         }
        //     }
        // };
        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                source:'',
                startDate: '',
                endDate: '',
                back: '',
                condition: '全部',
                replenishment: true
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };
        //查看订单
        $scope.orderLook = function () {
            if($scope.checked.length >1){
                MessageService.error('仅能查看一个订单，请选择！');
                return;
            }else {
                $state.go('orderDetails', {
                    id: $scope.checked[0].id,
                    page: vm.tableData.page,
                    state: vm.tableData.state,
                    source: vm.tableData.source,
                    startDate: vm.tableData.startDate,
                    endDate: vm.tableData.endDate,
                    back: vm.tableData.back,
                    condition: vm.tableData.condition,
                    keyword: vm.tableData.keyword
                });
            }
        };
        //客户备注
        $scope.orderRemark = function () {
            // if(!vm.tablePitch){
            //     MessageService.error("请选择订单");
            //     return
            // }
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单 ！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-remark.html',
                    controller: 'OrderRemarkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return
                        }]
                    }
                }).result.then(function (backData) {
                    // console.log(backData);
                });
            }
        };
        //取消补货订单
        $scope.orderReplenishment = function () {
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单！');
                return;
            }else {
                if ($scope.checked[0].makeupId != null) {
                    MessageService.error('已经拼版的订单不可取消！');
                    return;
                }
                MessageService.confirm("确认取消当前补货订单？", function () {
                    SalesOrder.delete({id: $scope.checked[0].id}, function () {
                        init();
                        MessageService.success("补货订单取消成功");
                    }, function (error) {
                        MessageService.error("取消失败，请重试！");
                    });
                });
            }
        };

        //选择物流公司
        $scope.orderExpress = function(){
            //如果是已发货状态则不能修改物流公司
            var flagExpress =false;
            angular.forEach($scope.checked,function(item){
                if(item.status =="Delivered"){
                    flagExpress =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('存在已发货的订单，不能修改物流公司，请重新选择！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-express.html',
                    controller: 'OrderExpressController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked
                        }]
                    }
                }).result.then(function (backData) {
                    if (backData) {
                        init()
                    }
                });
            }
        };
        //修改
        $scope.modification = function(){
            var flagExpress =false;
            var isStatus =false;
            var isStatusProducing =false;
            angular.forEach($scope.checked,function(item, index){
                if(item.status !="Assigned" && item.status !="Producing" && item.status !="Delivered"){
                    flagExpress =true;
                    return;
                }
                if(index>0 && item.status != $scope.checked[index-1].status){
                    isStatus =true;
                    return;
                }
                if(item.status == "Producing" && $scope.checked.length>1){
                    isStatusProducing =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('只能修改已分配、生产中、已发货这三个状态的订单');
                return;
            }
            if(isStatus){
                MessageService.error('请选择相同状态下的订单');
                return;
            }
            if(isStatusProducing){
                MessageService.error('生产中的订单只能选择一个');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }

        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/sales_order/exportReplenishData',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };


        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderRemarkController', OrderRemarkController);

    OrderRemarkController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder','$uibModalInstance'];

    function OrderRemarkController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder, $uibModalInstance) {
        var vm = this;
        vm.data = {
            description: ''
        };
        vm.isSaving = false;
        $scope.save = function () {
            if(!vm.data.description){
                MessageService.error("备注不能为空");
                return
            }
            vm.isSaving = true;
            $uibModalInstance.close();
        }
        $scope.hide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderModificationController', OrderModificationController);

    OrderModificationController.$inject = ['$scope', 'Principal', 'LoginService', '$state','$location','MessageService', 'ParseLinks', 'SalesOrder','$uibModalInstance', 'entity', 'Express'];

    function OrderModificationController ($scope, Principal, LoginService, $state,$location,MessageService, ParseLinks, SalesOrder, $uibModalInstance, entity, Express) {
        var vm = this;
        vm.order = entity;
        vm.status_info = vm.order[0].status;
        vm.isDelivery = $state.current.name == 'orderSelf' && $location.$$search.state == 'Collect'
        vm.data={};
        vm.expressCompanies = [];

        vm.deliveryMethodList = [
            {name:'自送', id: "Self"},
            {name:'快递', id: "Delivery"}
        ];

        if(vm.status_info == 'Assigned'){
            vm.statusList=[
                {name:'生产中', id:'Producing'},
                {name:'已回件', id:'Collect'},
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }
        if(vm.status_info == 'Producing'){
            vm.statusList=[
                {name:'已回件', id:'Collect'},
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }
        if(vm.status_info == 'Delivered'){
            vm.statusList=[
                {name:'已回件', id:'Collect'},
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }
        if(vm.status_info == 'Collect'){
            vm.statusList=[
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }



        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        $scope.statusChange = function(){
            vm.data.downLoadDate = "";
            Express.getAll(function(res){
                res.forEach(function (item) {
                    // if(item.enable && vm.order[0].supplierId == item.supplierId){
                    if(item.enable){
                        vm.expressCompanies.push(item)
                    }
                })
            });
        }
        function formatDate(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            const seconds = String(d.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          }

        if(vm.isDelivery){
            vm.data.deliveryType = 'Delivery'
            vm.data.deliveryDate = formatDate(new Date());
            Express.getAll(function(res){
                vm.expressCompanies = [];
                res.forEach(function (item) {
                    // if(item.enable && vm.order[0].supplierId == item.supplierId){
                    if(item.enable){
                        vm.expressCompanies.push(item);
                    }
                });
            }, function(error) {
                MessageService.error('获取快递公司失败');
            });
        }
        //保存
        $scope.save = function () {
            vm.data.downLoadDate = angular.copy(angular.element("#downLoadDate").val());
            vm.data.deliveryDate = angular.copy(angular.element("#deliveryDate").val());
            if(!vm.isDelivery && !vm.data.status){
                MessageService.error("状态不能为空");
                return;
            }
            if(!vm.isDelivery && (vm.data.status == 'Producing' && !vm.data.downLoadDate)){
                MessageService.error("下载时间不能为空");
                return;
            }

            if(vm.isDelivery && !vm.data.deliveryType){
                MessageService.error("配送方式不能为空");
                return;
            }
            if((vm.data.status == 'Delivered' || vm.isDelivery) && vm.data.deliveryType == 'Delivery' && !vm.data.deliveryComp){
                MessageService.error("快递公司不能为空");
                return;
            }
            if((vm.data.status == 'Delivered' || vm.isDelivery) && vm.data.deliveryType == 'Delivery' && !vm.data.deliveryDate){
                MessageService.error("发货日期不能为空");
                return;
            }
            if((vm.data.status == 'Delivered' || vm.isDelivery) && vm.data.deliveryType == 'Delivery' && !vm.data.logisticsNumber){
                MessageService.error("快递单号不能为空");
                return;
            }
            var _data=[];
            var  expressSetting = vm.expressCompanies.find(function(com){
                return com.name == vm.data.deliveryComp
            })

            if(vm.data.deliveryType == 'Self'){
                vm.data.deliveryDate = formatDate(new Date());
            }
            vm.order.forEach(function (item) {
                _data.push({
                    status: vm.isDelivery ?'Delivered': vm.data.status,
                    downLoadDate: vm.data.downLoadDate,
                    deliveryComp: vm.data.deliveryComp,
                    expressSettingId:expressSetting ? expressSetting.id : '',
                    logisticsNumber: vm.data.logisticsNumber,
                    deliveryDate: vm.data.deliveryDate,
                    orderId: item.id,
                })
            })
            SalesOrder.updateOrderBatch(_data, function (res) {
                MessageService.success("发货成功");
                $uibModalInstance.close(true);
            }, function (error) {
                MessageService.error("发货失败");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderGeneralPreviewController', OrderGeneralPreviewController);

    OrderGeneralPreviewController.$inject = ['$scope','$http', '$q', 'DateUtils', '$localStorage', 'PurchaseProductLine', 'Supplier', 'Depository', 'UnitMeasurement', 'Product', 'PurchaseOrder', 'entity','$uibModal'];

    function OrderGeneralPreviewController ($scope, $http, $q, DateUtils, $localStorage, PurchaseProductLine, Supplier, Depository, UnitMeasurement, Product, PurchaseOrder, entity,$uibModal) {
        var vm = this;
        vm.data = entity;
        vm.token = $localStorage.authenticationToken;
        $scope.goback = function (){
            history.back();
        };
        $scope.export = function (){
            $http({
                url: 'api/order_pack/exportDetail/' + vm.data.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = vm.data.number + "出库单_" + DateUtils.convertLocalDateToServer(Date.now()) +".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        }

        $scope.preview = function (){
            var iframe = document.getElementById('print-frame');
            if (iframe === null || iframe === undefined) {
                iframe = document.createElement('iframe');
                iframe.lang = 'en';
                iframe.style.display = 'none';
                iframe.id = 'print-frame';
                document.body.insertBefore(iframe, document.body.children[0]);
                iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title></title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'>";
            }

            setTimeout(function () {
                var changePrint = function (type) {
                    var html = '';
                    type = type?type:1;
                    if(type=='1'){
                        html='<style type="text/css" media="print">\n' + '  @page { size: landscape; }\n' + '</style>';
                    }else{
                        html='<style type="text/css" media="print">\n' + '  @page { size: portrait; }\n' + '</style>';
                    }
                    return html;
                };
                $('#previewId').append(changePrint(1));
                iframe.contentDocument.body.innerHTML = document.getElementById("previewId").innerHTML;
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 300);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderGeneralDetailsController', OrderGeneralDetailsController);

    OrderGeneralDetailsController.$inject = ['$scope',  'Principal',  '$uibModal', '$state','OrderPack','MessageService', 'ParseLinks', '$localStorage','$http', '$stateParams', '$rootScope'];

    function OrderGeneralDetailsController ($scope,  Principal,  $uibModal, $state,OrderPack,MessageService, ParseLinks, $localStorage, $http, $stateParams, $rootScope) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.token = $localStorage.authenticationToken;
        vm.data = {}
        vm.changehWarehouse = changehWarehouse;
        vm.reserveList = []

        init()

        function init(){
            OrderPack.get({id : $stateParams.id},function(res){
                vm.data = res
                if(res.status === 'ToDelivery'){
                    getReserve()
                }
            },function(){

            })
        }
        function getReserve(){
            OrderPack.fetchReserve({id : $stateParams.id},function(res){
                vm.data.salesOrders.forEach(function(itm){
                    res.lines.forEach(function(item){
                        if(itm.id === item.id && item.reserves.length){
                            // 按仓库数量倒序排列
                            item.reserves.sort(function(a,b){
                                return b.quantity - a.quantity
                            })
                            itm.reserves =  item.reserves
                            // 默认选中第一个仓库
                            itm.warehouseId = item.reserves[0].warehouseId
                            itm.warehouseName = item.reserves[0].warehouseName
                            itm.warehouseQuantity = item.reserves[0].quantity
                        }
                    })
                })

            },function(res){
                console.log(res);
            })
        }
        //打印
        // $scope.printpage = function () {
        //     var iframe = document.getElementById('print-frame');
        //     if (iframe === null || iframe === undefined) {
        //         iframe = document.createElement('iframe');
        //         iframe.lang = 'en';
        //         iframe.style.display = 'none';
        //         iframe.id = 'print-frame';
        //         document.body.insertBefore(iframe,document.body.children[0]);
        //         iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title>主板文件</title><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'><link rel='stylesheet' href='content/css/main.css'>";
        //     }
        //
        //     setTimeout(function () {
        //         iframe.contentDocument.body.innerHTML = document.getElementById("printPage").innerHTML;
        //         iframe.contentDocument.getElementById("printHide").style.display="none";
        //         iframe.contentDocument.getElementById("printHide1").style.display="none";
        //         iframe.contentWindow.focus();
        //         iframe.contentWindow.print();
        //     },300);
        // };


        $scope.printpageBtn = function(){

            $http({
                url: 'api/sales_order/downloadJustifyFiles',
                method: "GET",
                params: {id: vm.salesOrder.id},
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var fileName = vm.salesOrder.number + (!vm.salesOrder.sku ? "" :"_" + vm.salesOrder.sku) + (!vm.salesOrder.propertySku ? "" : "_" + vm.salesOrder.propertySku);
                var blob = new Blob([data], {type: "application/zip"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                a.setAttribute('download', fileName);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (error, status) {
                if(status == 400){
                    MessageService.error("组版文件不存在");
                }else{
                    MessageService.error(data.data.message || "导出失败，请重试！");
                }
            });
        };
    //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    number: $stateParams.number,
                    logisticsNumber: $stateParams.logisticsNumber,
                    source: $stateParams.source,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    timeWarning: $stateParams.timeWarning,
                    replenishment: $stateParams.replenishment,
                    refund: $stateParams.refund,
                    supplierId: $stateParams.supplierId,
                    productId: $stateParams.productId,
                    keyword: $stateParams.keyword,
                    promoteProduct: $stateParams.promoteProduct
                });
            }else {
                history.back();
            }
        };

        $scope.editAddress = function(){
            $uibModal.open({
                templateUrl: 'app/order/order-address.html',
                controller: 'OrderAddressController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return vm.data
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    // $state.reload();
                    init()
                }
            });
        };

        //发货
        $scope.delivery = function () {
            if(!validQuantity())return
            $uibModal.open({
                templateUrl: 'app/order/delivery-dialog.html',
                controller: 'DeliveryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return vm.data;
                    },
                    isDetail:function(){
                        return true
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        // 仓库下拉框change时触发， 将仓库名称和库存赋值
        function changehWarehouse(data,index){
            if(!data.warehouseId){
                data.warehouseQuantity  = ''
                return
            }
            var currentWarehouse = data.reserves.find(function(item){
               return item.warehouseId === data.warehouseId
            })
            data.warehouseName = currentWarehouse.warehouseName
            data.warehouseQuantity = currentWarehouse.quantity

            // // 如果库订购数量小于库存 就赋值
            // if(data.quantity <= currentWarehouse.quantity){
            //     data.warehouseName = currentWarehouse.warehouseName
            //     data.warehouseQuantity = currentWarehouse.quantity
            // }else{
            //     data.warehouseName = ''
            //     data.warehouseQuantity = ''
            //     data.warehouseId = ''
            //     MessageService.error('库存不足，请重新选择，当前仓库库存: '+currentWarehouse.quantity)
            //     return
            // }

        }

        // 检查库存是否满足订购数量，满足才能发货
        function validQuantity(){
            var flag = true
            // 必须选择仓库
            var unSelectWarehouse = vm.data.salesOrders.filter(function(item){
                return item.warehouseQuantity == undefined || item.warehouseQuantity === ''
            })
            if(unSelectWarehouse.length > 0){
                MessageService.error('请选择仓库')
                flag = false
                return
            }
            // 库存数量校验
            var warningArr  = []
            vm.data.salesOrders.forEach(function(item){
                 if(item.quantity > Number(item.warehouseQuantity)){
                    warningArr.push(item.productName)
                 }
            })
            var _warningArr = warningArr.join(',')
            if(warningArr.length > 0) {
                flag = false
                MessageService.error(_warningArr + '库存不足，无法发货')
            }
            return flag
            // if(flag){
            //     vm.data.salesOrders.forEach(function(item){
            //         if(!item.warehouseId){
            //             MessageService.error('请选择仓库')
            //             flag = false
            //             return
            //         }
            //         if(item.quantity > item.warehouseQuantity){
            //             MessageService.error('库存不足，请重新选择')
            //             flag = false
            //             return
            //         }
            //     })
            // }
            // return flag
        }

        $scope.getStatus = function(item){
            switch (item) {
                // case 'UnPaid':
                //     return '未支付';
                // case 'Producing':
                //     return '生产中';
                case 'ToDelivery':
                    return '待发货';
                case 'Delivered':
                    return '已发货';
                case 'Received':
                    return '已收货';
                case 'Completed':
                    return '已完成';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderGeneralController', OrderGeneralController);

    OrderGeneralController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder', '$uibModal', 'Supplier','Product',
        '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'ProductCategory','OrderPack','DeliveryRequest','DeliverySettings'];

    function OrderGeneralController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder, $uibModal, Supplier, Product,
                                     $localStorage, $http, $stateParams, $rootScope, $location, ProductCategory,OrderPack, DeliveryRequest,DeliverySettings) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        var warehouse = {}
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tablePitch = '';
        vm.sourceList = [
            {name:'自营订单', value:'self'},
            {name:'第三方平台', value: '第三方平台'},
            {name:'外接订单', value: '外接订单'}
        ];
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.replenishmentList = [
            {name:'是', value: "true"},
            {name:'否', value: "false"}
        ];
        vm.refundList = [
            {name:'是', value: "true"},
            {name:'否', value: "false"}
        ];
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'待发货', value:'ToDelivery'},
            {name:'已发货', value: 'Delivered'},
            {name:'已收货', value: 'Received'},
            {name:'已关闭', value: 'Close'}
        ];
        //商品品类 一级
        vm.promoteProducts = ProductCategory.getAllCategory();
        vm.productCategoryId = "";
        vm.productCategorySecondId = "";

        vm.predicate = 'createdDate';
        vm.resolve = false;
        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            page: Number(vm.page) || 0,
            size: 20,
            state:$stateParams.state || $location.search().state || '',
            source:$stateParams.source || $location.search().source || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            number:$stateParams.number || $location.search().number || '',
            logisticsNumber:$stateParams.logisticsNumber || $location.search().logisticsNumber || '',
            orderType: 'General'
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);
        vm.isFilter = vm.tableData.back || vm.tableData.replenishment || vm.tableData.refund ? true : false;
        Supplier.getAll("", function (res) {
            vm.suppliers = res;
            if(vm.tableData.supplierId != ''){
                for(var i=0; i<vm.suppliers.length; i++ ){
                    if(vm.suppliers[i].id == vm.tableData.supplierId){
                        vm.supplier = vm.suppliers[i];
                    }
                }
            }
        });
        Product.getAllByCategory({type: 'OrderingProduct'}, function (res) {
            vm.productList = res;
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                        vm.skuList = vm.productList[i].propertyConfigs;
                    }
                }
            }
        });

        // Product.getAllByCategory({type: 'Parts'}, function(res){
        //     angular.forEach(res, function(item){
        //         if(vm.promoteProducts.indexOf(item.name) == -1){
        //             vm.promoteProducts.push(item.name);
        //         }
        //     })
        // });

        //获取选中的数组
        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.salesOrders.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }

            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                // 'source':vm.tableData.source,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'number':vm.tableData.number,
                'logisticsNumber':vm.tableData.logisticsNumber,
                'orderType':'General',

            });
            OrderPack.query(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                res.forEach(function(item){
                   item.productStr = ''
                    item.salesOrders.forEach(function(itm,idx){
                        if(idx!==item.salesOrders.length-1){
                            item.productStr = item.productStr + itm.productName + ','
                        }else{
                            item.productStr = item.productStr + itm.productName
                        }
                    })
                })
                vm.salesOrders = res
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });

            //获取订单总数和总张数
            SalesOrder.getNumByCondition(vm.tableData,function(res) {
                $scope.orderNumberTotal = res.total;
                $scope.pageCountTotal = res.pages;
            })

        };
        //商品1级品类
        $scope.promoteProductsSelect = function(){
            vm.promoteProductsSecond = [];
            vm.tableData.productCategoryId = vm.productCategoryId;
            for(var i=0; i<vm.promoteProducts.length; i++){
                if(vm.promoteProducts[i].id == vm.productCategoryId){
                    // console.log(vm.promoteProducts[i]);
                    vm.promoteProductsSecond = vm.promoteProducts[i].productCategoryVMS;
                }
            }
        }
        //商品品类 二级
        $scope.promoteProductsSecondSelect = function(){
            if(!vm.productCategorySecondId){
                vm.tableData.productCategoryId = vm.productCategoryId;
            }else {
                vm.tableData.productCategoryId = vm.productCategorySecondId;
            }
        }

        $scope.selectSupplier =function(data){
            if(data){
                vm.tableData.supplierId = data.id;
            }else {
                vm.tableData.supplierId = "";
            }
        };
        $scope.selectProduct =function(data){
            if(data){
                vm.tableData.productId = data.id;
                vm.skuList = data.propertyConfigs;
            }else {
                vm.tableData.productId = "";
                vm.tableData.sku = "";
                vm.skuList = [];
            }
        };
        $scope.filter = function(){
            vm.isFilter = !vm.isFilter;
            //vm.tableData.back = '';
            //vm.tableData.replenishment= '';
            //vm.tableData.refund= '';
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            init()
        };
        $scope.warningSelect = function(){
            vm.tableData.state = "";
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        // $scope.tableTr = function(data){
        //     vm.tablePitch = data;
        //     for(var i=0; i<vm.salesOrders.length; i++){
        //         if(data.id == vm.salesOrders[i].id){
        //             vm.salesOrders[i].pitchOn = true;
        //         }else {
        //             vm.salesOrders[i].pitchOn = false;
        //         }
        //     }
        // };
        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                source:'',
                startDate: '',
                endDate: '',
                back: '',
                timeWarning:'',
                replenishment: '',
                refund: '',
                condition: '全部',
                supplierId: '',
                productId: '',
                productCategoryId:'',
                number:'',
                logisticsNumber:'',
                sku:'',
                orderType:'General',
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };
        //发货
        $scope.delivery = function (record) {
            checkWarehouse(record)
        };

        //客户备注
        $scope.orderRemark = function () {
            // if(!vm.tablePitch){
            //     MessageService.error("请选择订单");
            //     return
            // }
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单 ！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-remark.html',
                    controller: 'OrderRemarkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return
                        }]
                    }
                }).result.then(function (backData) {
                    // console.log(backData);
                });
            }
        };
        //补货订单
        $scope.orderReplenishment = function(){
            // if(!vm.tablePitch){
            //     MessageService.error("请选择订单");
            //     return
            // }
            if($scope.checked.length >1){
                MessageService.error('只能选择一个订单 ！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-replenishment.html',
                    controller: 'OrderReplenishmentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked[0]
                        }]
                    }
                }).result.then(function (backData) {
                    if (backData) {
                        init()
                    }
                });
            }
        };

        //选择物流公司
        $scope.orderExpress = function(){
            //如果是已发货状态则不能修改物流公司
            var flagExpress =false;
            angular.forEach($scope.checked,function(item){
                if(item.status =="Delivered"){
                    flagExpress =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('存在已发货的订单，不能修改物流公司，请重新选择！');
                return;
            }else {
                $uibModal.open({
                    templateUrl: 'app/order/order-express.html',
                    controller: 'OrderExpressController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function () {
                            return $scope.checked
                        }]
                    }
                }).result.then(function (backData) {
                    if (backData) {
                        init()
                    }
                });
            }
        };
        //修改
        $scope.modification = function(){
            var flagExpress =false;
            var isStatus =false;
            var isStatusProducing =false;
            angular.forEach($scope.checked,function(item, index){
                if(item.status !="Assigned" && item.status !="Producing" && item.status !="Delivered"){
                    flagExpress =true;
                    return;
                }
                if(index>0 && item.status != $scope.checked[index-1].status){
                    isStatus =true;
                    return;
                }
                if(item.status == "Producing" && $scope.checked.length>1){
                    isStatusProducing =true;
                    return;
                }
            });
            if(flagExpress){
                MessageService.error('只能修改已分配、生产中、已发货这三个状态的订单');
                return;
            }
            if(isStatus){
                MessageService.error('请选择相同状态下的订单');
                return;
            }
            if(isStatusProducing){
                MessageService.error('生产中的订单只能选择一个');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/order/order-modification.html',
                controller: 'OrderModificationController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return $scope.checked
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    init()
                }
            });
        }
        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/order_pack/export',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });
        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }


        // 自动设置符合订购数量要求的仓库
        function checkWarehouse(record){
            OrderPack.fetchReserve({id : record.id},function(res){
                record.salesOrders.forEach(function(item){
                    res.lines.forEach(function(itm){
                        if(item.id === itm.id){
                            // 按仓库数量倒序排列
                            itm.reserves.sort(function(a,b){
                                return b.quantity - a.quantity
                            })

                            warehouse =  itm.reserves.find(function(_itm){
                                return _itm.quantity >= item.quantity
                            }) || {}
                            item.warehouseId =  warehouse && warehouse.warehouseId || ''
                            item.warehouseQuantity =  warehouse && warehouse.quantity || 0
                            warehouse = {}
                        }
                    })
                })

                var warningArr  = []
                record.salesOrders.forEach(function(item){
                    if(item.quantity > item.warehouseQuantity){
                    warningArr.push(item.productName)
                    }
                })
                var _warningArr = warningArr.join(',')
                if(warningArr.length > 0) {
                    MessageService.error(_warningArr + '库存不足，无法发货')
                    return
                }
                // 打开发货弹框
                openDeliveryDialog(record)
            },function(res){
                console.log(res);
            })
        }

        function openDeliveryDialog(record) {
            $uibModal.open({
                templateUrl: 'app/order/delivery-dialog.html',
                controller: 'DeliveryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return record;
                    },
                    isDetail:function(){
                        return false
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.getStatus = function(item){
            switch (item) {
                // case 'UnPaid':
                //     return '未支付';
                // case 'Producing':
                //     return '生产中';
                case 'ToDelivery':
                    return '待发货';
                case 'Delivered':
                    return '已发货';
                case 'Received':
                    return '已收货';
                case 'Completed':
                    return '已完成';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderExternalController', OrderExternalController);

    OrderExternalController.$inject = ['$scope', '$stateParams', '$location', '$http', 'Principal', 'LoginService', '$state', 'SalesOrder',
    'MessageService', 'ParseLinks', 'Product', '$uibModal'];

    function OrderExternalController ($scope, $stateParams, $location, $http, Principal, LoginService, $state, SalesOrder,
        MessageService, ParseLinks, Product, $uibModal) {

        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.isFilter = false;
        vm.tablePitch = '';
        vm.merchantsList = [
            {name:'摩登印', value:'摩登印'},
            {name:'人人店', value:'人人店'}
        ];
        vm.backList = [
            {name:'已回件', value:true},
            {name:'未回件', value:false},
        ];
        vm.replenishmentList = [
            {name:'是', value:true},
            {name:'否', value:false},
        ];
        vm.refundList = [
            {name:'是', value:true},
            {name:'否', value:false},
        ];
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'生产中', value:'Producing'},
            {name:'已发货', value:'Delivered'}
        ];

        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.tableData = {
            page: 0,
            size: 20,
            sort: ['createdDate,DESC'],
            state:'',
            source:'',
            startDate: GetDateStr(-31),
            endDate: GetDateStr(0),
            merchants: '',
            platformName: '',
            port: '',
            back: '',
            replenishment: '',
            refund: '',
            payment: '',
            orderExternal: 'orderExternal',
            productId: $stateParams.productId || $location.search().productId ||'',
            sku: $stateParams.sku || $location.search().sku ||''
        };

        $scope.sort = function () {
            vm.tableData.sort = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            init();
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        init()
        function init() {
            vm.tableList = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            SalesOrder.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        Product.getAllByCategory({type: 'OrderingProduct'}, function (res) {
            vm.productList = res;
            if(vm.tableData.productId != ''){
                for(var i=0; i<vm.productList.length; i++ ){
                    if(vm.productList[i].id == vm.tableData.productId){
                        vm.product = vm.productList[i];
                        vm.skuList = vm.productList[i].propertyConfigs;
                    }
                }
            }
        });

        $scope.selectProduct =function(data){
            if(data){
                vm.tableData.productId = data.id;
                vm.skuList = data.propertyConfigs;
            }else {
                vm.tableData.productId = "";
                vm.tableData.sku = "";
                vm.skuList = [];
            }
        };

        $scope.filter = function(){
            vm.isFilter = !vm.isFilter;
            vm.tableData.back = '';
            vm.tableData.replenishment= '';
            vm.tableData.refund= '';
        };
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };
        $scope.tableTr = function(data){
            vm.tablePitch = data;
        };
        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                page: 0,
                size: 20,
                sort: ['createdDate,DESC'],
                state:'',
                source:'',
                startDate: '',
                endDate: '',
                merchants: '',
                payment: '',
                port: '',
                back: '',
                replenishment: '',
                refund: '',
                orderExternal: 'orderExternal',
                productId: $stateParams.productId || $location.search().productId ||'',
                sku:$stateParams.sku || $location.search().sku ||''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        }
        //查看订单
        $scope.orderLook = function () {
            $state.go('orderVipDetails',{id:vm.tablePitch.id});
        };

        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/sales_order/exportDataExternal',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "外部订单" + Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        // 上传文件CSV
        $scope.orderUploadCsv = function(){
            $uibModal.open({
                templateUrl: 'app/order/order-upload-scv.html',
                controller: 'OrderUploadCsvController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return null;
                    }]
                }
            }).result.then(function (backData) {
                init();
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderExtemalDetailsController', OrderExtemalDetailsController);

    OrderExtemalDetailsController.$inject = ['$scope', 'Principal', 'entity', 'LoginService', '$state','User','MessageService', 'ParseLinks', '$localStorage','$http', '$stateParams', '$rootScope'];

    function OrderExtemalDetailsController ($scope, Principal, entity, LoginService, $state,User,MessageService, ParseLinks, $localStorage, $http, $stateParams, $rootScope) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.salesOrder = entity;
        //打印
        // $scope.printpage = function () {
        //     var iframe = document.getElementById('print-frame');
        //     if (iframe === null || iframe === undefined) {
        //         iframe = document.createElement('iframe');
        //         iframe.lang = 'en';
        //         iframe.style.display = 'none';
        //         iframe.id = 'print-frame';
        //         document.body.insertBefore(iframe,document.body.children[0]);
        //         iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title>主板文件</title><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'><link rel='stylesheet' href='content/css/main.css'>";
        //     }
        //
        //     setTimeout(function () {
        //         iframe.contentDocument.body.innerHTML = document.getElementById("printPage").innerHTML;
        //         iframe.contentDocument.getElementById("printHide").style.display="none";
        //         iframe.contentDocument.getElementById("printHide1").style.display="none";
        //         iframe.contentWindow.focus();
        //         iframe.contentWindow.print();
        //     },300);
        // };


        $scope.printpageBtn = function(){

            $http({
                url: 'api/sales_order/downloadJustifyFiles',
                method: "GET",
                params: {id: vm.salesOrder.id},
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var fileName = vm.salesOrder.number + (!vm.salesOrder.sku ? "" :"_" + vm.salesOrder.sku) + (!vm.salesOrder.propertySku ? "" : "_" + vm.salesOrder.propertySku);
                var blob = new Blob([data], {type: "application/zip"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                a.setAttribute('download', fileName);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (error, status) {
                if(status == 400){
                    MessageService.error("组版文件不存在");
                }else{
                    MessageService.error(error.data.message || "导出失败，请重试！");
                }
            });
        };
    //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    source: $stateParams.source,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    timeWarning: $stateParams.timeWarning,
                    replenishment: $stateParams.replenishment,
                    refund: $stateParams.refund,
                    supplierId: $stateParams.supplierId,
                    productId: $stateParams.productId,
                    keyword: $stateParams.keyword,
                    promoteProduct: $stateParams.promoteProduct
                });
            }else {
                history.back();
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderExpressController', OrderExpressController);

    OrderExpressController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder','$uibModalInstance', 'entity', 'Express'];

    function OrderExpressController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder, $uibModalInstance, entity, Express) {
        var vm = this;
        vm.order_express = entity;
        vm.order_expressIds =vm.order_express.map(function(item){return item.number;});

        Express.getAll(function(res){
            vm.express = res.filter(function(item){return item.enable})
        });

        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        //保存
        $scope.save = function () {
            if(!vm.code){
                MessageService.error("物流指定不能为空");
                return;
            }

            vm.orderData ={
                numbers: vm.order_expressIds.join(','),
                expressId: vm.code
            };
            SalesOrder.appointLogisticsCompany(vm.orderData, function (res) {
                MessageService.success("物流公司指定成功");
                $uibModalInstance.close(true);
            }, function (error) {
                MessageService.error("物流公司指定失败");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderDetailsController', OrderDetailsController);

    OrderDetailsController.$inject = ['$scope', 'Principal', 'entity', '$state', 'MessageService', '$localStorage', '$stateParams', '$rootScope', '$uibModal','OrderPack','DeliveryRequest','SupplierDeliveryRequest'];

    function OrderDetailsController ($scope, Principal, entity, $state, MessageService, $localStorage, $stateParams, $rootScope, $uibModal,OrderPack,DeliveryRequest,SupplierDeliveryRequest) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.salesOrder = entity;
        vm.fileUrl = vm.salesOrder.justifyFile;
        if(vm.salesOrder.justifyFile){
            if (vm.salesOrder.justifyFile.indexOf('http') >= 0) {
                vm.fileUrl = vm.salesOrder.justifyFile;
            } else if (vm.salesOrder.justifyFile.indexOf('.pdf') > 0 || vm.salesOrder.justifyFile.indexOf('.zip') > 0) {
                vm.fileUrl = vm.salesOrder.channelUrl + '/' + vm.salesOrder.justifyFile;
                if (vm.salesOrder.justifyFile.indexOf('.zip') > 0) {
                    vm.salesOrder.orderType = 'General';
                }
            } else {
                vm.fileUrl = vm.salesOrder.channelUrl + vm.salesOrder.justifyFile +'/'+ vm.salesOrder.sourceOrderNumber + '.pdf';
            }
        }
        // OrderPack.get({id: vm.salesOrder.orderPackId}, function (res) {
        //     vm.orderPack = res;
        // })
        vm.orderPack = [];
        vm.SupplierOrderPack = [];
        DeliveryRequest.bySaleOrder({id: vm.salesOrder.id}, function (res) {
            vm.orderPack = res;
        })
        SupplierDeliveryRequest.bySaleOrder({id: vm.salesOrder.id}, function (res) {
            vm.SupplierOrderPack = res;
        })

        //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    source: $stateParams.source,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    timeWarning: $stateParams.timeWarning,
                    replenishment: $stateParams.replenishment,
                    refund: $stateParams.refund,
                    supplierId: $stateParams.supplierId,
                    productId: $stateParams.productId,
                    keyword: $stateParams.keyword,
                    promoteProduct: $stateParams.promoteProduct,
                    phone: $stateParams.phone,
                    logisticsNumber: $stateParams.logisticsNumber,
                    deliveryType: $stateParams.deliveryType,
                });
            }else {
                history.back();
            }
        };

        $scope.editAddress = function(){
            $uibModal.open({
                templateUrl: 'app/order/order-address.html',
                controller: 'OrderAddressController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return vm.salesOrder
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    $state.reload();
                }
            });
        };
        $scope.viewDeliveryTrack = function(type){
            $uibModal.open({
                templateUrl: 'app/order/delivery-track.html',
                controller: 'DeliveryTrackController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return vm.salesOrder
                    }],
                    type: [function() {
                        return type
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    $state.reload();
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderAddressController', OrderAddressController);

    OrderAddressController.$inject = ['$q', '$scope', 'Principal', '$state', 'MessageService', 'SalesOrder','$uibModalInstance', 'entity', 'LocationProvice', 'LocationCity', 'LocationDistrict', 'OrderPack'];

    function OrderAddressController ($q, $scope, Principal, $state, MessageService, SalesOrder, $uibModalInstance, entity, LocationProvice, LocationCity, LocationDistrict, OrderPack) {
        var vm = this;
        vm.salesOrder = entity;

        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;

        $q.all([vm.salesOrder.$promise]).then(function(){
            init();
        });

        function init() {
            OrderPack.get({id:vm.salesOrder.id}, function (res) {
                vm.orderPack = res;
                // 获取地址
                LocationProvice.query({},function (data) {
                    vm.provinces =  data;
                    for (var i = vm.provinces.length - 1; i >= 0; i--) {
                        var p = vm.provinces[i];
                        if (res.orderLocation && p.name == res.orderLocation.address.split("-")[0]) {
                            vm.province = p;
                            break;
                        }
                    }
                    vm.districts = [];
                    if(vm.province){
                        LocationCity.findByProvince({provinceId: vm.province.id}, function (data) {
                            vm.citys = data;
                            for (var i = vm.citys.length - 1; i >= 0; i--) {
                                var c = vm.citys[i];
                                if (res.orderLocation && c.name == res.orderLocation.address.split("-")[1]) {
                                    vm.city = c;
                                    break;
                                }
                            }
                            if(vm.city){
                                LocationDistrict.findByCities({cityId: vm.city.id}, function (data) {
                                    vm.districts = data;
                                    for (var i = vm.districts.length - 1; i >= 0; i--) {
                                        var di = vm.districts[i];
                                        if (res.orderLocation && di.name == res.orderLocation.address.split("-")[2]) {
                                            vm.district = di;
                                            vm.address = res.orderLocation.address.split(vm.district.name+"-")[1];
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            })
        }

        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
            });
        }

        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        $scope.save = function() {
            vm.orderPack.orderLocation.address = vm.province.name+"-"+vm.city.name+"-"+vm.district.name+"-"+vm.address;
            OrderPack.updateOrderLocation(vm.orderPack, function(data){
                MessageService.success("修改成功！");
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('orderWarn', {
                parent: 'module',
                url: '/orderWarn',
                params:{page: null,state: null,source: null,startDate: null,endDate: null,back: null,timeWarning: null,replenishment: null,refund: null,supplierId: null,productId: null,keyword: null,productCategoryId:null, sku:null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-warn.html',
                        controller: 'OrderWarnController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('orderSelf', {
                parent: 'module',
                url: '/orderSelf',
                params:{page: null,state: null,source: null,startDate: null,endDate: null,back: null,timeWarning: null,replenishment: null,refund: null,supplierId: null,productId: null,keyword: null,productCategoryId:null, sku:null,phone:null,logisticsNumber:null,deliveryType:null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-self.html',
                        controller: 'OrderSelfController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('orderGeneral', {
                parent: 'module',
                url: '/orderGeneral',
                params:{page: null,state: '',source: null,startDate: null,endDate: null,back: null,timeWarning: null,replenishment: null,refund: null,supplierId: null,productId: null,keyword: null,productCategoryId:null, sku:null,number:null,logisticsNumber:null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-general.html',
                        controller: 'OrderGeneralController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })

            .state('ordergGeneralDetails', {
                parent: 'module',
                url: '/ordergGeneralDetails/{id}',
                params:{page: null,state: null,source: null,startDate: null,endDate: null,back: null,timeWarning: null,replenishment: null,refund: null,supplierId: null,productId: null,keyword: null,productCategoryId:null, sku:null,number:null,logisticsNumber:null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-general-details.html',
                        controller: 'OrderGeneralDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('orderExternal', {
                parent: 'module',
                url: '/orderExternal',
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-external.html',
                        controller: 'OrderExternalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('orderReplenish', {
                parent: 'module',
                url: '/orderReplenish',
                params:{page: null,state: null,source: null,startDate: null,endDate: null,back: null,keyword: null,productCategoryId:null, sku:null},
                data: {
                    authorities: ['ROLE_REPLENISHMENT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-replenish.html',
                        controller: 'OrderReplenishController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('orderDetails', {
                parent: 'module',
                url: '/orderDetails/{id}',
                params:{page: null,state: null,source: null,startDate: null,endDate: null,back: null,timeWarning: null,replenishment: null,refund: null,supplierId: null,productId: null,keyword: null,productCategoryId:null, sku:null,phone:null,logisticsNumber:null,deliveryType:null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-details.html',
                        controller: 'OrderDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }],
                    entity: ['SalesOrder','$stateParams', function(SalesOrder, $stateParams) {
                        return SalesOrder.get({id : $stateParams.id}).$promise;
                    }]
                }
            })
            .state('orderExtemalDetails', {
                parent: 'module',
                url: '/orderExtemalDetails/{id}',
                params:{page: null,state: null,source: null,startDate: null,endDate: null,back: null,timeWarning: null,replenishment: null,refund: null,supplierId: null,productId: null,keyword: null,productCategoryId:null, sku:null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-extemal-details.html',
                        controller: 'OrderExtemalDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }],
                    entity: ['SalesOrder','$stateParams', function(SalesOrder, $stateParams) {
                        return SalesOrder.get({id : $stateParams.id}).$promise;
                    }]
                }
            })
            .state('orderVipDetails', {
                parent: 'module',
                url: '/orderVipDetails/{id}',
                data: {
                    authorities: ['ROLE_VIP_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/orderVip-details.html',
                        controller: 'OrderVipDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('ordergGeneralPreview', {
                parent: 'module',
                url: '/ordergGeneralPreview/{id}',
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/order/order-general-preview.html',
                        controller: 'OrderGeneralPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderPack', function($stateParams, OrderPack) {
                        return OrderPack.get({id: $stateParams.id}).$promise;
                    }]
                }

                // OrderPack.get({id : $stateParams.id},function(res){
                //     vm.data = res
                //     if(res.status === 'ToDelivery'){
                //         getReserve()
                //     }
                // },function(){

                // })
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('SalesOrder', SalesOrder)
        .factory('OrderPack', OrderPack)
        .factory('PayOrders', PayOrders);

    SalesOrder.$inject = ['$resource'];
    OrderPack.$inject = ['$resource'];
    PayOrders.$inject = ['$resource'];

    function SalesOrder ($resource) {
        var resourceUrl =  'api/sales_order/:id';

        return $resource(resourceUrl, {}, {
            'updateOrder':{
                method: 'POST',
                params: {
                    id: 'updateOrder'
                }
            },
            'updateOrderBatch':{
                method: 'POST',
                isArray: true,
                params: {
                    id: 'updateOrderBatch'
                }
            },
            'getHotLinkData':{
                method: 'GET',
                params: {
                    id: 'getHotLinkData'
                }
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'manufactureStats': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'manufactureStats'
                }
            },
            'getNumByCondition': {
                method: 'GET',
                params: {
                    id: 'getNumByCondition'
                }
            },
            'byCondition': {
                method: 'POST',
                isArray: true,
                params: {
                    id: 'byCondition'
                }
            },
            'pageWarnCount2': {
                method: 'POST',
                params: {
                    id: 'pageWarnCount2'
                }
            },
            'getReplenishData2': {
                method: 'GET',
                params: {
                    id: 'getReplenishData2'
                }
            },
            'getReplenishData': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'getReplenishData'
                }
            },
            'getData4Supplier': {
                method: 'GET',
                params: {
                    id: 'getData4Supplier'
                }
            },
            'getData4SupplierPage': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'getData4Supplier/page'
                }
            },
            'getByOrderMakeupFileId': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'getByOrderMakeupFileId'
                }
            },
            'allot': {
                method: 'GET',
                params: {
                    id: 'allot'
                }
            },
            'noAllot': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'no_allot'
                }
            },
            'noAllotMakeUpId': {
                method: 'GET',
                params: {
                    id: 'no_allot_make_up_id'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'exportData1': {
                method: 'GET',
                params: {
                    id: 'exportData1'
                }
            },
            'exportData2': {
                method: 'GET',
                params: {
                    id: 'exportData2'
                }
            },
            'replenishment': {
                method: 'POST',
                params: {
                    id: 'replenishment'
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    id: 'id'
                }
            },
            'getOrderTask':{
                method:'GET',
                isArray: true,
                params: {
                    id: 'getOrderTask'
                }
            },
            'taskAssigned':{
                method:'GET',
                params: {
                    id: 'taskAssigned'
                }
            },
            'addRemarks':{
                method:'GET',
                params: {
                    id: 'addRemarks'
                }
            },
            'appointLogisticsCompany':{
                method:'GET',
                params: {
                    id: 'appointLogisticsCompany'
                }
            },
            'pageWarn': {
                method: 'GET',
                params: {
                    id: 'pageWarn'
                },
                isArray: true
            },
            'pageWarnCount': {
                method: 'GET',
                params: {
                    id: 'pageWarnCount'
                }
            },
            'updateLocation': {
                method: 'POST',
                params: {
                    id: 'updateLocation'
                }
            },
            'getAllStoreName': {
                method: 'GET',
                params: {
                    id: 'getAllStoreName'
                },
                isArray: true
            },
            'getData4Channel': {
                method: 'GET',
                params: {
                    id: 'getData4Channel'
                }
            },
            'getData4ChannelPage': {
                method: 'GET',
                params: {
                    id: 'getData4Channel/page'
                },
                isArray: true
            },
            'getData4DowmloadPage': {
                method: 'GET',
                params: {
                    id: 'getData4Dowmload/page'
                },
                isArray: true
            },
            'downloadData4Dowmload': {
                method: 'GET',
                params: {
                    id: 'downloadData4Dowmload'
                }
            },
            'exportReplenishData': {
                method: 'GET',
                params: {
                    id: 'exportReplenishData'
                }
            },
            'getHomePageData': {
                method: 'GET',
                params: {
                    id: 'getHomePageData'
                }
            },
            'storeNames': {
                method: 'GET',
                params: {
                    id: 'storeNames'
                },
                isArray: true
            }
        });
    }
    function OrderPack ($resource) {
        var resourceUrl =  'api/order_pack/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'revoke': {
                method: 'POST',
                params: {
                    id: 'revoke'
                }
            },
            'replenishment': {
                method: 'POST',
                params: {
                    id: 'replenishment'
                }
            },
            'updateOrderLocation': {
                method: 'POST',
                params: {
                    id: 'updateOrderLocation'
                }
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'fetchReserve': {
                method: 'GET',
                params: {
                    path: 'getReserve'
                }
            },
            'delivery': {
                method: 'POST',
                params: {
                    id: 'delivery'
                }
            },
            'deleteOrder': {
                method: 'DELETE'
            }
        });
    }

    function PayOrders ($resource) {
        var resourceUrl =  'api/pay-orders/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'replenishment': {
                method: 'POST',
                params: {
                    id: 'replenishment'
                }
            },
            'updateOrderLocation': {
                method: 'POST',
                params: {
                    id: 'updateOrderLocation'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryTrackController', DeliveryTrackController);

    DeliveryTrackController.$inject = ['$q', '$scope', 'OrderTraces', '$state', 'MessageService', 'SalesOrder','$uibModalInstance', 'entity', 'type', 'LocationCity', 'LocationDistrict', 'OrderPack'];

    function DeliveryTrackController ($q, $scope, OrderTraces, $state, MessageService, SalesOrder, $uibModalInstance, entity, type, LocationCity, LocationDistrict, OrderPack) {
        var vm = this;
        vm.salesOrder = entity;
        vm.trackData = []
        vm.type = type //供应商物流
        $q.all([vm.salesOrder.$promise]).then(function(){
            init();
        });

        function init() {
            OrderTraces.byOrderId({orderId:vm.salesOrder.id,supplier:vm.type == 'supplier'}, function (res) {
                if(res && res.length>0 && res[0].traces){
                    vm.trackData = res[0].traces;
                }
            })
        }
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        $scope.save = function() {
            vm.orderPack.orderLocation.address = vm.province.name+"-"+vm.city.name+"-"+vm.district.name+"-"+vm.address;
            OrderPack.updateOrderLocation(vm.orderPack, function(data){
                MessageService.success("修改成功！");
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryDialogController', DeliveryDialogController);

    DeliveryDialogController.$inject = ['$q', '$scope', 'OrderPack', 'isDetail', 'MessageService', 'Express', 'entity', '$uibModalInstance', 'DeliveryRequest'];

    function DeliveryDialogController ($q, $scope, OrderPack, isDetail, MessageService, Express, entity, $uibModalInstance, DeliveryRequest) {
        var vm = this;
        vm.data = entity;

        Express.getAll(function(res){
            vm.expressCompanies = res.filter(function(item){return item.enable});
        });
        //取消
        $scope.cancelRecord = function () {
            $uibModalInstance.close();
        }

        $scope.save = function () {
            if(!vm.deliveryComp){
                MessageService.error('请选择快递公司');
                return
            }
            if(!vm.logisticsNumber){
                MessageService.error('请输入快递单号');
                return
            }
            var lines = []
            vm.data.salesOrders.forEach(function(item){
                var obj = {
                    id:item.id,
                    warehouseId:item.warehouseId
                }
                lines.push(obj)
            })
            var _data =  {
                id:vm.data.id,
                logisticsNumber:vm.logisticsNumber,
                deliveryComp:vm.deliveryComp,
                lines:lines
            }
            OrderPack.delivery(_data, function (res) {
                MessageService.success("发货成功")
                $uibModalInstance.close(true);
            },function(error){
                MessageService.error(res.message || "发货失败");
            })
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('SideBarService', SideBarService);

        SideBarService.$inject = ['$uibModal'];

    function SideBarService ($uibModal) {

        var service = {
            sort: sort
        };

        function sort(){
            $(function() {
                $('#nav-accordion').dcAccordion({
                    eventType: 'click',
                    autoClose: true,
                    saveState: true,
                    disableLink: true,
                    speed: 'slow',
                    showCount: false,
                    autoExpand: true,
                    classExpand: 'dcjq-current-parent'
                });
            });

            jQuery('#sidebar .sub-menu > a').click(function () {
                var o = ($(this).offset());
                diff = 250 - o.top;
                if(diff>0)
                    $("#sidebar").scrollTo("-="+Math.abs(diff),500);
                else
                    $("#sidebar").scrollTo("+="+Math.abs(diff),500);
            });

            $(function() {
                function responsiveView() {
                    var wSize = $(window).width();
                    if (wSize <= 768) {
                        $('#container').addClass('sidebar-close');
                        $('#sidebar > ul').hide();
                    }

                    if (wSize > 768) {
                        $('#container').removeClass('sidebar-close');
                        $('#sidebar > ul').show();
                    }
                }
                $(window).on('load', responsiveView);
                $(window).on('resize', responsiveView);
            });

            $('.fa-bars').click(function () {
                if ($('#sidebar > ul').is(":visible") === true) {
                    $('#main-content').css({
                        'margin-left': '0px'
                    });
                    $('#sidebar').css({
                        'margin-left': '-240px'
                    });
                    $('#sidebar > ul').hide();
                    $("#container").addClass("sidebar-closed");
                } else {
                    $('#main-content').css({
                        'margin-left': '240px'
                    });
                    $('#sidebar > ul').show();
                    $('#sidebar').css({
                        'margin-left': '0'
                    });
                    $("#container").removeClass("sidebar-closed");
                }
            });
        }

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ModuleResetPasswordController', ModuleResetPasswordController);

    ModuleResetPasswordController.$inject = ['Auth', 'Principal','$uibModalInstance','User','$state','Password'];

    function ModuleResetPasswordController (Auth, Principal,$uibModalInstance,User,$state,Password) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.cancel = cancel;
        vm.success = null;
        vm.postData = {
            password: null
        };

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password != vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                vm.postData.password = vm.password;
                Password.change(vm.password,function(data){
                    vm.error = null;
                    vm.success = 'OK';
                    $uibModalInstance.close();
                    Auth.logout();
                    $state.go('login');
                });
            }
        }

        function cancel (){
            $state.go("home");
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('module', {
            abstract: true,
            parent: 'app',
            url: '/module',
            data: {
                authorities: []
            },
            views: {
                'index@': {
                    templateUrl: 'app/module/module.html',
                    controller: 'ModuleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ModuleController', ModuleController);

    ModuleController.$inject = ['$scope','Auth', 'Principal', '$uibModal', 'LoginService', '$state','Module','SideBarService', '$sessionStorage','$timeout','Notices', 'MessageService'];

    function ModuleController ($scope, Auth,Principal, $uibModal, LoginService, $state,Module,SideBarService, $sessionStorage,$timeout,Notices, MessageService) {
        var vm = this;
        vm.modules = Module;
        vm.hide = hide;
        vm.check = check;
        vm.logout = logout;
        vm.jzMessage = [];
        vm.noticeModule = noticeModule;
        vm.user = $sessionStorage.user;
        vm.jzMessageShow = false;
        vm.unReadCount = 0;
        vm.getUnReadCount = getUnReadCount;
        // console.log(vm.user);

        SideBarService.sort();

        init();
        function init() {
            Notices.unRead({
                keyword:'',
                read:false,
                page: 0,
                size: 10,
                sort: "id,DESC",
            }, function (res) {
                vm.jzMessage = res;
            })
        }
        getUnReadCount();
        function getUnReadCount(){
            return Notices.getUnReadCount({}, function (res) {
                vm.unReadCount = res.count;
            })
        }

        vm.stompClient = null;
        var sockjs_url = '/scm/ws';
        function connect() {
            var socket = new SockJS(sockjs_url);//连接服务端的端点，连接以后才可以订阅广播消息和个人消息
            vm.stompClient = Stomp.over(socket);
            vm.stompClient.connect({}, function(frame) {
                vm.stompClient.subscribe('/topic/notices', function(greeting){
                    var body = JSON.parse(greeting.body)
                    vm.unReadCount = body ? body.count : 0;
                    $scope.$apply();
                });
            });
        }
        connect()

        $scope.jzMessageOver = function(e){
            if(!vm.jzMessageShow){
                vm.jzMessageShow = true;
                init();
            }
        },
        $scope.jzMessageLeave = function(){
            vm.jzMessageShow = false;
        },
        $scope.$on('moduleInit', function () {
            init();
        });

        $scope.navSelect = function (nav,outerIndex) {
            $state.go(nav.id,nav.parameter);
            if(vm.navId == nav.id){
                return
            }
            angular.element('.sub_menu').removeClass('navOn');
            vm.navId = nav.id;
            sessionStorage.setItem('subId',nav.id);//二级菜单的id
            sessionStorage.setItem('outerIndex',outerIndex);//一级菜单index
            sessionStorage.removeItem('tableData');
        };


        //等待页面加载完成之后 自执行
        vm.subId = sessionStorage.getItem('subId');
        vm.outerIndex = sessionStorage.getItem('outerIndex');
        if(vm.subId && vm.outerIndex) {
            $timeout(function () {
                angular.element('#z' + vm.outerIndex).trigger('click');
                angular.element('#' + vm.subId).addClass('navOn');
            }, 100);
        }

        //列表收缩 展开
        $(document).on('click', '.list-menu', function(){
            if(!$(this).hasClass('on')){
                $(this).next('.shell-nav-body').slideDown(200).parent().siblings('li').find('.shell-nav-body').slideUp(200);
                $(this).addClass('on').parent().siblings('li').find('.list-menu').removeClass('on');
                $(this).find('.shell-nav-head-fr-show').addClass('rotateIcon').end().parent().siblings('li').find('.shell-nav-head-fr-show').removeClass('rotateIcon');
            }else{
                $(this).removeClass('on');
                $(this).next('.shell-nav-body').slideUp(200).parent().siblings('li').find('.shell-nav-body').slideUp(200);
                $(this).find('.shell-nav-head-fr-show').removeClass('rotateIcon');
            }
        });

        function hide(){
            var wSize = $(window).width();
            if(wSize<768){
                vm.click = true;
            }
        }

        function check(){
            var wSize = $(window).width();
            if(wSize<768){
                if(vm.click){
                    $('#sidebar').removeClass("test");
                    vm.click = false;
                }
            }
            if(wSize>768){
                $('#sidebar').removeClass("test");
                vm.click = false;
            }
        }

        function logout(){
            vm.stompClient.disconnect();
            Auth.logout();
            $state.go("login");
            sessionStorage.removeItem('subId');
            sessionStorage.removeItem('outerIndex');
            sessionStorage.removeItem('tableData');
        }

        //重置密码
        $scope.modifyContent = function(){
            $uibModal.open({
                templateUrl: 'app/user/user-password.html',
                controller: 'UserPasswordController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return vm.user;
                    }
                }
            }).result.then(function(result){
                if(result){
                    logout();
                }
            });
        };

        Principal.identity().then(function(data) {
        	vm.auth=data.authorities;
        	if(vm.auth.length>0){
        		for(var i=0;i<vm.auth.length;i++){
        			if(vm.modules.length>0){
        				for(var j=0;j<vm.modules.length;j++){
        					if(vm.modules[j].auth.length>0&&vm.modules[j].auth.indexOf(vm.auth[i])>-1){
        						vm.modules[j].visiable = true;
        						if(vm.modules[j].menus.length>0){
        							for(var k=0;k<vm.modules[j].menus.length;k++){
        								if(vm.modules[j].menus[k].auth.length>0&&vm.modules[j].menus[k].auth.indexOf(vm.auth[i])>-1){
        									vm.modules[j].menus[k].visiable = true;
        								}
        							}
        						}
        					}
        				}
        			}
        		}
        	}
        });

        //标记已读
        $scope.read = function (data) {
            Notices.read({id:data.id}, function (res) {
                MessageService.success('已读');
                init();
            })
        };
        //全部已读
        $scope.readBatch = function () {
            var _ids = [];
            if(vm.jzMessage.length> 0){
                for(var i=0; i<vm.jzMessage.length; i++){
                    _ids.push(vm.jzMessage[i].id)
                }
                Notices.readBatch(_ids, function (res) {
                    MessageService.success('已读');
                    init();
                })
            }
        };
        function noticeModule(item){
            switch(item) {
                case 'Team':
                    return '团队'
                case 'Order':
                    return '订单'
                case 'InquiryOrder':
                    return '询价单'
                case 'Information':
                    return '案例'
                default:
                    return ''
            }
        }
    }
})();

(function($){
	$.fn.dcAccordion = function(options) {

		//set default options 
		var defaults = {
			classParent	 : 'dcjq-parent',
			classActive	 : 'active',
			classArrow	 : 'dcjq-icon',
			classCount	 : 'dcjq-count',
			classExpand	 : 'dcjq-current-parent',
			eventType	 : 'click',
			hoverDelay	 : 300,
			menuClose     : true,
			autoClose    : true,
			autoExpand	 : false,
			speed        : 'slow',
			saveState	 : true,
			disableLink	 : true,
			showCount : false,
		};

		//call in the default otions
		var options = $.extend(defaults, options);

		this.each(function(options){

			var obj = this;
			setUpAccordion();
			if(defaults.autoExpand == true){
				$('li.'+defaults.classExpand+' > a').addClass(defaults.classActive);
			}
			resetAccordion();

			if(defaults.eventType == 'hover'){

				var config = {
					sensitivity: 2, // number = sensitivity threshold (must be 1 or higher)
					interval: defaults.hoverDelay, // number = milliseconds for onMouseOver polling interval
					over: linkOver, // function = onMouseOver callback (REQUIRED)
					timeout: defaults.hoverDelay, // number = milliseconds delay before onMouseOut
					out: linkOut // function = onMouseOut callback (REQUIRED)
				};

				$('li a',obj).hoverIntent(config);
				var configMenu = {
					sensitivity: 2, // number = sensitivity threshold (must be 1 or higher)
					interval: 1000, // number = milliseconds for onMouseOver polling interval
					over: menuOver, // function = onMouseOver callback (REQUIRED)
					timeout: 1000, // number = milliseconds delay before onMouseOut
					out: menuOut // function = onMouseOut callback (REQUIRED)
				};

				$(obj).hoverIntent(configMenu);

				// Disable parent links
				if(defaults.disableLink == true){

					$('li a',obj).click(function(e){
						if($(this).siblings('ul').length >0){
							e.preventDefault();
						}
					});
				}

			} else {
			
				$('li a',obj).click(function(e){

					$activeLi = $(this).parent('li');
					$parentsLi = $activeLi.parents('li');
					$parentsUl = $activeLi.parents('ul');

					// Prevent browsing to link if has child links
					if(defaults.disableLink == true){
						if($(this).siblings('ul').length >0){
							e.preventDefault();
						}
					}

					// Auto close sibling menus
					if(defaults.autoClose == true){
						autoCloseAccordion($parentsLi, $parentsUl);
					}

					if ($('> ul',$activeLi).is(':visible')){
						$('ul',$activeLi).slideUp(defaults.speed);
						$('a',$activeLi).removeClass(defaults.classActive);
					} else {
						$(this).siblings('ul').slideToggle(defaults.speed);
						$('> a',$activeLi).addClass(defaults.classActive);
					}
					
				});
			}

			// Set up accordion
			function setUpAccordion(){

				$arrow = '<span class="'+defaults.classArrow+'"></span>';
				var classParentLi = defaults.classParent+'-li';
				$('> ul',obj).show();
				$('li',obj).each(function(){
					if($('> ul',this).length > 0){
						$(this).addClass(classParentLi);
						$('> a',this).addClass(defaults.classParent).append($arrow);
					}
				});
				$('> ul',obj).hide();
				if(defaults.showCount == true){
					$('li.'+classParentLi,obj).each(function(){
						if(defaults.disableLink == true){
							var getCount = parseInt($('ul a:not(.'+defaults.classParent+')',this).length);
						} else {
							var getCount = parseInt($('ul a',this).length);
						}
						$('> a',this).append(' <span class="'+defaults.classCount+'">'+getCount+'</span>');
					});
				}
			}
			
			function linkOver(){

			$activeLi = $(this).parent('li');
			$parentsLi = $activeLi.parents('li');
			$parentsUl = $activeLi.parents('ul');

			// Auto close sibling menus
			if(defaults.autoClose == true){
				autoCloseAccordion($parentsLi, $parentsUl);

			}

			if ($('> ul',$activeLi).is(':visible')){
				$('ul',$activeLi).slideUp(defaults.speed);
				$('a',$activeLi).removeClass(defaults.classActive);
			} else {
				$(this).siblings('ul').slideToggle(defaults.speed);
				$('> a',$activeLi).addClass(defaults.classActive);
			}

			// Write cookie if save state is on
			if(defaults.saveState == true){
				createCookie(defaults.cookie, obj);
			}
		}

		function linkOut(){
		}

		function menuOver(){
		}

		function menuOut(){

			if(defaults.menuClose == true){
				$('ul',obj).slideUp(defaults.speed);
				// Reset active links
				$('a',obj).removeClass(defaults.classActive);
				createCookie(defaults.cookie, obj);
			}
		}

		// Auto-Close Open Menu Items
		function autoCloseAccordion($parentsLi, $parentsUl){
			$('ul',obj).not($parentsUl).slideUp(defaults.speed);
			// Reset active links
			$('a',obj).removeClass(defaults.classActive);
			$('> a',$parentsLi).addClass(defaults.classActive);
		}
		// Reset accordion using active links
		function resetAccordion(){
			$('ul',obj).hide();
			$allActiveLi = $('a.'+defaults.classActive,obj);
			$allActiveLi.siblings('ul').show();
		}
		});
	};
})(jQuery);
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent:'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'index@': {
                    templateUrl: 'app/login/login.html',
                    controller: 'AppLoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AppLoginController', AppLoginController);

    AppLoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth','MessageService'];

    function AppLoginController ($rootScope, $state, $timeout, Auth,MessageService) {
        var vm = this;

        vm.authenticationError = false;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.remember = remember;

        $timeout(function (){angular.element('#username').focus();});
        sessionStorage.removeItem('subId');
        sessionStorage.removeItem('outerIndex');
        sessionStorage.removeItem('tableData');

        function remember(){
            vm.rememberMe = !vm.rememberMe;
        };

        function login (event) {
            event.preventDefault();
            if(vm.username==null){
                MessageService.error("请输入用户名");
                return;
            }
            if(vm.password==null){
                MessageService.error("请输入密码");
                return;
            }
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    location.reload();


                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                } else {
                    location.reload();
                    $timeout(function(){
                        $state.go('home');
                    },1000);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplierDeliveryDetailController', SupplierDeliveryDetailController);

    SupplierDeliveryDetailController.$inject = ['$scope', '$state','MessageService', 'DeliveryRequest', 'entity', '$stateParams','$q','$filter','OrderTraces'];

    function SupplierDeliveryDetailController ($scope,$state,MessageService,DeliveryRequest, entity, $stateParams,$q,$filter,OrderTraces) {
        var vm = this;
        vm.tracesList =[];
        vm.invoice = entity;

        $q.all([vm.invoice.$promise]).then(function(){
            vm.deliveryTime =  $filter('date')(vm.invoice.deliveryTime, "yyyy-MM-dd HH:mm:ss");

            // 获取实时物流信息
            OrderTraces.getByDeliveryRequestId({deliveryRequestId: vm.invoice.id}, function(data){
                vm.tracesList = data.traces;
            })
        });

        //返回
        $scope.goBack = function () {
            $state.go("supplier-delivery",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplierDeliveryController', SupplierDeliveryController);

    SupplierDeliveryController.$inject = ['$scope', '$http', 'Principal', 'LoginService', '$state', 'SupplierDeliveryOrder', 'Express', 'MessageService',
    'ParseLinks', '$stateParams', 'SalesOrder', 'Supplier', 'DateUtils'];

    function SupplierDeliveryController ($scope, $http, Principal, LoginService, $state, SupplierDeliveryOrder, Express, MessageService,
        ParseLinks, $stateParams, SalesOrder, Supplier, DateUtils) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            expressSettingId:'',
            keyword: '',
            deliveryStart:'',
            deliveryEnd:'',
            supId:'',
            deliveryStatus:'',
            delivered:true
        };
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'已发货', value:'Delivered'},
            {name:'已揽件', value:'Receiving'},
            {name:'已签收', value:'Received'},
            {name:'物流异常', value:'Abnormal'},
        ];
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);

        Express.getAll(function(res){
            vm.expressCompanies = res.filter(function(item){return item.enable});
        });
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            vm.tableData.deliveryStart = angular.copy(angular.element("#startDate").val());
            vm.tableData.deliveryEnd = angular.copy(angular.element("#endDate").val());
            SupplierDeliveryOrder.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.page = 0;
            vm.tableData.deliveryStatus = data.value;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                expressSettingId:'',
                keyword: '',
                deliveryStart:'',
                deliveryEnd:'',
                supId:"",
                deliveryStatus:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        };
        $scope.deliverChange = function(){
            for(var i=0; i<vm.expressCompanies.length; i++){
                if(vm.expressCompanies[i].id == vm.tableData.expressSettingId){
                    vm.tableData.supId = vm.expressCompanies[i].supplierId
                }
            }
        }


        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/supplier-delivery-order/exportData',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "供应商发货记录_" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");

            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$state','MessageService', 'DeliveryRequest', 'entity', '$stateParams','$q','$filter','OrderTraces'];

    function InvoiceDetailController ($scope,$state,MessageService,DeliveryRequest, entity, $stateParams,$q,$filter,OrderTraces) {
        var vm = this;
        vm.tracesList =[];
        vm.invoice = entity;

        $q.all([vm.invoice.$promise]).then(function(){
            vm.deliveryDate =  $filter('date')(vm.invoice.deliveryDate, "yyyy-MM-dd HH:mm:ss");

            // 获取实时物流信息
            OrderTraces.getByDeliveryRequestId({deliveryRequestId: vm.invoice.id}, function(data){
                vm.tracesList = data.traces;
            })
        });

        //返回
        $scope.goBack = function () {
            $state.go("invoice",{page: $stateParams.page});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('invoice', {
                parent: 'module',
                url: '/invoice',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/invoice/invoice.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoiceDetail', {
                parent: 'module',
                url: '/invoiceDetail/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/invoice/invoice-detail.html',
                        controller: 'InvoiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DeliveryRequest', function($stateParams, DeliveryRequest) {
                        return DeliveryRequest.get({id : $stateParams.id});
                    }]
                }
            })
            .state('supplier-delivery', {
                parent: 'module',
                url: '/supplier-delivery',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/invoice/supplier-delivery.html',
                        controller: 'SupplierDeliveryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplier-delivery-detail', {
                parent: 'module',
                url: '/supplier-delivery/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/invoice/supplier-delivery-detail.html',
                        controller: 'SupplierDeliveryDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SupplierDeliveryOrder', function($stateParams, SupplierDeliveryOrder) {
                        return SupplierDeliveryOrder.detail({id : $stateParams.id});
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Invoice', Invoice)
        .factory('OrderTraces', OrderTraces);

    Invoice.$inject = ['$resource'];
    OrderTraces.$inject = ['$resource'];

    function Invoice ($resource) {
        var resourceUrl =  'api/deliver-orders/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getRealTimeExpress': {
                method: 'GET',
                params: {
                    path: 'getRealTimeExpress'
                }
            }
        });
    }
    function OrderTraces ($resource) {
        var resourceUrl =  'api/order-traces/:path/:id';

        return $resource(resourceUrl, {}, {
            'getByDeliveryRequestId': {
                method: 'GET',
                params: {
                    path: 'getByDeliveryRequestId'
                }
            },
            'byOrderId': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'byOrderId'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$scope', '$http', 'Principal', 'LoginService', '$state', 'DeliveryRequest', 'Express', 'MessageService',
    'ParseLinks', '$stateParams', 'SalesOrder', 'Supplier', 'DateUtils'];

    function InvoiceController ($scope, $http, Principal, LoginService, $state, DeliveryRequest, Express, MessageService,
        ParseLinks, $stateParams, SalesOrder, Supplier, DateUtils) {
        var vm = this;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            expressSettingId:'',
            keyword: '',
            deliveryStart:'',
            deliveryEnd:'',
            supId:'',
            deliveryStatus:'',
            delivered:true
        };
        vm.conditionList = [
            {name:'全部', value:''},
            {name:'已发货', value:'Delivered'},
            {name:'已揽件', value:'Receiving'},
            {name:'已签收', value:'Received'},
            {name:'物流异常', value:'Abnormal'},
        ];
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);

        Express.getAll(function(res){
            vm.expressCompanies = res.filter(function(item){return item.enable});
        });
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.clear =clear;
        init();
        function init() {
            vm.tableList = [];
            vm.tableData.deliveryStart = angular.copy(angular.element("#startDate").val());
            vm.tableData.deliveryEnd = angular.copy(angular.element("#endDate").val());
            DeliveryRequest.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.page = 0;
            vm.tableData.deliveryStatus = data.value;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                expressSettingId:'',
                keyword: '',
                deliveryStart:'',
                deliveryEnd:'',
                supId:"",
                deliveryStatus:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        };
        $scope.deliverChange = function(){
            for(var i=0; i<vm.expressCompanies.length; i++){
                if(vm.expressCompanies[i].id == vm.tableData.expressSettingId){
                    vm.tableData.supId = vm.expressCompanies[i].supplierId
                }
            }
        }


        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/delivery-request/exportData',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "发货记录_" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");

            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('StoreRefundGoodsDetailsController', StoreRefundGoodsDetailsController);

    StoreRefundGoodsDetailsController.$inject = ['$scope', 'Principal', '$state', 'MessageService', '$localStorage', '$stateParams', '$rootScope', '$uibModal','refundGoods','FindWarehouse'];

    function StoreRefundGoodsDetailsController ($scope, Principal,  $state, MessageService, $localStorage, $stateParams, $rootScope, $uibModal,refundGoods,FindWarehouse) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_RETURN').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.searchWarehouse= searchWarehouse

        init()

        function init(){
            refundGoods.get({id : $stateParams.id},function(res){
                vm.data = res
                vm.data.lines.forEach(function(item,index){
                    if(vm.data.status === 'ToConfirm'){
                        item.warehouseId = item.warehouses.length ? item.warehouses[0].id : ''
                        item.refundQuantity = item.refundQuantity !== null ? item.refundQuantity : item.quantity
                        item.refundPrice = item.refundPrice !== null ? item.refundPrice : item.price
                    }
                    searchWarehouse(item)
                })
            },function(res){
                MessageService.error("查询失败，请重试！");
            })
        }

        //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    stockOrderNumber: $stateParams.stockOrderNumber,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    number: $stateParams.number,
                    storeName: $stateParams.storeName,
                });
            }else {
                history.back();
            }
        };

        // 是否确认退货
        $scope.save = function(item){
            if(!valiData(vm.data.lines)) return
            MessageService.confirm("是否确认退货?", function () {
                refundGoods.confirm(vm.data, function () {
                    init();
                    MessageService.success("退货成功");
                }, function (error) {
                    MessageService.error(error.data.message || "退货失败，请重试！");
                });
            });
        }

        function valiData(data){
            var flag = true
            data.forEach(function(item){
                if(flag){
                    if(!item.warehouseId){
                        MessageService.error("请选择退货入库仓库！");
                        flag = false
                        return
                    }
                    if(item.refundQuantity == null){
                        MessageService.error("请输入实收数量！");
                        flag = false
                        return
                    }
                    if(item.refundPrice === null || item.refundPrice === ''){
                        MessageService.error("请输入实收单价！");
                        flag = false
                        return
                    }
                }
            })
            return flag
        }

        // 是否确认关闭
        $scope.close = function(item){
            MessageService.confirm("是否确认关闭?", function () {
                refundGoods.close({id:vm.data.id}, function () {
                    init();
                    MessageService.success("关闭成功");
                }, function (error) {
                    MessageService.error("关闭失败，请重试！");
                });
            });
        }

        $scope.getStatus = function(item){
            switch (item) {
                case 'ToConfirm':
                    return '待确认';
                case 'Confirm':
                    return '已确认';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }

        // 查库存
        function searchWarehouse(item,index){
            // 仓库名赋值
            item.warehouses.forEach(function(itm){
                if(itm.id === item.warehouseId) item.warehouseName = itm.name
            })
            var params = {
                warehouseId:item.warehouseId,
                productNumber:item.scmNumber,
            }
            if(!item.warehouseId) {
                item.inventoryDesc = ''
                return
            }
            FindWarehouse.searchByidAndNumber(params, function (res) {
                if(res.message && res.message.usableQuantity !== null){
                    item.inventoryDesc = res.message.usableQuantity
                }else{
                    item.inventoryDesc = ''
                }
            }, function (error) {
                MessageService.error("查询失败，请重试！");
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('StoreRefundGoodsController', StoreRefundGoodsController);

    StoreRefundGoodsController.$inject = ['$scope', 'Principal', 'refundGoods', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'DateUtils'];

    function StoreRefundGoodsController ($scope, Principal, refundGoods, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, DateUtils){
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_RETURN').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];


        vm.conditionList = [
            {name:'全部', value:''},
            {name:'待确认', value:'ToConfirm'},
            {name:'已确认', value:'Confirm'},
            {name:'已关闭', value:'Close'},
        ];
        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            storeName: $stateParams.storeName || $location.search().storeName || '',
            state:$stateParams.state || $location.search().state || '',
            stockOrderNumber:$stateParams.stockOrderNumber || $location.search().stockOrderNumber || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            back: $stateParams.back || $location.search().back || '',
            number: $stateParams.number || $location.search().number || ''
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'stockOrderNumber':vm.tableData.stockOrderNumber,
                'startDate':vm.tableData.startDate,
                'storeName':vm.tableData.storeName,
                'number':vm.tableData.number,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back
            });
            vm.tableData.items= getItems()
            var _data = {
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
                items:getItems()
            }
            refundGoods.byCondition(_data, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.number = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['id,DESC'],
                page: 0,
                size: 20,
                state:'',
                stockOrderNumber:'',
                startDate: '',
                endDate: '',
                back: '',
                number:'',
                storeName:''
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };


        //导出
        $scope.orderExportDetails = function () {
            $http({
                url: 'api/inventory-refunds/export',
                method: "POST",
                data: {items:getItems()},
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "门店退货" + DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        //导出
        $scope.orderExport = function () {
            var url = 'api/inventory-refunds/exportSummaryDate?number='+ vm.tableData.number + '&storeName=' + vm.tableData.storeName
            var _startTime = vm.tableData.startDate ? DateUtils.convertLocalDateToServer(vm.tableData.startDate) + "T00:00:00.000Z" : ''
            var _endTime = vm.tableData.endDate ? DateUtils.convertLocalDateToServer(vm.tableData.endDate) + "T23:59:59.000Z" : ''
                url += '&timeStart=' + _startTime +'&timeEnd=' + _endTime
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "门店退货统计"+ DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function getItems(){
            var items = []
            if(vm.tableData.stockOrderNumber){
                items.push({key:'stockOrderNumber',op:'=',value:vm.tableData.stockOrderNumber})
            }
            if(vm.tableData.number){
                items.push({key:'number',op:'=',value:vm.tableData.number})
            }
            if(vm.tableData.storeName){
                items.push({key:'storeName',op:'like',value:vm.tableData.storeName})
            }
            if (vm.tableData.state) {
                items.push({key: "status", op: "=", value: vm.tableData.state});
            };
            if (vm.tableData.startDate) {
                items.push({key: "createdDate", op: ">=", value: DateUtils.convertLocalDateToServer(vm.tableData.startDate)+"T00:00:00.000Z"});
            };
            if (vm.tableData.endDate) {
                items.push({key: "createdDate", op: "<=", value: DateUtils.convertLocalDateToServer(vm.tableData.endDate)+"T23:59:59.000Z"});
            };
            return items
        }

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });


        $scope.getStatus = function(item){
            switch (item) {
                case 'ToConfirm':
                    return '待确认';
                case 'Confirm':
                    return '已确认';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundPreviewController', OutBoundPreviewController);

    OutBoundPreviewController.$inject = ['$scope','$state', '$q', 'MessageService', 'entity','$http','$localStorage','DateUtils'];

    function OutBoundPreviewController ($scope, $state, $q, MessageService, entity,$http,$localStorage,DateUtils) {
        var vm = this;
        vm.data = entity;
        vm.nums = 0;
        vm.token = $localStorage.authenticationToken;
        vm.outNums = 0;
        $q.all([vm.data.$promise]).then(function(){
            if(vm.data.lines.length>0){
                vm.data.lines.forEach(function (item){
                    if(!item.cancelled){
                        vm.nums += item.num;
                        vm.outNums += item.outNum;
                    }
                })
            }
        });
        $scope.goback = function (){
            history.back();
        };

        $scope.export = function (){
            $http({
                url: 'api/inventory-stock-out/exportDetail/'+vm.data.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = vm.data.storeName + "_出库单_" + DateUtils.convertLocalDateToServer(Date.now()) +".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        }

        $scope.preview = function (){
            var iframe = document.getElementById('print-frame');
            if (iframe === null || iframe === undefined) {
                iframe = document.createElement('iframe');
                iframe.lang = 'en';
                iframe.style.display = 'none';
                iframe.id = 'print-frame';
                document.body.insertBefore(iframe, document.body.children[0]);
                iframe.contentDocument.head.innerHTML = "<meta charset='UTF-8'><title></title><link rel='stylesheet' href='content/css/main.css'><link rel='stylesheet' href='bower_components/bootstrap/dist/css/bootstrap.css'>";
            }

            setTimeout(function () {
                var changePrint = function (type) {
                    var html = '';
                    type = type?type:1;
                    if(type=='1'){
                        html='<style type="text/css" media="print">\n' + '  @page { size: landscape; }\n' + '</style>';
                    }else{
                        html='<style type="text/css" media="print">\n' + '  @page { size: portrait; }\n' + '</style>';
                    }
                    return html;
                };
                $('#previewId').append(changePrint(1));
                iframe.contentDocument.body.innerHTML = document.getElementById("previewId").innerHTML;
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 300);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundDifferenceDetailsController', OutBoundDifferenceDetailsController);

    OutBoundDifferenceDetailsController.$inject = ['$scope', 'Principal', '$state', 'MessageService', '$localStorage', '$stateParams', '$rootScope', '$uibModal','stockDiffs','FindWarehouse'];

    function OutBoundDifferenceDetailsController ($scope, Principal,  $state, MessageService, $localStorage, $stateParams, $rootScope, $uibModal,stockDiffs,FindWarehouse) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_DIFF').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;


        init()

        function init(){
            stockDiffs.get({id : $stateParams.id},function(res){
                vm.data = res
                // 默认选中当前商品的第一个仓库并查询库存
                if(vm.data.status === 'UnShippedOut'){
                    vm.data.lines.forEach(function(item,index){
                        item.outNum = item.num
                        item.warehouseId = item.warehouses[0].id
                        // searchWarehouse(item)
                    })
                }

            },function(res){
                MessageService.error("查询失败，请重试！");
            })
        }

        //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    stockOrderNumber: $stateParams.stockOrderNumber,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    number: $stateParams.number,
                    storeName: $stateParams.storeName,
                });
            }else {
                history.back();
            }
        };

        // 处理差异
        $scope.handleDifference = function(item){
            MessageService.confirm("是否确认处理差异?", function () {
                stockDiffs.confirm({id: vm.data.id,remark:vm.data.remark}, function () {
                    init();
                    MessageService.success("确认成功");
                }, function (error) {
                    MessageService.error(error.data.message || "确认失败，请重试！");
                })
            });
        }
        // 驳回差异
        $scope.handleRejectDifference = function(item){
            MessageService.confirm("是否确认驳回差异?", function () {
                stockDiffs.reject({id: vm.data.id}, function () {
                    MessageService.success("驳回成功");
                    init();
                }, function (error) {
                    MessageService.error(error.data.message || "驳回失败，请重试！");
                })
            });
        }

        $scope.getStatus = function(item){
            switch (item) {
                case 'ToCheck':
                    return '待确认';
                case 'Check':
                    return '已确认';
                case 'Rejected':
                    return '已驳回';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundDifferenceController', OutBoundDifferenceController);

    OutBoundDifferenceController.$inject = ['$scope', 'Principal', 'stockDiffs', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'DateUtils'];

    function OutBoundDifferenceController ($scope, Principal, stockDiffs, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, DateUtils) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_DIFF').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        vm.conditionList = [
            {name:'全部', value:''},
            {name:'待确认', value:'ToCheck'},
            {name:'已确认', value:'Check'},
            {name:'已驳回', value:'Rejected'}
        ];
        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            storeName: $stateParams.storeName || $location.search().storeName || '',
            state:$stateParams.state || $location.search().state || '',
            stockOrderNumber:$stateParams.stockOrderNumber || $location.search().stockOrderNumber || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            back: $stateParams.back || $location.search().back || '',
            number: $stateParams.number || $location.search().number || ''
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'stockOrderNumber':vm.tableData.stockOrderNumber,
                'startDate':vm.tableData.startDate,
                'storeName':vm.tableData.storeName,
                'number':vm.tableData.number,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back
            });
            vm.tableData.items= getItems()
            var _data = {
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
                items:getItems()
            }
            stockDiffs.byCondition(_data, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.number = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['id,DESC'],
                page: 0,
                size: 20,
                state:'',
                stockOrderNumber:'',
                startDate: '',
                endDate: '',
                back: '',
                number:'',
                storeName:'',
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };


        //导出
        $scope.orderExportDetails = function () {
            $http({
                url: 'api/inventory-stock-diffs/import',
                method: "POST",
                data: {items:getItems()},
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "门店入库差异明细.xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };


        //导出
        $scope.orderExport = function () {
            var url = 'api/inventory-stock-diff/export?number='+ vm.tableData.number + '&storeName=' + vm.tableData.storeName
            var _startTime = vm.tableData.startDate ? DateUtils.convertLocalDateToServer(vm.tableData.startDate) + "T00:00:00.000Z" : ''
            var _endTime = vm.tableData.endDate ? DateUtils.convertLocalDateToServer(vm.tableData.endDate) + "T23:59:59.000Z" : ''
                url += '&timeStart=' + _startTime +'&timeEnd=' + _endTime
            $http({
                url: url,
                method: "GET",
                // data: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "门店入库差异统计.xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function getItems(){
            var items = []
            if(vm.tableData.stockOrderNumber){
                items.push({key:'stockOrderNumber',op:'=',value:vm.tableData.stockOrderNumber})
            }
            if(vm.tableData.number){
                items.push({key:'number',op:'=',value:vm.tableData.number})
            }
            if(vm.tableData.storeName){
                items.push({key:'storeName',op:'like',value:vm.tableData.storeName})
            }
            if (vm.tableData.state) {
                items.push({key: "status", op: "=", value: vm.tableData.state});
            };
            if (vm.tableData.startDate) {
                items.push({key: "createdDate", op: ">=", value: DateUtils.convertLocalDateToServer(vm.tableData.startDate)+"T00:00:00.000Z"});
            };
            if (vm.tableData.endDate) {
                items.push({key: "createdDate", op: "<=", value: DateUtils.convertLocalDateToServer(vm.tableData.endDate)+"T23:59:59.000Z"});
            };
            return items
        }


        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });


        $scope.getStatus = function(item){
            switch (item) {
                case 'ToCheck':
                    return '待确认';
                case 'Check':
                    return '已确认';
                case 'Rejected':
                    return '已驳回';
                default:
                    return item
            }
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundDetailsController', OutBoundDetailsController);

    OutBoundDetailsController.$inject = ['$scope', 'Principal', '$state', 'MessageService', '$localStorage', '$stateParams', '$rootScope', '$uibModal','OutBound','FindWarehouse','$http','DateUtils','OutBound1'];

    function OutBoundDetailsController ($scope, Principal,  $state, MessageService, $localStorage, $stateParams, $rootScope, $uibModal,OutBound,FindWarehouse,$http,DateUtils,OutBound1) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_OUT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.searchWarehouse = searchWarehouse;
        vm.refoundAmount = 0


        init()

        function init(){
            OutBound.get({id : $stateParams.id},function(res){
                vm.data = res
                // 默认选中当前商品的第一个仓库并查询库存
                if(vm.data.status === 'UnShippedOut'){
                    vm.data.lines.forEach(function(item,index){
                        item.outNum = item.num
                        item.warehouseId = item.warehouses[0].id
                        searchWarehouse(item)
                    })
                }
                res.lines.forEach(function(item){
                    if(item.num - item.outNum > 0){
                        vm.refoundAmount += (item.num - item.outNum) * item.price
                    }
                })
            },function(res){
                MessageService.error("查询失败，请重试！");
            })
        }

        //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    stockOrderNumber: $stateParams.stockOrderNumber,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    number: $stateParams.number,
                    storeName: $stateParams.storeName,
                });
            }else {
                history.back();
            }
        };
        // 出库
        $scope.outBound = function(flag){
            $uibModal.open({
                templateUrl: 'app/inventoryManagement/components/out-bound-detail-tips.html',
                controller: 'OutBoundDetailTipsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return vm.data;
                    },
                    flag:flag
                }
            }).result.then(function(result){
                console.log('resultresultresult',result);
                if(result && result.expressNumber){
                    vm.data.expressNumber = result.expressNumber
                }
                if(result.flag){
                    OutBound.outBound(vm.data, function () {
                        MessageService.success("出库成功");
                        history.back();
                    }, function (error) {
                        MessageService.error("出库失败，请重试！");
                    })
                }else{
                    console.log(result);
                    // 仅修改快递单号
                    OutBound1.expressNumber({id:vm.data.id,expressNumber:result.expressNumber}, function () {
                        MessageService.success("修改成功");
                        init()
                    }, function (error) {
                        MessageService.error("修改失败，请重试！");
                    })
                }
            });
        };

        // 关闭出库单
        $scope.close = function(){
            $uibModal.open({
                templateUrl: 'app/inventoryManagement/components/close-outBount-dialog.html',
                controller: 'CloseOutBoundDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function () {
                        return vm.data.id
                    }]
                }
            }).result.then(function (reason) {
                OutBound.close({id:vm.data.id,reason:reason}, function () {
                    MessageService.success("关闭成功");
                    history.back();
                }, function (error) {
                    MessageService.error("关闭失败，请重试！");
                });
            });
        };

        // 查库存
        function searchWarehouse(item,index){
            // 仓库名赋值
            item.warehouses.forEach(function(itm){
                if(itm.id === item.warehouseId) item.warehouseName = itm.name
            })
            var params = {
                warehouseId:item.warehouseId,
                productNumber:item.scmNumber,
            }
            if(!item.warehouseId) {
                item.inventoryDesc = ''
                return
            }
            FindWarehouse.searchByidAndNumber(params, function (res) {
                if(res.message && res.message.availableQuantity !== null){
                    item.inventoryDesc = res.message.availableQuantity
                }else{
                    item.inventoryDesc = ''
                }
            }, function (error) {
                MessageService.error("查询失败，请重试！");
            });
        };

        // 出库数量是否大于库存
        $scope.checkNum = function(itm,oNum){
            // console.log(itm.inventoryDesc);
            // if(itm.inventoryDesc === 0){
            //     MessageService.error("该仓库库存不足");
            //     itm.outNum  = null
            //     return
            // }
            if(itm.inventoryDesc === '' || itm.inventoryDesc === null){
                MessageService.error("请先选择出库仓库");
                itm.outNum  = null
                return
            }
            if(oNum > itm.inventoryDesc){
                MessageService.error("出库数量不能大于库存数量");
                itm.outNum  = null
                return
            }
            if(oNum > itm.num){
                MessageService.error("出库数量不能大于报货数量");
                itm.outNum  = null
                return
            }
        };

        // 单价格式限制 大于等于0 小数点后两位
        $scope.checkPrice = function(itm,num){
            if(!num){
                itm.price = 0
                return
            }else{
                num = num.toString()
            }
            const regex = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;

            if (!regex.test(num)) {
                if (num.startsWith('-')) {
                    MessageService.error('单价不能小于0')
                    itm.price = 0
                    return
                }
                const cleaned = num.replace(/[^\d.]/g, '');
                if (cleaned === '') return '';

                const parts = cleaned.split('.');
                var integerPart = parts[0];

                var decimalPart = parts.length > 1 ? parts[1].slice(0, 2) : '';
                if (integerPart === '') {
                    integerPart = '0';
                }
                if (decimalPart.length > 2) {
                    decimalPart = decimalPart.slice(0, 2);
                }
                var _num =  integerPart + decimalPart ? '.' + decimalPart : ''
                num = Number(_num)
                itm.price = num
            }
        };

        // 处理差异
        $scope.handleDifference = function(item){
            MessageService.confirm("是否确认生成门店入库差异单?", function () {
                OutBound.checkDiff({inventoryStockOutId: vm.data.id}, function () {
                    init();
                    MessageService.success("生成成功");
                }, function (error) {
                    MessageService.error("生成失败，请重试！");
                });
            });
        }

        $scope.export = function(type){
            $http({
                url: 'api/inventory-stock-out/exportInventoryStockOutDetail/'+vm.data.id+'?reportType=' + type,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var tableName = type === 'storeBill' ? "门店账单" : "仓库成本"
                var filename = vm.data.number + tableName + DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        }

        // 出库数量不能为空判断
        function valiData(){
            var flag = true
            vm.data.lines.forEach(function(item){
                if(flag){
                    if(item.outNum === null){
                        MessageService.error("出库数量不能为空")
                        flag = false
                    }
                    if(item.outNum > item.inventoryDesc){
                        MessageService.error("出库数量不能大于现有库存数量")
                        flag = false
                    }
                }

            })
            return flag
        }

        // 去采购
        $scope.jump = function(){
            $state.go('purchaseProductLineAdd');
        };
        $scope.getStatus = function(item){
            switch (item) {
                case 'UnShippedOut':
                    return '未出库';
                case 'UnPaid':
                    return '待支付';
                case 'PartShippedOut':
                    return '部分出库';
                case 'Cancelled':
                    return '未支付作废';
                case 'ShippedOut':
                    return '已出库';
                case 'ShippedIn':
                    return '已收货';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundController', OutBoundController);

    OutBoundController.$inject = ['$scope', 'Principal', 'OutBound', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'DateUtils'];

    function OutBoundController ($scope, Principal, OutBound, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, DateUtils) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_OUT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.dateType = 'businessTime'
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        vm.conditionList = [
            {name:'全部', value:''},
            {name:'未出库', value:'UnShippedOut'},
            {name:'已出库', value:'ShippedOut'},
            {name:'部分出库', value:'PartShippedOut'},
            {name:'已收货', value: 'ShippedIn'},
            {name:'已关闭', value: 'Close'},
        ];
        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            storeName: $stateParams.storeName || $location.search().storeName || '',
            payType: $stateParams.payType || $location.search().payType || '',
            state:$stateParams.state || $location.search().state || '',
            stockOrderNumber:$stateParams.stockOrderNumber || $location.search().stockOrderNumber || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            back: $stateParams.back || $location.search().back || '',
            number: $stateParams.number || $location.search().number || ''
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());

            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'stockOrderNumber':vm.tableData.stockOrderNumber,
                'startDate':vm.tableData.startDate,
                'storeName':vm.tableData.storeName,
                'payType':vm.tableData.payType,
                'number':vm.tableData.number,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back
            });
            vm.tableData.items= getItems()
            var _data = {
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
                items:getItems()
            }
            OutBound.byCondition(_data, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.number = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                stockOrderNumber:'',
                startDate: '',
                endDate: '',
                back: '',
                number:'',
                storeName:'',
                payType:'',
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };


        //导出
        $scope.orderExport = function () {
            var url = 'api/inventory-stock-out/export?number='+ vm.tableData.number + '&storeName=' + vm.tableData.storeName + '&payType=' + vm.tableData.payType + '&stockOrderNumber=' + vm.tableData.stockOrderNumber
            var _startTime = vm.tableData.startDate ? DateUtils.convertLocalDateToServer(vm.tableData.startDate) + "T00:00:00.000Z" : ''
            var _endTime = vm.tableData.endDate ? DateUtils.convertLocalDateToServer(vm.tableData.endDate) + "T23:59:59.000Z" : ''
            if(vm.dateType == 'businessTime'){
                url += '&businessStart=' + _startTime +'&businessEnd=' + _endTime
            }else{
                url += '&outStockStart=' + _startTime +'&outStockEnd=' + _endTime
            }
            $http({
                url: url,
                method: "GET",
                // data: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "出库单.xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
        //导出明细
        $scope.orderExportDetails = function () {
            var _data = {
                items:getItems()
            }
            $http({
                url: 'api/inventory-stock-out/exportList',
                method: "POST",
                data: _data,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                // var filename = "采购单" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                var filename = "出库明细" + DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
        //导出汇总明细
        $scope.exportCountDetails = function () {
            var _data = {
                items:getItems()
            }
            $http({
                url: 'api/inventory-stock-out/exportSummaryList',
                method: "POST",
                data: _data,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "汇总明细" + DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (error, status, headers, config) {
                console.log(error);
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function getItems(){
            var items = [{key:'status',op:'in',value:'UnShippedOut;PartShippedOut;ShippedOut;ShippedIn;Close'}]
            if(vm.tableData.stockOrderNumber){
                items.push({key:'stockOrderNumber',op:'=',value:vm.tableData.stockOrderNumber})
            }
            if(vm.tableData.number){
                items.push({key:'number',op:'=',value:vm.tableData.number})
            }
            if(vm.tableData.storeName){
                items.push({key:'storeName',op:'like',value:vm.tableData.storeName})
            }
            if(vm.tableData.payType){
                items.push({key:'payType',op:'=',value:vm.tableData.payType})
            }
            if (vm.tableData.state) {
                items.push({key: "status", op: "=", value: vm.tableData.state});
            };
            if (vm.tableData.startDate) {
                items.push({key: vm.dateType, op: ">=", value: DateUtils.convertLocalDateToServer(vm.tableData.startDate)+"T00:00:00.000Z"});
            };
            if (vm.tableData.endDate) {
                items.push({key: vm.dateType, op: "<=", value: DateUtils.convertLocalDateToServer(vm.tableData.endDate)+"T23:59:59.000Z"});
            };
            return items
        }

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });

        // 处理差异
        $scope.handleDifference = function(item){
            MessageService.confirm("是否确认生成门店入库差异单?", function () {
                OutBound.checkDiff({inventoryStockOutId: item.id}, function () {
                    init();
                    MessageService.success("生成成功");
                }, function (error) {
                    MessageService.error("生成失败，请重试！");
                });
            });
        }

        $scope.getStatus = function(item){
            switch (item) {
                case 'UnShippedOut':
                    return '未出库';
                case 'UnPaid':
                    return '待支付';
                case 'PartShippedOut':
                    return '部分出库';
                case 'Cancelled':
                    return '未支付作废';
                case 'ShippedOut':
                    return '已出库';
                case 'ShippedIn':
                    return '已收货';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }
        $scope.getPayType = function(item){
            switch (item) {
                case 'CASH':
                    return '现结';
                case 'CHARGE':
                    return '记账';
                default:
                    return item
            }
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outBound', {
                parent: 'module',
                url: '/outBound',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null, storeName: null},
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_OUT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/out-bound.html',
                        controller: 'OutBoundController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
            .state('outBoundDetails', {
                parent: 'module',
                url: '/outBoundDetails/{id}',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null,storeName: null},
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_OUT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/out-bound-details.html',
                        controller: 'OutBoundDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('outBoundPreview', {
                parent: 'module',
                url: '/outBoundPreview/{id}',
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_OUT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/out-bound-preview.html',
                        controller: 'OutBoundPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OutBound', function($stateParams, OutBound) {
                        return OutBound.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('outBoundDifference', {
                parent: 'module',
                url: '/outBoundDifference',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null, storeName: null},
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_DIFF']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/out-bound-difference.html',
                        controller: 'OutBoundDifferenceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
            .state('outBoundDifferenceDetails', {
                parent: 'module',
                url: '/outBoundDifferenceDetails/{id}',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null,storeName: null},
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_DIFF']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/out-bound-difference-details.html',
                        controller: 'OutBoundDifferenceDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('storeRefundGoods', {
                parent: 'module',
                url: '/storeRefundGoods',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null, storeName: null},
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_RETURN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/store-refund-goods.html',
                        controller: 'StoreRefundGoodsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })
            .state('storeRefundGoodsDetails', {
                parent: 'module',
                url: '/storeRefundGoodsDetails/{id}',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null,storeName: null},
                data: {
                    authorities: ['ROLE_INVENTORY_STOCK_RETURN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/store-refund-goods-details.html',
                        controller: 'StoreRefundGoodsDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('inBound', {
                parent: 'module',
                url: '/inBound',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null, storeName: null},
                data: {
                    authorities: ['ROLE_ENTRUST']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/in-bound.html',
                        controller: 'InBoundController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('orderSource');
                        return $translate.refresh();
                    }]
                }
            })


            .state('inBoundNew', {
                parent: 'module',
                url: '/inBoundNew',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null,storeName: null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/in-bound-details.html',
                        controller: 'InBoundDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('inBoundDetails', {
                parent: 'module',
                url: '/inBoundDetails/{id}',
                params:{page: null,state: null,stockOrderNumber: null,startDate: null,endDate: null,back: null,number: null,storeName: null},
                data: {
                    authorities: ['ROLE_SELF_SUPPORT_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/inventoryManagement/in-bound-details.html',
                        controller: 'InBoundDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('orderStatus');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('OutBound', OutBound)
        .factory('OutBound1', OutBound1)
        .factory('FindWarehouse', FindWarehouse)
        .factory('stockDiffs', stockDiffs)
        .factory('refundGoods', refundGoods)

        OutBound.$inject = ['$resource'];
        OutBound1.$inject = ['$resource'];
        FindWarehouse.$inject = ['$resource'];
        stockDiffs.$inject = ['$resource'];
        refundGoods.$inject = ['$resource'];

    function OutBound ($resource) {
        var resourceUrl =  'api/inventory-stock-out/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'close': {
                method: 'GET',
                params: {
                    path: 'close'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'outBound': {
                method: 'PUT'
            },
            "byCondition":{
                method:"POST",
                params:{
                    id:"byCondition"
                },
                isArray: true
            },
            'checkDiff': {
                method: 'GET',
                params: {
                    path: 'checkDiff'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
    function OutBound1 ($resource) {
        var resourceUrl =  'api/inventory-stock-out/:path';
        return $resource(resourceUrl, {}, {
            'expressNumber': {
                method: 'GET',
                params: {
                    path: 'expressNumber',
                    id:''
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        console.log('data',data);
                    }
                    return data;
                }
            },
        });
    }
    function FindWarehouse ($resource) {
        var resourceUrl =  'api/reserves/findByWarehouseIdAndProductNumber/:path/:id';

        return $resource(resourceUrl, {}, {
            'searchByidAndNumber': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }

    function stockDiffs ($resource) {
        var resourceUrl =  'api/inventory-stock-diffs/:path/:id';
        return $resource(resourceUrl, {}, {
            'searchByidAndNumber': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    id:"byCondition"
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'confirm': {
                method: 'GET',
                params: {
                    path: 'confirm'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'reject': {
                method: 'GET',
                params: {
                    path: 'reject'
                }
            },
        });
    }
    function refundGoods ($resource) {
        var resourceUrl =  'api/inventory-refunds/:path/:id';
        return $resource(resourceUrl, {}, {
            'searchByidAndNumber': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    id:"byCondition"
                },
                isArray: true
            },
            'close': {
                method: 'GET',
                params:{
                    path:"close"
                }
            },
            'get': {
                method: 'GET'
            },
            'confirm': {
                method: 'PUT'
            },
        });
    }

})();

(function() {
'use strict';

    angular
        .module('gwApp')
        .controller('InBoundDetailsController', InBoundDetailsController);

    InBoundDetailsController.$inject = ['$scope', 'Principal', '$state', 'MessageService', '$localStorage', '$stateParams', '$rootScope', '$uibModal','OutBound','FindWarehouse'];

    function InBoundDetailsController ($scope, Principal,  $state, MessageService, $localStorage, $stateParams, $rootScope, $uibModal,OutBound,FindWarehouse) {
        var vm = this;
        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.searchWarehouse = searchWarehouse;
        vm.data = {}
        vm.data.status = 'UNSUBMITTED'
        vm.selectedPurchase = '' //选中的采购单
        // init()

        function init(){
            OutBound.get({id : $stateParams.id},function(res){
                console.log(res);
                vm.data  = res
                // 默认选中当前商品的第一个仓库并查询库存
                if(vm.data.status === 'UnShippedOut'){
                    vm.data.lines.forEach(function(item,index){
                        item.warehouseId = item.warehouses[0].id
                        searchWarehouse(item)
                    })
                }

            },function(res){
                MessageService.error("查询失败，请重试！");
            })
        }

        //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    stockOrderNumber: $stateParams.stockOrderNumber,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    number: $stateParams.number,
                    storeName: $stateParams.storeName,
                });
            }else {
                history.back();
            }
        };
        // 出库
        $scope.outBound = function(){
            console.log(vm.data);
            if(valiData()){
                 MessageService.confirm("是否确认出库？", function () {
                    OutBound.outBound(vm.data, function () {
                        MessageService.success("出库成功");
                        history.back();
                }, function (error) {
                        MessageService.error("出库失败，请重试！");
                    });
                });
            }
        };

        // 关闭出库单
        $scope.close = function(){
            MessageService.confirm("是否确认关闭该出库单，关闭后无法撤销？", function () {
                OutBound.close({id:vm.data.id}, function () {
                    MessageService.success("关闭成功");
                    history.back();
                }, function (error) {
                    MessageService.error("关闭失败，请重试！");
                });
            });
        };

        // 查库存
        function searchWarehouse(item,index){
            // 仓库名赋值
            item.warehouses.forEach(function(itm){
                if(itm.id === item.warehouseId) item.warehouseName = itm.name
            })
            var params = {
                warehouseId:item.warehouseId,
                productNumber:item.scmNumber,
            }
            FindWarehouse.searchByidAndNumber(params, function (res) {
                if(res.message && res.message.usableQuantity !== null){
                    item.inventoryDesc = res.message.usableQuantity
                }else{
                    item.inventoryDesc = ''
                }
            }, function (error) {
                MessageService.error("查询失败，请重试！");
            });
        };

        // 出库数量是否大于库存
        $scope.checkNum = function(itm,num){
            if(!itm.inventoryDesc){
                MessageService.error("请先选择出库仓库");
                itm.outNum  = null
                return
            }
            if(num > itm.inventoryDesc){
                MessageService.error("出库数量不能大于库存数量");
                itm.outNum  = null
                return
            }
        };

        // 出库数量不能为空判断
        function valiData(){
            var flag = true
            vm.data.lines.forEach(function(item){
                if(flag){
                    if(item.outNum === null){
                        MessageService.error("出库数量不能为空")
                        flag = false
                    }
                }

            })
            return flag
        }


        //    返回   保留筛选信息
        $scope.goBack = function(){
            if($rootScope.previousState){
                $state.go($rootScope.previousState.name,{
                    page: $stateParams.page,
                    state: $stateParams.state,
                    stockOrderNumber: $stateParams.stockOrderNumber,
                    startDate: $stateParams.startDate,
                    endDate: $stateParams.endDate,
                    back: $stateParams.back,
                    number: $stateParams.number,
                    storeName: $stateParams.storeName,
                });
            }else {
                history.back();
            }
        };

        // 关联采购单
        $scope.relationPurchase = function(){
            $uibModal.open({
                templateUrl: 'app/inventoryManagement/components/relation-purchase-dialog.html',
                controller: 'RelationPurchaseDialogTwoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity:[function(){
                        return vm.data.number
                    }]
                }
            }).result.then(function(result){
                // loadAll();
                console.log(result);
                if(result){
                    vm.selectedPurchase = result
                    vm.data.number = result
                }
            });
        };

         //选择商品
         $scope.addProduct =function () {
            var products = [];
            if(vm.data.lines && vm.data.lines.length>0){
                vm.data.lines.forEach(function (itemLine){
                    products.push({
                        id: itemLine.itemValueLineId
                    })
                })
            }
            $uibModal.open({
                templateUrl: 'app/inventoryManagement/components/choose-product-sku.html',
                controller: 'ChooseProductSkuController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return {
                            multiple: true,
                            products:products,
                            productTypes:"GeneralProduct;MaterialProduct"
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    console.log(res);
                    var lines = angular.copy(vm.data.lines);
                    vm.data.lines = [];
                    res.forEach(function (item){
                        // var e = ListService.inList2(item,vm.data.itemLines ,["id"],["itemValueLineId"]);
                        // if(!e){
                        //     var e1 = ListService.inList2(item,_itemLines ,["id"],["itemValueLineId"]);
                        //     if(e1){
                        //         vm.data.itemLines.push(e1);
                        //     }else{
                        //         vm.data.itemLines.push({
                        //             unit:item.unit,
                        //             quantity:0,
                        //             requireQuantity:0,
                        //             price:item.costPrice,
                        //             productId:item.productId,
                        //             productName:item.productName,
                        //             productNumber:item.productNumber,
                        //             sku:item.sku,
                        //             skuNumber:item.number,
                        //             itemValueLineId:item.id,
                        //             remarks:'',
                        //         });
                        //     }
                        // }

                    })
                    getQuantity();
                    // var e = ListService.inList2(res[0],vm.data.itemLines ,["id"],["itemValueLineId"]);
                    // if(e){
                    //     MessageService.error(res[0].sku + "已存在");
                    // }else{
                    //     vm.data.itemLines.push({
                    //         unit:res[0].unit,
                    //         quantity:0,
                    //         requireQuantity:0,
                    //         price:res[0].costPrice,
                    //         productId:res[0].productId,
                    //         productName:res[0].productName,
                    //         productNumber:res[0].productNumber,
                    //         sku:res[0].sku,
                    //         itemValueLineId:res[0].id,
                    //         remarks:'',
                    //     });
                    //     getQuantity()
                    // }
                }
            });
        }

        $scope.getStatus = function(item){
            switch (item) {
                case 'UnShippedOut':
                    return '未出库';
                case 'ShippedOut':
                    return '已出库';
                case 'ShippedIn':
                    return '已入库';
                case 'Close':
                    return '关闭';
                default:
                    return item
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InBoundController', InBoundController);

    InBoundController.$inject = ['$scope', 'Principal', 'OutBound', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'DateUtils'];

    function InBoundController ($scope, Principal, OutBound, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, DateUtils) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_SELF_SUPPORT_ORDER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        vm.conditionList = [
            {name:'全部', value:''},
            {name:'待提交', value:'UnShippedOut'},
            {name:'已完成', value:'Finish'},
            {name:'已关闭', value: 'Close'},
        ];
        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            storeName: $stateParams.storeName || $location.search().storeName || '',
            state:$stateParams.state || $location.search().state || '',
            stockOrderNumber:$stateParams.stockOrderNumber || $location.search().stockOrderNumber || '',
            startDate: $stateParams.startDate || $location.search().startDate || GetDateStr(-31),
            endDate: $stateParams.endDate || $location.search().endDate || GetDateStr(0),
            back: $stateParams.back || $location.search().back || '',
            number: $stateParams.number || $location.search().number || ''
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || GetDateStr(-31));
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || GetDateStr(0));

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'stockOrderNumber':vm.tableData.stockOrderNumber,
                'startDate':vm.tableData.startDate,
                'storeName':vm.tableData.storeName,
                'number':vm.tableData.number,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back
            });
            var items = []


            if(vm.tableData.stockOrderNumber){
                items.push({key:'stockOrderNumber',op:'=',value:vm.tableData.stockOrderNumber})
            }
            if(vm.tableData.number){
                items.push({key:'number',op:'=',value:vm.tableData.number})
            }
            if(vm.tableData.storeName){
                items.push({key:'storeName',op:'like',value:vm.tableData.storeName})
            }
            if (vm.tableData.state) {
                items.push({key: "status", op: "=", value: vm.tableData.state});
            };
            if (vm.tableData.startDate) {
                items.push({key: "businessTime", op: ">=", value: DateUtils.convertLocalDateToServer(vm.tableData.startDate)+"T00:00:00.000Z"});
            };
            if (vm.tableData.endDate) {
                items.push({key: "businessTime", op: "<=", value: DateUtils.convertLocalDateToServer(vm.tableData.endDate)+"T23:59:59.000Z"});
            };
            vm.tableData.items= items
            var _data = {
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
                items:items
            }
            OutBound.byCondition(_data, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.number = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                stockOrderNumber:'',
                startDate: '',
                endDate: '',
                back: '',
                number:'',
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };


        //导出
        $scope.orderExport = function () {
            $http({
                url: 'api/inventory-stock-out/import',
                method: "POST",
                data: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "出库单.xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });


        $scope.getStatus = function(item){
            switch (item) {
                case 'UnShippedOut':
                    return '未出库';
                case 'ShippedOut':
                    return '已出库';
                case 'ShippedIn':
                    return '已入库';
                case 'Close':
                    return '关闭';
                default:
                    return item
            }
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RelationPurchaseDialogTwoController', RelationPurchaseDialogTwoController);

    RelationPurchaseDialogTwoController.$inject = ['$scope','$state','Reserves','$uibModalInstance','MessageService','Inventory','$stateParams','entity'];

    function RelationPurchaseDialogTwoController ($scope, $state,Reserves,$uibModalInstance,MessageService,Inventory,$stateParams,entity) {
        var vm = this;
        //获取产品 、sku 仓库
        // Reserves.getAllReserveByType({type:'accessories'},function(res){
        //     vm.reserves =res;
        // });
        console.log(entity);
        if(entity) vm.pitch = entity
        vm.data = [
            {
                number:1,
                quantity:2,
                amount:4,
                remarks:'备注1',
                createdDate:'2024-04-29T06:09:37Z',
            },
            {
                number:2,
                quantity:2,
                amount:4,
                remarks:'备注2',
                createdDate:'2024-04-29T06:09:37Z',
            },
            {
                number:3,
                quantity:2,
                amount:4,
                remarks:'备注3',
                createdDate:'2024-04-29T06:09:37Z',
            },
        ]

        $scope.search = function(){
            MessageService.error(vm.number+"查询");
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

        $scope.saveRecord = function(){
            $uibModalInstance.close(vm.pitch);
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundDetailTipsController', OutBoundDetailTipsController);

    OutBoundDetailTipsController.$inject = ['$scope','$timeout','$uibModalInstance','msgdata','flag'];

    function OutBoundDetailTipsController ($scope, $timeout,$uibModalInstance,msgdata,flag) {
        var vm = this;
        vm.amount = 0
        vm.lines = []
        vm.flag = flag
        vm.expressNumber = ''
        if(vm.flag){
            init()
        }
        function init(){
            msgdata.lines && msgdata.lines.forEach(function(item){
                console.log(item);
                if(item.num - item.outNum > 0){
                    // var _amount =
                    vm.amount += (item.num - item.outNum) * item.price
                    vm.lines.push(item)
                }
            })
            if(vm.lines.length){
                $timeout(function(){
                    var dom = document.getElementsByClassName('bg-center')
                    var dom1 = document.getElementsByClassName('modal-lg')
                    dom[0].style.width = '990px'
                    dom1[0].style.width = '990px'
                })
            }
        }
        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };
        $scope.save = function(){
            console.log(vm.flag,vm.expressNumber);
            $uibModalInstance.close({flag:vm.flag,expressNumber:vm.expressNumber});
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CloseOutBoundDialogController', CloseOutBoundDialogController);

    CloseOutBoundDialogController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService', 'ParseLinks', 'SalesOrder','$uibModalInstance', 'entity', 'Express'];

    function CloseOutBoundDialogController ($scope, Principal, LoginService, $state,User,MessageService, ParseLinks, SalesOrder, $uibModalInstance, entity, Express) {
        var vm = this;
        vm.id = entity;
        vm.reason = ''

        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        //保存
        $scope.save = function () {
            $uibModalInstance.close(vm.reason);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChooseProductSkuController', ChooseProductSkuController);

    ChooseProductSkuController.$inject = ['$q', '$scope','$uibModalInstance','MessageService','Product','ParseLinks','entity','ListService'];

    function ChooseProductSkuController ($q, $scope, $uibModalInstance,MessageService,Product,ParseLinks,entity,ListService) {
        var vm = this;
        vm.keyword ='';
        vm.data=entity.products || [];
        vm.multiple=entity.multiple || false;
        vm.productTypes=entity.productTypes;
        vm.productTypes2=entity.productTypes2;
        vm.productType2 = null;
        vm.categories = [
            {name:'成品', type:'GeneralProduct', categories:[]},
            {name:'辅料', type:'MaterialProduct', categories:[]},
        ];
        vm.categories.forEach(function (item) {
            if(vm.productTypes && vm.productTypes.indexOf(item.type)>-1){
                item.show = true;
            }
            if(vm.productTypes2 && vm.productTypes2.indexOf(item.type2)>-1){
                item.show = true;
            }
        })
        vm.transition = function(){
            init();
        }
        fetchData()
        function fetchData(){
            var items = [{key:"category",op:"=",value:'GeneralProduct'},{key:"category",op:"=",value:'MaterialProduct'}];
            Product.getAllByCondition({
                // items:items
            }, function (res, headers) {
                console.log(res);
                // vm.links = ParseLinks.parse(headers('link'));
                // vm.queryCount = headers('X-Total-Count');

                // for(var i=0;i<res.length;i++){
                //     for(var j=0;j<res[i].productCirculations.length; j++){
                //         if(res[i].productCirculations[j].defaulted){
                //             res[i].productCirculationsList = res[i].productCirculations[j];
                //         }
                //     }
                // }
                // vm.tableList = res;
                // var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                // vm.pagecount = pages; //得到总页数
                // //调用分页
                // laypage({
                //     cont: 'paging',
                //     curr: (vm.tableData.page + 1), //初始化当前页
                //     pages: pages,
                //     skip: true, //是否开启跳页
                //     first: false,
                //     last: false,
                //     limit: true,
                //     jump: function(obj, first){
                //         if (!first) {
                //             vm.tableData.page = obj.curr - 1;
                //             init();
                //         }
                // //     }
                // });
            }, function (error) {

            });
        }


        // Category.getAllByCondition({
        //     items: [{key: "cancelled", op: "=", value: false},{key: "usable", op: "=", value: "true"},{key: "type", op: "in", value: vm.productTypes}]
        // },function (res) {
        //     res.forEach(function (item) {
        //         var e = ListService.inList(item,vm.categories,["type"]);
        //         if(e){
        //             vm.categories[e.subscriptIndex].categories.push(item);
        //         }
        //     })
        //     for(var i=0; i<vm.categories.length; i++){
        //         if(vm.categories[i].show){
        //             vm.categories[i].selected = true;
        //             if(vm.categories[i].categories){
        //                 vm.categorieId = vm.categories[i].categories[0].id;
        //             }else{
        //                 vm.productType2 = vm.categories[i].type2;
        //             }
        //             init()
        //             break
        //         }
        //     }
        // });
        vm.page=0;
        vm.products = [];
        function init(){
            var items = [
                {key: "product.cancelled", op: "=", value: false},
                {key: "product.saleable", op: "=", value: true},
                {key: "cancelled", op: "=", value: false},
                {key: "enable", op: "=", value: true},
                ];

            if(vm.categorieId){
                items.push({key: "product.category.id", op: "=", value: vm.categorieId})
            }
            if(vm.productType2){
                items.push({key: "product.productType2", op: "=", value: vm.productType2})
            }
            if(vm.keyword){
                items.push({key: "product.name", op: "like", value: vm.keyword})
            }
            // ItemValue.byCondition({
            //     items: items,
            //     page: vm.page,
            //     size: 10,
            //     sort: ["id,asc"]
            // }, function (res,headers) {
            //     vm.links = ParseLinks.parse(headers('link'));
            //     vm.totalItems = headers('X-Total-Count');
            //     vm.queryCount = vm.totalItems;
            //     vm.products = res || [];
            // });
        }

        $scope.categorieClick = function (item) {
            vm.productType2 = null;
            vm.categorieId = item.id;
            vm.page=0;
            vm.products = [];
            vm.keyword = "";
            init()
        }
        $scope.categorieClick1 = function (item) {
            vm.productType2 = item.type2;
            vm.categorieId = null;
            vm.page=0;
            vm.products = [];
            vm.keyword = "";
            init()
        }
        $scope.search = function(){
            vm.page=0;
            vm.products = [];
            init()
        };
        $scope.productChoice = function(data){
            var e = ListService.inList(data,vm.data ,["id"]);
            if(e){
                vm.data.splice(e.subscriptIndex,1);
            }else{
                if(vm.multiple){
                    vm.data.push(data)
                }else{
                    vm.data = [data];
                }
            }
            console.log(vm.data)
        };
        $scope.getExist = function(data){
            var e = ListService.inList(data,vm.data ,["id"]);
            if(e){
                return true
            }else{
                return false
            }
        }
        $scope.save = function(){
            $uibModalInstance.close(vm.data);
        }
        $scope.cancel = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'module',
            url: '/home',
            data: {
                authorities: []
            },
            reload:true,
            views: {
                'content': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$http', '$q', '$scope', 'Principal', '$state', '$localStorage', 'SalesOrder', 'Supplier', 'Channels', 'Reserves', 'Notices'];

    function HomeController ($http, $q, $scope, Principal, $state, $localStorage, SalesOrder, Supplier, Channels, Reserves, Notices) {
        var vm = this;
        vm.orderDatas = SalesOrder.getHotLinkData();
        vm.supplierDatas = Supplier.getHomePageData();
        vm.channelDatas = Channels.getHomePageData();
        vm.reserveDatas = Reserves.getHomePageData();
        vm.newsDatas = Notices.getNewest();
        var myChart = echarts.init(document.getElementById('main'));
        myChart.showLoading();
        $q.all([vm.orderDatas.$promise]).then(function(){
           
            myChart.hideLoading();
            vm.startDate = vm.orderDatas.dateJson[0].date;
            vm.endDate = vm.orderDatas.dateJson[6].date;
            chart(vm.orderDatas.dateJson, myChart);
            function chart(data, myChart) {
                var _time = [];
                var _data = [];
                var _legend = "订单数";
                if (data && data) {
                    for(var i = 0; i< data.length; i++){
                        _time.push(data[i].date); 
                        _data.push(data[i].quantity);
                    }
                }
                var option = {
                    tooltip: {trigger: 'axis'},
                    legend: {
                        data:[_legend]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        data: _time
                    },
                    yAxis: {},
                    series: [{
                        name: _legend,
                        type: 'line',
                        itemStyle : {
                            normal : {
                                color:'#ff9601',
                                lineStyle:{
                                    color:'#ff9601'
                                }
                            }
                        },
                        data: _data
                    }]
                };
                myChart.setOption(option);
            }
        });
    }
})();

/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reserve', {
                parent: 'module',
                url: '/reserve',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/reserve/reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Reserves', Reserves);

    Reserves.$inject = ['$resource'];

    function Reserves ($resource) {
        var resourceUrl =  'api/reserves/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method:'PUT',
                isArray: false
            },
            'delete': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'getHomePageData': {
                method:'GET',
                params: {
                    path: 'getHomePageData'
                }
            },
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllReserveByType': {
                method: 'GET',
                params: {
                    path: 'getAllReserveByType'
                },
                isArray: true
            },
            'getByWarehouseAndProductNumber': {
                method: 'GET',
                params: {
                    path: 'getByWarehouseAndProductNumber'
                }
            }

        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReserveController', ReserveController);

    ReserveController.$inject = ['$scope','Reserves','Depository','MessageService', '$http','ParseLinks', '$localStorage','$stateParams','$uibModal','ProductCategory'];

    function ReserveController ($scope,Reserves,Depository,MessageService, $http,ParseLinks, $localStorage,$stateParams,$uibModal,ProductCategory) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;
        vm.token = $localStorage.authenticationToken;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "product"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });
        vm.productCategoryFirst = ProductCategory.byCondition({items: [{key: 'subordinate', op: '=', value: false},{key: 'sort', op: '=', value: 'product'}, {key: 'enable', op: '=', value: true}]})


        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: 'product',// 类型。accessories 辅料 / product 成品
            key:'',
            state:'all',
            warehouseId:''
        };

        vm.conditionList = [
            {name:'全部', value:'all'},
            {name:'正常', value: 'normal'},
            {name:'预警', value:'warning'}
        ];
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            loadAll();
        };

        loadAll();
        function loadAll() {
            vm.inventories = [];
            Reserves.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.inventories = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }

        $scope.inventoryTask = function(data){
            $uibModal.open({
                templateUrl: 'app/finishedWarehouse/reserve/inventoryTask.html',
                controller: 'InventoryTaskController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                loadAll();
            });
        };

        $scope.allocateTask = function(data){
            $uibModal.open({
                templateUrl: 'app/finishedWarehouse/reserve/allocateTask.html',
                controller: 'AllocationTaskController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                loadAll();
            });
        };


        //下载
        $scope.orderExport = function () {
            $http({
                url: 'api/reserves/exportData',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "成品仓库记录.xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };


        $scope.changeSearchCategoryFirst = function(){
            vm.productCategorySecond = [];
            vm.products = [];
            if (vm.tableData.categoryOneId == null) {
                return;
            }
            ProductCategory.byCondition({items:
                [{key: 'subordinate', op: '=', value: true},
                {key: 'enable', op: '=', value: true},
                {key: 'productCategory.id', op: '=', value: vm.tableData.categoryOneId}]
            }, function(res){
                 vm.productCategorySecond = res;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryTaskController', InventoryTaskController);

    InventoryTaskController.$inject = ['$scope','$state','Reserves','$uibModalInstance','MessageService','Inventory','msgdata'];

    function InventoryTaskController ($scope, $state,Reserves,$uibModalInstance,MessageService,Inventory,msgdata) {
        var vm = this;
        vm.inventory = msgdata;
        $scope.validate = function() {
            if (vm.num === null || vm.num === "") {
                MessageService.error("请输入调整数量");
                return false;
            };
            if(vm.num < 0){
                MessageService.error("数量不可为负数");
                return false;
            }
            if (vm.reason == null || vm.reason == "") {
                MessageService.error("请输入调整原因");
                return false;
            };
            return true;
        };

        $scope.saveInventory = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                skuName:vm.inventory.propertyConfig.sku,
                quantity:vm.inventory.availableQuantity,
                type:vm.num > vm.inventory.availableQuantity ?'in':'out',
                pageType:'product',
                num: vm.num > vm.inventory.availableQuantity ? vm.num - vm.inventory.availableQuantity : vm.inventory.availableQuantity - vm.num,
                warehouse:vm.inventory.warehouse,
                reason:vm.reason,
                propertyConfig: {id: vm.inventory.propertyConfig.id}
            };
            Inventory.create(obj,function (res) {
                MessageService.success("盘点调整新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("盘点调整新建失败1！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AllocationTaskController', AllocationTaskController);

    AllocationTaskController.$inject = ['$scope','$state','$uibModalInstance','MessageService','Product','Allocations','Depository','msgdata'];

    function AllocationTaskController ($scope, $state,$uibModalInstance,MessageService,Product,Allocations,Depository,msgdata) {
        var vm = this;
        vm.allocation = msgdata;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "product"},function(res){
            vm.depositories = res.filter(function(item){return item.defaulted});
        });

        Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
            vm.products = res.filter(function(item){return item.enable});
        })

        $scope.validate = function() {
            if (vm.inWarehouse == null || vm.inWarehouse == "") {
                MessageService.error("请选择调入仓库");
                return false;
            };
            if (vm.allocation.warehouse.id ==vm.inWarehouse.id) {
                MessageService.error("调入仓库和调出仓库一致，无效");
                return false;
            };
            if (!vm.num) {
                MessageService.error("请选择调整数量");
                return false;
            };
            if (vm.num > vm.allocation.usableQuantity) {
                MessageService.error("调出库存不足！");
                return false;
            };
            if (!vm.reason) {
                MessageService.error("请选择调整原因");
                return false;
            };
            return true;
        };

        $scope.saveAllocation = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                inWarehouse:vm.inWarehouse,
                outWarehouse:vm.allocation.warehouse,
                measurement:vm.allocation.measurement,
                propertyConfig:vm.allocation.propertyConfig,
                type:'product',
                num:vm.num,
                reason:vm.reason
            };
            Allocations.create(obj,function (res) {
                MessageService.success("挑拨记录新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("挑拨记录新建失败！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outgoingAndWarehousing', {
                parent: 'module',
                url: '/outgoingAndWarehousing',
                params:{page: null},
                data: {
                    authorities: ['ROLE_OUTIN_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/outgoingAndWarehousing/outgoingAndWarehousing.html',
                        controller: 'OutgoingAndWarehousingController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('WarehouseRecords', WarehouseRecords);

    WarehouseRecords.$inject = ['$resource'];

    function WarehouseRecords ($resource) {
        var resourceUrl =  'api/warehouse-records/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method:'PUT',
                isArray: false
            },
            'delete': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutgoingAndWarehousingController', OutgoingAndWarehousingController);

    OutgoingAndWarehousingController.$inject = ['$scope','WarehouseRecords','Depository','MessageService', 'ParseLinks', '$stateParams'];

    function OutgoingAndWarehousingController ($scope,WarehouseRecords,Depository,MessageService, ParseLinks, $stateParams) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;

        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "product"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: 'product',// 类型。accessories 辅料 / product 成品
            key:'',
            startTime:'',
            endTime:'',
            warehouseId:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        loadAll();
        function loadAll() {
            vm.warehouseRecords = [];
            vm.tableData.startTime = angular.copy(angular.element("#startDate").val());
            vm.tableData.endTime = angular.copy(angular.element("#endDate").val());
            WarehouseRecords.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.warehouseRecords = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.reset = function(){
            vm.tableData = {
                page: 0,
                size: 20,
                type: 'product',// 类型。accessories 辅料 / product 成品
                key:'',
                startTime:'',
                endTime:'',
                warehouseId:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            loadAll();
        };
        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryDetailController', InventoryDetailController);

    InventoryDetailController.$inject = ['$scope','$state','Reserves','$uibModalInstance','msgdata','MessageService'];

    function InventoryDetailController ($scope, $state,Reserves,$uibModalInstance,msgdata,MessageService) {
        var vm = this;
        vm.inventory= msgdata;

        if (vm.inventory.type == 'out') {
            vm.num = vm.inventory.quantity - vm.inventory.num;
        } else if (vm.inventory.type == 'in') {
            vm.num = vm.inventory.quantity + vm.inventory.num;
        }

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryAddController', InventoryAddController);

    InventoryAddController.$inject = ['$scope','$state','Reserves','$uibModalInstance','MessageService','Inventory','$stateParams'];

    function InventoryAddController ($scope, $state,Reserves,$uibModalInstance,MessageService,Inventory,$stateParams) {
        var vm = this;
        //获取产品 、sku 仓库
        Reserves.getAllReserveByType({type:'product'},function(res){
            res.forEach(function(item) {
                if (item && item.productList && Array.isArray(item.productList)) {
                    item.productList.forEach(function(material) {
                        console.log(material);
                        if (material && material.propertyConfigs) {
                            var _temp = material.propertyConfigs.filter(function(config) {
                                return config && !config.cancelled;
                            });
                            material.propertyConfigs = _temp;
                        } else {
                            material = {
                                propertyConfigs : []
                            };
                        }
                    });
                }
            });
            vm.reserves =res;
        });

        vm.flag=false;
        //获取记录数量
        $scope.getRecordNum = function(data){
            if(data ==null){
                vm.quantity='';
                vm.flag=false;
            }else{
                Reserves.getByWarehouseAndProductNumber({
                    warehouseId:vm.warehouse.warehouse.id,
                    propertyConfigId:vm.propertyConfig.id,
                    type:'product'
                },function(res){
                    vm.quantity = res.availableQuantity;
                    vm.flag=false;
                },function(error){
                    vm.quantity =0;
                    vm.flag=true;
                });
            }
        };

        $scope.validate = function() {
            if (vm.warehouse == null || vm.warehouse == "") {
                MessageService.error("请选择仓库");
                return false;
            };

            if (vm.product == null || vm.product == '') {
                MessageService.error('请选择商品');
                return false;
            }
            if (vm.propertyConfig == null || vm.propertyConfig == "") {
                MessageService.error("请选择SKU");
                return false;
            };

            if (vm.quantity == 0) {
                MessageService.error("所选商品无库存记录,无法保存");
                return false;
            };

            if (vm.num == null || vm.num == "") {
                MessageService.error("请输入调整数量");
                return false;
            };

            if (vm.reason == null || vm.reason == "") {
                MessageService.error("请输入调整原因");
                return false;
            };
            return true;
        };

        $scope.saveInventory = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                skuName:vm.propertyConfig.sku,
                type: vm.num > vm.quantity ?'in':'out',
                pageType:'product',
                num: vm.num > vm.quantity ? vm.num - vm.quantity : vm.quantity - vm.num,
                quantity: vm.quantity,
                warehouse: vm.warehouse.warehouse,
                reason: vm.reason,
                propertyConfig: {id: vm.propertyConfig.id}
            };
            Inventory.create(obj,function (res) {
                MessageService.success("盘点调整新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("盘点调整新建失败！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inventory', {
                parent: 'module',
                url: '/inventory',
                params:{page: null},
                data: {
                    authorities: ['ROLE_INVENTORY_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/inventory/inventory.html',
                        controller: 'InventoryController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Inventory', Inventory);

    Inventory.$inject = ['$resource'];

    function Inventory ($resource) {
        var resourceUrl =  'api/inventories/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method:'PUT',
                isArray: false
            },
            'delete': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryController', InventoryController);

    InventoryController.$inject = ['$scope','Inventory','MessageService', 'Depository','ParseLinks', '$stateParams','$uibModal'];

    function InventoryController ($scope,Inventory,MessageService, Depository,ParseLinks, $stateParams,$uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "product"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            pageType: 'product',// 类型。accessories 辅料 / product 成品
            key:'',
            sort: ['createdDate,DESC'],
            startDate:'',
            endDate:'',
            warehouseId:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        loadAll();
        function loadAll() {
            vm.inventories = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            Inventory.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.inventories = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.reset = function(){
            vm.tableData = {
                page: 0,
                size: 20,
                pageType: 'product',// 类型。accessories 辅料 / product 成品
                key:'',
                startDate:'',
                endDate:'',
                warehouseId:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            loadAll();
        };
        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }

        //新建盘点调整
        $scope.newInventory = function(){
            $uibModal.open({
                templateUrl: 'app/finishedWarehouse/inventory/inventory-add.html',
                controller: 'InventoryAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(result){
                loadAll();
            });
        };

        //查看盘点调整
        $scope.viewInventory = function(data){
            $uibModal.open({
                templateUrl: 'app/finishedWarehouse/inventory/inventory-detail.html',
                controller: 'InventoryDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                //loadAll();
            });
        };




    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AllocationAddController', AllocationAddController);

    AllocationAddController.$inject = ['$scope','$state','$uibModalInstance','MessageService','Reserves','Product','Allocations','Depository'];

    function AllocationAddController ($scope, $state,$uibModalInstance,MessageService,Reserves,Product,Allocations,Depository) {
        var vm = this;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "product"},function(res){
            vm.depositories = res.filter(function(item){return item.defaulted});
        });

        Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
            // vm.products = res.filter(function(item){return item.enable});
            var res1 = res.filter(function(item){return item.enable});
            res1.forEach(function(item) {
                        if (item && item.propertyConfigs) {
                            var _temp = item.propertyConfigs.filter(function(config) {
                                return config && !config.cancelled;
                            });
                            item.propertyConfigs = _temp;
                        } else {
                            // item = {
                            //     propertyConfigs : []
                            // };
                        }
            });
            vm.products = res1
        })

        $scope.getUseQuantity = function(data, propertyConfig){
            if(data ==null){
                vm.reserveQuantity =-1;
            }else{
                Reserves.getByWarehouseAndProductNumber({
                    warehouseId: data.id,
                    propertyConfigId: propertyConfig.id,
                    type:'product'
                },function(res){
                    vm.reserveQuantity = res.usableQuantity;
                },function(error){
                    vm.reserveQuantity =0;
                });
            }
        };

        $scope.selectProduct = function(data){
            vm.outWarehouse =null;
            vm.inWarehouse =null;
            vm.reserveQuantity =-1;
            vm.propertyConfig = data.propertyConfigs[0];
        };

        $scope.validate = function() {
            if (vm.product == null || vm.product == '') {
                MessageService.error('请选择商品');
                return false;
            }
            if (vm.propertyConfig == null || vm.propertyConfig == '') {
                MessageService.error('请选择SKU');
                return false;
            }
            if (vm.outWarehouse == null || vm.outWarehouse == "") {
                MessageService.error("请选择调出仓库");
                return false;
            };
            if (vm.inWarehouse == null || vm.inWarehouse == "") {
                MessageService.error("请选择调入仓库");
                return false;
            };
            if (vm.outWarehouse.id ==vm.inWarehouse.id) {
                MessageService.error("调入仓库和调出仓库一致，无效");
                return false;
            };
            if (!vm.num) {
                MessageService.error("请选择调整数量");
                return false;
            };
            if (vm.num > vm.reserveQuantity) {
                MessageService.error("调出库存不足！");
                return false;
            };
            if (!vm.reason) {
                MessageService.error("请选择调整原因");
                return false;
            };
            return true;
        };

        $scope.saveAllocation = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                inWarehouse:vm.inWarehouse,
                outWarehouse:vm.outWarehouse,
                measurement:{
                    id:vm.product.measurementId,
                    name:vm.product.measurementName
                },
                propertyConfig:vm.propertyConfig,
                type:'product',
                num:vm.num,
                reason:vm.reason
            };
            Allocations.create(obj,function (res) {
                MessageService.success("挑拨记录新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("挑拨记录新建失败！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('allocation', {
                parent: 'module',
                url: '/allocation',
                params:{page: null},
                data: {
                    authorities: ['ROLE_ALLOCATION_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/allocation/allocation.html',
                        controller: 'AllocationController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Allocations', Allocations);

    Allocations.$inject = ['$resource'];

    function Allocations ($resource) {
        var resourceUrl =  'api/allocations/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method:'PUT',
                isArray: false
            },
            'delete': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AllocationController', AllocationController);

    AllocationController.$inject = ['$scope','Allocations','Depository','MessageService', 'ParseLinks', '$stateParams','Product','$uibModal'];

    function AllocationController ($scope,Allocations,Depository,MessageService, ParseLinks, $stateParams,Product,$uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;

        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "product"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: 'product',// 类型。accessories 辅料 / product 成品
            key:'',
            sort: ['createdDate,DESC'],
            startDate:'',
            endDate:'',
            inWarehouseId:'',
            outWarehouseId:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        loadAll();
        function loadAll() {
            vm.allocations = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            Allocations.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.allocations = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.reset = function(){
            vm.tableData = {
                page: 0,
                size: 20,
                type: 'product',// 类型。accessories 辅料 / product 成品
                key:'',
                startDate:'',
                endDate:'',
                inWarehouseId:'',
                outWarehouseId:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            loadAll();
        };
        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }

        $scope.newAllocation = function(){
            $uibModal.open({
                templateUrl: 'app/finishedWarehouse/allocation/allocation-add.html',
                controller: 'AllocationAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(result){
                //angular.forEach(vm.tableList, function (item) {
                //    item.checked = false;
                //});
                loadAll();
            });
        };




    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PermissionDialogController', PermissionDialogController);

    PermissionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Permission'];

    function PermissionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Permission) {
        var vm = this;

        vm.permission = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.permission.id !== null) {
                Permission.update(vm.permission, onSaveSuccess, onSaveError);
            } else {
                Permission.save(vm.permission, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gwApp:permissionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PermissionDetailController', PermissionDetailController);

    PermissionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Permission'];

    function PermissionDetailController($scope, $rootScope, $stateParams, previousState, entity, Permission) {
        var vm = this;

        vm.permission = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gwApp:permissionUpdate', function(event, result) {
            vm.permission = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PermissionDeleteController',PermissionDeleteController);

    PermissionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Permission'];

    function PermissionDeleteController($uibModalInstance, entity, Permission) {
        var vm = this;

        vm.permission = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Permission.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('permission', {
            parent: 'entity',
            url: '/permission',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gwApp.permission.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/permission/permissions.html',
                    controller: 'PermissionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('permission');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('permission-detail', {
            parent: 'entity',
            url: '/permission/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gwApp.permission.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/permission/permission-detail.html',
                    controller: 'PermissionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('permission');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Permission', function($stateParams, Permission) {
                    return Permission.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'permission',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('permission-detail.edit', {
            parent: 'permission-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/permission/permission-dialog.html',
                    controller: 'PermissionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Permission', function(Permission) {
                            return Permission.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('permission.new', {
            parent: 'permission',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/permission/permission-dialog.html',
                    controller: 'PermissionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                module: null,
                                authority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('permission', null, { reload: 'permission' });
                }, function() {
                    $state.go('permission');
                });
            }]
        })
        .state('permission.edit', {
            parent: 'permission',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/permission/permission-dialog.html',
                    controller: 'PermissionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Permission', function(Permission) {
                            return Permission.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('permission', null, { reload: 'permission' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('permission.delete', {
            parent: 'permission',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/permission/permission-delete-dialog.html',
                    controller: 'PermissionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Permission', function(Permission) {
                            return Permission.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('permission', null, { reload: 'permission' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Permission', Permission);

    Permission.$inject = ['$resource'];

    function Permission ($resource) {
        var resourceUrl =  'api/permissions/:id';

        return $resource(resourceUrl, {}, {
            'getAllByScope':{
                method: 'GET', isArray: true,
                params: {
                    id: 'getAllByScope'
                },
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PermissionController', PermissionController);

    PermissionController.$inject = ['$scope', '$state', 'Permission'];

    function PermissionController ($scope, $state, Permission) {
        var vm = this;

        vm.permissions = [];

        loadAll();

        function loadAll() {
            Permission.query(function(result) {
                vm.permissions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplierDeliveryRequestController', SupplierDeliveryRequestController);

    SupplierDeliveryRequestController.$inject = ['$scope', '$uibModal', '$state', 'SupplierDeliveryRequest', 'Express', 'MessageService', 'ParseLinks', '$stateParams', 'Supplier', 'Depository'];

    function SupplierDeliveryRequestController ($scope, $uibModal, $state, SupplierDeliveryRequest, Express, MessageService, ParseLinks, $stateParams, Supplier, Depository) {
        var vm = this;
        vm.clear =clear;
        vm.condition = "InitialOrder";
        vm.conditionList = [
            {name:'发货请求', value:'InitialOrder'},
            {name:'合并发货', value:'MergeOrder'},
        ];
        vm.deliveryStatusList = [
            {name:'已发货', value:'Delivered'},
            {name:'已揽件', value:'Receiving'},
            {name:'已签收', value:'Received'},
            {name:'物流异常', value:'Abnormal'}
        ]
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            expressSettingId:'',
            keyword: '',
            expectStart: '',
            expectEnd: '',
            supId: '',
            warehouseId: '',
            type: vm.condition,
            deliveryStatus:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.supList = Supplier.getAll();
        vm.depositories = Depository.getAll();

        $scope.conditionSelect = function(data){
            vm.condition = data.value;
            vm.tableData.page = 0;
            vm.tableData.type = vm.condition;
            init()
        };
        Express.getAll(function(res){
            vm.expressCompanies = res.filter(function(item){return item.enable});
        });

        init();
        function init() {
            vm.tableList = [];
            vm.objList = [];
            vm.tableData.expectStart = angular.copy(angular.element("#startDate").val());
            vm.tableData.expectEnd = angular.copy(angular.element("#endDate").val());
            SupplierDeliveryRequest.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                expressSettingId:'',
                keyword: '',
                expectStart:'',
                expectEnd:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        };

        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }

            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        vm.objList = [];
        $scope.selectOne = function(obj){
            var flag = false;
            for (var i = vm.objList.length - 1; i >= 0; i--) {
                if (vm.objList[i].id == obj.id) {
                    vm.objList.splice(i, 1);
                    flag = true;
                }
            }

            if (!flag) {
                vm.objList.push(obj);
            }
            console.log(vm.objList)
        };

        $scope.magerRequest = function() {
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-request-details.html',
                controller: 'DeliveryRequestDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return null;
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.shipmentsClick = function() {
            if(!vm.objList || vm.objList.length != 1){
                MessageService.error("只能选择一个未发货的发货请求");
                return
            }
            if(vm.objList[0].deliveryStatus != 'UnDeliver'){
                MessageService.error("只能选择一个未发货的发货请求");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-request-shipments.html',
                controller: 'DeliveryRequestShipmentsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return vm.objList[0];
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.shippedAgain = function() {
            if(vm.objList.length === 0){
                MessageService.error("请选择重新发货的订单");
                return
            }
            if(vm.objList.length > 1){
                MessageService.error("只能选择一个发货订单");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/shippedAgain.html',
                controller: 'ShippedAgainController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return vm.objList;
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.splitDeliveryRequest = function() {
            // if (vm.objList.length != 1) {
            //     MessageService.error("选择一项拆分");
            //     return
            // }
            var _objList = [];
            for(var i=0; i<vm.objList.length; i++){
                _objList.push(vm.objList[i].id)
            }

            SupplierDeliveryRequest.splitDeliveryRequest({ids: _objList.join(",")}, function() {
                MessageService.success("拆分成功");
                init();
            })
        }

        $scope.showPage = function() {
            if (vm.objList.length != 1) {
                MessageService.error("选择一项查看");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-request-page.html',
                controller: 'DeliveryRequestPageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {id: vm.objList[0].id};
                    }
                }
            }).result.then(function(result){
                init();
            });
        }
        $scope.details = function() {
            if (vm.objList.length != 1) {
                MessageService.error("选择一项查看");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-details.html',
                controller: 'DeliveryDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {id: vm.objList[0].id};
                    }
                }
            }).result.then(function(result){
                init();
            });
        }
        $scope.statusInfo = function (item) {
            switch (item) {
                case 'UnDeliver':
                    return '未发货';
                case 'Delivered':
                    return '已发货';
                case 'Receiving':
                    return '已揽件';
                case 'Received':
                    return '已签收';
                case 'Abnormal':
                    return '物流异常';
                default:
                    return '暂无状态';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ShippedAgainController', ShippedAgainController);

    ShippedAgainController.$inject = ['$q', '$scope', 'Principal', '$state', 'MessageService', 'LocationProvice', '$localStorage', '$uibModalInstance', 'entity','LocationCity','LocationDistrict', 'DeliveryRequest'];

    function ShippedAgainController ($q, $scope, Principal, $state, MessageService, LocationProvice, $localStorage, $uibModalInstance, entity,LocationCity,LocationDistrict, DeliveryRequest) {
        var vm = this;
        vm.data={
            id: entity[0].id,
            contact:entity[0].contact,
            phone:entity[0].phone,
            address:''
        }
        vm.datalist = entity[0];
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;
        init();
        function init(){
            vm._address = vm.datalist.address.split("-");
            vm.address = vm._address[3] ? vm._address[3] : "";
            LocationProvice.query({},function (data) {
                vm.provinces =  data;
                if(vm._address[0]){
                    for(var i=0; i<data.length; i++){
                        if(vm._address[0] == data[i].name){
                            vm.province = data[i];
                            changeProvince()
                        }
                    }
                }
            });
        }
        function changeProvince() {
            LocationCity.findByProvince({provinceId:vm.province.id},function (data) {
                vm.citys = data;
                vm.districts = [];
                if(vm._address[1]){
                    for(var i=0; i<data.length; i++){
                        if(vm._address[1] == data[i].name){
                            vm.city = data[i];
                            changeCity()
                        }
                    }
                }
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: vm.city.id},function (data) {
                vm.districts = data;
                if(vm._address[2]){
                    for(var i=0; i<data.length; i++){
                        if(vm._address[2] == data[i].name){
                            vm.district = data[i];
                        }
                    }
                }
            });
        }

        $scope.save = function(){
            if(!vm.data.contact){
                MessageService.error("姓名不能为空");
                return
            }

            if (vm.data.phone == null || vm.data.phone == "") {
                MessageService.error("联系方式不能为空");
                return false;
            }

            if(!vm.province){
                MessageService.error("省市区不能为空");
                return
            }
            if(!vm.city){
                MessageService.error("市区不能为空");
                return
            }
            if(!vm.district){
                MessageService.error("区县不能为空");
                return
            }
            if(!vm.address){
                MessageService.error("详细地址不能为空");
                return
            }
            vm.data.address = vm.province.name + '-' + vm.city.name + '-'  + vm.district.name + '-'  + vm.address;
            console.log(vm.data)
            DeliveryRequest.rebuildDeliveryRequest(vm.data, function (res) {
                $uibModalInstance.close(true);
            })
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryRequestShipmentsController', DeliveryRequestShipmentsController);

    DeliveryRequestShipmentsController.$inject = ['$q', '$scope', 'SupplierDeliveryRequest', '$state', 'MessageService', 'Express', 'entity', '$uibModalInstance', 'DeliveryRequest'];

    function DeliveryRequestShipmentsController ($q, $scope, SupplierDeliveryRequest, $state, MessageService, Express, entity, $uibModalInstance, DeliveryRequest) {
        var vm = this;
        vm.delivery = entity;
        console.log($state);
        vm.isSupplier = $state.current.name == 'supplierDeliveryRequest'
        Express.getAll(function(res){
            vm.expressCompanies = res.filter(function(item){return item.enable});
        });
        //取消
        $scope.cancelRecord = function () {
            $uibModalInstance.close();
        }

        $scope.save = function () {
            if(vm.isSupplier){
                SupplierDeliveryRequest.delivery({
                    deliveryRequestId: vm.delivery.id,
                    expressSettingId: vm.expressSettingId,
                    logisticsNumber: vm.logisticsNumber
                }, function (res) {
                    if(res.state == 200){
                        MessageService.success("发货成功");
                        $uibModalInstance.close(true);
                    }else{
                        MessageService.error(res.message || "发货失败");
                    }
                })
            }else{

                DeliveryRequest.delivery({
                    deliveryRequestId: vm.delivery.id,
                    expressSettingId: vm.expressSettingId,
                    logisticsNumber: vm.logisticsNumber
                }, function (res) {
                    if(res.state == 200){
                        MessageService.success("发货成功");
                        $uibModalInstance.close(true);
                    }else{
                        MessageService.error(res.message || "发货失败");
                    }
                })
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryRequestPageController', DeliveryRequestPageController);

    DeliveryRequestPageController.$inject = ['$q', '$scope', 'Principal', '$state', 'MessageService', 'DeliveryRequest', 'entity', '$uibModalInstance'];

    function DeliveryRequestPageController ($q, $scope, Principal, $state, MessageService, DeliveryRequest, entity, $uibModalInstance) {
        var vm = this;

        vm.objList = [];

        // console.log(entity.id);

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_DELIVER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.data = DeliveryRequest.mergeRequestPage({ids: entity.id});
        $q.all([vm.data.$promise]).then(function(){
            // console.log(vm.data);
        });


        $scope.goBack = function(){
            $uibModalInstance.close();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryRequestDetailsController', DeliveryRequestDetailsController);

    DeliveryRequestDetailsController.$inject = ['$q', '$scope', 'Principal', '$state', 'MessageService', 'DeliveryRequest', '$localStorage', '$uibModalInstance'];

    function DeliveryRequestDetailsController ($q, $scope, Principal, $state, MessageService, DeliveryRequest, $localStorage, $uibModalInstance) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_DELIVER').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });

        vm.dataList = DeliveryRequest.mergeRequestList();
        $q.all([vm.dataList.$promise]).then(function(){
            vm.checkedAll = false;
        });

        $scope.selectAll = function(data) {
            for (var i = data.deliveryRequestList.length - 1; i >= 0; i--) {
                data.deliveryRequestList[i].selected = data.selected;
            }
        }

        $scope.selectOne = function (obj, data) {
            vm.objList = [];
            var flag = true;
            for (var i = data.deliveryRequestList.length - 1; i >= 0; i--) {
                if (!data.deliveryRequestList[i].selected) {
                    flag = false;
                }
            }
            if (flag) {
                data.selected = true;
            } else {
                data.selected = false;
            }

            if (obj.selected) {
                vm.objList.push(obj.id);
            } else {
                for (var i = 0; i < vm.objList.length; i ++) {
                    if (vm.objList[i] == obj.id) {
                        if (vm.objList.length == 1) {
                            vm.objList = [];
                        } else {
                            vm.objList.splice(i, 1);
                        }
                    }
                }
            }
        };
        vm.colorList = [];
        vm.colorIndex = '';
        $scope.color = function(index, item){
            if(vm.colorIndex !== index){
                vm.colorIndex = index;
                vm.colorList = [];
            }
            var _index = vm.colorList.indexOf(item);
            if(_index == -1){
                vm.colorList.push(item)
            }
            return vm.colorList.indexOf(item)%6
        };

        $scope.mergeBtn = function () {
            vm.objList = [];

            for (var i = vm.dataList.length - 1; i >= 0; i--) {
                for (var j = vm.dataList[i].deliveryRequestList.length - 1; j >= 0; j--) {
                    if (vm.dataList[i].deliveryRequestList[j].selected) {
                        vm.objList.push(vm.dataList[i].deliveryRequestList[j].id);
                    }
                }
            }

            DeliveryRequest.mergeDeliveryRequest({ids:vm.objList.join(",")}, function(){
                MessageService.success("合并成功");
                $uibModalInstance.close();
            });
        }


        $scope.goBack = function(){
            $uibModalInstance.close();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('deliveryRequest', {
                parent: 'module',
                url: '/delivery-request',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/delivery/delivery-request.html',
                        controller: 'DeliveryRequestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).state('supplierDeliveryRequest', {
                parent: 'module',
                url: '/supplier-delivery-request',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/delivery/supplier-delivery-request.html',
                        controller: 'SupplierDeliveryRequestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('DeliveryRequest', DeliveryRequest)
        .factory('SupplierDeliveryRequest', SupplierDeliveryRequest)
        .factory('SupplierDeliveryOrder', SupplierDeliveryOrder);

    DeliveryRequest.$inject = ['$resource'];
    SupplierDeliveryRequest.$inject = ['$resource'];
    SupplierDeliveryOrder.$inject = ['$resource'];

    function DeliveryRequest ($resource) {
        var resourceUrl =  'api/delivery-request/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'printExpressOrder': {
                method: 'GET',
                params: {
                    path: 'printExpressOrder'
                }
            },
            'delivery': {
                method: 'GET',
                params: {
                    path: 'delivery'
                }
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getData2': {
                method:'GET',
                params: {
                    path: 'getData2'
                },
                isArray: true
            },
            'getData': {
                method:'GET',
                params: {
                    path: 'getData'
                },
                isArray: true
            },

            'mergeRequestList': {
                method: 'GET',
                params: {
                    path: 'mergeRequestList'
                },
                isArray: true
            },
            'mergeDeliveryRequest': {
                method: 'GET',
                params: {
                    path: 'mergeDeliveryRequest'
                },
                isArray: true
            },
            'splitDeliveryRequest': {
                method: 'GET',
                params: {
                    path: 'splitDeliveryRequest'
                }
            },
            'bySaleOrder': {
                method: 'GET',
                params: {
                    path: 'bySaleOrder'
                },
                isArray: true
            },
            'bySaleOrderOld': {
                method: 'GET',
                params: {
                    path: 'bySaleOrder-old'
                },
                isArray: true
            },
            'getRealTimeExpress': {
                method: 'GET',
                params: {
                    path: 'getRealTimeExpress'
                }
            },
            'mergeRequestPage': {
                method: 'GET',
                params: {
                    path: 'mergeRequestPage'
                }
            },
            'rebuildDeliveryRequest': {
                method: 'POST',
                params: {
                    path: 'rebuildDeliveryRequest'
                }
            }
        });
    }
    function SupplierDeliveryRequest ($resource) {
        var resourceUrl =  'api/supplier-delivery-request/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'printExpressOrder': {
                method: 'GET',
                params: {
                    path: 'printExpressOrder'
                }
            },
            'delivery': {
                method: 'GET',
                params: {
                    path: 'delivery'
                }
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getData2': {
                method:'GET',
                params: {
                    path: 'getData2'
                },
                isArray: true
            },
            'getData': {
                method:'GET',
                params: {
                    path: 'getData'
                },
                isArray: true
            },

            'mergeRequestList': {
                method: 'GET',
                params: {
                    path: 'mergeRequestList'
                },
                isArray: true
            },
            'mergeDeliveryRequest': {
                method: 'GET',
                params: {
                    path: 'mergeDeliveryRequest'
                },
                isArray: true
            },
            'splitDeliveryRequest': {
                method: 'GET',
                params: {
                    path: 'splitDeliveryRequest'
                }
            },
            'bySaleOrder': {
                method: 'GET',
                params: {
                    path: 'bySaleOrder'
                },
                isArray: true
            },
            'bySaleOrderOld': {
                method: 'GET',
                params: {
                    path: 'bySaleOrder-old'
                },
                isArray: true
            },
            'getRealTimeExpress': {
                method: 'GET',
                params: {
                    path: 'getRealTimeExpress'
                }
            },
            'mergeRequestPage': {
                method: 'GET',
                params: {
                    path: 'mergeRequestPage'
                }
            },
            'rebuildDeliveryRequest': {
                method: 'POST',
                params: {
                    path: 'rebuildDeliveryRequest'
                }
            }
        });
    }
    function SupplierDeliveryOrder ($resource) {
        var resourceUrl =  'api/supplier-delivery-order/:path/:id';

        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    id:"byCondition"
                },
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'detail': {
                method:'GET'
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryRequestController', DeliveryRequestController);

    DeliveryRequestController.$inject = ['$scope', '$uibModal', '$state', 'DeliveryRequest', 'Express', 'MessageService', 'ParseLinks', '$stateParams', 'Supplier', 'Depository'];

    function DeliveryRequestController ($scope, $uibModal, $state, DeliveryRequest, Express, MessageService, ParseLinks, $stateParams, Supplier, Depository) {
        var vm = this;
        vm.clear =clear;
        vm.condition = "InitialOrder";
        vm.conditionList = [
            {name:'发货请求', value:'InitialOrder'},
            {name:'合并发货', value:'MergeOrder'},
        ];
        vm.deliveryStatusList = [
            {name:'已发货', value:'Delivered'},
            {name:'已揽件', value:'Receiving'},
            {name:'已签收', value:'Received'},
            {name:'物流异常', value:'Abnormal'}
        ]
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            sort: ['createdDate,DESC'],
            expressSettingId:'',
            keyword: '',
            expectStart: '',
            expectEnd: '',
            supId: '',
            warehouseId: '',
            type: vm.condition,
            deliveryStatus:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        vm.supList = Supplier.getAll();
        vm.depositories = Depository.getAll();

        $scope.conditionSelect = function(data){
            vm.condition = data.value;
            vm.tableData.page = 0;
            vm.tableData.type = vm.condition;
            init()
        };
        Express.getAll(function(res){
            vm.expressCompanies = res.filter(function(item){return item.enable});
        });

        init();
        function init() {
            vm.tableList = [];
            vm.objList = [];
            vm.tableData.expectStart = angular.copy(angular.element("#startDate").val());
            vm.tableData.expectEnd = angular.copy(angular.element("#endDate").val());
            DeliveryRequest.query(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.tableList = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });
        };

        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        function clear(){
            vm.tableData.keyword = '';
            vm.tableData.page = 0;
            init();
        }
        $scope.reset = function(){
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                expressSettingId:'',
                keyword: '',
                expectStart:'',
                expectEnd:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
        };

        $scope.checked =[];
        $scope.tableTr = function(data){
            var index = $scope.checked.indexOf(data);
            if(index == -1 && data.checked){
                $scope.checked.push(data);
            }else if (!data.checked && index !== -1){
                $scope.checked.splice(index, 1);
            }
            if (vm.tableList.length === $scope.checked.length) {
                $scope.select_all = true;
            } else {
                $scope.select_all = false;
            }

            vm.tablePitch = $scope.checked.length >0 ?true:false;
        };

        vm.objList = [];
        $scope.selectOne = function(obj){
            var flag = false;
            for (var i = vm.objList.length - 1; i >= 0; i--) {
                if (vm.objList[i].id == obj.id) {
                    vm.objList.splice(i, 1);
                    flag = true;
                }
            }

            if (!flag) {
                vm.objList.push(obj);
            }
            console.log(vm.objList)
        };

        $scope.magerRequest = function() {
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-request-details.html',
                controller: 'DeliveryRequestDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return null;
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.shipmentsClick = function() {
            if(!vm.objList || vm.objList.length != 1){
                MessageService.error("只能选择一个未发货的发货请求");
                return
            }
            if(vm.objList[0].deliveryStatus != 'UnDeliver'){
                MessageService.error("只能选择一个未发货的发货请求");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-request-shipments.html',
                controller: 'DeliveryRequestShipmentsController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return vm.objList[0];
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.shippedAgain = function() {
            if(vm.objList.length === 0){
                MessageService.error("请选择重新发货的订单");
                return
            }
            if(vm.objList.length > 1){
                MessageService.error("只能选择一个发货订单");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/shippedAgain.html',
                controller: 'ShippedAgainController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return vm.objList;
                    }
                }
            }).result.then(function(result){
                if(result){
                    init();
                }
            });
        };

        $scope.splitDeliveryRequest = function() {
            // if (vm.objList.length != 1) {
            //     MessageService.error("选择一项拆分");
            //     return
            // }
            var _objList = [];
            for(var i=0; i<vm.objList.length; i++){
                _objList.push(vm.objList[i].id)
            }

            DeliveryRequest.splitDeliveryRequest({ids: _objList.join(",")}, function() {
                MessageService.success("拆分成功");
                init();
            })
        }

        $scope.showPage = function() {
            if (vm.objList.length != 1) {
                MessageService.error("选择一项查看");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-request-page.html',
                controller: 'DeliveryRequestPageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {id: vm.objList[0].id};
                    }
                }
            }).result.then(function(result){
                init();
            });
        }
        $scope.details = function() {
            if (vm.objList.length != 1) {
                MessageService.error("选择一项查看");
                return
            }
            $uibModal.open({
                templateUrl: 'app/delivery/delivery-details.html',
                controller: 'DeliveryDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {id: vm.objList[0].id};
                    }
                }
            }).result.then(function(result){
                init();
            });
        }
        $scope.statusInfo = function (item) {
            switch (item) {
                case 'UnDeliver':
                    return '未发货';
                case 'Delivered':
                    return '已发货';
                case 'Receiving':
                    return '已揽件';
                case 'Received':
                    return '已签收';
                case 'Abnormal':
                    return '物流异常';
                default:
                    return '暂无状态';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryDetailsController', DeliveryDetailsController);

    DeliveryDetailsController.$inject = ['$q', '$scope', 'Principal', '$state', 'MessageService', 'LocationProvice', '$localStorage', '$uibModalInstance', 'entity','DeliveryRequest','SupplierDeliveryRequest'];

    function DeliveryDetailsController ($q, $scope, Principal, $state, MessageService, LocationProvice, $localStorage, $uibModalInstance, entity,DeliveryRequest,SupplierDeliveryRequest) {
        var vm = this;
        console.log($state);
        if($state.current.name == 'supplierDeliveryRequest'){
            SupplierDeliveryRequest.get({id: entity.id}, function (res) {
                vm.data = res;
            })
        }else{
            DeliveryRequest.get({id: entity.id}, function (res) {
                vm.data = res;
            })
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderStatisticsController', OrderStatisticsController);

    OrderStatisticsController.$inject = ['$scope', '$state', 'MessageService','$location', 'SalesOrder', '$uibModal', 'ParseLinks','Product', '$localStorage','$http', '$stateParams', '$rootScope'];

    function OrderStatisticsController ($scope, $state, MessageService,$location, SalesOrder, $uibModal, ParseLinks, Product, $localStorage, $http, $stateParams, $rootScope) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.timeName = 'month';
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            productName: '',
            state: '',
            startDate: "",
            storeName:'',
            endDate: "",
            orderType:'Ordering',
            size:20
        };
        vm.backList = [
            {name:'全部', value: ""},
            {name:'未发货', value: "UnDelivered"},
            {name:'已发货', value: "Delivered"},
            {name:'已签收', value: "Received"}
        ];
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeName = '';
        vm.timeList = [
            {name:'昨日', value:'day'},
            {name:'最近7天', value:'week'},
            {name:'最近30天', value:'month'}
        ];
        vm.salesOrders = [
            {
                id:1,
                stockOrderNumber:1,
                operator:1,
            }
        ]
        vm.dateType = 'created'
        $scope.getProductId =function(data){
            vm.tableData.productId =data ? data.id :'';
        };
        vm.storeList = SalesOrder.storeNames()

        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);
        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            var params = {
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'source':vm.tableData.source,
                'refund':vm.tableData.refund,
                'keyword':vm.tableData.keyword,
                'productName':vm.tableData.productName,
                'storeName':vm.tableData.storeName,
                'size':vm.tableData.size,
                'orderType':vm.tableData.orderType,
            }
            if(vm.dateType === 'created'){
                params.createdStartDate = vm.tableData.startDate
                params.createdEndDate = vm.tableData.endDate
            }else if(vm.dateType === 'delivered'){
                params.startDate = vm.tableData.startDate
                params.endDate = vm.tableData.endDate
            }else if(vm.dateType === 'received'){
                params.receivedStartDate = vm.tableData.startDate
                params.receivedEndDate = vm.tableData.endDate
            }
            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'source':vm.tableData.source,
                'startDate':vm.tableData.startDate,
                'endDate':vm.tableData.endDate,
                'refund':vm.tableData.refund,
                'keyword':vm.tableData.keyword,
                'productName':vm.tableData.productName,
                'storeName':vm.tableData.storeName,
            });
            SalesOrder.manufactureStats(params, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {

            });

            //获取订单总数和总张数
            $scope.orderNumberTotal = 0;
            $scope.pageCountTotal = 0;
            SalesOrder.getNumByCondition(vm.tableData, function(res) {
                $scope.orderNumberTotal = res.total;
                $scope.pageCountTotal = res.pages == null ? 0 : res.pages;
            });
        };

        $scope.timeCb = function (time) {
            vm.timeName = time.value;
            angular.element("#endDate").val(GetDateStr(0));
            if(time.value == 'day'){
                angular.element("#startDate").val(GetDateStr(-1));
            }
            if(time.value == 'week'){
                angular.element("#startDate").val(GetDateStr(-7));
            }
            if(time.value == 'month'){
                angular.element("#startDate").val(GetDateStr(-30));
            }
            initData();
        };

        $scope.inquire = function () {
            vm.tableData.page = 0
            init();
        }
        function initData() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            // if(vm.tableData.supId == ""){
            //     MessageService.error("供应商不能为空");
            //     return
            // }
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _startDate = new Date(vm.tableData.startDate);
            var _endDate = new Date(vm.tableData.endDate);
            var _mistiming = parseInt(_endDate - _startDate) / 1000 / 60 / 60 / 24;
            vm.timeName = "";
            if(GetDateStr(0) == vm.tableData.endDate){
                if(_mistiming == 1){vm.timeName = "day";}
                if(_mistiming == 7){vm.timeName = "week";}
                if(_mistiming == 30){vm.timeName = "month";}
            }
        }

        //下载
        $scope.export = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }

            var _params = {
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'source':vm.tableData.source,
                'refund':vm.tableData.refund,
                'keyword':vm.tableData.keyword,
                'productName':vm.tableData.productName,
                'storeName':vm.tableData.storeName,
                'size':vm.tableData.size,
                'orderType':vm.tableData.orderType,
            }
            if(vm.dateType === 'created'){
                _params.createdStartDate = vm.tableData.startDate
                _params.createdEndDate = vm.tableData.endDate
            }else if(vm.dateType === 'delivered'){
                _params.startDate = vm.tableData.startDate
                _params.endDate = vm.tableData.endDate
            }else if(vm.dateType === 'received'){
                _params.receivedStartDate = vm.tableData.startDate
                _params.receivedEndDate = vm.tableData.endDate
            }
            $http({
                url: 'api/sales_order/export',
                method: "GET",
                params: _params,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function getDate (datestr) {
            datestr = datestr.split(" ")[0];
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        }
        function getDiffDate (start, end) {
            var startTime = getDate(start);
            var endTime = getDate(end);
            var dateArr = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                var year = startTime.getFullYear();
                var month = startTime.getMonth().toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
                var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
                dateArr.push(year + "-" + month + "-" + day);
                startTime.setDate(startTime.getDate() + 1);
            }
            return dateArr;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('DataChart', DataChart);

    DataChart.$inject = ['$resource'];

    function DataChart ($resource) {
        var resourceUrl =  'api/sales_order/:path/:id';

        return $resource(resourceUrl, {}, {
            'export': {
                method: 'GET',
                // isArray: true,
                params: {
                    path: 'export'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getData': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getData'
                }
            },
            'getData2': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getData2'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('orderStatistics', {
                parent: 'module',
                url: '/orderStatistics',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/dataChart/orderStatistics.html',
                        controller: 'OrderStatisticsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubTransactionDetailController', CustomerHubTransactionDetailController);

    CustomerHubTransactionDetailController.$inject = ['$scope', '$state', 'CustomerHub', '$stateParams', 'msgdata', '$uibModalInstance', 'ParseLinks', 'MessageService', '$localStorage', '$http'];

    function CustomerHubTransactionDetailController($scope, $state, CustomerHub, $stateParams, msgdata, $uibModalInstance, ParseLinks, MessageService, $localStorage, $http) {
        var vm = this;
        vm.clear = clear;
        vm.customer = msgdata;
        vm.token = $localStorage.authenticationToken;

        vm.loadAll = loadAll;
        vm.pageSize = [
            { name: '10', value: 10 },
            { name: '15', value: 15 },
            { name: '20', value: 20 },
            { name: '30', value: 30 },
            { name: '40', value: 40 },
            { name: '50', value: 50 }
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            customerId: vm.customer.id,
            sort: ['createdDate,DESC'],
            startDate: GetDateStr(-31),
            endDate: GetDateStr(0),
            type: ''
        };

        $scope.getType = function(type){
            if (type == "plus") {
                return "充值";
            }
            if (type == "minus") {
                return "消费";
            }
            if (type == "refund") {
                return "充值退款";
            }
            if (type == "cancelOrder") {
                return "订单退款";
            }
            return "--";
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate() + AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth() + 1) < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y + "-" + m + "-" + d;
        }
        vm.types = [
            { name: 'plus', value: '充值' },
            { name: 'minus', value: '消费' },
            { name: 'refund', value: '充值退款' },
            { name: 'cancelOrder', value: '订单退款' }
        ];


        loadAll();

        function loadAll() {
            vm.records = [];
            if (angular.element("#startDate").val()) {
                vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            }
            if (angular.element("#endDate").val()) {
                vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            }
            CustomerHub.getTransactionRecord(vm.tableData, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.records = res;
                var pages = Math.ceil(vm.queryCount / vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first) {
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function(error) {

            });
        }

        $scope.search = function() {
            vm.tableData.page = 0;
            loadAll();
        };

        function clear() {
            vm.tableData.type = '';
            vm.tableData.page = 0;
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            $uibModalInstance.close();
        }
        //下载
        $scope.export = function() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            $http({
                url: 'api/customer-hubs/downloadTransactionRecord',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function(data, status, headers, config) {
                var blob = new Blob([data], { type: "application/vnd.ms-excel" });
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = '交易明细' + Date.now() + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function(data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ResetPasswordController', ResetPasswordController);

    ResetPasswordController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','$uibModal','$uibModalInstance','MessageService','$timeout', 'entity'];

    function ResetPasswordController ($scope, Principal, LoginService,$state,User,$uibModal,$uibModalInstance,MessageService,$timeout, entity) {
        var vm = this;
        vm.user = entity;


        $scope.save = function() {
            console.log(vm.user)
            if(vm.user.password == "" || vm.user.password == null){
                MessageService.error("新密码不能为空");
                return;
            }
            if (vm.user.password.length<4 || vm.user.password.length >100) {
                MessageService.error("新密码长度在4-100位之间");
                return false;
            }
            if (vm.user.confirmPassword == null || vm.user.confirmPassword == "") {
                MessageService.error("确认密码不能为空");
                return false;
            }
            if (vm.user.confirmPassword != vm.user.password) {
                MessageService.error("确认密码与新密码不一致");
                return false;
            }
            if (vm.user.confirmPassword.length<4 || vm.user.confirmPassword.length >100) {
                MessageService.error("确认密码长度在4-100位之间");
                return false;
            }
            vm.isSaving = true;
            User.reset({
                id: vm.user.id,
                username: vm.user.username,
                password: vm.user.password
            }, function (res) {
                vm.isSaving = false;

                MessageService.success('重置密码成功');
                $uibModalInstance.close(vm.user);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("重置密码失败");
            });
        };
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubAmountController', CustomerHubAmountController);

    CustomerHubAmountController.$inject = ['$scope','$state','PayOrder','msgdata', '$uibModalInstance','MessageService'];

    function CustomerHubAmountController ($scope,$state,PayOrder, msgdata ,$uibModalInstance,MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.amount = 0;
        vm.customer = msgdata;

        vm.orders = PayOrder.getAllByCondition({items:[
            {key:"invoiced",value:"false", op:"="}, 
            {key:"paid",value:"true", op:"="}, 
            {key:"refund",value:"false", op:"="}]}, function(data){
                if (data && data.length >0) {
                   for (var i = data.length - 1; i >= 0; i--) {
                       vm.amount = vm.amount + data[i].amount;
                    } 
                }
            })

        function clear(){
            $uibModalInstance.dismiss();
        }

        $scope.validate = function () {
            if (vm.balance == null || vm.balance == "") {
                MessageService.error("退款金额不能为空");
                return false;
            }
            if (vm.balance <0.01) {
                MessageService.error("退款金额不能小于0.01");
                return false;
            }
            if (vm.amount < vm.balance) {
                MessageService.error("退款金额不能大于"+ vm.amount);
                return false;
            }
            return true;
        };

        function save () {
            if (!$scope.validate()) {
                return;
            }

            //plus充值/minus消费
            PayOrder.refund({
                customerId: msgdata.id,
                amount: vm.balance,
                type: 'balance'
            }, function (res) {
                vm.isSaving = false;
                    MessageService.success("退款成功");
                    $uibModalInstance.close(res);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("退款失败");
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InvoicingOperateController', InvoicingOperateController);

    InvoicingOperateController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','$uibModal','$uibModalInstance','MessageService','$timeout','msgdata','Invoices'];

    function InvoicingOperateController ($scope, Principal, LoginService,$state,User,$uibModal,$uibModalInstance,MessageService,$timeout,msgdata,Invoices) {
        var vm = this;
        vm.operate = angular.copy(msgdata.data);
        vm.title = msgdata.title

        $scope.save = function() {
            if(!vm.operate.invoiceNumber){
                MessageService.error('发票号');
                return
            }

            if(!vm.operate.deliveryCompany){
                MessageService.error('请输入快递公司');
                return
            }
            if(!vm.operate.deliveryNumber){
                MessageService.error('请输入快递单号');
                return
            }
            vm.isSaving = true;
            Invoices.delivery({
                id:vm.operate.id,
                invoiceNumber:vm.operate.invoiceNumber,
                deliveryCompany:vm.operate.deliveryCompany,
                deliveryNumber:vm.operate.deliveryNumber
            },function (res) {
                MessageService.success('配送成功');
                $uibModalInstance.close(vm.operate);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("配送失败");
            })
        };

        $scope.save2 = function(){
            Invoices.reject({id:vm.operate.id,remark:vm.operate.remark},function (res) {
                MessageService.success('拒绝成功');
                $uibModalInstance.close(vm.operate);
            })
        }

        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InvoicingDetailController', InvoicingDetailController);

    InvoicingDetailController.$inject = ['$scope', 'Principal','entity', '$stateParams', '$state','$uibModal','Invoices','MessageService','CustomerHub','$q','SalesOrder','PayOrders'];

    function InvoicingDetailController ($scope, Principal, entity, $stateParams, $state,$uibModal,Invoices,MessageService,CustomerHub,$q,SalesOrder,PayOrders) {
        var vm = this;

        vm.invoice = entity;
        vm.salesOrders = [];
        vm.payOrders = [];
        $q.all([vm.invoice.$promise]).then(function(){
            console.log(vm.invoice)
            vm.customerHub = CustomerHub.get({id: vm.invoice.customerHubId});
            // if(vm.invoice)
            angular.forEach(vm.invoice.invoiceOrders,function (order) {
                if(order.invoiceOrderType=='SALESORDER'){
                    SalesOrder.get({id:order.orderId},function (res) {
                        vm.salesOrders.push(res);
                    })
                }else{
                    PayOrders.get({id:order.orderId},function (res) {
                        vm.payOrders.push(res);
                    })
                }
            })
        })

        //返回
        $scope.goBack = function () {
            $state.go("invoicing",{page: $stateParams.page});
        };

        $scope.approve = function(){
            Invoices.approve({id: vm.invoice.id}, function (res) {
                MessageService.success('已通过');
                vm.invoice = res;
            })
        }

        $scope.operate = function(attr){
            $uibModal.open({
                templateUrl: 'app/customerHub/invoicing-operate.html',
                controller: 'InvoicingOperateController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return {
                            title:attr,
                            data:vm.invoice
                        }
                    }
                }
            }).result.then(function(result){
                console.log(result);
                vm.invoice.invoiceStatus = 'REJECTED';
                vm.invoice.remark = result.remark;
                // vm.invoice = result;
                // $scope.$digest()
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InvoicingController', InvoicingController);

    InvoicingController.$inject = ['$scope', 'Principal', 'LoginService', '$state','CustomerHub','MessageService', 'ParseLinks', '$stateParams','$uibModal', 'Invoices'];

    function InvoicingController ($scope, Principal, LoginService, $state,CustomerHub,MessageService, ParseLinks, $stateParams,$uibModal, Invoices) {
        var vm = this;

        vm.categories =[{
            name:'outsource',
            value:'委外'
        },{
            name:'SourceMaterials',
            value:'原辅材料'
        }];
        vm.loadAll = loadAll;
        vm.clear =clear;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        //待审核  已审核  已拒绝     配送中        已签收
        // CREATED, APPROVE, REJECTED, RECEIVING, RECEIVED
        vm.conditionList = [
            {name:'全部', id:''},
            {name:'待审核', id: 'CREATED'},
            {name:'已审核', id: 'APPROVE'},
            {name:'已拒绝', id: 'REJECTED'},
            {name:'已配送', id: 'RECEIVING'},
            {name:'已签收', id: 'RECEIVED'},
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            keyword:'',
            invoiceStatus: $stateParams.status|| ''
        };

        loadAll();
        function loadAll() {
            vm.invoices = [];
            Invoices.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.invoices = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.operate = function(data,attr){
            $uibModal.open({
                templateUrl: 'app/customerHub/invoicing-operate.html',
                controller: 'InvoicingOperateController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return {
                            title:attr,
                            data:data
                        }
                    }
                }
            }).result.then(function(result){
                // console.log(result);
                console.log(result)
                console.log(data)
                // data.invoiceStatus = 'REJECTED';
                loadAll();
            });
        }

        $scope.approve = function(data){
            Invoices.approve({id: data.id}, function (res) {
                MessageService.success('已通过');
                loadAll();
            })
        }


        $scope.conditionSelect = function(data){
            vm.tableData.invoiceStatus = data.id;
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.keyword = null;
            vm.tableData.page = 0;
            loadAll();
        }

        $scope.deleteData = function(id){
            MessageService.confirm("确认要删除该条数据？", function () {
                Invoices.delete({id: id}, function () {
                    loadAll();
                    MessageService.success("删除成功");
                }, function (error) {
                    MessageService.error("删除失败，请重试！");
                });
            });
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('EditPhoneController', EditPhoneController);

    EditPhoneController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','$uibModal','$uibModalInstance','MessageService','$timeout', 'entity'];

    function EditPhoneController ($scope, Principal, LoginService,$state,User,$uibModal,$uibModalInstance,MessageService,$timeout, entity) {
        var vm = this;
        vm.user = angular.copy(entity);
        vm.user.phone = Number(vm.user.phone);
        console.log(vm.user)


        $scope.save = function() {
            if (vm.user.phone == null || vm.user.phone == "") {
                MessageService.error("联系方式不能为空");
                return false;
            }
            // var myreg=/^[1][3,4,5,6,7,8][0-9]{9}$/;
            // if (!myreg.test(vm.user.phone)) {
            //     MessageService.error("请输入11位符合要求的电话号码");
            //     return;
            // };
            vm.isSaving = true;
            User.update(vm.user, function (res) {
                vm.isSaving = false;
                MessageService.success('更新成功');
                $uibModalInstance.close(vm.user);
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("更新失败");
            });
        };
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubSkuController', CustomerHubSkuController);

    CustomerHubSkuController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService', 'Product', '$q', 'PrePressFlow','$uibModal', 'ProofRule'];

    function CustomerHubSkuController ($scope, msgdata, $uibModalInstance, MessageService, Product, $q, PrePressFlow,$uibModal, ProofRule) {
        var vm = this;

        console.log(msgdata.customerSkuManages)
        // return
        vm.clear = clear;
        vm.save = save;
        vm.skuManages = [];
        vm.delSku = [];
        vm.addSku = [];
        vm.product = Product.get({id: msgdata.productId});
        // 印前处理流程
        // vm.prePressList = PrePressFlow.getAll();
        PrePressFlow.getAll({},function(res){
            vm.prePressList = res.filter(function(item){return item.enable});
        });


        ProofRule.getAll({},function(res){
            vm.proofRules = res.filter(function(item){return item.enable});
        });

        $q.all([vm.product.$promise]).then(function(){
            vm.product.propertyConfigs.sort(function(a, b) {
                return a.sort - b.sort
            })
            vm.propertyList = vm.product.propertyConfigs;
            vm.addSku = angular.copy(vm.propertyList);
            if (!!msgdata.customerSkuManages) {
                for (var i = msgdata.customerSkuManages.length - 1; i >= 0; i--) {
                    var skuManage ={
                        prePress: msgdata.customerSkuManages[i].prePress,
                        prePressFlowId: msgdata.customerSkuManages[i].prePressFlowId,
                        needCheck: msgdata.customerSkuManages[i].needCheck,
                        proofRuleId: msgdata.customerSkuManages[i].proofRuleId,
                        propertyConfigId: msgdata.customerSkuManages[i].propertyConfigId,
                        customerProductManageId: msgdata.customerSkuManages[i].customerProductManageId,
                        delete:msgdata.customerSkuManages[i].delete,
                        cancelled:msgdata.customerSkuManages[i].cancelled
                    };
                    vm.skuManages.push(skuManage);
                }

                for (var x = vm.skuManages.length - 1; x >= 0; x--) {
                    for (var y = vm.propertyList.length - 1; y >= 0; y--) {
                        if (vm.propertyList[y].id == vm.skuManages[x].propertyConfigId) {
                            vm.skuManages[x].propertyConfig = vm.propertyList[y];
                            vm.propertyList[y].isAdd = true;
                        }
                    }

                    if(vm.skuManages[x].delete||vm.skuManages[x].cancelled){
                        vm.delSku.push(vm.skuManages[x])
                    }
                }

                for (var y = vm.propertyList.length - 1; y >= 0; y--) {
                    if(vm.propertyList[y].isAdd){
                        vm.addSku.splice(y, 1);
                    }
                }
                if (vm.addSku.length) {
                    angular.forEach(vm.addSku, function (sku) {
                        var sku2 = {
                            propertyConfigId: sku.id,
                            propertyConfig:sku,
                            delete:true,
                            cancelled:true,
                            prePress:true,
                            needCheck:true,
                            prePressFlowId:null,
                            proofRuleId:null,
                        }
                        vm.skuManages.push(sku2);
                        vm.delSku.push(sku2);
                    })
                }
                console.log(vm.addSku)
                console.log(vm.delSku)
            }else{
                angular.forEach(vm.propertyList,function (p) {
                    // console.log(p);
                    var skuManage = {
                        propertyConfigId: p.id,
                        propertyConfig:p,
                        prePress:true,
                        needCheck:true,
                        prePressFlowId:null,
                        proofRuleId:null,
                    }
                    vm.skuManages.push(skuManage);
                })
            }
            console.log(vm.skuManages)
        });

        $scope.changePropertyConfig = function(data){
            // data.propertyConfigId = data.propertyConfig.id
        };

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            vm.isSaving = true;
            var skuManageList = [];
            var count = 0,count2 = 0;

            for (var i = vm.skuManages.length - 1; i >= 0; i--) {
                var skuManageObj ={
                    propertyConfigId: vm.skuManages[i].propertyConfigId,
                    prePress:vm.skuManages[i].prePress,
                    prePressFlowId:vm.skuManages[i].prePressFlowId,
                    needCheck:vm.skuManages[i].needCheck,
                    proofRuleId:vm.skuManages[i].proofRuleId,
                    delete:vm.skuManages[i].delete,
                    cancelled:vm.skuManages[i].cancelled
                };

                if(vm.skuManages[i].prePress&&!vm.skuManages[i].prePressFlowId){
                    count++;
                }
                if(vm.skuManages[i].needCheck&&!vm.skuManages[i].proofRuleId){
                    count2++;
                }
                skuManageList.push(skuManageObj);
            }
            console.log(count)
            if(count>0){
                vm.isSaving = false;
                MessageService.error("请选择印前处理流程");
                return
            }
            if(count2>0){
                vm.isSaving = false;
                MessageService.error("请选择校验方式");
                return
            }
            console.log(vm.skuManages)
            console.log(skuManageList)
            $uibModalInstance.close(skuManageList);
        }

        //添加商品管理
        $scope.skuCopy = function(data){
            // var skuManage ={
            //     propertyConfig: vm.skuManages[i].propertyConfig,
            //     prePress:vm.skuManages[i].prePress,
            //     prePressFlow:vm.skuManages[i].prePressFlow,
            // };
            //
            // vm.flag = false;
            // angular.forEach(vm.skuManages, function(item){
            //     if(!item.makeupId || !item.capacity || !item.propertyId || !item.deviceId){
            //         vm.flag = true;
            //     }
            // });
            // if(vm.flag){
            //     MessageService.error("请完善空白项，再追加");
            // }else{
            //     vm.skuManages.push(angular.copy(skuManage));
            // }
            $uibModal.open({
                templateUrl: 'app/customerHub/customerHub-copy.html',
                controller: 'CustomerHubCopyController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return {
                            skuManages:vm.skuManages,
                            data:data
                        }
                    }
                }
            }).result.then(function(result){
                // console.log(result);
                angular.forEach(result.skuManages,function(item,i){
                    if(item.selected){
                        // vm.skuManages[i].prePressFlow = angular.copy(item.prePressFlow);
                        vm.skuManages[i].prePressFlowId = angular.copy(item.prePressFlowId);
                        vm.skuManages[i].prePress = angular.copy(item.prePress);
                        vm.skuManages[i].proofRuleId = angular.copy(item.proofRuleId);
                        vm.skuManages[i].needCheck = angular.copy(item.needCheck);
                    }
                });
                console.log(vm.skuManages);
            });
        };

        $scope.skuDelete = function(index){
            vm.delSku.push(vm.skuManages[index]);
            vm.skuManages[index].delete = true;
            vm.skuManages[index].cancelled = true;
            vm.skuManages[index].prePress = false;
            vm.skuManages[index].prePressFlowId = null;
            vm.skuManages[index].proofRuleId = null;
            vm.skuManages[index].needCheck = false;
        };

        $scope.addSkuManage = function () {
            for(var i = 0;i<vm.skuManages.length;i++){
                var sku = vm.skuManages[i];
                if(sku.propertyConfigId==vm.delSku[vm.delSku.length-1].propertyConfigId){
                    sku.delete = false;
                    sku.cancelled = false;
                    vm.delSku.splice(vm.delSku.length-1,1);
                    break
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubNewController', CustomerHubNewController);

    CustomerHubNewController.$inject = ['$scope','entity','$state','User','$uibModal','MessageService', 'Supplier','$q', '$stateParams','Product','Machine','Makeups', 'SupplierAbutSetting', 'CustomerHub','ProofRule'];

    function CustomerHubNewController ($scope,entity,$state,User,$uibModal,MessageService,Supplier,$q, $stateParams,Product,Machine,Makeups,SupplierAbutSetting,CustomerHub,ProofRule) {
        var vm = this;
        vm.save= save;
        vm.customerHub = entity;
        vm.userGroups = [];
        vm.userDel = [];
        console.log(entity);
        vm.multimediaGroups =[
            {
                name:'outsource',
                value:'委外'
            },{
                name:'SourceMaterials',
                value:'原辅材料'
            }];
        vm.cashiers =[
            {name:'CashSettlement',value:'现结'},
            {name:'MonthlyKnots',value:'月结'}
        ];
        vm.payTypes =[
            {name:'InvoicePayment',value:'开票付款'},
            {name:'CashDelivery',value:'货到付款'}
        ];
        vm.settlementTypes =[
            {name:'DownLoad',value:'下载结算'},
            {name:'Delivered',value:'发货结算'}
        ];


        Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
            vm.products = res.filter(function(item){return item.enable});
        })

        $scope.productionDelete = function(index){
            vm.customerHub.customerProductManages.splice(index,1);
        };

        $scope.changeProduct = function(data){
            data.customerSkuManages = null
        };

        $scope.skuMakeupDetail = function(data){
            if(!data.productId){
                MessageService.error('请选择商品');
                return
            }
            $uibModal.open({
                templateUrl: 'app/customerHub/customerHub-sku.html',
                controller: 'CustomerHubSkuController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'mg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                data.customerSkuManages = result;
            });
        };

        $q.all([vm.customerHub.$promise]).then(function(){
            if (vm.customerHub.balance) {
                vm.customerHub.balance = Number(vm.customerHub.balance.toFixed(2));
            }
            if(vm.customerHub.id!=''){
                $scope.titleContent = '编辑客户';
                vm.userGroups = User.getAll({scope:'client', customerHubId:vm.customerHub.id});

            }else{
                $scope.titleContent = '新建客户';
                vm.customerHub = {};
                vm.customerHub.locations =[];
                vm.customerHub.makeups =[];
                vm.customerHub.productionManages =[];
                vm.user =null;
                $('.special').attr('disabled',false);
                $('.special2').show();
            }
        });

        //添加商品管理
        $scope.addproduction = function(){
            var productionManage ={
                productId:'',
                productName:'',
                numberShelf:''
            };

            if(!vm.customerHub.customerProductManages){
                vm.customerHub.customerProductManages=[]
            }
            vm.customerHub.customerProductManages.push(angular.copy(productionManage));
        };

        $scope.editPhone = function(userInfo){
            $uibModal.open({
                templateUrl: 'app/customerHub/edit-phone.html',
                controller: 'EditPhoneController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return userInfo;
                    }
                }
            }).result.then(function(result){
                if(result){
                    userInfo.username = result.username;
                    userInfo.phone = result.phone;
                    console.log(userInfo);
                }
            });
        }

        //新建 or 编辑 用户名
        $scope.modifyContent = function(userInfo,index){
            if(userInfo){
                $uibModal.open({
                    templateUrl: 'app/customerHub/reset-password.html',
                    controller: 'ResetPasswordController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('supplier');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return userInfo;
                        }
                    }
                }).result.then(function(result){
                    if(result){
                        userInfo.username = result.username;
                        console.log(userInfo);
                    }
                });
            }else{
                $uibModal.open({
                    templateUrl: 'app/supply/create-user.html',
                    controller: 'CreateUserController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('supplier');
                            return $translate.refresh();
                        }],
                        msgdata: function () {
                            return userInfo;
                        },
                        entity: function () {
                            return 'customerHub';
                        }
                    }
                }).result.then(function(result){
                    if(result){
                        result.add = true;
                        result.edit = false;
                        result.username = result.name;
                        vm.userGroups.push(result);
                        console.log(vm.userGroups);
                    }
                });
            }


        };

        //充值
        $scope.recharge = function(){
            $uibModal.open({
                templateUrl: 'app/customerHub/recharge-amount.html',
                controller: 'CustomerHubAmountController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.customerHub;
                    }
                }
            }).result.then(function(result){
                vm.customerHub.balance = vm.customerHub.balance - result.amount;
            });
        };

        //交易明细
        $scope.transactionDetail = function(){
            $uibModal.open({
                templateUrl: 'app/customerHub/transaction-detail.html',
                controller: 'CustomerHubTransactionDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.customerHub;
                    }
                }
            }).result.then(function(result){
            });
        };



        //删除
        $scope.userDelete = function (index) {
            if(vm.userGroups[index].id){
                vm.userDel.push(vm.userGroups[index].id);
            }
            vm.userGroups.splice(index,1);
        };

        //添加地址
        $scope.addAddress = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/address-new.html',
                controller: 'AddressNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result);
                vm.customerHub.locations.push(result);
            });
        };

        //编辑地址
        $scope.addressEdit = function(data,index){
            $uibModal.open({
                templateUrl: 'app/supply/address-new.html',
                controller: 'AddressNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result);
                vm.customerHub.locations[index] = result;
            });
        };

        //删除地址
        $scope.addressDelete = function(index){
            vm.supply.locations.splice(index,1);
        };

        $scope.validate = function () {
            if(vm.customerHub.name =='' || vm.customerHub.name == null){
                MessageService.error("客户简称不能为空");
                return;
            }
            if(vm.customerHub.name.length >20){
                MessageService.error("客户简称不能超过20位");
                return;
            }
            if(vm.customerHub.fillName =='' || vm.customerHub.fillName == null){
                MessageService.error("客户全称不能为空");
                return;
            }
            if(vm.customerHub.fillName.length >30){
                MessageService.error("客户全称不能超过30位");
                return;
            }

            if(vm.customerHub.priceAdaptRate =='' || vm.customerHub.priceAdaptRate == null){
                MessageService.error("价格调整比例不能为空");
                return;
            }

            if(vm.customerHub.priceAdaptRate < 0 && vm.customerHub.priceAdaptRate > 100 || vm.customerHub.priceAdaptRate == undefined){
                MessageService.error("价格调整比例只能为0-100的整数");
                return;
            }

            if(vm.customerHub.acceptLocation){
                if(vm.customerHub.storeNumber =='' || vm.customerHub.storeNumber == null){
                    MessageService.error("商户编号不能为空");
                    return;
                }
                if(vm.customerHub.apiUrl =='' || vm.customerHub.apiUrl == null){
                    MessageService.error("接口api不能为空");
                    return;
                }
            }

            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;

            var count = 0,count2 = 0, count3 = 0;

            if (vm.customerHub.customerProductManages!= null) {
                for(var i = 0;i<vm.customerHub.customerProductManages.length;i++){
                    var cpm = vm.customerHub.customerProductManages[i];

                    if(!cpm.cancelled&&!cpm.productId){
                        count3++;
                    }
                    if(cpm.customerSkuManages&&cpm.customerSkuManages.length){
                        for(var j = 0;j<cpm.customerSkuManages.length;j++){
                            var csm = cpm.customerSkuManages[j];
                            if(csm.delete){
                                csm.cancelled = true;
                            }
                        }
                    }
                }
            }
            console.log("count: "+count+" count2: "+count2)
            if(count3>0){
                vm.isSaving = false;
                MessageService.error("请选择商品");
                return
            }

            //筛选出重复的  比较productId
            if(vm.customerHub.customerProductManages&&vm.customerHub.customerProductManages.length){
                vm.arr = uniqeByKeys(vm.customerHub.customerProductManages, ['productId']);
                if(vm.arr.length!= vm.customerHub.customerProductManages.length){
                    vm.isSaving = false;
                    MessageService.error("已有该属性，请勿重复添加");
                    return
                }

            }

            if(vm.customerHub.id){
                CustomerHub.update(vm.customerHub,function (res) {
                    angular.forEach(vm.userGroups,function (item) {
                        item.customerHubId = res.id;
                    })
                    //更新用户
                    User.batchSave(vm.userGroups)
                    //删除用户
                    if(vm.userDel.length){
                        User.batchDelete({ids:vm.userDel})
                    }

                    MessageService.success("更新成功！");
                    $state.go('customerHub',{page: $stateParams.page});
                },function (error) {
                    vm.isSaving = false;
                    MessageService.error("更新失败！");
                });
            }else{
                CustomerHub.save(vm.customerHub,function (res) {
                    angular.forEach(vm.userGroups,function (item) {
                        item.customerHubId = res.id;
                    })
                    //更新用户
                    User.batchSave(vm.userGroups)
                    MessageService.success("客户新建成功！");
                    $state.go('customerHub',{page: $stateParams.page});
                },function (error) {
                    vm.isSaving = false;
                    MessageService.error("客户新建失败！");
                });
            }
        }
        //返回
        $scope.goBack = function () {
            $state.go("customerHub",{page: $stateParams.page});
        }

        function obj2key(obj, keys) {
            var n = keys.length,
                key = [];
            while (n--) {
                key.push(obj[keys[n]]);
            }
            return key.join('|');
        }

        function uniqeByKeys(array, keys) {
            var arr = [];
            var hash = {};
            for (var i = 0, j = array.length; i < j; i++) {
                if(!array[i].cancelled&&!array[i].deleted){
                    var k = obj2key(array[i], keys);
                    if (!(k in hash)) {
                        hash[k] = true;
                        arr.push(array[i]);
                    }
                }else{
                    arr.push(array[i]);
                }

            }
            return arr;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubDetailController', CustomerHubDetailController);

    CustomerHubDetailController.$inject = ['$scope', 'Principal','entity', '$stateParams', '$state','$uibModal'];

    function CustomerHubDetailController ($scope, Principal, entity, $stateParams, $state,$uibModal) {
        var vm = this;

        vm.supply = entity;
        //返回
        $scope.goBack = function () {
            $state.go("customerHub",{page: $stateParams.page});
        };

        $scope.productionDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/zone-detail.html',
                controller: 'ZoneDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data.areaList;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        $scope.propertyPrice = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-price-page.html',
                controller: 'SkuPricePageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        $scope.skuFileDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-file-detail.html',
                controller: 'SkuFileDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        $scope.skuMakeupDetail = function(data){
            $uibModal.open({
                templateUrl: 'app/supply/sku-makeup-detail.html',
                controller: 'SkuMakeupDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return data;
                    }
                }
            }).result.then(function(result){
                console.log(result)
                //data.areaList = result;
            });
        };

        //充值
        $scope.recharge = function(){
            $uibModal.open({
                templateUrl: 'app/supply/recharge-amount.html',
                controller: 'RechargeAmountController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.supply;
                    }
                }
            }).result.then(function(result){
                vm.supply.balance = result.balance;
            });
        };

        //交易明细
        $scope.transactionDetail = function(){
            $uibModal.open({
                templateUrl: 'app/customerHub/transaction-detail.html',
                controller: 'CustomerHubTransactionDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplier');
                        return $translate.refresh();
                    }],
                    msgdata: function () {
                        return vm.supply;
                    }
                }
            }).result.then(function(result){
                // vm.supply.balance = result.balance;
            });
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubCopyController', CustomerHubCopyController);

    CustomerHubCopyController.$inject = ['$scope', 'msgdata', '$uibModalInstance', 'MessageService'];

    function CustomerHubCopyController ($scope, msgdata, $uibModalInstance, MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.data = angular.copy(msgdata);
        vm.selectedAll = false;
        console.log(vm.data)

        $scope.chooseAll = function () {
            for (var i = 0; i < vm.data.skuManages.length; i++) {
                var item = vm.data.skuManages[i];
                if(item.delete||item.cancelled){
                    continue
                }
                item.selected = vm.selectedAll;
            }
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

        function save() {
            angular.forEach(vm.data.skuManages,function(item){
                if(item.selected){
                    if(vm.data.tag=='priceListSku'){
                        item.type = angular.copy(vm.data.data.type);
                        item.baseOn = angular.copy(vm.data.data.baseOn);
                        item.ladderSetups = angular.copy(vm.data.data.ladderSetups);
                        item.priceNum = angular.copy(vm.data.data.priceNum);
                        item.piecePrice = angular.copy(vm.data.data.piecePrice);
                        item.vipPrice = angular.copy(vm.data.data.vipPrice);
                        item.vipPiecePrice = angular.copy(vm.data.data.vipPiecePrice);
                    }else{
                        item.prePress = angular.copy(vm.data.data.prePress);
                        item.prePressFlowId = angular.copy(vm.data.data.prePressFlowId);
                        item.needCheck = angular.copy(vm.data.data.needCheck);
                        item.proofRuleId = angular.copy(vm.data.data.proofRuleId);
                    }

                }
            });
            vm.isSaving = true;
            $uibModalInstance.close(vm.data);
        }
    }
})();

/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerHub', {
                parent: 'module',
                url: '/customerHub',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/customerHub/customerHub.html',
                        controller: 'CustomerHubController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('customerHub');
                        return $translate.refresh();
                    }]
                }
            })
            .state('customerHubNew', {
                parent: 'module',
                url: '/customerHub-new',
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/customerHub/customerHub-dialog.html',
                        controller: 'CustomerHubNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('customerHub');
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {
                            id:''
                        };
                    }
                }
            })
            .state('customerHubEdit', {
                parent: 'module',
                url: '/customerHub-edit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/customerHub/customerHub-dialog.html',
                        controller: 'CustomerHubNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('customerHub');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CustomerHub', function ($stateParams, CustomerHub) {
                        return CustomerHub.get({id: $stateParams.id});
                    }]
                }
            })
            .state('customerHubDetail', {
                parent: 'module',
                url: '/customerHub-detail/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/supply/customerHub-detail.html',
                        controller: 'CustomerHubDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('customerHub');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CustomerHub', function ($stateParams, CustomerHub) {
                        return CustomerHub.get({id: $stateParams.id});
                    }]
                }
            })
            .state('invoicing', {
                parent: 'module',
                url: '/invoicing',
                params:{page: null,status: null,keyword: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/customerHub/invoicing.html',
                        controller: 'InvoicingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('invoicing');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoicing-detail', {
                parent: 'module',
                url: '/invoicing-detail/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_SUP']
                },
                views: {
                    'content': {
                        templateUrl: 'app/customerHub/invoicing-detail.html',
                        controller: 'InvoicingDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('invoicing');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Invoices', function ($stateParams, Invoices) {
                        return Invoices.get({id: $stateParams.id});
                    }]
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('CustomerHub', CustomerHub)
        .factory('PayOrder', PayOrder)
        .factory('Invoices', Invoices);

    CustomerHub.$inject = ['$resource'];
    PayOrder.$inject = ['$resource'];
    Invoices.$inject = ['$resource'];

    function PayOrder($resource) {
        var resourceUrl = 'api/pay-orders/:path/:id';

        return $resource(resourceUrl, {}, {
            'refund': {
                method: 'POST',
                params: {
                    path: 'refund'
                }
            },
            'getAllByCondition': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                },
                isArray:true
            },
        });
    }

    function CustomerHub($resource) {
        var resourceUrl = 'api/customer-hubs/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false,
                params: {
                    path: 'create'
                }
            },
            'changeBalance': {
                method: 'GET',
                params: {
                    path: 'changeBalance'
                }
            },
            'getTransactionRecord': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'getTransactionRecord'
                }
            },
            'delete': {
                method: 'DELETE'
            },
            'page': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'getAll': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'getHomePageData': {
                method: 'GET',
                params: {
                    path: 'getHomePageData'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' ,
                headers: {
                    scope:'client'
                }
            },
            'save': { method: 'POST' ,
                headers: {
                    scope:'client'
                }
            }

        });
    }

    function Invoices($resource) {
        var resourceUrl = 'api/invoices/:path/:id';

        return $resource(resourceUrl, {}, {
            'delivery':{
                method:'GET',
                params: {
                    path: 'delivery'
                }
            },
            'reject': {
                method:'GET',
                params: {
                    path: 'reject'
                }
            },
            'approve': {
                method:'GET',
                params: {
                    path: 'approve'
                }
            },
            'create': {
                method: 'POST',
                isArray: false,
                params: {
                    path: 'create'
                }
            },
            'delete': {
                method: 'DELETE'
            },
            'page': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'getAll': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'getHomePageData': {
                method: 'GET',
                params: {
                    path: 'getHomePageData'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }

        });
    }


})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('CustomerHubController', CustomerHubController);

    CustomerHubController.$inject = ['$scope', 'Principal', 'LoginService', '$state','CustomerHub','MessageService', 'ParseLinks', '$stateParams'];

    function CustomerHubController ($scope, Principal, LoginService, $state,CustomerHub,MessageService, ParseLinks, $stateParams) {
        var vm = this;

        vm.categories =[{
            name:'outsource',
            value:'委外'
        },{
            name:'SourceMaterials',
            value:'原辅材料'
        }];
        vm.loadAll = loadAll;
        vm.clear =clear;

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            keyword:''
        };

        loadAll();
        function loadAll() {
            vm.customerHubs = [];
            CustomerHub.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.customerHubs = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.keyword = null;
            vm.tableData.page = 0;
            loadAll();
        }

        $scope.deleteCustomerHub = function(id){
            MessageService.confirm("确认要删除该客户？", function () {
                CustomerHub.delete({id: id}, function () {
                    loadAll();
                    MessageService.success("客户删除成功");
                }, function (error) {
                    MessageService.error("客户删除失败，请重试！");
                });
            });
        };

    }
})();

/* 
 *  
 * uuid.js - Version 0.3 JavaScript Class to create a UUID like identifier 
 *  
 * Copyright (C) 2006-2008, Erik Giberti (AF-Design), All rights reserved. 
 *  
 * This program is free software; you can redistribute it and/or modify it under 
 * the terms of the GNU General Public License as published by the Free Software 
 * Foundation; either version 2 of the License, or (at your option) any later 
 * version. 
 *  
 * This program is distributed in the hope that it will be useful, but WITHOUT 
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS 
 * FOR A PARTICULAR PURPOSE. See the GNU General Public License for more 
 * details. 
 *  
 * You should have received a copy of the GNU General Public License along with 
 * this program; if not, write to the Free Software Foundation, Inc., 59 Temple 
 * Place, Suite 330, Boston, MA 02111-1307 USA 
 *  
 * The latest version of this file can be downloaded from 
 * http://www.af-design.com/resources/javascript_uuid.php 
 *  
 * HISTORY: 6/5/06 - Initial Release 5/22/08 - Updated code to run faster, 
 * removed randrange(min,max) in favor of a simpler rand(max) function. Reduced 
 * overhead by using getTime() method of date class (suggestion by James Hall). 
 * 9/5/08 - Fixed a bug with rand(max) and additional efficiencies pointed out 
 * by Robert Kieffer http://broofa.com/ 
 *  
 * KNOWN ISSUES: - Still no way to get MAC address in JavaScript - Research into 
 * other versions of UUID show promising possibilities (more research needed) - 
 * Documentation needs improvement 
 *  
 */  
  
// On creation of a UUID object, set it's initial value  
function UUID() {  
    this.id = this.createUUID();  
}
  
// When asked what this Object is, lie and return it's value  
UUID.prototype.valueOf = function() {  
    return this.id;  
};  
UUID.prototype.toString = function() {  
    return this.id;  
};  
  
//  
// INSTANCE SPECIFIC METHODS  
//  
  
UUID.prototype.createUUID = function() {  
    //  
    // Loose interpretation of the specification DCE 1.1: Remote Procedure Call  
    // described at  
    // http://www.opengroup.org/onlinepubs/009629399/apdxa.htm#tagtcjh_37  
    // since JavaScript doesn't allow access to internal systems, the last 48  
    // bits  
    // of the node section is made up using a series of random numbers (6 octets  
    // long).  
    //    
    var dg = new Date(1582, 10, 15, 0, 0, 0, 0);  
    var dc = new Date();  
    var t = dc.getTime() - dg.getTime();  
    var tl = UUID.getIntegerBits(t, 0, 31);  
    var tm = UUID.getIntegerBits(t, 32, 47);  
    var thv = UUID.getIntegerBits(t, 48, 59) + '1'; // version 1, security version is 2  
    var csar = UUID.getIntegerBits(UUID.rand(4095), 0, 7);  
    var csl = UUID.getIntegerBits(UUID.rand(4095), 0, 7);  
  
    // since detection of anything about the machine/browser is far to buggy,  
    // include some more random numbers here  
    // if NIC or an IP can be obtained reliably, that should be put in  
    // here instead.  
    var n = UUID.getIntegerBits(UUID.rand(8191), 0, 7)  
            + UUID.getIntegerBits(UUID.rand(8191), 8, 15)  
            + UUID.getIntegerBits(UUID.rand(8191), 0, 7)  
            + UUID.getIntegerBits(UUID.rand(8191), 8, 15)  
            + UUID.getIntegerBits(UUID.rand(8191), 0, 15); // this last number is two octets long  
    return tl + tm + thv + csar + csl + n;  
};  
  
//  
// GENERAL METHODS (Not instance specific)  
//  
  
// Pull out only certain bits from a very large integer, used to get the time  
// code information for the first part of a UUID. Will return zero's if there  
// aren't enough bits to shift where it needs to.  
UUID.getIntegerBits = function(val, start, end) {  
    var base16 = UUID.returnBase(val, 16);  
    var quadArray = new Array();  
    var quadString = '';  
    var i = 0;  
    for (i = 0; i < base16.length; i++) {  
        quadArray.push(base16.substring(i, i + 1));  
    }  
    for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {  
        if (!quadArray[i] || quadArray[i] == '')  
            quadString += '0';  
        else  
            quadString += quadArray[i];  
    }  
    return quadString;  
};  
  
// Replaced from the original function to leverage the built in methods in  
// JavaScript. Thanks to Robert Kieffer for pointing this one out  
UUID.returnBase = function(number, base) {  
    return (number).toString(base).toUpperCase();  
};  
  
// pick a random number within a range of numbers  
// int b rand(int a); where 0 <= b <= a  
UUID.rand = function(max) {  
    return Math.floor(Math.random() * (max + 1));  
};  
  
// end of UUID class file  

(function(){
	'use strict';
	angular
	.module('gwApp')
	.factory('UidService',UidService);

	UidService.$inject = [];
	
	function UidService(){
		var service={
			get:get
		}
		return service;
	}
	function get(){
		var d = new Date().getTime();
		var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
		});
		return uid;
	}

})();
(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('gwApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
	'use strict';
	angular
		.module('gwApp')
		.factory('ListService', ListService);

	ListService.$inject = [];

	function ListService() {
		var service = {
			inList: inList,
			inList2 :inList2,
			removeEmptyInList: removeEmptyInList
		};
		return service;

		function inList2(value, list, valueAttr , listAttr) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (valueAttr && listAttr) {
						if (v && value[valueAttr] == v[listAttr]) {
							return v;
						};
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function inList(value, list, attrList) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (attrList) {
						if (v) {
							var match = 0;
							for (var j = 0; attrList && j < attrList.length; j++) {
								var attr = attrList[j];
								if (attr) {
									if (v[attr] == value[attr]) {
										match++;
									} else {
										break;
									}
								}
							}
							if (match == attrList.length) {
								return v;
							}
						}
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function removeEmptyInList(list, key) {
			if (!list) return;
			for (var i = 0; i < list.length; i++) {
				var item = list[i];
				if (item && !item[key]) {
					list.splice(i, 1);
					i--;
				}
			}
		}
	}



})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: 
                '<div class="info">' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +'条数据,'+
                    '每页'+'{{$ctrl.itemsPerPage}}'+'条,'+'第'+'{{$ctrl.page}}'+'页/'+'共'+'{{$ctrl.s}}'+ '页'+ '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        },
        controller: 'jhiItemCountCtrl'
    };

    angular
        .module('gwApp')
        .component('jhiItemCount', jhiItemCount)
        .controller('jhiItemCountCtrl', jhiItemCountCtrl);
        jhiItemCountCtrl.$inject = [];
        function jhiItemCountCtrl(){
            var vm = this;
            vm.s = Math.ceil(vm.queryCount/vm.itemsPerPage);
        }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat,
            dayStart: dayStart,
            dayEnd: dayEnd,
            dayMid: dayMid
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }

        function dayStart(val) {
            if (!val) {
                return null;
            }
            var date = new Date(val);
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            return date;
        }

        function dayMid(val) {
            if (!val) {
                return null;
            }
            var date = new Date(val);
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            return date;
        }

        function dayEnd(val) {
            if (!val) {
                return null;
            }
            var date = new Date(val);
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            return date;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

function printLodop(MessageService,DeliverySettings,html,proview){
    if(LODOP){
        var width = 210;
        var height = 210;
        DeliverySettings.get({},function (res){
            if(res.templateSize){
                if(res.templateSize.split("x")[0]){
                    width = res.templateSize.split("x")[0];
                }
                if(res.templateSize.split("x")[1]){
                    height = res.templateSize.split("x")[1];
                }
            }
            LODOP.SET_LICENSES("","2A0562B5A4A7A585F7300EBFD8D3AE0B5E4","","");
            LODOP.PRINT_INIT("");
            LODOP.SET_PRINT_PAGESIZE(3,width+"mm",10,"") // 纸张方向大小
            LODOP.ADD_PRINT_HTM(0,0,width+"mm","100%",html);
            if(proview){
                LODOP.PREVIEW() // 打印预览
            }else{
                LODOP.PRINT()    //直接打印
            }
        })
    }else{
        MessageService.error("请检查C-Lodop是否启用");
    }
}

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('gwApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

var app = angular.module('editor', []); 
    app.directive('contenteditable', function() {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, ctrl) {
       
          element.bind('keyup', function() {
            scope.$apply(function() {
              var html=element.html();

              ctrl.$setViewValue(html);
            });
          });

        }
      };
    });


(function() {
	'use strict';

	angular
		.module('gwApp')
		.factory('RegionService', RegionService);
 
	RegionService.$inject = ['regions'];

	function RegionService(regions) {
		var $regions = {};
		var root = {};
		$regions['root'] = root;
		for (var i = 0; i < regions.length; i++) {
			var region = regions[i];
			$regions[region.c] = region;
			if (region.pc && $regions[region.pc]) {
				$regions[region.pc].children = $regions[region.pc].children || [];
				if ($regions[region.pc].children.indexOf(region) === -1) {
					$regions[region.pc].children.push(region);
					region.parent = $regions[region.pc];
				}
			}
			if (!region.pc) {
				region.parent = root;
				root.children = root.children || [];
				root.children.push(region);
			}
		}

		return {
			get: function(key) {
				return $regions[key];
			},
			getCountries: function() {
				return $regions['root'].children;
			}
		};
	}
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('regions', regions);

    function regions() {
        var regions = [{
            "c": "86",
            "n": "中国"
        }, {
            "c": "110000",
            "n": "北京市",
            "pc": "86"
        }, {
            "c": "110100",
            "n": "北京市",
            "pc": "110000"
        }, {
            "c": "110101",
            "n": "东城区",
            "pc": "110100"
        }, {
            "c": "110102",
            "n": "西城区",
            "pc": "110100"
        }, {
            "c": "110105",
            "n": "朝阳区",
            "pc": "110100"
        }, {
            "c": "110106",
            "n": "丰台区",
            "pc": "110100"
        }, {
            "c": "110107",
            "n": "石景山区",
            "pc": "110100"
        }, {
            "c": "110108",
            "n": "海淀区",
            "pc": "110100"
        }, {
            "c": "110109",
            "n": "门头沟区",
            "pc": "110100"
        }, {
            "c": "110111",
            "n": "房山区",
            "pc": "110100"
        }, {
            "c": "110112",
            "n": "通州区",
            "pc": "110100"
        }, {
            "c": "110113",
            "n": "顺义区",
            "pc": "110100"
        }, {
            "c": "110114",
            "n": "昌平区",
            "pc": "110100"
        }, {
            "c": "110115",
            "n": "大兴区",
            "pc": "110100"
        }, {
            "c": "110116",
            "n": "怀柔区",
            "pc": "110100"
        }, {
            "c": "110117",
            "n": "平谷区",
            "pc": "110100"
        }, {
            "c": "110228",
            "n": "密云县",
            "pc": "110100"
        }, {
            "c": "110229",
            "n": "延庆县",
            "pc": "110100"
        }, {
            "c": "120000",
            "n": "天津市",
            "pc": "86"
        }, {
            "c": "120100",
            "n": "天津市",
            "pc": "120000"
        }, {
            "c": "120101",
            "n": "和平区",
            "pc": "120100"
        }, {
            "c": "120102",
            "n": "河东区",
            "pc": "120100"
        }, {
            "c": "120103",
            "n": "河西区",
            "pc": "120100"
        }, {
            "c": "120104",
            "n": "南开区",
            "pc": "120100"
        }, {
            "c": "120105",
            "n": "河北区",
            "pc": "120100"
        }, {
            "c": "120106",
            "n": "红桥区",
            "pc": "120100"
        }, {
            "c": "120110",
            "n": "东丽区",
            "pc": "120100"
        }, {
            "c": "120111",
            "n": "西青区",
            "pc": "120100"
        }, {
            "c": "120112",
            "n": "津南区",
            "pc": "120100"
        }, {
            "c": "120113",
            "n": "北辰区",
            "pc": "120100"
        }, {
            "c": "120114",
            "n": "武清区",
            "pc": "120100"
        }, {
            "c": "120115",
            "n": "宝坻区",
            "pc": "120100"
        }, {
            "c": "120116",
            "n": "滨海新区",
            "pc": "120100"
        }, {
            "c": "120221",
            "n": "宁河县",
            "pc": "120100"
        }, {
            "c": "120223",
            "n": "静海县",
            "pc": "120100"
        }, {
            "c": "120225",
            "n": "蓟县",
            "pc": "120100"
        }, {
            "c": "130000",
            "n": "河北省",
            "pc": "86"
        }, {
            "c": "130100",
            "n": "石家庄市",
            "pc": "130000"
        }, {
            "c": "130101",
            "n": "市辖区",
            "pc": "130100"
        }, {
            "c": "130102",
            "n": "长安区",
            "pc": "130100"
        }, {
            "c": "130103",
            "n": "桥东区",
            "pc": "130100"
        }, {
            "c": "130104",
            "n": "桥西区",
            "pc": "130100"
        }, {
            "c": "130105",
            "n": "新华区",
            "pc": "130100"
        }, {
            "c": "130107",
            "n": "井陉矿区",
            "pc": "130100"
        }, {
            "c": "130108",
            "n": "裕华区",
            "pc": "130100"
        }, {
            "c": "130121",
            "n": "井陉县",
            "pc": "130100"
        }, {
            "c": "130123",
            "n": "正定县",
            "pc": "130100"
        }, {
            "c": "130124",
            "n": "栾城县",
            "pc": "130100"
        }, {
            "c": "130125",
            "n": "行唐县",
            "pc": "130100"
        }, {
            "c": "130126",
            "n": "灵寿县",
            "pc": "130100"
        }, {
            "c": "130127",
            "n": "高邑县",
            "pc": "130100"
        }, {
            "c": "130128",
            "n": "深泽县",
            "pc": "130100"
        }, {
            "c": "130129",
            "n": "赞皇县",
            "pc": "130100"
        }, {
            "c": "130130",
            "n": "无极县",
            "pc": "130100"
        }, {
            "c": "130131",
            "n": "平山县",
            "pc": "130100"
        }, {
            "c": "130132",
            "n": "元氏县",
            "pc": "130100"
        }, {
            "c": "130133",
            "n": "赵县",
            "pc": "130100"
        }, {
            "c": "130181",
            "n": "辛集市",
            "pc": "130100"
        }, {
            "c": "130182",
            "n": "藁城市",
            "pc": "130100"
        }, {
            "c": "130183",
            "n": "晋州市",
            "pc": "130100"
        }, {
            "c": "130184",
            "n": "新乐市",
            "pc": "130100"
        }, {
            "c": "130185",
            "n": "鹿泉市",
            "pc": "130100"
        }, {
            "c": "130200",
            "n": "唐山市",
            "pc": "130000"
        }, {
            "c": "130201",
            "n": "市辖区",
            "pc": "130200"
        }, {
            "c": "130202",
            "n": "路南区",
            "pc": "130200"
        }, {
            "c": "130203",
            "n": "路北区",
            "pc": "130200"
        }, {
            "c": "130204",
            "n": "古冶区",
            "pc": "130200"
        }, {
            "c": "130205",
            "n": "开平区",
            "pc": "130200"
        }, {
            "c": "130207",
            "n": "丰南区",
            "pc": "130200"
        }, {
            "c": "130208",
            "n": "丰润区",
            "pc": "130200"
        }, {
            "c": "130209",
            "n": "曹妃甸区",
            "pc": "130200"
        }, {
            "c": "130223",
            "n": "滦县",
            "pc": "130200"
        }, {
            "c": "130224",
            "n": "滦南县",
            "pc": "130200"
        }, {
            "c": "130225",
            "n": "乐亭县",
            "pc": "130200"
        }, {
            "c": "130227",
            "n": "迁西县",
            "pc": "130200"
        }, {
            "c": "130229",
            "n": "玉田县",
            "pc": "130200"
        }, {
            "c": "130281",
            "n": "遵化市",
            "pc": "130200"
        }, {
            "c": "130283",
            "n": "迁安市",
            "pc": "130200"
        }, {
            "c": "130300",
            "n": "秦皇岛市",
            "pc": "130000"
        }, {
            "c": "130301",
            "n": "市辖区",
            "pc": "130300"
        }, {
            "c": "130302",
            "n": "海港区",
            "pc": "130300"
        }, {
            "c": "130303",
            "n": "山海关区",
            "pc": "130300"
        }, {
            "c": "130304",
            "n": "北戴河区",
            "pc": "130300"
        }, {
            "c": "130321",
            "n": "青龙满族自治县",
            "pc": "130300"
        }, {
            "c": "130322",
            "n": "昌黎县",
            "pc": "130300"
        }, {
            "c": "130323",
            "n": "抚宁县",
            "pc": "130300"
        }, {
            "c": "130324",
            "n": "卢龙县",
            "pc": "130300"
        }, {
            "c": "130400",
            "n": "邯郸市",
            "pc": "130000"
        }, {
            "c": "130401",
            "n": "市辖区",
            "pc": "130400"
        }, {
            "c": "130402",
            "n": "邯山区",
            "pc": "130400"
        }, {
            "c": "130403",
            "n": "丛台区",
            "pc": "130400"
        }, {
            "c": "130404",
            "n": "复兴区",
            "pc": "130400"
        }, {
            "c": "130406",
            "n": "峰峰矿区",
            "pc": "130400"
        }, {
            "c": "130421",
            "n": "邯郸县",
            "pc": "130400"
        }, {
            "c": "130423",
            "n": "临漳县",
            "pc": "130400"
        }, {
            "c": "130424",
            "n": "成安县",
            "pc": "130400"
        }, {
            "c": "130425",
            "n": "大名县",
            "pc": "130400"
        }, {
            "c": "130426",
            "n": "涉县",
            "pc": "130400"
        }, {
            "c": "130427",
            "n": "磁县",
            "pc": "130400"
        }, {
            "c": "130428",
            "n": "肥乡县",
            "pc": "130400"
        }, {
            "c": "130429",
            "n": "永年县",
            "pc": "130400"
        }, {
            "c": "130430",
            "n": "邱县",
            "pc": "130400"
        }, {
            "c": "130431",
            "n": "鸡泽县",
            "pc": "130400"
        }, {
            "c": "130432",
            "n": "广平县",
            "pc": "130400"
        }, {
            "c": "130433",
            "n": "馆陶县",
            "pc": "130400"
        }, {
            "c": "130434",
            "n": "魏县",
            "pc": "130400"
        }, {
            "c": "130435",
            "n": "曲周县",
            "pc": "130400"
        }, {
            "c": "130481",
            "n": "武安市",
            "pc": "130400"
        }, {
            "c": "130500",
            "n": "邢台市",
            "pc": "130000"
        }, {
            "c": "130501",
            "n": "市辖区",
            "pc": "130500"
        }, {
            "c": "130502",
            "n": "桥东区",
            "pc": "130500"
        }, {
            "c": "130503",
            "n": "桥西区",
            "pc": "130500"
        }, {
            "c": "130521",
            "n": "邢台县",
            "pc": "130500"
        }, {
            "c": "130522",
            "n": "临城县",
            "pc": "130500"
        }, {
            "c": "130523",
            "n": "内丘县",
            "pc": "130500"
        }, {
            "c": "130524",
            "n": "柏乡县",
            "pc": "130500"
        }, {
            "c": "130525",
            "n": "隆尧县",
            "pc": "130500"
        }, {
            "c": "130526",
            "n": "任县",
            "pc": "130500"
        }, {
            "c": "130527",
            "n": "南和县",
            "pc": "130500"
        }, {
            "c": "130528",
            "n": "宁晋县",
            "pc": "130500"
        }, {
            "c": "130529",
            "n": "巨鹿县",
            "pc": "130500"
        }, {
            "c": "130530",
            "n": "新河县",
            "pc": "130500"
        }, {
            "c": "130531",
            "n": "广宗县",
            "pc": "130500"
        }, {
            "c": "130532",
            "n": "平乡县",
            "pc": "130500"
        }, {
            "c": "130533",
            "n": "威县",
            "pc": "130500"
        }, {
            "c": "130534",
            "n": "清河县",
            "pc": "130500"
        }, {
            "c": "130535",
            "n": "临西县",
            "pc": "130500"
        }, {
            "c": "130581",
            "n": "南宫市",
            "pc": "130500"
        }, {
            "c": "130582",
            "n": "沙河市",
            "pc": "130500"
        }, {
            "c": "130600",
            "n": "保定市",
            "pc": "130000"
        }, {
            "c": "130601",
            "n": "市辖区",
            "pc": "130600"
        }, {
            "c": "130602",
            "n": "新市区",
            "pc": "130600"
        }, {
            "c": "130603",
            "n": "北市区",
            "pc": "130600"
        }, {
            "c": "130604",
            "n": "南市区",
            "pc": "130600"
        }, {
            "c": "130621",
            "n": "满城县",
            "pc": "130600"
        }, {
            "c": "130622",
            "n": "清苑县",
            "pc": "130600"
        }, {
            "c": "130623",
            "n": "涞水县",
            "pc": "130600"
        }, {
            "c": "130624",
            "n": "阜平县",
            "pc": "130600"
        }, {
            "c": "130625",
            "n": "徐水县",
            "pc": "130600"
        }, {
            "c": "130626",
            "n": "定兴县",
            "pc": "130600"
        }, {
            "c": "130627",
            "n": "唐县",
            "pc": "130600"
        }, {
            "c": "130628",
            "n": "高阳县",
            "pc": "130600"
        }, {
            "c": "130629",
            "n": "容城县",
            "pc": "130600"
        }, {
            "c": "130630",
            "n": "涞源县",
            "pc": "130600"
        }, {
            "c": "130631",
            "n": "望都县",
            "pc": "130600"
        }, {
            "c": "130632",
            "n": "安新县",
            "pc": "130600"
        }, {
            "c": "130633",
            "n": "易县",
            "pc": "130600"
        }, {
            "c": "130634",
            "n": "曲阳县",
            "pc": "130600"
        }, {
            "c": "130635",
            "n": "蠡县",
            "pc": "130600"
        }, {
            "c": "130636",
            "n": "顺平县",
            "pc": "130600"
        }, {
            "c": "130637",
            "n": "博野县",
            "pc": "130600"
        }, {
            "c": "130638",
            "n": "雄县",
            "pc": "130600"
        }, {
            "c": "130681",
            "n": "涿州市",
            "pc": "130600"
        }, {
            "c": "130682",
            "n": "定州市",
            "pc": "130600"
        }, {
            "c": "130683",
            "n": "安国市",
            "pc": "130600"
        }, {
            "c": "130684",
            "n": "高碑店市",
            "pc": "130600"
        }, {
            "c": "130700",
            "n": "张家口市",
            "pc": "130000"
        }, {
            "c": "130701",
            "n": "市辖区",
            "pc": "130700"
        }, {
            "c": "130702",
            "n": "桥东区",
            "pc": "130700"
        }, {
            "c": "130703",
            "n": "桥西区",
            "pc": "130700"
        }, {
            "c": "130705",
            "n": "宣化区",
            "pc": "130700"
        }, {
            "c": "130706",
            "n": "下花园区",
            "pc": "130700"
        }, {
            "c": "130721",
            "n": "宣化县",
            "pc": "130700"
        }, {
            "c": "130722",
            "n": "张北县",
            "pc": "130700"
        }, {
            "c": "130723",
            "n": "康保县",
            "pc": "130700"
        }, {
            "c": "130724",
            "n": "沽源县",
            "pc": "130700"
        }, {
            "c": "130725",
            "n": "尚义县",
            "pc": "130700"
        }, {
            "c": "130726",
            "n": "蔚县",
            "pc": "130700"
        }, {
            "c": "130727",
            "n": "阳原县",
            "pc": "130700"
        }, {
            "c": "130728",
            "n": "怀安县",
            "pc": "130700"
        }, {
            "c": "130729",
            "n": "万全县",
            "pc": "130700"
        }, {
            "c": "130730",
            "n": "怀来县",
            "pc": "130700"
        }, {
            "c": "130731",
            "n": "涿鹿县",
            "pc": "130700"
        }, {
            "c": "130732",
            "n": "赤城县",
            "pc": "130700"
        }, {
            "c": "130733",
            "n": "崇礼县",
            "pc": "130700"
        }, {
            "c": "130800",
            "n": "承德市",
            "pc": "130000"
        }, {
            "c": "130801",
            "n": "市辖区",
            "pc": "130800"
        }, {
            "c": "130802",
            "n": "双桥区",
            "pc": "130800"
        }, {
            "c": "130803",
            "n": "双滦区",
            "pc": "130800"
        }, {
            "c": "130804",
            "n": "鹰手营子矿区",
            "pc": "130800"
        }, {
            "c": "130821",
            "n": "承德县",
            "pc": "130800"
        }, {
            "c": "130822",
            "n": "兴隆县",
            "pc": "130800"
        }, {
            "c": "130823",
            "n": "平泉县",
            "pc": "130800"
        }, {
            "c": "130824",
            "n": "滦平县",
            "pc": "130800"
        }, {
            "c": "130825",
            "n": "隆化县",
            "pc": "130800"
        }, {
            "c": "130826",
            "n": "丰宁满族自治县",
            "pc": "130800"
        }, {
            "c": "130827",
            "n": "宽城满族自治县",
            "pc": "130800"
        }, {
            "c": "130828",
            "n": "围场满族蒙古族自治县",
            "pc": "130800"
        }, {
            "c": "130900",
            "n": "沧州市",
            "pc": "130000"
        }, {
            "c": "130901",
            "n": "市辖区",
            "pc": "130900"
        }, {
            "c": "130902",
            "n": "新华区",
            "pc": "130900"
        }, {
            "c": "130903",
            "n": "运河区",
            "pc": "130900"
        }, {
            "c": "130921",
            "n": "沧县",
            "pc": "130900"
        }, {
            "c": "130922",
            "n": "青县",
            "pc": "130900"
        }, {
            "c": "130923",
            "n": "东光县",
            "pc": "130900"
        }, {
            "c": "130924",
            "n": "海兴县",
            "pc": "130900"
        }, {
            "c": "130925",
            "n": "盐山县",
            "pc": "130900"
        }, {
            "c": "130926",
            "n": "肃宁县",
            "pc": "130900"
        }, {
            "c": "130927",
            "n": "南皮县",
            "pc": "130900"
        }, {
            "c": "130928",
            "n": "吴桥县",
            "pc": "130900"
        }, {
            "c": "130929",
            "n": "献县",
            "pc": "130900"
        }, {
            "c": "130930",
            "n": "孟村回族自治县",
            "pc": "130900"
        }, {
            "c": "130981",
            "n": "泊头市",
            "pc": "130900"
        }, {
            "c": "130982",
            "n": "任丘市",
            "pc": "130900"
        }, {
            "c": "130983",
            "n": "黄骅市",
            "pc": "130900"
        }, {
            "c": "130984",
            "n": "河间市",
            "pc": "130900"
        }, {
            "c": "131000",
            "n": "廊坊市",
            "pc": "130000"
        }, {
            "c": "131001",
            "n": "市辖区",
            "pc": "131000"
        }, {
            "c": "131002",
            "n": "安次区",
            "pc": "131000"
        }, {
            "c": "131003",
            "n": "广阳区",
            "pc": "131000"
        }, {
            "c": "131022",
            "n": "固安县",
            "pc": "131000"
        }, {
            "c": "131023",
            "n": "永清县",
            "pc": "131000"
        }, {
            "c": "131024",
            "n": "香河县",
            "pc": "131000"
        }, {
            "c": "131025",
            "n": "大城县",
            "pc": "131000"
        }, {
            "c": "131026",
            "n": "文安县",
            "pc": "131000"
        }, {
            "c": "131028",
            "n": "大厂回族自治县",
            "pc": "131000"
        }, {
            "c": "131081",
            "n": "霸州市",
            "pc": "131000"
        }, {
            "c": "131082",
            "n": "三河市",
            "pc": "131000"
        }, {
            "c": "131100",
            "n": "衡水市",
            "pc": "130000"
        }, {
            "c": "131101",
            "n": "市辖区",
            "pc": "131100"
        }, {
            "c": "131102",
            "n": "桃城区",
            "pc": "131100"
        }, {
            "c": "131121",
            "n": "枣强县",
            "pc": "131100"
        }, {
            "c": "131122",
            "n": "武邑县",
            "pc": "131100"
        }, {
            "c": "131123",
            "n": "武强县",
            "pc": "131100"
        }, {
            "c": "131124",
            "n": "饶阳县",
            "pc": "131100"
        }, {
            "c": "131125",
            "n": "安平县",
            "pc": "131100"
        }, {
            "c": "131126",
            "n": "故城县",
            "pc": "131100"
        }, {
            "c": "131127",
            "n": "景县",
            "pc": "131100"
        }, {
            "c": "131128",
            "n": "阜城县",
            "pc": "131100"
        }, {
            "c": "131181",
            "n": "冀州市",
            "pc": "131100"
        }, {
            "c": "131182",
            "n": "深州市",
            "pc": "131100"
        }, {
            "c": "140000",
            "n": "山西省",
            "pc": "86"
        }, {
            "c": "140100",
            "n": "太原市",
            "pc": "140000"
        }, {
            "c": "140101",
            "n": "市辖区",
            "pc": "140100"
        }, {
            "c": "140105",
            "n": "小店区",
            "pc": "140100"
        }, {
            "c": "140106",
            "n": "迎泽区",
            "pc": "140100"
        }, {
            "c": "140107",
            "n": "杏花岭区",
            "pc": "140100"
        }, {
            "c": "140108",
            "n": "尖草坪区",
            "pc": "140100"
        }, {
            "c": "140109",
            "n": "万柏林区",
            "pc": "140100"
        }, {
            "c": "140110",
            "n": "晋源区",
            "pc": "140100"
        }, {
            "c": "140121",
            "n": "清徐县",
            "pc": "140100"
        }, {
            "c": "140122",
            "n": "阳曲县",
            "pc": "140100"
        }, {
            "c": "140123",
            "n": "娄烦县",
            "pc": "140100"
        }, {
            "c": "140181",
            "n": "古交市",
            "pc": "140100"
        }, {
            "c": "140200",
            "n": "大同市",
            "pc": "140000"
        }, {
            "c": "140201",
            "n": "市辖区",
            "pc": "140200"
        }, {
            "c": "140202",
            "n": "城区",
            "pc": "140200"
        }, {
            "c": "140203",
            "n": "矿区",
            "pc": "140200"
        }, {
            "c": "140211",
            "n": "南郊区",
            "pc": "140200"
        }, {
            "c": "140212",
            "n": "新荣区",
            "pc": "140200"
        }, {
            "c": "140221",
            "n": "阳高县",
            "pc": "140200"
        }, {
            "c": "140222",
            "n": "天镇县",
            "pc": "140200"
        }, {
            "c": "140223",
            "n": "广灵县",
            "pc": "140200"
        }, {
            "c": "140224",
            "n": "灵丘县",
            "pc": "140200"
        }, {
            "c": "140225",
            "n": "浑源县",
            "pc": "140200"
        }, {
            "c": "140226",
            "n": "左云县",
            "pc": "140200"
        }, {
            "c": "140227",
            "n": "大同县",
            "pc": "140200"
        }, {
            "c": "140300",
            "n": "阳泉市",
            "pc": "140000"
        }, {
            "c": "140301",
            "n": "市辖区",
            "pc": "140300"
        }, {
            "c": "140302",
            "n": "城区",
            "pc": "140300"
        }, {
            "c": "140303",
            "n": "矿区",
            "pc": "140300"
        }, {
            "c": "140311",
            "n": "郊区",
            "pc": "140300"
        }, {
            "c": "140321",
            "n": "平定县",
            "pc": "140300"
        }, {
            "c": "140322",
            "n": "盂县",
            "pc": "140300"
        }, {
            "c": "140400",
            "n": "长治市",
            "pc": "140000"
        }, {
            "c": "140401",
            "n": "市辖区",
            "pc": "140400"
        }, {
            "c": "140402",
            "n": "城区",
            "pc": "140400"
        }, {
            "c": "140411",
            "n": "郊区",
            "pc": "140400"
        }, {
            "c": "140421",
            "n": "长治县",
            "pc": "140400"
        }, {
            "c": "140423",
            "n": "襄垣县",
            "pc": "140400"
        }, {
            "c": "140424",
            "n": "屯留县",
            "pc": "140400"
        }, {
            "c": "140425",
            "n": "平顺县",
            "pc": "140400"
        }, {
            "c": "140426",
            "n": "黎城县",
            "pc": "140400"
        }, {
            "c": "140427",
            "n": "壶关县",
            "pc": "140400"
        }, {
            "c": "140428",
            "n": "长子县",
            "pc": "140400"
        }, {
            "c": "140429",
            "n": "武乡县",
            "pc": "140400"
        }, {
            "c": "140430",
            "n": "沁县",
            "pc": "140400"
        }, {
            "c": "140431",
            "n": "沁源县",
            "pc": "140400"
        }, {
            "c": "140481",
            "n": "潞城市",
            "pc": "140400"
        }, {
            "c": "140500",
            "n": "晋城市",
            "pc": "140000"
        }, {
            "c": "140501",
            "n": "晋城市市辖区",
            "pc": "140500"
        }, {
            "c": "140502",
            "n": "城区",
            "pc": "140500"
        }, {
            "c": "140521",
            "n": "沁水县",
            "pc": "140500"
        }, {
            "c": "140522",
            "n": "阳城县",
            "pc": "140500"
        }, {
            "c": "140524",
            "n": "陵川县",
            "pc": "140500"
        }, {
            "c": "140525",
            "n": "泽州县",
            "pc": "140500"
        }, {
            "c": "140581",
            "n": "高平市",
            "pc": "140500"
        }, {
            "c": "140600",
            "n": "朔州市",
            "pc": "140000"
        }, {
            "c": "140601",
            "n": "市辖区",
            "pc": "140600"
        }, {
            "c": "140602",
            "n": "朔城区",
            "pc": "140600"
        }, {
            "c": "140603",
            "n": "平鲁区",
            "pc": "140600"
        }, {
            "c": "140621",
            "n": "山阴县",
            "pc": "140600"
        }, {
            "c": "140622",
            "n": "应县",
            "pc": "140600"
        }, {
            "c": "140623",
            "n": "右玉县",
            "pc": "140600"
        }, {
            "c": "140624",
            "n": "怀仁县",
            "pc": "140600"
        }, {
            "c": "140700",
            "n": "晋中市",
            "pc": "140000"
        }, {
            "c": "140701",
            "n": "市辖区",
            "pc": "140700"
        }, {
            "c": "140702",
            "n": "榆次区",
            "pc": "140700"
        }, {
            "c": "140721",
            "n": "榆社县",
            "pc": "140700"
        }, {
            "c": "140722",
            "n": "左权县",
            "pc": "140700"
        }, {
            "c": "140723",
            "n": "和顺县",
            "pc": "140700"
        }, {
            "c": "140724",
            "n": "昔阳县",
            "pc": "140700"
        }, {
            "c": "140725",
            "n": "寿阳县",
            "pc": "140700"
        }, {
            "c": "140726",
            "n": "太谷县",
            "pc": "140700"
        }, {
            "c": "140727",
            "n": "祁县",
            "pc": "140700"
        }, {
            "c": "140728",
            "n": "平遥县",
            "pc": "140700"
        }, {
            "c": "140729",
            "n": "灵石县",
            "pc": "140700"
        }, {
            "c": "140781",
            "n": "介休市",
            "pc": "140700"
        }, {
            "c": "140800",
            "n": "运城市",
            "pc": "140000"
        }, {
            "c": "140801",
            "n": "市辖区",
            "pc": "140800"
        }, {
            "c": "140802",
            "n": "盐湖区",
            "pc": "140800"
        }, {
            "c": "140821",
            "n": "临猗县",
            "pc": "140800"
        }, {
            "c": "140822",
            "n": "万荣县",
            "pc": "140800"
        }, {
            "c": "140823",
            "n": "闻喜县",
            "pc": "140800"
        }, {
            "c": "140824",
            "n": "稷山县",
            "pc": "140800"
        }, {
            "c": "140825",
            "n": "新绛县",
            "pc": "140800"
        }, {
            "c": "140826",
            "n": "绛县",
            "pc": "140800"
        }, {
            "c": "140827",
            "n": "垣曲县",
            "pc": "140800"
        }, {
            "c": "140828",
            "n": "夏县",
            "pc": "140800"
        }, {
            "c": "140829",
            "n": "平陆县",
            "pc": "140800"
        }, {
            "c": "140830",
            "n": "芮城县",
            "pc": "140800"
        }, {
            "c": "140881",
            "n": "永济市",
            "pc": "140800"
        }, {
            "c": "140882",
            "n": "河津市",
            "pc": "140800"
        }, {
            "c": "140900",
            "n": "忻州市",
            "pc": "140000"
        }, {
            "c": "140901",
            "n": "市辖区",
            "pc": "140900"
        }, {
            "c": "140902",
            "n": "忻府区",
            "pc": "140900"
        }, {
            "c": "140921",
            "n": "定襄县",
            "pc": "140900"
        }, {
            "c": "140922",
            "n": "五台县",
            "pc": "140900"
        }, {
            "c": "140923",
            "n": "代县",
            "pc": "140900"
        }, {
            "c": "140924",
            "n": "繁峙县",
            "pc": "140900"
        }, {
            "c": "140925",
            "n": "宁武县",
            "pc": "140900"
        }, {
            "c": "140926",
            "n": "静乐县",
            "pc": "140900"
        }, {
            "c": "140927",
            "n": "神池县",
            "pc": "140900"
        }, {
            "c": "140928",
            "n": "五寨县",
            "pc": "140900"
        }, {
            "c": "140929",
            "n": "岢岚县",
            "pc": "140900"
        }, {
            "c": "140930",
            "n": "河曲县",
            "pc": "140900"
        }, {
            "c": "140931",
            "n": "保德县",
            "pc": "140900"
        }, {
            "c": "140932",
            "n": "偏关县",
            "pc": "140900"
        }, {
            "c": "140981",
            "n": "原平市",
            "pc": "140900"
        }, {
            "c": "141000",
            "n": "临汾市",
            "pc": "140000"
        }, {
            "c": "141001",
            "n": "市辖区",
            "pc": "141000"
        }, {
            "c": "141002",
            "n": "尧都区",
            "pc": "141000"
        }, {
            "c": "141021",
            "n": "曲沃县",
            "pc": "141000"
        }, {
            "c": "141022",
            "n": "翼城县",
            "pc": "141000"
        }, {
            "c": "141023",
            "n": "襄汾县",
            "pc": "141000"
        }, {
            "c": "141024",
            "n": "洪洞县",
            "pc": "141000"
        }, {
            "c": "141025",
            "n": "古县",
            "pc": "141000"
        }, {
            "c": "141026",
            "n": "安泽县",
            "pc": "141000"
        }, {
            "c": "141027",
            "n": "浮山县",
            "pc": "141000"
        }, {
            "c": "141028",
            "n": "吉县",
            "pc": "141000"
        }, {
            "c": "141029",
            "n": "乡宁县",
            "pc": "141000"
        }, {
            "c": "141030",
            "n": "大宁县",
            "pc": "141000"
        }, {
            "c": "141031",
            "n": "隰县",
            "pc": "141000"
        }, {
            "c": "141032",
            "n": "永和县",
            "pc": "141000"
        }, {
            "c": "141033",
            "n": "蒲县",
            "pc": "141000"
        }, {
            "c": "141034",
            "n": "汾西县",
            "pc": "141000"
        }, {
            "c": "141081",
            "n": "侯马市",
            "pc": "141000"
        }, {
            "c": "141082",
            "n": "霍州市",
            "pc": "141000"
        }, {
            "c": "141100",
            "n": "吕梁市",
            "pc": "140000"
        }, {
            "c": "141101",
            "n": "市辖区",
            "pc": "141100"
        }, {
            "c": "141102",
            "n": "离石区",
            "pc": "141100"
        }, {
            "c": "141121",
            "n": "文水县",
            "pc": "141100"
        }, {
            "c": "141122",
            "n": "交城县",
            "pc": "141100"
        }, {
            "c": "141123",
            "n": "兴县",
            "pc": "141100"
        }, {
            "c": "141124",
            "n": "临县",
            "pc": "141100"
        }, {
            "c": "141125",
            "n": "柳林县",
            "pc": "141100"
        }, {
            "c": "141126",
            "n": "石楼县",
            "pc": "141100"
        }, {
            "c": "141127",
            "n": "岚县",
            "pc": "141100"
        }, {
            "c": "141128",
            "n": "方山县",
            "pc": "141100"
        }, {
            "c": "141129",
            "n": "中阳县",
            "pc": "141100"
        }, {
            "c": "141130",
            "n": "交口县",
            "pc": "141100"
        }, {
            "c": "141181",
            "n": "孝义市",
            "pc": "141100"
        }, {
            "c": "141182",
            "n": "汾阳市",
            "pc": "141100"
        }, {
            "c": "150000",
            "n": "内蒙古自治区",
            "pc": "86"
        }, {
            "c": "150100",
            "n": "呼和浩特市",
            "pc": "150000"
        }, {
            "c": "150101",
            "n": "市辖区",
            "pc": "150100"
        }, {
            "c": "150102",
            "n": "新城区",
            "pc": "150100"
        }, {
            "c": "150103",
            "n": "回民区",
            "pc": "150100"
        }, {
            "c": "150104",
            "n": "玉泉区",
            "pc": "150100"
        }, {
            "c": "150105",
            "n": "赛罕区",
            "pc": "150100"
        }, {
            "c": "150121",
            "n": "土默特左旗",
            "pc": "150100"
        }, {
            "c": "150122",
            "n": "托克托县",
            "pc": "150100"
        }, {
            "c": "150123",
            "n": "和林格尔县",
            "pc": "150100"
        }, {
            "c": "150124",
            "n": "清水河县",
            "pc": "150100"
        }, {
            "c": "150125",
            "n": "武川县",
            "pc": "150100"
        }, {
            "c": "150200",
            "n": "包头市",
            "pc": "150000"
        }, {
            "c": "150201",
            "n": "市辖区",
            "pc": "150200"
        }, {
            "c": "150202",
            "n": "东河区",
            "pc": "150200"
        }, {
            "c": "150203",
            "n": "昆都仑区",
            "pc": "150200"
        }, {
            "c": "150204",
            "n": "青山区",
            "pc": "150200"
        }, {
            "c": "150205",
            "n": "石拐区",
            "pc": "150200"
        }, {
            "c": "150206",
            "n": "白云鄂博矿区",
            "pc": "150200"
        }, {
            "c": "150207",
            "n": "九原区",
            "pc": "150200"
        }, {
            "c": "150221",
            "n": "土默特右旗",
            "pc": "150200"
        }, {
            "c": "150222",
            "n": "固阳县",
            "pc": "150200"
        }, {
            "c": "150223",
            "n": "达尔罕茂明安联合旗",
            "pc": "150200"
        }, {
            "c": "150300",
            "n": "乌海市",
            "pc": "150000"
        }, {
            "c": "150301",
            "n": "市辖区",
            "pc": "150300"
        }, {
            "c": "150302",
            "n": "海勃湾区",
            "pc": "150300"
        }, {
            "c": "150303",
            "n": "海南区",
            "pc": "150300"
        }, {
            "c": "150304",
            "n": "乌达区",
            "pc": "150300"
        }, {
            "c": "150400",
            "n": "赤峰市",
            "pc": "150000"
        }, {
            "c": "150401",
            "n": "市辖区",
            "pc": "150400"
        }, {
            "c": "150402",
            "n": "红山区",
            "pc": "150400"
        }, {
            "c": "150403",
            "n": "元宝山区",
            "pc": "150400"
        }, {
            "c": "150404",
            "n": "松山区",
            "pc": "150400"
        }, {
            "c": "150421",
            "n": "阿鲁科尔沁旗",
            "pc": "150400"
        }, {
            "c": "150422",
            "n": "巴林左旗",
            "pc": "150400"
        }, {
            "c": "150423",
            "n": "巴林右旗",
            "pc": "150400"
        }, {
            "c": "150424",
            "n": "林西县",
            "pc": "150400"
        }, {
            "c": "150425",
            "n": "克什克腾旗",
            "pc": "150400"
        }, {
            "c": "150426",
            "n": "翁牛特旗",
            "pc": "150400"
        }, {
            "c": "150428",
            "n": "喀喇沁旗",
            "pc": "150400"
        }, {
            "c": "150429",
            "n": "宁城县",
            "pc": "150400"
        }, {
            "c": "150430",
            "n": "敖汉旗",
            "pc": "150400"
        }, {
            "c": "150500",
            "n": "通辽市",
            "pc": "150000"
        }, {
            "c": "150501",
            "n": "市辖区",
            "pc": "150500"
        }, {
            "c": "150502",
            "n": "科尔沁区",
            "pc": "150500"
        }, {
            "c": "150521",
            "n": "科尔沁左翼中旗",
            "pc": "150500"
        }, {
            "c": "150522",
            "n": "科尔沁左翼后旗",
            "pc": "150500"
        }, {
            "c": "150523",
            "n": "开鲁县",
            "pc": "150500"
        }, {
            "c": "150524",
            "n": "库伦旗",
            "pc": "150500"
        }, {
            "c": "150525",
            "n": "奈曼旗",
            "pc": "150500"
        }, {
            "c": "150526",
            "n": "扎鲁特旗",
            "pc": "150500"
        }, {
            "c": "150581",
            "n": "霍林郭勒市",
            "pc": "150500"
        }, {
            "c": "150600",
            "n": "鄂尔多斯市",
            "pc": "150000"
        }, {
            "c": "150601",
            "n": "市辖区",
            "pc": "150600"
        }, {
            "c": "150602",
            "n": "东胜区",
            "pc": "150600"
        }, {
            "c": "150621",
            "n": "达拉特旗",
            "pc": "150600"
        }, {
            "c": "150622",
            "n": "准格尔旗",
            "pc": "150600"
        }, {
            "c": "150623",
            "n": "鄂托克前旗",
            "pc": "150600"
        }, {
            "c": "150624",
            "n": "鄂托克旗",
            "pc": "150600"
        }, {
            "c": "150625",
            "n": "杭锦旗",
            "pc": "150600"
        }, {
            "c": "150626",
            "n": "乌审旗",
            "pc": "150600"
        }, {
            "c": "150627",
            "n": "伊金霍洛旗",
            "pc": "150600"
        }, {
            "c": "150700",
            "n": "呼伦贝尔市",
            "pc": "150000"
        }, {
            "c": "150701",
            "n": "市辖区",
            "pc": "150700"
        }, {
            "c": "150702",
            "n": "海拉尔区",
            "pc": "150700"
        }, {
            "c": "150721",
            "n": "阿荣旗",
            "pc": "150700"
        }, {
            "c": "150722",
            "n": "莫力达瓦达斡尔族自治旗",
            "pc": "150700"
        }, {
            "c": "150723",
            "n": "鄂伦春自治旗",
            "pc": "150700"
        }, {
            "c": "150724",
            "n": "鄂温克族自治旗",
            "pc": "150700"
        }, {
            "c": "150725",
            "n": "陈巴尔虎旗",
            "pc": "150700"
        }, {
            "c": "150726",
            "n": "新巴尔虎左旗",
            "pc": "150700"
        }, {
            "c": "150727",
            "n": "新巴尔虎右旗",
            "pc": "150700"
        }, {
            "c": "150781",
            "n": "满洲里市",
            "pc": "150700"
        }, {
            "c": "150782",
            "n": "牙克石市",
            "pc": "150700"
        }, {
            "c": "150783",
            "n": "扎兰屯市",
            "pc": "150700"
        }, {
            "c": "150784",
            "n": "额尔古纳市",
            "pc": "150700"
        }, {
            "c": "150785",
            "n": "根河市",
            "pc": "150700"
        }, {
            "c": "150800",
            "n": "巴彦淖尔市",
            "pc": "150000"
        }, {
            "c": "150801",
            "n": "市辖区",
            "pc": "150800"
        }, {
            "c": "150802",
            "n": "临河区",
            "pc": "150800"
        }, {
            "c": "150821",
            "n": "五原县",
            "pc": "150800"
        }, {
            "c": "150822",
            "n": "磴口县",
            "pc": "150800"
        }, {
            "c": "150823",
            "n": "乌拉特前旗",
            "pc": "150800"
        }, {
            "c": "150824",
            "n": "乌拉特中旗",
            "pc": "150800"
        }, {
            "c": "150825",
            "n": "乌拉特后旗",
            "pc": "150800"
        }, {
            "c": "150826",
            "n": "杭锦后旗",
            "pc": "150800"
        }, {
            "c": "150900",
            "n": "乌兰察布市",
            "pc": "150000"
        }, {
            "c": "150901",
            "n": "市辖区",
            "pc": "150900"
        }, {
            "c": "150902",
            "n": "集宁区",
            "pc": "150900"
        }, {
            "c": "150921",
            "n": "卓资县",
            "pc": "150900"
        }, {
            "c": "150922",
            "n": "化德县",
            "pc": "150900"
        }, {
            "c": "150923",
            "n": "商都县",
            "pc": "150900"
        }, {
            "c": "150924",
            "n": "兴和县",
            "pc": "150900"
        }, {
            "c": "150925",
            "n": "凉城县",
            "pc": "150900"
        }, {
            "c": "150926",
            "n": "察哈尔右翼前旗",
            "pc": "150900"
        }, {
            "c": "150927",
            "n": "察哈尔右翼中旗",
            "pc": "150900"
        }, {
            "c": "150928",
            "n": "察哈尔右翼后旗",
            "pc": "150900"
        }, {
            "c": "150929",
            "n": "四子王旗",
            "pc": "150900"
        }, {
            "c": "150981",
            "n": "丰镇市",
            "pc": "150900"
        }, {
            "c": "152200",
            "n": "兴安盟",
            "pc": "150000"
        }, {
            "c": "152201",
            "n": "乌兰浩特市",
            "pc": "152200"
        }, {
            "c": "152202",
            "n": "阿尔山市",
            "pc": "152200"
        }, {
            "c": "152221",
            "n": "科尔沁右翼前旗",
            "pc": "152200"
        }, {
            "c": "152222",
            "n": "科尔沁右翼中旗",
            "pc": "152200"
        }, {
            "c": "152223",
            "n": "扎赉特旗",
            "pc": "152200"
        }, {
            "c": "152224",
            "n": "突泉县",
            "pc": "152200"
        }, {
            "c": "152500",
            "n": "锡林郭勒盟",
            "pc": "150000"
        }, {
            "c": "152501",
            "n": "二连浩特市",
            "pc": "152500"
        }, {
            "c": "152502",
            "n": "锡林浩特市",
            "pc": "152500"
        }, {
            "c": "152522",
            "n": "阿巴嘎旗",
            "pc": "152500"
        }, {
            "c": "152523",
            "n": "苏尼特左旗",
            "pc": "152500"
        }, {
            "c": "152524",
            "n": "苏尼特右旗",
            "pc": "152500"
        }, {
            "c": "152525",
            "n": "东乌珠穆沁旗",
            "pc": "152500"
        }, {
            "c": "152526",
            "n": "西乌珠穆沁旗",
            "pc": "152500"
        }, {
            "c": "152527",
            "n": "太仆寺旗",
            "pc": "152500"
        }, {
            "c": "152528",
            "n": "镶黄旗",
            "pc": "152500"
        }, {
            "c": "152529",
            "n": "正镶白旗",
            "pc": "152500"
        }, {
            "c": "152530",
            "n": "正蓝旗",
            "pc": "152500"
        }, {
            "c": "152531",
            "n": "多伦县",
            "pc": "152500"
        }, {
            "c": "152900",
            "n": "阿拉善盟",
            "pc": "150000"
        }, {
            "c": "152921",
            "n": "阿拉善左旗",
            "pc": "152900"
        }, {
            "c": "152922",
            "n": "阿拉善右旗",
            "pc": "152900"
        }, {
            "c": "152923",
            "n": "额济纳旗",
            "pc": "152900"
        }, {
            "c": "210000",
            "n": "辽宁省",
            "pc": "86"
        }, {
            "c": "210100",
            "n": "沈阳市",
            "pc": "210000"
        }, {
            "c": "210101",
            "n": "市辖区",
            "pc": "210100"
        }, {
            "c": "210102",
            "n": "和平区",
            "pc": "210100"
        }, {
            "c": "210103",
            "n": "沈河区",
            "pc": "210100"
        }, {
            "c": "210104",
            "n": "大东区",
            "pc": "210100"
        }, {
            "c": "210105",
            "n": "皇姑区",
            "pc": "210100"
        }, {
            "c": "210106",
            "n": "铁西区",
            "pc": "210100"
        }, {
            "c": "210111",
            "n": "苏家屯区",
            "pc": "210100"
        }, {
            "c": "210112",
            "n": "东陵区",
            "pc": "210100"
        }, {
            "c": "210113",
            "n": "沈北新区",
            "pc": "210100"
        }, {
            "c": "210114",
            "n": "于洪区",
            "pc": "210100"
        }, {
            "c": "210122",
            "n": "辽中县",
            "pc": "210100"
        }, {
            "c": "210123",
            "n": "康平县",
            "pc": "210100"
        }, {
            "c": "210124",
            "n": "法库县",
            "pc": "210100"
        }, {
            "c": "210181",
            "n": "新民市",
            "pc": "210100"
        }, {
            "c": "210200",
            "n": "大连市",
            "pc": "210000"
        }, {
            "c": "210201",
            "n": "市辖区",
            "pc": "210200"
        }, {
            "c": "210202",
            "n": "中山区",
            "pc": "210200"
        }, {
            "c": "210203",
            "n": "西岗区",
            "pc": "210200"
        }, {
            "c": "210204",
            "n": "沙河口区",
            "pc": "210200"
        }, {
            "c": "210211",
            "n": "甘井子区",
            "pc": "210200"
        }, {
            "c": "210212",
            "n": "旅顺口区",
            "pc": "210200"
        }, {
            "c": "210213",
            "n": "金州区",
            "pc": "210200"
        }, {
            "c": "210224",
            "n": "长海县",
            "pc": "210200"
        }, {
            "c": "210281",
            "n": "瓦房店市",
            "pc": "210200"
        }, {
            "c": "210282",
            "n": "普兰店市",
            "pc": "210200"
        }, {
            "c": "210283",
            "n": "庄河市",
            "pc": "210200"
        }, {
            "c": "210300",
            "n": "鞍山市",
            "pc": "210000"
        }, {
            "c": "210301",
            "n": "市辖区",
            "pc": "210300"
        }, {
            "c": "210302",
            "n": "铁东区",
            "pc": "210300"
        }, {
            "c": "210303",
            "n": "铁西区",
            "pc": "210300"
        }, {
            "c": "210304",
            "n": "立山区",
            "pc": "210300"
        }, {
            "c": "210311",
            "n": "千山区",
            "pc": "210300"
        }, {
            "c": "210321",
            "n": "台安县",
            "pc": "210300"
        }, {
            "c": "210323",
            "n": "岫岩满族自治县",
            "pc": "210300"
        }, {
            "c": "210381",
            "n": "海城市",
            "pc": "210300"
        }, {
            "c": "210400",
            "n": "抚顺市",
            "pc": "210000"
        }, {
            "c": "210401",
            "n": "市辖区",
            "pc": "210400"
        }, {
            "c": "210402",
            "n": "新抚区",
            "pc": "210400"
        }, {
            "c": "210403",
            "n": "东洲区",
            "pc": "210400"
        }, {
            "c": "210404",
            "n": "望花区",
            "pc": "210400"
        }, {
            "c": "210411",
            "n": "顺城区",
            "pc": "210400"
        }, {
            "c": "210421",
            "n": "抚顺县",
            "pc": "210400"
        }, {
            "c": "210422",
            "n": "新宾满族自治县",
            "pc": "210400"
        }, {
            "c": "210423",
            "n": "清原满族自治县",
            "pc": "210400"
        }, {
            "c": "210500",
            "n": "本溪市",
            "pc": "210000"
        }, {
            "c": "210501",
            "n": "市辖区",
            "pc": "210500"
        }, {
            "c": "210502",
            "n": "平山区",
            "pc": "210500"
        }, {
            "c": "210503",
            "n": "溪湖区",
            "pc": "210500"
        }, {
            "c": "210504",
            "n": "明山区",
            "pc": "210500"
        }, {
            "c": "210505",
            "n": "南芬区",
            "pc": "210500"
        }, {
            "c": "210521",
            "n": "本溪满族自治县",
            "pc": "210500"
        }, {
            "c": "210522",
            "n": "桓仁满族自治县",
            "pc": "210500"
        }, {
            "c": "210600",
            "n": "丹东市",
            "pc": "210000"
        }, {
            "c": "210601",
            "n": "市辖区",
            "pc": "210600"
        }, {
            "c": "210602",
            "n": "元宝区",
            "pc": "210600"
        }, {
            "c": "210603",
            "n": "振兴区",
            "pc": "210600"
        }, {
            "c": "210604",
            "n": "振安区",
            "pc": "210600"
        }, {
            "c": "210624",
            "n": "宽甸满族自治县",
            "pc": "210600"
        }, {
            "c": "210681",
            "n": "东港市",
            "pc": "210600"
        }, {
            "c": "210682",
            "n": "凤城市",
            "pc": "210600"
        }, {
            "c": "210700",
            "n": "锦州市",
            "pc": "210000"
        }, {
            "c": "210701",
            "n": "市辖区",
            "pc": "210700"
        }, {
            "c": "210702",
            "n": "古塔区",
            "pc": "210700"
        }, {
            "c": "210703",
            "n": "凌河区",
            "pc": "210700"
        }, {
            "c": "210711",
            "n": "太和区",
            "pc": "210700"
        }, {
            "c": "210726",
            "n": "黑山县",
            "pc": "210700"
        }, {
            "c": "210727",
            "n": "义县",
            "pc": "210700"
        }, {
            "c": "210781",
            "n": "凌海市",
            "pc": "210700"
        }, {
            "c": "210782",
            "n": "北镇市",
            "pc": "210700"
        }, {
            "c": "210800",
            "n": "营口市",
            "pc": "210000"
        }, {
            "c": "210801",
            "n": "市辖区",
            "pc": "210800"
        }, {
            "c": "210802",
            "n": "站前区",
            "pc": "210800"
        }, {
            "c": "210803",
            "n": "西市区",
            "pc": "210800"
        }, {
            "c": "210804",
            "n": "鲅鱼圈区",
            "pc": "210800"
        }, {
            "c": "210811",
            "n": "老边区",
            "pc": "210800"
        }, {
            "c": "210881",
            "n": "盖州市",
            "pc": "210800"
        }, {
            "c": "210882",
            "n": "大石桥市",
            "pc": "210800"
        }, {
            "c": "210900",
            "n": "阜新市",
            "pc": "210000"
        }, {
            "c": "210901",
            "n": "市辖区",
            "pc": "210900"
        }, {
            "c": "210902",
            "n": "海州区",
            "pc": "210900"
        }, {
            "c": "210903",
            "n": "新邱区",
            "pc": "210900"
        }, {
            "c": "210904",
            "n": "太平区",
            "pc": "210900"
        }, {
            "c": "210905",
            "n": "清河门区",
            "pc": "210900"
        }, {
            "c": "210911",
            "n": "细河区",
            "pc": "210900"
        }, {
            "c": "210921",
            "n": "阜新蒙古族自治县",
            "pc": "210900"
        }, {
            "c": "210922",
            "n": "彰武县",
            "pc": "210900"
        }, {
            "c": "211000",
            "n": "辽阳市",
            "pc": "210000"
        }, {
            "c": "211001",
            "n": "市辖区",
            "pc": "211000"
        }, {
            "c": "211002",
            "n": "白塔区",
            "pc": "211000"
        }, {
            "c": "211003",
            "n": "文圣区",
            "pc": "211000"
        }, {
            "c": "211004",
            "n": "宏伟区",
            "pc": "211000"
        }, {
            "c": "211005",
            "n": "弓长岭区",
            "pc": "211000"
        }, {
            "c": "211011",
            "n": "太子河区",
            "pc": "211000"
        }, {
            "c": "211021",
            "n": "辽阳县",
            "pc": "211000"
        }, {
            "c": "211081",
            "n": "灯塔市",
            "pc": "211000"
        }, {
            "c": "211100",
            "n": "盘锦市",
            "pc": "210000"
        }, {
            "c": "211101",
            "n": "市辖区",
            "pc": "211100"
        }, {
            "c": "211102",
            "n": "双台子区",
            "pc": "211100"
        }, {
            "c": "211103",
            "n": "兴隆台区",
            "pc": "211100"
        }, {
            "c": "211121",
            "n": "大洼县",
            "pc": "211100"
        }, {
            "c": "211122",
            "n": "盘山县",
            "pc": "211100"
        }, {
            "c": "211200",
            "n": "铁岭市",
            "pc": "210000"
        }, {
            "c": "211201",
            "n": "市辖区",
            "pc": "211200"
        }, {
            "c": "211202",
            "n": "银州区",
            "pc": "211200"
        }, {
            "c": "211204",
            "n": "清河区",
            "pc": "211200"
        }, {
            "c": "211221",
            "n": "铁岭县",
            "pc": "211200"
        }, {
            "c": "211223",
            "n": "西丰县",
            "pc": "211200"
        }, {
            "c": "211224",
            "n": "昌图县",
            "pc": "211200"
        }, {
            "c": "211281",
            "n": "调兵山市",
            "pc": "211200"
        }, {
            "c": "211282",
            "n": "开原市",
            "pc": "211200"
        }, {
            "c": "211300",
            "n": "朝阳市",
            "pc": "210000"
        }, {
            "c": "211301",
            "n": "市辖区",
            "pc": "211300"
        }, {
            "c": "211302",
            "n": "双塔区",
            "pc": "211300"
        }, {
            "c": "211303",
            "n": "龙城区",
            "pc": "211300"
        }, {
            "c": "211321",
            "n": "朝阳县",
            "pc": "211300"
        }, {
            "c": "211322",
            "n": "建平县",
            "pc": "211300"
        }, {
            "c": "211324",
            "n": "喀喇沁左翼蒙古族自治县",
            "pc": "211300"
        }, {
            "c": "211381",
            "n": "北票市",
            "pc": "211300"
        }, {
            "c": "211382",
            "n": "凌源市",
            "pc": "211300"
        }, {
            "c": "211400",
            "n": "葫芦岛市",
            "pc": "210000"
        }, {
            "c": "211401",
            "n": "市辖区",
            "pc": "211400"
        }, {
            "c": "211402",
            "n": "连山区",
            "pc": "211400"
        }, {
            "c": "211403",
            "n": "龙港区",
            "pc": "211400"
        }, {
            "c": "211404",
            "n": "南票区",
            "pc": "211400"
        }, {
            "c": "211421",
            "n": "绥中县",
            "pc": "211400"
        }, {
            "c": "211422",
            "n": "建昌县",
            "pc": "211400"
        }, {
            "c": "211481",
            "n": "兴城市",
            "pc": "211400"
        }, {
            "c": "220000",
            "n": "吉林省",
            "pc": "86"
        }, {
            "c": "220100",
            "n": "长春市",
            "pc": "220000"
        }, {
            "c": "220101",
            "n": "市辖区",
            "pc": "220100"
        }, {
            "c": "220102",
            "n": "南关区",
            "pc": "220100"
        }, {
            "c": "220103",
            "n": "宽城区",
            "pc": "220100"
        }, {
            "c": "220104",
            "n": "朝阳区",
            "pc": "220100"
        }, {
            "c": "220105",
            "n": "二道区",
            "pc": "220100"
        }, {
            "c": "220106",
            "n": "绿园区",
            "pc": "220100"
        }, {
            "c": "220112",
            "n": "双阳区",
            "pc": "220100"
        }, {
            "c": "220122",
            "n": "农安县",
            "pc": "220100"
        }, {
            "c": "220181",
            "n": "九台市",
            "pc": "220100"
        }, {
            "c": "220182",
            "n": "榆树市",
            "pc": "220100"
        }, {
            "c": "220183",
            "n": "德惠市",
            "pc": "220100"
        }, {
            "c": "220200",
            "n": "吉林市",
            "pc": "220000"
        }, {
            "c": "220201",
            "n": "市辖区",
            "pc": "220200"
        }, {
            "c": "220202",
            "n": "昌邑区",
            "pc": "220200"
        }, {
            "c": "220203",
            "n": "龙潭区",
            "pc": "220200"
        }, {
            "c": "220204",
            "n": "船营区",
            "pc": "220200"
        }, {
            "c": "220211",
            "n": "丰满区",
            "pc": "220200"
        }, {
            "c": "220221",
            "n": "永吉县",
            "pc": "220200"
        }, {
            "c": "220281",
            "n": "蛟河市",
            "pc": "220200"
        }, {
            "c": "220282",
            "n": "桦甸市",
            "pc": "220200"
        }, {
            "c": "220283",
            "n": "舒兰市",
            "pc": "220200"
        }, {
            "c": "220284",
            "n": "磐石市",
            "pc": "220200"
        }, {
            "c": "220300",
            "n": "四平市",
            "pc": "220000"
        }, {
            "c": "220301",
            "n": "市辖区",
            "pc": "220300"
        }, {
            "c": "220302",
            "n": "铁西区",
            "pc": "220300"
        }, {
            "c": "220303",
            "n": "铁东区",
            "pc": "220300"
        }, {
            "c": "220322",
            "n": "梨树县",
            "pc": "220300"
        }, {
            "c": "220323",
            "n": "伊通满族自治县",
            "pc": "220300"
        }, {
            "c": "220381",
            "n": "公主岭市",
            "pc": "220300"
        }, {
            "c": "220382",
            "n": "双辽市",
            "pc": "220300"
        }, {
            "c": "220400",
            "n": "辽源市",
            "pc": "220000"
        }, {
            "c": "220401",
            "n": "市辖区",
            "pc": "220400"
        }, {
            "c": "220402",
            "n": "龙山区",
            "pc": "220400"
        }, {
            "c": "220403",
            "n": "西安区",
            "pc": "220400"
        }, {
            "c": "220421",
            "n": "东丰县",
            "pc": "220400"
        }, {
            "c": "220422",
            "n": "东辽县",
            "pc": "220400"
        }, {
            "c": "220500",
            "n": "通化市",
            "pc": "220000"
        }, {
            "c": "220501",
            "n": "市辖区",
            "pc": "220500"
        }, {
            "c": "220502",
            "n": "东昌区",
            "pc": "220500"
        }, {
            "c": "220503",
            "n": "二道江区",
            "pc": "220500"
        }, {
            "c": "220521",
            "n": "通化县",
            "pc": "220500"
        }, {
            "c": "220523",
            "n": "辉南县",
            "pc": "220500"
        }, {
            "c": "220524",
            "n": "柳河县",
            "pc": "220500"
        }, {
            "c": "220581",
            "n": "梅河口市",
            "pc": "220500"
        }, {
            "c": "220582",
            "n": "集安市",
            "pc": "220500"
        }, {
            "c": "220600",
            "n": "白山市",
            "pc": "220000"
        }, {
            "c": "220601",
            "n": "市辖区",
            "pc": "220600"
        }, {
            "c": "220602",
            "n": "浑江区",
            "pc": "220600"
        }, {
            "c": "220605",
            "n": "江源区",
            "pc": "220600"
        }, {
            "c": "220621",
            "n": "抚松县",
            "pc": "220600"
        }, {
            "c": "220622",
            "n": "靖宇县",
            "pc": "220600"
        }, {
            "c": "220623",
            "n": "长白朝鲜族自治县",
            "pc": "220600"
        }, {
            "c": "220681",
            "n": "临江市",
            "pc": "220600"
        }, {
            "c": "220700",
            "n": "松原市",
            "pc": "220000"
        }, {
            "c": "220701",
            "n": "市辖区",
            "pc": "220700"
        }, {
            "c": "220702",
            "n": "宁江区",
            "pc": "220700"
        }, {
            "c": "220721",
            "n": "前郭尔罗斯蒙古族自治县",
            "pc": "220700"
        }, {
            "c": "220722",
            "n": "长岭县",
            "pc": "220700"
        }, {
            "c": "220723",
            "n": "乾安县",
            "pc": "220700"
        }, {
            "c": "220724",
            "n": "扶余县",
            "pc": "220700"
        }, {
            "c": "220800",
            "n": "白城市",
            "pc": "220000"
        }, {
            "c": "220801",
            "n": "市辖区",
            "pc": "220800"
        }, {
            "c": "220802",
            "n": "洮北区",
            "pc": "220800"
        }, {
            "c": "220821",
            "n": "镇赉县",
            "pc": "220800"
        }, {
            "c": "220822",
            "n": "通榆县",
            "pc": "220800"
        }, {
            "c": "220881",
            "n": "洮南市",
            "pc": "220800"
        }, {
            "c": "220882",
            "n": "大安市",
            "pc": "220800"
        }, {
            "c": "222400",
            "n": "延边朝鲜族自治州",
            "pc": "220000"
        }, {
            "c": "222401",
            "n": "延吉市",
            "pc": "222400"
        }, {
            "c": "222402",
            "n": "图们市",
            "pc": "222400"
        }, {
            "c": "222403",
            "n": "敦化市",
            "pc": "222400"
        }, {
            "c": "222404",
            "n": "珲春市",
            "pc": "222400"
        }, {
            "c": "222405",
            "n": "龙井市",
            "pc": "222400"
        }, {
            "c": "222406",
            "n": "和龙市",
            "pc": "222400"
        }, {
            "c": "222424",
            "n": "汪清县",
            "pc": "222400"
        }, {
            "c": "222426",
            "n": "安图县",
            "pc": "222400"
        }, {
            "c": "230000",
            "n": "黑龙江省",
            "pc": "86"
        }, {
            "c": "230100",
            "n": "哈尔滨市",
            "pc": "230000"
        }, {
            "c": "230101",
            "n": "市辖区",
            "pc": "230100"
        }, {
            "c": "230102",
            "n": "道里区",
            "pc": "230100"
        }, {
            "c": "230103",
            "n": "南岗区",
            "pc": "230100"
        }, {
            "c": "230104",
            "n": "道外区",
            "pc": "230100"
        }, {
            "c": "230108",
            "n": "平房区",
            "pc": "230100"
        }, {
            "c": "230109",
            "n": "松北区",
            "pc": "230100"
        }, {
            "c": "230110",
            "n": "香坊区",
            "pc": "230100"
        }, {
            "c": "230111",
            "n": "呼兰区",
            "pc": "230100"
        }, {
            "c": "230112",
            "n": "阿城区",
            "pc": "230100"
        }, {
            "c": "230123",
            "n": "依兰县",
            "pc": "230100"
        }, {
            "c": "230124",
            "n": "方正县",
            "pc": "230100"
        }, {
            "c": "230125",
            "n": "宾县",
            "pc": "230100"
        }, {
            "c": "230126",
            "n": "巴彦县",
            "pc": "230100"
        }, {
            "c": "230127",
            "n": "木兰县",
            "pc": "230100"
        }, {
            "c": "230128",
            "n": "通河县",
            "pc": "230100"
        }, {
            "c": "230129",
            "n": "延寿县",
            "pc": "230100"
        }, {
            "c": "230182",
            "n": "双城市",
            "pc": "230100"
        }, {
            "c": "230183",
            "n": "尚志市",
            "pc": "230100"
        }, {
            "c": "230184",
            "n": "五常市",
            "pc": "230100"
        }, {
            "c": "230200",
            "n": "齐齐哈尔市",
            "pc": "230000"
        }, {
            "c": "230201",
            "n": "市辖区",
            "pc": "230200"
        }, {
            "c": "230202",
            "n": "龙沙区",
            "pc": "230200"
        }, {
            "c": "230203",
            "n": "建华区",
            "pc": "230200"
        }, {
            "c": "230204",
            "n": "铁锋区",
            "pc": "230200"
        }, {
            "c": "230205",
            "n": "昂昂溪区",
            "pc": "230200"
        }, {
            "c": "230206",
            "n": "富拉尔基区",
            "pc": "230200"
        }, {
            "c": "230207",
            "n": "碾子山区",
            "pc": "230200"
        }, {
            "c": "230208",
            "n": "梅里斯达斡尔族区",
            "pc": "230200"
        }, {
            "c": "230221",
            "n": "龙江县",
            "pc": "230200"
        }, {
            "c": "230223",
            "n": "依安县",
            "pc": "230200"
        }, {
            "c": "230224",
            "n": "泰来县",
            "pc": "230200"
        }, {
            "c": "230225",
            "n": "甘南县",
            "pc": "230200"
        }, {
            "c": "230227",
            "n": "富裕县",
            "pc": "230200"
        }, {
            "c": "230229",
            "n": "克山县",
            "pc": "230200"
        }, {
            "c": "230230",
            "n": "克东县",
            "pc": "230200"
        }, {
            "c": "230231",
            "n": "拜泉县",
            "pc": "230200"
        }, {
            "c": "230281",
            "n": "讷河市",
            "pc": "230200"
        }, {
            "c": "230300",
            "n": "鸡西市",
            "pc": "230000"
        }, {
            "c": "230301",
            "n": "市辖区",
            "pc": "230300"
        }, {
            "c": "230302",
            "n": "鸡冠区",
            "pc": "230300"
        }, {
            "c": "230303",
            "n": "恒山区",
            "pc": "230300"
        }, {
            "c": "230304",
            "n": "滴道区",
            "pc": "230300"
        }, {
            "c": "230305",
            "n": "梨树区",
            "pc": "230300"
        }, {
            "c": "230306",
            "n": "城子河区",
            "pc": "230300"
        }, {
            "c": "230307",
            "n": "麻山区",
            "pc": "230300"
        }, {
            "c": "230321",
            "n": "鸡东县",
            "pc": "230300"
        }, {
            "c": "230381",
            "n": "虎林市",
            "pc": "230300"
        }, {
            "c": "230382",
            "n": "密山市",
            "pc": "230300"
        }, {
            "c": "230400",
            "n": "鹤岗市",
            "pc": "230000"
        }, {
            "c": "230401",
            "n": "市辖区",
            "pc": "230400"
        }, {
            "c": "230402",
            "n": "向阳区",
            "pc": "230400"
        }, {
            "c": "230403",
            "n": "工农区",
            "pc": "230400"
        }, {
            "c": "230404",
            "n": "南山区",
            "pc": "230400"
        }, {
            "c": "230405",
            "n": "兴安区",
            "pc": "230400"
        }, {
            "c": "230406",
            "n": "东山区",
            "pc": "230400"
        }, {
            "c": "230407",
            "n": "兴山区",
            "pc": "230400"
        }, {
            "c": "230421",
            "n": "萝北县",
            "pc": "230400"
        }, {
            "c": "230422",
            "n": "绥滨县",
            "pc": "230400"
        }, {
            "c": "230500",
            "n": "双鸭山市",
            "pc": "230000"
        }, {
            "c": "230501",
            "n": "市辖区",
            "pc": "230500"
        }, {
            "c": "230502",
            "n": "尖山区",
            "pc": "230500"
        }, {
            "c": "230503",
            "n": "岭东区",
            "pc": "230500"
        }, {
            "c": "230505",
            "n": "四方台区",
            "pc": "230500"
        }, {
            "c": "230506",
            "n": "宝山区",
            "pc": "230500"
        }, {
            "c": "230521",
            "n": "集贤县",
            "pc": "230500"
        }, {
            "c": "230522",
            "n": "友谊县",
            "pc": "230500"
        }, {
            "c": "230523",
            "n": "宝清县",
            "pc": "230500"
        }, {
            "c": "230524",
            "n": "饶河县",
            "pc": "230500"
        }, {
            "c": "230600",
            "n": "大庆市",
            "pc": "230000"
        }, {
            "c": "230601",
            "n": "市辖区",
            "pc": "230600"
        }, {
            "c": "230602",
            "n": "萨尔图区",
            "pc": "230600"
        }, {
            "c": "230603",
            "n": "龙凤区",
            "pc": "230600"
        }, {
            "c": "230604",
            "n": "让胡路区",
            "pc": "230600"
        }, {
            "c": "230605",
            "n": "红岗区",
            "pc": "230600"
        }, {
            "c": "230606",
            "n": "大同区",
            "pc": "230600"
        }, {
            "c": "230621",
            "n": "肇州县",
            "pc": "230600"
        }, {
            "c": "230622",
            "n": "肇源县",
            "pc": "230600"
        }, {
            "c": "230623",
            "n": "林甸县",
            "pc": "230600"
        }, {
            "c": "230624",
            "n": "杜尔伯特蒙古族自治县",
            "pc": "230600"
        }, {
            "c": "230700",
            "n": "伊春市",
            "pc": "230000"
        }, {
            "c": "230701",
            "n": "市辖区",
            "pc": "230700"
        }, {
            "c": "230702",
            "n": "伊春区",
            "pc": "230700"
        }, {
            "c": "230703",
            "n": "南岔区",
            "pc": "230700"
        }, {
            "c": "230704",
            "n": "友好区",
            "pc": "230700"
        }, {
            "c": "230705",
            "n": "西林区",
            "pc": "230700"
        }, {
            "c": "230706",
            "n": "翠峦区",
            "pc": "230700"
        }, {
            "c": "230707",
            "n": "新青区",
            "pc": "230700"
        }, {
            "c": "230708",
            "n": "美溪区",
            "pc": "230700"
        }, {
            "c": "230709",
            "n": "金山屯区",
            "pc": "230700"
        }, {
            "c": "230710",
            "n": "五营区",
            "pc": "230700"
        }, {
            "c": "230711",
            "n": "乌马河区",
            "pc": "230700"
        }, {
            "c": "230712",
            "n": "汤旺河区",
            "pc": "230700"
        }, {
            "c": "230713",
            "n": "带岭区",
            "pc": "230700"
        }, {
            "c": "230714",
            "n": "乌伊岭区",
            "pc": "230700"
        }, {
            "c": "230715",
            "n": "红星区",
            "pc": "230700"
        }, {
            "c": "230716",
            "n": "上甘岭区",
            "pc": "230700"
        }, {
            "c": "230722",
            "n": "嘉荫县",
            "pc": "230700"
        }, {
            "c": "230781",
            "n": "铁力市",
            "pc": "230700"
        }, {
            "c": "230800",
            "n": "佳木斯市",
            "pc": "230000"
        }, {
            "c": "230801",
            "n": "市辖区",
            "pc": "230800"
        }, {
            "c": "230803",
            "n": "向阳区",
            "pc": "230800"
        }, {
            "c": "230804",
            "n": "前进区",
            "pc": "230800"
        }, {
            "c": "230805",
            "n": "东风区",
            "pc": "230800"
        }, {
            "c": "230811",
            "n": "郊区",
            "pc": "230800"
        }, {
            "c": "230822",
            "n": "桦南县",
            "pc": "230800"
        }, {
            "c": "230826",
            "n": "桦川县",
            "pc": "230800"
        }, {
            "c": "230828",
            "n": "汤原县",
            "pc": "230800"
        }, {
            "c": "230833",
            "n": "抚远县",
            "pc": "230800"
        }, {
            "c": "230881",
            "n": "同江市",
            "pc": "230800"
        }, {
            "c": "230882",
            "n": "富锦市",
            "pc": "230800"
        }, {
            "c": "230900",
            "n": "七台河市",
            "pc": "230000"
        }, {
            "c": "230901",
            "n": "市辖区",
            "pc": "230900"
        }, {
            "c": "230902",
            "n": "新兴区",
            "pc": "230900"
        }, {
            "c": "230903",
            "n": "桃山区",
            "pc": "230900"
        }, {
            "c": "230904",
            "n": "茄子河区",
            "pc": "230900"
        }, {
            "c": "230921",
            "n": "勃利县",
            "pc": "230900"
        }, {
            "c": "231000",
            "n": "牡丹江市",
            "pc": "230000"
        }, {
            "c": "231001",
            "n": "市辖区",
            "pc": "231000"
        }, {
            "c": "231002",
            "n": "东安区",
            "pc": "231000"
        }, {
            "c": "231003",
            "n": "阳明区",
            "pc": "231000"
        }, {
            "c": "231004",
            "n": "爱民区",
            "pc": "231000"
        }, {
            "c": "231005",
            "n": "西安区",
            "pc": "231000"
        }, {
            "c": "231024",
            "n": "东宁县",
            "pc": "231000"
        }, {
            "c": "231025",
            "n": "林口县",
            "pc": "231000"
        }, {
            "c": "231081",
            "n": "绥芬河市",
            "pc": "231000"
        }, {
            "c": "231083",
            "n": "海林市",
            "pc": "231000"
        }, {
            "c": "231084",
            "n": "宁安市",
            "pc": "231000"
        }, {
            "c": "231085",
            "n": "穆棱市",
            "pc": "231000"
        }, {
            "c": "231100",
            "n": "黑河市",
            "pc": "230000"
        }, {
            "c": "231101",
            "n": "市辖区",
            "pc": "231100"
        }, {
            "c": "231102",
            "n": "爱辉区",
            "pc": "231100"
        }, {
            "c": "231121",
            "n": "嫩江县",
            "pc": "231100"
        }, {
            "c": "231123",
            "n": "逊克县",
            "pc": "231100"
        }, {
            "c": "231124",
            "n": "孙吴县",
            "pc": "231100"
        }, {
            "c": "231181",
            "n": "北安市",
            "pc": "231100"
        }, {
            "c": "231182",
            "n": "五大连池市",
            "pc": "231100"
        }, {
            "c": "231200",
            "n": "绥化市",
            "pc": "230000"
        }, {
            "c": "231201",
            "n": "市辖区",
            "pc": "231200"
        }, {
            "c": "231202",
            "n": "北林区",
            "pc": "231200"
        }, {
            "c": "231221",
            "n": "望奎县",
            "pc": "231200"
        }, {
            "c": "231222",
            "n": "兰西县",
            "pc": "231200"
        }, {
            "c": "231223",
            "n": "青冈县",
            "pc": "231200"
        }, {
            "c": "231224",
            "n": "庆安县",
            "pc": "231200"
        }, {
            "c": "231225",
            "n": "明水县",
            "pc": "231200"
        }, {
            "c": "231226",
            "n": "绥棱县",
            "pc": "231200"
        }, {
            "c": "231281",
            "n": "安达市",
            "pc": "231200"
        }, {
            "c": "231282",
            "n": "肇东市",
            "pc": "231200"
        }, {
            "c": "231283",
            "n": "海伦市",
            "pc": "231200"
        }, {
            "c": "232700",
            "n": "大兴安岭地区",
            "pc": "230000"
        }, {
            "c": "232721",
            "n": "呼玛县",
            "pc": "232700"
        }, {
            "c": "232722",
            "n": "塔河县",
            "pc": "232700"
        }, {
            "c": "232723",
            "n": "漠河县",
            "pc": "232700"
        }, {
            "c": "310000",
            "n": "上海市",
            "pc": "86"
        }, {
            "c": "310100",
            "n": "上海市",
            "pc": "310000"
        }, {
            "c": "310101",
            "n": "黄浦区",
            "pc": "310100"
        }, {
            "c": "310104",
            "n": "徐汇区",
            "pc": "310100"
        }, {
            "c": "310105",
            "n": "长宁区",
            "pc": "310100"
        }, {
            "c": "310106",
            "n": "静安区",
            "pc": "310100"
        }, {
            "c": "310107",
            "n": "普陀区",
            "pc": "310100"
        }, {
            "c": "310108",
            "n": "闸北区",
            "pc": "310100"
        }, {
            "c": "310109",
            "n": "虹口区",
            "pc": "310100"
        }, {
            "c": "310110",
            "n": "杨浦区",
            "pc": "310100"
        }, {
            "c": "310112",
            "n": "闵行区",
            "pc": "310100"
        }, {
            "c": "310113",
            "n": "宝山区",
            "pc": "310100"
        }, {
            "c": "310114",
            "n": "嘉定区",
            "pc": "310100"
        }, {
            "c": "310115",
            "n": "浦东新区",
            "pc": "310100"
        }, {
            "c": "310116",
            "n": "金山区",
            "pc": "310100"
        }, {
            "c": "310117",
            "n": "松江区",
            "pc": "310100"
        }, {
            "c": "310118",
            "n": "青浦区",
            "pc": "310100"
        }, {
            "c": "310120",
            "n": "奉贤区",
            "pc": "310100"
        }, {
            "c": "310230",
            "n": "崇明县",
            "pc": "310100"
        }, {
            "c": "320000",
            "n": "江苏省",
            "pc": "86"
        }, {
            "c": "320100",
            "n": "南京市",
            "pc": "320000"
        }, {
            "c": "320101",
            "n": "市辖区",
            "pc": "320100"
        }, {
            "c": "320102",
            "n": "玄武区",
            "pc": "320100"
        }, {
            "c": "320103",
            "n": "白下区",
            "pc": "320100"
        }, {
            "c": "320104",
            "n": "秦淮区",
            "pc": "320100"
        }, {
            "c": "320105",
            "n": "建邺区",
            "pc": "320100"
        }, {
            "c": "320106",
            "n": "鼓楼区",
            "pc": "320100"
        }, {
            "c": "320107",
            "n": "下关区",
            "pc": "320100"
        }, {
            "c": "320111",
            "n": "浦口区",
            "pc": "320100"
        }, {
            "c": "320113",
            "n": "栖霞区",
            "pc": "320100"
        }, {
            "c": "320114",
            "n": "雨花台区",
            "pc": "320100"
        }, {
            "c": "320115",
            "n": "江宁区",
            "pc": "320100"
        }, {
            "c": "320116",
            "n": "六合区",
            "pc": "320100"
        }, {
            "c": "320124",
            "n": "溧水县",
            "pc": "320100"
        }, {
            "c": "320125",
            "n": "高淳县",
            "pc": "320100"
        }, {
            "c": "320200",
            "n": "无锡市",
            "pc": "320000"
        }, {
            "c": "320201",
            "n": "市辖区",
            "pc": "320200"
        }, {
            "c": "320202",
            "n": "崇安区",
            "pc": "320200"
        }, {
            "c": "320203",
            "n": "南长区",
            "pc": "320200"
        }, {
            "c": "320204",
            "n": "北塘区",
            "pc": "320200"
        }, {
            "c": "320205",
            "n": "锡山区",
            "pc": "320200"
        }, {
            "c": "320206",
            "n": "惠山区",
            "pc": "320200"
        }, {
            "c": "320211",
            "n": "滨湖区",
            "pc": "320200"
        }, {
            "c": "320281",
            "n": "江阴市",
            "pc": "320200"
        }, {
            "c": "320282",
            "n": "宜兴市",
            "pc": "320200"
        }, {
            "c": "320300",
            "n": "徐州市",
            "pc": "320000"
        }, {
            "c": "320301",
            "n": "市辖区",
            "pc": "320300"
        }, {
            "c": "320302",
            "n": "鼓楼区",
            "pc": "320300"
        }, {
            "c": "320303",
            "n": "云龙区",
            "pc": "320300"
        }, {
            "c": "320305",
            "n": "贾汪区",
            "pc": "320300"
        }, {
            "c": "320311",
            "n": "泉山区",
            "pc": "320300"
        }, {
            "c": "320312",
            "n": "铜山区",
            "pc": "320300"
        }, {
            "c": "320321",
            "n": "丰县",
            "pc": "320300"
        }, {
            "c": "320322",
            "n": "沛县",
            "pc": "320300"
        }, {
            "c": "320324",
            "n": "睢宁县",
            "pc": "320300"
        }, {
            "c": "320381",
            "n": "新沂市",
            "pc": "320300"
        }, {
            "c": "320382",
            "n": "邳州市",
            "pc": "320300"
        }, {
            "c": "320400",
            "n": "常州市",
            "pc": "320000"
        }, {
            "c": "320401",
            "n": "市辖区",
            "pc": "320400"
        }, {
            "c": "320402",
            "n": "天宁区",
            "pc": "320400"
        }, {
            "c": "320404",
            "n": "钟楼区",
            "pc": "320400"
        }, {
            "c": "320405",
            "n": "戚墅堰区",
            "pc": "320400"
        }, {
            "c": "320411",
            "n": "新北区",
            "pc": "320400"
        }, {
            "c": "320412",
            "n": "武进区",
            "pc": "320400"
        }, {
            "c": "320481",
            "n": "溧阳市",
            "pc": "320400"
        }, {
            "c": "320482",
            "n": "金坛市",
            "pc": "320400"
        }, {
            "c": "320500",
            "n": "苏州市",
            "pc": "320000"
        }, {
            "c": "320501",
            "n": "市辖区",
            "pc": "320500"
        }, {
            "c": "320505",
            "n": "虎丘区",
            "pc": "320500"
        }, {
            "c": "320506",
            "n": "吴中区",
            "pc": "320500"
        }, {
            "c": "320507",
            "n": "相城区",
            "pc": "320500"
        }, {
            "c": "320508",
            "n": "姑苏区",
            "pc": "320500"
        }, {
            "c": "320509",
            "n": "吴江区",
            "pc": "320500"
        }, {
            "c": "320581",
            "n": "常熟市",
            "pc": "320500"
        }, {
            "c": "320582",
            "n": "张家港市",
            "pc": "320500"
        }, {
            "c": "320583",
            "n": "昆山市",
            "pc": "320500"
        }, {
            "c": "320585",
            "n": "太仓市",
            "pc": "320500"
        }, {
            "c": "320600",
            "n": "南通市",
            "pc": "320000"
        }, {
            "c": "320601",
            "n": "市辖区",
            "pc": "320600"
        }, {
            "c": "320602",
            "n": "崇川区",
            "pc": "320600"
        }, {
            "c": "320611",
            "n": "港闸区",
            "pc": "320600"
        }, {
            "c": "320612",
            "n": "通州区",
            "pc": "320600"
        }, {
            "c": "320621",
            "n": "海安县",
            "pc": "320600"
        }, {
            "c": "320623",
            "n": "如东县",
            "pc": "320600"
        }, {
            "c": "320681",
            "n": "启东市",
            "pc": "320600"
        }, {
            "c": "320682",
            "n": "如皋市",
            "pc": "320600"
        }, {
            "c": "320684",
            "n": "海门市",
            "pc": "320600"
        }, {
            "c": "320700",
            "n": "连云港市",
            "pc": "320000"
        }, {
            "c": "320701",
            "n": "市辖区",
            "pc": "320700"
        }, {
            "c": "320703",
            "n": "连云区",
            "pc": "320700"
        }, {
            "c": "320705",
            "n": "新浦区",
            "pc": "320700"
        }, {
            "c": "320706",
            "n": "海州区",
            "pc": "320700"
        }, {
            "c": "320721",
            "n": "赣榆县",
            "pc": "320700"
        }, {
            "c": "320722",
            "n": "东海县",
            "pc": "320700"
        }, {
            "c": "320723",
            "n": "灌云县",
            "pc": "320700"
        }, {
            "c": "320724",
            "n": "灌南县",
            "pc": "320700"
        }, {
            "c": "320800",
            "n": "淮安市",
            "pc": "320000"
        }, {
            "c": "320801",
            "n": "市辖区",
            "pc": "320800"
        }, {
            "c": "320802",
            "n": "清河区",
            "pc": "320800"
        }, {
            "c": "320803",
            "n": "淮安区",
            "pc": "320800"
        }, {
            "c": "320804",
            "n": "淮阴区",
            "pc": "320800"
        }, {
            "c": "320811",
            "n": "清浦区",
            "pc": "320800"
        }, {
            "c": "320826",
            "n": "涟水县",
            "pc": "320800"
        }, {
            "c": "320829",
            "n": "洪泽县",
            "pc": "320800"
        }, {
            "c": "320830",
            "n": "盱眙县",
            "pc": "320800"
        }, {
            "c": "320831",
            "n": "金湖县",
            "pc": "320800"
        }, {
            "c": "320900",
            "n": "盐城市",
            "pc": "320000"
        }, {
            "c": "320901",
            "n": "市辖区",
            "pc": "320900"
        }, {
            "c": "320902",
            "n": "亭湖区",
            "pc": "320900"
        }, {
            "c": "320903",
            "n": "盐都区",
            "pc": "320900"
        }, {
            "c": "320921",
            "n": "响水县",
            "pc": "320900"
        }, {
            "c": "320922",
            "n": "滨海县",
            "pc": "320900"
        }, {
            "c": "320923",
            "n": "阜宁县",
            "pc": "320900"
        }, {
            "c": "320924",
            "n": "射阳县",
            "pc": "320900"
        }, {
            "c": "320925",
            "n": "建湖县",
            "pc": "320900"
        }, {
            "c": "320981",
            "n": "东台市",
            "pc": "320900"
        }, {
            "c": "320982",
            "n": "大丰市",
            "pc": "320900"
        }, {
            "c": "321000",
            "n": "扬州市",
            "pc": "320000"
        }, {
            "c": "321001",
            "n": "市辖区",
            "pc": "321000"
        }, {
            "c": "321002",
            "n": "广陵区",
            "pc": "321000"
        }, {
            "c": "321003",
            "n": "邗江区",
            "pc": "321000"
        }, {
            "c": "321012",
            "n": "江都区",
            "pc": "321000"
        }, {
            "c": "321023",
            "n": "宝应县",
            "pc": "321000"
        }, {
            "c": "321081",
            "n": "仪征市",
            "pc": "321000"
        }, {
            "c": "321084",
            "n": "高邮市",
            "pc": "321000"
        }, {
            "c": "321100",
            "n": "镇江市",
            "pc": "320000"
        }, {
            "c": "321101",
            "n": "市辖区",
            "pc": "321100"
        }, {
            "c": "321102",
            "n": "京口区",
            "pc": "321100"
        }, {
            "c": "321111",
            "n": "润州区",
            "pc": "321100"
        }, {
            "c": "321112",
            "n": "丹徒区",
            "pc": "321100"
        }, {
            "c": "321181",
            "n": "丹阳市",
            "pc": "321100"
        }, {
            "c": "321182",
            "n": "扬中市",
            "pc": "321100"
        }, {
            "c": "321183",
            "n": "句容市",
            "pc": "321100"
        }, {
            "c": "321200",
            "n": "泰州市",
            "pc": "320000"
        }, {
            "c": "321201",
            "n": "市辖区",
            "pc": "321200"
        }, {
            "c": "321202",
            "n": "海陵区",
            "pc": "321200"
        }, {
            "c": "321203",
            "n": "高港区",
            "pc": "321200"
        }, {
            "c": "321281",
            "n": "兴化市",
            "pc": "321200"
        }, {
            "c": "321282",
            "n": "靖江市",
            "pc": "321200"
        }, {
            "c": "321283",
            "n": "泰兴市",
            "pc": "321200"
        }, {
            "c": "321284",
            "n": "姜堰市",
            "pc": "321200"
        }, {
            "c": "321300",
            "n": "宿迁市",
            "pc": "320000"
        }, {
            "c": "321301",
            "n": "市辖区",
            "pc": "321300"
        }, {
            "c": "321302",
            "n": "宿城区",
            "pc": "321300"
        }, {
            "c": "321311",
            "n": "宿豫区",
            "pc": "321300"
        }, {
            "c": "321322",
            "n": "沭阳县",
            "pc": "321300"
        }, {
            "c": "321323",
            "n": "泗阳县",
            "pc": "321300"
        }, {
            "c": "321324",
            "n": "泗洪县",
            "pc": "321300"
        }, {
            "c": "330000",
            "n": "浙江省",
            "pc": "86"
        }, {
            "c": "330100",
            "n": "杭州市",
            "pc": "330000"
        }, {
            "c": "330101",
            "n": "市辖区",
            "pc": "330100"
        }, {
            "c": "330102",
            "n": "上城区",
            "pc": "330100"
        }, {
            "c": "330103",
            "n": "下城区",
            "pc": "330100"
        }, {
            "c": "330104",
            "n": "江干区",
            "pc": "330100"
        }, {
            "c": "330105",
            "n": "拱墅区",
            "pc": "330100"
        }, {
            "c": "330106",
            "n": "西湖区",
            "pc": "330100"
        }, {
            "c": "330108",
            "n": "滨江区",
            "pc": "330100"
        }, {
            "c": "330109",
            "n": "萧山区",
            "pc": "330100"
        }, {
            "c": "330110",
            "n": "余杭区",
            "pc": "330100"
        }, {
            "c": "330122",
            "n": "桐庐县",
            "pc": "330100"
        }, {
            "c": "330127",
            "n": "淳安县",
            "pc": "330100"
        }, {
            "c": "330182",
            "n": "建德市",
            "pc": "330100"
        }, {
            "c": "330183",
            "n": "富阳市",
            "pc": "330100"
        }, {
            "c": "330185",
            "n": "临安市",
            "pc": "330100"
        }, {
            "c": "330200",
            "n": "宁波市",
            "pc": "330000"
        }, {
            "c": "330201",
            "n": "市辖区",
            "pc": "330200"
        }, {
            "c": "330203",
            "n": "海曙区",
            "pc": "330200"
        }, {
            "c": "330204",
            "n": "江东区",
            "pc": "330200"
        }, {
            "c": "330205",
            "n": "江北区",
            "pc": "330200"
        }, {
            "c": "330206",
            "n": "北仑区",
            "pc": "330200"
        }, {
            "c": "330211",
            "n": "镇海区",
            "pc": "330200"
        }, {
            "c": "330212",
            "n": "鄞州区",
            "pc": "330200"
        }, {
            "c": "330225",
            "n": "象山县",
            "pc": "330200"
        }, {
            "c": "330226",
            "n": "宁海县",
            "pc": "330200"
        }, {
            "c": "330281",
            "n": "余姚市",
            "pc": "330200"
        }, {
            "c": "330282",
            "n": "慈溪市",
            "pc": "330200"
        }, {
            "c": "330283",
            "n": "奉化市",
            "pc": "330200"
        }, {
            "c": "330300",
            "n": "温州市",
            "pc": "330000"
        }, {
            "c": "330301",
            "n": "市辖区",
            "pc": "330300"
        }, {
            "c": "330302",
            "n": "鹿城区",
            "pc": "330300"
        }, {
            "c": "330303",
            "n": "龙湾区",
            "pc": "330300"
        }, {
            "c": "330304",
            "n": "瓯海区",
            "pc": "330300"
        }, {
            "c": "330322",
            "n": "洞头县",
            "pc": "330300"
        }, {
            "c": "330324",
            "n": "永嘉县",
            "pc": "330300"
        }, {
            "c": "330326",
            "n": "平阳县",
            "pc": "330300"
        }, {
            "c": "330327",
            "n": "苍南县",
            "pc": "330300"
        }, {
            "c": "330328",
            "n": "文成县",
            "pc": "330300"
        }, {
            "c": "330329",
            "n": "泰顺县",
            "pc": "330300"
        }, {
            "c": "330381",
            "n": "瑞安市",
            "pc": "330300"
        }, {
            "c": "330382",
            "n": "乐清市",
            "pc": "330300"
        }, {
            "c": "330400",
            "n": "嘉兴市",
            "pc": "330000"
        }, {
            "c": "330401",
            "n": "市辖区",
            "pc": "330400"
        }, {
            "c": "330402",
            "n": "南湖区",
            "pc": "330400"
        }, {
            "c": "330411",
            "n": "秀洲区",
            "pc": "330400"
        }, {
            "c": "330421",
            "n": "嘉善县",
            "pc": "330400"
        }, {
            "c": "330424",
            "n": "海盐县",
            "pc": "330400"
        }, {
            "c": "330481",
            "n": "海宁市",
            "pc": "330400"
        }, {
            "c": "330482",
            "n": "平湖市",
            "pc": "330400"
        }, {
            "c": "330483",
            "n": "桐乡市",
            "pc": "330400"
        }, {
            "c": "330500",
            "n": "湖州市",
            "pc": "330000"
        }, {
            "c": "330501",
            "n": "市辖区",
            "pc": "330500"
        }, {
            "c": "330502",
            "n": "吴兴区",
            "pc": "330500"
        }, {
            "c": "330503",
            "n": "南浔区",
            "pc": "330500"
        }, {
            "c": "330521",
            "n": "德清县",
            "pc": "330500"
        }, {
            "c": "330522",
            "n": "长兴县",
            "pc": "330500"
        }, {
            "c": "330523",
            "n": "安吉县",
            "pc": "330500"
        }, {
            "c": "330600",
            "n": "绍兴市",
            "pc": "330000"
        }, {
            "c": "330601",
            "n": "市辖区",
            "pc": "330600"
        }, {
            "c": "330602",
            "n": "越城区",
            "pc": "330600"
        }, {
            "c": "330621",
            "n": "绍兴县",
            "pc": "330600"
        }, {
            "c": "330624",
            "n": "新昌县",
            "pc": "330600"
        }, {
            "c": "330681",
            "n": "诸暨市",
            "pc": "330600"
        }, {
            "c": "330682",
            "n": "上虞市",
            "pc": "330600"
        }, {
            "c": "330683",
            "n": "嵊州市",
            "pc": "330600"
        }, {
            "c": "330700",
            "n": "金华市",
            "pc": "330000"
        }, {
            "c": "330701",
            "n": "市辖区",
            "pc": "330700"
        }, {
            "c": "330702",
            "n": "婺城区",
            "pc": "330700"
        }, {
            "c": "330703",
            "n": "金东区",
            "pc": "330700"
        }, {
            "c": "330723",
            "n": "武义县",
            "pc": "330700"
        }, {
            "c": "330726",
            "n": "浦江县",
            "pc": "330700"
        }, {
            "c": "330727",
            "n": "磐安县",
            "pc": "330700"
        }, {
            "c": "330781",
            "n": "兰溪市",
            "pc": "330700"
        }, {
            "c": "330782",
            "n": "义乌市",
            "pc": "330700"
        }, {
            "c": "330783",
            "n": "东阳市",
            "pc": "330700"
        }, {
            "c": "330784",
            "n": "永康市",
            "pc": "330700"
        }, {
            "c": "330800",
            "n": "衢州市",
            "pc": "330000"
        }, {
            "c": "330801",
            "n": "市辖区",
            "pc": "330800"
        }, {
            "c": "330802",
            "n": "柯城区",
            "pc": "330800"
        }, {
            "c": "330803",
            "n": "衢江区",
            "pc": "330800"
        }, {
            "c": "330822",
            "n": "常山县",
            "pc": "330800"
        }, {
            "c": "330824",
            "n": "开化县",
            "pc": "330800"
        }, {
            "c": "330825",
            "n": "龙游县",
            "pc": "330800"
        }, {
            "c": "330881",
            "n": "江山市",
            "pc": "330800"
        }, {
            "c": "330900",
            "n": "舟山市",
            "pc": "330000"
        }, {
            "c": "330901",
            "n": "市辖区",
            "pc": "330900"
        }, {
            "c": "330902",
            "n": "定海区",
            "pc": "330900"
        }, {
            "c": "330903",
            "n": "普陀区",
            "pc": "330900"
        }, {
            "c": "330921",
            "n": "岱山县",
            "pc": "330900"
        }, {
            "c": "330922",
            "n": "嵊泗县",
            "pc": "330900"
        }, {
            "c": "331000",
            "n": "台州市",
            "pc": "330000"
        }, {
            "c": "331001",
            "n": "市辖区",
            "pc": "331000"
        }, {
            "c": "331002",
            "n": "椒江区",
            "pc": "331000"
        }, {
            "c": "331003",
            "n": "黄岩区",
            "pc": "331000"
        }, {
            "c": "331004",
            "n": "路桥区",
            "pc": "331000"
        }, {
            "c": "331021",
            "n": "玉环县",
            "pc": "331000"
        }, {
            "c": "331022",
            "n": "三门县",
            "pc": "331000"
        }, {
            "c": "331023",
            "n": "天台县",
            "pc": "331000"
        }, {
            "c": "331024",
            "n": "仙居县",
            "pc": "331000"
        }, {
            "c": "331081",
            "n": "温岭市",
            "pc": "331000"
        }, {
            "c": "331082",
            "n": "临海市",
            "pc": "331000"
        }, {
            "c": "331100",
            "n": "丽水市",
            "pc": "330000"
        }, {
            "c": "331101",
            "n": "市辖区",
            "pc": "331100"
        }, {
            "c": "331102",
            "n": "莲都区",
            "pc": "331100"
        }, {
            "c": "331121",
            "n": "青田县",
            "pc": "331100"
        }, {
            "c": "331122",
            "n": "缙云县",
            "pc": "331100"
        }, {
            "c": "331123",
            "n": "遂昌县",
            "pc": "331100"
        }, {
            "c": "331124",
            "n": "松阳县",
            "pc": "331100"
        }, {
            "c": "331125",
            "n": "云和县",
            "pc": "331100"
        }, {
            "c": "331126",
            "n": "庆元县",
            "pc": "331100"
        }, {
            "c": "331127",
            "n": "景宁畲族自治县",
            "pc": "331100"
        }, {
            "c": "331181",
            "n": "龙泉市",
            "pc": "331100"
        }, {
            "c": "340000",
            "n": "安徽省",
            "pc": "86"
        }, {
            "c": "340100",
            "n": "合肥市",
            "pc": "340000"
        }, {
            "c": "340101",
            "n": "市辖区",
            "pc": "340100"
        }, {
            "c": "340102",
            "n": "瑶海区",
            "pc": "340100"
        }, {
            "c": "340103",
            "n": "庐阳区",
            "pc": "340100"
        }, {
            "c": "340104",
            "n": "蜀山区",
            "pc": "340100"
        }, {
            "c": "340111",
            "n": "包河区",
            "pc": "340100"
        }, {
            "c": "340121",
            "n": "长丰县",
            "pc": "340100"
        }, {
            "c": "340122",
            "n": "肥东县",
            "pc": "340100"
        }, {
            "c": "340123",
            "n": "肥西县",
            "pc": "340100"
        }, {
            "c": "340124",
            "n": "庐江县",
            "pc": "340100"
        }, {
            "c": "340181",
            "n": "巢湖市",
            "pc": "340100"
        }, {
            "c": "340200",
            "n": "芜湖市",
            "pc": "340000"
        }, {
            "c": "340201",
            "n": "市辖区",
            "pc": "340200"
        }, {
            "c": "340202",
            "n": "镜湖区",
            "pc": "340200"
        }, {
            "c": "340203",
            "n": "弋江区",
            "pc": "340200"
        }, {
            "c": "340207",
            "n": "鸠江区",
            "pc": "340200"
        }, {
            "c": "340208",
            "n": "三山区",
            "pc": "340200"
        }, {
            "c": "340221",
            "n": "芜湖县",
            "pc": "340200"
        }, {
            "c": "340222",
            "n": "繁昌县",
            "pc": "340200"
        }, {
            "c": "340223",
            "n": "南陵县",
            "pc": "340200"
        }, {
            "c": "340225",
            "n": "无为县",
            "pc": "340200"
        }, {
            "c": "340300",
            "n": "蚌埠市",
            "pc": "340000"
        }, {
            "c": "340301",
            "n": "市辖区",
            "pc": "340300"
        }, {
            "c": "340302",
            "n": "龙子湖区",
            "pc": "340300"
        }, {
            "c": "340303",
            "n": "蚌山区",
            "pc": "340300"
        }, {
            "c": "340304",
            "n": "禹会区",
            "pc": "340300"
        }, {
            "c": "340311",
            "n": "淮上区",
            "pc": "340300"
        }, {
            "c": "340321",
            "n": "怀远县",
            "pc": "340300"
        }, {
            "c": "340322",
            "n": "五河县",
            "pc": "340300"
        }, {
            "c": "340323",
            "n": "固镇县",
            "pc": "340300"
        }, {
            "c": "340400",
            "n": "淮南市",
            "pc": "340000"
        }, {
            "c": "340401",
            "n": "市辖区",
            "pc": "340400"
        }, {
            "c": "340402",
            "n": "大通区",
            "pc": "340400"
        }, {
            "c": "340403",
            "n": "田家庵区",
            "pc": "340400"
        }, {
            "c": "340404",
            "n": "谢家集区",
            "pc": "340400"
        }, {
            "c": "340405",
            "n": "八公山区",
            "pc": "340400"
        }, {
            "c": "340406",
            "n": "潘集区",
            "pc": "340400"
        }, {
            "c": "340421",
            "n": "凤台县",
            "pc": "340400"
        }, {
            "c": "340500",
            "n": "马鞍山市",
            "pc": "340000"
        }, {
            "c": "340501",
            "n": "市辖区",
            "pc": "340500"
        }, {
            "c": "340503",
            "n": "花山区",
            "pc": "340500"
        }, {
            "c": "340504",
            "n": "雨山区",
            "pc": "340500"
        }, {
            "c": "340506",
            "n": "博望区",
            "pc": "340500"
        }, {
            "c": "340521",
            "n": "当涂县",
            "pc": "340500"
        }, {
            "c": "340522",
            "n": "含山县",
            "pc": "340500"
        }, {
            "c": "340523",
            "n": "和县",
            "pc": "340500"
        }, {
            "c": "340600",
            "n": "淮北市",
            "pc": "340000"
        }, {
            "c": "340601",
            "n": "市辖区",
            "pc": "340600"
        }, {
            "c": "340602",
            "n": "杜集区",
            "pc": "340600"
        }, {
            "c": "340603",
            "n": "相山区",
            "pc": "340600"
        }, {
            "c": "340604",
            "n": "烈山区",
            "pc": "340600"
        }, {
            "c": "340621",
            "n": "濉溪县",
            "pc": "340600"
        }, {
            "c": "340700",
            "n": "铜陵市",
            "pc": "340000"
        }, {
            "c": "340701",
            "n": "市辖区",
            "pc": "340700"
        }, {
            "c": "340702",
            "n": "铜官山区",
            "pc": "340700"
        }, {
            "c": "340703",
            "n": "狮子山区",
            "pc": "340700"
        }, {
            "c": "340711",
            "n": "郊区",
            "pc": "340700"
        }, {
            "c": "340721",
            "n": "铜陵县",
            "pc": "340700"
        }, {
            "c": "340800",
            "n": "安庆市",
            "pc": "340000"
        }, {
            "c": "340801",
            "n": "市辖区",
            "pc": "340800"
        }, {
            "c": "340802",
            "n": "迎江区",
            "pc": "340800"
        }, {
            "c": "340803",
            "n": "大观区",
            "pc": "340800"
        }, {
            "c": "340811",
            "n": "宜秀区",
            "pc": "340800"
        }, {
            "c": "340822",
            "n": "怀宁县",
            "pc": "340800"
        }, {
            "c": "340823",
            "n": "枞阳县",
            "pc": "340800"
        }, {
            "c": "340824",
            "n": "潜山县",
            "pc": "340800"
        }, {
            "c": "340825",
            "n": "太湖县",
            "pc": "340800"
        }, {
            "c": "340826",
            "n": "宿松县",
            "pc": "340800"
        }, {
            "c": "340827",
            "n": "望江县",
            "pc": "340800"
        }, {
            "c": "340828",
            "n": "岳西县",
            "pc": "340800"
        }, {
            "c": "340881",
            "n": "桐城市",
            "pc": "340800"
        }, {
            "c": "341000",
            "n": "黄山市",
            "pc": "340000"
        }, {
            "c": "341001",
            "n": "市辖区",
            "pc": "341000"
        }, {
            "c": "341002",
            "n": "屯溪区",
            "pc": "341000"
        }, {
            "c": "341003",
            "n": "黄山区o:p>",
            "pc": "341000"
        }, {
            "c": "341004",
            "n": "徽州区",
            "pc": "341000"
        }, {
            "c": "341021",
            "n": "歙县",
            "pc": "341000"
        }, {
            "c": "341022",
            "n": "休宁县",
            "pc": "341000"
        }, {
            "c": "341023",
            "n": "黟县",
            "pc": "341000"
        }, {
            "c": "341024",
            "n": "祁门县",
            "pc": "341000"
        }, {
            "c": "341100",
            "n": "滁州市",
            "pc": "340000"
        }, {
            "c": "341101",
            "n": "市辖区",
            "pc": "341100"
        }, {
            "c": "341102",
            "n": "琅琊区",
            "pc": "341100"
        }, {
            "c": "341103",
            "n": "南谯区",
            "pc": "341100"
        }, {
            "c": "341122",
            "n": "来安县",
            "pc": "341100"
        }, {
            "c": "341124",
            "n": "全椒县",
            "pc": "341100"
        }, {
            "c": "341125",
            "n": "定远县",
            "pc": "341100"
        }, {
            "c": "341126",
            "n": "凤阳县",
            "pc": "341100"
        }, {
            "c": "341181",
            "n": "天长市",
            "pc": "341100"
        }, {
            "c": "341182",
            "n": "明光市",
            "pc": "341100"
        }, {
            "c": "341200",
            "n": "阜阳市",
            "pc": "340000"
        }, {
            "c": "341201",
            "n": "市辖区",
            "pc": "341200"
        }, {
            "c": "341202",
            "n": "颍州区",
            "pc": "341200"
        }, {
            "c": "341203",
            "n": "颍东区",
            "pc": "341200"
        }, {
            "c": "341204",
            "n": "颍泉区",
            "pc": "341200"
        }, {
            "c": "341221",
            "n": "临泉县",
            "pc": "341200"
        }, {
            "c": "341222",
            "n": "太和县",
            "pc": "341200"
        }, {
            "c": "341225",
            "n": "阜南县",
            "pc": "341200"
        }, {
            "c": "341226",
            "n": "颍上县",
            "pc": "341200"
        }, {
            "c": "341282",
            "n": "界首市",
            "pc": "341200"
        }, {
            "c": "341300",
            "n": "宿州市",
            "pc": "340000"
        }, {
            "c": "341301",
            "n": "市辖区",
            "pc": "341300"
        }, {
            "c": "341302",
            "n": "埇桥区",
            "pc": "341300"
        }, {
            "c": "341321",
            "n": "砀山县",
            "pc": "341300"
        }, {
            "c": "341322",
            "n": "萧县",
            "pc": "341300"
        }, {
            "c": "341323",
            "n": "灵璧县",
            "pc": "341300"
        }, {
            "c": "341324",
            "n": "泗县",
            "pc": "341300"
        }, {
            "c": "341500",
            "n": "六安市",
            "pc": "340000"
        }, {
            "c": "341501",
            "n": "市辖区",
            "pc": "341500"
        }, {
            "c": "341502",
            "n": "金安区",
            "pc": "341500"
        }, {
            "c": "341503",
            "n": "裕安区",
            "pc": "341500"
        }, {
            "c": "341521",
            "n": "寿县",
            "pc": "341500"
        }, {
            "c": "341522",
            "n": "霍邱县",
            "pc": "341500"
        }, {
            "c": "341523",
            "n": "舒城县",
            "pc": "341500"
        }, {
            "c": "341524",
            "n": "金寨县",
            "pc": "341500"
        }, {
            "c": "341525",
            "n": "霍山县",
            "pc": "341500"
        }, {
            "c": "341600",
            "n": "亳州市",
            "pc": "340000"
        }, {
            "c": "341601",
            "n": "市辖区",
            "pc": "341600"
        }, {
            "c": "341602",
            "n": "谯城区",
            "pc": "341600"
        }, {
            "c": "341621",
            "n": "涡阳县",
            "pc": "341600"
        }, {
            "c": "341622",
            "n": "蒙城县",
            "pc": "341600"
        }, {
            "c": "341623",
            "n": "利辛县",
            "pc": "341600"
        }, {
            "c": "341700",
            "n": "池州市",
            "pc": "340000"
        }, {
            "c": "341701",
            "n": "市辖区",
            "pc": "341700"
        }, {
            "c": "341702",
            "n": "贵池区",
            "pc": "341700"
        }, {
            "c": "341721",
            "n": "东至县",
            "pc": "341700"
        }, {
            "c": "341722",
            "n": "石台县",
            "pc": "341700"
        }, {
            "c": "341723",
            "n": "青阳县",
            "pc": "341700"
        }, {
            "c": "341800",
            "n": "宣城市",
            "pc": "340000"
        }, {
            "c": "341801",
            "n": "市辖区",
            "pc": "341800"
        }, {
            "c": "341802",
            "n": "宣州区",
            "pc": "341800"
        }, {
            "c": "341821",
            "n": "郎溪县",
            "pc": "341800"
        }, {
            "c": "341822",
            "n": "广德县",
            "pc": "341800"
        }, {
            "c": "341823",
            "n": "泾县",
            "pc": "341800"
        }, {
            "c": "341824",
            "n": "绩溪县",
            "pc": "341800"
        }, {
            "c": "341825",
            "n": "旌德县",
            "pc": "341800"
        }, {
            "c": "341881",
            "n": "宁国市",
            "pc": "341800"
        }, {
            "c": "350000",
            "n": "福建省",
            "pc": "86"
        }, {
            "c": "350100",
            "n": "福州市",
            "pc": "350000"
        }, {
            "c": "350101",
            "n": "市辖区",
            "pc": "350100"
        }, {
            "c": "350102",
            "n": "鼓楼区",
            "pc": "350100"
        }, {
            "c": "350103",
            "n": "台江区",
            "pc": "350100"
        }, {
            "c": "350104",
            "n": "仓山区",
            "pc": "350100"
        }, {
            "c": "350105",
            "n": "马尾区",
            "pc": "350100"
        }, {
            "c": "350111",
            "n": "晋安区",
            "pc": "350100"
        }, {
            "c": "350121",
            "n": "闽侯县",
            "pc": "350100"
        }, {
            "c": "350122",
            "n": "连江县",
            "pc": "350100"
        }, {
            "c": "350123",
            "n": "罗源县",
            "pc": "350100"
        }, {
            "c": "350124",
            "n": "闽清县",
            "pc": "350100"
        }, {
            "c": "350125",
            "n": "永泰县",
            "pc": "350100"
        }, {
            "c": "350128",
            "n": "平潭县",
            "pc": "350100"
        }, {
            "c": "350181",
            "n": "福清市",
            "pc": "350100"
        }, {
            "c": "350182",
            "n": "长乐市",
            "pc": "350100"
        }, {
            "c": "350200",
            "n": "厦门市",
            "pc": "350000"
        }, {
            "c": "350201",
            "n": "市辖区",
            "pc": "350200"
        }, {
            "c": "350203",
            "n": "思明区",
            "pc": "350200"
        }, {
            "c": "350205",
            "n": "海沧区",
            "pc": "350200"
        }, {
            "c": "350206",
            "n": "湖里区",
            "pc": "350200"
        }, {
            "c": "350211",
            "n": "集美区",
            "pc": "350200"
        }, {
            "c": "350212",
            "n": "同安区",
            "pc": "350200"
        }, {
            "c": "350213",
            "n": "翔安区",
            "pc": "350200"
        }, {
            "c": "350300",
            "n": "莆田市",
            "pc": "350000"
        }, {
            "c": "350301",
            "n": "市辖区",
            "pc": "350300"
        }, {
            "c": "350302",
            "n": "城厢区",
            "pc": "350300"
        }, {
            "c": "350303",
            "n": "涵江区",
            "pc": "350300"
        }, {
            "c": "350304",
            "n": "荔城区",
            "pc": "350300"
        }, {
            "c": "350305",
            "n": "秀屿区",
            "pc": "350300"
        }, {
            "c": "350322",
            "n": "仙游县",
            "pc": "350300"
        }, {
            "c": "350400",
            "n": "三明市",
            "pc": "350000"
        }, {
            "c": "350401",
            "n": "市辖区",
            "pc": "350400"
        }, {
            "c": "350402",
            "n": "梅列区",
            "pc": "350400"
        }, {
            "c": "350403",
            "n": "三元区",
            "pc": "350400"
        }, {
            "c": "350421",
            "n": "明溪县",
            "pc": "350400"
        }, {
            "c": "350423",
            "n": "清流县",
            "pc": "350400"
        }, {
            "c": "350424",
            "n": "宁化县",
            "pc": "350400"
        }, {
            "c": "350425",
            "n": "大田县",
            "pc": "350400"
        }, {
            "c": "350426",
            "n": "尤溪县",
            "pc": "350400"
        }, {
            "c": "350427",
            "n": "沙县",
            "pc": "350400"
        }, {
            "c": "350428",
            "n": "将乐县",
            "pc": "350400"
        }, {
            "c": "350429",
            "n": "泰宁县",
            "pc": "350400"
        }, {
            "c": "350430",
            "n": "建宁县",
            "pc": "350400"
        }, {
            "c": "350481",
            "n": "永安市",
            "pc": "350400"
        }, {
            "c": "350500",
            "n": "泉州市",
            "pc": "350000"
        }, {
            "c": "350501",
            "n": "市辖区",
            "pc": "350500"
        }, {
            "c": "350502",
            "n": "鲤城区",
            "pc": "350500"
        }, {
            "c": "350503",
            "n": "丰泽区",
            "pc": "350500"
        }, {
            "c": "350504",
            "n": "洛江区",
            "pc": "350500"
        }, {
            "c": "350505",
            "n": "泉港区",
            "pc": "350500"
        }, {
            "c": "350521",
            "n": "惠安县",
            "pc": "350500"
        }, {
            "c": "350524",
            "n": "安溪县",
            "pc": "350500"
        }, {
            "c": "350525",
            "n": "永春县",
            "pc": "350500"
        }, {
            "c": "350526",
            "n": "德化县",
            "pc": "350500"
        }, {
            "c": "350527",
            "n": "金门县",
            "pc": "350500"
        }, {
            "c": "350581",
            "n": "石狮市",
            "pc": "350500"
        }, {
            "c": "350582",
            "n": "晋江市",
            "pc": "350500"
        }, {
            "c": "350583",
            "n": "南安市",
            "pc": "350500"
        }, {
            "c": "350600",
            "n": "漳州市",
            "pc": "350000"
        }, {
            "c": "350601",
            "n": "市辖区",
            "pc": "350600"
        }, {
            "c": "350602",
            "n": "芗城区",
            "pc": "350600"
        }, {
            "c": "350603",
            "n": "龙文区",
            "pc": "350600"
        }, {
            "c": "350622",
            "n": "云霄县",
            "pc": "350600"
        }, {
            "c": "350623",
            "n": "漳浦县",
            "pc": "350600"
        }, {
            "c": "350624",
            "n": "诏安县",
            "pc": "350600"
        }, {
            "c": "350625",
            "n": "长泰县",
            "pc": "350600"
        }, {
            "c": "350626",
            "n": "东山县",
            "pc": "350600"
        }, {
            "c": "350627",
            "n": "南靖县",
            "pc": "350600"
        }, {
            "c": "350628",
            "n": "平和县",
            "pc": "350600"
        }, {
            "c": "350629",
            "n": "华安县",
            "pc": "350600"
        }, {
            "c": "350681",
            "n": "龙海市",
            "pc": "350600"
        }, {
            "c": "350700",
            "n": "南平市",
            "pc": "350000"
        }, {
            "c": "350701",
            "n": "市辖区",
            "pc": "350700"
        }, {
            "c": "350702",
            "n": "延平区",
            "pc": "350700"
        }, {
            "c": "350721",
            "n": "顺昌县",
            "pc": "350700"
        }, {
            "c": "350722",
            "n": "浦城县",
            "pc": "350700"
        }, {
            "c": "350723",
            "n": "光泽县",
            "pc": "350700"
        }, {
            "c": "350724",
            "n": "松溪县",
            "pc": "350700"
        }, {
            "c": "350725",
            "n": "政和县",
            "pc": "350700"
        }, {
            "c": "350781",
            "n": "邵武市",
            "pc": "350700"
        }, {
            "c": "350782",
            "n": "武夷山市",
            "pc": "350700"
        }, {
            "c": "350783",
            "n": "建瓯市",
            "pc": "350700"
        }, {
            "c": "350784",
            "n": "建阳市",
            "pc": "350700"
        }, {
            "c": "350800",
            "n": "龙岩市",
            "pc": "350000"
        }, {
            "c": "350801",
            "n": "市辖区",
            "pc": "350800"
        }, {
            "c": "350802",
            "n": "新罗区",
            "pc": "350800"
        }, {
            "c": "350821",
            "n": "长汀县",
            "pc": "350800"
        }, {
            "c": "350822",
            "n": "永定县",
            "pc": "350800"
        }, {
            "c": "350823",
            "n": "上杭县",
            "pc": "350800"
        }, {
            "c": "350824",
            "n": "武平县",
            "pc": "350800"
        }, {
            "c": "350825",
            "n": "连城县",
            "pc": "350800"
        }, {
            "c": "350881",
            "n": "漳平市",
            "pc": "350800"
        }, {
            "c": "350900",
            "n": "宁德市",
            "pc": "350000"
        }, {
            "c": "350901",
            "n": "市辖区",
            "pc": "350900"
        }, {
            "c": "350902",
            "n": "蕉城区",
            "pc": "350900"
        }, {
            "c": "350921",
            "n": "霞浦县",
            "pc": "350900"
        }, {
            "c": "350922",
            "n": "古田县",
            "pc": "350900"
        }, {
            "c": "350923",
            "n": "屏南县",
            "pc": "350900"
        }, {
            "c": "350924",
            "n": "寿宁县",
            "pc": "350900"
        }, {
            "c": "350925",
            "n": "周宁县",
            "pc": "350900"
        }, {
            "c": "350926",
            "n": "柘荣县",
            "pc": "350900"
        }, {
            "c": "350981",
            "n": "福安市",
            "pc": "350900"
        }, {
            "c": "350982",
            "n": "福鼎市",
            "pc": "350900"
        }, {
            "c": "360000",
            "n": "江西省",
            "pc": "86"
        }, {
            "c": "360100",
            "n": "南昌市",
            "pc": "360000"
        }, {
            "c": "360101",
            "n": "市辖区",
            "pc": "360100"
        }, {
            "c": "360102",
            "n": "东湖区",
            "pc": "360100"
        }, {
            "c": "360103",
            "n": "西湖区",
            "pc": "360100"
        }, {
            "c": "360104",
            "n": "青云谱区",
            "pc": "360100"
        }, {
            "c": "360105",
            "n": "湾里区",
            "pc": "360100"
        }, {
            "c": "360111",
            "n": "青山湖区",
            "pc": "360100"
        }, {
            "c": "360121",
            "n": "南昌县",
            "pc": "360100"
        }, {
            "c": "360122",
            "n": "新建县",
            "pc": "360100"
        }, {
            "c": "360123",
            "n": "安义县",
            "pc": "360100"
        }, {
            "c": "360124",
            "n": "进贤县",
            "pc": "360100"
        }, {
            "c": "360200",
            "n": "景德镇市",
            "pc": "360000"
        }, {
            "c": "360201",
            "n": "市辖区",
            "pc": "360200"
        }, {
            "c": "360202",
            "n": "昌江区",
            "pc": "360200"
        }, {
            "c": "360203",
            "n": "珠山区",
            "pc": "360200"
        }, {
            "c": "360222",
            "n": "浮梁县",
            "pc": "360200"
        }, {
            "c": "360281",
            "n": "乐平市",
            "pc": "360200"
        }, {
            "c": "360300",
            "n": "萍乡市",
            "pc": "360000"
        }, {
            "c": "360301",
            "n": "市辖区",
            "pc": "360300"
        }, {
            "c": "360302",
            "n": "安源区",
            "pc": "360300"
        }, {
            "c": "360313",
            "n": "湘东区",
            "pc": "360300"
        }, {
            "c": "360321",
            "n": "莲花县",
            "pc": "360300"
        }, {
            "c": "360322",
            "n": "上栗县",
            "pc": "360300"
        }, {
            "c": "360323",
            "n": "芦溪县",
            "pc": "360300"
        }, {
            "c": "360400",
            "n": "九江市",
            "pc": "360000"
        }, {
            "c": "360401",
            "n": "市辖区",
            "pc": "360400"
        }, {
            "c": "360402",
            "n": "庐山区",
            "pc": "360400"
        }, {
            "c": "360403",
            "n": "浔阳区",
            "pc": "360400"
        }, {
            "c": "360421",
            "n": "九江县",
            "pc": "360400"
        }, {
            "c": "360423",
            "n": "武宁县",
            "pc": "360400"
        }, {
            "c": "360424",
            "n": "修水县",
            "pc": "360400"
        }, {
            "c": "360425",
            "n": "永修县",
            "pc": "360400"
        }, {
            "c": "360426",
            "n": "德安县",
            "pc": "360400"
        }, {
            "c": "360427",
            "n": "星子县",
            "pc": "360400"
        }, {
            "c": "360428",
            "n": "都昌县",
            "pc": "360400"
        }, {
            "c": "360429",
            "n": "湖口县",
            "pc": "360400"
        }, {
            "c": "360430",
            "n": "彭泽县",
            "pc": "360400"
        }, {
            "c": "360481",
            "n": "瑞昌市",
            "pc": "360400"
        }, {
            "c": "360482",
            "n": "共青城市",
            "pc": "360400"
        }, {
            "c": "360500",
            "n": "新余市",
            "pc": "360000"
        }, {
            "c": "360501",
            "n": "市辖区",
            "pc": "360500"
        }, {
            "c": "360502",
            "n": "渝水区",
            "pc": "360500"
        }, {
            "c": "360521",
            "n": "分宜县",
            "pc": "360500"
        }, {
            "c": "360600",
            "n": "鹰潭市",
            "pc": "360000"
        }, {
            "c": "360601",
            "n": "市辖区",
            "pc": "360600"
        }, {
            "c": "360602",
            "n": "月湖区",
            "pc": "360600"
        }, {
            "c": "360622",
            "n": "余江县",
            "pc": "360600"
        }, {
            "c": "360681",
            "n": "贵溪市",
            "pc": "360600"
        }, {
            "c": "360700",
            "n": "赣州市",
            "pc": "360000"
        }, {
            "c": "360701",
            "n": "市辖区",
            "pc": "360700"
        }, {
            "c": "360702",
            "n": "章贡区",
            "pc": "360700"
        }, {
            "c": "360721",
            "n": "赣县",
            "pc": "360700"
        }, {
            "c": "360722",
            "n": "信丰县",
            "pc": "360700"
        }, {
            "c": "360723",
            "n": "大余县",
            "pc": "360700"
        }, {
            "c": "360724",
            "n": "上犹县",
            "pc": "360700"
        }, {
            "c": "360725",
            "n": "崇义县",
            "pc": "360700"
        }, {
            "c": "360726",
            "n": "安远县",
            "pc": "360700"
        }, {
            "c": "360727",
            "n": "龙南县",
            "pc": "360700"
        }, {
            "c": "360728",
            "n": "定南县",
            "pc": "360700"
        }, {
            "c": "360729",
            "n": "全南县",
            "pc": "360700"
        }, {
            "c": "360730",
            "n": "宁都县",
            "pc": "360700"
        }, {
            "c": "360731",
            "n": "于都县",
            "pc": "360700"
        }, {
            "c": "360732",
            "n": "兴国县",
            "pc": "360700"
        }, {
            "c": "360733",
            "n": "会昌县",
            "pc": "360700"
        }, {
            "c": "360734",
            "n": "寻乌县",
            "pc": "360700"
        }, {
            "c": "360735",
            "n": "石城县",
            "pc": "360700"
        }, {
            "c": "360781",
            "n": "瑞金市",
            "pc": "360700"
        }, {
            "c": "360782",
            "n": "南康市",
            "pc": "360700"
        }, {
            "c": "360800",
            "n": "吉安市",
            "pc": "360000"
        }, {
            "c": "360801",
            "n": "市辖区",
            "pc": "360800"
        }, {
            "c": "360802",
            "n": "吉州区",
            "pc": "360800"
        }, {
            "c": "360803",
            "n": "青原区",
            "pc": "360800"
        }, {
            "c": "360821",
            "n": "吉安县",
            "pc": "360800"
        }, {
            "c": "360822",
            "n": "吉水县",
            "pc": "360800"
        }, {
            "c": "360823",
            "n": "峡江县",
            "pc": "360800"
        }, {
            "c": "360824",
            "n": "新干县",
            "pc": "360800"
        }, {
            "c": "360825",
            "n": "永丰县",
            "pc": "360800"
        }, {
            "c": "360826",
            "n": "泰和县",
            "pc": "360800"
        }, {
            "c": "360827",
            "n": "遂川县",
            "pc": "360800"
        }, {
            "c": "360828",
            "n": "万安县",
            "pc": "360800"
        }, {
            "c": "360829",
            "n": "安福县",
            "pc": "360800"
        }, {
            "c": "360830",
            "n": "永新县",
            "pc": "360800"
        }, {
            "c": "360881",
            "n": "井冈山市",
            "pc": "360800"
        }, {
            "c": "360900",
            "n": "宜春市",
            "pc": "360000"
        }, {
            "c": "360901",
            "n": "市辖区",
            "pc": "360900"
        }, {
            "c": "360902",
            "n": "袁州区",
            "pc": "360900"
        }, {
            "c": "360921",
            "n": "奉新县",
            "pc": "360900"
        }, {
            "c": "360922",
            "n": "万载县",
            "pc": "360900"
        }, {
            "c": "360923",
            "n": "上高县",
            "pc": "360900"
        }, {
            "c": "360924",
            "n": "宜丰县",
            "pc": "360900"
        }, {
            "c": "360925",
            "n": "靖安县",
            "pc": "360900"
        }, {
            "c": "360926",
            "n": "铜鼓县",
            "pc": "360900"
        }, {
            "c": "360981",
            "n": "丰城市",
            "pc": "360900"
        }, {
            "c": "360982",
            "n": "樟树市",
            "pc": "360900"
        }, {
            "c": "360983",
            "n": "高安市",
            "pc": "360900"
        }, {
            "c": "361000",
            "n": "抚州市",
            "pc": "360000"
        }, {
            "c": "361001",
            "n": "市辖区",
            "pc": "361000"
        }, {
            "c": "361002",
            "n": "临川区",
            "pc": "361000"
        }, {
            "c": "361021",
            "n": "南城县",
            "pc": "361000"
        }, {
            "c": "361022",
            "n": "黎川县",
            "pc": "361000"
        }, {
            "c": "361023",
            "n": "南丰县",
            "pc": "361000"
        }, {
            "c": "361024",
            "n": "崇仁县",
            "pc": "361000"
        }, {
            "c": "361025",
            "n": "乐安县",
            "pc": "361000"
        }, {
            "c": "361026",
            "n": "宜黄县",
            "pc": "361000"
        }, {
            "c": "361027",
            "n": "金溪县",
            "pc": "361000"
        }, {
            "c": "361028",
            "n": "资溪县",
            "pc": "361000"
        }, {
            "c": "361029",
            "n": "东乡县",
            "pc": "361000"
        }, {
            "c": "361030",
            "n": "广昌县",
            "pc": "361000"
        }, {
            "c": "361100",
            "n": "上饶市",
            "pc": "360000"
        }, {
            "c": "361101",
            "n": "市辖区",
            "pc": "361100"
        }, {
            "c": "361102",
            "n": "信州区",
            "pc": "361100"
        }, {
            "c": "361121",
            "n": "上饶县",
            "pc": "361100"
        }, {
            "c": "361122",
            "n": "广丰县",
            "pc": "361100"
        }, {
            "c": "361123",
            "n": "玉山县",
            "pc": "361100"
        }, {
            "c": "361124",
            "n": "铅山县",
            "pc": "361100"
        }, {
            "c": "361125",
            "n": "横峰县",
            "pc": "361100"
        }, {
            "c": "361126",
            "n": "弋阳县",
            "pc": "361100"
        }, {
            "c": "361127",
            "n": "余干县",
            "pc": "361100"
        }, {
            "c": "361128",
            "n": "鄱阳县",
            "pc": "361100"
        }, {
            "c": "361129",
            "n": "万年县",
            "pc": "361100"
        }, {
            "c": "361130",
            "n": "婺源县",
            "pc": "361100"
        }, {
            "c": "361181",
            "n": "德兴市",
            "pc": "361100"
        }, {
            "c": "370000",
            "n": "山东省",
            "pc": "86"
        }, {
            "c": "370100",
            "n": "济南市",
            "pc": "370000"
        }, {
            "c": "370101",
            "n": "市辖区",
            "pc": "370100"
        }, {
            "c": "370102",
            "n": "历下区",
            "pc": "370100"
        }, {
            "c": "370103",
            "n": "市中区",
            "pc": "370100"
        }, {
            "c": "370104",
            "n": "槐荫区",
            "pc": "370100"
        }, {
            "c": "370105",
            "n": "天桥区",
            "pc": "370100"
        }, {
            "c": "370112",
            "n": "历城区",
            "pc": "370100"
        }, {
            "c": "370113",
            "n": "长清区",
            "pc": "370100"
        }, {
            "c": "370124",
            "n": "平阴县",
            "pc": "370100"
        }, {
            "c": "370125",
            "n": "济阳县",
            "pc": "370100"
        }, {
            "c": "370126",
            "n": "商河县",
            "pc": "370100"
        }, {
            "c": "370181",
            "n": "章丘市",
            "pc": "370100"
        }, {
            "c": "370200",
            "n": "青岛市",
            "pc": "370000"
        }, {
            "c": "370201",
            "n": "市辖区",
            "pc": "370200"
        }, {
            "c": "370202",
            "n": "市南区",
            "pc": "370200"
        }, {
            "c": "370203",
            "n": "市北区",
            "pc": "370200"
        }, {
            "c": "370205",
            "n": "四方区",
            "pc": "370200"
        }, {
            "c": "370211",
            "n": "黄岛区",
            "pc": "370200"
        }, {
            "c": "370212",
            "n": "崂山区",
            "pc": "370200"
        }, {
            "c": "370213",
            "n": "李沧区",
            "pc": "370200"
        }, {
            "c": "370214",
            "n": "城阳区",
            "pc": "370200"
        }, {
            "c": "370281",
            "n": "胶州市",
            "pc": "370200"
        }, {
            "c": "370282",
            "n": "即墨市",
            "pc": "370200"
        }, {
            "c": "370283",
            "n": "平度市",
            "pc": "370200"
        }, {
            "c": "370284",
            "n": "胶南市",
            "pc": "370200"
        }, {
            "c": "370285",
            "n": "莱西市",
            "pc": "370200"
        }, {
            "c": "370300",
            "n": "淄博市",
            "pc": "370000"
        }, {
            "c": "370301",
            "n": "市辖区",
            "pc": "370300"
        }, {
            "c": "370302",
            "n": "淄川区",
            "pc": "370300"
        }, {
            "c": "370303",
            "n": "张店区",
            "pc": "370300"
        }, {
            "c": "370304",
            "n": "博山区",
            "pc": "370300"
        }, {
            "c": "370305",
            "n": "临淄区",
            "pc": "370300"
        }, {
            "c": "370306",
            "n": "周村区",
            "pc": "370300"
        }, {
            "c": "370321",
            "n": "桓台县",
            "pc": "370300"
        }, {
            "c": "370322",
            "n": "高青县",
            "pc": "370300"
        }, {
            "c": "370323",
            "n": "沂源县",
            "pc": "370300"
        }, {
            "c": "370400",
            "n": "枣庄市",
            "pc": "370000"
        }, {
            "c": "370401",
            "n": "市辖区",
            "pc": "370400"
        }, {
            "c": "370402",
            "n": "市中区",
            "pc": "370400"
        }, {
            "c": "370403",
            "n": "薛城区",
            "pc": "370400"
        }, {
            "c": "370404",
            "n": "峄城区",
            "pc": "370400"
        }, {
            "c": "370405",
            "n": "台儿庄区",
            "pc": "370400"
        }, {
            "c": "370406",
            "n": "山亭区",
            "pc": "370400"
        }, {
            "c": "370481",
            "n": "滕州市",
            "pc": "370400"
        }, {
            "c": "370500",
            "n": "东营市",
            "pc": "370000"
        }, {
            "c": "370501",
            "n": "市辖区",
            "pc": "370500"
        }, {
            "c": "370502",
            "n": "东营区",
            "pc": "370500"
        }, {
            "c": "370503",
            "n": "河口区",
            "pc": "370500"
        }, {
            "c": "370521",
            "n": "垦利县",
            "pc": "370500"
        }, {
            "c": "370522",
            "n": "利津县",
            "pc": "370500"
        }, {
            "c": "370523",
            "n": "广饶县",
            "pc": "370500"
        }, {
            "c": "370600",
            "n": "烟台市",
            "pc": "370000"
        }, {
            "c": "370601",
            "n": "市辖区",
            "pc": "370600"
        }, {
            "c": "370602",
            "n": "芝罘区",
            "pc": "370600"
        }, {
            "c": "370611",
            "n": "福山区",
            "pc": "370600"
        }, {
            "c": "370612",
            "n": "牟平区",
            "pc": "370600"
        }, {
            "c": "370613",
            "n": "莱山区",
            "pc": "370600"
        }, {
            "c": "370634",
            "n": "长岛县",
            "pc": "370600"
        }, {
            "c": "370681",
            "n": "龙口市",
            "pc": "370600"
        }, {
            "c": "370682",
            "n": "莱阳市",
            "pc": "370600"
        }, {
            "c": "370683",
            "n": "莱州市",
            "pc": "370600"
        }, {
            "c": "370684",
            "n": "蓬莱市",
            "pc": "370600"
        }, {
            "c": "370685",
            "n": "招远市",
            "pc": "370600"
        }, {
            "c": "3706",
            "n": "栖霞市",
            "pc": "370600"
        }, {
            "c": "370687",
            "n": "海阳市",
            "pc": "370600"
        }, {
            "c": "370700",
            "n": "潍坊市",
            "pc": "370000"
        }, {
            "c": "370701",
            "n": "市辖区",
            "pc": "370700"
        }, {
            "c": "370702",
            "n": "潍城区",
            "pc": "370700"
        }, {
            "c": "370703",
            "n": "寒亭区",
            "pc": "370700"
        }, {
            "c": "370704",
            "n": "坊子区",
            "pc": "370700"
        }, {
            "c": "370705",
            "n": "奎文区",
            "pc": "370700"
        }, {
            "c": "370724",
            "n": "临朐县",
            "pc": "370700"
        }, {
            "c": "370725",
            "n": "昌乐县",
            "pc": "370700"
        }, {
            "c": "370781",
            "n": "青州市",
            "pc": "370700"
        }, {
            "c": "370782",
            "n": "诸城市",
            "pc": "370700"
        }, {
            "c": "370783",
            "n": "寿光市",
            "pc": "370700"
        }, {
            "c": "370784",
            "n": "安丘市",
            "pc": "370700"
        }, {
            "c": "370785",
            "n": "高密市",
            "pc": "370700"
        }, {
            "c": "3707",
            "n": "昌邑市",
            "pc": "370700"
        }, {
            "c": "370800",
            "n": "济宁市",
            "pc": "370000"
        }, {
            "c": "370801",
            "n": "市辖区",
            "pc": "370800"
        }, {
            "c": "370802",
            "n": "市中区",
            "pc": "370800"
        }, {
            "c": "370811",
            "n": "任城区",
            "pc": "370800"
        }, {
            "c": "370826",
            "n": "微山县",
            "pc": "370800"
        }, {
            "c": "370827",
            "n": "鱼台县",
            "pc": "370800"
        }, {
            "c": "370828",
            "n": "金乡县",
            "pc": "370800"
        }, {
            "c": "370829",
            "n": "嘉祥县",
            "pc": "370800"
        }, {
            "c": "370830",
            "n": "汶上县",
            "pc": "370800"
        }, {
            "c": "370831",
            "n": "泗水县",
            "pc": "370800"
        }, {
            "c": "370832",
            "n": "梁山县",
            "pc": "370800"
        }, {
            "c": "370881",
            "n": "曲阜市",
            "pc": "370800"
        }, {
            "c": "370882",
            "n": "兖州市",
            "pc": "370800"
        }, {
            "c": "370883",
            "n": "邹城市",
            "pc": "370800"
        }, {
            "c": "370900",
            "n": "泰安市",
            "pc": "370000"
        }, {
            "c": "370901",
            "n": "市辖区",
            "pc": "370900"
        }, {
            "c": "370902",
            "n": "泰山区",
            "pc": "370900"
        }, {
            "c": "370911",
            "n": "岱岳区",
            "pc": "370900"
        }, {
            "c": "370921",
            "n": "宁阳县",
            "pc": "370900"
        }, {
            "c": "370923",
            "n": "东平县",
            "pc": "370900"
        }, {
            "c": "370982",
            "n": "新泰市",
            "pc": "370900"
        }, {
            "c": "370983",
            "n": "肥城市",
            "pc": "370900"
        }, {
            "c": "371000",
            "n": "威海市",
            "pc": "370000"
        }, {
            "c": "371001",
            "n": "市辖区",
            "pc": "371000"
        }, {
            "c": "371002",
            "n": "环翠区",
            "pc": "371000"
        }, {
            "c": "371081",
            "n": "文登市",
            "pc": "371000"
        }, {
            "c": "371082",
            "n": "荣成市",
            "pc": "371000"
        }, {
            "c": "371083",
            "n": "乳山市",
            "pc": "371000"
        }, {
            "c": "371100",
            "n": "日照市",
            "pc": "370000"
        }, {
            "c": "371101",
            "n": "市辖区",
            "pc": "371100"
        }, {
            "c": "371102",
            "n": "东港区",
            "pc": "371100"
        }, {
            "c": "371103",
            "n": "岚山区",
            "pc": "371100"
        }, {
            "c": "371121",
            "n": "五莲县",
            "pc": "371100"
        }, {
            "c": "371122",
            "n": "莒县",
            "pc": "371100"
        }, {
            "c": "371200",
            "n": "莱芜市",
            "pc": "370000"
        }, {
            "c": "371201",
            "n": "市辖区",
            "pc": "371200"
        }, {
            "c": "371202",
            "n": "莱城区",
            "pc": "371200"
        }, {
            "c": "371203",
            "n": "钢城区",
            "pc": "371200"
        }, {
            "c": "371300",
            "n": "临沂市",
            "pc": "370000"
        }, {
            "c": "371301",
            "n": "市辖区",
            "pc": "371300"
        }, {
            "c": "371302",
            "n": "兰山区",
            "pc": "371300"
        }, {
            "c": "371311",
            "n": "罗庄区",
            "pc": "371300"
        }, {
            "c": "371312",
            "n": "河东区",
            "pc": "371300"
        }, {
            "c": "371321",
            "n": "沂南县",
            "pc": "371300"
        }, {
            "c": "371322",
            "n": "郯城县",
            "pc": "371300"
        }, {
            "c": "371323",
            "n": "沂水县",
            "pc": "371300"
        }, {
            "c": "371324",
            "n": "苍山县",
            "pc": "371300"
        }, {
            "c": "371325",
            "n": "费县",
            "pc": "371300"
        }, {
            "c": "371326",
            "n": "平邑县",
            "pc": "371300"
        }, {
            "c": "371327",
            "n": "莒南县",
            "pc": "371300"
        }, {
            "c": "371328",
            "n": "蒙阴县",
            "pc": "371300"
        }, {
            "c": "371329",
            "n": "临沭县",
            "pc": "371300"
        }, {
            "c": "371400",
            "n": "德州市",
            "pc": "370000"
        }, {
            "c": "371401",
            "n": "市辖区",
            "pc": "371400"
        }, {
            "c": "371402",
            "n": "德城区",
            "pc": "371400"
        }, {
            "c": "371421",
            "n": "陵县",
            "pc": "371400"
        }, {
            "c": "371422",
            "n": "宁津县",
            "pc": "371400"
        }, {
            "c": "371423",
            "n": "庆云县",
            "pc": "371400"
        }, {
            "c": "371424",
            "n": "临邑县",
            "pc": "371400"
        }, {
            "c": "371425",
            "n": "齐河县",
            "pc": "371400"
        }, {
            "c": "371426",
            "n": "平原县",
            "pc": "371400"
        }, {
            "c": "371427",
            "n": "夏津县",
            "pc": "371400"
        }, {
            "c": "371428",
            "n": "武城县",
            "pc": "371400"
        }, {
            "c": "371481",
            "n": "乐陵市",
            "pc": "371400"
        }, {
            "c": "371482",
            "n": "禹城市",
            "pc": "371400"
        }, {
            "c": "371500",
            "n": "聊城市",
            "pc": "370000"
        }, {
            "c": "371501",
            "n": "市辖区",
            "pc": "371500"
        }, {
            "c": "371502",
            "n": "东昌府区",
            "pc": "371500"
        }, {
            "c": "371521",
            "n": "阳谷县",
            "pc": "371500"
        }, {
            "c": "371522",
            "n": "莘县",
            "pc": "371500"
        }, {
            "c": "371523",
            "n": "茌平县",
            "pc": "371500"
        }, {
            "c": "371524",
            "n": "东阿县",
            "pc": "371500"
        }, {
            "c": "371525",
            "n": "冠县",
            "pc": "371500"
        }, {
            "c": "371526",
            "n": "高唐县",
            "pc": "371500"
        }, {
            "c": "371581",
            "n": "临清市",
            "pc": "371500"
        }, {
            "c": "371600",
            "n": "滨州市",
            "pc": "370000"
        }, {
            "c": "371601",
            "n": "市辖区",
            "pc": "371600"
        }, {
            "c": "371602",
            "n": "滨城区",
            "pc": "371600"
        }, {
            "c": "371621",
            "n": "惠民县",
            "pc": "371600"
        }, {
            "c": "371622",
            "n": "阳信县",
            "pc": "371600"
        }, {
            "c": "371623",
            "n": "无棣县",
            "pc": "371600"
        }, {
            "c": "371624",
            "n": "沾化县",
            "pc": "371600"
        }, {
            "c": "371625",
            "n": "博兴县",
            "pc": "371600"
        }, {
            "c": "371626",
            "n": "邹平县",
            "pc": "371600"
        }, {
            "c": "371700",
            "n": "菏泽市",
            "pc": "370000"
        }, {
            "c": "371701",
            "n": "市辖区",
            "pc": "371700"
        }, {
            "c": "371702",
            "n": "牡丹区",
            "pc": "371700"
        }, {
            "c": "371721",
            "n": "曹县",
            "pc": "371700"
        }, {
            "c": "371722",
            "n": "单县",
            "pc": "371700"
        }, {
            "c": "371723",
            "n": "成武县",
            "pc": "371700"
        }, {
            "c": "371724",
            "n": "巨野县",
            "pc": "371700"
        }, {
            "c": "371725",
            "n": "郓城县",
            "pc": "371700"
        }, {
            "c": "371726",
            "n": "鄄城县",
            "pc": "371700"
        }, {
            "c": "371727",
            "n": "定陶县",
            "pc": "371700"
        }, {
            "c": "371728",
            "n": "东明县",
            "pc": "371700"
        }, {
            "c": "410000",
            "n": "河南省",
            "pc": "86"
        }, {
            "c": "410100",
            "n": "郑州市",
            "pc": "410000"
        }, {
            "c": "410101",
            "n": "市辖区",
            "pc": "410100"
        }, {
            "c": "410102",
            "n": "中原区",
            "pc": "410100"
        }, {
            "c": "410103",
            "n": "二七区",
            "pc": "410100"
        }, {
            "c": "410104",
            "n": "管城回族区",
            "pc": "410100"
        }, {
            "c": "410105",
            "n": "金水区",
            "pc": "410100"
        }, {
            "c": "410106",
            "n": "上街区",
            "pc": "410100"
        }, {
            "c": "410108",
            "n": "惠济区",
            "pc": "410100"
        }, {
            "c": "410122",
            "n": "中牟县",
            "pc": "410100"
        }, {
            "c": "410181",
            "n": "巩义市",
            "pc": "410100"
        }, {
            "c": "410182",
            "n": "荥阳市",
            "pc": "410100"
        }, {
            "c": "410183",
            "n": "新密市",
            "pc": "410100"
        }, {
            "c": "410184",
            "n": "新郑市",
            "pc": "410100"
        }, {
            "c": "410185",
            "n": "登封市",
            "pc": "410100"
        }, {
            "c": "410200",
            "n": "开封市",
            "pc": "410000"
        }, {
            "c": "410201",
            "n": "市辖区",
            "pc": "410200"
        }, {
            "c": "410202",
            "n": "龙亭区",
            "pc": "410200"
        }, {
            "c": "410203",
            "n": "顺河回族区",
            "pc": "410200"
        }, {
            "c": "410204",
            "n": "鼓楼区",
            "pc": "410200"
        }, {
            "c": "410205",
            "n": "禹王台区",
            "pc": "410200"
        }, {
            "c": "410211",
            "n": "金明区",
            "pc": "410200"
        }, {
            "c": "410221",
            "n": "杞县",
            "pc": "410200"
        }, {
            "c": "410222",
            "n": "通许县",
            "pc": "410200"
        }, {
            "c": "410223",
            "n": "尉氏县",
            "pc": "410200"
        }, {
            "c": "410224",
            "n": "开封县",
            "pc": "410200"
        }, {
            "c": "410225",
            "n": "兰考县",
            "pc": "410200"
        }, {
            "c": "410300",
            "n": "洛阳市",
            "pc": "410000"
        }, {
            "c": "410301",
            "n": "市辖区",
            "pc": "410300"
        }, {
            "c": "410302",
            "n": "老城区",
            "pc": "410300"
        }, {
            "c": "410303",
            "n": "西工区",
            "pc": "410300"
        }, {
            "c": "410304",
            "n": "瀍河回族区",
            "pc": "410300"
        }, {
            "c": "410305",
            "n": "涧西区",
            "pc": "410300"
        }, {
            "c": "410306",
            "n": "吉利区",
            "pc": "410300"
        }, {
            "c": "410311",
            "n": "洛龙区",
            "pc": "410300"
        }, {
            "c": "410322",
            "n": "孟津县",
            "pc": "410300"
        }, {
            "c": "410323",
            "n": "新安县",
            "pc": "410300"
        }, {
            "c": "410324",
            "n": "栾川县",
            "pc": "410300"
        }, {
            "c": "410325",
            "n": "嵩县",
            "pc": "410300"
        }, {
            "c": "410326",
            "n": "汝阳县",
            "pc": "410300"
        }, {
            "c": "410327",
            "n": "宜阳县",
            "pc": "410300"
        }, {
            "c": "410328",
            "n": "洛宁县",
            "pc": "410300"
        }, {
            "c": "410329",
            "n": "伊川县",
            "pc": "410300"
        }, {
            "c": "410381",
            "n": "偃师市",
            "pc": "410300"
        }, {
            "c": "410400",
            "n": "平顶山市",
            "pc": "410000"
        }, {
            "c": "410401",
            "n": "市辖区",
            "pc": "410400"
        }, {
            "c": "410402",
            "n": "新华区",
            "pc": "410400"
        }, {
            "c": "410403",
            "n": "卫东区",
            "pc": "410400"
        }, {
            "c": "410404",
            "n": "石龙区",
            "pc": "410400"
        }, {
            "c": "410411",
            "n": "湛河区",
            "pc": "410400"
        }, {
            "c": "410421",
            "n": "宝丰县",
            "pc": "410400"
        }, {
            "c": "410422",
            "n": "叶县",
            "pc": "410400"
        }, {
            "c": "410423",
            "n": "鲁山县",
            "pc": "410400"
        }, {
            "c": "410425",
            "n": "郏县",
            "pc": "410400"
        }, {
            "c": "410481",
            "n": "舞钢市",
            "pc": "410400"
        }, {
            "c": "410482",
            "n": "汝州市",
            "pc": "410400"
        }, {
            "c": "410500",
            "n": "安阳市",
            "pc": "410000"
        }, {
            "c": "410501",
            "n": "市辖区",
            "pc": "410500"
        }, {
            "c": "410502",
            "n": "文峰区",
            "pc": "410500"
        }, {
            "c": "410503",
            "n": "北关区",
            "pc": "410500"
        }, {
            "c": "410505",
            "n": "殷都区",
            "pc": "410500"
        }, {
            "c": "410506",
            "n": "龙安区",
            "pc": "410500"
        }, {
            "c": "410522",
            "n": "安阳县",
            "pc": "410500"
        }, {
            "c": "410523",
            "n": "汤阴县",
            "pc": "410500"
        }, {
            "c": "410526",
            "n": "滑县",
            "pc": "410500"
        }, {
            "c": "410527",
            "n": "内黄县",
            "pc": "410500"
        }, {
            "c": "410581",
            "n": "林州市",
            "pc": "410500"
        }, {
            "c": "410600",
            "n": "鹤壁市",
            "pc": "410000"
        }, {
            "c": "410601",
            "n": "市辖区",
            "pc": "410600"
        }, {
            "c": "410602",
            "n": "鹤山区",
            "pc": "410600"
        }, {
            "c": "410603",
            "n": "山城区",
            "pc": "410600"
        }, {
            "c": "410611",
            "n": "淇滨区",
            "pc": "410600"
        }, {
            "c": "410621",
            "n": "浚县",
            "pc": "410600"
        }, {
            "c": "410622",
            "n": "淇县",
            "pc": "410600"
        }, {
            "c": "410700",
            "n": "新乡市",
            "pc": "410000"
        }, {
            "c": "410701",
            "n": "市辖区",
            "pc": "410700"
        }, {
            "c": "410702",
            "n": "红旗区",
            "pc": "410700"
        }, {
            "c": "410703",
            "n": "卫滨区",
            "pc": "410700"
        }, {
            "c": "410704",
            "n": "凤泉区",
            "pc": "410700"
        }, {
            "c": "410711",
            "n": "牧野区",
            "pc": "410700"
        }, {
            "c": "410721",
            "n": "新乡县",
            "pc": "410700"
        }, {
            "c": "410724",
            "n": "获嘉县",
            "pc": "410700"
        }, {
            "c": "410725",
            "n": "原阳县",
            "pc": "410700"
        }, {
            "c": "410726",
            "n": "延津县",
            "pc": "410700"
        }, {
            "c": "410727",
            "n": "封丘县",
            "pc": "410700"
        }, {
            "c": "410728",
            "n": "长垣县",
            "pc": "410700"
        }, {
            "c": "410781",
            "n": "卫辉市",
            "pc": "410700"
        }, {
            "c": "410782",
            "n": "辉县市",
            "pc": "410700"
        }, {
            "c": "410800",
            "n": "焦作市",
            "pc": "410000"
        }, {
            "c": "410801",
            "n": "市辖区",
            "pc": "410800"
        }, {
            "c": "410802",
            "n": "解放区",
            "pc": "410800"
        }, {
            "c": "410803",
            "n": "中站区",
            "pc": "410800"
        }, {
            "c": "410804",
            "n": "马村区",
            "pc": "410800"
        }, {
            "c": "410811",
            "n": "山阳区",
            "pc": "410800"
        }, {
            "c": "410821",
            "n": "修武县",
            "pc": "410800"
        }, {
            "c": "410822",
            "n": "博爱县",
            "pc": "410800"
        }, {
            "c": "410823",
            "n": "武陟县",
            "pc": "410800"
        }, {
            "c": "410825",
            "n": "温县",
            "pc": "410800"
        }, {
            "c": "410882",
            "n": "沁阳市",
            "pc": "410800"
        }, {
            "c": "410883",
            "n": "孟州市",
            "pc": "410800"
        }, {
            "c": "410900",
            "n": "濮阳市",
            "pc": "410000"
        }, {
            "c": "410901",
            "n": "市辖区",
            "pc": "410900"
        }, {
            "c": "410902",
            "n": "华龙区",
            "pc": "410900"
        }, {
            "c": "410922",
            "n": "清丰县",
            "pc": "410900"
        }, {
            "c": "410923",
            "n": "南乐县",
            "pc": "410900"
        }, {
            "c": "410926",
            "n": "范县",
            "pc": "410900"
        }, {
            "c": "410927",
            "n": "台前县",
            "pc": "410900"
        }, {
            "c": "410928",
            "n": "濮阳县",
            "pc": "410900"
        }, {
            "c": "411000",
            "n": "许昌市",
            "pc": "410000"
        }, {
            "c": "411001",
            "n": "市辖区",
            "pc": "411000"
        }, {
            "c": "411002",
            "n": "魏都区",
            "pc": "411000"
        }, {
            "c": "411023",
            "n": "许昌县",
            "pc": "411000"
        }, {
            "c": "411024",
            "n": "鄢陵县",
            "pc": "411000"
        }, {
            "c": "411025",
            "n": "襄城县",
            "pc": "411000"
        }, {
            "c": "411081",
            "n": "禹州市",
            "pc": "411000"
        }, {
            "c": "411082",
            "n": "长葛市",
            "pc": "411000"
        }, {
            "c": "411100",
            "n": "漯河市",
            "pc": "410000"
        }, {
            "c": "411101",
            "n": "市辖区",
            "pc": "411100"
        }, {
            "c": "411102",
            "n": "源汇区",
            "pc": "411100"
        }, {
            "c": "411103",
            "n": "郾城区",
            "pc": "411100"
        }, {
            "c": "411104",
            "n": "召陵区",
            "pc": "411100"
        }, {
            "c": "411121",
            "n": "舞阳县",
            "pc": "411100"
        }, {
            "c": "411122",
            "n": "临颍县",
            "pc": "411100"
        }, {
            "c": "411200",
            "n": "三门峡市",
            "pc": "410000"
        }, {
            "c": "411201",
            "n": "市辖区",
            "pc": "411200"
        }, {
            "c": "411202",
            "n": "湖滨区",
            "pc": "411200"
        }, {
            "c": "411221",
            "n": "渑池县",
            "pc": "411200"
        }, {
            "c": "411222",
            "n": "陕县",
            "pc": "411200"
        }, {
            "c": "411224",
            "n": "卢氏县",
            "pc": "411200"
        }, {
            "c": "411281",
            "n": "义马市",
            "pc": "411200"
        }, {
            "c": "411282",
            "n": "灵宝市",
            "pc": "411200"
        }, {
            "c": "411300",
            "n": "南阳市",
            "pc": "410000"
        }, {
            "c": "411301",
            "n": "市辖区",
            "pc": "411300"
        }, {
            "c": "411302",
            "n": "宛城区",
            "pc": "411300"
        }, {
            "c": "411303",
            "n": "卧龙区",
            "pc": "411300"
        }, {
            "c": "411321",
            "n": "南召县",
            "pc": "411300"
        }, {
            "c": "411322",
            "n": "方城县",
            "pc": "411300"
        }, {
            "c": "411323",
            "n": "西峡县",
            "pc": "411300"
        }, {
            "c": "411324",
            "n": "镇平县",
            "pc": "411300"
        }, {
            "c": "411325",
            "n": "内乡县",
            "pc": "411300"
        }, {
            "c": "411326",
            "n": "淅川县",
            "pc": "411300"
        }, {
            "c": "411327",
            "n": "社旗县",
            "pc": "411300"
        }, {
            "c": "411328",
            "n": "唐河县",
            "pc": "411300"
        }, {
            "c": "411329",
            "n": "新野县",
            "pc": "411300"
        }, {
            "c": "411330",
            "n": "桐柏县",
            "pc": "411300"
        }, {
            "c": "411381",
            "n": "邓州市",
            "pc": "411300"
        }, {
            "c": "411400",
            "n": "商丘市",
            "pc": "410000"
        }, {
            "c": "411401",
            "n": "市辖区",
            "pc": "411400"
        }, {
            "c": "411402",
            "n": "梁园区",
            "pc": "411400"
        }, {
            "c": "411403",
            "n": "睢阳区",
            "pc": "411400"
        }, {
            "c": "411421",
            "n": "民权县",
            "pc": "411400"
        }, {
            "c": "411422",
            "n": "睢县",
            "pc": "411400"
        }, {
            "c": "411423",
            "n": "宁陵县",
            "pc": "411400"
        }, {
            "c": "411424",
            "n": "柘城县",
            "pc": "411400"
        }, {
            "c": "411425",
            "n": "虞城县",
            "pc": "411400"
        }, {
            "c": "411426",
            "n": "夏邑县",
            "pc": "411400"
        }, {
            "c": "411481",
            "n": "永城市",
            "pc": "411400"
        }, {
            "c": "411500",
            "n": "信阳市",
            "pc": "410000"
        }, {
            "c": "411501",
            "n": "市辖区",
            "pc": "411500"
        }, {
            "c": "411502",
            "n": "浉河区",
            "pc": "411500"
        }, {
            "c": "411503",
            "n": "平桥区",
            "pc": "411500"
        }, {
            "c": "411521",
            "n": "罗山县",
            "pc": "411500"
        }, {
            "c": "411522",
            "n": "光山县",
            "pc": "411500"
        }, {
            "c": "411523",
            "n": "新县",
            "pc": "411500"
        }, {
            "c": "411524",
            "n": "商城县",
            "pc": "411500"
        }, {
            "c": "411525",
            "n": "固始县",
            "pc": "411500"
        }, {
            "c": "411526",
            "n": "潢川县",
            "pc": "411500"
        }, {
            "c": "411527",
            "n": "淮滨县",
            "pc": "411500"
        }, {
            "c": "411528",
            "n": "息县",
            "pc": "411500"
        }, {
            "c": "411600",
            "n": "周口市",
            "pc": "410000"
        }, {
            "c": "411601",
            "n": "市辖区",
            "pc": "411600"
        }, {
            "c": "411602",
            "n": "川汇区",
            "pc": "411600"
        }, {
            "c": "411621",
            "n": "扶沟县",
            "pc": "411600"
        }, {
            "c": "411622",
            "n": "西华县",
            "pc": "411600"
        }, {
            "c": "411623",
            "n": "商水县",
            "pc": "411600"
        }, {
            "c": "411624",
            "n": "沈丘县",
            "pc": "411600"
        }, {
            "c": "411625",
            "n": "郸城县",
            "pc": "411600"
        }, {
            "c": "411626",
            "n": "淮阳县",
            "pc": "411600"
        }, {
            "c": "411627",
            "n": "太康县",
            "pc": "411600"
        }, {
            "c": "411628",
            "n": "鹿邑县",
            "pc": "411600"
        }, {
            "c": "411681",
            "n": "项城市",
            "pc": "411600"
        }, {
            "c": "411700",
            "n": "驻马店市",
            "pc": "410000"
        }, {
            "c": "411701",
            "n": "市辖区",
            "pc": "411700"
        }, {
            "c": "411702",
            "n": "驿城区",
            "pc": "411700"
        }, {
            "c": "411721",
            "n": "西平县",
            "pc": "411700"
        }, {
            "c": "411722",
            "n": "上蔡县",
            "pc": "411700"
        }, {
            "c": "411723",
            "n": "平舆县",
            "pc": "411700"
        }, {
            "c": "411724",
            "n": "正阳县",
            "pc": "411700"
        }, {
            "c": "411725",
            "n": "确山县",
            "pc": "411700"
        }, {
            "c": "411726",
            "n": "泌阳县",
            "pc": "411700"
        }, {
            "c": "411727",
            "n": "汝南县",
            "pc": "411700"
        }, {
            "c": "411728",
            "n": "遂平县",
            "pc": "411700"
        }, {
            "c": "411729",
            "n": "新蔡县",
            "pc": "411700"
        }, {
            "c": "419000",
            "n": "省直辖县级行政区划",
            "pc": "410000"
        }, {
            "c": "419001",
            "n": "济源市",
            "pc": "419000"
        }, {
            "c": "420000",
            "n": "湖北省",
            "pc": "86"
        }, {
            "c": "420100",
            "n": "武汉市",
            "pc": "420000"
        }, {
            "c": "420101",
            "n": "市辖区",
            "pc": "420100"
        }, {
            "c": "420102",
            "n": "江岸区",
            "pc": "420100"
        }, {
            "c": "420103",
            "n": "江汉区",
            "pc": "420100"
        }, {
            "c": "420104",
            "n": "硚口区",
            "pc": "420100"
        }, {
            "c": "420105",
            "n": "汉阳区",
            "pc": "420100"
        }, {
            "c": "420106",
            "n": "武昌区",
            "pc": "420100"
        }, {
            "c": "420107",
            "n": "青山区",
            "pc": "420100"
        }, {
            "c": "420111",
            "n": "洪山区",
            "pc": "420100"
        }, {
            "c": "420112",
            "n": "东西湖区",
            "pc": "420100"
        }, {
            "c": "420113",
            "n": "汉南区",
            "pc": "420100"
        }, {
            "c": "420114",
            "n": "蔡甸区",
            "pc": "420100"
        }, {
            "c": "420115",
            "n": "江夏区",
            "pc": "420100"
        }, {
            "c": "420116",
            "n": "黄陂区",
            "pc": "420100"
        }, {
            "c": "420117",
            "n": "新洲区",
            "pc": "420100"
        }, {
            "c": "420200",
            "n": "黄石市",
            "pc": "420000"
        }, {
            "c": "420201",
            "n": "市辖区",
            "pc": "420200"
        }, {
            "c": "420202",
            "n": "黄石港区",
            "pc": "420200"
        }, {
            "c": "420203",
            "n": "西塞山区",
            "pc": "420200"
        }, {
            "c": "420204",
            "n": "下陆区",
            "pc": "420200"
        }, {
            "c": "420205",
            "n": "铁山区",
            "pc": "420200"
        }, {
            "c": "420222",
            "n": "阳新县",
            "pc": "420200"
        }, {
            "c": "420281",
            "n": "大冶市",
            "pc": "420200"
        }, {
            "c": "420300",
            "n": "十堰市",
            "pc": "420000"
        }, {
            "c": "420301",
            "n": "市辖区",
            "pc": "420300"
        }, {
            "c": "420302",
            "n": "茅箭区",
            "pc": "420300"
        }, {
            "c": "420303",
            "n": "张湾区",
            "pc": "420300"
        }, {
            "c": "420321",
            "n": "郧县",
            "pc": "420300"
        }, {
            "c": "420322",
            "n": "郧西县",
            "pc": "420300"
        }, {
            "c": "420323",
            "n": "竹山县",
            "pc": "420300"
        }, {
            "c": "420324",
            "n": "竹溪县",
            "pc": "420300"
        }, {
            "c": "420325",
            "n": "房县",
            "pc": "420300"
        }, {
            "c": "420381",
            "n": "丹江口市",
            "pc": "420300"
        }, {
            "c": "420500",
            "n": "宜昌市",
            "pc": "420000"
        }, {
            "c": "420501",
            "n": "市辖区",
            "pc": "420500"
        }, {
            "c": "420502",
            "n": "西陵区",
            "pc": "420500"
        }, {
            "c": "420503",
            "n": "伍家岗区",
            "pc": "420500"
        }, {
            "c": "420504",
            "n": "点军区",
            "pc": "420500"
        }, {
            "c": "420505",
            "n": "猇亭区",
            "pc": "420500"
        }, {
            "c": "420506",
            "n": "夷陵区",
            "pc": "420500"
        }, {
            "c": "420525",
            "n": "远安县",
            "pc": "420500"
        }, {
            "c": "420526",
            "n": "兴山县",
            "pc": "420500"
        }, {
            "c": "420527",
            "n": "秭归县",
            "pc": "420500"
        }, {
            "c": "420528",
            "n": "长阳土家族自治县",
            "pc": "420500"
        }, {
            "c": "420529",
            "n": "五峰土家族自治县",
            "pc": "420500"
        }, {
            "c": "420581",
            "n": "宜都市",
            "pc": "420500"
        }, {
            "c": "420582",
            "n": "当阳市",
            "pc": "420500"
        }, {
            "c": "420583",
            "n": "枝江市",
            "pc": "420500"
        }, {
            "c": "420600",
            "n": "襄阳市",
            "pc": "420000"
        }, {
            "c": "420601",
            "n": "市辖区",
            "pc": "420600"
        }, {
            "c": "420602",
            "n": "襄城区",
            "pc": "420600"
        }, {
            "c": "420606",
            "n": "樊城区",
            "pc": "420600"
        }, {
            "c": "420607",
            "n": "襄州区",
            "pc": "420600"
        }, {
            "c": "420624",
            "n": "南漳县",
            "pc": "420600"
        }, {
            "c": "420625",
            "n": "谷城县",
            "pc": "420600"
        }, {
            "c": "420626",
            "n": "保康县",
            "pc": "420600"
        }, {
            "c": "420682",
            "n": "老河口市",
            "pc": "420600"
        }, {
            "c": "420683",
            "n": "枣阳市",
            "pc": "420600"
        }, {
            "c": "420684",
            "n": "宜城市",
            "pc": "420600"
        }, {
            "c": "420700",
            "n": "鄂州市",
            "pc": "420000"
        }, {
            "c": "420701",
            "n": "市辖区",
            "pc": "420700"
        }, {
            "c": "420702",
            "n": "梁子湖区",
            "pc": "420700"
        }, {
            "c": "420703",
            "n": "华容区",
            "pc": "420700"
        }, {
            "c": "420704",
            "n": "鄂城区",
            "pc": "420700"
        }, {
            "c": "420800",
            "n": "荆门市",
            "pc": "420000"
        }, {
            "c": "420801",
            "n": "市辖区",
            "pc": "420800"
        }, {
            "c": "420802",
            "n": "东宝区",
            "pc": "420800"
        }, {
            "c": "420804",
            "n": "掇刀区",
            "pc": "420800"
        }, {
            "c": "420821",
            "n": "京山县",
            "pc": "420800"
        }, {
            "c": "420822",
            "n": "沙洋县",
            "pc": "420800"
        }, {
            "c": "420881",
            "n": "钟祥市",
            "pc": "420800"
        }, {
            "c": "420900",
            "n": "孝感市",
            "pc": "420000"
        }, {
            "c": "420901",
            "n": "市辖区",
            "pc": "420900"
        }, {
            "c": "420902",
            "n": "孝南区",
            "pc": "420900"
        }, {
            "c": "420921",
            "n": "孝昌县",
            "pc": "420900"
        }, {
            "c": "420922",
            "n": "大悟县",
            "pc": "420900"
        }, {
            "c": "420923",
            "n": "云梦县",
            "pc": "420900"
        }, {
            "c": "420981",
            "n": "应城市",
            "pc": "420900"
        }, {
            "c": "420982",
            "n": "安陆市",
            "pc": "420900"
        }, {
            "c": "420984",
            "n": "汉川市",
            "pc": "420900"
        }, {
            "c": "421000",
            "n": "荆州市",
            "pc": "420000"
        }, {
            "c": "421001",
            "n": "市辖区",
            "pc": "421000"
        }, {
            "c": "421002",
            "n": "沙市区",
            "pc": "421000"
        }, {
            "c": "421003",
            "n": "荆州区",
            "pc": "421000"
        }, {
            "c": "421022",
            "n": "公安县",
            "pc": "421000"
        }, {
            "c": "421023",
            "n": "监利县",
            "pc": "421000"
        }, {
            "c": "421024",
            "n": "江陵县",
            "pc": "421000"
        }, {
            "c": "421081",
            "n": "石首市",
            "pc": "421000"
        }, {
            "c": "421083",
            "n": "洪湖市",
            "pc": "421000"
        }, {
            "c": "421087",
            "n": "松滋市",
            "pc": "421000"
        }, {
            "c": "421100",
            "n": "黄冈市",
            "pc": "420000"
        }, {
            "c": "421101",
            "n": "市辖区",
            "pc": "421100"
        }, {
            "c": "421102",
            "n": "黄州区",
            "pc": "421100"
        }, {
            "c": "421121",
            "n": "团风县",
            "pc": "421100"
        }, {
            "c": "421122",
            "n": "红安县",
            "pc": "421100"
        }, {
            "c": "421123",
            "n": "罗田县",
            "pc": "421100"
        }, {
            "c": "421124",
            "n": "英山县",
            "pc": "421100"
        }, {
            "c": "421125",
            "n": "浠水县",
            "pc": "421100"
        }, {
            "c": "421126",
            "n": "蕲春县",
            "pc": "421100"
        }, {
            "c": "421127",
            "n": "黄梅县",
            "pc": "421100"
        }, {
            "c": "421181",
            "n": "麻城市",
            "pc": "421100"
        }, {
            "c": "421182",
            "n": "武穴市",
            "pc": "421100"
        }, {
            "c": "421200",
            "n": "咸宁市",
            "pc": "420000"
        }, {
            "c": "421201",
            "n": "市辖区",
            "pc": "421200"
        }, {
            "c": "421202",
            "n": "咸安区",
            "pc": "421200"
        }, {
            "c": "421221",
            "n": "嘉鱼县",
            "pc": "421200"
        }, {
            "c": "421222",
            "n": "通城县",
            "pc": "421200"
        }, {
            "c": "421223",
            "n": "崇阳县",
            "pc": "421200"
        }, {
            "c": "421224",
            "n": "通山县",
            "pc": "421200"
        }, {
            "c": "421281",
            "n": "赤壁市",
            "pc": "421200"
        }, {
            "c": "421300",
            "n": "随州市",
            "pc": "420000"
        }, {
            "c": "421301",
            "n": "市辖区",
            "pc": "421300"
        }, {
            "c": "421303",
            "n": "曾都区",
            "pc": "421300"
        }, {
            "c": "421321",
            "n": "随县",
            "pc": "421300"
        }, {
            "c": "421381",
            "n": "广水市",
            "pc": "421300"
        }, {
            "c": "422800",
            "n": "恩施土家族苗族自治州",
            "pc": "420000"
        }, {
            "c": "422801",
            "n": "恩施市",
            "pc": "422800"
        }, {
            "c": "422802",
            "n": "利川市",
            "pc": "422800"
        }, {
            "c": "422822",
            "n": "建始县",
            "pc": "422800"
        }, {
            "c": "422823",
            "n": "巴东县",
            "pc": "422800"
        }, {
            "c": "422825",
            "n": "宣恩县",
            "pc": "422800"
        }, {
            "c": "422826",
            "n": "咸丰县",
            "pc": "422800"
        }, {
            "c": "422827",
            "n": "来凤县",
            "pc": "422800"
        }, {
            "c": "422828",
            "n": "鹤峰县",
            "pc": "422800"
        }, {
            "c": "429000",
            "n": "省直辖县级行政区划",
            "pc": "420000"
        }, {
            "c": "429004",
            "n": "仙桃市",
            "pc": "429000"
        }, {
            "c": "429005",
            "n": "潜江市",
            "pc": "429000"
        }, {
            "c": "429006",
            "n": "天门市",
            "pc": "429000"
        }, {
            "c": "429021",
            "n": "神农架林区",
            "pc": "429000"
        }, {
            "c": "430000",
            "n": "湖南省",
            "pc": "86"
        }, {
            "c": "430100",
            "n": "长沙市",
            "pc": "430000"
        }, {
            "c": "430101",
            "n": "市辖区",
            "pc": "430100"
        }, {
            "c": "430102",
            "n": "芙蓉区",
            "pc": "430100"
        }, {
            "c": "430103",
            "n": "天心区",
            "pc": "430100"
        }, {
            "c": "430104",
            "n": "岳麓区",
            "pc": "430100"
        }, {
            "c": "430105",
            "n": "开福区",
            "pc": "430100"
        }, {
            "c": "430111",
            "n": "雨花区",
            "pc": "430100"
        }, {
            "c": "430112",
            "n": "望城区",
            "pc": "430100"
        }, {
            "c": "430121",
            "n": "长沙县",
            "pc": "430100"
        }, {
            "c": "430124",
            "n": "宁乡县",
            "pc": "430100"
        }, {
            "c": "430181",
            "n": "浏阳市",
            "pc": "430100"
        }, {
            "c": "430200",
            "n": "株洲市",
            "pc": "430000"
        }, {
            "c": "430201",
            "n": "市辖区",
            "pc": "430200"
        }, {
            "c": "430202",
            "n": "荷塘区",
            "pc": "430200"
        }, {
            "c": "430203",
            "n": "芦淞区",
            "pc": "430200"
        }, {
            "c": "430204",
            "n": "石峰区",
            "pc": "430200"
        }, {
            "c": "430211",
            "n": "天元区",
            "pc": "430200"
        }, {
            "c": "430221",
            "n": "株洲县",
            "pc": "430200"
        }, {
            "c": "430223",
            "n": "攸县",
            "pc": "430200"
        }, {
            "c": "430224",
            "n": "茶陵县",
            "pc": "430200"
        }, {
            "c": "430225",
            "n": "炎陵县",
            "pc": "430200"
        }, {
            "c": "430281",
            "n": "醴陵市",
            "pc": "430200"
        }, {
            "c": "430300",
            "n": "湘潭市",
            "pc": "430000"
        }, {
            "c": "430301",
            "n": "市辖区",
            "pc": "430300"
        }, {
            "c": "430302",
            "n": "雨湖区",
            "pc": "430300"
        }, {
            "c": "430304",
            "n": "岳塘区",
            "pc": "430300"
        }, {
            "c": "430321",
            "n": "湘潭县",
            "pc": "430300"
        }, {
            "c": "430381",
            "n": "湘乡市",
            "pc": "430300"
        }, {
            "c": "430382",
            "n": "韶山市",
            "pc": "430300"
        }, {
            "c": "430400",
            "n": "衡阳市",
            "pc": "430000"
        }, {
            "c": "430401",
            "n": "市辖区",
            "pc": "430400"
        }, {
            "c": "430405",
            "n": "珠晖区",
            "pc": "430400"
        }, {
            "c": "430406",
            "n": "雁峰区",
            "pc": "430400"
        }, {
            "c": "430407",
            "n": "石鼓区",
            "pc": "430400"
        }, {
            "c": "430408",
            "n": "蒸湘区",
            "pc": "430400"
        }, {
            "c": "430412",
            "n": "南岳区",
            "pc": "430400"
        }, {
            "c": "430421",
            "n": "衡阳县",
            "pc": "430400"
        }, {
            "c": "430422",
            "n": "衡南县",
            "pc": "430400"
        }, {
            "c": "430423",
            "n": "衡山县",
            "pc": "430400"
        }, {
            "c": "430424",
            "n": "衡东县",
            "pc": "430400"
        }, {
            "c": "430426",
            "n": "祁东县",
            "pc": "430400"
        }, {
            "c": "430481",
            "n": "耒阳市",
            "pc": "430400"
        }, {
            "c": "430482",
            "n": "常宁市",
            "pc": "430400"
        }, {
            "c": "430500",
            "n": "邵阳市",
            "pc": "430000"
        }, {
            "c": "430501",
            "n": "市辖区",
            "pc": "430500"
        }, {
            "c": "430502",
            "n": "双清区",
            "pc": "430500"
        }, {
            "c": "430503",
            "n": "大祥区",
            "pc": "430500"
        }, {
            "c": "430511",
            "n": "北塔区",
            "pc": "430500"
        }, {
            "c": "430521",
            "n": "邵东县",
            "pc": "430500"
        }, {
            "c": "430522",
            "n": "新邵县",
            "pc": "430500"
        }, {
            "c": "430523",
            "n": "邵阳县",
            "pc": "430500"
        }, {
            "c": "430524",
            "n": "隆回县",
            "pc": "430500"
        }, {
            "c": "430525",
            "n": "洞口县",
            "pc": "430500"
        }, {
            "c": "430527",
            "n": "绥宁县",
            "pc": "430500"
        }, {
            "c": "430528",
            "n": "新宁县",
            "pc": "430500"
        }, {
            "c": "430529",
            "n": "城步苗族自治县",
            "pc": "430500"
        }, {
            "c": "430581",
            "n": "武冈市",
            "pc": "430500"
        }, {
            "c": "430600",
            "n": "岳阳市",
            "pc": "430000"
        }, {
            "c": "430601",
            "n": "市辖区",
            "pc": "430600"
        }, {
            "c": "430602",
            "n": "岳阳楼区",
            "pc": "430600"
        }, {
            "c": "430603",
            "n": "云溪区",
            "pc": "430600"
        }, {
            "c": "430611",
            "n": "君山区",
            "pc": "430600"
        }, {
            "c": "430621",
            "n": "岳阳县",
            "pc": "430600"
        }, {
            "c": "430623",
            "n": "华容县",
            "pc": "430600"
        }, {
            "c": "430624",
            "n": "湘阴县",
            "pc": "430600"
        }, {
            "c": "430626",
            "n": "平江县",
            "pc": "430600"
        }, {
            "c": "430681",
            "n": "汨罗市",
            "pc": "430600"
        }, {
            "c": "430682",
            "n": "临湘市",
            "pc": "430600"
        }, {
            "c": "430700",
            "n": "常德市",
            "pc": "430000"
        }, {
            "c": "430701",
            "n": "市辖区",
            "pc": "430700"
        }, {
            "c": "430702",
            "n": "武陵区",
            "pc": "430700"
        }, {
            "c": "430703",
            "n": "鼎城区",
            "pc": "430700"
        }, {
            "c": "430721",
            "n": "安乡县",
            "pc": "430700"
        }, {
            "c": "430722",
            "n": "汉寿县",
            "pc": "430700"
        }, {
            "c": "430723",
            "n": "澧县",
            "pc": "430700"
        }, {
            "c": "430724",
            "n": "临澧县",
            "pc": "430700"
        }, {
            "c": "430725",
            "n": "桃源县",
            "pc": "430700"
        }, {
            "c": "430726",
            "n": "石门县",
            "pc": "430700"
        }, {
            "c": "430781",
            "n": "津市市",
            "pc": "430700"
        }, {
            "c": "430800",
            "n": "张家界市",
            "pc": "430000"
        }, {
            "c": "430801",
            "n": "市辖区",
            "pc": "430800"
        }, {
            "c": "430802",
            "n": "永定区",
            "pc": "430800"
        }, {
            "c": "430811",
            "n": "武陵源区",
            "pc": "430800"
        }, {
            "c": "430821",
            "n": "慈利县",
            "pc": "430800"
        }, {
            "c": "430822",
            "n": "桑植县",
            "pc": "430800"
        }, {
            "c": "430900",
            "n": "益阳市",
            "pc": "430000"
        }, {
            "c": "430901",
            "n": "市辖区",
            "pc": "430900"
        }, {
            "c": "430902",
            "n": "资阳区",
            "pc": "430900"
        }, {
            "c": "430903",
            "n": "赫山区",
            "pc": "430900"
        }, {
            "c": "430921",
            "n": "南县",
            "pc": "430900"
        }, {
            "c": "430922",
            "n": "桃江县",
            "pc": "430900"
        }, {
            "c": "430923",
            "n": "安化县",
            "pc": "430900"
        }, {
            "c": "430981",
            "n": "沅江市",
            "pc": "430900"
        }, {
            "c": "431000",
            "n": "郴州市",
            "pc": "430000"
        }, {
            "c": "431001",
            "n": "市辖区",
            "pc": "431000"
        }, {
            "c": "431002",
            "n": "北湖区",
            "pc": "431000"
        }, {
            "c": "431003",
            "n": "苏仙区",
            "pc": "431000"
        }, {
            "c": "431021",
            "n": "桂阳县",
            "pc": "431000"
        }, {
            "c": "431022",
            "n": "宜章县",
            "pc": "431000"
        }, {
            "c": "431023",
            "n": "永兴县",
            "pc": "431000"
        }, {
            "c": "431024",
            "n": "嘉禾县",
            "pc": "431000"
        }, {
            "c": "431025",
            "n": "临武县",
            "pc": "431000"
        }, {
            "c": "431026",
            "n": "汝城县",
            "pc": "431000"
        }, {
            "c": "431027",
            "n": "桂东县",
            "pc": "431000"
        }, {
            "c": "431028",
            "n": "安仁县",
            "pc": "431000"
        }, {
            "c": "431081",
            "n": "资兴市",
            "pc": "431000"
        }, {
            "c": "431100",
            "n": "永州市",
            "pc": "430000"
        }, {
            "c": "431101",
            "n": "市辖区",
            "pc": "431100"
        }, {
            "c": "431102",
            "n": "零陵区",
            "pc": "431100"
        }, {
            "c": "431103",
            "n": "冷水滩区",
            "pc": "431100"
        }, {
            "c": "431121",
            "n": "祁阳县",
            "pc": "431100"
        }, {
            "c": "431122",
            "n": "东安县",
            "pc": "431100"
        }, {
            "c": "431123",
            "n": "双牌县",
            "pc": "431100"
        }, {
            "c": "431124",
            "n": "道县",
            "pc": "431100"
        }, {
            "c": "431125",
            "n": "江永县",
            "pc": "431100"
        }, {
            "c": "431126",
            "n": "宁远县",
            "pc": "431100"
        }, {
            "c": "431127",
            "n": "蓝山县",
            "pc": "431100"
        }, {
            "c": "431128",
            "n": "新田县",
            "pc": "431100"
        }, {
            "c": "431129",
            "n": "江华瑶族自治县",
            "pc": "431100"
        }, {
            "c": "431200",
            "n": "怀化市",
            "pc": "430000"
        }, {
            "c": "431201",
            "n": "市辖区",
            "pc": "431200"
        }, {
            "c": "431202",
            "n": "鹤城区",
            "pc": "431200"
        }, {
            "c": "431221",
            "n": "中方县",
            "pc": "431200"
        }, {
            "c": "431222",
            "n": "沅陵县",
            "pc": "431200"
        }, {
            "c": "431223",
            "n": "辰溪县",
            "pc": "431200"
        }, {
            "c": "431224",
            "n": "溆浦县",
            "pc": "431200"
        }, {
            "c": "431225",
            "n": "会同县",
            "pc": "431200"
        }, {
            "c": "431226",
            "n": "麻阳苗族自治县",
            "pc": "431200"
        }, {
            "c": "431227",
            "n": "新晃侗族自治县",
            "pc": "431200"
        }, {
            "c": "431228",
            "n": "芷江侗族自治县",
            "pc": "431200"
        }, {
            "c": "431229",
            "n": "靖州苗族侗族自治县",
            "pc": "431200"
        }, {
            "c": "431230",
            "n": "通道侗族自治县",
            "pc": "431200"
        }, {
            "c": "431281",
            "n": "洪江市",
            "pc": "431200"
        }, {
            "c": "431300",
            "n": "娄底市",
            "pc": "430000"
        }, {
            "c": "431301",
            "n": "市辖区",
            "pc": "431300"
        }, {
            "c": "431302",
            "n": "娄星区",
            "pc": "431300"
        }, {
            "c": "431321",
            "n": "双峰县",
            "pc": "431300"
        }, {
            "c": "431322",
            "n": "新化县",
            "pc": "431300"
        }, {
            "c": "431381",
            "n": "冷水江市",
            "pc": "431300"
        }, {
            "c": "431382",
            "n": "涟源市",
            "pc": "431300"
        }, {
            "c": "433100",
            "n": "湘西土家族苗族自治州",
            "pc": "430000"
        }, {
            "c": "433101",
            "n": "吉首市",
            "pc": "433100"
        }, {
            "c": "433122",
            "n": "泸溪县",
            "pc": "433100"
        }, {
            "c": "433123",
            "n": "凤凰县",
            "pc": "433100"
        }, {
            "c": "433124",
            "n": "花垣县",
            "pc": "433100"
        }, {
            "c": "433125",
            "n": "保靖县",
            "pc": "433100"
        }, {
            "c": "433126",
            "n": "古丈县",
            "pc": "433100"
        }, {
            "c": "433127",
            "n": "永顺县",
            "pc": "433100"
        }, {
            "c": "433130",
            "n": "龙山县",
            "pc": "433100"
        }, {
            "c": "440000",
            "n": "广东省",
            "pc": "86"
        }, {
            "c": "440100",
            "n": "广州市",
            "pc": "440000"
        }, {
            "c": "440101",
            "n": "市辖区",
            "pc": "440100"
        }, {
            "c": "440103",
            "n": "荔湾区",
            "pc": "440100"
        }, {
            "c": "440104",
            "n": "越秀区",
            "pc": "440100"
        }, {
            "c": "440105",
            "n": "海珠区",
            "pc": "440100"
        }, {
            "c": "440106",
            "n": "天河区",
            "pc": "440100"
        }, {
            "c": "440111",
            "n": "白云区",
            "pc": "440100"
        }, {
            "c": "440112",
            "n": "黄埔区",
            "pc": "440100"
        }, {
            "c": "440113",
            "n": "番禺区",
            "pc": "440100"
        }, {
            "c": "440114",
            "n": "花都区",
            "pc": "440100"
        }, {
            "c": "440115",
            "n": "南沙区",
            "pc": "440100"
        }, {
            "c": "440116",
            "n": "萝岗区",
            "pc": "440100"
        }, {
            "c": "440183",
            "n": "增城市",
            "pc": "440100"
        }, {
            "c": "440184",
            "n": "从化市",
            "pc": "440100"
        }, {
            "c": "440200",
            "n": "韶关市",
            "pc": "440000"
        }, {
            "c": "440201",
            "n": "市辖区",
            "pc": "440200"
        }, {
            "c": "440203",
            "n": "武江区",
            "pc": "440200"
        }, {
            "c": "440204",
            "n": "浈江区",
            "pc": "440200"
        }, {
            "c": "440205",
            "n": "曲江区",
            "pc": "440200"
        }, {
            "c": "440222",
            "n": "始兴县",
            "pc": "440200"
        }, {
            "c": "440224",
            "n": "仁化县",
            "pc": "440200"
        }, {
            "c": "440229",
            "n": "翁源县",
            "pc": "440200"
        }, {
            "c": "440232",
            "n": "乳源瑶族自治县",
            "pc": "440200"
        }, {
            "c": "440233",
            "n": "新丰县",
            "pc": "440200"
        }, {
            "c": "440281",
            "n": "乐昌市",
            "pc": "440200"
        }, {
            "c": "440282",
            "n": "南雄市",
            "pc": "440200"
        }, {
            "c": "440300",
            "n": "深圳市",
            "pc": "440000"
        }, {
            "c": "440301",
            "n": "市辖区",
            "pc": "440300"
        }, {
            "c": "440303",
            "n": "罗湖区",
            "pc": "440300"
        }, {
            "c": "440304",
            "n": "福田区",
            "pc": "440300"
        }, {
            "c": "440305",
            "n": "南山区",
            "pc": "440300"
        }, {
            "c": "440306",
            "n": "宝安区",
            "pc": "440300"
        }, {
            "c": "440307",
            "n": "龙岗区",
            "pc": "440300"
        }, {
            "c": "440308",
            "n": "盐田区",
            "pc": "440300"
        }, {
            "c": "440400",
            "n": "珠海市",
            "pc": "440000"
        }, {
            "c": "440401",
            "n": "市辖区",
            "pc": "440400"
        }, {
            "c": "440402",
            "n": "香洲区",
            "pc": "440400"
        }, {
            "c": "440403",
            "n": "斗门区",
            "pc": "440400"
        }, {
            "c": "440404",
            "n": "金湾区",
            "pc": "440400"
        }, {
            "c": "440500",
            "n": "汕头市",
            "pc": "440000"
        }, {
            "c": "440501",
            "n": "市辖区",
            "pc": "440500"
        }, {
            "c": "440507",
            "n": "龙湖区",
            "pc": "440500"
        }, {
            "c": "440511",
            "n": "金平区",
            "pc": "440500"
        }, {
            "c": "440512",
            "n": "濠江区",
            "pc": "440500"
        }, {
            "c": "440513",
            "n": "潮阳区",
            "pc": "440500"
        }, {
            "c": "440514",
            "n": "潮南区",
            "pc": "440500"
        }, {
            "c": "440515",
            "n": "澄海区",
            "pc": "440500"
        }, {
            "c": "440523",
            "n": "南澳县",
            "pc": "440500"
        }, {
            "c": "440600",
            "n": "佛山市",
            "pc": "440000"
        }, {
            "c": "440601",
            "n": "市辖区",
            "pc": "440600"
        }, {
            "c": "440604",
            "n": "禅城区",
            "pc": "440600"
        }, {
            "c": "440605",
            "n": "南海区",
            "pc": "440600"
        }, {
            "c": "440606",
            "n": "顺德区",
            "pc": "440600"
        }, {
            "c": "440607",
            "n": "三水区",
            "pc": "440600"
        }, {
            "c": "440608",
            "n": "高明区",
            "pc": "440600"
        }, {
            "c": "440700",
            "n": "江门市",
            "pc": "440000"
        }, {
            "c": "440701",
            "n": "市辖区",
            "pc": "440700"
        }, {
            "c": "440703",
            "n": "蓬江区",
            "pc": "440700"
        }, {
            "c": "440704",
            "n": "江海区",
            "pc": "440700"
        }, {
            "c": "440705",
            "n": "新会区",
            "pc": "440700"
        }, {
            "c": "440781",
            "n": "台山市",
            "pc": "440700"
        }, {
            "c": "440783",
            "n": "开平市",
            "pc": "440700"
        }, {
            "c": "440784",
            "n": "鹤山市",
            "pc": "440700"
        }, {
            "c": "440785",
            "n": "恩平市",
            "pc": "440700"
        }, {
            "c": "440800",
            "n": "湛江市",
            "pc": "440000"
        }, {
            "c": "440801",
            "n": "市辖区",
            "pc": "440800"
        }, {
            "c": "440802",
            "n": "赤坎区",
            "pc": "440800"
        }, {
            "c": "440803",
            "n": "霞山区",
            "pc": "440800"
        }, {
            "c": "440804",
            "n": "坡头区",
            "pc": "440800"
        }, {
            "c": "440811",
            "n": "麻章区",
            "pc": "440800"
        }, {
            "c": "440823",
            "n": "遂溪县",
            "pc": "440800"
        }, {
            "c": "440825",
            "n": "徐闻县",
            "pc": "440800"
        }, {
            "c": "440881",
            "n": "廉江市",
            "pc": "440800"
        }, {
            "c": "440882",
            "n": "雷州市",
            "pc": "440800"
        }, {
            "c": "440883",
            "n": "吴川市",
            "pc": "440800"
        }, {
            "c": "440900",
            "n": "茂名市",
            "pc": "440000"
        }, {
            "c": "440901",
            "n": "市辖区",
            "pc": "440900"
        }, {
            "c": "440902",
            "n": "茂南区",
            "pc": "440900"
        }, {
            "c": "440903",
            "n": "茂港区",
            "pc": "440900"
        }, {
            "c": "440923",
            "n": "电白县",
            "pc": "440900"
        }, {
            "c": "440981",
            "n": "高州市",
            "pc": "440900"
        }, {
            "c": "440982",
            "n": "化州市",
            "pc": "440900"
        }, {
            "c": "440983",
            "n": "信宜市",
            "pc": "440900"
        }, {
            "c": "441200",
            "n": "肇庆市",
            "pc": "440000"
        }, {
            "c": "441201",
            "n": "市辖区",
            "pc": "441200"
        }, {
            "c": "441202",
            "n": "端州区",
            "pc": "441200"
        }, {
            "c": "441203",
            "n": "鼎湖区",
            "pc": "441200"
        }, {
            "c": "441223",
            "n": "广宁县",
            "pc": "441200"
        }, {
            "c": "441224",
            "n": "怀集县",
            "pc": "441200"
        }, {
            "c": "441225",
            "n": "封开县",
            "pc": "441200"
        }, {
            "c": "441226",
            "n": "德庆县",
            "pc": "441200"
        }, {
            "c": "441283",
            "n": "高要市",
            "pc": "441200"
        }, {
            "c": "441284",
            "n": "四会市",
            "pc": "441200"
        }, {
            "c": "441300",
            "n": "惠州市",
            "pc": "440000"
        }, {
            "c": "441301",
            "n": "市辖区",
            "pc": "441300"
        }, {
            "c": "441302",
            "n": "惠城区",
            "pc": "441300"
        }, {
            "c": "441303",
            "n": "惠阳区",
            "pc": "441300"
        }, {
            "c": "441322",
            "n": "博罗县",
            "pc": "441300"
        }, {
            "c": "441323",
            "n": "惠东县",
            "pc": "441300"
        }, {
            "c": "441324",
            "n": "龙门县",
            "pc": "441300"
        }, {
            "c": "441400",
            "n": "梅州市",
            "pc": "440000"
        }, {
            "c": "441401",
            "n": "市辖区",
            "pc": "441400"
        }, {
            "c": "441402",
            "n": "梅江区",
            "pc": "441400"
        }, {
            "c": "441421",
            "n": "梅县",
            "pc": "441400"
        }, {
            "c": "441422",
            "n": "大埔县",
            "pc": "441400"
        }, {
            "c": "441423",
            "n": "丰顺县",
            "pc": "441400"
        }, {
            "c": "441424",
            "n": "五华县",
            "pc": "441400"
        }, {
            "c": "441426",
            "n": "平远县",
            "pc": "441400"
        }, {
            "c": "441427",
            "n": "蕉岭县",
            "pc": "441400"
        }, {
            "c": "441481",
            "n": "兴宁市",
            "pc": "441400"
        }, {
            "c": "441500",
            "n": "汕尾市",
            "pc": "440000"
        }, {
            "c": "441501",
            "n": "市辖区",
            "pc": "441500"
        }, {
            "c": "441502",
            "n": "城区",
            "pc": "441500"
        }, {
            "c": "441521",
            "n": "海丰县",
            "pc": "441500"
        }, {
            "c": "441523",
            "n": "陆河县",
            "pc": "441500"
        }, {
            "c": "441581",
            "n": "陆丰市",
            "pc": "441500"
        }, {
            "c": "441600",
            "n": "河源市",
            "pc": "440000"
        }, {
            "c": "441601",
            "n": "市辖区",
            "pc": "441600"
        }, {
            "c": "441602",
            "n": "源城区",
            "pc": "441600"
        }, {
            "c": "441621",
            "n": "紫金县",
            "pc": "441600"
        }, {
            "c": "441622",
            "n": "龙川县",
            "pc": "441600"
        }, {
            "c": "441623",
            "n": "连平县",
            "pc": "441600"
        }, {
            "c": "441624",
            "n": "和平县",
            "pc": "441600"
        }, {
            "c": "441625",
            "n": "东源县",
            "pc": "441600"
        }, {
            "c": "441700",
            "n": "阳江市",
            "pc": "440000"
        }, {
            "c": "441701",
            "n": "市辖区",
            "pc": "441700"
        }, {
            "c": "441702",
            "n": "江城区",
            "pc": "441700"
        }, {
            "c": "441721",
            "n": "阳西县",
            "pc": "441700"
        }, {
            "c": "441723",
            "n": "阳东县",
            "pc": "441700"
        }, {
            "c": "441781",
            "n": "阳春市",
            "pc": "441700"
        }, {
            "c": "441800",
            "n": "清远市",
            "pc": "440000"
        }, {
            "c": "441801",
            "n": "市辖区",
            "pc": "441800"
        }, {
            "c": "441802",
            "n": "清城区",
            "pc": "441800"
        }, {
            "c": "441821",
            "n": "佛冈县",
            "pc": "441800"
        }, {
            "c": "441823",
            "n": "阳山县",
            "pc": "441800"
        }, {
            "c": "441825",
            "n": "连山壮族瑶族自治县",
            "pc": "441800"
        }, {
            "c": "441826",
            "n": "连南瑶族自治县",
            "pc": "441800"
        }, {
            "c": "441827",
            "n": "清新县",
            "pc": "441800"
        }, {
            "c": "441881",
            "n": "英德市",
            "pc": "441800"
        }, {
            "c": "441882",
            "n": "连州市",
            "pc": "441800"
        }, {
            "c": "441900",
            "n": "东莞市",
            "pc": "440000"
        }, {
            "c": "442000",
            "n": "中山市",
            "pc": "440000"
        }, {
            "c": "445100",
            "n": "潮州市",
            "pc": "440000"
        }, {
            "c": "445101",
            "n": "市辖区",
            "pc": "445100"
        }, {
            "c": "445102",
            "n": "湘桥区",
            "pc": "445100"
        }, {
            "c": "445121",
            "n": "潮安县",
            "pc": "445100"
        }, {
            "c": "445122",
            "n": "饶平县",
            "pc": "445100"
        }, {
            "c": "445200",
            "n": "揭阳市",
            "pc": "440000"
        }, {
            "c": "445201",
            "n": "市辖区",
            "pc": "445200"
        }, {
            "c": "445202",
            "n": "榕城区",
            "pc": "445200"
        }, {
            "c": "445221",
            "n": "揭东县",
            "pc": "445200"
        }, {
            "c": "445222",
            "n": "揭西县",
            "pc": "445200"
        }, {
            "c": "445224",
            "n": "惠来县",
            "pc": "445200"
        }, {
            "c": "445281",
            "n": "普宁市",
            "pc": "445200"
        }, {
            "c": "445300",
            "n": "云浮市",
            "pc": "440000"
        }, {
            "c": "445301",
            "n": "市辖区",
            "pc": "445300"
        }, {
            "c": "445302",
            "n": "云城区",
            "pc": "445300"
        }, {
            "c": "445321",
            "n": "新兴县",
            "pc": "445300"
        }, {
            "c": "445322",
            "n": "郁南县",
            "pc": "445300"
        }, {
            "c": "445323",
            "n": "云安县",
            "pc": "445300"
        }, {
            "c": "445381",
            "n": "罗定市",
            "pc": "445300"
        }, {
            "c": "450000",
            "n": "广西壮族自治区",
            "pc": "86"
        }, {
            "c": "450100",
            "n": "南宁市",
            "pc": "450000"
        }, {
            "c": "450101",
            "n": "市辖区",
            "pc": "450100"
        }, {
            "c": "450102",
            "n": "兴宁区",
            "pc": "450100"
        }, {
            "c": "450103",
            "n": "青秀区",
            "pc": "450100"
        }, {
            "c": "450105",
            "n": "江南区",
            "pc": "450100"
        }, {
            "c": "450107",
            "n": "西乡塘区",
            "pc": "450100"
        }, {
            "c": "450108",
            "n": "良庆区",
            "pc": "450100"
        }, {
            "c": "450109",
            "n": "邕宁区",
            "pc": "450100"
        }, {
            "c": "450122",
            "n": "武鸣县",
            "pc": "450100"
        }, {
            "c": "450123",
            "n": "隆安县",
            "pc": "450100"
        }, {
            "c": "450124",
            "n": "马山县",
            "pc": "450100"
        }, {
            "c": "450125",
            "n": "上林县",
            "pc": "450100"
        }, {
            "c": "450126",
            "n": "宾阳县",
            "pc": "450100"
        }, {
            "c": "450127",
            "n": "横县",
            "pc": "450100"
        }, {
            "c": "450200",
            "n": "柳州市",
            "pc": "450000"
        }, {
            "c": "450201",
            "n": "市辖区",
            "pc": "450200"
        }, {
            "c": "450202",
            "n": "城中区",
            "pc": "450200"
        }, {
            "c": "450203",
            "n": "鱼峰区",
            "pc": "450200"
        }, {
            "c": "450204",
            "n": "柳南区",
            "pc": "450200"
        }, {
            "c": "450205",
            "n": "柳北区",
            "pc": "450200"
        }, {
            "c": "450221",
            "n": "柳江县",
            "pc": "450200"
        }, {
            "c": "450222",
            "n": "柳城县",
            "pc": "450200"
        }, {
            "c": "450223",
            "n": "鹿寨县",
            "pc": "450200"
        }, {
            "c": "450224",
            "n": "融安县",
            "pc": "450200"
        }, {
            "c": "450225",
            "n": "融水苗族自治县",
            "pc": "450200"
        }, {
            "c": "450226",
            "n": "三江侗族自治县",
            "pc": "450200"
        }, {
            "c": "450300",
            "n": "桂林市",
            "pc": "450000"
        }, {
            "c": "450301",
            "n": "市辖区",
            "pc": "450300"
        }, {
            "c": "450302",
            "n": "秀峰区",
            "pc": "450300"
        }, {
            "c": "450303",
            "n": "叠彩区",
            "pc": "450300"
        }, {
            "c": "450304",
            "n": "象山区",
            "pc": "450300"
        }, {
            "c": "450305",
            "n": "七星区",
            "pc": "450300"
        }, {
            "c": "450311",
            "n": "雁山区",
            "pc": "450300"
        }, {
            "c": "450321",
            "n": "阳朔县",
            "pc": "450300"
        }, {
            "c": "450322",
            "n": "临桂县",
            "pc": "450300"
        }, {
            "c": "450323",
            "n": "灵川县",
            "pc": "450300"
        }, {
            "c": "450324",
            "n": "全州县",
            "pc": "450300"
        }, {
            "c": "450325",
            "n": "兴安县",
            "pc": "450300"
        }, {
            "c": "450326",
            "n": "永福县",
            "pc": "450300"
        }, {
            "c": "450327",
            "n": "灌阳县",
            "pc": "450300"
        }, {
            "c": "450328",
            "n": "龙胜各族自治县",
            "pc": "450300"
        }, {
            "c": "450329",
            "n": "资源县",
            "pc": "450300"
        }, {
            "c": "450330",
            "n": "平乐县",
            "pc": "450300"
        }, {
            "c": "450331",
            "n": "荔浦县",
            "pc": "450300"
        }, {
            "c": "450332",
            "n": "恭城瑶族自治县",
            "pc": "450300"
        }, {
            "c": "450400",
            "n": "梧州市",
            "pc": "450000"
        }, {
            "c": "450401",
            "n": "市辖区",
            "pc": "450400"
        }, {
            "c": "450403",
            "n": "万秀区",
            "pc": "450400"
        }, {
            "c": "450404",
            "n": "蝶山区",
            "pc": "450400"
        }, {
            "c": "450405",
            "n": "长洲区",
            "pc": "450400"
        }, {
            "c": "450421",
            "n": "苍梧县",
            "pc": "450400"
        }, {
            "c": "450422",
            "n": "藤县",
            "pc": "450400"
        }, {
            "c": "450423",
            "n": "蒙山县",
            "pc": "450400"
        }, {
            "c": "450481",
            "n": "岑溪市",
            "pc": "450400"
        }, {
            "c": "450500",
            "n": "北海市",
            "pc": "450000"
        }, {
            "c": "450501",
            "n": "市辖区",
            "pc": "450500"
        }, {
            "c": "450502",
            "n": "海城区",
            "pc": "450500"
        }, {
            "c": "450503",
            "n": "银海区",
            "pc": "450500"
        }, {
            "c": "450512",
            "n": "铁山港区",
            "pc": "450500"
        }, {
            "c": "450521",
            "n": "合浦县",
            "pc": "450500"
        }, {
            "c": "450600",
            "n": "防城港市",
            "pc": "450000"
        }, {
            "c": "450601",
            "n": "市辖区",
            "pc": "450600"
        }, {
            "c": "450602",
            "n": "港口区",
            "pc": "450600"
        }, {
            "c": "450603",
            "n": "防城区",
            "pc": "450600"
        }, {
            "c": "450621",
            "n": "上思县",
            "pc": "450600"
        }, {
            "c": "450681",
            "n": "东兴市",
            "pc": "450600"
        }, {
            "c": "450700",
            "n": "钦州市",
            "pc": "450000"
        }, {
            "c": "450701",
            "n": "市辖区",
            "pc": "450700"
        }, {
            "c": "450702",
            "n": "钦南区",
            "pc": "450700"
        }, {
            "c": "450703",
            "n": "钦北区",
            "pc": "450700"
        }, {
            "c": "450721",
            "n": "灵山县",
            "pc": "450700"
        }, {
            "c": "450722",
            "n": "浦北县",
            "pc": "450700"
        }, {
            "c": "450800",
            "n": "贵港市",
            "pc": "450000"
        }, {
            "c": "450801",
            "n": "市辖区",
            "pc": "450800"
        }, {
            "c": "450802",
            "n": "港北区",
            "pc": "450800"
        }, {
            "c": "450803",
            "n": "港南区",
            "pc": "450800"
        }, {
            "c": "450804",
            "n": "覃塘区",
            "pc": "450800"
        }, {
            "c": "450821",
            "n": "平南县",
            "pc": "450800"
        }, {
            "c": "450881",
            "n": "桂平市",
            "pc": "450800"
        }, {
            "c": "450900",
            "n": "玉林市",
            "pc": "450000"
        }, {
            "c": "450901",
            "n": "市辖区",
            "pc": "450900"
        }, {
            "c": "450902",
            "n": "玉州区",
            "pc": "450900"
        }, {
            "c": "450921",
            "n": "容县",
            "pc": "450900"
        }, {
            "c": "450922",
            "n": "陆川县",
            "pc": "450900"
        }, {
            "c": "450923",
            "n": "博白县",
            "pc": "450900"
        }, {
            "c": "450924",
            "n": "兴业县",
            "pc": "450900"
        }, {
            "c": "450981",
            "n": "北流市",
            "pc": "450900"
        }, {
            "c": "451000",
            "n": "百色市",
            "pc": "450000"
        }, {
            "c": "451001",
            "n": "市辖区",
            "pc": "451000"
        }, {
            "c": "451002",
            "n": "右江区",
            "pc": "451000"
        }, {
            "c": "451021",
            "n": "田阳县",
            "pc": "451000"
        }, {
            "c": "451022",
            "n": "田东县",
            "pc": "451000"
        }, {
            "c": "451023",
            "n": "平果县",
            "pc": "451000"
        }, {
            "c": "451024",
            "n": "德保县",
            "pc": "451000"
        }, {
            "c": "451025",
            "n": "靖西县",
            "pc": "451000"
        }, {
            "c": "451026",
            "n": "那坡县",
            "pc": "451000"
        }, {
            "c": "451027",
            "n": "凌云县",
            "pc": "451000"
        }, {
            "c": "451028",
            "n": "乐业县",
            "pc": "451000"
        }, {
            "c": "451029",
            "n": "田林县",
            "pc": "451000"
        }, {
            "c": "451030",
            "n": "西林县",
            "pc": "451000"
        }, {
            "c": "451031",
            "n": "隆林各族自治县",
            "pc": "451000"
        }, {
            "c": "451100",
            "n": "贺州市",
            "pc": "450000"
        }, {
            "c": "451101",
            "n": "市辖区",
            "pc": "451100"
        }, {
            "c": "451102",
            "n": "八步区",
            "pc": "451100"
        }, {
            "c": "451121",
            "n": "昭平县",
            "pc": "451100"
        }, {
            "c": "451122",
            "n": "钟山县",
            "pc": "451100"
        }, {
            "c": "451123",
            "n": "富川瑶族自治县",
            "pc": "451100"
        }, {
            "c": "451200",
            "n": "河池市",
            "pc": "450000"
        }, {
            "c": "451201",
            "n": "市辖区",
            "pc": "451200"
        }, {
            "c": "451202",
            "n": "金城江区",
            "pc": "451200"
        }, {
            "c": "451221",
            "n": "南丹县",
            "pc": "451200"
        }, {
            "c": "451222",
            "n": "天峨县",
            "pc": "451200"
        }, {
            "c": "451223",
            "n": "凤山县",
            "pc": "451200"
        }, {
            "c": "451224",
            "n": "东兰县",
            "pc": "451200"
        }, {
            "c": "451225",
            "n": "罗城仫佬族自治县",
            "pc": "451200"
        }, {
            "c": "451226",
            "n": "环江毛南族自治县",
            "pc": "451200"
        }, {
            "c": "451227",
            "n": "巴马瑶族自治县",
            "pc": "451200"
        }, {
            "c": "451228",
            "n": "都安瑶族自治县",
            "pc": "451200"
        }, {
            "c": "451229",
            "n": "大化瑶族自治县",
            "pc": "451200"
        }, {
            "c": "451281",
            "n": "宜州市",
            "pc": "451200"
        }, {
            "c": "451300",
            "n": "来宾市",
            "pc": "450000"
        }, {
            "c": "451301",
            "n": "市辖区",
            "pc": "451300"
        }, {
            "c": "451302",
            "n": "兴宾区",
            "pc": "451300"
        }, {
            "c": "451321",
            "n": "忻城县",
            "pc": "451300"
        }, {
            "c": "451322",
            "n": "象州县",
            "pc": "451300"
        }, {
            "c": "451323",
            "n": "武宣县",
            "pc": "451300"
        }, {
            "c": "451324",
            "n": "金秀瑶族自治县",
            "pc": "451300"
        }, {
            "c": "451381",
            "n": "合山市",
            "pc": "451300"
        }, {
            "c": "451400",
            "n": "崇左市",
            "pc": "450000"
        }, {
            "c": "451401",
            "n": "市辖区",
            "pc": "451400"
        }, {
            "c": "451402",
            "n": "江洲区",
            "pc": "451400"
        }, {
            "c": "451421",
            "n": "扶绥县",
            "pc": "451400"
        }, {
            "c": "451422",
            "n": "宁明县",
            "pc": "451400"
        }, {
            "c": "451423",
            "n": "龙州县",
            "pc": "451400"
        }, {
            "c": "451424",
            "n": "大新县",
            "pc": "451400"
        }, {
            "c": "451425",
            "n": "天等县",
            "pc": "451400"
        }, {
            "c": "451481",
            "n": "凭祥市",
            "pc": "451400"
        }, {
            "c": "460000",
            "n": "海南省",
            "pc": "86"
        }, {
            "c": "460100",
            "n": "海口市",
            "pc": "460000"
        }, {
            "c": "460101",
            "n": "市辖区",
            "pc": "460100"
        }, {
            "c": "460105",
            "n": "秀英区",
            "pc": "460100"
        }, {
            "c": "460106",
            "n": "龙华区",
            "pc": "460100"
        }, {
            "c": "460107",
            "n": "琼山区",
            "pc": "460100"
        }, {
            "c": "460108",
            "n": "美兰区",
            "pc": "460100"
        }, {
            "c": "460200",
            "n": "三亚市",
            "pc": "460000"
        }, {
            "c": "460201",
            "n": "市辖区",
            "pc": "460200"
        }, {
            "c": "460300",
            "n": "三沙市",
            "pc": "460000"
        }, {
            "c": "460321",
            "n": "西沙群岛",
            "pc": "460300"
        }, {
            "c": "460322",
            "n": "南沙群岛",
            "pc": "460300"
        }, {
            "c": "460323",
            "n": "中沙群岛的岛礁及其海域",
            "pc": "460300"
        }, {
            "c": "469000",
            "n": "省直辖县级行政区划",
            "pc": "460000"
        }, {
            "c": "469001",
            "n": "五指山市",
            "pc": "469000"
        }, {
            "c": "469002",
            "n": "琼海市",
            "pc": "469000"
        }, {
            "c": "469003",
            "n": "儋州市",
            "pc": "469000"
        }, {
            "c": "469005",
            "n": "文昌市",
            "pc": "469000"
        }, {
            "c": "469006",
            "n": "万宁市",
            "pc": "469000"
        }, {
            "c": "469007",
            "n": "东方市",
            "pc": "469000"
        }, {
            "c": "469021",
            "n": "定安县",
            "pc": "469000"
        }, {
            "c": "469022",
            "n": "屯昌县",
            "pc": "469000"
        }, {
            "c": "469023",
            "n": "澄迈县",
            "pc": "469000"
        }, {
            "c": "469024",
            "n": "临高县",
            "pc": "469000"
        }, {
            "c": "469025",
            "n": "白沙黎族自治县",
            "pc": "469000"
        }, {
            "c": "469026",
            "n": "昌江黎族自治县",
            "pc": "469000"
        }, {
            "c": "469027",
            "n": "乐东黎族自治县",
            "pc": "469000"
        }, {
            "c": "469028",
            "n": "陵水黎族自治县",
            "pc": "469000"
        }, {
            "c": "469029",
            "n": "保亭黎族苗族自治县",
            "pc": "469000"
        }, {
            "c": "469030",
            "n": "琼中黎族苗族自治县",
            "pc": "469000"
        }, {
            "c": "500000",
            "n": "重庆市",
            "pc": "86"
        }, {
            "c": "500100",
            "n": "重庆市",
            "pc": "500000"
        }, {
            "c": "500101",
            "n": "万州区",
            "pc": "500100"
        }, {
            "c": "500102",
            "n": "涪陵区",
            "pc": "500100"
        }, {
            "c": "500103",
            "n": "渝中区",
            "pc": "500100"
        }, {
            "c": "500104",
            "n": "大渡口区",
            "pc": "500100"
        }, {
            "c": "500105",
            "n": "江北区",
            "pc": "500100"
        }, {
            "c": "500106",
            "n": "沙坪坝区",
            "pc": "500100"
        }, {
            "c": "500107",
            "n": "九龙坡区",
            "pc": "500100"
        }, {
            "c": "500108",
            "n": "南岸区",
            "pc": "500100"
        }, {
            "c": "500109",
            "n": "北碚区",
            "pc": "500100"
        }, {
            "c": "500110",
            "n": "綦江区",
            "pc": "500100"
        }, {
            "c": "500111",
            "n": "大足区",
            "pc": "500100"
        }, {
            "c": "500112",
            "n": "渝北区",
            "pc": "500100"
        }, {
            "c": "500113",
            "n": "巴南区",
            "pc": "500100"
        }, {
            "c": "500114",
            "n": "黔江区",
            "pc": "500100"
        }, {
            "c": "500115",
            "n": "长寿区",
            "pc": "500100"
        }, {
            "c": "500116",
            "n": "江津区",
            "pc": "500100"
        }, {
            "c": "500117",
            "n": "合川区",
            "pc": "500100"
        }, {
            "c": "500118",
            "n": "永川区",
            "pc": "500100"
        }, {
            "c": "500119",
            "n": "南川区",
            "pc": "500100"
        }, {
            "c": "500100",
            "n": "县",
            "pc": "500000"
        }, {
            "c": "500223",
            "n": "潼南县",
            "pc": "500100"
        }, {
            "c": "500224",
            "n": "铜梁县",
            "pc": "500100"
        }, {
            "c": "500226",
            "n": "荣昌县",
            "pc": "500100"
        }, {
            "c": "500227",
            "n": "璧山县",
            "pc": "500100"
        }, {
            "c": "500228",
            "n": "梁平县",
            "pc": "500100"
        }, {
            "c": "500229",
            "n": "城口县",
            "pc": "500100"
        }, {
            "c": "500230",
            "n": "丰都县",
            "pc": "500100"
        }, {
            "c": "500231",
            "n": "垫江县",
            "pc": "500100"
        }, {
            "c": "500232",
            "n": "武隆县",
            "pc": "500100"
        }, {
            "c": "500233",
            "n": "忠县",
            "pc": "500100"
        }, {
            "c": "500234",
            "n": "开县",
            "pc": "500100"
        }, {
            "c": "500235",
            "n": "云阳县",
            "pc": "500100"
        }, {
            "c": "500236",
            "n": "奉节县",
            "pc": "500100"
        }, {
            "c": "500237",
            "n": "巫山县",
            "pc": "500100"
        }, {
            "c": "500238",
            "n": "巫溪县",
            "pc": "500100"
        }, {
            "c": "500240",
            "n": "石柱土家族自治县",
            "pc": "500100"
        }, {
            "c": "500241",
            "n": "秀山土家族苗族自治县",
            "pc": "500100"
        }, {
            "c": "500242",
            "n": "酉阳土家族苗族自治县",
            "pc": "500100"
        }, {
            "c": "500243",
            "n": "彭水苗族土家族自治县",
            "pc": "500100"
        }, {
            "c": "510000",
            "n": "四川省",
            "pc": "86"
        }, {
            "c": "510100",
            "n": "成都市",
            "pc": "510000"
        }, {
            "c": "510101",
            "n": "市辖区",
            "pc": "510100"
        }, {
            "c": "510104",
            "n": "锦江区",
            "pc": "510100"
        }, {
            "c": "510105",
            "n": "青羊区",
            "pc": "510100"
        }, {
            "c": "510106",
            "n": "金牛区",
            "pc": "510100"
        }, {
            "c": "510107",
            "n": "武侯区",
            "pc": "510100"
        }, {
            "c": "510108",
            "n": "成华区",
            "pc": "510100"
        }, {
            "c": "510112",
            "n": "龙泉驿区",
            "pc": "510100"
        }, {
            "c": "510113",
            "n": "青白江区",
            "pc": "510100"
        }, {
            "c": "510114",
            "n": "新都区",
            "pc": "510100"
        }, {
            "c": "510115",
            "n": "温江区",
            "pc": "510100"
        }, {
            "c": "510121",
            "n": "金堂县",
            "pc": "510100"
        }, {
            "c": "510122",
            "n": "双流县",
            "pc": "510100"
        }, {
            "c": "510124",
            "n": "郫县",
            "pc": "510100"
        }, {
            "c": "510129",
            "n": "大邑县",
            "pc": "510100"
        }, {
            "c": "510131",
            "n": "蒲江县",
            "pc": "510100"
        }, {
            "c": "510132",
            "n": "新津县",
            "pc": "510100"
        }, {
            "c": "510181",
            "n": "都江堰市",
            "pc": "510100"
        }, {
            "c": "510182",
            "n": "彭州市",
            "pc": "510100"
        }, {
            "c": "510183",
            "n": "邛崃市",
            "pc": "510100"
        }, {
            "c": "510184",
            "n": "崇州市",
            "pc": "510100"
        }, {
            "c": "510300",
            "n": "自贡市",
            "pc": "510000"
        }, {
            "c": "510301",
            "n": "市辖区",
            "pc": "510300"
        }, {
            "c": "510302",
            "n": "自流井区",
            "pc": "510300"
        }, {
            "c": "510303",
            "n": "贡井区",
            "pc": "510300"
        }, {
            "c": "510304",
            "n": "大安区",
            "pc": "510300"
        }, {
            "c": "510311",
            "n": "沿滩区",
            "pc": "510300"
        }, {
            "c": "510321",
            "n": "荣县",
            "pc": "510300"
        }, {
            "c": "510322",
            "n": "富顺县",
            "pc": "510300"
        }, {
            "c": "510400",
            "n": "攀枝花市",
            "pc": "510000"
        }, {
            "c": "510401",
            "n": "市辖区",
            "pc": "510400"
        }, {
            "c": "510402",
            "n": "东区",
            "pc": "510400"
        }, {
            "c": "510403",
            "n": "西区",
            "pc": "510400"
        }, {
            "c": "510411",
            "n": "仁和区",
            "pc": "510400"
        }, {
            "c": "510421",
            "n": "米易县",
            "pc": "510400"
        }, {
            "c": "510422",
            "n": "盐边县",
            "pc": "510400"
        }, {
            "c": "510500",
            "n": "泸州市",
            "pc": "510000"
        }, {
            "c": "510501",
            "n": "市辖区",
            "pc": "510500"
        }, {
            "c": "510502",
            "n": "江阳区",
            "pc": "510500"
        }, {
            "c": "510503",
            "n": "纳溪区",
            "pc": "510500"
        }, {
            "c": "510504",
            "n": "龙马潭区",
            "pc": "510500"
        }, {
            "c": "510521",
            "n": "泸县",
            "pc": "510500"
        }, {
            "c": "510522",
            "n": "合江县",
            "pc": "510500"
        }, {
            "c": "510524",
            "n": "叙永县",
            "pc": "510500"
        }, {
            "c": "510525",
            "n": "古蔺县",
            "pc": "510500"
        }, {
            "c": "510600",
            "n": "德阳市",
            "pc": "510000"
        }, {
            "c": "510601",
            "n": "市辖区",
            "pc": "510600"
        }, {
            "c": "510603",
            "n": "旌阳区",
            "pc": "510600"
        }, {
            "c": "510623",
            "n": "中江县",
            "pc": "510600"
        }, {
            "c": "510626",
            "n": "罗江县",
            "pc": "510600"
        }, {
            "c": "510681",
            "n": "广汉市",
            "pc": "510600"
        }, {
            "c": "510682",
            "n": "什邡市",
            "pc": "510600"
        }, {
            "c": "510683",
            "n": "绵竹市",
            "pc": "510600"
        }, {
            "c": "510700",
            "n": "绵阳市",
            "pc": "510000"
        }, {
            "c": "510701",
            "n": "市辖区",
            "pc": "510700"
        }, {
            "c": "510703",
            "n": "涪城区",
            "pc": "510700"
        }, {
            "c": "510704",
            "n": "游仙区",
            "pc": "510700"
        }, {
            "c": "510722",
            "n": "三台县",
            "pc": "510700"
        }, {
            "c": "510723",
            "n": "盐亭县",
            "pc": "510700"
        }, {
            "c": "510724",
            "n": "安县",
            "pc": "510700"
        }, {
            "c": "510725",
            "n": "梓潼县",
            "pc": "510700"
        }, {
            "c": "510726",
            "n": "北川羌族自治县",
            "pc": "510700"
        }, {
            "c": "510727",
            "n": "平武县",
            "pc": "510700"
        }, {
            "c": "510781",
            "n": "江油市",
            "pc": "510700"
        }, {
            "c": "510800",
            "n": "广元市",
            "pc": "510000"
        }, {
            "c": "510801",
            "n": "市辖区",
            "pc": "510800"
        }, {
            "c": "510802",
            "n": "利州区",
            "pc": "510800"
        }, {
            "c": "510811",
            "n": "元坝区",
            "pc": "510800"
        }, {
            "c": "510812",
            "n": "朝天区",
            "pc": "510800"
        }, {
            "c": "510821",
            "n": "旺苍县",
            "pc": "510800"
        }, {
            "c": "510822",
            "n": "青川县",
            "pc": "510800"
        }, {
            "c": "510823",
            "n": "剑阁县",
            "pc": "510800"
        }, {
            "c": "510824",
            "n": "苍溪县",
            "pc": "510800"
        }, {
            "c": "510900",
            "n": "遂宁市",
            "pc": "510000"
        }, {
            "c": "510901",
            "n": "市辖区",
            "pc": "510900"
        }, {
            "c": "510903",
            "n": "船山区",
            "pc": "510900"
        }, {
            "c": "510904",
            "n": "安居区",
            "pc": "510900"
        }, {
            "c": "510921",
            "n": "蓬溪县",
            "pc": "510900"
        }, {
            "c": "510922",
            "n": "射洪县",
            "pc": "510900"
        }, {
            "c": "510923",
            "n": "大英县",
            "pc": "510900"
        }, {
            "c": "511000",
            "n": "内江市",
            "pc": "510000"
        }, {
            "c": "511001",
            "n": "市辖区",
            "pc": "511000"
        }, {
            "c": "511002",
            "n": "市中区",
            "pc": "511000"
        }, {
            "c": "511011",
            "n": "东兴区",
            "pc": "511000"
        }, {
            "c": "511024",
            "n": "威远县",
            "pc": "511000"
        }, {
            "c": "511025",
            "n": "资中县",
            "pc": "511000"
        }, {
            "c": "511028",
            "n": "隆昌县",
            "pc": "511000"
        }, {
            "c": "511100",
            "n": "乐山市",
            "pc": "510000"
        }, {
            "c": "511101",
            "n": "市辖区",
            "pc": "511100"
        }, {
            "c": "511102",
            "n": "市中区",
            "pc": "511100"
        }, {
            "c": "511111",
            "n": "沙湾区",
            "pc": "511100"
        }, {
            "c": "511112",
            "n": "五通桥区",
            "pc": "511100"
        }, {
            "c": "511113",
            "n": "金口河区",
            "pc": "511100"
        }, {
            "c": "511123",
            "n": "犍为县",
            "pc": "511100"
        }, {
            "c": "511124",
            "n": "井研县",
            "pc": "511100"
        }, {
            "c": "511126",
            "n": "夹江县",
            "pc": "511100"
        }, {
            "c": "511129",
            "n": "沐川县",
            "pc": "511100"
        }, {
            "c": "511132",
            "n": "峨边彝族自治县",
            "pc": "511100"
        }, {
            "c": "511133",
            "n": "马边彝族自治县",
            "pc": "511100"
        }, {
            "c": "511181",
            "n": "峨眉山市",
            "pc": "511100"
        }, {
            "c": "511300",
            "n": "南充市",
            "pc": "510000"
        }, {
            "c": "511301",
            "n": "市辖区",
            "pc": "511300"
        }, {
            "c": "511302",
            "n": "顺庆区",
            "pc": "511300"
        }, {
            "c": "511303",
            "n": "高坪区",
            "pc": "511300"
        }, {
            "c": "511304",
            "n": "嘉陵区",
            "pc": "511300"
        }, {
            "c": "511321",
            "n": "南部县",
            "pc": "511300"
        }, {
            "c": "511322",
            "n": "营山县",
            "pc": "511300"
        }, {
            "c": "511323",
            "n": "蓬安县",
            "pc": "511300"
        }, {
            "c": "511324",
            "n": "仪陇县",
            "pc": "511300"
        }, {
            "c": "511325",
            "n": "西充县",
            "pc": "511300"
        }, {
            "c": "511381",
            "n": "阆中市",
            "pc": "511300"
        }, {
            "c": "511400",
            "n": "眉山市",
            "pc": "510000"
        }, {
            "c": "511401",
            "n": "市辖区",
            "pc": "511400"
        }, {
            "c": "511402",
            "n": "东坡区",
            "pc": "511400"
        }, {
            "c": "511421",
            "n": "仁寿县",
            "pc": "511400"
        }, {
            "c": "511422",
            "n": "彭山县",
            "pc": "511400"
        }, {
            "c": "511423",
            "n": "洪雅县",
            "pc": "511400"
        }, {
            "c": "511424",
            "n": "丹棱县",
            "pc": "511400"
        }, {
            "c": "511425",
            "n": "青神县",
            "pc": "511400"
        }, {
            "c": "511500",
            "n": "宜宾市",
            "pc": "510000"
        }, {
            "c": "511501",
            "n": "市辖区",
            "pc": "511500"
        }, {
            "c": "511502",
            "n": "翠屏区",
            "pc": "511500"
        }, {
            "c": "511503",
            "n": "南溪区",
            "pc": "511500"
        }, {
            "c": "511521",
            "n": "宜宾县",
            "pc": "511500"
        }, {
            "c": "511523",
            "n": "江安县",
            "pc": "511500"
        }, {
            "c": "511524",
            "n": "长宁县",
            "pc": "511500"
        }, {
            "c": "511525",
            "n": "高县",
            "pc": "511500"
        }, {
            "c": "511526",
            "n": "珙县",
            "pc": "511500"
        }, {
            "c": "511527",
            "n": "筠连县",
            "pc": "511500"
        }, {
            "c": "511528",
            "n": "兴文县",
            "pc": "511500"
        }, {
            "c": "511529",
            "n": "屏山县",
            "pc": "511500"
        }, {
            "c": "511600",
            "n": "广安市",
            "pc": "510000"
        }, {
            "c": "511601",
            "n": "市辖区",
            "pc": "511600"
        }, {
            "c": "511602",
            "n": "广安区",
            "pc": "511600"
        }, {
            "c": "511621",
            "n": "岳池县",
            "pc": "511600"
        }, {
            "c": "511622",
            "n": "武胜县",
            "pc": "511600"
        }, {
            "c": "511623",
            "n": "邻水县",
            "pc": "511600"
        }, {
            "c": "511681",
            "n": "华蓥市",
            "pc": "511600"
        }, {
            "c": "511700",
            "n": "达州市",
            "pc": "510000"
        }, {
            "c": "511701",
            "n": "市辖区",
            "pc": "511700"
        }, {
            "c": "511702",
            "n": "通川区",
            "pc": "511700"
        }, {
            "c": "511721",
            "n": "达县",
            "pc": "511700"
        }, {
            "c": "511722",
            "n": "宣汉县",
            "pc": "511700"
        }, {
            "c": "511723",
            "n": "开江县",
            "pc": "511700"
        }, {
            "c": "511724",
            "n": "大竹县",
            "pc": "511700"
        }, {
            "c": "511725",
            "n": "渠县",
            "pc": "511700"
        }, {
            "c": "511781",
            "n": "万源市",
            "pc": "511700"
        }, {
            "c": "511800",
            "n": "雅安市",
            "pc": "510000"
        }, {
            "c": "511801",
            "n": "市辖区",
            "pc": "511800"
        }, {
            "c": "511802",
            "n": "雨城区",
            "pc": "511800"
        }, {
            "c": "511803",
            "n": "名山区",
            "pc": "511800"
        }, {
            "c": "511822",
            "n": "荥经县",
            "pc": "511800"
        }, {
            "c": "511823",
            "n": "汉源县",
            "pc": "511800"
        }, {
            "c": "511824",
            "n": "石棉县",
            "pc": "511800"
        }, {
            "c": "511825",
            "n": "天全县",
            "pc": "511800"
        }, {
            "c": "511826",
            "n": "芦山县",
            "pc": "511800"
        }, {
            "c": "511827",
            "n": "宝兴县",
            "pc": "511800"
        }, {
            "c": "511900",
            "n": "巴中市",
            "pc": "510000"
        }, {
            "c": "511901",
            "n": "市辖区",
            "pc": "511900"
        }, {
            "c": "511902",
            "n": "巴州区",
            "pc": "511900"
        }, {
            "c": "511921",
            "n": "通江县",
            "pc": "511900"
        }, {
            "c": "511922",
            "n": "南江县",
            "pc": "511900"
        }, {
            "c": "511923",
            "n": "平昌县",
            "pc": "511900"
        }, {
            "c": "512000",
            "n": "资阳市",
            "pc": "510000"
        }, {
            "c": "512001",
            "n": "市辖区",
            "pc": "512000"
        }, {
            "c": "512002",
            "n": "雁江区",
            "pc": "512000"
        }, {
            "c": "512021",
            "n": "安岳县",
            "pc": "512000"
        }, {
            "c": "512022",
            "n": "乐至县",
            "pc": "512000"
        }, {
            "c": "512081",
            "n": "简阳市",
            "pc": "512000"
        }, {
            "c": "513200",
            "n": "阿坝藏族羌族自治州",
            "pc": "510000"
        }, {
            "c": "513221",
            "n": "汶川县",
            "pc": "513200"
        }, {
            "c": "513222",
            "n": "理县",
            "pc": "513200"
        }, {
            "c": "513223",
            "n": "茂县",
            "pc": "513200"
        }, {
            "c": "513224",
            "n": "松潘县",
            "pc": "513200"
        }, {
            "c": "513225",
            "n": "九寨沟县",
            "pc": "513200"
        }, {
            "c": "513226",
            "n": "金川县",
            "pc": "513200"
        }, {
            "c": "513227",
            "n": "小金县",
            "pc": "513200"
        }, {
            "c": "513228",
            "n": "黑水县",
            "pc": "513200"
        }, {
            "c": "513229",
            "n": "马尔康县",
            "pc": "513200"
        }, {
            "c": "513230",
            "n": "壤塘县",
            "pc": "513200"
        }, {
            "c": "513231",
            "n": "阿坝县",
            "pc": "513200"
        }, {
            "c": "513232",
            "n": "若尔盖县",
            "pc": "513200"
        }, {
            "c": "513233",
            "n": "红原县",
            "pc": "513200"
        }, {
            "c": "513300",
            "n": "甘孜藏族自治州",
            "pc": "510000"
        }, {
            "c": "513321",
            "n": "康定县",
            "pc": "513300"
        }, {
            "c": "513322",
            "n": "泸定县",
            "pc": "513300"
        }, {
            "c": "513323",
            "n": "丹巴县",
            "pc": "513300"
        }, {
            "c": "513324",
            "n": "九龙县",
            "pc": "513300"
        }, {
            "c": "513325",
            "n": "雅江县",
            "pc": "513300"
        }, {
            "c": "513326",
            "n": "道孚县",
            "pc": "513300"
        }, {
            "c": "513327",
            "n": "炉霍县",
            "pc": "513300"
        }, {
            "c": "513328",
            "n": "甘孜县",
            "pc": "513300"
        }, {
            "c": "513329",
            "n": "新龙县",
            "pc": "513300"
        }, {
            "c": "513330",
            "n": "德格县",
            "pc": "513300"
        }, {
            "c": "513331",
            "n": "白玉县",
            "pc": "513300"
        }, {
            "c": "513332",
            "n": "石渠县",
            "pc": "513300"
        }, {
            "c": "513333",
            "n": "色达县",
            "pc": "513300"
        }, {
            "c": "513334",
            "n": "理塘县",
            "pc": "513300"
        }, {
            "c": "513335",
            "n": "巴塘县",
            "pc": "513300"
        }, {
            "c": "513336",
            "n": "乡城县",
            "pc": "513300"
        }, {
            "c": "513337",
            "n": "稻城县",
            "pc": "513300"
        }, {
            "c": "513338",
            "n": "得荣县",
            "pc": "513300"
        }, {
            "c": "513400",
            "n": "凉山彝族自治州",
            "pc": "510000"
        }, {
            "c": "513401",
            "n": "西昌市",
            "pc": "513400"
        }, {
            "c": "513422",
            "n": "木里藏族自治县",
            "pc": "513400"
        }, {
            "c": "513423",
            "n": "盐源县",
            "pc": "513400"
        }, {
            "c": "513424",
            "n": "德昌县",
            "pc": "513400"
        }, {
            "c": "513425",
            "n": "会理县",
            "pc": "513400"
        }, {
            "c": "513426",
            "n": "会东县",
            "pc": "513400"
        }, {
            "c": "513427",
            "n": "宁南县",
            "pc": "513400"
        }, {
            "c": "513428",
            "n": "普格县",
            "pc": "513400"
        }, {
            "c": "513429",
            "n": "布拖县",
            "pc": "513400"
        }, {
            "c": "513430",
            "n": "金阳县",
            "pc": "513400"
        }, {
            "c": "513431",
            "n": "昭觉县",
            "pc": "513400"
        }, {
            "c": "513432",
            "n": "喜德县",
            "pc": "513400"
        }, {
            "c": "513433",
            "n": "冕宁县",
            "pc": "513400"
        }, {
            "c": "513434",
            "n": "越西县",
            "pc": "513400"
        }, {
            "c": "513435",
            "n": "甘洛县",
            "pc": "513400"
        }, {
            "c": "513436",
            "n": "美姑县",
            "pc": "513400"
        }, {
            "c": "513437",
            "n": "雷波县",
            "pc": "513400"
        }, {
            "c": "520000",
            "n": "贵州省",
            "pc": "86"
        }, {
            "c": "520100",
            "n": "贵阳市",
            "pc": "520000"
        }, {
            "c": "520101",
            "n": "市辖区",
            "pc": "520100"
        }, {
            "c": "520102",
            "n": "南明区",
            "pc": "520100"
        }, {
            "c": "520103",
            "n": "云岩区",
            "pc": "520100"
        }, {
            "c": "520111",
            "n": "花溪区",
            "pc": "520100"
        }, {
            "c": "520112",
            "n": "乌当区",
            "pc": "520100"
        }, {
            "c": "520113",
            "n": "白云区",
            "pc": "520100"
        }, {
            "c": "520114",
            "n": "小河区",
            "pc": "520100"
        }, {
            "c": "520121",
            "n": "开阳县",
            "pc": "520100"
        }, {
            "c": "520122",
            "n": "息烽县",
            "pc": "520100"
        }, {
            "c": "520123",
            "n": "修文县",
            "pc": "520100"
        }, {
            "c": "520181",
            "n": "清镇市",
            "pc": "520100"
        }, {
            "c": "520200",
            "n": "六盘水市",
            "pc": "520000"
        }, {
            "c": "520201",
            "n": "钟山区",
            "pc": "520200"
        }, {
            "c": "520203",
            "n": "六枝特区",
            "pc": "520200"
        }, {
            "c": "520221",
            "n": "水城县",
            "pc": "520200"
        }, {
            "c": "520222",
            "n": "盘县",
            "pc": "520200"
        }, {
            "c": "520300",
            "n": "遵义市",
            "pc": "520000"
        }, {
            "c": "520301",
            "n": "市辖区",
            "pc": "520300"
        }, {
            "c": "520302",
            "n": "红花岗区",
            "pc": "520300"
        }, {
            "c": "520303",
            "n": "汇川区",
            "pc": "520300"
        }, {
            "c": "520321",
            "n": "遵义县",
            "pc": "520300"
        }, {
            "c": "520322",
            "n": "桐梓县",
            "pc": "520300"
        }, {
            "c": "520323",
            "n": "绥阳县",
            "pc": "520300"
        }, {
            "c": "520324",
            "n": "正安县",
            "pc": "520300"
        }, {
            "c": "520325",
            "n": "道真仡佬族苗族自治县",
            "pc": "520300"
        }, {
            "c": "520326",
            "n": "务川仡佬族苗族自治县",
            "pc": "520300"
        }, {
            "c": "520327",
            "n": "凤冈县",
            "pc": "520300"
        }, {
            "c": "520328",
            "n": "湄潭县",
            "pc": "520300"
        }, {
            "c": "520329",
            "n": "余庆县",
            "pc": "520300"
        }, {
            "c": "520330",
            "n": "习水县",
            "pc": "520300"
        }, {
            "c": "520381",
            "n": "赤水市",
            "pc": "520300"
        }, {
            "c": "520382",
            "n": "仁怀市",
            "pc": "520300"
        }, {
            "c": "520400",
            "n": "安顺市",
            "pc": "520000"
        }, {
            "c": "520401",
            "n": "市辖区",
            "pc": "520400"
        }, {
            "c": "520402",
            "n": "西秀区",
            "pc": "520400"
        }, {
            "c": "520421",
            "n": "平坝县",
            "pc": "520400"
        }, {
            "c": "520422",
            "n": "普定县",
            "pc": "520400"
        }, {
            "c": "520423",
            "n": "镇宁布依族苗族自治县",
            "pc": "520400"
        }, {
            "c": "520424",
            "n": "关岭布依族苗族自治县",
            "pc": "520400"
        }, {
            "c": "520425",
            "n": "紫云苗族布依族自治县",
            "pc": "520400"
        }, {
            "c": "520500",
            "n": "毕节市",
            "pc": "520000"
        }, {
            "c": "520502",
            "n": "七星关区",
            "pc": "520500"
        }, {
            "c": "520521",
            "n": "大方县",
            "pc": "520500"
        }, {
            "c": "520522",
            "n": "黔西县",
            "pc": "520500"
        }, {
            "c": "520523",
            "n": "金沙县",
            "pc": "520500"
        }, {
            "c": "520524",
            "n": "织金县",
            "pc": "520500"
        }, {
            "c": "520525",
            "n": "纳雍县",
            "pc": "520500"
        }, {
            "c": "520526",
            "n": "威宁彝族回族苗族自治县",
            "pc": "520500"
        }, {
            "c": "520527",
            "n": "赫章县",
            "pc": "520500"
        }, {
            "c": "520600",
            "n": "铜仁市",
            "pc": "520000"
        }, {
            "c": "520602",
            "n": "碧江区",
            "pc": "520600"
        }, {
            "c": "520603",
            "n": "万山区",
            "pc": "520600"
        }, {
            "c": "520621",
            "n": "江口县",
            "pc": "520600"
        }, {
            "c": "520622",
            "n": "玉屏侗族自治县",
            "pc": "520600"
        }, {
            "c": "520623",
            "n": "石阡县",
            "pc": "520600"
        }, {
            "c": "520624",
            "n": "思南县",
            "pc": "520600"
        }, {
            "c": "520625",
            "n": "印江土家族苗族自治县",
            "pc": "520600"
        }, {
            "c": "520626",
            "n": "德江县",
            "pc": "520600"
        }, {
            "c": "520627",
            "n": "沿河土家族自治县",
            "pc": "520600"
        }, {
            "c": "520628",
            "n": "松桃苗族自治县",
            "pc": "520600"
        }, {
            "c": "522300",
            "n": "黔西南布依族苗族自治州",
            "pc": "520000"
        }, {
            "c": "522301",
            "n": "兴义市",
            "pc": "522300"
        }, {
            "c": "522322",
            "n": "兴仁县",
            "pc": "522300"
        }, {
            "c": "522323",
            "n": "普安县",
            "pc": "522300"
        }, {
            "c": "522324",
            "n": "晴隆县",
            "pc": "522300"
        }, {
            "c": "522325",
            "n": "贞丰县",
            "pc": "522300"
        }, {
            "c": "522326",
            "n": "望谟县",
            "pc": "522300"
        }, {
            "c": "522327",
            "n": "册亨县",
            "pc": "522300"
        }, {
            "c": "522328",
            "n": "安龙县",
            "pc": "522300"
        }, {
            "c": "522600",
            "n": "黔东南苗族侗族自治州",
            "pc": "520000"
        }, {
            "c": "522601",
            "n": "凯里市",
            "pc": "522600"
        }, {
            "c": "522622",
            "n": "黄平县",
            "pc": "522600"
        }, {
            "c": "522623",
            "n": "施秉县",
            "pc": "522600"
        }, {
            "c": "522624",
            "n": "三穗县",
            "pc": "522600"
        }, {
            "c": "522625",
            "n": "镇远县",
            "pc": "522600"
        }, {
            "c": "522626",
            "n": "岑巩县",
            "pc": "522600"
        }, {
            "c": "522627",
            "n": "天柱县",
            "pc": "522600"
        }, {
            "c": "522628",
            "n": "锦屏县",
            "pc": "522600"
        }, {
            "c": "522629",
            "n": "剑河县",
            "pc": "522600"
        }, {
            "c": "522630",
            "n": "台江县",
            "pc": "522600"
        }, {
            "c": "522631",
            "n": "黎平县",
            "pc": "522600"
        }, {
            "c": "522632",
            "n": "榕江县",
            "pc": "522600"
        }, {
            "c": "522633",
            "n": "从江县",
            "pc": "522600"
        }, {
            "c": "522634",
            "n": "雷山县",
            "pc": "522600"
        }, {
            "c": "522635",
            "n": "麻江县",
            "pc": "522600"
        }, {
            "c": "522636",
            "n": "丹寨县",
            "pc": "522600"
        }, {
            "c": "522700",
            "n": "黔南布依族苗族自治州",
            "pc": "520000"
        }, {
            "c": "522701",
            "n": "都匀市",
            "pc": "522700"
        }, {
            "c": "522702",
            "n": "福泉市",
            "pc": "522700"
        }, {
            "c": "522722",
            "n": "荔波县",
            "pc": "522700"
        }, {
            "c": "522723",
            "n": "贵定县",
            "pc": "522700"
        }, {
            "c": "522725",
            "n": "瓮安县",
            "pc": "522700"
        }, {
            "c": "522726",
            "n": "独山县",
            "pc": "522700"
        }, {
            "c": "522727",
            "n": "平塘县",
            "pc": "522700"
        }, {
            "c": "522728",
            "n": "罗甸县",
            "pc": "522700"
        }, {
            "c": "522729",
            "n": "长顺县",
            "pc": "522700"
        }, {
            "c": "522730",
            "n": "龙里县",
            "pc": "522700"
        }, {
            "c": "522731",
            "n": "惠水县",
            "pc": "522700"
        }, {
            "c": "522732",
            "n": "三都水族自治县",
            "pc": "522700"
        }, {
            "c": "530000",
            "n": "云南省",
            "pc": "86"
        }, {
            "c": "530100",
            "n": "昆明市",
            "pc": "530000"
        }, {
            "c": "530101",
            "n": "市辖区",
            "pc": "530100"
        }, {
            "c": "530102",
            "n": "五华区",
            "pc": "530100"
        }, {
            "c": "530103",
            "n": "盘龙区",
            "pc": "530100"
        }, {
            "c": "530111",
            "n": "官渡区",
            "pc": "530100"
        }, {
            "c": "530112",
            "n": "西山区",
            "pc": "530100"
        }, {
            "c": "530113",
            "n": "东川区",
            "pc": "530100"
        }, {
            "c": "530114",
            "n": "呈贡区",
            "pc": "530100"
        }, {
            "c": "530122",
            "n": "晋宁县",
            "pc": "530100"
        }, {
            "c": "530124",
            "n": "富民县",
            "pc": "530100"
        }, {
            "c": "530125",
            "n": "宜良县",
            "pc": "530100"
        }, {
            "c": "530126",
            "n": "石林彝族自治县",
            "pc": "530100"
        }, {
            "c": "530127",
            "n": "嵩明县",
            "pc": "530100"
        }, {
            "c": "530128",
            "n": "禄劝彝族苗族自治县",
            "pc": "530100"
        }, {
            "c": "530129",
            "n": "寻甸回族彝族自治县",
            "pc": "530100"
        }, {
            "c": "530181",
            "n": "安宁市",
            "pc": "530100"
        }, {
            "c": "530300",
            "n": "曲靖市",
            "pc": "530000"
        }, {
            "c": "530301",
            "n": "市辖区",
            "pc": "530300"
        }, {
            "c": "530302",
            "n": "麒麟区",
            "pc": "530300"
        }, {
            "c": "530321",
            "n": "马龙县",
            "pc": "530300"
        }, {
            "c": "530322",
            "n": "陆良县",
            "pc": "530300"
        }, {
            "c": "530323",
            "n": "师宗县",
            "pc": "530300"
        }, {
            "c": "530324",
            "n": "罗平县",
            "pc": "530300"
        }, {
            "c": "530325",
            "n": "富源县",
            "pc": "530300"
        }, {
            "c": "530326",
            "n": "会泽县",
            "pc": "530300"
        }, {
            "c": "530328",
            "n": "沾益县",
            "pc": "530300"
        }, {
            "c": "530381",
            "n": "宣威市",
            "pc": "530300"
        }, {
            "c": "530400",
            "n": "玉溪市",
            "pc": "530000"
        }, {
            "c": "530402",
            "n": "红塔区",
            "pc": "530400"
        }, {
            "c": "530421",
            "n": "江川县",
            "pc": "530400"
        }, {
            "c": "530422",
            "n": "澄江县",
            "pc": "530400"
        }, {
            "c": "530423",
            "n": "通海县",
            "pc": "530400"
        }, {
            "c": "530424",
            "n": "华宁县",
            "pc": "530400"
        }, {
            "c": "530425",
            "n": "易门县",
            "pc": "530400"
        }, {
            "c": "530426",
            "n": "峨山彝族自治县",
            "pc": "530400"
        }, {
            "c": "530427",
            "n": "新平彝族傣族自治县",
            "pc": "530400"
        }, {
            "c": "530428",
            "n": "元江哈尼族彝族傣族自治县",
            "pc": "530400"
        }, {
            "c": "530500",
            "n": "保山市",
            "pc": "530000"
        }, {
            "c": "530501",
            "n": "市辖区",
            "pc": "530500"
        }, {
            "c": "530502",
            "n": "隆阳区",
            "pc": "530500"
        }, {
            "c": "530521",
            "n": "施甸县",
            "pc": "530500"
        }, {
            "c": "530522",
            "n": "腾冲县",
            "pc": "530500"
        }, {
            "c": "530523",
            "n": "龙陵县",
            "pc": "530500"
        }, {
            "c": "530524",
            "n": "昌宁县",
            "pc": "530500"
        }, {
            "c": "530600",
            "n": "昭通市",
            "pc": "530000"
        }, {
            "c": "530601",
            "n": "市辖区",
            "pc": "530600"
        }, {
            "c": "530602",
            "n": "昭阳区",
            "pc": "530600"
        }, {
            "c": "530621",
            "n": "鲁甸县",
            "pc": "530600"
        }, {
            "c": "530622",
            "n": "巧家县",
            "pc": "530600"
        }, {
            "c": "530623",
            "n": "盐津县",
            "pc": "530600"
        }, {
            "c": "530624",
            "n": "大关县",
            "pc": "530600"
        }, {
            "c": "530625",
            "n": "永善县",
            "pc": "530600"
        }, {
            "c": "530626",
            "n": "绥江县",
            "pc": "530600"
        }, {
            "c": "530627",
            "n": "镇雄县",
            "pc": "530600"
        }, {
            "c": "530628",
            "n": "彝良县",
            "pc": "530600"
        }, {
            "c": "530629",
            "n": "威信县",
            "pc": "530600"
        }, {
            "c": "530630",
            "n": "水富县",
            "pc": "530600"
        }, {
            "c": "530700",
            "n": "丽江市",
            "pc": "530000"
        }, {
            "c": "530701",
            "n": "市辖区",
            "pc": "530700"
        }, {
            "c": "530702",
            "n": "古城区",
            "pc": "530700"
        }, {
            "c": "530721",
            "n": "玉龙纳西族自治县",
            "pc": "530700"
        }, {
            "c": "530722",
            "n": "永胜县",
            "pc": "530700"
        }, {
            "c": "530723",
            "n": "华坪县",
            "pc": "530700"
        }, {
            "c": "530724",
            "n": "宁蒗彝族自治县",
            "pc": "530700"
        }, {
            "c": "530800",
            "n": "普洱市",
            "pc": "530000"
        }, {
            "c": "530801",
            "n": "市辖区",
            "pc": "530800"
        }, {
            "c": "530802",
            "n": "思茅区",
            "pc": "530800"
        }, {
            "c": "530821",
            "n": "宁洱哈尼族彝族自治县",
            "pc": "530800"
        }, {
            "c": "530822",
            "n": "墨江哈尼族自治县",
            "pc": "530800"
        }, {
            "c": "530823",
            "n": "景东彝族自治县",
            "pc": "530800"
        }, {
            "c": "530824",
            "n": "景谷傣族彝族自治县",
            "pc": "530800"
        }, {
            "c": "530825",
            "n": "镇沅彝族哈尼族拉祜族自治县",
            "pc": "530800"
        }, {
            "c": "530826",
            "n": "江城哈尼族彝族自治县",
            "pc": "530800"
        }, {
            "c": "530827",
            "n": "孟连傣族拉祜族佤族自治县",
            "pc": "530800"
        }, {
            "c": "530828",
            "n": "澜沧拉祜族自治县",
            "pc": "530800"
        }, {
            "c": "530829",
            "n": "西盟佤族自治县",
            "pc": "530800"
        }, {
            "c": "530900",
            "n": "临沧市",
            "pc": "530000"
        }, {
            "c": "530901",
            "n": "市辖区",
            "pc": "530900"
        }, {
            "c": "530902",
            "n": "临翔区",
            "pc": "530900"
        }, {
            "c": "530921",
            "n": "凤庆县",
            "pc": "530900"
        }, {
            "c": "530922",
            "n": "云县",
            "pc": "530900"
        }, {
            "c": "530923",
            "n": "永德县",
            "pc": "530900"
        }, {
            "c": "530924",
            "n": "镇康县",
            "pc": "530900"
        }, {
            "c": "530925",
            "n": "双江拉祜族佤族布朗族傣族自治县",
            "pc": "530900"
        }, {
            "c": "530926",
            "n": "耿马傣族佤族自治县",
            "pc": "530900"
        }, {
            "c": "530927",
            "n": "沧源佤族自治县",
            "pc": "530900"
        }, {
            "c": "532300",
            "n": "楚雄彝族自治州",
            "pc": "530000"
        }, {
            "c": "532301",
            "n": "楚雄市",
            "pc": "532300"
        }, {
            "c": "532322",
            "n": "双柏县",
            "pc": "532300"
        }, {
            "c": "532323",
            "n": "牟定县",
            "pc": "532300"
        }, {
            "c": "532324",
            "n": "南华县",
            "pc": "532300"
        }, {
            "c": "532325",
            "n": "姚安县",
            "pc": "532300"
        }, {
            "c": "532326",
            "n": "大姚县",
            "pc": "532300"
        }, {
            "c": "532327",
            "n": "永仁县",
            "pc": "532300"
        }, {
            "c": "532328",
            "n": "元谋县",
            "pc": "532300"
        }, {
            "c": "532329",
            "n": "武定县",
            "pc": "532300"
        }, {
            "c": "532331",
            "n": "禄丰县",
            "pc": "532300"
        }, {
            "c": "532500",
            "n": "红河哈尼族彝族自治州",
            "pc": "530000"
        }, {
            "c": "532501",
            "n": "个旧市",
            "pc": "532500"
        }, {
            "c": "532502",
            "n": "开远市",
            "pc": "532500"
        }, {
            "c": "532503",
            "n": "蒙自市",
            "pc": "532500"
        }, {
            "c": "532523",
            "n": "屏边苗族自治县",
            "pc": "532500"
        }, {
            "c": "532524",
            "n": "建水县",
            "pc": "532500"
        }, {
            "c": "532525",
            "n": "石屏县",
            "pc": "532500"
        }, {
            "c": "532526",
            "n": "弥勒县",
            "pc": "532500"
        }, {
            "c": "532527",
            "n": "泸西县",
            "pc": "532500"
        }, {
            "c": "532528",
            "n": "元阳县",
            "pc": "532500"
        }, {
            "c": "532529",
            "n": "红河县",
            "pc": "532500"
        }, {
            "c": "532530",
            "n": "金平苗族瑶族傣族自治县",
            "pc": "532500"
        }, {
            "c": "532531",
            "n": "绿春县",
            "pc": "532500"
        }, {
            "c": "532532",
            "n": "河口瑶族自治县",
            "pc": "532500"
        }, {
            "c": "532600",
            "n": "文山壮族苗族自治州",
            "pc": "530000"
        }, {
            "c": "532601",
            "n": "文山市",
            "pc": "532600"
        }, {
            "c": "532622",
            "n": "砚山县",
            "pc": "532600"
        }, {
            "c": "532623",
            "n": "西畴县",
            "pc": "532600"
        }, {
            "c": "532624",
            "n": "麻栗坡县",
            "pc": "532600"
        }, {
            "c": "532625",
            "n": "马关县",
            "pc": "532600"
        }, {
            "c": "532626",
            "n": "丘北县",
            "pc": "532600"
        }, {
            "c": "532627",
            "n": "广南县",
            "pc": "532600"
        }, {
            "c": "532628",
            "n": "富宁县",
            "pc": "532600"
        }, {
            "c": "532800",
            "n": "西双版纳傣族自治州",
            "pc": "530000"
        }, {
            "c": "532801",
            "n": "景洪市",
            "pc": "532800"
        }, {
            "c": "532822",
            "n": "勐海县",
            "pc": "532800"
        }, {
            "c": "532823",
            "n": "勐腊县",
            "pc": "532800"
        }, {
            "c": "532900",
            "n": "大理白族自治州",
            "pc": "530000"
        }, {
            "c": "532901",
            "n": "大理市",
            "pc": "532900"
        }, {
            "c": "532922",
            "n": "漾濞彝族自治县",
            "pc": "532900"
        }, {
            "c": "532923",
            "n": "祥云县",
            "pc": "532900"
        }, {
            "c": "532924",
            "n": "宾川县",
            "pc": "532900"
        }, {
            "c": "532925",
            "n": "弥渡县",
            "pc": "532900"
        }, {
            "c": "532926",
            "n": "南涧彝族自治县",
            "pc": "532900"
        }, {
            "c": "532927",
            "n": "巍山彝族回族自治县",
            "pc": "532900"
        }, {
            "c": "532928",
            "n": "永平县",
            "pc": "532900"
        }, {
            "c": "532929",
            "n": "云龙县",
            "pc": "532900"
        }, {
            "c": "532930",
            "n": "洱源县",
            "pc": "532900"
        }, {
            "c": "532931",
            "n": "剑川县",
            "pc": "532900"
        }, {
            "c": "532932",
            "n": "鹤庆县",
            "pc": "532900"
        }, {
            "c": "533100",
            "n": "德宏傣族景颇族自治州",
            "pc": "530000"
        }, {
            "c": "533102",
            "n": "瑞丽市",
            "pc": "533100"
        }, {
            "c": "533103",
            "n": "芒市",
            "pc": "533100"
        }, {
            "c": "533122",
            "n": "梁河县",
            "pc": "533100"
        }, {
            "c": "533123",
            "n": "盈江县",
            "pc": "533100"
        }, {
            "c": "533124",
            "n": "陇川县",
            "pc": "533100"
        }, {
            "c": "533300",
            "n": "怒江傈僳族自治州",
            "pc": "530000"
        }, {
            "c": "533321",
            "n": "泸水县",
            "pc": "533300"
        }, {
            "c": "533323",
            "n": "福贡县",
            "pc": "533300"
        }, {
            "c": "533324",
            "n": "贡山独龙族怒族自治县",
            "pc": "533300"
        }, {
            "c": "533325",
            "n": "兰坪白族普米族自治县",
            "pc": "533300"
        }, {
            "c": "533400",
            "n": "迪庆藏族自治州",
            "pc": "530000"
        }, {
            "c": "533421",
            "n": "香格里拉县",
            "pc": "533400"
        }, {
            "c": "533422",
            "n": "德钦县",
            "pc": "533400"
        }, {
            "c": "533423",
            "n": "维西傈僳族自治县",
            "pc": "533400"
        }, {
            "c": "540000",
            "n": "西藏自治区",
            "pc": "86"
        }, {
            "c": "540100",
            "n": "拉萨市",
            "pc": "540000"
        }, {
            "c": "540101",
            "n": "市辖区",
            "pc": "540100"
        }, {
            "c": "540102",
            "n": "城关区",
            "pc": "540100"
        }, {
            "c": "540121",
            "n": "林周县",
            "pc": "540100"
        }, {
            "c": "540122",
            "n": "当雄县",
            "pc": "540100"
        }, {
            "c": "540123",
            "n": "尼木县",
            "pc": "540100"
        }, {
            "c": "540124",
            "n": "曲水县",
            "pc": "540100"
        }, {
            "c": "540125",
            "n": "堆龙德庆县",
            "pc": "540100"
        }, {
            "c": "540126",
            "n": "达孜县",
            "pc": "540100"
        }, {
            "c": "540127",
            "n": "墨竹工卡县",
            "pc": "540100"
        }, {
            "c": "542100",
            "n": "昌都地区",
            "pc": "540000"
        }, {
            "c": "542121",
            "n": "昌都县",
            "pc": "542100"
        }, {
            "c": "542122",
            "n": "江达县",
            "pc": "542100"
        }, {
            "c": "542123",
            "n": "贡觉县",
            "pc": "542100"
        }, {
            "c": "542124",
            "n": "类乌齐县",
            "pc": "542100"
        }, {
            "c": "542125",
            "n": "丁青县",
            "pc": "542100"
        }, {
            "c": "542126",
            "n": "察雅县",
            "pc": "542100"
        }, {
            "c": "542127",
            "n": "八宿县",
            "pc": "542100"
        }, {
            "c": "542128",
            "n": "左贡县",
            "pc": "542100"
        }, {
            "c": "542129",
            "n": "芒康县",
            "pc": "542100"
        }, {
            "c": "542132",
            "n": "洛隆县",
            "pc": "542100"
        }, {
            "c": "542133",
            "n": "边坝县",
            "pc": "542100"
        }, {
            "c": "542200",
            "n": "山南地区",
            "pc": "540000"
        }, {
            "c": "542221",
            "n": "乃东县",
            "pc": "542200"
        }, {
            "c": "542222",
            "n": "扎囊县",
            "pc": "542200"
        }, {
            "c": "542223",
            "n": "贡嘎县",
            "pc": "542200"
        }, {
            "c": "542224",
            "n": "桑日县",
            "pc": "542200"
        }, {
            "c": "542225",
            "n": "琼结县",
            "pc": "542200"
        }, {
            "c": "542226",
            "n": "曲松县",
            "pc": "542200"
        }, {
            "c": "542227",
            "n": "措美县",
            "pc": "542200"
        }, {
            "c": "542228",
            "n": "洛扎县",
            "pc": "542200"
        }, {
            "c": "542229",
            "n": "加查县",
            "pc": "542200"
        }, {
            "c": "542231",
            "n": "隆子县",
            "pc": "542200"
        }, {
            "c": "542232",
            "n": "错那县",
            "pc": "542200"
        }, {
            "c": "542233",
            "n": "浪卡子县",
            "pc": "542200"
        }, {
            "c": "542300",
            "n": "日喀则地区",
            "pc": "540000"
        }, {
            "c": "542301",
            "n": "日喀则市",
            "pc": "542300"
        }, {
            "c": "542322",
            "n": "南木林县",
            "pc": "542300"
        }, {
            "c": "542323",
            "n": "江孜县",
            "pc": "542300"
        }, {
            "c": "542324",
            "n": "定日县",
            "pc": "542300"
        }, {
            "c": "542325",
            "n": "萨迦县",
            "pc": "542300"
        }, {
            "c": "542326",
            "n": "拉孜县",
            "pc": "542300"
        }, {
            "c": "542327",
            "n": "昂仁县",
            "pc": "542300"
        }, {
            "c": "542328",
            "n": "谢通门县",
            "pc": "542300"
        }, {
            "c": "542329",
            "n": "白朗县",
            "pc": "542300"
        }, {
            "c": "542330",
            "n": "仁布县",
            "pc": "542300"
        }, {
            "c": "542331",
            "n": "康马县",
            "pc": "542300"
        }, {
            "c": "542332",
            "n": "定结县",
            "pc": "542300"
        }, {
            "c": "542333",
            "n": "仲巴县",
            "pc": "542300"
        }, {
            "c": "542334",
            "n": "亚东县",
            "pc": "542300"
        }, {
            "c": "542335",
            "n": "吉隆县",
            "pc": "542300"
        }, {
            "c": "542336",
            "n": "聂拉木县",
            "pc": "542300"
        }, {
            "c": "542337",
            "n": "萨嘎县",
            "pc": "542300"
        }, {
            "c": "542338",
            "n": "岗巴县",
            "pc": "542300"
        }, {
            "c": "542400",
            "n": "那曲地区",
            "pc": "540000"
        }, {
            "c": "542421",
            "n": "那曲县",
            "pc": "542400"
        }, {
            "c": "542422",
            "n": "嘉黎县",
            "pc": "542400"
        }, {
            "c": "542423",
            "n": "比如县",
            "pc": "542400"
        }, {
            "c": "542424",
            "n": "聂荣县",
            "pc": "542400"
        }, {
            "c": "542425",
            "n": "安多县",
            "pc": "542400"
        }, {
            "c": "542426",
            "n": "申扎县",
            "pc": "542400"
        }, {
            "c": "542427",
            "n": "索县",
            "pc": "542400"
        }, {
            "c": "542428",
            "n": "班戈县",
            "pc": "542400"
        }, {
            "c": "542429",
            "n": "巴青县",
            "pc": "542400"
        }, {
            "c": "542430",
            "n": "尼玛县",
            "pc": "542400"
        }, {
            "c": "542500",
            "n": "阿里地区",
            "pc": "540000"
        }, {
            "c": "542521",
            "n": "普兰县",
            "pc": "542500"
        }, {
            "c": "542522",
            "n": "札达县",
            "pc": "542500"
        }, {
            "c": "542523",
            "n": "噶尔县",
            "pc": "542500"
        }, {
            "c": "542524",
            "n": "日土县",
            "pc": "542500"
        }, {
            "c": "542525",
            "n": "革吉县",
            "pc": "542500"
        }, {
            "c": "542526",
            "n": "改则县",
            "pc": "542500"
        }, {
            "c": "542527",
            "n": "措勤县",
            "pc": "542500"
        }, {
            "c": "542600",
            "n": "林芝地区",
            "pc": "540000"
        }, {
            "c": "542621",
            "n": "林芝县",
            "pc": "542600"
        }, {
            "c": "542622",
            "n": "工布江达县",
            "pc": "542600"
        }, {
            "c": "542623",
            "n": "米林县",
            "pc": "542600"
        }, {
            "c": "542624",
            "n": "墨脱县",
            "pc": "542600"
        }, {
            "c": "542625",
            "n": "波密县",
            "pc": "542600"
        }, {
            "c": "542626",
            "n": "察隅县",
            "pc": "542600"
        }, {
            "c": "542627",
            "n": "朗县",
            "pc": "542600"
        }, {
            "c": "610000",
            "n": "陕西省",
            "pc": "86"
        }, {
            "c": "610100",
            "n": "西安市",
            "pc": "610000"
        }, {
            "c": "610101",
            "n": "市辖区",
            "pc": "610100"
        }, {
            "c": "610102",
            "n": "新城区",
            "pc": "610100"
        }, {
            "c": "610103",
            "n": "碑林区",
            "pc": "610100"
        }, {
            "c": "610104",
            "n": "莲湖区",
            "pc": "610100"
        }, {
            "c": "610111",
            "n": "灞桥区",
            "pc": "610100"
        }, {
            "c": "610112",
            "n": "未央区",
            "pc": "610100"
        }, {
            "c": "610113",
            "n": "雁塔区",
            "pc": "610100"
        }, {
            "c": "610114",
            "n": "阎良区",
            "pc": "610100"
        }, {
            "c": "610115",
            "n": "临潼区",
            "pc": "610100"
        }, {
            "c": "610116",
            "n": "长安区",
            "pc": "610100"
        }, {
            "c": "610122",
            "n": "蓝田县",
            "pc": "610100"
        }, {
            "c": "610124",
            "n": "周至县",
            "pc": "610100"
        }, {
            "c": "610125",
            "n": "户县",
            "pc": "610100"
        }, {
            "c": "610126",
            "n": "高陵县",
            "pc": "610100"
        }, {
            "c": "610200",
            "n": "铜川市",
            "pc": "610000"
        }, {
            "c": "610201",
            "n": "市辖区",
            "pc": "610200"
        }, {
            "c": "610202",
            "n": "王益区",
            "pc": "610200"
        }, {
            "c": "610203",
            "n": "印台区",
            "pc": "610200"
        }, {
            "c": "610204",
            "n": "耀州区",
            "pc": "610200"
        }, {
            "c": "610222",
            "n": "宜君县",
            "pc": "610200"
        }, {
            "c": "610300",
            "n": "宝鸡市",
            "pc": "610000"
        }, {
            "c": "610301",
            "n": "市辖区",
            "pc": "610300"
        }, {
            "c": "610302",
            "n": "渭滨区",
            "pc": "610300"
        }, {
            "c": "610303",
            "n": "金台区",
            "pc": "610300"
        }, {
            "c": "610304",
            "n": "陈仓区",
            "pc": "610300"
        }, {
            "c": "610322",
            "n": "凤翔县",
            "pc": "610300"
        }, {
            "c": "610323",
            "n": "岐山县",
            "pc": "610300"
        }, {
            "c": "610324",
            "n": "扶风县",
            "pc": "610300"
        }, {
            "c": "610326",
            "n": "眉县",
            "pc": "610300"
        }, {
            "c": "610327",
            "n": "陇县",
            "pc": "610300"
        }, {
            "c": "610328",
            "n": "千阳县",
            "pc": "610300"
        }, {
            "c": "610329",
            "n": "麟游县",
            "pc": "610300"
        }, {
            "c": "610330",
            "n": "凤县",
            "pc": "610300"
        }, {
            "c": "610331",
            "n": "太白县",
            "pc": "610300"
        }, {
            "c": "610400",
            "n": "咸阳市",
            "pc": "610000"
        }, {
            "c": "610401",
            "n": "市辖区",
            "pc": "610400"
        }, {
            "c": "610402",
            "n": "秦都区",
            "pc": "610400"
        }, {
            "c": "610403",
            "n": "杨陵区",
            "pc": "610400"
        }, {
            "c": "610404",
            "n": "渭城区",
            "pc": "610400"
        }, {
            "c": "610422",
            "n": "三原县",
            "pc": "610400"
        }, {
            "c": "610423",
            "n": "泾阳县",
            "pc": "610400"
        }, {
            "c": "610424",
            "n": "乾县",
            "pc": "610400"
        }, {
            "c": "610425",
            "n": "礼泉县",
            "pc": "610400"
        }, {
            "c": "610426",
            "n": "永寿县",
            "pc": "610400"
        }, {
            "c": "610427",
            "n": "彬县",
            "pc": "610400"
        }, {
            "c": "610428",
            "n": "长武县",
            "pc": "610400"
        }, {
            "c": "610429",
            "n": "旬邑县",
            "pc": "610400"
        }, {
            "c": "610430",
            "n": "淳化县",
            "pc": "610400"
        }, {
            "c": "610431",
            "n": "武功县",
            "pc": "610400"
        }, {
            "c": "610481",
            "n": "兴平市",
            "pc": "610400"
        }, {
            "c": "610500",
            "n": "渭南市",
            "pc": "610000"
        }, {
            "c": "610501",
            "n": "市辖区",
            "pc": "610500"
        }, {
            "c": "610502",
            "n": "临渭区",
            "pc": "610500"
        }, {
            "c": "610521",
            "n": "华县",
            "pc": "610500"
        }, {
            "c": "610522",
            "n": "潼关县",
            "pc": "610500"
        }, {
            "c": "610523",
            "n": "大荔县",
            "pc": "610500"
        }, {
            "c": "610524",
            "n": "合阳县",
            "pc": "610500"
        }, {
            "c": "610525",
            "n": "澄城县",
            "pc": "610500"
        }, {
            "c": "610526",
            "n": "蒲城县",
            "pc": "610500"
        }, {
            "c": "610527",
            "n": "白水县",
            "pc": "610500"
        }, {
            "c": "610528",
            "n": "富平县",
            "pc": "610500"
        }, {
            "c": "610581",
            "n": "韩城市",
            "pc": "610500"
        }, {
            "c": "610582",
            "n": "华阴市",
            "pc": "610500"
        }, {
            "c": "610600",
            "n": "延安市",
            "pc": "610000"
        }, {
            "c": "610601",
            "n": "市辖区",
            "pc": "610600"
        }, {
            "c": "610602",
            "n": "宝塔区",
            "pc": "610600"
        }, {
            "c": "610621",
            "n": "延长县",
            "pc": "610600"
        }, {
            "c": "610622",
            "n": "延川县",
            "pc": "610600"
        }, {
            "c": "610623",
            "n": "子长县",
            "pc": "610600"
        }, {
            "c": "610624",
            "n": "安塞县",
            "pc": "610600"
        }, {
            "c": "610625",
            "n": "志丹县",
            "pc": "610600"
        }, {
            "c": "610626",
            "n": "吴起县",
            "pc": "610600"
        }, {
            "c": "610627",
            "n": "甘泉县",
            "pc": "610600"
        }, {
            "c": "610628",
            "n": "富县",
            "pc": "610600"
        }, {
            "c": "610629",
            "n": "洛川县",
            "pc": "610600"
        }, {
            "c": "610630",
            "n": "宜川县",
            "pc": "610600"
        }, {
            "c": "610631",
            "n": "黄龙县",
            "pc": "610600"
        }, {
            "c": "610632",
            "n": "黄陵县",
            "pc": "610600"
        }, {
            "c": "610700",
            "n": "汉中市",
            "pc": "610000"
        }, {
            "c": "610701",
            "n": "市辖区",
            "pc": "610700"
        }, {
            "c": "610702",
            "n": "汉台区",
            "pc": "610700"
        }, {
            "c": "610721",
            "n": "南郑县",
            "pc": "610700"
        }, {
            "c": "610722",
            "n": "城固县",
            "pc": "610700"
        }, {
            "c": "610723",
            "n": "洋县",
            "pc": "610700"
        }, {
            "c": "610724",
            "n": "西乡县",
            "pc": "610700"
        }, {
            "c": "610725",
            "n": "勉县",
            "pc": "610700"
        }, {
            "c": "610726",
            "n": "宁强县",
            "pc": "610700"
        }, {
            "c": "610727",
            "n": "略阳县",
            "pc": "610700"
        }, {
            "c": "610728",
            "n": "镇巴县",
            "pc": "610700"
        }, {
            "c": "610729",
            "n": "留坝县",
            "pc": "610700"
        }, {
            "c": "610730",
            "n": "佛坪县",
            "pc": "610700"
        }, {
            "c": "610800",
            "n": "榆林市",
            "pc": "610000"
        }, {
            "c": "610801",
            "n": "市辖区",
            "pc": "610800"
        }, {
            "c": "610802",
            "n": "榆阳区",
            "pc": "610800"
        }, {
            "c": "610821",
            "n": "神木县",
            "pc": "610800"
        }, {
            "c": "610822",
            "n": "府谷县",
            "pc": "610800"
        }, {
            "c": "610823",
            "n": "横山县",
            "pc": "610800"
        }, {
            "c": "610824",
            "n": "靖边县",
            "pc": "610800"
        }, {
            "c": "610825",
            "n": "定边县",
            "pc": "610800"
        }, {
            "c": "610826",
            "n": "绥德县",
            "pc": "610800"
        }, {
            "c": "610827",
            "n": "米脂县",
            "pc": "610800"
        }, {
            "c": "610828",
            "n": "佳县",
            "pc": "610800"
        }, {
            "c": "610829",
            "n": "吴堡县",
            "pc": "610800"
        }, {
            "c": "610830",
            "n": "清涧县",
            "pc": "610800"
        }, {
            "c": "610831",
            "n": "子洲县",
            "pc": "610800"
        }, {
            "c": "610900",
            "n": "安康市",
            "pc": "610000"
        }, {
            "c": "610901",
            "n": "市辖区",
            "pc": "610900"
        }, {
            "c": "610902",
            "n": "汉滨区",
            "pc": "610900"
        }, {
            "c": "610921",
            "n": "汉阴县",
            "pc": "610900"
        }, {
            "c": "610922",
            "n": "石泉县",
            "pc": "610900"
        }, {
            "c": "610923",
            "n": "宁陕县",
            "pc": "610900"
        }, {
            "c": "610924",
            "n": "紫阳县",
            "pc": "610900"
        }, {
            "c": "610925",
            "n": "岚皋县",
            "pc": "610900"
        }, {
            "c": "610926",
            "n": "平利县",
            "pc": "610900"
        }, {
            "c": "610927",
            "n": "镇坪县",
            "pc": "610900"
        }, {
            "c": "610928",
            "n": "旬阳县",
            "pc": "610900"
        }, {
            "c": "610929",
            "n": "白河县",
            "pc": "610900"
        }, {
            "c": "611000",
            "n": "商洛市",
            "pc": "610000"
        }, {
            "c": "611001",
            "n": "市辖区",
            "pc": "611000"
        }, {
            "c": "611002",
            "n": "商州区",
            "pc": "611000"
        }, {
            "c": "611021",
            "n": "洛南县",
            "pc": "611000"
        }, {
            "c": "611022",
            "n": "丹凤县",
            "pc": "611000"
        }, {
            "c": "611023",
            "n": "商南县",
            "pc": "611000"
        }, {
            "c": "611024",
            "n": "山阳县",
            "pc": "611000"
        }, {
            "c": "611025",
            "n": "镇安县",
            "pc": "611000"
        }, {
            "c": "611026",
            "n": "柞水县",
            "pc": "611000"
        }, {
            "c": "620000",
            "n": "甘肃省",
            "pc": "86"
        }, {
            "c": "620100",
            "n": "兰州市",
            "pc": "620000"
        }, {
            "c": "620101",
            "n": "市辖区",
            "pc": "620100"
        }, {
            "c": "620102",
            "n": "城关区",
            "pc": "620100"
        }, {
            "c": "620103",
            "n": "七里河区",
            "pc": "620100"
        }, {
            "c": "620104",
            "n": "西固区",
            "pc": "620100"
        }, {
            "c": "620105",
            "n": "安宁区",
            "pc": "620100"
        }, {
            "c": "620111",
            "n": "红古区",
            "pc": "620100"
        }, {
            "c": "620121",
            "n": "永登县",
            "pc": "620100"
        }, {
            "c": "620122",
            "n": "皋兰县",
            "pc": "620100"
        }, {
            "c": "620123",
            "n": "榆中县",
            "pc": "620100"
        }, {
            "c": "620200",
            "n": "嘉峪关市",
            "pc": "620000"
        }, {
            "c": "620201",
            "n": "市辖区",
            "pc": "620200"
        }, {
            "c": "620300",
            "n": "金昌市",
            "pc": "620000"
        }, {
            "c": "620301",
            "n": "市辖区",
            "pc": "620300"
        }, {
            "c": "620302",
            "n": "金川区",
            "pc": "620300"
        }, {
            "c": "620321",
            "n": "永昌县",
            "pc": "620300"
        }, {
            "c": "620400",
            "n": "白银市",
            "pc": "620000"
        }, {
            "c": "620401",
            "n": "市辖区",
            "pc": "620400"
        }, {
            "c": "620402",
            "n": "白银区",
            "pc": "620400"
        }, {
            "c": "620403",
            "n": "平川区",
            "pc": "620400"
        }, {
            "c": "620421",
            "n": "靖远县",
            "pc": "620400"
        }, {
            "c": "620422",
            "n": "会宁县",
            "pc": "620400"
        }, {
            "c": "620423",
            "n": "景泰县",
            "pc": "620400"
        }, {
            "c": "620500",
            "n": "天水市",
            "pc": "620000"
        }, {
            "c": "620501",
            "n": "市辖区",
            "pc": "620500"
        }, {
            "c": "620502",
            "n": "秦州区",
            "pc": "620500"
        }, {
            "c": "620503",
            "n": "麦积区",
            "pc": "620500"
        }, {
            "c": "620521",
            "n": "清水县",
            "pc": "620500"
        }, {
            "c": "620522",
            "n": "秦安县",
            "pc": "620500"
        }, {
            "c": "620523",
            "n": "甘谷县",
            "pc": "620500"
        }, {
            "c": "620524",
            "n": "武山县",
            "pc": "620500"
        }, {
            "c": "620525",
            "n": "张家川回族自治县",
            "pc": "620500"
        }, {
            "c": "620600",
            "n": "武威市",
            "pc": "620000"
        }, {
            "c": "620601",
            "n": "市辖区",
            "pc": "620600"
        }, {
            "c": "620602",
            "n": "凉州区",
            "pc": "620600"
        }, {
            "c": "620621",
            "n": "民勤县",
            "pc": "620600"
        }, {
            "c": "620622",
            "n": "古浪县",
            "pc": "620600"
        }, {
            "c": "620623",
            "n": "天祝藏族自治县",
            "pc": "620600"
        }, {
            "c": "620700",
            "n": "张掖市",
            "pc": "620000"
        }, {
            "c": "620701",
            "n": "市辖区",
            "pc": "620700"
        }, {
            "c": "620702",
            "n": "甘州区",
            "pc": "620700"
        }, {
            "c": "620721",
            "n": "肃南裕固族自治县",
            "pc": "620700"
        }, {
            "c": "620722",
            "n": "民乐县",
            "pc": "620700"
        }, {
            "c": "620723",
            "n": "临泽县",
            "pc": "620700"
        }, {
            "c": "620724",
            "n": "高台县",
            "pc": "620700"
        }, {
            "c": "620725",
            "n": "山丹县",
            "pc": "620700"
        }, {
            "c": "620800",
            "n": "平凉市",
            "pc": "620000"
        }, {
            "c": "620801",
            "n": "市辖区",
            "pc": "620800"
        }, {
            "c": "620802",
            "n": "崆峒区",
            "pc": "620800"
        }, {
            "c": "620821",
            "n": "泾川县",
            "pc": "620800"
        }, {
            "c": "620822",
            "n": "灵台县",
            "pc": "620800"
        }, {
            "c": "620823",
            "n": "崇信县",
            "pc": "620800"
        }, {
            "c": "620824",
            "n": "华亭县",
            "pc": "620800"
        }, {
            "c": "620825",
            "n": "庄浪县",
            "pc": "620800"
        }, {
            "c": "620826",
            "n": "静宁县",
            "pc": "620800"
        }, {
            "c": "620900",
            "n": "酒泉市",
            "pc": "620000"
        }, {
            "c": "620901",
            "n": "市辖区",
            "pc": "620900"
        }, {
            "c": "620902",
            "n": "肃州区",
            "pc": "620900"
        }, {
            "c": "620921",
            "n": "金塔县",
            "pc": "620900"
        }, {
            "c": "620922",
            "n": "瓜州县",
            "pc": "620900"
        }, {
            "c": "620923",
            "n": "肃北蒙古族自治县",
            "pc": "620900"
        }, {
            "c": "620924",
            "n": "阿克塞哈萨克族自治县",
            "pc": "620900"
        }, {
            "c": "620981",
            "n": "玉门市",
            "pc": "620900"
        }, {
            "c": "620982",
            "n": "敦煌市",
            "pc": "620900"
        }, {
            "c": "621000",
            "n": "庆阳市",
            "pc": "620000"
        }, {
            "c": "621001",
            "n": "市辖区",
            "pc": "621000"
        }, {
            "c": "621002",
            "n": "西峰区",
            "pc": "621000"
        }, {
            "c": "621021",
            "n": "庆城县",
            "pc": "621000"
        }, {
            "c": "621022",
            "n": "环县",
            "pc": "621000"
        }, {
            "c": "621023",
            "n": "华池县",
            "pc": "621000"
        }, {
            "c": "621024",
            "n": "合水县",
            "pc": "621000"
        }, {
            "c": "621025",
            "n": "正宁县",
            "pc": "621000"
        }, {
            "c": "621026",
            "n": "宁县",
            "pc": "621000"
        }, {
            "c": "621027",
            "n": "镇原县",
            "pc": "621000"
        }, {
            "c": "621100",
            "n": "定西市",
            "pc": "620000"
        }, {
            "c": "621101",
            "n": "市辖区",
            "pc": "621100"
        }, {
            "c": "621102",
            "n": "安定区",
            "pc": "621100"
        }, {
            "c": "621121",
            "n": "通渭县",
            "pc": "621100"
        }, {
            "c": "621122",
            "n": "陇西县",
            "pc": "621100"
        }, {
            "c": "621123",
            "n": "渭源县",
            "pc": "621100"
        }, {
            "c": "621124",
            "n": "临洮县",
            "pc": "621100"
        }, {
            "c": "621125",
            "n": "漳县",
            "pc": "621100"
        }, {
            "c": "621126",
            "n": "岷县",
            "pc": "621100"
        }, {
            "c": "621200",
            "n": "陇南市",
            "pc": "620000"
        }, {
            "c": "621201",
            "n": "市辖区",
            "pc": "621200"
        }, {
            "c": "621202",
            "n": "武都区",
            "pc": "621200"
        }, {
            "c": "621221",
            "n": "成县",
            "pc": "621200"
        }, {
            "c": "621222",
            "n": "文县",
            "pc": "621200"
        }, {
            "c": "621223",
            "n": "宕昌县",
            "pc": "621200"
        }, {
            "c": "621224",
            "n": "康县",
            "pc": "621200"
        }, {
            "c": "621225",
            "n": "西和县",
            "pc": "621200"
        }, {
            "c": "621226",
            "n": "礼县",
            "pc": "621200"
        }, {
            "c": "621227",
            "n": "徽县",
            "pc": "621200"
        }, {
            "c": "621228",
            "n": "两当县",
            "pc": "621200"
        }, {
            "c": "622900",
            "n": "临夏回族自治州",
            "pc": "620000"
        }, {
            "c": "622901",
            "n": "临夏市",
            "pc": "622900"
        }, {
            "c": "622921",
            "n": "临夏县",
            "pc": "622900"
        }, {
            "c": "622922",
            "n": "康乐县",
            "pc": "622900"
        }, {
            "c": "622923",
            "n": "永靖县",
            "pc": "622900"
        }, {
            "c": "622924",
            "n": "广河县",
            "pc": "622900"
        }, {
            "c": "622925",
            "n": "和政县",
            "pc": "622900"
        }, {
            "c": "622926",
            "n": "东乡族自治县",
            "pc": "622900"
        }, {
            "c": "622927",
            "n": "积石山保安族东乡族撒拉族自治县",
            "pc": "622900"
        }, {
            "c": "623000",
            "n": "甘南藏族自治州",
            "pc": "620000"
        }, {
            "c": "623001",
            "n": "合作市",
            "pc": "623000"
        }, {
            "c": "623021",
            "n": "临潭县",
            "pc": "623000"
        }, {
            "c": "623022",
            "n": "卓尼县",
            "pc": "623000"
        }, {
            "c": "623023",
            "n": "舟曲县",
            "pc": "623000"
        }, {
            "c": "623024",
            "n": "迭部县",
            "pc": "623000"
        }, {
            "c": "623025",
            "n": "玛曲县",
            "pc": "623000"
        }, {
            "c": "623026",
            "n": "碌曲县",
            "pc": "623000"
        }, {
            "c": "623027",
            "n": "夏河县",
            "pc": "623000"
        }, {
            "c": "630000",
            "n": "青海省",
            "pc": "86"
        }, {
            "c": "630100",
            "n": "西宁市",
            "pc": "630000"
        }, {
            "c": "630101",
            "n": "市辖区",
            "pc": "630100"
        }, {
            "c": "630102",
            "n": "城东区",
            "pc": "630100"
        }, {
            "c": "630103",
            "n": "城中区",
            "pc": "630100"
        }, {
            "c": "630104",
            "n": "城西区",
            "pc": "630100"
        }, {
            "c": "630105",
            "n": "城北区",
            "pc": "630100"
        }, {
            "c": "630121",
            "n": "大通回族土族自治县",
            "pc": "630100"
        }, {
            "c": "630122",
            "n": "湟中县",
            "pc": "630100"
        }, {
            "c": "630123",
            "n": "湟源县",
            "pc": "630100"
        }, {
            "c": "632100",
            "n": "海东地区",
            "pc": "630000"
        }, {
            "c": "632121",
            "n": "平安县",
            "pc": "632100"
        }, {
            "c": "632122",
            "n": "民和回族土族自治县",
            "pc": "632100"
        }, {
            "c": "632123",
            "n": "乐都县",
            "pc": "632100"
        }, {
            "c": "632126",
            "n": "互助土族自治县",
            "pc": "632100"
        }, {
            "c": "632127",
            "n": "化隆回族自治县",
            "pc": "632100"
        }, {
            "c": "632128",
            "n": "循化撒拉族自治县",
            "pc": "632100"
        }, {
            "c": "632200",
            "n": "海北藏族自治州",
            "pc": "630000"
        }, {
            "c": "632221",
            "n": "门源回族自治县",
            "pc": "632200"
        }, {
            "c": "632222",
            "n": "祁连县",
            "pc": "632200"
        }, {
            "c": "632223",
            "n": "海晏县",
            "pc": "632200"
        }, {
            "c": "632224",
            "n": "刚察县",
            "pc": "632200"
        }, {
            "c": "632300",
            "n": "黄南藏族自治州",
            "pc": "630000"
        }, {
            "c": "632321",
            "n": "同仁县",
            "pc": "632300"
        }, {
            "c": "632322",
            "n": "尖扎县",
            "pc": "632300"
        }, {
            "c": "632323",
            "n": "泽库县",
            "pc": "632300"
        }, {
            "c": "632324",
            "n": "河南蒙古族自治县",
            "pc": "632300"
        }, {
            "c": "632500",
            "n": "海南藏族自治州",
            "pc": "630000"
        }, {
            "c": "632521",
            "n": "共和县",
            "pc": "632500"
        }, {
            "c": "632522",
            "n": "同德县",
            "pc": "632500"
        }, {
            "c": "632523",
            "n": "贵德县",
            "pc": "632500"
        }, {
            "c": "632524",
            "n": "兴海县",
            "pc": "632500"
        }, {
            "c": "632525",
            "n": "贵南县",
            "pc": "632500"
        }, {
            "c": "632600",
            "n": "果洛藏族自治州",
            "pc": "630000"
        }, {
            "c": "632621",
            "n": "玛沁县",
            "pc": "632600"
        }, {
            "c": "632622",
            "n": "班玛县",
            "pc": "632600"
        }, {
            "c": "632623",
            "n": "甘德县",
            "pc": "632600"
        }, {
            "c": "632624",
            "n": "达日县",
            "pc": "632600"
        }, {
            "c": "632625",
            "n": "久治县",
            "pc": "632600"
        }, {
            "c": "632626",
            "n": "玛多县",
            "pc": "632600"
        }, {
            "c": "632700",
            "n": "玉树藏族自治州",
            "pc": "630000"
        }, {
            "c": "632721",
            "n": "玉树县",
            "pc": "632700"
        }, {
            "c": "632722",
            "n": "杂多县",
            "pc": "632700"
        }, {
            "c": "632723",
            "n": "称多县",
            "pc": "632700"
        }, {
            "c": "632724",
            "n": "治多县",
            "pc": "632700"
        }, {
            "c": "632725",
            "n": "囊谦县",
            "pc": "632700"
        }, {
            "c": "632726",
            "n": "曲麻莱县",
            "pc": "632700"
        }, {
            "c": "632800",
            "n": "海西蒙古族藏族自治州",
            "pc": "630000"
        }, {
            "c": "632801",
            "n": "格尔木市",
            "pc": "632800"
        }, {
            "c": "632802",
            "n": "德令哈市",
            "pc": "632800"
        }, {
            "c": "632821",
            "n": "乌兰县",
            "pc": "632800"
        }, {
            "c": "632822",
            "n": "都兰县",
            "pc": "632800"
        }, {
            "c": "632823",
            "n": "天峻县",
            "pc": "632800"
        }, {
            "c": "640000",
            "n": "宁夏回族自治区",
            "pc": "86"
        }, {
            "c": "640100",
            "n": "银川市",
            "pc": "640000"
        }, {
            "c": "640101",
            "n": "市辖区",
            "pc": "640100"
        }, {
            "c": "640104",
            "n": "兴庆区",
            "pc": "640100"
        }, {
            "c": "640105",
            "n": "西夏区",
            "pc": "640100"
        }, {
            "c": "640106",
            "n": "金凤区",
            "pc": "640100"
        }, {
            "c": "640121",
            "n": "永宁县",
            "pc": "640100"
        }, {
            "c": "640122",
            "n": "贺兰县",
            "pc": "640100"
        }, {
            "c": "640181",
            "n": "灵武市",
            "pc": "640100"
        }, {
            "c": "640200",
            "n": "石嘴山市",
            "pc": "640000"
        }, {
            "c": "640201",
            "n": "市辖区",
            "pc": "640200"
        }, {
            "c": "640202",
            "n": "大武口区",
            "pc": "640200"
        }, {
            "c": "640205",
            "n": "惠农区",
            "pc": "640200"
        }, {
            "c": "640221",
            "n": "平罗县",
            "pc": "640200"
        }, {
            "c": "640300",
            "n": "吴忠市",
            "pc": "640000"
        }, {
            "c": "640301",
            "n": "市辖区",
            "pc": "640300"
        }, {
            "c": "640302",
            "n": "利通区",
            "pc": "640300"
        }, {
            "c": "640303",
            "n": "红寺堡区",
            "pc": "640300"
        }, {
            "c": "640323",
            "n": "盐池县",
            "pc": "640300"
        }, {
            "c": "640324",
            "n": "同心县",
            "pc": "640300"
        }, {
            "c": "640381",
            "n": "青铜峡市",
            "pc": "640300"
        }, {
            "c": "640400",
            "n": "固原市",
            "pc": "640000"
        }, {
            "c": "640401",
            "n": "市辖区",
            "pc": "640400"
        }, {
            "c": "640402",
            "n": "原州区",
            "pc": "640400"
        }, {
            "c": "640422",
            "n": "西吉县",
            "pc": "640400"
        }, {
            "c": "640423",
            "n": "隆德县",
            "pc": "640400"
        }, {
            "c": "640424",
            "n": "泾源县",
            "pc": "640400"
        }, {
            "c": "640425",
            "n": "彭阳县",
            "pc": "640400"
        }, {
            "c": "640500",
            "n": "中卫市",
            "pc": "640000"
        }, {
            "c": "640501",
            "n": "市辖区",
            "pc": "640500"
        }, {
            "c": "640502",
            "n": "沙坡头区",
            "pc": "640500"
        }, {
            "c": "640521",
            "n": "中宁县",
            "pc": "640500"
        }, {
            "c": "640522",
            "n": "海原县",
            "pc": "640500"
        }, {
            "c": "650000",
            "n": "新疆维吾尔自治区",
            "pc": "86"
        }, {
            "c": "650100",
            "n": "乌鲁木齐市",
            "pc": "650000"
        }, {
            "c": "650101",
            "n": "市辖区",
            "pc": "650100"
        }, {
            "c": "650102",
            "n": "天山区",
            "pc": "650100"
        }, {
            "c": "650103",
            "n": "沙依巴克区",
            "pc": "650100"
        }, {
            "c": "650104",
            "n": "新市区",
            "pc": "650100"
        }, {
            "c": "650105",
            "n": "水磨沟区",
            "pc": "650100"
        }, {
            "c": "650106",
            "n": "头屯河区",
            "pc": "650100"
        }, {
            "c": "650107",
            "n": "达坂城区",
            "pc": "650100"
        }, {
            "c": "650109",
            "n": "米东区",
            "pc": "650100"
        }, {
            "c": "650121",
            "n": "乌鲁木齐县",
            "pc": "650100"
        }, {
            "c": "650200",
            "n": "克拉玛依市",
            "pc": "650000"
        }, {
            "c": "650201",
            "n": "市辖区",
            "pc": "650200"
        }, {
            "c": "650202",
            "n": "独山子区",
            "pc": "650200"
        }, {
            "c": "650203",
            "n": "克拉玛依区",
            "pc": "650200"
        }, {
            "c": "650204",
            "n": "白碱滩区",
            "pc": "650200"
        }, {
            "c": "650205",
            "n": "乌尔禾区",
            "pc": "650200"
        }, {
            "c": "652100",
            "n": "吐鲁番地区",
            "pc": "650000"
        }, {
            "c": "652101",
            "n": "吐鲁番市",
            "pc": "652100"
        }, {
            "c": "652122",
            "n": "鄯善县",
            "pc": "652100"
        }, {
            "c": "652123",
            "n": "托克逊县",
            "pc": "652100"
        }, {
            "c": "652200",
            "n": "哈密地区",
            "pc": "650000"
        }, {
            "c": "652201",
            "n": "哈密市",
            "pc": "652200"
        }, {
            "c": "652222",
            "n": "巴里坤哈萨克自治县",
            "pc": "652200"
        }, {
            "c": "652223",
            "n": "伊吾县",
            "pc": "652200"
        }, {
            "c": "652300",
            "n": "昌吉回族自治州",
            "pc": "650000"
        }, {
            "c": "652301",
            "n": "昌吉市",
            "pc": "652300"
        }, {
            "c": "652302",
            "n": "阜康市",
            "pc": "652300"
        }, {
            "c": "652323",
            "n": "呼图壁县",
            "pc": "652300"
        }, {
            "c": "652324",
            "n": "玛纳斯县",
            "pc": "652300"
        }, {
            "c": "652325",
            "n": "奇台县",
            "pc": "652300"
        }, {
            "c": "652327",
            "n": "吉木萨尔县",
            "pc": "652300"
        }, {
            "c": "652328",
            "n": "木垒哈萨克自治县",
            "pc": "652300"
        }, {
            "c": "652700",
            "n": "博尔塔拉蒙古自治州",
            "pc": "650000"
        }, {
            "c": "652701",
            "n": "博乐市",
            "pc": "652700"
        }, {
            "c": "652722",
            "n": "精河县",
            "pc": "652700"
        }, {
            "c": "652723",
            "n": "温泉县",
            "pc": "652700"
        }, {
            "c": "652800",
            "n": "巴音郭楞蒙古自治州",
            "pc": "650000"
        }, {
            "c": "652801",
            "n": "库尔勒市",
            "pc": "652800"
        }, {
            "c": "652822",
            "n": "轮台县",
            "pc": "652800"
        }, {
            "c": "652823",
            "n": "尉犁县",
            "pc": "652800"
        }, {
            "c": "652824",
            "n": "若羌县",
            "pc": "652800"
        }, {
            "c": "652825",
            "n": "且末县",
            "pc": "652800"
        }, {
            "c": "652826",
            "n": "焉耆回族自治县",
            "pc": "652800"
        }, {
            "c": "652827",
            "n": "和静县",
            "pc": "652800"
        }, {
            "c": "652828",
            "n": "和硕县",
            "pc": "652800"
        }, {
            "c": "652829",
            "n": "博湖县",
            "pc": "652800"
        }, {
            "c": "652900",
            "n": "阿克苏地区",
            "pc": "650000"
        }, {
            "c": "652901",
            "n": "阿克苏市",
            "pc": "652900"
        }, {
            "c": "652922",
            "n": "温宿县",
            "pc": "652900"
        }, {
            "c": "652923",
            "n": "库车县",
            "pc": "652900"
        }, {
            "c": "652924",
            "n": "沙雅县",
            "pc": "652900"
        }, {
            "c": "652925",
            "n": "新和县",
            "pc": "652900"
        }, {
            "c": "652926",
            "n": "拜城县",
            "pc": "652900"
        }, {
            "c": "652927",
            "n": "乌什县",
            "pc": "652900"
        }, {
            "c": "652928",
            "n": "阿瓦提县",
            "pc": "652900"
        }, {
            "c": "652929",
            "n": "柯坪县",
            "pc": "652900"
        }, {
            "c": "653000",
            "n": "克孜勒苏柯尔克孜自治州",
            "pc": "650000"
        }, {
            "c": "653001",
            "n": "阿图什市",
            "pc": "653000"
        }, {
            "c": "653022",
            "n": "阿克陶县",
            "pc": "653000"
        }, {
            "c": "653023",
            "n": "阿合奇县",
            "pc": "653000"
        }, {
            "c": "653024",
            "n": "乌恰县",
            "pc": "653000"
        }, {
            "c": "653100",
            "n": "喀什地区",
            "pc": "650000"
        }, {
            "c": "653101",
            "n": "喀什市",
            "pc": "653100"
        }, {
            "c": "653121",
            "n": "疏附县",
            "pc": "653100"
        }, {
            "c": "653122",
            "n": "疏勒县",
            "pc": "653100"
        }, {
            "c": "653123",
            "n": "英吉沙县",
            "pc": "653100"
        }, {
            "c": "653124",
            "n": "泽普县",
            "pc": "653100"
        }, {
            "c": "653125",
            "n": "莎车县",
            "pc": "653100"
        }, {
            "c": "653126",
            "n": "叶城县",
            "pc": "653100"
        }, {
            "c": "653127",
            "n": "麦盖提县",
            "pc": "653100"
        }, {
            "c": "653128",
            "n": "岳普湖县",
            "pc": "653100"
        }, {
            "c": "653129",
            "n": "伽师县",
            "pc": "653100"
        }, {
            "c": "653130",
            "n": "巴楚县",
            "pc": "653100"
        }, {
            "c": "653131",
            "n": "塔什库尔干塔吉克自治县",
            "pc": "653100"
        }, {
            "c": "653200",
            "n": "和田地区",
            "pc": "650000"
        }, {
            "c": "653201",
            "n": "和田市",
            "pc": "653200"
        }, {
            "c": "653221",
            "n": "和田县",
            "pc": "653200"
        }, {
            "c": "653222",
            "n": "墨玉县",
            "pc": "653200"
        }, {
            "c": "653223",
            "n": "皮山县",
            "pc": "653200"
        }, {
            "c": "653224",
            "n": "洛浦县",
            "pc": "653200"
        }, {
            "c": "653225",
            "n": "策勒县",
            "pc": "653200"
        }, {
            "c": "653226",
            "n": "于田县",
            "pc": "653200"
        }, {
            "c": "653227",
            "n": "民丰县",
            "pc": "653200"
        }, {
            "c": "654000",
            "n": "伊犁哈萨克自治州",
            "pc": "650000"
        }, {
            "c": "654002",
            "n": "伊宁市",
            "pc": "654000"
        }, {
            "c": "654003",
            "n": "奎屯市",
            "pc": "654000"
        }, {
            "c": "654021",
            "n": "伊宁县",
            "pc": "654000"
        }, {
            "c": "654022",
            "n": "察布查尔锡伯自治县",
            "pc": "654000"
        }, {
            "c": "654023",
            "n": "霍城县",
            "pc": "654000"
        }, {
            "c": "654024",
            "n": "巩留县",
            "pc": "654000"
        }, {
            "c": "654025",
            "n": "新源县",
            "pc": "654000"
        }, {
            "c": "654026",
            "n": "昭苏县",
            "pc": "654000"
        }, {
            "c": "654027",
            "n": "特克斯县",
            "pc": "654000"
        }, {
            "c": "654028",
            "n": "尼勒克县",
            "pc": "654000"
        }, {
            "c": "654200",
            "n": "塔城地区",
            "pc": "650000"
        }, {
            "c": "654201",
            "n": "塔城市",
            "pc": "654200"
        }, {
            "c": "654202",
            "n": "乌苏市",
            "pc": "654200"
        }, {
            "c": "654221",
            "n": "额敏县",
            "pc": "654200"
        }, {
            "c": "654223",
            "n": "沙湾县",
            "pc": "654200"
        }, {
            "c": "654224",
            "n": "托里县",
            "pc": "654200"
        }, {
            "c": "654225",
            "n": "裕民县",
            "pc": "654200"
        }, {
            "c": "654226",
            "n": "和布克赛尔蒙古自治县",
            "pc": "654200"
        }, {
            "c": "654300",
            "n": "阿勒泰地区",
            "pc": "650000"
        }, {
            "c": "654301",
            "n": "阿勒泰市",
            "pc": "654300"
        }, {
            "c": "654321",
            "n": "布尔津县",
            "pc": "654300"
        }, {
            "c": "654322",
            "n": "富蕴县",
            "pc": "654300"
        }, {
            "c": "654323",
            "n": "福海县",
            "pc": "654300"
        }, {
            "c": "654324",
            "n": "哈巴河县",
            "pc": "654300"
        }, {
            "c": "654325",
            "n": "青河县",
            "pc": "654300"
        }, {
            "c": "654326",
            "n": "吉木乃县",
            "pc": "654300"
        }, {
            "c": "659000",
            "n": "自治区直辖县级行政区划",
            "pc": "650000"
        }, {
            "c": "659001",
            "n": "石河子市",
            "pc": "659000"
        }, {
            "c": "659002",
            "n": "阿拉尔市",
            "pc": "659000"
        }, {
            "c": "659003",
            "n": "图木舒克市",
            "pc": "659000"
        }, {
            "c": "659004",
            "n": "五家渠市",
            "pc": "659000"
        }, {
            "c": "710000",
            "n": "台湾省",
            "pc": "86"
        }, {
            "c": "810000",
            "n": "香港特别行政区",
            "pc": "86"
        }, {
            "c": "820000",
            "n": "澳门特别行政区",
            "pc": "86"
        }];
        return regions;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('regionBt', regionBt); 

    regionBt.$inject = ['RegionService'];
    function regionBt(RegionService) {
        var directive = {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                depends: '='
            },
            replace: true,
            template: '<select name="a" ng-options="o.c as o.n for o in options">' + //
            '            <option value="">请选择...</option>' + //
            '          </select>',
            link: function(scope, element, attrs, modelCtrl) {
                scope.$watch('depends', function(newVal, oldVal) {
                    if ('depends' in attrs&&attrs.depends!=null) {
                        var parent = RegionService.get(scope.depends);
                        scope.options = [];
                        if (parent) {
                            scope.options = parent.children;
                        }
                        var oldModelValue = modelCtrl.$modelValue;
                        modelCtrl.$setViewValue();
                        for (var i = 0; i < scope.options.length; i++) {
                            var option = scope.options[i];
                            if (option.c === oldModelValue) {
                                modelCtrl.$setViewValue(oldModelValue);
                            }
                        }
                    } else {
                        scope.options = RegionService.getCountries();
                    }
                });
            }
        };
        return directive;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('MessageService', MessageService);

    MessageService.$inject = ['$uibModal'];

    function MessageService($uibModal) {
        var service = {
            confirm: confirm,
            successConfirm: successConfirm,
            comment:comment,
            loading:loading,
            error:error,
            notice:notice,
            info:info,
            success:success, 
            notify:notify


        };

        var settings = {
            title: 'The notice title.', // The notice's title.
            title_escape: false, // Whether to escape the content of the title. (Not allow HTML.)
            // text: 'The notice text.', // The notice's text.
            text_escape: false, // Whether to escape the content of the text. (Not allow HTML.)
            styling: "bootstrap3", // What styling classes to use. (Can be either jqueryui or bootstrap or bootstrap3.)
            // addclass: "", // Additional classes to be added to the notice. (For custom styling.)
            // cornerclass: "", // Class to be added to the notice for corner styling.
            // nonblock: false, // Create a non-blocking notice. It lets the user click elements underneath it.
            // nonblock_opacity: .2, // The opacity of the notice (if it's non-blocking) when the mouse is over it.
            history: false, // Display a pull down menu to redisplay previous notices, and place the notice in the history.
            // width: "300px", // Width of the notice.
            // min_height: "16px", // Minimum height of the notice. It will expand to fit content.
            type: "notice", // Type of the notice. "notice", "info", "success", or "error".
            icon: true, // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
            // animation: "fade", // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
            // animate_speed: "slow", // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
            // opacity: 1, // Opacity of the notice.
            // shadow: true, // Display a drop shadow.
            // closer: true, // Provide a button for the user to manually close the notice.
            // closer_hover: true, // Only show the closer button on hover.
            // sticker: true, // Provide a button for the user to manually stick the notice.
            // sticker_hover: true, // Only show the sticker button on hover.
            // hide: true, // After a delay, remove the notice.
            delay: 2000 // Delay in milliseconds before the notice is removed.
                // mouse_reset: true, // Reset the hide timer if the mouse moves over the notice.
                // remove: true, // Remove the notice's elements from the DOM after it is removed.
                // insert_brs: true, // Change new lines to br tags.
                // stack: {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25}
        };
        var current;

        function notice(content) {
            var hash = angular.copy(settings);
            hash.type = 'notice';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        }

        function info(content) {
            var hash = angular.copy(settings);
            hash.type = 'info';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        }

        function success(content) {
            var hash = angular.copy(settings);
            hash.type = 'success';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        }

        function error(content) {
            var hash = angular.copy(settings);
            hash.type = 'error';
            hash.title = content;
            return this.notify(hash);
        }

        function notify(hash) {
            if (current) {
                current.remove();
            }
            current = new PNotify(hash);
            return current; 

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + hash.title + '</h3>' + //
                    '</div>' + // 
                    '</div>', 
            });
        }

        function loading() {
            return $uibModal.open({
                template: '<i class="fa fa-5x fa-spinner fa-spin fa-white"></i>',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'loading-window'
            });
        }

        function confirm(msg, confirmCallback, cancelCallback) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + msg + '</h3>' + //
                    '</div>' + //
                    '<div class="row">' + //
                    '<button class="btn btn-warning pull-right" style="margin-left:10px"  ng-click="cancel()">取消</button>' + //
                    '<button class="btn btn-primary pull-right" ng-click="ok()">确认</button>' + //
                    '</div>' + //
                    '</div>',
                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });

        }

        function successConfirm(msg, confirmCallback) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3 style="cursor:pointer;" ng-click="ok()">' + msg + '</h3>',
                controller: ModalInstanceCtrl
            });
            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            });
        }

        function comment(msg, confirmCallback, cancelCallback, commentMust) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance', '$timeout',
                function($scope, $uibModalInstance, $timeout) {
                    $scope.ok = function(comment) {
                        if (commentMust && !comment) {
                            // return self.error('评论必填');
                            $scope.error = true;
                            return;
                        }
                        $scope.error = false;
                        $uibModalInstance.close(comment);
                    };
                    if (commentMust) {
                        $scope.placeholderMsg = "请输入评论(必填)";
                    } else {
                        $scope.placeholderMsg = "请输入评论(可空)";
                    }

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $timeout(function() {
                        $scope.$apply();
                    });
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + msg + '</h3>' + //
                    '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                    '<span style="color:red;float:left;margin-left:10px;" ng-show="error">必填</span>' + //
                    '</div>' + //
                    '<div class="row">' + //
                    '<button class="btn btn-warning pull-right" ng-click="cancel()">取消</button>' + //
                    '<button class="btn btn-primary pull-right" ng-click="ok(comment)">确认</button>' + //
                    '</div>' + //
                    '</div>',
                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function(comment) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(comment);
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });
        }
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'zh-cn',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    "use strict";

    var ModeleSelect = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/components/c-select/c-select.html",
        controllerAs: "vm",
        scope: {},
        bindings: {
            ngModel: "=",
            placeholder: "@",
            prefix: "@", //前缀
            options: "=",
            labelKey: "@",
            valueKey: "@",
            ngChange: "&",
            isSearch: "<",
            width: "<",
        },
        controller: [
            "$scope",
            "$timeout",
            "$element",
            "$compile",
            "$sce",
            function ($scope, $timeout, $element, $compile, $sce) {
                var vm = this;
                var content = null;
                var selectEle = $element.find(".modele-select")[0];
                vm.useOptions = [];
                vm.optionsOld = [];
                //设置默认值
                if (!vm.placeholder) vm.placeholder = "请选择";
                if (!vm.labelKey) vm.labelKey = "label";
                if (!vm.valueKey) vm.valueKey = "value";
                vm.searchText = "";
                vm.$onInit = function () {
                    init();
                }
                function init(){
                    var _option = [];
                    var isAllStrings = Array.isArray(vm.options) && vm.options.every(function(item) {
                        return typeof item === "string";
                    });
                    if (isAllStrings) { //如果传入['a','b','c']这种选项也可以支持
                        vm.options.forEach(function(item){
                            _option.push({
                                label:item,
                                value:item
                            })
                        })
                    }else{
                        _option = vm.options;
                    }
                    if (!_option) {
                        vm.useOptions = [];
                    }else{
                        vm.useOptions = angular.copy(_option);
                    }

                    vm.optionsOld = angular.copy(vm.useOptions);
                }
                //创建option节点
                function createOptionDom() {
                    var template = '<div class="modele-select-option" ng-show="vm.showOption"></div>';
                    var linkFn = $compile(template);
                    content = linkFn($scope);
                    // 插入到 body 元素下面
                    angular.element(document.body).append(content);

                    var templateMark = '<div class="modele-select-mark" ng-if="vm.showOption" ng-click="hide()"></div>';
                    var linkFn = $compile(templateMark);
                    // 插入到 body 元素下面
                    angular.element(document.body).append(linkFn($scope));

                }

                //下拉框是否展示
                vm.showOption = false;
                vm.selectWidth = selectEle.getBoundingClientRect().width;

                //监控options的变化
                $scope.$watch("vm.options.$resolved", function (newVal, oldVal) {
                    if (newVal) {
                        init();
                    }
                });

                $scope.$watch("vm.options", function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        init();
                    }
                });
                //组装option
                vm.createOptions = function () {
                    if (!content) {
                        createOptionDom();
                    }
                    filterFn();
                    var optionDom = "";
                    // 如果vm.isSearch为true，添加搜索框
                    if (vm.isSearch) {
                        optionDom += '<div class="option-search-box">';
                        optionDom += '<input type="text" class="searchInput" ng-model="vm.searchText" placeholder="搜索" ng-change="searchInputChange($event)">';
                        optionDom += '<i class="iconfont icon-sousuo cursor-pointer" ng-click="onIconClick($event)"></i>';
                        optionDom += '</div>';
                    }
                    angular.forEach(vm.useOptions, function (item) {
                        if(item[vm.labelKey].indexOf("'")>-1){
                            item[vm.labelKey] = replaceSingleQuotes(item[vm.labelKey])
                        }
                        optionDom += '<div class="option-item" ng-show="' + item.optionIsShow + '" ng-click="selectOption($event)" data-value="' + item[vm.valueKey] + '" ng-bind-html="vm.getHighlightedText(' + "'" + item[vm.labelKey] + "'" + ', vm.searchText)"></div>';
                    });
                    var compiledOptionDom = $compile(optionDom)($scope);
                    angular.element(content).html(compiledOptionDom);
                    if (vm.showOption) {
                        vm.getOptionPlace();
                    }
                    $timeout(function(){
                        if (angular.element(content).find('.searchInput').length) {
                            angular.element(content).find('.searchInput')[0].focus();
                        }
                        var activeElements = angular.element(content).find('.active');
                        if (activeElements.length > 0) {
                            var activeElement = activeElements[0];
                            activeElement.scrollIntoView();
                            angular.element(content)[0].scrollTop -= 36;
                        }
                    },10)
                }
                //中文符号替换
                function replaceSingleQuotes(str) {
                    var count = 0;
                    return str.replace(/'/g, (match) => {
                        count++;
                        if (count % 2 === 1) {
                            return '‘';
                        } else {
                            return '’';
                        }
                    });
                }
                //获取选择框展示的名称
                vm.getShowName = function () {
                    if (vm.ngModel === "" || vm.ngModel === null) {
                        return '';
                    } else {
                        var selectIndex = vm.useOptions.findIndex(function (item) {
                            return item[vm.valueKey] == vm.ngModel;
                        })
                        if (selectIndex >= 0) {
                            //修改页面状态
                            $(content).find(".option-item").removeClass("active");
                            $(content).find(".option-item").eq(selectIndex).addClass("active");
                            return vm.useOptions[selectIndex][vm.labelKey];
                        }
                        return '';
                    }
                };

                //判断下拉框展示位置
                vm.getOptionPlace = function () {
                    if (!vm.showOption) return;
                    $timeout(function () {
                        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                        var windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
                        var selectInfo = selectEle.getBoundingClientRect();
                        var optionHeight = $(content)[0].getBoundingClientRect().height;
                        vm.selectWidth = selectInfo.width;
                        $(content).css({
                            width: vm.selectWidth + "px"
                        })
                        //判断右侧距离是否足够
                        if ($(content)[0].getBoundingClientRect().right >= windowWidth) {
                            $(content).css({
                                right: 0,
                                left: 'auto'
                            });
                        } else {
                            $(content).css({
                                left: selectInfo.left + "px",
                                right: 'auto'
                            });
                        }


                        //判断下方高度是否足够
                        if (windowHeight - selectInfo.bottom > optionHeight + 4) {
                            $(content).css({
                                top: selectInfo.bottom + 4 + "px",
                                bottom: "auto",
                                transform: "none"
                            });
                            return;
                        }
                        //判断上方高度是否足够
                        if (selectInfo.top > optionHeight + 4) {
                            $(content).css({
                                bottom: windowHeight - selectInfo.top + 4 + "px",
                                top: "auto",
                                transform: "none"
                            });
                            return;
                        }
                        //距离不够，居中显示
                        $(content).css({
                            top: "50%",
                            transform: "translate(0, -50%)"
                        });
                    });
                    $timeout(function(){
                        $(content).css({
                            zIndex: 9999,
                            // position:'relative'
                        });
                    },10)
                };
                //点击输入框，展示或隐藏下拉列表
                $scope.clickInput = function () {
                    if (vm.showOption) {
                        $scope.hide();
                    } else {
                        $scope.show();
                    }
                };
                $scope.show = function () {
                    if (!content) {
                        createOptionDom();
                    }
                    vm.createOptions();
                    $timeout(function () {
                        vm.showOption = true;
                        $(content).show();
                        vm.getOptionPlace();
                    });
                };
                $scope.hide = function () {
                    $timeout(function () {
                        vm.searchText = '';
                        vm.showOption = false;
                        $(content).hide();
                    });
                };
                // 判断光标是否在类名为"modele-select-option"的元素中
                function isCursorInModeleSelectOption() {
                    // 获取光标当前的坐标位置
                    var x = event.clientX;
                    var y = event.clientY;
                    if (!x || !y) {
                        return false
                    }
                    // 确保x和y的值在文档范围内
                    var maxX = document.documentElement.scrollWidth || document.body.scrollWidth;
                    var maxY = document.documentElement.scrollHeight || document.body.scrollHeight;
                    x = Math.min(Math.max(x, 0), maxX);
                    y = Math.min(Math.max(y, 0), maxY);

                    var cursorElement = document.elementFromPoint(x, y);
                    return cursorElement.closest(".modele-select-option") !== null;
                }
                //页面点击
                function docClick() {
                    if (vm.showOption && !isCursorInModeleSelectOption()) {
                        $scope.hide();
                    }
                }

                vm.resizeTimer = null;
                //屏幕大小变化或页面滚动
                function onResizeOrScroll() {
                    if (vm.showOption) {
                        if (!isCursorInModeleSelectOption()) {
                            $scope.hide();
                            return;
                        }
                        if (!vm.resizeTimer) {
                            vm.resizeTimer = setTimeout(function () {
                                //重新计算下拉框展示位置
                                vm.getOptionPlace();
                                vm.resizeTimer = null;
                            }, 100);
                        }
                    }
                }
                document.addEventListener("click", docClick);
                window.addEventListener("resize", onResizeOrScroll);
                window.addEventListener("scroll", onResizeOrScroll);
                window.addEventListener("mousewheel", onResizeOrScroll);

                vm.$onDestroy = function () {
                    //删除插入元素，取消监听事件
                    if (content) {
                        content.remove();
                    }
                    document.removeEventListener("click", docClick);
                    window.removeEventListener("resize", onResizeOrScroll);
                    window.removeEventListener("scroll", onResizeOrScroll);
                    window.removeEventListener("mousewheel", onResizeOrScroll);
                };

                $scope.searchInputChange = function (event) {
                    vm.createOptions();
                }

                // 点击iconfont图标触发的函数
                $scope.onIconClick = function (event) {
                    event.stopPropagation(); // 阻止事件冒泡
                    vm.createOptions();
                };

                function filterFn() {
                    var options = angular.copy(vm.optionsOld)
                    if (vm.searchText.trim() === '') {
                        options.forEach(function (item) {
                            item.optionIsShow = true;
                        })
                    } else {
                        var regex = new RegExp(vm.searchText, 'i');
                        options.forEach(function (item) {
                            if (regex.test(item[vm.labelKey])) {
                                item.optionIsShow = true;
                            } else {
                                item.optionIsShow = false;
                            }
                        });
                    }
                    vm.useOptions = angular.copy(options);
                }

                vm.getHighlightedText = function (text, searchText) {
                    if (!angular.isString(text)) {
                        return text;
                    }

                    if (!angular.isString(searchText) || searchText.trim() === '') {
                        return $sce.trustAsHtml(text);
                    }

                    var regex = new RegExp(searchText, 'gi');
                    var highlighted = text.replace(regex, function (match) {
                        return '<span class="highlight">' + match + '</span>';
                    });

                    return $sce.trustAsHtml(highlighted);
                };

                $scope.selectOption = function (e) {
                    vm.ngModel = $(e.target).attr('data-value');
                    $scope.hide();
                    $timeout(function () {
                        if (typeof vm.ngChange === "function") {
                            vm.ngChange();
                        }
                    }, 20);
                }

                $scope.removeSelect = function(e){
                    e.stopPropagation();
                    vm.ngModel = null;
                    $timeout(function () {
                        if (typeof vm.ngChange === "function") {
                            vm.ngChange();
                        }
                    }, 20);
                }
            }
        ]
    };
    angular.module("gwApp").component("selectView", ModeleSelect);
})();

(function () {
    'use strict';

    var ngBarcode = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/components/barcode/ng-barcode.html',
        controllerAs: 'vm',
        bindings: {
            text:'<',
            width: '<',
            height: '<',
            unit:'<',
            dpi:'<',
            hideText:'<'
        },

        controller: ['$scope', '$timeout', '$element','UidService', function ($scope, $timeout, $element, UidService) {
            var vm = this;

            function initOptions() {
                vm.option = {
                    width:4,
                    fontOptions: "bold",
                    font: "Microsoft YaHei, 微软雅黑, 黑体, SimHei",
                    displayValue: !vm.hideText
                };
                // 设置默认值
                vm.unit = vm.unit || 'px';

                if (vm.dpi && vm.unit == 'mm') {
                    vm.option.height = mmToPx(vm.height,vm.dpi);
                    vm.option.fontSize = mmToPx(vm.height/2,vm.dpi);
                }
            }

            function mmToPx(mm,dpi) {
                if (mm && dpi) {
                    return (mm / 25.4) * dpi;
                }else{
                    return null
                }
            }

            function generateBarcode() {
                var barcodeElement = angular.element($element).find('#barcodeId');
                if (vm.text) {
                    barcodeElement.JsBarcode(vm.text, vm.option);
                }
            }

            vm.$onInit = function() {
                initOptions();
                generateBarcode();
            };

            vm.$onChanges = function(changes) {
                if (changes.text || changes.width || changes.height || changes.unit || changes.dpi || changes.hideText) {
                    initOptions();
                    generateBarcode();
                }
            };
        }]
    };
    angular.module('gwApp')
        .component('ngBarcode', ngBarcode);

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('gwApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 500,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('gwApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('gwApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 500; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('gwApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SupplierDowmloadChartController', SupplierDowmloadChartController);

    SupplierDowmloadChartController.$inject = ['$scope', '$state', 'Supplier', 'MessageService', 'SalesOrder', '$uibModal','Product', '$localStorage','$http',
        '$stateParams', '$rootScope', 'Channels'];

    function SupplierDowmloadChartController ($scope, $state, Supplier, MessageService, SalesOrder, $uibModal, Product, $localStorage, $http,
        $stateParams, $rootScope, Channels) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.timeName = 'day';
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            supId: '',
            productName: '',
            sku: '',
            type: 'justify',
            startDate: '',
            endDate: '',
        };
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeName = '';

        $scope.getProductId =function(data){
            vm.tableData.productName = data ? data.name :'';
        };

        init();
        function init() {
            Supplier.getAll(function (res) {
                vm.supplierList = res.filter(function(item){return item.enable});
            });

            // 获取商品信息
            Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
                vm.productList = res.filter(function(item){return item.enable});
            })

            vm.covarianceList = [
                {name:'未拼版下载', value:'justify'},
                {name:'已拼版下载', value:'makeup'}
            ];
            vm.timeList = [
                {name:'昨日', value:'day'},
                {name:'最近7天', value:'week'},
                {name:'最近30天', value:'month'}
            ];
            angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
            angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
            initData();
        }
        $scope.timeCb = function (time) {
            // vm.timeName = time.value;
            angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
            if(time.value == 'day'){
                angular.element("#startDate").val(GetDateStr(-1)+' 00:00:00');
            }
            if(time.value == 'week'){
                angular.element("#startDate").val(GetDateStr(-7)+' 00:00:00');
            }
            if(time.value == 'month'){
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
            }
            initData();
        };

        $scope.inquire = function () {
            initData();
        }
        function initData() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _startDate = new Date(vm.tableData.startDate);
            var _endDate = new Date(vm.tableData.endDate);
            var _mistiming = parseInt(_endDate - _startDate) / 1000 / 60 / 60 / 24;
            vm.timeName = "";
            if(GetDateStr(-1) == vm.tableData.endDate){
                if(_mistiming == 0){vm.timeName = "day";}
                if(_mistiming == 6){vm.timeName = "week";}
                if(_mistiming == 29){vm.timeName = "month";}
            }

            SalesOrder.getData4DowmloadPage(vm.tableData, function (res) {
                vm.typeData = res;

                // 表格数据
                // vm.tableData2 =angular.copy(vm.tableData);
                // vm.tableData2.page= 0;
                // vm.tableData2.size= 20;
                // SalesOrder.getData4ChannelPage(vm.tableData2, function (data) {
                //     vm.typeData = data;
                // }, function (error) {});
            }, function () {
                MessageService.error("查询数据失败，请稍后重试！");
            })
        }

        function total(data){
            vm.typeData = [];
            vm.orderNumSum = 0;
            vm.quantitySum = 0;
            vm.pagesSum = 0;
            vm.downloadsSum = 0;
            if(vm.tableData.type == 'completed'){
                vm.typeName = '完成订单数';
            }
            if(vm.tableData.type == 'assigned'){
                vm.typeName = '分配订单数';
            }
            if(vm.tableData.type == 'downloaded'){
                vm.typeName = '下载次数';
                for(var item in data){
                    var _obj = {
                        productName: item,
                        downloads: data[item]
                    };
                    vm.downloadsSum += data[item];
                    vm.typeData.push(_obj)
                }
            }else {
                vm.typeData = data;
                for(var i=0; i<data.length; i++){
                    if(data[i].orderNum){
                        vm.orderNumSum += data[i].orderNum;
                    }
                    if(data[i].quantity){
                        vm.quantitySum += data[i].quantity;
                    }
                    if(data[i].pages){
                        vm.pagesSum += data[i].pages;
                    }
                }
            }
        }

        //下载
        $scope.chartExport = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            $http({
                url: 'api/sales_order/downloadData4Dowmload',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function getDate (datestr) {
            datestr = datestr.split(" ")[0];
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        }
        function getDiffDate (start, end) {
            var startTime = getDate(start);
            var endTime = getDate(end);
            var dateArr = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                var year = startTime.getFullYear();
                var month = startTime.getMonth().toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
                var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
                dateArr.push(year + "-" + month + "-" + day);
                startTime.setDate(startTime.getDate() + 1);
            }
            return dateArr;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReplenishmentChartController', ReplenishmentChartController);

    ReplenishmentChartController.$inject = ['$scope', '$state', 'MessageService', 'SalesOrder', '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope','ReplenishmentReason'];

    function ReplenishmentChartController ($scope, $state, MessageService, SalesOrder, $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope,ReplenishmentReason) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.timeName = 'day';
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            supId: '',
            productId: '',
            sku: '',
            startDate: '',
            endDate: '',
        };
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeName = '';

        $scope.getProductId =function(data){
            vm.tableData.productId =data ? data.id :'';
        };

        init();
        function init() {
            ReplenishmentReason.getAll(function (res) {
                vm.reasonList = res;
            })
            Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
                vm.productList = res.filter(function(item){return item.enable});
            })
            Supplier.getAll(function (res) {
                vm.supplierList = res.filter(function(item){return item.enable});
                vm.tableData.supId = res[0].id;
                vm.timeList = [
                    {name:'昨日', value:'day'},
                    {name:'最近7天', value:'week'},
                    {name:'最近30天', value:'month'}
                ];
                angular.element("#endDate").val(GetDateStr(-0)+' 23:59:59');
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
                initData();
            });
        }
        $scope.timeCb = function (time) {
            // vm.timeName = time.value;
            angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
            if(time.value == 'day'){
                angular.element("#startDate").val(GetDateStr(-1)+' 00:00:00');
            }
            if(time.value == 'week'){
                angular.element("#startDate").val(GetDateStr(-7)+' 00:00:00');
            }
            if(time.value == 'month'){
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
            }
            initData();
        };

        $scope.inquire = function () {
            initData();
        }
        function initData() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.supId == ""){
                MessageService.error("供应商不能为空");
                return
            }
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _startDate = new Date(vm.tableData.startDate);
            var _endDate = new Date(vm.tableData.endDate);
            var _mistiming = parseInt(_endDate - _startDate) / 1000 / 60 / 60 / 24;
            vm.timeName = "";
            if(GetDateStr(-1) == vm.tableData.endDate){
                if(_mistiming == 0){vm.timeName = "day";}
                if(_mistiming == 6){vm.timeName = "week";}
                if(_mistiming == 29){vm.timeName = "month";}
            }

            var myChart = echarts.init(document.getElementById('main'));
            myChart.showLoading();
            SalesOrder.getReplenishData2(vm.tableData, function (res) {
                chart(res.data, myChart);
                myChart.hideLoading();

                // 表格数据
                vm.tableData2 =angular.copy(vm.tableData);
                // vm.tableData2.page= 0;
                vm.tableData2.size= 20;
                SalesOrder.getReplenishData(vm.tableData2, function (data) {
                    vm.typeData = data;
                }, function (error) {});
            }, function () {
                MessageService.error("查询数据失败，请稍后重试！");
                myChart.hideLoading();
            })
        }


        function chart(data, myChart) {
            var _time = [];
            var _legend = "订单数";
            if(vm.tableData.startDate == vm.tableData.endDate){
                _time.push(vm.tableData.startDate)
            }else {
                _time = getDiffDate(vm.tableData.startDate,vm.tableData.endDate);
                _time.push(vm.tableData.endDate)
            }
            var option = {
                tooltip: {trigger: 'axis'},
                legend: {
                    data:[_legend]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    data: _time
                },
                yAxis: {},
                series: [{
                    name: _legend,
                    type: 'line',
                    itemStyle : {
                        normal : {
                            color:'#ff9601',
                            lineStyle:{
                                color:'#ff9601'
                            }
                        }
                    },
                    data: data
                }]
            };
            myChart.setOption(option);
        }

        //下载
        $scope.chartExport = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            $http({
                url: 'api/sales_order/downloadReplenishData',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function getDate (datestr) {
            datestr = datestr.split(" ")[0];
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        }
        function getDiffDate (start, end) {
            var startTime = getDate(start);
            var endTime = getDate(end);
            var dateArr = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                var year = startTime.getFullYear();
                var month = startTime.getMonth().toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
                var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
                dateArr.push(year + "-" + month + "-" + day);
                startTime.setDate(startTime.getDate() + 1);
            }
            return dateArr;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('MerchantChartController', MerchantChartController);

    MerchantChartController.$inject = ['$scope', '$state', 'MessageService', 'SalesOrder', '$uibModal','Product', '$localStorage','$http',
        '$stateParams', '$rootScope', 'Channels', '$q'];

    function MerchantChartController ($scope, $state, MessageService, SalesOrder, $uibModal, Product, $localStorage, $http,
        $stateParams, $rootScope, Channels, $q) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.timeName = 'day';
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            merchantName: '',
            productId: '',
            sku: '',
            returnPiece: '',
            type: 'unProduce',
            startDate: '',
            endDate: '',
        };
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeName = '';

        $scope.getProductId =function(data){
            vm.tableData.productId =data ? data.id :'';
        };

        init();
        function init() {
            // 获取全部渠道和商户的数据
            vm.merchantNames = SalesOrder.getAllStoreName({});

            // 获取商品信息
            Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
                vm.productList = res.filter(function(item){return item.enable});
            })

            //unProduce待生产、Producing生产中、Delivered已发货
            vm.covarianceList = [
                {name:'待生产', value:'unProduce'},
                {name:'生产中', value:'Producing'},
                {name:'已发货', value:'Delivered'},
                {name:'已分配', value:'Assigned'}      // 这个类型是除了未分配之外的所有有效订单的集合
            ];
            vm.timeList = [
                {name:'昨日', value:'day'},
                {name:'最近7天', value:'week'},
                {name:'最近30天', value:'month'}
            ];

            $q.all([vm.merchantNames.$promise]).then(function(){
                if (vm.merchantNames.length>0) {
                    vm.tableData.merchantName = vm.merchantNames[0].storeName;
                }
                angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
                initData();
            })

        }
        $scope.timeCb = function (time) {
            // vm.timeName = time.value;
            angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
            if(time.value == 'day'){
                angular.element("#startDate").val(GetDateStr(-1)+' 00:00:00');
            }
            if(time.value == 'week'){
                angular.element("#startDate").val(GetDateStr(-7)+' 00:00:00');
            }
            if(time.value == 'month'){
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
            }
            initData();
        };

        $scope.inquire = function () {
            initData();
        }
        function initData() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _startDate = new Date(vm.tableData.startDate);
            var _endDate = new Date(vm.tableData.endDate);
            var _mistiming = parseInt(_endDate - _startDate) / 1000 / 60 / 60 / 24;
            vm.timeName = "";
            if(GetDateStr(-1) == vm.tableData.endDate){
                if(_mistiming == 0){vm.timeName = "day";}
                if(_mistiming == 6){vm.timeName = "week";}
                if(_mistiming == 29){vm.timeName = "month";}
            }

            var myChart = echarts.init(document.getElementById('main'));
            myChart.showLoading();
            SalesOrder.getData4Channel(vm.tableData, function (res) {
                chart(res.data, myChart);
                vm.pages = res.pages;
                vm.total = res.total;
                vm.quantity = res.quantity;
                myChart.hideLoading();

                // 表格数据
                vm.tableData2 =angular.copy(vm.tableData);
                // vm.tableData2.page= 0;
                vm.tableData2.size= 20;
                SalesOrder.getData4ChannelPage(vm.tableData2, function (data) {
                    vm.typeData = data;
                }, function (error) {});
            }, function () {
                MessageService.error("查询数据失败，请稍后重试！");
                myChart.hideLoading();
            })
        }


        function chart(data, myChart) {
            var _time = [];
            var _legend = "订单数";
            if(vm.tableData.startDate == vm.tableData.endDate){
                _time.push(vm.tableData.startDate)
            }else {
                _time = getDiffDate(vm.tableData.startDate,vm.tableData.endDate);
                _time.push(vm.tableData.endDate)
            }
            var option = {
                tooltip: {trigger: 'axis'},
                legend: {
                    data:[_legend]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    data: _time
                },
                yAxis: {},
                series: [{
                    name: _legend,
                    type: 'line',
                    itemStyle : {
                        normal : {
                            color:'#ff9601',
                            lineStyle:{
                                color:'#ff9601'
                            }
                        }
                    },
                    data: data
                }]
            };
            myChart.setOption(option);
        }

        function total(data){
            vm.typeData = [];
            vm.orderNumSum = 0;
            vm.quantitySum = 0;
            vm.pagesSum = 0;
            vm.downloadsSum = 0;
            if(vm.tableData.type == 'completed'){
                vm.typeName = '完成订单数';
            }
            if(vm.tableData.type == 'assigned'){
                vm.typeName = '分配订单数';
            }
            if(vm.tableData.type == 'downloaded'){
                vm.typeName = '下载次数';
                for(var item in data){
                    var _obj = {
                        productName: item,
                        downloads: data[item]
                    };
                    vm.downloadsSum += data[item];
                    vm.typeData.push(_obj)
                }
            }else {
                vm.typeData = data;
                for(var i=0; i<data.length; i++){
                    if(data[i].orderNum){
                        vm.orderNumSum += data[i].orderNum;
                    }
                    if(data[i].quantity){
                        vm.quantitySum += data[i].quantity;
                    }
                    if(data[i].pages){
                        vm.pagesSum += data[i].pages;
                    }
                }
            }
        }

        //下载
        $scope.chartExport = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            $http({
                url: 'api/sales_order/downloadData4Channel',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function getDate (datestr) {
            datestr = datestr.split(" ")[0];
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        }
        function getDiffDate (start, end) {
            var startTime = getDate(start);
            var endTime = getDate(end);
            var dateArr = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                var year = startTime.getFullYear();
                var month = startTime.getMonth().toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
                var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
                dateArr.push(year + "-" + month + "-" + day);
                startTime.setDate(startTime.getDate() + 1);
            }
            return dateArr;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliverChartController', DeliverChartController);

    DeliverChartController.$inject = ['$scope', '$state', 'MessageService', 'SalesOrder', '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope','Express', 'DeliveryRequest','Channels'];

    function DeliverChartController ($scope, $state, MessageService, SalesOrder, $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, Express, DeliveryRequest ,Channels) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.timeName = 'day';
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            supplierId: '',
            logisticsCompany: '',
            channelId: '',
            merchantName: '',
            startDate: '',
            endDate: '',
        };
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeName = '';

        init();
        function init() {
            Express.getAll(function(res){
                vm.expressCompanies = res.filter(function(item){return item.enable});
            });
            // 获取全部渠道和商户的数据
            vm.merchantNames = SalesOrder.getAllStoreName();
            // 获取全部渠道数据
            vm.channels = Channels.getAll();
            Supplier.getAll(function (res) {
                vm.supplierList = res.filter(function(item){return item.enable});
                vm.tableData.supplierId = res[0].id;
                vm.timeList = [
                    {name:'昨日', value:'day'},
                    {name:'最近7天', value:'week'},
                    {name:'最近30天', value:'month'}
                ];
                angular.element("#endDate").val(GetDateStr(-0)+' 23:59:59');
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
                initData();
            });
        }
        $scope.timeCb = function (time) {
            // vm.timeName = time.value;
            angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
            if(time.value == 'day'){
                angular.element("#startDate").val(GetDateStr(-1)+' 00:00:00');
            }
            if(time.value == 'week'){
                angular.element("#startDate").val(GetDateStr(-7)+' 00:00:00');
            }
            if(time.value == 'month'){
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
            }
            initData();
        };

        $scope.inquire = function () {
            initData();
        }
        function initData() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.supplierId == ""){
                MessageService.error("供应商不能为空");
                return
            }
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _startDate = new Date(vm.tableData.startDate);
            var _endDate = new Date(vm.tableData.endDate);
            var _mistiming = parseInt(_endDate - _startDate) / 1000 / 60 / 60 / 24;
            vm.timeName = "";
            if(GetDateStr(-1) == vm.tableData.endDate){
                if(_mistiming == 0){vm.timeName = "day";}
                if(_mistiming == 6){vm.timeName = "week";}
                if(_mistiming == 29){vm.timeName = "month";}
            }


            var myChart = echarts.init(document.getElementById('main'));
            myChart.showLoading();
            DeliveryRequest.getData2(vm.tableData, function (data) {
                console.log(data)
                chart(data, myChart);
                myChart.hideLoading();
            }, function (error) {});
            DeliveryRequest.getData(vm.tableData, function (res) {
                vm.typeData = res;
            }, function () {
                MessageService.error("查询数据失败，请稍后重试！");
                myChart.hideLoading();
            })
        }


        function chart(data, myChart) {
            var _time = [];
            var _legend = "订单数";
            if(vm.tableData.startDate == vm.tableData.endDate){
                _time.push(vm.tableData.startDate)
            }else {
                _time = getDiffDate(vm.tableData.startDate,vm.tableData.endDate);
                _time.push(vm.tableData.endDate)
            }
            var _chartData = chartData(data,_time);
            console.log(_time)
            var option = {
                tooltip: {trigger: 'axis'},
                legend: {
                    data:[_legend]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    data: _time
                },
                yAxis: {},
                series: [{
                    name: _legend,
                    type: 'line',
                    itemStyle : {
                        normal : {
                            color:'#ff9601',
                            lineStyle:{
                                color:'#ff9601'
                            }
                        }
                    },
                    data: _chartData
                }]
            };
            myChart.setOption(option);
        }

        //下载
        $scope.chartExport = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _data = {
                deliverCompany: vm.tableData.logisticsCompany,
                supId: vm.tableData.supplierId,
                channelId: vm.tableData.channelId,
                startDate: vm.tableData.startDate,
                endDate: vm.tableData.endDate,
            };
            $http({
                url: 'api/delivery-request/exportData2',
                method: "GET",
                params: _data,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function getDate (datestr) {
            datestr = datestr.split(" ")[0];
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        }
        function getDiffDate (start, end) {
            var startTime = getDate(start);
            var endTime = getDate(end);
            var dateArr = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                var year = startTime.getFullYear();
                var month = startTime.getMonth().toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
                var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
                dateArr.push(year + "-" + month + "-" + day);
                startTime.setDate(startTime.getDate() + 1);
            }
            return dateArr;
        }

        function chartData(data,time) {
            var _data = [];
            for(var j=0; j<time.length; j++){
                var _isTime = 0;
                var _time = time[j].length > 10 ? time[j].slice(0,10) : time[j];
                for(var i=0; i<data.length; i++){
                    var _deliveryDate = data[i].deliveryDate;
                    if(_deliveryDate == _time){
                        _isTime = data[i].quantity;
                        break
                    }
                }
                _data.push(_isTime)
            }
            console.log(_data)
            return _data
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chart', {
                parent: 'module',
                url: '/chart',
                data: {
                    authorities: ['ROLE_DATA_STATISTICS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/chart.html',
                        controller: 'ChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('merchant-chart', {
                parent: 'module',
                url: '/merchant-chart',
                data: {
                    authorities: ['ROLE_MERCHANT_CHART']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/merchant-chart.html',
                        controller: 'MerchantChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplier-download-chart', {
                parent: 'module',
                url: '/supplier-download-chart',
                data: {
                    authorities: ['ROLE_SUPPLIER_DOWNLOAD_CHART']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/supplier-download-chart.html',
                        controller: 'SupplierDowmloadChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('replenishment-chart', {
                parent: 'module',
                url: '/replenishment-chart',
                data: {
                    authorities: ['ROLE_DATA_STATISTICS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/replenishment-chart.html',
                        controller: 'ReplenishmentChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('deliver-chart', {
                parent: 'module',
                url: '/deliver-chart',
                data: {
                    authorities: ['ROLE_DATA_STATISTICS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/deliver-chart.html',
                        controller: 'DeliverChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('DeliverOrders', DeliverOrders);

    DeliverOrders.$inject = ['$resource'];

    function DeliverOrders ($resource) {
        var resourceUrl =  'api/deliver-orders/:path/:id';

        return $resource(resourceUrl, {}, {
            'page': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getData': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getData'
                }
            },
            'getData2': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getData2'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ChartController', ChartController);

    ChartController.$inject = ['$scope', '$state', 'MessageService', 'SalesOrder', '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope'];

    function ChartController ($scope, $state, MessageService, SalesOrder, $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope) {
        var vm = this;
        vm.token = $localStorage.authenticationToken;
        vm.timeName = 'day';
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            supId: '',
            productId: '',
            sku: '',
            returnPiece: '',
            type: 'Assigned',
            startDate: "",
            endDate: "",
        };
        vm.backList = [
            {name:'已回件', value: "true"},
            {name:'未回件', value: "false"}
        ];
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.typeName = '';

        $scope.getProductId =function(data){
            vm.tableData.productId =data ? data.id :'';
        };

        init();
        function init() {
            Supplier.getAll(function (res) {
                vm.supplierList = res.filter(function(item){return item.enable});
                vm.tableData.supId = res[0].id;

                //unProduce待生产、Producing生产中、Delivered已发货
                vm.covarianceList = [
                    // {name:'完成订单', value:'completed'},
                    // {name:'已分配订单', value:'assigned'},
                    // {name:'下载文件', value:'downloaded'}
                    {name:'已分配', value:'Assigned'},
                    {name:'已生产', value:'Producing'},
                    {name:'已发货', value:'Delivered'}    // 这个类型是除了未分配之外的所有有效订单的集合
                ];
                vm.timeList = [
                    {name:'昨日', value:'day'},
                    {name:'最近7天', value:'week'},
                    {name:'最近30天', value:'month'}
                ];
                angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
                initData();
            });
            Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
                vm.productList = res.filter(function(item){return item.enable});
            })
        }
        $scope.timeCb = function (time) {
            // vm.timeName = time.value;
            angular.element("#endDate").val(GetDateStr(-1)+' 23:59:59');
            if(time.value == 'day'){
                angular.element("#startDate").val(GetDateStr(-1)+' 00:00:00');
            }
            if(time.value == 'week'){
                angular.element("#startDate").val(GetDateStr(-7)+' 00:00:00');
            }
            if(time.value == 'month'){
                angular.element("#startDate").val(GetDateStr(-30)+' 00:00:00');
            }
            initData();
        };

        $scope.inquire = function () {
            initData();
        }
        function initData() {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.supId == ""){
                MessageService.error("供应商不能为空");
                return
            }
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            var _startDate = new Date(vm.tableData.startDate);
            var _endDate = new Date(vm.tableData.endDate);
            var _mistiming = parseInt(_endDate - _startDate) / 1000 / 60 / 60 / 24;
            vm.timeName = "";
            if(GetDateStr(-1) == vm.tableData.endDate){
                if(_mistiming == 0){vm.timeName = "day";}
                if(_mistiming == 6){vm.timeName = "week";}
                if(_mistiming == 29){vm.timeName = "month";}
            }

            var myChart = echarts.init(document.getElementById('main'));
            myChart.showLoading();
            SalesOrder.getData4Supplier(vm.tableData, function (res) {
                chart(res.data, myChart);
                vm.pages = res.pages;
                vm.total = res.total;
                vm.quantity = res.quantity;
                myChart.hideLoading();

                // 表格数据
                vm.tableData2 =angular.copy(vm.tableData);
                // vm.tableData2.page= 0;
                vm.tableData2.size= 20;
                SalesOrder.getData4SupplierPage(vm.tableData2, function (data) {
                    vm.typeData = data;
                }, function (error) {});
            }, function () {
                MessageService.error("查询数据失败，请稍后重试！");
                myChart.hideLoading();
            })
        }


        function chart(data, myChart) {
            var _time = [];
            var _legend = "订单数";
            if(vm.tableData.startDate == vm.tableData.endDate){
                _time.push(vm.tableData.startDate)
            }else {
                _time = getDiffDate(vm.tableData.startDate,vm.tableData.endDate);
                _time.push(vm.tableData.endDate)
            }
            var option = {
                tooltip: {trigger: 'axis'},
                legend: {
                    data:[_legend]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    data: _time
                },
                yAxis: {},
                series: [{
                    name: _legend,
                    type: 'line',
                    itemStyle : {
                        normal : {
                            color:'#ff9601',
                            lineStyle:{
                                color:'#ff9601'
                            }
                        }
                    },
                    data: data
                }]
            };
            myChart.setOption(option);
        }

        function total(data){
            vm.typeData = [];
            vm.orderNumSum = 0;
            vm.quantitySum = 0;
            vm.pagesSum = 0;
            vm.downloadsSum = 0;
            if(vm.tableData.type == 'completed'){
                vm.typeName = '完成订单数';
            }
            if(vm.tableData.type == 'assigned'){
                vm.typeName = '分配订单数';
            }
            if(vm.tableData.type == 'downloaded'){
                vm.typeName = '下载次数';
                for(var item in data){
                    var _obj = {
                        productName: item,
                        downloads: data[item]
                    };
                    vm.downloadsSum += data[item];
                    vm.typeData.push(_obj)
                }
            }else {
                vm.typeData = data;
                for(var i=0; i<data.length; i++){
                    if(data[i].orderNum){
                        vm.orderNumSum += data[i].orderNum;
                    }
                    if(data[i].quantity){
                        vm.quantitySum += data[i].quantity;
                    }
                    if(data[i].pages){
                        vm.pagesSum += data[i].pages;
                    }
                }
            }
        }

        //下载
        $scope.chartExport = function () {
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            if(vm.tableData.startDate == ""){
                MessageService.error("开始时间不能为空");
                return
            }
            if(vm.tableData.endDate == ""){
                MessageService.error("结束时间不能为空");
                return
            }
            $http({
                url: 'api/sales_order/downloadData4Supplier',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = Date.now() + ".xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
        function getDate (datestr) {
            datestr = datestr.split(" ")[0];
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        }
        function getDiffDate (start, end) {
            var startTime = getDate(start);
            var endTime = getDate(end);
            var dateArr = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                var year = startTime.getFullYear();
                var month = startTime.getMonth().toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
                var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
                dateArr.push(year + "-" + month + "-" + day);
                startTime.setDate(startTime.getDate() + 1);
            }
            return dateArr;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('gwApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };
        var DateZoneOffset_Value = ( - new Date().getTimezoneOffset() / 60);

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            config.headers["DateZone-Offset"] = DateZoneOffset_Value;
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "zh-cn"');
                $cookies.putObject(name, 'zh-cn');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('zh-cn');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('deltazo-main-');
        $sessionStorageProvider.setKeyPrefix('deltazo-main-');
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('gwApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('gwApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/gateway',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reserve2', {
                parent: 'module',
                url: '/reserve2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/reserve/reserve.html',
                        controller: 'ReserveTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ReserveTwoController', ReserveTwoController);

    ReserveTwoController.$inject = ['$scope','Reserves','Depository','ProductCategory', '$http','ParseLinks', '$stateParams','$localStorage','$uibModal'];

    function ReserveTwoController ($scope,Reserves,Depository,ProductCategory, $http,ParseLinks, $stateParams,$localStorage,$uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;
        vm.token = $localStorage.authenticationToken;
        vm.productCategoryFirst = ProductCategory.byCondition({items: [{key: 'subordinate', op: '=', value: false},{key: 'sort', op: '=', value: 'accessories'}, {key: 'enable', op: '=', value: true}]})

        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "accessories"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: 'accessories',// 类型。accessories 辅料 / product 成品
            key:'',
            state:'all',
            sort: ['createdDate,DESC'],
            warehouseId: ''
        };
        vm.conditionList = [
            {name:'全部', value:'all'},
            {name:'正常', value: 'normal'},
            {name:'预警', value:'warning'}
        ];
        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.page = 0;
            loadAll();
        };
        loadAll();
        function loadAll() {
            vm.inventories = [];
            Reserves.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.inventories = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }


        $scope.inventoryTask = function(data){
            $uibModal.open({
                templateUrl: 'app/accessories/reserve/inventoryTask.html',
                controller: 'InventoryTaskTwoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                loadAll();
            });
        };

        $scope.allocateTask = function(data){
            $uibModal.open({
                templateUrl: 'app/accessories/reserve/allocateTask.html',
                controller: 'AllocationTaskTwoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                loadAll();
            });
        };

        //下载
        $scope.orderExport = function () {
            $http({
                url: 'api/reserves/exportData',
                method: "GET",
                params: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "辅料仓库列表.xls";
                a.setAttribute('download', '');
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $scope.changeSearchCategoryFirst = function(){
            vm.productCategorySecond = [];
            vm.products = [];
            if (vm.tableData.categoryOneId == null) {
                return;
            }
            ProductCategory.byCondition({items:
                [{key: 'subordinate', op: '=', value: true},
                {key: 'enable', op: '=', value: true},
                {key: 'productCategory.id', op: '=', value: vm.tableData.categoryOneId}]
            }, function(res){
                 vm.productCategorySecond = res;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryTaskTwoController', InventoryTaskTwoController);

    InventoryTaskTwoController.$inject = ['$scope','$uibModalInstance','MessageService','Inventory','msgdata'];

    function InventoryTaskTwoController ($scope, $uibModalInstance,MessageService,Inventory,msgdata) {
        var vm = this;
        vm.inventory = msgdata;
        $scope.validate = function() {
            if (vm.num === null || vm.num === "") {
                MessageService.error("请输入调整数量");
                return false;
            };
            if(vm.num < 0){
                MessageService.error("数量不可为负数");
                return false;
            }
            if (vm.reason == null || vm.reason == "") {
                MessageService.error("请输入调整原因");
                return false;
            };
            return true;
        };

        $scope.saveInventory = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                skuName:vm.inventory.propertyConfig.sku,
                quantity:vm.inventory.availableQuantity,
                type:vm.num > vm.inventory.availableQuantity ?'in':'out',
                pageType:'accessories',
                num: vm.num > vm.inventory.availableQuantity ? vm.num - vm.inventory.availableQuantity : vm.inventory.availableQuantity - vm.num,
                warehouse:vm.inventory.warehouse,
                reason:vm.reason,
                propertyConfig: {id: vm.inventory.propertyConfig.id}
            };
            Inventory.create(obj,function (res) {
                MessageService.success("盘点调整新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("盘点调整新建失败1！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AllocationTaskTwoController', AllocationTaskTwoController);

    AllocationTaskTwoController.$inject = ['$scope','$state','$uibModalInstance','MessageService','Product','Allocations','Depository','msgdata'];

    function AllocationTaskTwoController ($scope, $state,$uibModalInstance,MessageService,Product,Allocations,Depository,msgdata) {
        var vm = this;
        vm.allocation = msgdata;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "accessories"},function(res){
            vm.depositories = res.filter(function(item){return item.defaulted});
        });
        Product.getAllByCondition({items:[{key:"category",op:"=",value:'GeneralProduct'}]},function (res){
            vm.products = res.filter(function(item){return item.enable});
        })

        $scope.validate = function() {
            if (vm.inWarehouse == null || vm.inWarehouse == "") {
                MessageService.error("请选择调入仓库");
                return false;
            };
            if (vm.allocation.warehouse.id ==vm.inWarehouse.id) {
                MessageService.error("调入仓库和调出仓库一致，无效");
                return false;
            };
            if (!vm.num) {
                MessageService.error("请选择调整数量");
                return false;
            };
            if (vm.num > vm.allocation.usableQuantity) {
                MessageService.error("调出库存不足！");
                return false;
            };
            if (!vm.reason) {
                MessageService.error("请选择调整原因");
                return false;
            };
            return true;
        };

        $scope.saveAllocation = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                inWarehouse:vm.inWarehouse,
                outWarehouse:vm.allocation.warehouse,
                measurement:vm.allocation.measurement,
                propertyConfig:vm.allocation.propertyConfig,
                type:'accessories',
                num:vm.num,
                reason:vm.reason
            };
            Allocations.create(obj,function (res) {
                MessageService.success("挑拨记录新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("挑拨记录新建失败！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outgoingAndWarehousing2', {
                parent: 'module',
                url: '/outgoingAndWarehousing2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_OUTIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/outgoingAndWarehousing/outgoingAndWarehousing.html',
                        controller: 'OutgoingWarehousingTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutgoingWarehousingTwoController', OutgoingWarehousingTwoController);

    OutgoingWarehousingTwoController.$inject = ['$scope','WarehouseRecords','Depository','MessageService', 'ParseLinks', '$stateParams'];

    function OutgoingWarehousingTwoController ($scope,WarehouseRecords,Depository,MessageService, ParseLinks, $stateParams) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;


        //type   accessories 辅料 / product 成品
        Depository.getAll({type: "accessories"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: 'accessories',// 类型。accessories 辅料 / product 成品
            key:'',
            sort: ['createdDate,DESC'],
            startTime:'',
            endTime:'',
            warehouseId:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        loadAll();
        function loadAll() {
            vm.warehouseRecords = [];
            vm.tableData.startTime = angular.copy(angular.element("#startDate").val());
            vm.tableData.endTime = angular.copy(angular.element("#endDate").val());
            WarehouseRecords.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.warehouseRecords = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.reset = function(){
            vm.tableData = {
                page: 0,
                size: 20,
                type: 'accessories',// 类型。accessories 辅料 / product 成品
                key:'',
                startTime:'',
                endTime:'',
                warehouseId:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            loadAll();
        };
        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryDetailTwoController', InventoryDetailTwoController);

    InventoryDetailTwoController.$inject = ['$scope','$state','Reserves','$uibModalInstance','msgdata','MessageService'];

    function InventoryDetailTwoController ($scope, $state,Reserves,$uibModalInstance,msgdata,MessageService) {
        var vm = this;
        vm.inventory= msgdata;
        if (vm.inventory.type == 'out') {
            vm.num = vm.inventory.quantity - vm.inventory.num;
        } else if (vm.inventory.type == 'in') {
            vm.num = vm.inventory.quantity + vm.inventory.num;
        }

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryAddTwoController', InventoryAddTwoController);

    InventoryAddTwoController.$inject = ['$scope','$state','Reserves','$uibModalInstance','MessageService','Inventory','$stateParams'];

    function InventoryAddTwoController ($scope, $state,Reserves,$uibModalInstance,MessageService,Inventory,$stateParams) {
        var vm = this;
        //获取产品 、sku 仓库
        Reserves.getAllReserveByType({type:'accessories'},function(res){
            console.log(res);
            res.forEach(function(item) {
                if (item && item.materialList && Array.isArray(item.materialList)) {
                    item.materialList.forEach(function(material) {
                        console.log(material);
                        if (material && material.propertyConfigs) {
                            var _temp = material.propertyConfigs.filter(function(config) {
                                return config && !config.cancelled;
                            });
                            material.propertyConfigs = _temp;
                        } else {
                            material = {
                                propertyConfigs : []
                            };
                        }
                    });
                }
            });
            vm.reserves = res;
        });

        vm.flag=false;
        //获取记录数量
        $scope.getRecordNum = function(data){
            if(data ==null){
                vm.quantity='';
                vm.flag=false;
            }else{
                Reserves.getByWarehouseAndProductNumber({
                    warehouseId:vm.warehouse.warehouse.id,
                    propertyConfigId:vm.propertyConfig.id,
                    type:'accessories'
                },function(res){
                    vm.quantity = res.availableQuantity;
                    vm.flag=false;
                },function(error){
                    vm.quantity =0;
                    vm.flag=true;
                });
            }
        };

        $scope.validate = function() {
            if (vm.warehouse == null || vm.warehouse == "") {
                MessageService.error("请选择仓库");
                return false;
            };

            if (vm.material == null || vm.material == '') {
                MessageService.error('请选择辅料');
                return false;
            }
            if (vm.propertyConfig == null || vm.propertyConfig == "") {
                MessageService.error("请选择SKU");
                return false;
            };

            if (vm.quantity == 0) {
                MessageService.error("所选辅料无库存记录,无法保存");
                return false;
            };
            if (vm.num == null || vm.num == "") {
                MessageService.error("请输入调整数量");
                return false;
            };

            if (vm.reason == null || vm.reason == "") {
                MessageService.error("请输入调整原因");
                return false;
            };
            return true;
        };

        $scope.saveInventory = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                skuName:vm.propertyConfig.sku,
                type:vm.num > vm.quantity ?'in':'out',
                pageType:'accessories',
                num: vm.num > vm.quantity ? vm.num - vm.quantity : vm.quantity - vm.num,
                quantity:vm.quantity,
                warehouse:vm.warehouse.warehouse,
                reason:vm.reason,
                propertyConfig: {id: vm.propertyConfig.id}
            };

            Inventory.create(obj,function (res) {
                MessageService.success("盘点调整新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("盘点调整新建失败！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inventory2', {
                parent: 'module',
                url: '/inventory2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_INVENTORY']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/inventory/inventory.html',
                        controller: 'InventoryTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('InventoryTwoController', InventoryTwoController);

    InventoryTwoController.$inject = ['$scope','Inventory','MessageService', 'Depository','ParseLinks', '$stateParams','$uibModal'];

    function InventoryTwoController ($scope,Inventory,MessageService, Depository,ParseLinks, $stateParams,$uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "accessories"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            pageType: 'accessories',// 类型。accessories 辅料 / product 成品
            key:'',
            sort: ['createdDate,DESC'],
            startDate:'',
            endDate:'',
            warehouseId:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        loadAll();
        function loadAll() {
            vm.inventories = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            Inventory.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.inventories = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.reset = function(){
            vm.tableData = {
                page: 0,
                size: 20,
                pageType: 'accessories',// 类型。accessories 辅料 / product 成品
                key:'',
                startDate:'',
                endDate:'',
                warehouseId:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            loadAll();
        };
        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }

        //新建盘点调整
        $scope.newInventory = function(){
            $uibModal.open({
                templateUrl: 'app/accessories/inventory/inventory-add.html',
                controller: 'InventoryAddTwoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(result){
                loadAll();
            });
        };

        //查看盘点调整
        $scope.viewInventory = function(data){
            $uibModal.open({
                templateUrl: 'app/accessories/inventory/inventory-detail.html',
                controller: 'InventoryDetailTwoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    msgdata: function() {
                        return data;
                    }
                }
            }).result.then(function(result){
                //loadAll();
            });
        };




    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AllocationAddTwoController', AllocationAddTwoController);

    AllocationAddTwoController.$inject = ['$scope','$state','$uibModalInstance','MessageService','Product','Reserves','Allocations','Depository'];

    function AllocationAddTwoController ($scope, $state,$uibModalInstance,MessageService,Product,Reserves,Allocations,Depository) {
        var vm = this;
        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "accessories"},function(res){
            vm.depositories = res.filter(function(item){return item.defaulted});
        });
        Product.getAllByCondition({items:[{key:"category",op:"=",value:'MaterialProduct'}]},function (res){
            // vm.materials = res.filter(function(item){return item.enable});
            var res1 = res.filter(function(item){return item.enable});
            res1.forEach(function(item) {
                        if (item && item.propertyConfigs) {
                            var _temp = item.propertyConfigs.filter(function(config) {
                                return config && !config.cancelled;
                            });
                            item.propertyConfigs = _temp;
                        } else {
                            // item = {
                            //     propertyConfigs : []
                            // };
                        }
            });
            vm.materials = res1
        })

        $scope.getUseQuantity = function(data,propertyConfig){
            if(data ==null){
                vm.reserveQuantity =-1;
            }else{
                Reserves.getByWarehouseAndProductNumber({
                    warehouseId:data.id,
                    propertyConfigId:propertyConfig.id,
                    type:'accessories'
                },function(res){
                    vm.reserveQuantity = res.usableQuantity;
                },function(error){
                    vm.reserveQuantity =0;
                });
            }
        };

        $scope.selectProduct = function(data){
            vm.outWarehouse =null;
            vm.inWarehouse =null;
            vm.reserveQuantity =-1;
            vm.propertyConfig =data.propertyConfigs[0];
        };

        $scope.validate = function() {
            if (vm.material == null || vm.material == '') {
                MessageService.error('请选择商品');
                return false;
            }
            if (vm.propertyConfig == null || vm.propertyConfig == '') {
                MessageService.error('请选择SKU');
                return false;
            }
            if (vm.outWarehouse == null || vm.outWarehouse == "") {
                MessageService.error("请选择调出仓库");
                return false;
            };
            if (vm.inWarehouse == null || vm.inWarehouse == "") {
                MessageService.error("请选择调入仓库");
                return false;
            };
            if (vm.outWarehouse.id ==vm.inWarehouse.id) {
                MessageService.error("调入仓库和调出仓库一致，无效");
                return false;
            };
            if (!vm.num) {
                MessageService.error("请选择调整数量");
                return false;
            };
            if (vm.num > vm.reserveQuantity) {
                MessageService.error("调出库存不足！");
                return false;
            };
            if (!vm.reason) {
                MessageService.error("请选择调整原因");
                return false;
            };
            return true;
        };

        $scope.saveAllocation = function(){
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            var obj={
                inWarehouse:vm.inWarehouse,
                outWarehouse:vm.outWarehouse,
                measurement:{
                    id:vm.material.measurementId,
                    name:vm.material.measurementName
                },
                propertyConfig:vm.propertyConfig,
                type:'accessories',
                num:vm.num,
                reason:vm.reason
            };
            Allocations.create(obj,function (res) {
                MessageService.success("挑拨记录新建成功!");
                $uibModalInstance.close();
            },function (error) {
                vm.isSaving = false;
                MessageService.error("挑拨记录新建失败！");
            });
        };

        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('allocation2', {
                parent: 'module',
                url: '/allocation2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_ALLOCATION']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/allocation/allocation.html',
                        controller: 'AllocationTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('AllocationTwoController', AllocationTwoController);

    AllocationTwoController.$inject = ['$scope','Allocations','Depository','MessageService', 'ParseLinks', '$stateParams','Product','$uibModal'];

    function AllocationTwoController ($scope,Allocations,Depository,MessageService, ParseLinks, $stateParams,Product,$uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.clear =clear;

        //type  accessories 辅料 / product 成品
        Depository.getAll({type: "accessories"},function(res){
            vm.categories = res.filter(function(item){return item.defaulted});
        });

        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];
        vm.tableData = {
            page: Number($stateParams.page) || 0,
            size: 20,
            type: 'accessories',// 类型。accessories 辅料 / product 成品
            key:'',
            sort: ['createdDate,DESC'],
            startDate:'',
            endDate:'',
            inWarehouseId:'',
            outWarehouseId:''
        };
        angular.element("#startDate").val(null);
        angular.element("#endDate").val(null);
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }

        loadAll();
        function loadAll() {
            vm.allocations = [];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());
            Allocations.page(vm.tableData, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');

                vm.allocations = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            loadAll();
                        }
                    }
                });
            }, function (error) {

            });
        }

        $scope.search =function(){
            vm.tableData.page = 0;
            loadAll();
        };

        $scope.reset = function(){
            vm.tableData = {
                page: 0,
                size: 20,
                type: 'accessories',// 类型。accessories 辅料 / product 成品
                key:'',
                startDate:'',
                endDate:'',
                inWarehouseId:'',
                outWarehouseId:''
            };
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            loadAll();
        };
        function clear(){
            vm.tableData.key = null;
            vm.tableData.page = 0;
            loadAll();
        }

        $scope.newAllocation = function(){
            $uibModal.open({
                templateUrl: 'app/accessories/allocation/allocation-add.html',
                controller: 'AllocationAddTwoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(result){
                //angular.forEach(vm.tableList, function (item) {
                //    item.checked = false;
                //});
                loadAll();
            });
        };




    }
})();
(function(){angular.module('gwApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/chart/chart.html','<div class="bgc-fff p30" id="orientation"><div class="clearfix"><span class="title1">\u4F9B\u5E94\u5546\u6570\u636E\u7EDF\u8BA1</span></div><div class="mtop20"><div class="form-search2"><ul class="clearfix"><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.supId" ng-options="data.id as data.name for data in vm.supplierList"><!-- <option value="" selected="selected">\u8BF7\u9009\u62E9</option> --></select></div></li><li><p>\u4EA7\u54C1</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.product" ng-options="data as data.name for data in vm.productList" ng-change="getProductId(vm.product)"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>SKU</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.sku" ng-options="data.sku as data.sku for data in vm.product.propertyConfigs"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u7EDF\u8BA1\u9879</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.type" ng-options="data.value as data.name for data in vm.covarianceList"></select></div></li><li><p>\u662F\u5426\u56DE\u4EF6</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.returnPiece" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul><ul class="clearfix"><li><p style="height: 10px"></p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p style="height: 10px"></p><div class="form-search2-term"><button type="button" class="c-btns mr10" ng-repeat="time in vm.timeList" ng-click="timeCb(time)" ng-class="{true: \'c-btn1\', false: \'c-btn2\'}[time.value == vm.timeName]">{{time.name}}</button></div></li></ul></div><div class="mt10" style="width: auto; max-width: 1200px; padding-right: 30px"><button type="button" class="c-btn c-btn1 mr10" ng-click="inquire()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="chartExport()">\u4E0B\u8F7D</button><div style="float: right; line-height: 36px; color: #333; font-weight: 600">\u5408\u8BA1\u8BA2\u5355\u603B\u6570\uFF1A{{vm.total || 0}}\uFF1B \u8BA2\u5355\u4EFD\u6570\uFF1A{{vm.quantity}}\u4EFD\uFF1B \u5408\u6210\u9875\u6570\uFF1A{{vm.pages || 0}}\u9875</div></div><div id="main" style="width: auto; max-width: 1200px; height:400px; margin-top: 20px"></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="line-height: 40px"></label><div class="c-form-div wid-1000"><div class="c-table mtop20 th-35"><table><thead><tr><th>\u4EA7\u54C1\u540D\u79F0</th><th>\u4EA7\u54C1SKU</th><th>\u8BA2\u5355\u6570\u91CF</th><th>\u8BA2\u5355\u4EFD\u6570</th><th>\u5408\u6210\u9875\u6570</th><th>\u5546\u54C1\u5355\u4EF7</th><th>\u603B\u91D1\u989D</th></tr></thead><tbody><tr ng-repeat="data in vm.typeData"><td>{{data.productName}}</td><td>{{data.sku}}</td><td>{{data.total}}</td><td>{{data.quantity}}</td><td>{{data.pageCount}}</td><td>{{data.price}}</td><td>{{data.totalSum}}</td></tr><tr class="noData" ng-if="vm.typeData.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table><!-- <div class="c-paging"> --><!-- <div class="c-paging1">\n                                <span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span>\n                                <span>\u5171{{vm.pagecount}}\u9875</span>\n                                <span>\u6BCF\u9875\n                                <b>{{vm.tableData2.size}}</b>\n                                \u6761\u6570\u636E\n                                </span>\n                            </div>\n                            <div id="paging" class="c-paging2"></div> --><!-- </div> --></div></div></div></div></div></div>');
$templateCache.put('app/chart/deliver-chart.html','<div class="bgc-fff p30" id="orientation"><div class="clearfix"><span class="title1">\u53D1\u8D27\u6570\u636E\u7EDF\u8BA1</span></div><div class="mtop20"><div class="form-search2"><ul class="clearfix"><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.supplierId" ng-options="data.id as data.name for data in vm.supplierList"><option value="" selected="selected">\u5168\u90E8</option></select></div></li><li><p>\u5FEB\u9012\u516C\u53F8</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.logisticsCompany" ng-options="data.id as data.name for data in vm.expressCompanies" ng-change="getProductId(vm.product)"><option value="" selected="selected">\u5168\u90E8</option></select></div></li><li><p>\u6E20\u9053</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.channelId" ng-options="data.id as data.name for data in vm.channels"><option value="" selected="selected">\u5168\u90E8</option></select></div></li><!-- <li>\n                    <p>\u5546\u6237</p>\n                    <div class="form-search2-term">\n                        <select class="c-select1" ng-model="vm.tableData.merchantName" ng-options="data.storeName as data.storeName for data in vm.merchantNames">\n                            <option value="" selected="selected">\u5168\u90E8</option>\n                        </select>\n                    </div>\n                </li> --></ul><ul class="clearfix"><li><p style="height: 10px"></p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p style="height: 10px"></p><div class="form-search2-term"><button type="button" class="c-btns mr10" ng-repeat="time in vm.timeList" ng-click="timeCb(time)" ng-class="{true: \'c-btn1\', false: \'c-btn2\'}[time.value == vm.timeName]">{{time.name}}</button></div></li></ul></div><div class="mt10" style="width: auto; max-width: 1200px; padding-right: 30px"><button type="button" class="c-btn c-btn1 mr10" ng-click="inquire()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="chartExport()">\u4E0B\u8F7D</button></div><div id="main" style="width: auto; max-width: 1200px; height:400px; margin-top: 20px"></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="line-height: 40px"></label><div class="c-form-div wid-1000"><div class="c-table mtop20 th-35"><table><thead><tr><th>\u4F9B\u5E94\u5546</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5546\u6237</th><th>\u53D1\u8D27\u6570</th></tr></thead><tbody><tr ng-repeat="data in vm.typeData"><td>{{data.supplierName}}</td><td>{{data.logisticsCompany}}</td><td>{{data.channelName}}</td><td>{{data.quantity}}</td></tr><tr class="noData" ng-if="vm.typeData.length == 0"><td colspan="4" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table><!-- <div class="c-paging"> --><!-- <div class="c-paging1">\n                                <span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span>\n                                <span>\u5171{{vm.pagecount}}\u9875</span>\n                                <span>\u6BCF\u9875\n                                <b>{{vm.tableData2.size}}</b>\n                                \u6761\u6570\u636E\n                                </span>\n                            </div>\n                            <div id="paging" class="c-paging2"></div> --><!-- </div> --></div></div></div></div></div></div>');
$templateCache.put('app/chart/merchant-chart.html','<div class="bgc-fff p30" id="orientation"><div class="clearfix"><span class="title1">\u5546\u6237\u6570\u636E\u7EDF\u8BA1</span></div><div class="mtop20"><div class="form-search2"><ul class="clearfix"><li><p>\u5546\u6237</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.merchantName" ng-options="data.storeName as data.storeName for data in vm.merchantNames"></select></div></li><li><p>\u4EA7\u54C1</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.product" ng-options="data as data.name for data in vm.productList" ng-change="getProductId(vm.product)"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>SKU</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.sku" ng-options="data.sku as data.sku for data in vm.product.propertyConfigs"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u7EDF\u8BA1\u9879</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.type" ng-options="data.value as data.name for data in vm.covarianceList"></select></div></li></ul><ul class="clearfix"><li><p>\u662F\u5426\u56DE\u4EF6</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.returnPiece" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p style="height: 10px; padding-top: 20px"></p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p style="height: 10px; padding-top: 20px"></p><div class="form-search2-term"><button type="button" class="c-btns mr10" ng-repeat="time in vm.timeList" ng-click="timeCb(time)" ng-class="{true: \'c-btn1\', false: \'c-btn2\'}[time.value == vm.timeName]">{{time.name}}</button></div></li></ul></div><div class="mt10" style="width: auto; max-width: 1200px; padding-right: 30px"><button type="button" class="c-btn c-btn1 mr10" ng-click="inquire()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="chartExport()">\u4E0B\u8F7D</button><div style="float: right; line-height: 36px; color: #333; font-weight: 600">\u5408\u8BA1\u8BA2\u5355\u603B\u6570\uFF1A{{vm.total || 0}}\uFF1B \u8BA2\u5355\u4EFD\u6570\uFF1A{{vm.quantity}}\u4EFD\uFF1B \u5408\u6210\u9875\u6570\uFF1A{{vm.pages || 0}}\u9875</div></div><div id="main" style="width: auto; max-width: 1200px; height:400px; margin-top: 20px"></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="line-height: 40px"></label><div class="c-form-div wid-1000"><div class="c-table mtop20 th-35"><table><thead><tr><th>\u4EA7\u54C1\u540D\u79F0</th><th>\u4EA7\u54C1SKU</th><th>\u8BA2\u5355\u6570\u91CF</th><th>\u8BA2\u5355\u4EFD\u6570</th><th>\u5408\u6210\u9875\u6570</th></tr></thead><tbody><tr ng-repeat="data in vm.typeData"><td>{{data.productName}}</td><td>{{data.sku}}</td><td>{{data.total}}</td><td>{{data.quantity}}</td><td>{{data.pageCount}}</td></tr><tr class="noData" ng-if="vm.typeData.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/chart/replenishment-chart.html','<div class="bgc-fff p30" id="orientation"><div class="clearfix"><span class="title1">\u8865\u8D27\u6570\u636E\u7EDF\u8BA1</span></div><div class="mtop20"><div class="form-search2"><ul class="clearfix"><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.supId" ng-options="data.id as data.name for data in vm.supplierList"><option value="" selected="selected">\u5168\u90E8</option></select></div></li><li><p>\u4EA7\u54C1</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.product" ng-options="data as data.name for data in vm.productList" ng-change="getProductId(vm.product)"><option value="" selected="selected">\u5168\u90E8</option></select></div></li><li><p>SKU</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.sku" ng-options="data.sku as data.sku for data in vm.product.propertyConfigs"><option value="" selected="selected">\u5168\u90E8</option></select></div></li><li><p>\u8865\u8D27\u539F\u56E0</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.replenishmentReason" ng-options="data.reason as data.reason for data in vm.reasonList"><option value="" selected="selected">\u5168\u90E8</option></select></div></li></ul><ul class="clearfix"><li><p style="height: 10px"></p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p style="height: 10px"></p><div class="form-search2-term"><button type="button" class="c-btns mr10" ng-repeat="time in vm.timeList" ng-click="timeCb(time)" ng-class="{true: \'c-btn1\', false: \'c-btn2\'}[time.value == vm.timeName]">{{time.name}}</button></div></li></ul></div><div class="mt10" style="width: auto; max-width: 1200px; padding-right: 30px"><button type="button" class="c-btn c-btn1 mr10" ng-click="inquire()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="chartExport()">\u4E0B\u8F7D</button></div><div id="main" style="width: auto; max-width: 1200px; height:400px; margin-top: 20px"></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="line-height: 40px"></label><div class="c-form-div wid-1000"><div class="c-table mtop20 th-35"><table><thead><tr><th>\u8865\u8D27\u539F\u56E0</th><th>\u8BA2\u5355\u6570\u91CF</th><th>\u4EFD\u6570</th></tr></thead><tbody><tr ng-repeat="data in vm.typeData"><td>{{data.replenishmentReason}}</td><td>{{data.quantity}}</td><td>{{data.total}}</td></tr><tr class="noData" ng-if="vm.typeData.length == 0"><td colspan="3" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table><!-- <div class="c-paging"> --><!-- <div class="c-paging1">\n                                <span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span>\n                                <span>\u5171{{vm.pagecount}}\u9875</span>\n                                <span>\u6BCF\u9875\n                                <b>{{vm.tableData2.size}}</b>\n                                \u6761\u6570\u636E\n                                </span>\n                            </div>\n                            <div id="paging" class="c-paging2"></div> --><!-- </div> --></div></div></div></div></div></div>');
$templateCache.put('app/chart/supplier-download-chart.html','<div class="bgc-fff p30" id="orientation"><div class="clearfix"><span class="title1">\u4F9B\u5E94\u5546\u6570\u636E\u4E0B\u8F7D\u7EDF\u8BA1</span></div><div class="mtop20"><div class="form-search2"><ul class="clearfix"><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.supId" ng-options="data.id as data.name for data in vm.supplierList"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u4EA7\u54C1</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.product" ng-options="data as data.name for data in vm.productList" ng-change="getProductId(vm.product)"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>SKU</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.sku" ng-options="data.sku as data.sku for data in vm.product.propertyConfigs"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u7EDF\u8BA1\u9879</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.type" ng-options="data.value as data.name for data in vm.covarianceList"></select></div></li></ul><ul class="clearfix"><li><p style="height: 10px"></p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p style="height: 10px"></p><div class="form-search2-term"><button type="button" class="c-btns mr10" ng-repeat="time in vm.timeList" ng-click="timeCb(time)" ng-class="{true: \'c-btn1\', false: \'c-btn2\'}[time.value == vm.timeName]">{{time.name}}</button></div></li></ul></div><div class="mt10" style="width: auto; max-width: 1200px; padding-right: 30px"><button type="button" class="c-btn c-btn1 mr10" ng-click="inquire()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="chartExport()">\u4E0B\u8F7D</button></div><div class="mtop20 c-form-div"><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u4EA7\u54C1\u540D\u79F0</th><th style="text-align: center">\u4EA7\u54C1SKU</th><th style="text-align: center">\u4EFD\u6570</th><th style="text-align: center">\u6587\u4EF6\u4E0B\u8F7D\u6570\u91CF</th></tr></thead><tbody><tr ng-repeat="data in vm.typeData"><td style="text-align: center">{{data.sku.split(\'_\')[0]}}</td><td style="text-align: center">{{data.sku}}</td><td style="text-align: center">{{data.quantity}}</td><td style="text-align: center">{{data.total}}</td></tr><tr class="noData" ng-if="vm.typeData.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/customerHub/customerHub-copy.html','<div class="bg-content"><div class="user-modal bg-center scrollbar-main" style="height: 470px;overflow: auto"><!--        <div style="margin-bottom: 20px;">--><!--            <span class="title1">\u590D\u5236\u6570\u636E</span>--><!--        </div>--><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding">\u590D\u5236\u6570\u636E</label><div class="col-md-12 col-sm-12 col-xs-12"><label><span title="{{sku.propertyConfig.sku}}">{{vm.data.data.propertyConfig.sku}}</span></label></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding">\u590D\u5236\u5230</label><div class="col-md-12 col-sm-12 col-xs-12"><label><input type="checkbox" ng-model="vm.selectedAll" ng-change="chooseAll()"> <span>\u5168\u9009</span></label></div><div class="col-md-12 col-sm-12 col-xs-12"><div ng-repeat="sku in vm.data.skuManages track by $index" ng-hide="sku.delete||sku.cancelled||sku.propertyConfig.id==vm.data.data.propertyConfig.id"><label><input type="checkbox" ng-model="sku.selected"> <span title="{{sku.propertyConfig.sku}}">{{sku.propertyConfig.sku}}</span></label></div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/customerHub/customerHub-detail.html','<div class="bgc-fff p30 clearfix"><div style="margin-bottom: 20px"><span class="title1">\u4F9B\u5E94\u5546\u8BE6\u60C5</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F9B\u5E94\u5546\u7B80\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.name" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F9B\u5E94\u5546\u5168\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.fullname" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8D26\u6237\u4F59\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><span style="font-size: 16px;margin-right: 30px">{{vm.supply.balance}}</span> <button type="button" class="btn-yellow-common btn-edit" ng-click="recharge()">\u5145\u503C</button> <button type="button" ng-if="!!vm.supply.balance" class="btn-yellow-common btn-edit" ng-click="transactionDetail()">\u4EA4\u6613\u660E\u7EC6</button></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u9884\u8B66\u91D1\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.warnBalance" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5206\u7C7B</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.category == \'SourceMaterials\'?\'\u539F\u8F85\u6750\u6599\':\'\u59D4\u5916\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7528\u6237\u540D</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.supply.username == null || vm.supply.username == \'\' ?\'\u65E0\':vm.supply.username}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u662F\u5426\u6709\u6548</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.supply.enable" style="outline: none" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u662F\u5426\u5916\u53D1</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.supply.outward" style="outline: none" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.outward"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5916\u53D1\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px" data-translate="{{\'supplier.outwardType.\' + vm.supply.outwardType}}"></span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.outward"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5916\u53D1\u5BF9\u63A5\u65B9</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.supply.supplierAbutSettingName}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7A0E\u7387\uFF08%\uFF09</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.taxRate" disabled="disabled"></div></div><!--<div class="col-lg-12 col-sm-12 form-group no-padding">--><!--<label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u62FC\u7248\u7BA1\u7406</label>--><!--<div class="col-md-9 col-sm-9 col-xs-8 line-35">--><!--<span ng-if="vm.supply.makeups.length >0" ng-repeat="makeup in vm.supply.makeups">{{makeup.name}};</span>--><!--</div>--><!--</div>--><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7ED3\u7B97\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.settlementMethod == \'CashSettlement\'?\'\u73B0\u7ED3\':\'\u6708\u7ED3\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7ED3\u7B97\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.settlementType == \'DownLoad\'?\'\u4E0B\u8F7D\u7ED3\u7B97\':\'\u53D1\u8D27\u7ED3\u7B97\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4ED8\u6B3E\u6761\u4EF6</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.paymentTerm == \'InvoicePayment\'?\'\u5F00\u7968\u4ED8\u6B3E\':\'\u8D27\u5230\u4ED8\u6B3E\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7EB3\u7A0E\u767B\u8BB0\u7F16\u7801</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.taxCode" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u6CE8\u518C\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.registeredAddress" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5907\u6CE8</label><div class="col-md-9 col-sm-9 col-xs-8"><textarea class="form-control-edit" style="height: 60px!important;resize: none" ng-model="vm.supply.remarks" disabled="disabled"></textarea></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5E8F\u53F7</th><th>\u8054\u7CFB\u5730\u5740</th><th>\u8054\u7CFB\u4EBA</th><th>\u8054\u7CFB\u65B9\u5F0F</th></tr><tr ng-repeat="location in vm.supply.locations track by $index"><td style="width: 80px">{{$index+1}}</td><td title="{{location.province+location.city+location.district+location.address}}">{{location.province+location.city+location.district+location.address.substr(0,15)+\'...\'}}</td><td title="{{location.contact}}">{{location.contact.length >15 ?location.contact.substr(0,15)+\'...\':location.contact}}</td><td>{{location.phone}}</td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.productionManages.length >0"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u751F\u4EA7\u7BA1\u7406</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5546\u54C1</th><!-- <th>\u673A\u578B</th> --><th>\u62FC\u7248\u65B9\u5F0F</th><th>\u6587\u4EF6\u683C\u5F0F</th><!-- <th>\u4EA7\u80FD</th> --><th>\u8986\u76D6\u533A\u57DF</th><!-- <th>\u4EF7\u683C\u8BBE\u7F6E</th> --></tr><tr ng-repeat="productionManage in vm.supply.productionManages track by $index"><td>{{productionManage.productName}}</td><!-- <td>{{productionManage.deviceType}}</td> --><td><button class="btn-yellow-common btn-edit" ng-click="skuMakeupDetail(productionManage)">\u67E5\u770B</button></td><td><button class="btn-yellow-common btn-edit" ng-click="skuFileDetail(productionManage)">\u67E5\u770B</button></td><!-- <td>{{productionManage.capacity}}</td> --><td><button class="btn-yellow-common btn-edit" ng-click="productionDetail(productionManage)">\u67E5\u770B</button></td><!-- <td>\n                        <button class="btn-yellow-common btn-edit" ng-click="propertyPrice(productionManage)">\u67E5\u770B</button>\n                    </td> --></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/customerHub/customerHub-dialog.html','<div class="bgc-fff p30 clearfix"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">{{titleContent}}</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5BA2\u6237\u7B80\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5BA2\u6237\u7B80\u79F0" ng-model="vm.customerHub.name"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5BA2\u6237\u5168\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5BA2\u6237\u5168\u79F0" ng-model="vm.customerHub.fillName"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.customerHub.id"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8D26\u6237\u4F59\u989D</label><div class="col-md-5 col-sm-5 col-xs-4"><input type="number" class="form-control-edit" ng-model="vm.customerHub.balance" min="0" disabled="disabled"></div><div class="col-md-4 col-sm-4 col-xs-3"><button type="button" class="btn-yellow-common btn-edit" ng-click="recharge()">\u9000\u6B3E</button> <button type="button" class="btn-yellow-common btn-edit" ng-click="transactionDetail()">\u4EA4\u6613\u660E\u7EC6</button></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F1A\u5458</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.customerHub.vipOpen" style="outline: none"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4EF7\u683C\u8C03\u6574\u6BD4\u4F8B</label><div class="col-md-2 col-sm-3 col-xs-3"><input type="number" class="form-control-edit" ng-model="vm.customerHub.priceAdaptRate" min="0" style="outline: none;width: 50%;display: inline-block;margin-right: 4px">%</div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5730\u5740\u81EA\u52A8\u83B7\u53D6</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.customerHub.acceptLocation" style="outline: none"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.customerHub.acceptLocation"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5546\u6237\u7F16\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u53F7" ng-model="vm.customerHub.storeNumber"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.customerHub.acceptLocation"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u63A5\u53E3api</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u63A5\u53E3api" ng-model="vm.customerHub.apiUrl"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u6709\u6548</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.customerHub.enable" style="outline: none"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding">\u5F00\u7968\u4FE1\u606F</label><div class="col-md-12 col-sm-12 col-xs-12"><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u516C\u53F8\u62AC\u5934</label><div class="col-md-9 col-sm-9 col-xs-8">{{vm.customerHub.companyTitle}}</div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u7EB3\u7A0E\u767B\u8BB0\u7F16\u7801</label><div class="col-md-9 col-sm-9 col-xs-8">{{vm.customerHub.taxPayerIdentifyNo}}</div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u6CE8\u518C\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8">{{vm.customerHub.bankName}}</div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u5F00\u6237\u884C\u540D\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8">{{vm.customerHub.accountNo}}</div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u5F00\u6237\u8D26\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8">{{vm.customerHub.address}}</div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u7535\u8BDD</label><div class="col-md-9 col-sm-9 col-xs-8">{{vm.customerHub.phone}}</div></div></div></div><!--    <div class="col-lg-12 col-sm-12 form-group no-padding">--><!--        <label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u5730\u5740</label>--><!--        <div class="col-md-9 col-sm-9 col-xs-8">--><!--            <table class="address-list">--><!--                <tr>--><!--                    <th>\u8054\u7CFB\u5730\u5740</th>--><!--                    <th>\u8054\u7CFB\u4EBA</th>--><!--                    <th>\u8054\u7CFB\u65B9\u5F0F</th>--><!--                    <th>\u64CD\u4F5C</th>--><!--                </tr>--><!--                <tr ng-repeat="location in vm.customerHub.locations track by $index">--><!--                    <td title="{{location.province+location.city+location.district+location.address}}">{{location.province+location.city+location.district+location.address.substr(0,15)+\'...\'}}</td>--><!--                    <td title="{{location.contact}}">{{location.contact.length >15 ?location.contact.substr(0,15)+\'...\':location.contact}}</td>--><!--                    <td>{{location.phone}}</td>--><!--                    <td style="width: 200px;">--><!--                        <button class="btn-yellow-common btn-edit" ng-click="addressEdit(location,$index)">\u7F16\u8F91</button>--><!--                        <button class="btn-yellow-common btn-edit" ng-click="addressDelete($index)">\u5220\u9664</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td colspan="5">--><!--                        <span ng-click="addAddress(\'\')" class="addblu">--><!--                            <img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u5730\u5740</span>--><!--                    </td>--><!--                </tr>--><!--            </table>--><!--        </div>--><!--    </div>--><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7528\u6237\u5217\u8868</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5E8F\u53F7</th><th>\u7528\u6237\u540D</th><th>\u59D3\u540D</th><th>\u8054\u7CFB\u65B9\u5F0F</th><th>\u64CD\u4F5C</th></tr><tr ng-repeat="user in vm.userGroups track by $index"><td style="width: 80px">{{$index+1}}</td><td>{{user.username}}</td><td>{{user.fullname}}</td><td>{{user.phone}}</td><td style="width: 300px"><button class="btn-yellow-common btn-edit" ng-click="editPhone(user)">\u7F16\u8F91</button> <button class="btn-yellow-common btn-edit" ng-click="modifyContent(user,$index)">\u91CD\u7F6E\u5BC6\u7801</button> <button class="btn-yellow-common btn-edit" ng-click="userDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="5"><span ng-click="modifyContent()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u7528\u6237</span></td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53EF\u7528\u4EA7\u54C1</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5546\u54C1</th><th>\u81EA\u6709\u5355\u53F7</th><th>\u64CD\u4F5C</th></tr><tr ng-repeat="productionManage in vm.customerHub.customerProductManages track by $index"><td><select class="c-select2 radius-5 special" ng-model="productionManage.productId" ng-change="changeProduct(productionManage)" ng-options="product.id as product.name for product in vm.products"><option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option></select></td><td><input type="checkbox" class="checkOrIf" ng-model="productionManage.numberShelf" style="outline: none"></td><td style="width: 200px"><button class="btn-yellow-common btn-edit" ng-click="skuMakeupDetail(productionManage)">\u8BBE\u7F6E</button> <button class="btn-yellow-common btn-edit" ng-click="productionDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="6"><span ng-click="addproduction()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u4EA7\u54C1</span></td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/customerHub/customerHub-sku.html','<div class="bg-content" style="max-height: 70vh"><div class="user-modal bg-center clearfix" style="width:940px"><div style="margin-bottom: 20px"><span class="title1">SKU\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5546\u54C1\u89C4\u683C</th><th style="text-align: center">\u662F\u5426\u5370\u524D\u5904\u7406</th><th style="text-align: center">\u9009\u62E9\u5370\u524D\u5904\u7406\u6D41\u7A0B</th><th style="text-align: center">\u662F\u5426\u6821\u9A8C</th><th style="text-align: center">\u6821\u9A8C\u65B9\u5F0F</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="skuManage in vm.skuManages track by $index" ng-hide="skuManage.delete||skuManage.cancelled"><td style="text-align: center"><select class="c-select2 radius-5 special" ng-model="skuManage.propertyConfigId" ng-change="changePropertyConfig(skuManage)" ng-options="property.id as property.sku for property in vm.propertyList"><option value="">\u8BF7\u9009\u62E9SKU</option></select></td><td style="text-align: center"><input type="checkbox" class="checkOrIf" ng-model="skuManage.prePress" style="outline: none"></td><td style="text-align: center"><select class="c-select2 radius-5 special" ng-model="skuManage.prePressFlowId" ng-options="prePress.id as prePress.name for prePress in vm.prePressList"><option value="">\u8BF7\u9009\u62E9</option></select></td><td><input type="checkbox" class="checkOrIf" ng-model="skuManage.needCheck" style="outline: none"></td><td><select class="c-select2 radius-5 special" ng-model="skuManage.proofRuleId" ng-options="rule.id as rule.name for rule in vm.proofRules"><option value="">\u8BF7\u9009\u62E9</option></select></td><td><button class="btn-yellow-common btn-edit" ng-click="skuCopy(skuManage)">\u590D\u5236</button> <button class="btn-yellow-common btn-edit" ng-click="skuDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="4" ng-if="vm.delSku.length"><span ng-click="addSkuManage()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFASKU\u7BA1\u7406</span></td></tr></tbody></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/customerHub/customerHub.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1" data-translate="customerHub.home.title"></span> <button type="button" class="c-btn c-btn1" ui-sref="customerHubNew">\u65B0\u5EFA\u5BA2\u6237</button><div class="pull-right"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.keyword"><button type="button" class="hei_35 clear-search" ng-click="vm.clear()"><span>\u6E05\u9664</span></button></span></div></form></div></div></div></div></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5BA2\u6237\u7B80\u79F0</th><th style="text-align: center">\u5BA2\u6237\u5168\u79F0</th><th style="text-align: center">\u662F\u5426\u4F1A\u5458</th><th style="text-align: center">\u8D26\u6237\u4F59\u989D</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="customerHub in vm.customerHubs track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{customerHub.name}}">{{customerHub.name.length >10 ?customerHub.name.substr(0,10)+\'...\':customerHub.name}}</td><td style="text-align: center" title="{{customerHub.fillName}}">{{customerHub.fillName.length >10 ? customerHub.fillName.substr(0,10)+\'...\':customerHub.fillName}}</td><td style="text-align: center">{{customerHub.vipOpen ? \'\u662F\' : \'\u5426\'}}</td><td style="text-align: center">{{customerHub.balance}}</td><td style="text-align: center">{{customerHub.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 300px; text-align: center"><button class="btn-yellow-common btn-edit" style="margin-right: 0" ui-sref="customerHubEdit({id:customerHub.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="btn-yellow-common btn-edit" ng-click="deleteCustomerHub(customerHub.id)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.suppliers.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/customerHub/edit-phone.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5BA2\u6237\u4FEE\u6539</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u7528\u6237\u540D\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.user.username" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="number" class="c-input1" ng-model="vm.user.phone"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="width: 375px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/customerHub/invoicing-detail.html','<div class="bgc-fff p30 clearfix"><div class="col-lg-12 col-sm-12 no-padding"><span class="title1">\u5DF2\u9009\u62E9\u7684\u5F00\u7968\u8BA2\u5355</span></div><div class="col-lg-12 col-sm-12 no-padding flex-btn-group-container" style="height: 35px"><div class="flex-1" style="height: 100%"><label class="control-label font-style">\u6765\u6E90</label></div><div class="flex-1" style="height: 100%"><label class="control-label font-style">\u652F\u4ED8\u65B9\u5F0F</label></div><div class="flex-1" style="height: 100%"><label class="control-label font-style">\u91D1\u989D</label></div><div class="flex-1" style="height: 100%"><label class="control-label font-style">\u652F\u4ED8\u65F6\u95F4</label></div><div class="flex-1" style="height: 100%"><label class="control-label font-style">\u5173\u8054\u652F\u4ED8\u8BA2\u5355Id</label></div><div class="flex-1" style="height: 100%"><label class="control-label font-style">\u4EA4\u6613\u6D41\u6C34\u53F7</label></div></div><div><div class="col-lg-12 col-sm-12 no-padding flex-btn-group-container" ng-repeat="order in vm.salesOrders track by $index"><div class="flex-1" style="height: 100%">\u8BA2\u5355\u652F\u4ED8</div><div class="flex-1" style="height: 100%"><div>{{order.payMethod==\'\u5FAE\u4FE1\u652F\u4ED8\'?\'\u589E\u503C\u7A0E\':order.payMethod == \'aliPay\'?\'\u652F\u4ED8\u5B9D\u652F\u4ED8\':order.payMethod == \'balance\'?\'\u4F59\u989D\u652F\u4ED8\':\'\'}}</div></div><div class="flex-1" style="height: 100%"><div>\uFFE5{{order.amount}}</div></div><div class="flex-1" style="height: 100%"><div>{{order.payDate| date:\'yyyy-MM-dd HH:mm\'}}</div></div><div class="flex-1" style="height: 100%"><div>{{order.number}}</div></div><div class="flex-1" style="height: 100%"><div>{{transactionId}}</div></div></div><div class="col-lg-12 col-sm-12 no-padding flex-btn-group-container" ng-repeat="order in vm.payOrders track by $index"><div class="flex-1" style="height: 100%">\u8D26\u53F7\u5145\u503C</div><div class="flex-1" style="height: 100%"><div>{{order.payMethod==\'\u5FAE\u4FE1\u652F\u4ED8\'?\'\u589E\u503C\u7A0E\':order.payMethod == \'aliPay\'?\'\u652F\u4ED8\u5B9D\u652F\u4ED8\':order.payMethod == \'balance\'?\'\u4F59\u989D\u652F\u4ED8\':\'\'}}</div></div><div class="flex-1" style="height: 100%"><div>\uFFE5{{order.amount}}</div></div><div class="flex-1" style="height: 100%"><div>{{order.payDate| date:\'yyyy-MM-dd HH:mm\'}}</div></div><div class="flex-1" style="height: 100%"><div>{{order.number}}</div></div><div class="flex-1" style="height: 100%"><div>{{transactionId}}</div></div></div></div><div class="col-lg-12 col-sm-12 no-padding mt10"><span class="title1">\u5F00\u7968\u72B6\u6001</span></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u72B6\u6001</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.invoice.invoiceStatus==\'CREATED\'?\'\u5F85\u5BA1\u6838\':vm.invoice.invoiceStatus == \'APPROVE\'?\'\u5BA1\u6838\u901A\u8FC7\':vm.invoice.invoiceStatus == \'REJECTED\'?\'\u5DF2\u9A73\u56DE\':vm.invoice.invoiceStatus == \'RECEIVING\'?\'\u914D\u9001\u4E2D\':vm.invoice.invoiceStatus == \'RECEIVED\'?\'\u5DF2\u7B7E\u6536\':\'\'}} </span><button class="btn-yellow-common btn-edit" style="margin: 0 10px" ng-click="approve(data)" ng-if="vm.invoice.invoiceStatus==\'CREATED\'">\u901A\u8FC7</button> <button class="btn-yellow-common btn-edit" ng-click="operate(\'\u62D2\u7EDD\u5F00\u7968\')" ng-if="vm.invoice.invoiceStatus==\'CREATED\'">\u62D2\u7EDD</button></div></div><div class="col-lg-12 col-sm-12 no-padding" ng-if="vm.invoice.invoiceStatus == \'REJECTED\'"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u62D2\u7EDD\u7406\u7531</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><textarea class="c-textarea1" ng-model="vm.invoice.remark" style="width: 40%; resize: none" disabled="disabled"></textarea></div></div><div class="col-lg-12 col-sm-12 no-padding" ng-if="vm.invoice.invoiceStatus == \'RECEIVING\'||vm.invoice.invoiceStatus == \'RECEIVED\'"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53D1\u7968\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.invoice.invoiceNumber}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding" ng-if="vm.invoice.invoiceStatus == \'RECEIVING\'||vm.invoice.invoiceStatus == \'RECEIVED\'"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5FEB\u9012\u516C\u53F8</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.invoice.deliveryCompany}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding" ng-if="vm.invoice.invoiceStatus == \'RECEIVING\'||vm.invoice.invoiceStatus == \'RECEIVED\'"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5FEB\u9012\u5355\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.invoice.deliveryNumber}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding mt50"><span class="title1">\u5F00\u7968\u4FE1\u606F</span></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u516C\u53F8\u62AC\u5934</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.customerHub.companyTitle}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.customerHub.taxPayerIdentifyNo}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5F00\u6237\u94F6\u884C\u540D\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.customerHub.bankName}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5F00\u6237\u8D26\u6237</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.customerHub.accountNo}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u516C\u53F8\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.customerHub.address}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u7535\u8BDD</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.customerHub.phone}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding mt30"><span class="title1">\u8D39\u7528\u540D\u76EE</span></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">{{vm.invoice.costItem==\'serviceFee\'?\'\u670D\u52A1\u8D39\':\'\'}}</label></div><div class="col-lg-12 col-sm-12 no-padding mt30"><span class="title1">\u6536\u4EF6\u4FE1\u606F</span></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u6536\u4EF6\u4EBA\u540D\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.invoice.location.contact}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.invoice.location.phone}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u6536\u4EF6\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><span style="font-size: 16px">{{vm.invoice.location.address}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5FEB\u9012\u5355\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8"><span style="font-size: 16px">{{vm.invoice.deliveryNumber}}</span></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53D1\u7968\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8"><span style="font-size: 16px">{{vm.invoice.invoiceNumber}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/customerHub/invoicing-operate.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">{{vm.title}}</span></div><div class="mtop20"><div ng-if="vm.title==\'\u53D1\u7968\u914D\u9001\u4FE1\u606F\'"><div class="c-form"><label class="c-form-label">\u53D1\u7968\u53F7\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.operate.invoiceNumber"></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u516C\u53F8\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.operate.deliveryCompany"></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="number" class="c-input1" ng-model="vm.operate.deliveryNumber"></div></div></div><div ng-if="vm.title==\'\u62D2\u7EDD\u5F00\u7968\'"><div class="c-form"><label class="c-form-label">\u62D2\u7EDD\u7406\u7531\uFF1A</label><div class="c-form-div" style="width: 375px"><textarea class="form-control-edit" style="height: 60px!important;resize: none" ng-model="vm.operate.remark"></textarea></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="width: 375px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving" ng-if="vm.title==\'\u53D1\u7968\u914D\u9001\u4FE1\u606F\'">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1 mr10" ng-click="save2()" ng-disabled="vm.isSaving" ng-if="vm.title==\'\u62D2\u7EDD\u5F00\u7968\'">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/customerHub/invoicing.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1" data-translate="invoicing.home.title"></span></div><div class="p30"><div class="clearfix"><button type="button" class="c-btn c-btn1 mr10" ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)">{{data.name}}</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5355\u53F7\u641C\u7D22\u3002" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u7533\u8BF7\u5355\u53F7</th><th style="text-align: center">\u53D1\u7968\u62AC\u5934</th><th style="text-align: center">\u53D1\u7968\u7C7B\u578B</th><th style="text-align: center">\u5F00\u7968\u91D1\u989D</th><th style="text-align: center">\u7533\u8BF7\u65E5\u671F</th><th style="text-align: center">\u53D1\u7968\u53F7</th><th style="text-align: center">\u5FEB\u9012\u5355\u53F7</th><th style="text-align: center">\u72B6\u6001</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.invoices" ng-if="vm.invoices.length > 0"><td style="text-align: center">{{data.number}}</td><td style="text-align: center">{{data.title}}</td><td style="text-align: center">{{data.type == \'VALUEADDEDTAX\'?\'\u589E\u503C\u7A0E\':data.type == \'ORDINARYTAX\'?\'\u666E\u901A\u53D1\u7968\':data.type}}</td><td style="text-align: center">{{data.amount}}</td><td style="text-align: center">{{data.createdDate| date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center">{{data.invoiceNumber}}</td><td style="text-align: center">{{data.deliveryNumber}}</td><td style="text-align: center">{{data.invoiceStatus==\'CREATED\'?\'\u5F85\u5BA1\u6838\':data.invoiceStatus == \'APPROVE\'?\'\u5BA1\u6838\u901A\u8FC7\':data.invoiceStatus == \'REJECTED\'?\'\u5DF2\u9A73\u56DE\':data.invoiceStatus == \'RECEIVING\'?\'\u914D\u9001\u4E2D\':data.invoiceStatus == \'RECEIVED\'?\'\u5DF2\u7B7E\u6536\':\'\'}}</td><td style="text-align: center"><button class="btn-yellow-common btn-edit" style="margin-right: 0" ui-sref="invoicing-detail({id:data.id, page: vm.tableData.page})">\u67E5\u770B</button> <button class="btn-yellow-common btn-edit" style="margin-right: 0" ng-click="approve(data)" ng-if="data.invoiceStatus==\'CREATED\'">\u901A\u8FC7</button> <button class="btn-yellow-common btn-edit" style="margin-right: 0" ng-click="operate(data,\'\u62D2\u7EDD\u5F00\u7968\')" ng-if="data.invoiceStatus==\'CREATED\'">\u62D2\u7EDD</button> <button class="btn-yellow-common btn-edit" ng-click="operate(data,\'\u53D1\u7968\u914D\u9001\u4FE1\u606F\')" ng-if="data.invoiceStatus==\'APPROVE\'">\u914D\u9001</button> <button class="btn-yellow-common btn-edit" ng-click="deleteData(data.id)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.invoices.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/customerHub/recharge-amount.html','<div class="bg-content"><div class="user-modal bg-center" style="min-height: 180px!important"><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u9000\u6B3E\u91D1\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="number" min="0.01" class="form-control-edit" step="0.01" placeholder="\u8BF7\u8F93\u5165\u9000\u6B3E\u91D1\u989D" ng-model="vm.balance"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/customerHub/reset-password.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u91CD\u7F6E\u5BC6\u7801</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u7528\u6237\u540D\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.user.username" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u65B0\u5BC6\u7801\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="password" class="c-input1" ng-model="vm.user.password"></div></div><div class="c-form"><label class="c-form-label">\u786E\u8BA4\u5BC6\u7801\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="password" class="c-input1" ng-model="vm.user.confirmPassword"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="width: 375px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/customerHub/transaction-detail.html','<div class="bg-content"><div class="user-modal bg-center" style="width: 100%!important"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u4EA4\u6613\u8BB0\u5F55</span></div><div class="mtop20"><div class="c-form" style="margin: 0"><label class="c-form-label">\u4EA4\u6613\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" style="width: 150px" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" style="width: 150px" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="clearfix" style="margin: 10px 0 0 0"><div class="c-form" style="float: left"><label class="c-form-label">\u4EA4\u6613\u7C7B\u578B\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.type" style="width: 150px" ng-options="type.name as type.value for type in vm.types" ng-change="search()"><option value="">\u4EA4\u6613\u7C7B\u578B</option></select></div></div><div style="float: left"><button type="button" class="c-btn c-btn1 hei_30" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn1 hei_30" ng-click="export()">\u4E0B\u8F7D</button></div></div></div><div class="c-table mtop20 th-35" style="height: 300px"><table><thead><tr><th style="width: 190px" class="no-padding">\u4EA4\u6613\u65F6\u95F4</th><th style="width: 160px" class="no-padding">\u4EA4\u6613\u7C7B\u578B</th><th style="width: 160px" class="no-padding">\u4EA4\u6613\u91D1\u989D</th><th style="width: 150px" class="no-padding">\u4EA4\u6613\u540E\u91D1\u989D</th><th style="width: 150px" class="no-padding">\u5546\u6237\u6E90\u5355\u53F7</th><th style="width: 150px" class="no-padding">\u64CD\u4F5C\u8005</th></tr></thead><tr ng-repeat="record in vm.records |orderBy:\'-createdDate\' track by $index"><td style="width: 190px">{{record.createdDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td style="width: 160px">{{getType(record.type)}}</td><td style="width: 160px">{{record.amount}}</td><td style="width: 150px">{{record.afterAmount}}</td><td style="width: 150px">{{record.sourceOrderNumber}}</td><td style="width: 150px">{{record.createdBy ==\'anonymousUser\' ? \'\u7CFB\u7EDF\u64CD\u4F5C\':record.createdBy}}</td></tr><tr class="noData" ng-if="vm.records.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div><div class="c-paging" style="margin-bottom: 20px;text-align: center!important"><button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/dataChart/orderStatistics.html','<div class="bgc-fff p30" id="orientation"><div class="clearfix"><span class="title1">\u95E8\u5E97\u7EDF\u8BA1</span></div><div class="mtop20"><div class="form-search2"><ul class="clearfix"><li><p>\u95E8\u5E97</p><div class="form-search2-term"><select class="c-select1" style="width: 160px" ng-model="vm.tableData.storeName" ng-options="data as data for data in vm.storeList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u5546\u54C1</p><div class="form-search2-term"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.productName"></div></li><li><p>\u8BA2\u5355\u72B6\u6001</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.state" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u65E5\u671F\u7C7B\u578B</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.dateType"><option value="created">\u5F55\u5165\u65E5\u671F</option><option value="delivered">\u53D1\u8D27\u65E5\u671F</option><option value="received">\u7B7E\u6536\u65E5\u671F</option></select></div></li><li><p>\u9009\u62E9\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" style="width: 160px" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" style="width: 160px" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div></li><li><p style="height: 20px"></p><div class="form-search2-term"><button type="button" class="c-btns mr10" ng-repeat="time in vm.timeList" ng-click="timeCb(time)" ng-class="{true: \'c-btn1\', false: \'c-btn2\'}[time.value == vm.timeName]">{{time.name}}</button></div></li><li><p style="height: 20px"></p><button type="button" class="c-btn c-btn1 mr10" ng-click="inquire()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="export()">\u4E0B\u8F7D</button></li></ul></div><div class="mtop20"><div class="c-table scrollbar-main"><table style="overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th>\u8BA2\u5355\u53F7</th><th style="text-align: center">\u5546\u6237\u6E90\u5355\u53F7</th><th style="text-align: center">\u8BA2\u5355\u6765\u6E90</th><th style="text-align: center">\u5546\u54C1\u8BE6\u60C5</th><th style="text-align: center">\u4F5C\u54C1\u540D</th><th style="text-align: center">\u603BP\u6570</th><th style="text-align: center">\u52A0\u9875\u6570</th><th style="text-align: center">\u8BA2\u8D2D\u6570\u91CF</th><th style="text-align: center">\u6E20\u9053\u4EF7</th><th style="text-align: center">\u751F\u4EA7\u5546</th><th style="text-align: center">\u7ED3\u7B97\u5355\u672C\u4EF7</th><th style="text-align: center">\u52A0\u9875\u4EF7</th><th style="text-align: center">\u7ED3\u7B97\u603B\u4EF7</th><th style="text-align: center">\u5F55\u5165\u65F6\u95F4</th><th style="text-align: center">\u4E0B\u8F7D\u65F6\u95F4</th><th style="text-align: center">\u53D1\u8D27\u65F6\u95F4</th><th style="text-align: center">\u7B7E\u6536\u65F6\u95F4</th><th style="text-align: center">\u5907\u6CE8</th><th style="text-align: center">\u662F\u5426\u8865\u8D27</th><th style="text-align: center">\u8865\u8D27\u539F\u56E0</th><th style="text-align: center">\u8865\u8D27\u5907\u6CE8</th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.number}}</td><td style="text-align: center;width: 200px;max-width: 200px;min-width: 200px">{{salesOrder.sourceOrderNumber}}</td><td style="text-align: center;width: 200px;max-width: 200px;min-width: 200px">{{salesOrder.sourceType == \'online_mi\' ? \'MI\u5546\u57CE\' :salesOrder.storeName}}</td><td style="text-align: center;width: 200px;max-width: 200px;min-width: 200px">{{salesOrder.propertySku}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.name}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.pageCount}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.addPageNum}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.quantity}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.settleAmount | currency}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.supplierName}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.supSettlePrice | currency}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.addPageAmount | currency}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.supSettleAmount | currency}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.createdDate | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.downLoadDate | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.deliveryDate | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.pickDate | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="width: 150px;max-width: 150px;min-width: 150px" title="{{salesOrder.remarks}}">{{salesOrder.remarks|limitTo:\'10\'}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.replenishment ? \'\u662F\' : \'\u5426\'}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.replenishmentReason}}</td><td style="width: 150px;max-width: 150px;min-width: 150px" title="{{salesOrder.replenishmentRemarks}}">{{salesOrder.replenishmentRemarks|limitTo:\'10\'}}</td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="18" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div></div>');
$templateCache.put('app/delivery/delivery-details.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53D1\u8D27\u8BF7\u6C42\u8BE6\u60C5</span></div><div class="mt10"><div class="title lh30">\u5546\u54C1\u8BE6\u60C5</div><div class="c-table1"><table><thead><tr><th>\u8BA2\u5355\u53F7</th><th>\u5546\u6237\u539F\u5355\u53F7</th><th>\u8BA2\u8D2D\u5546\u54C1</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u8BA1\u5212\u4EA4\u671F</th><th>\u4ED3\u5E93</th></tr></thead><tbody><tr ng-repeat="data in vm.data.salesOrders track by $index"><td>{{data.number}}</td><td>{{data.sourceOrderNumber}}</td><td>{{data.productName}}</td><td>{{data.quantity}}</td><td>{{data.expectedDate |date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{data.warehouseName}}</td></tr></tbody></table></div><div class="title lh30 mtop20">\u6536\u8D27\u8BE6\u60C5</div><div class="c-table1"><table><thead><tr><th>\u6536\u8D27\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th></tr></thead><tbody><tr><td>{{vm.data.contact}}</td><td>{{vm.data.phone}}</td><td>{{vm.data.address}}</td></tr></tbody></table></div><div class="title lh30 mtop20">\u7269\u6D41\u8BE6\u60C5</div><div class="c-table1"><table><thead><tr><th>\u63FD\u4EF6\u65F6\u95F4</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5FEB\u9012\u5355\u53F7</th></tr></thead><tbody><tr><td>{{vm.data.salesOrders[0].pickDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{vm.data.logisticsCompany}}</td><td>{{vm.data.logisticsNumber}}</td></tr></tbody></table></div><div class="mtop20 text-center"><button type="button" class="c-btn c-btn1" ng-click="modalHide()">\u8FD4\u56DE</button></div></div></div><style>.modal-dialog{\n        width: 800px !important;\n    }</style>');
$templateCache.put('app/delivery/delivery-request-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u5408\u5E76\u67E5\u8BE2</span> <button type="button" class="c-btn c-btn1" ng-click="mergeBtn()">\u5408\u5E76</button> <button type="button" class="c-btn c-btn1 printHide" style="margin-left: 15px" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div><div class="bgc-fff p30 scrollbar-main" style="padding-top: 0px; max-height: 550px; overflow-y: auto"><span ng-if="vm.dataList.length == 0">\u6682\u65E0\u53EF\u64CD\u4F5C\u8BA2\u5355</span><div class="c-table1" ng-repeat="data in vm.dataList track by $index"><table style="width: 800px"><thead><tr><td colspan="7" style="padding: 15px 15px"><span style="font-size: 14px">{{data.contact}},{{data.phone|limitTo:\'7\'}}****,{{data.address}}</span></td></tr><tr><th><input type="checkbox" ng-model="data.selected" ng-click="selectAll(data)"></th><th>\u5546\u6237\u539F\u5355\u53F7</th><th>\u53D1\u8D27\u8BF7\u6C42\u7F16\u53F7</th><th style="width: 80px">\u4F9B\u5E94\u5546</th><th style="width: 170px">\u8BA2\u8D2D\u5546\u54C1</th><th style="width: 80px">\u8BA2\u8D2D\u6570\u91CF</th><th>\u8BA1\u5212\u4EA4\u671F</th></tr></thead><tbody><tr ng-repeat="dr in data.deliveryRequestList"><td><input type="checkbox" ng-model="dr.selected" ng-click="selectOne(dr, data)"></td><td>{{dr.orderNumber}}</td><td>{{dr.number}}</td><td colspan="3" style="padding: 0"><div class="table-colspan-tr clearfix" ng-repeat="order in dr.salesOrders"><span class="spanText" title="{{order.supplierName}}" style="left: 0">{{order.supplierName}}</span> <span title="{{order.propertySku}}" class="spanText1 {{\'skuColor\' + color(dr.number, order.propertySku)}}" style="left: 80px"><span style="position: unset">{{order.propertySku}}</span> </span><span class="spanText" style="left: 250px;border-right: 0">{{order.quantity}}</span></div></td><td>{{dr.expectedDate | date:\'yyyy-MM-dd\'}}</td></tr><tr><td colspan="7" style="padding: 15px 15px"><span style="margin-right: 30px">\u8BA2\u5355\u884C\u6570:{{data.orderQuantity}}</span> <span>\u603B\u4EFD\u6570:{{data.quantity}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/delivery/delivery-request-page.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u5408\u5E76\u53D1\u8D27\u8BE6\u60C5</span> <button type="button" class="c-btn c-btn1 printHide" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div><div class="bgc-fff p30" style="padding-top: 0px; max-height: 550px; overflow-y: auto"><div class="c-table1"><table style="width: 800px"><thead><tr><td colspan="6" style="padding: 15px 15px"><span style="font-size: 14px">{{vm.data.contact + \',\' + vm.data.phone + \',\' + vm.data.address}}</span></td></tr><tr><th></th><th>\u5546\u6237\u539F\u5355\u53F7</th><th>\u4ED3\u5E93</th><th style="width: 110px">\u8BA2\u8D2D\u5546\u54C1</th><th style="width: 110px">\u8BA2\u8D2D\u6570\u91CF</th><th>\u8BA1\u5212\u4EA4\u671F</th></tr></thead><tbody><tr ng-repeat="dr in vm.data.deliveryRequestList track by $index"><td><input type="checkbox" ng-model="dr.checked" ng-click="selectOne(dr)"></td><td>{{dr.orderNumber}}</td><td>{{dr.warehouse.name}}</td><td colspan="2" style="padding: 0"><div class="table-colspan-tr clearfix" ng-repeat="order in dr.salesOrders track by $index"><span class="spanText" title="{{order.productName}}" style="left: 0; width: 110px">{{order.productName}}</span> <span class="spanText" style="border-right: 0;left: 110px; width: 110px">{{order.quantity}}</span></div></td><td>{{dr.expectedDate | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div><div style="line-height: 30px; font-weight: bold"><span style="margin-right: 30px">\u8BA2\u5355\u884C\u6570:{{vm.data.orderQuantity}}</span> <span>\u603B\u4EFD\u6570:{{vm.data.quantity}}</span></div></div></div>');
$templateCache.put('app/delivery/delivery-request-shipments.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u53D1\u8D27</span></div></div></div></div><div class="bgc-fff p30"><div class="c-form"><label class="c-form-label" style="width: 80px">\u5FEB\u9012\u516C\u53F8\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><select class="c-select1" ng-model="vm.expressSettingId" ng-options="data.id as data.name for data in vm.expressCompanies"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 80px">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.logisticsNumber"></div></div><div class="c-form"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving">\u63D0\u4EA4</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/delivery/delivery-request.html','<div class="bgc-fff p30"><p class="font_25">\u53D1\u8D27\u8BF7\u6C42</p><div class="search_content clearfix"><div class="pull-right wid-300"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.keyword"><button type="button" class="hei_35 clear-search" ng-click="vm.clear()"><span>\u6E05\u9664</span></button></span></div></form></div></div></div></div><div class="pull-left wid-500"><label class="c-form-label">\u8BA1\u5212\u4EA4\u671F\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.expectStart" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.expectEnd" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u4F9B\u5E94\u5546\uFF1A</label><select name="" class="c-select1" ng-model="vm.tableData.supId" ng-options="data.id as data.name for data in vm.supList"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u7269\u6D41\u516C\u53F8\uFF1A</label><select name="" class="c-select1" ng-model="vm.tableData.expressSettingId" ng-options="data.id as data.name for data in vm.expressCompanies"><option value="">\u8BF7\u9009\u62E9\u7269\u6D41\u516C\u53F8</option></select></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u72B6\u6001\uFF1A</label><select name="" class="c-select1" ng-model="vm.tableData.deliveryStatus" ng-options="data.value as data.name for data in vm.deliveryStatusList"><option value="">\u5168\u90E8</option></select></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><!-- <ul class="clearfix table-state">\n        <li ng-repeat="data in vm.conditionList track by $index"\n            ng-click="conditionSelect(data)"\n            ng-class="{\'pitchOn\': data.value == vm.condition}">{{data.name}}</li>\n    </ul> --><div class="p30"><div class="clearfix"><button type="button" class="c-btn c-btn1" ng-click="details()" ng-if="vm.condition==\'InitialOrder\'">\u67E5\u770B</button><!-- <button type="button" class="c-btn c-btn1" ng-click="shippedAgain()" ng-if="vm.condition==\'InitialOrder\'">\u91CD\u65B0\u53D1\u8D27</button>\n            <button type="button" class="c-btn c-btn1" ng-click="magerRequest()" ng-if="vm.condition==\'InitialOrder\'">\u5408\u5E76\u67E5\u8BE2</button> --> <button type="button" class="c-btn c-btn1" ng-click="showPage()" ng-if="vm.condition==\'MergeOrder\'">\u67E5\u770B</button> <button style="margin-left: 10px" type="button" class="c-btn c-btn1" ng-click="splitDeliveryRequest()" ng-if="vm.condition==\'MergeOrder\'">\u64A4\u9500\u5408\u5E76</button> <button type="button" class="c-btn c-btn1" ng-click="shipmentsClick()">\u53D1\u8D27</button></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center"></th><th style="text-align: center">\u53D1\u8D27\u8BF7\u6C42\u7F16\u53F7</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u8BA2\u5355\u53F7</th><th style="text-align: center">\u5546\u6237\u539F\u5355\u53F7</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u72B6\u6001</th><th style="text-align: center">\u4ED3\u5E93</th><th style="text-align: center">\u8BA1\u5212\u4EA4\u671F</th><th style="text-align: center">\u6536\u8D27\u4EBA</th><th style="text-align: center">\u8054\u7CFB\u7535\u8BDD</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u5FEB\u9012\u516C\u53F8</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u5FEB\u9012\u5355\u53F7</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u53D1\u8D27\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 20px; max-width: 20px; text-align: center"><input type="checkbox" ng-model="data.checked" ng-click="selectOne(data)"></td><td style="text-align: center">{{data.number}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.scmNumber}}</td><td style="text-align: center">{{data.orderNumber}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{statusInfo(data.deliveryStatus)}}</td><td style="text-align: center">{{data.warehouse.name}}</td><td style="text-align: center">{{data.expectedDate |date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center">{{data.contact}}</td><td style="text-align: center">{{data.phone}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.logisticsCompany}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.logisticsNumber}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="11" class="bgc-f0f0f2" ng-if="vm.condition==\'InitialOrder\'"><span>\u6682\u65E0\u5185\u5BB9</span></td><td colspan="9" class="bgc-f0f0f2" ng-if="vm.condition==\'MergeOrder\'"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/delivery/shippedAgain.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53D1\u8D27\u4FE1\u606F</span></div><div class="mt10"><div class="c-form"><label class="c-form-label" style="width: 80px">\u6E90\u5355\u53F7\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.datalist.orderNumber" disabled="disabled"></div></div><div ng-repeat="item in vm.datalist.salesOrders track by $index"><div class="c-form"><label class="c-form-label" style="width: 80px">\u8BA2\u8D2D\u5546\u54C1\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="item.propertySku" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label" style="width: 80px">\u8BA2\u8D2D\u6570\u91CF\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="item.quantity" disabled="disabled"></div></div></div><div class="title1">\u6536\u8D27\u5730\u5740</div><div class="c-form mt10"><label class="c-form-label" style="width: 80px">\u59D3\u540D\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.data.contact" placeholder="\u59D3\u540D"></div></div><div class="c-form"><label class="c-form-label" style="width: 80px">\u8054\u7CFB\u7535\u8BDD\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.data.phone" maxlength="11" placeholder="\u7535\u8BDD"></div></div><div class="c-form"><label class="c-form-label" style="width: 80px">\u6536\u8D27\u5730\u5740\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><select class="c-select1" style="width: 30%; margin-right: 10px" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="c-select1" style="width: 30%; margin-right: 10px" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="c-select1" style="width: 30%; margin-right: 10px" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 80px">\u8BE6\u7EC6\u5730\u5740\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.address" placeholder="\u8BE6\u7EC6\u5730\u5740"></div></div><div class="c-form"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/delivery/supplier-delivery-request.html','<div class="bgc-fff p30"><p class="font_25">\u4F9B\u5E94\u5546\u53D1\u8D27\u8BF7\u6C42</p><div class="search_content clearfix"><div class="pull-right wid-300"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.keyword"><button type="button" class="hei_35 clear-search" ng-click="vm.clear()"><span>\u6E05\u9664</span></button></span></div></form></div></div></div></div><div class="pull-left wid-500"><label class="c-form-label">\u8BA1\u5212\u4EA4\u671F\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.expectStart" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.expectEnd" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u4F9B\u5E94\u5546\uFF1A</label><select name="" class="c-select1" ng-model="vm.tableData.supId" ng-options="data.id as data.name for data in vm.supList"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u7269\u6D41\u516C\u53F8\uFF1A</label><select name="" class="c-select1" ng-model="vm.tableData.expressSettingId" ng-options="data.id as data.name for data in vm.expressCompanies"><option value="">\u8BF7\u9009\u62E9\u7269\u6D41\u516C\u53F8</option></select></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u72B6\u6001\uFF1A</label><select name="" class="c-select1" ng-model="vm.tableData.deliveryStatus" ng-options="data.value as data.name for data in vm.deliveryStatusList"><option value="">\u5168\u90E8</option></select></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><!-- <ul class="clearfix table-state">\n        <li ng-repeat="data in vm.conditionList track by $index"\n            ng-click="conditionSelect(data)"\n            ng-class="{\'pitchOn\': data.value == vm.condition}">{{data.name}}</li>\n    </ul> --><div class="p30"><div class="clearfix"><button type="button" class="c-btn c-btn1" ng-click="details()" ng-if="vm.condition==\'InitialOrder\'">\u67E5\u770B</button><!-- <button type="button" class="c-btn c-btn1" ng-click="shippedAgain()" ng-if="vm.condition==\'InitialOrder\'">\u91CD\u65B0\u53D1\u8D27</button>\n            <button type="button" class="c-btn c-btn1" ng-click="magerRequest()" ng-if="vm.condition==\'InitialOrder\'">\u5408\u5E76\u67E5\u8BE2</button> --> <button type="button" class="c-btn c-btn1" ng-click="showPage()" ng-if="vm.condition==\'MergeOrder\'">\u67E5\u770B</button><!-- <button style="margin-left: 10px;" type="button" class="c-btn c-btn1" ng-click="splitDeliveryRequest()" ng-if="vm.condition==\'MergeOrder\'">\u64A4\u9500\u5408\u5E76</button> --> <button type="button" class="c-btn c-btn1" ng-click="shipmentsClick()">\u53D1\u8D27</button></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center"></th><th style="text-align: center">\u53D1\u8D27\u8BF7\u6C42\u7F16\u53F7</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u8BA2\u5355\u53F7</th><th style="text-align: center">\u5546\u6237\u539F\u5355\u53F7</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u72B6\u6001</th><th style="text-align: center">\u4ED3\u5E93</th><th style="text-align: center">\u8BA1\u5212\u4EA4\u671F</th><th style="text-align: center">\u6536\u8D27\u4EBA</th><th style="text-align: center">\u8054\u7CFB\u7535\u8BDD</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u5FEB\u9012\u516C\u53F8</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u5FEB\u9012\u5355\u53F7</th><th style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">\u53D1\u8D27\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 20px; max-width: 20px; text-align: center"><input type="checkbox" ng-model="data.checked" ng-click="selectOne(data)"></td><td style="text-align: center">{{data.number}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.scmNumber}}</td><td style="text-align: center">{{data.orderNumber}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{statusInfo(data.deliveryStatus)}}</td><td style="text-align: center">{{data.warehouse.name}}</td><td style="text-align: center">{{data.expectedDate |date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center">{{data.contact}}</td><td style="text-align: center">{{data.phone}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.logisticsCompany}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.logisticsNumber}}</td><td style="text-align: center" ng-if="vm.condition==\'InitialOrder\'">{{data.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="11" class="bgc-f0f0f2" ng-if="vm.condition==\'InitialOrder\'"><span>\u6682\u65E0\u5185\u5BB9</span></td><td colspan="9" class="bgc-f0f0f2" ng-if="vm.condition==\'MergeOrder\'"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/home/home.html','<div class="col-xs-12"><div class="bgc-fff col-xs-12" style="padding: 15px"><div class="col-xs-4 text-center"><div class="col-xs-6"><h2 class="home-title-h2">{{vm.orderDatas.unProduceQuantity}}</h2><span style="font-size: 16px;color: #595959">\u5F85\u751F\u4EA7\u8BA2\u5355</span></div><div class="col-xs-6"><h2 class="home-title-h2 color-ff9601">{{vm.orderDatas.unProduceQuantity}}</h2><span style="font-size: 16px;color: #595959">\u5F85\u751F\u4EA7\u9884\u8B66</span></div></div><div class="col-xs-4 text-center"><div class="col-xs-6"><h2 class="home-title-h2">{{vm.orderDatas.producingQuantity}}</h2><span style="font-size: 16px;color: #595959">\u751F\u4EA7\u4E2D\u8BA2\u5355</span></div><div class="col-xs-6"><h2 class="home-title-h2 color-ff9601">{{vm.orderDatas.unDeliveryWarnQuantity}}</h2><span style="font-size: 16px;color: #595959">\u5F85\u53D1\u8D27\u9884\u8B66</span></div></div><div class="col-xs-4 text-center"><div class="col-xs-6"><h2 class="home-title-h2">{{vm.orderDatas.deliveredQuantity}}</h2><span style="font-size: 16px;color: #595959">\u5F85\u63FD\u4EF6\u8BA2\u5355</span></div><div class="col-xs-6"><h2 class="home-title-h2 color-ff9601">{{vm.orderDatas.deliveredWarnQuantity}}</h2><span style="font-size: 16px;color: #595959">\u672A\u63FD\u4EF6\u9884\u8B66</span></div></div><div class="col-xs-12 mtop20"><div id="main" style="width: auto; max-width: 1400px; height:400px; margin-top: 20px"></div></div></div><div class="bgc-fff col-xs-12 mtop20" style="padding: 15px"><div class="col-xs-12"><div class="col-xs-12 mtop20"><div class="col-xs-3" ui-sref="supplyManagement"><div class="col-xs-12"><img src="../content/images/gs3_gys.png" style="width: 14px;margin: -6px 8px 0 0"> <span style="font-size: 18px;color: #000">\u4F9B\u5E94\u5546</span></div><div class="col-xs-12" style="margin-top: 15px"><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u4F9B\u5E94\u5546\u603B\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.supplierDatas.totalQuantity}}</span></div><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u4F59\u989D\u9884\u8B66\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.supplierDatas.warnQuantity}}</span></div></div></div><div class="col-xs-3" ui-sref="channel"><div class="col-xs-12"><img src="../content/images/gs3_kc.png" style="width: 18px;margin: -6px 8px 0 0"> <span style="font-size: 18px;color: #000">\u6E20\u9053</span></div><div class="col-xs-12" style="margin-top: 15px"><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u6E20\u9053\u603B\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.channelDatas.totalQuantity}}</span></div><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u4F59\u989D\u9884\u8B66\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.channelDatas.warnQuantity}}</span></div></div></div><div class="col-xs-3" ui-sref="reserve"><div class="col-xs-12"><img src="../content/images/gs3_qd.png" style="width: 18px;margin: -6px 8px 0 0"> <span style="font-size: 18px;color: #000">\u6210\u54C1\u5E93\u5B58</span></div><div class="col-xs-12" style="margin-top: 15px"><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u6210\u54C1\u5E93\u5B58\u603B\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.reserveDatas.productTotalQuantity}}</span></div><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u9884\u8B66\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.reserveDatas.productWarnQuantity}}</span></div></div></div><div class="col-xs-3" ui-sref="reserve2"><div class="col-xs-12"><img src="../content/images/gs3_qd.png" style="width: 18px;margin: -6px 8px 0 0"> <span style="font-size: 18px;color: #000">\u8F85\u6750\u5E93\u5B58</span></div><div class="col-xs-12" style="margin-top: 15px"><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u8F85\u6750\u5E93\u5B58\u603B\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.reserveDatas.accessoryTotalQuantity}}</span></div><div><span class="col-xs-8" style="color: #595959; font-size: 14px; padding:0px">\u9884\u8B66\u6570\uFF1A</span> <span class="col-xs-4" style="color: #262626; font-size: 20px; padding:0px">{{vm.reserveDatas.accessoryWarnQuantity}}</span></div></div></div></div></div></div></div><!-- <div class="bgc-fff col-xs-3" style="padding-top: 15px; min-height: 815px;line-height: 30px">\n    <div style="color: #262626; font-size: 20px">\n        \u6700\u65B0\u6D88\u606F\n    </div>\n    <div style="color: #595959;font-size: 16px; padding-top: 8px;" ng-repeat="news in vm.newsDatas">\n        {{news.title}}\n    </div>\n    <div style="font-size: 14px; padding-top: 8px;text-align: center;">\n        <a ui-sref="inform">\u524D\u5F80\u901A\u77E5\u4E2D\u5FC3</a>\n    </div>\n</div>\n -->');
$templateCache.put('app/inventoryManagement/in-bound-details.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u91C7\u8D2D\u5355</span></div><div class="mtop20" style="display: flex"><div class="c-form"><label class="c-form-label control-label font-style">\u72B6\u6001\uFF1A</label><div class="c-form-div" style="line-height: 30px;color:#000;font-size: 15px;width: 100px">\u72B6\u6001</div></div><div class="c-form"><label class="c-form-label control-label font-style">\u64CD\u4F5C\u5458\uFF1A</label><div class="c-form-div" style="line-height: 30px;color:#000;font-size: 15px;width: 100px">\u72B6\u6001</div></div><div class="c-form"><label class="c-form-label control-label font-style">\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div" style="line-height: 30px;color:#000;font-size: 15px;margin-right: 40px"><select id="supplier" class="c-select1" ng-model="vm.data.supplier" ng-options="supplier as supplier.name for supplier in vm.suppliers" ng-change="getSupplier()"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u5355\u53F7\uFF1A</label><div class="c-form-div" style="line-height: 30px;color:#000;font-size: 15px"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.data.number"></div></div><div class="c-form"><div class="c-form-div" style="line-height: 30px;color:#000;font-size: 15px;margin-left: 10px"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="relationPurchase()">\u5173\u8054\u91C7\u8D2D\u5355</button></div></div></div><div class="c-form"><label class="c-form-label">\u4E0A\u4F20\u9644\u4EF6\uFF1A</label><div class="c-form-div flex-align-center" style="width: 50%" ng-if="vm.data.status == \'UNSUBMITTED\'"><input ng-if="!vm.data.fileUrl" type="file" class="form-control border-radius" datatype="coverImg" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"><div ng-if="!!vm.data.fileUrl"><span>{{vm.data.filename || vm.data.fileUrl}}</span> <i class="glyphicon glyphicon-remove" ng-click="vm.data.fileUrl = \'\'" style="color: red"></i></div></div><div class="c-form-div flex-align-center" style="width: 50%" ng-if="vm.data.status != \'UNSUBMITTED\'">{{vm.data.filename || vm.data.fileUrl}}</div></div><div class="c-form"><label class="c-form-label">\u5907\u6CE8\uFF1A</label><div class="c-form-div" style="width: 50%"><textarea maxlength="50" style="height: 50px" ng-model="vm.data.remarks" class="c-input1 c-textarea" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8" ng-if="vm.data.status == \'UNSUBMITTED\'"></textarea><span ng-if="vm.data.status != \'UNSUBMITTED\'">{{vm.data.remarks}}</span></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\uFF1A</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th style="min-width: 120px">\u5E8F\u53F7</th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>\u89C4\u683C\u7F16\u53F7</th><th>\u5E78\u597D\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5165\u5E93\u6570\u91CF</th><th>\u5165\u5E93\u91D1\u989D</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="purchaseProductLine in vm.data.lines track by $index"><td style="padding: 0"><select class="c-select1" ng-model="purchaseProductLine.product" ng-options="product as product.name for product in vm.products" ng-change="selectPurchaseProduct(purchaseProductLine)"><option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option></select></td><td style="padding: 0"><select class="c-select1" ng-model="purchaseProductLine.propertyConfig.id" ng-options="propertyConfig.id as propertyConfig.sku for propertyConfig in purchaseProductLine.propertyConfigs"><option value="">\u8BF7\u9009\u62E9SKU</option></select></td><td style="padding: 0; width: 80px; text-align: center">{{purchaseProductLine.product.measurementName}}</td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.num" style="border: 0" min="0"></td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.price" style="border: 0" min="0"></td><td style="padding: 0; width: 80px"><span ng-if="!!purchaseProductLine.num && !!purchaseProductLine.price">\uFFE5{{purchaseProductLine.num * purchaseProductLine.price |number:2}}</span></td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.tax" style="border: 0" min="0"></td><td style="padding: 0; width: 80px"><span ng-if="!!purchaseProductLine.price && !!vm.purchaseOrder.supplier">{{(purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price}}</span></td><td style="width: 200px; max-width: 200px; min-width: 200px"><!-- <button type="button" class="btn-flow" ng-click="editAddress($index)">\u7F16\u8F91\u8054\u7CFB\u4FE1\u606F</button> --> <button type="button" class="btn-flow" ng-click="vm.productDelete($index)">\u79FB\u9664</button></td></tr><tr><td colspan="9"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="addProduct()"><i></i>\u6DFB\u52A0\u5546\u54C1</button></td></tr></tbody></table></div></div></div><div class="c-form mtop20"><div class="wid_100" style="padding-left: 10px"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveNum()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1 mr10" ng-click="saveNum()" ng-disabled="vm.isSaving">\u63D0\u4EA4</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/inventoryManagement/in-bound.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5165\u5E93\u7BA1\u7406</span></div><div class="mtop20 clearfix"><div class="pull-left" style="padding-right: 20px"><label class="c-form-label">\u5165\u5E93\u5355\u53F7\uFF1A</label><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.number"></div><div class="pull-left wid-800"><label class="c-form-label ml-20">\u5165\u5E93\u65E5\u671F\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u5F00\u59CB\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u7ED3\u675F\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right" style="padding-right: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2 mr10" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1" ui-sref="inBoundNew">\u65B0\u589E\u5165\u5E93</button> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state }">{{data.name}}</li></ul><div class="p30"><div class="c-table mtop20 scrollbar-main"><table style="overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center">\u5165\u5E93\u5355\u53F7</th><th style="text-align: center">\u5165\u5E93\u603B\u91CF</th><th style="text-align: center">\u5165\u5E93\u603B\u989D</th><th style="text-align: center">\u72B6\u6001</th><th style="text-align: center">\u62A5\u8D27\u5907\u6CE8</th><th style="text-align: center">\u64CD\u4F5C\u4EBA</th><th style="text-align: center">\u521B\u5EFA\u65E5\u671F</th><th style="text-align: center">\u6700\u540E\u4FEE\u6539</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="text-align: center">{{salesOrder.stockOrderNumber}}</td><td style="text-align: center">{{salesOrder.inventoryStockNum}}</td><td style="text-align: center">{{salesOrder.inventoryStockAmount}}</td><td style="text-align: center">{{getStatus(salesOrder.status)}}</td><td style="text-align: center">{{salesOrder.businessRemark}}</td><td style="text-align: center">{{salesOrder.operator}}</td><td style="text-align: center">{{salesOrder.outStockTime | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center">{{salesOrder.outStockTime | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="outBoundDetails({\n                            id:salesOrder.id,\n                            page: vm.tableData.page,\n                            state:vm.tableData.state,\n                            stockOrderNumber:vm.tableData.stockOrderNumber,\n                            startDate:vm.tableData.startDate,\n                            endDate:vm.tableData.endDate,\n                            back:vm.tableData.back,\n                            number:vm.tableData.number,\n                            storeName:vm.tableData.storeName\n                    })">\u8BE6\u60C5</button></td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/inventoryManagement/out-bound-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u51FA\u5E93\u5355\u8BE6\u60C5</span></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u51FA\u5E93\u5355\u53F7</span><div class="orderDetails-text">{{vm.data.number}}</div></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u62A5\u8D27\u5355\u53F7</span><p class="orderDetails-text">{{vm.data.stockOrderNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u62A5\u8D27\u65E5\u671F</span><p class="orderDetails-text">{{vm.data.businessTime | date:\'yyyy-MM-dd HH:mm\'}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u72B6\u6001</span><p class="orderDetails-text">{{getStatus(vm.data.status)}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u7F16\u53F7</span><p class="orderDetails-text">{{vm.data.storeNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u540D\u79F0</span><p class="orderDetails-text">{{vm.data.storeName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u6765\u6E90\u6E20\u9053</span><p class="orderDetails-text">{{vm.data.channelName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u5730\u5740</span><p class="orderDetails-text">{{vm.data.address}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u64CD\u4F5C\u5458</span><p class="orderDetails-text">{{vm.data.operator}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u51FA\u5E93\u65E5\u671F</span><p class="orderDetails-text">{{vm.data.outStockTime | date:\'yyyy-MM-dd HH:mm\' }}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u51FA\u5E93\u8BF4\u660E</span><p class="orderDetails-text">{{vm.data.reason }}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title"><div style="display: flex"><span>\u5FEB\u9012\u5355\u53F7</span><div ng-if="vm.data.status == \'PartShippedOut\' || vm.data.status == \'ShippedOut\' || vm.data.status == \'ShippedIn\'" ng-click="outBound(false)" style="width: 18px;height: 18px;background: #ff9601;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-left: 6px"><img style="width: 10px;height: 10px" src="../../content//images/icon_edit.png" alt=""></div></div><p class="orderDetails-text">{{vm.data.expressNumber}}</p></span></li></ul><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u62A5\u8D27\u5907\u6CE8</span><div class="orderDetails-text">{{vm.data.businessRemark}}</div></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u8BB0\u8D26\u65B9\u5F0F</span><div class="orderDetails-text">{{vm.data.payType === \'CASH\' ? \'\u73B0\u7ED3\' : \'\u8BB0\u8D26\'}}</div></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u652F\u4ED8\u7F16\u53F7</span><div class="orderDetails-text">{{vm.data.payNumber}}</div></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u9000\u6B3E\u7F16\u53F7</span><div class="orderDetails-text">{{vm.data.refundNumber}}</div></li></ul></div></div></div></div></div><div class="bgc-fff p30" style="padding-top: 0"><div style="font-weight: bold;color: #000"><!-- #6786FC --> <span>\u5B9E\u4ED8\u603B\u8BA1\uFF1A<span style="color: #6786FC">{{vm.data.inventoryStockAmount | currency}}</span></span> <span ng-if="vm.refoundAmount !== 0">\u9000\u6B3E\u91D1\u989D\uFF1A<span style="color: #f00">{{ vm.refoundAmount | currency}}</span></span></div><div><div class="c-table1"><table><thead><tr><th></th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>sku\u7F16\u53F7</th><th>\u578B\u53F7\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th>\u62A5\u8D27\u6570\u91CF</th><th>\u51FA\u5E93\u4ED3\u5E93</th><th>\u51FA\u5E93\u6570\u91CF</th><th>\u51FA\u5E93\u91D1\u989D</th><th>\u5E93\u5B58\u6210\u672C</th><th ng-if="vm.data.status === \'ShippedIn\'">\u63A5\u6536\u6570\u91CF</th><th ng-if="vm.data.status === \'ShippedIn\'">\u5E94\u6536\u91D1\u989D</th><th ng-if="vm.data.status === \'ShippedIn\'">\u5DEE\u5F02</th><th ng-if="vm.data.status === \'UnShippedOut\'">\u5E93\u5B58\u8BF4\u660E</th></tr></thead><tbody><tr ng-repeat="data in vm.data.lines track by $index"><td>{{$index+1}}</td><td>{{data.productNumber}}</td><td>{{data.productName}}</td><td>{{data.skuNumber}}</td><td>{{data.skuStr}}</td><td>{{data.unit}}</td><td><input ng-if="vm.data.status ==\'UnShippedOut\'" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.price" ng-blur="checkPrice(data,data.price)"> <span ng-if="vm.data.status !==\'UnShippedOut\'">{{data.price | currency}}</span></td><td>{{data.num}}</td><td><select ng-if="vm.data.status ==\'UnShippedOut\'" name="" class="c-select1" style="width: 100%" ng-model="data.warehouseId" ng-options="category.id as category.name for category in data.warehouses" ng-change="vm.searchWarehouse(data,$index)"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select><span ng-if="vm.data.status !==\'UnShippedOut\'">{{data.warehouseName}}</span></td><td><input ng-if="vm.data.status ==\'UnShippedOut\'" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.outNum" ng-blur="checkNum(data,data.outNum)"> <span ng-if="vm.data.status !==\'UnShippedOut\'">{{data.outNum}}</span></td><td>{{data.outNum * data.price | currency}}</td><td>{{data.reserveAmount | currency}}</td><td ng-if="vm.data.status === \'ShippedIn\'">{{data.inStockNum}}</td><td ng-if="vm.data.status === \'ShippedIn\'">{{data.inStockAmount | currency}}</td><td ng-if="vm.data.status === \'ShippedIn\'">{{data.outNum - data.inStockNum}}</td><td ng-if="vm.data.status === \'UnShippedOut\'"><span ng-if="data.inventoryDesc !== null && data.inventoryDesc !== \'\'">\u73B0\u6709\u5E93\u5B58: </span>{{data.inventoryDesc}}</td></tr></tbody></table></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'UnShippedOut\'" ng-click="outBound(true)">\u51FA\u5E93</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'UnShippedOut\'" ng-click="jump()">\u53BB\u91C7\u8D2D</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-if="vm.data.status === \'UnShippedOut\'" ng-click="close()">\u5173\u95ED</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'ShippedIn\' && vm.data.diffQty !==  null && vm.data.diffQty !==  0  && !vm.data.checkDiff" ng-click="handleDifference()">\u5904\u7406\u5DEE\u5F02</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-click="export(\'storeBill\')">\u5BFC\u51FA\u95E8\u5E97\u8D26\u5355</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-click="export(\'costBill\')">\u5BFC\u51FA\u4ED3\u5E93\u6210\u672C</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div><style>.outBoundDetail-title{\n        font-size: 12px!important\n    }</style>');
$templateCache.put('app/inventoryManagement/out-bound-difference-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u5DEE\u5F02\u5355\u8BE6\u60C5</span></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u5DEE\u5F02\u5355\u53F7</span><div class="orderDetails-text">{{vm.data.number}}</div></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u51FA\u5E93\u5355\u53F7</span><p class="orderDetails-text">{{vm.data.inventoryStockNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u5904\u7406\u65E5\u671F</span><p class="orderDetails-text">{{vm.data.finishTime | date:\'yyyy-MM-dd HH:mm\'}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u72B6\u6001</span><p class="orderDetails-text">{{getStatus(vm.data.status)}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u7F16\u53F7</span><p class="orderDetails-text">{{vm.data.storeNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u540D\u79F0</span><p class="orderDetails-text">{{vm.data.storeName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u6765\u6E90\u6E20\u9053</span><p class="orderDetails-text">{{vm.data.channelName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u5730\u5740</span><p class="orderDetails-text">{{vm.data.address}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u64CD\u4F5C\u5458</span><p class="orderDetails-text">{{vm.data.operator}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u51FA\u5E93\u65E5\u671F</span><p class="orderDetails-text">{{vm.data.outStockTime | date:\'yyyy-MM-dd HH:mm\' }}</p></li></ul><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u5907\u6CE8</span><div class="orderDetails-text">{{vm.data.remark}}</div><!-- <input class="c-input1" ng-if="vm.data.status == \'ToCheck\'" ng-model="vm.data.remark" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8" style="resize: none;width: 500px;"></input> --></li></ul></div></div></div></div></div><div class="bgc-fff p30" style="padding-top: 0"><div><div class="c-table1"><table><thead><tr><th></th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>\u578B\u53F7\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th>\u62A5\u8D27\u6570\u91CF</th><th>\u51FA\u5E93\u4ED3\u5E93</th><th>\u51FA\u5E93\u6570\u91CF</th><th>\u5165\u5E93\u6570\u91CF</th><th>\u5DEE\u5F02</th></tr></thead><tbody><tr ng-repeat="data in vm.data.lines track by $index"><td>{{$index+1}}</td><td>{{data.productNumber}}</td><td>{{data.productName}}</td><td>{{data.skuStr}}</td><td>{{data.unit}}</td><td><input ng-if="vm.data.status ==\'UnShippedOut\'" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.price" ng-blur="checkPrice(data,data.price)"> <span ng-if="vm.data.status !==\'UnShippedOut\'">{{data.price | currency}}</span></td><td>{{data.num}}</td><td><select ng-if="vm.data.status ==\'UnShippedOut\'" name="" class="c-select1" style="width: 100%" ng-model="data.warehouseId" ng-options="category.id as category.name for category in data.warehouses" ng-change="vm.searchWarehouse(data,$index)"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select><span ng-if="vm.data.status !==\'UnShippedOut\'">{{data.warehouseName}}</span></td><td><input ng-if="vm.data.status ==\'UnShippedOut\'" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.outNum" ng-blur="checkNum(data,data.outNum)"> <span ng-if="vm.data.status !==\'UnShippedOut\'">{{data.outNum}}</span></td><td>{{data.inStockNum}}</td><td>{{data.outNum - data.inStockNum}}</td></tr></tbody></table></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'ToCheck\'" ng-click="handleDifference()">\u786E\u8BA4\u5DEE\u5F02</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'ToCheck\'" ng-click="handleRejectDifference()">\u9A73\u56DE</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div><style>.outBoundDetail-title{\n        font-size: 12px!important\n    }</style>');
$templateCache.put('app/inventoryManagement/out-bound-difference.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u51FA\u5E93\u5DEE\u5F02\u5355</span></div><div class="mtop20 clearfix"><div class="pull-left wid-800"><label class="c-form-label">\u5DEE\u5F02\u5355\u65E5\u671F\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u5F00\u59CB\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u7ED3\u675F\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u51FA\u5E93\u95E8\u5E97\uFF1A</label><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.storeName"></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u5DEE\u5F02\u5355\u53F7\uFF1A</label><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.number"></div><div class="pull-right" style="padding-right: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2 mr10" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" ng-click="orderExportDetails()">\u5BFC\u51FA\u660E\u7EC6</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state }">{{data.name}}</li></ul><div class="p30"><div class="c-table mtop20 scrollbar-main"><table style="overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th>\u5DEE\u5F02\u5355\u53F7</th><th style="text-align: center">\u51FA\u5E93\u5355\u53F7</th><th style="text-align: center">\u51FA\u5E93\u95E8\u5E97</th><th style="text-align: center">\u5DEE\u5F02\u6570\u91CF</th><th style="text-align: center">\u5DEE\u5F02\u91D1\u989D</th><th style="text-align: center">\u5907\u6CE8</th><th style="text-align: center">\u72B6\u6001</th><th style="text-align: center">\u5904\u7406\u65E5\u671F</th><th style="text-align: center">\u64CD\u4F5C\u4EBA</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.salesOrders track by $index" ng-click="tableTr(item)" ng-if="vm.salesOrders.length > 0"><td>{{item.number}}</td><td style="text-align: center">{{item.inventoryStockNumber}}</td><td style="text-align: center">{{item.storeName}}</td><td style="text-align: center">{{item.diffNum}}</td><td style="text-align: center">{{item.diffAmount}}</td><td style="text-align: center">{{item.remark}}</td><td style="text-align: center">{{getStatus(item.status)}}</td><td style="text-align: center">{{item.finishTime | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center">{{item.operator}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="outBoundDifferenceDetails({\n                            id:item.id,\n                            page: vm.tableData.page,\n                            state:vm.tableData.state,\n                            stockOrderNumber:vm.tableData.stockOrderNumber,\n                            startDate:vm.tableData.startDate,\n                            endDate:vm.tableData.endDate,\n                            back:vm.tableData.back,\n                            number:vm.tableData.number,\n                            storeName:vm.tableData.storeName\n                    })">\u8BE6\u60C5</button></td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/inventoryManagement/out-bound-preview.html','<div class="bgc-fff p30" style="position: relative"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u51FA\u5E93\u5355\u9884\u89C8</span> <button type="button" class="c-btn c-btn1" ng-click="preview()">\u6253\u5370\u9884\u89C8</button> <button type="button" class="c-btn c-btn2" ng-click="goback()">\u8FD4\u56DE</button> <button type="button" class="c-btn c-btn1" ng-click="export()" style="position: absolute;left: 36px;top: 96px">\u5BFC\u51FA</button></div><div class="mtop20" id="previewId" style="box-shadow: 0 0 24px 0 rgba(0, 0, 0, .2)"><div style="padding: 50px"><div style="font-size: 30px;font-weight: bold; height: 80px; border-bottom: 1px solid #ddd; text-align: center; color: #333; margin-bottom: 40px">MOMENTSGO\u51FA\u5E93\u5355</div><div style="display: flex;flex-wrap: wrap"><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u51FA\u5E93\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.number}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u51FA\u5E93\u65E5\u671F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.outStockTime | date:\'yyyy-MM-dd HH:mm\'}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u62A5\u8D27\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.stockOrderNumber}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u62A5\u8D27\u65E5\u671F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.businessTime | date:\'yyyy-MM-dd HH:mm\'}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u95E8\u5E97\u540D\u79F0:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.storeName}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u95E8\u5E97\u5730\u5740:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.address}}</div></div><div class="c-form" style="width: 100%"><label class="c-form-label control-label font-style">\u62A5\u8D27\u5907\u6CE8:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.businessRemark}}</div></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u5546\u54C1\u4FE1\u606F:</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>sku\u7F16\u53F7</th><th>\u578B\u53F7\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th>\u62A5\u8D27\u6570\u91CF</th><th>\u51FA\u5E93\u4ED3\u5E93</th><th>\u51FA\u5E93\u6570\u91CF</th></tr></thead><tbody><tr ng-repeat="item in vm.data.lines track by $index" ng-if="!item.cancelled"><td>{{item.productNumber}}</td><td>{{item.productName}}</td><td>{{item.skuNumber}}</td><td>{{item.skuStr}}</td><td>{{item.unit}}</td><td>{{item.price | currency}}</td><td>{{item.num}}</td><td>{{item.warehouseName}}</td><td>{{item.outNum}}</td></tr></tbody></table></div></div></div><div style="text-align: right; font-size: 18px; color: #333; line-height: 30px"><span style="margin-right: 40px">\u62A5\u8D27\u6570\u91CF\uFF1A{{vm.nums}}</span> <span>\u51FA\u5E93\u6570\u91CF\uFF1A{{vm.outNums}}</span></div></div></div></div>');
$templateCache.put('app/inventoryManagement/out-bound.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u51FA\u5E93\u7BA1\u7406</span></div><div class="form-search2 mtop20"><ul class="clearfix"><li><p>\u65E5\u671F\u7C7B\u578B</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.dateType"><option value="businessTime">\u62A5\u8D27\u65E5\u671F</option><option value="outStockTime">\u51FA\u5E93\u65E5\u671F</option></select></div></li><li><p>\u9009\u62E9\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u6765\u6E90\u95E8\u5E97</p><div class="form-search2-term"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.storeName"></div></li><li><p>\u51FA\u5E93\u5355\u53F7</p><div class="form-search2-term"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.number"></div></li><li><p>\u8BB0\u8D26\u65B9\u5F0F</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.payType" style="width: 120px"><option value="">\u5168\u90E8</option><option value="CASH">\u73B0\u7ED3</option><option value="CHARGE">\u8BB0\u8D26</option></select></div></li><li><p></p><div class="form-search2-term"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" ng-click="orderExportDetails()">\u5BFC\u51FA\u660E\u7EC6</button> <button type="button" class="c-btn c-btn1" ng-click="exportCountDetails()">\u5BFC\u51FA\u6C47\u603B\u660E\u7EC6</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state }">{{data.name}}</li></ul><div class="p30"><div class="c-table mtop20 scrollbar-main"><table style="width: 2300px; overflow-x: auto" class="out-bound-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th>\u51FA\u5E93\u5355\u53F7</th><th style="text-align: center">\u62A5\u8D27\u5355\u53F7</th><th style="text-align: center">\u6765\u6E90\u95E8\u5E97</th><th style="text-align: center">\u62A5\u8D27\u603B\u91CF</th><th style="text-align: center">\u62A5\u8D27\u603B\u989D</th><th style="text-align: center">\u51FA\u5E93\u6570\u91CF</th><th style="text-align: center">\u51FA\u5E93\u603B\u989D</th><th style="text-align: center">\u63A5\u6536\u6570\u91CF</th><th style="text-align: center">\u5DEE\u5F02</th><th style="text-align: center">\u5E94\u6536\u91D1\u989D</th><th style="text-align: center">\u62A5\u8D27\u65E5\u671F</th><th style="text-align: center">\u62A5\u8D27\u5907\u6CE8</th><th style="text-align: center">\u72B6\u6001</th><th style="text-align: center">\u8BB0\u8D26\u65B9\u5F0F</th><th style="text-align: center">\u51FA\u5E93\u8BF4\u660E</th><th style="text-align: center">\u51FA\u5E93\u65E5\u671F</th><th style="text-align: center">\u64CD\u4F5C\u4EBA</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.number}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.stockOrderNumber}}</td><td style="text-align: center;width: 200px;max-width: 200px;min-width: 200px">{{salesOrder.storeName}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{salesOrder.inventoryStockNum}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.inventoryStockAmount | currency}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{salesOrder.outStockNum}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.outStockAmount | currency}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{salesOrder.inStockNum}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{salesOrder.status == \'ShippedIn\' ? salesOrder.diffQty : \'\'}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{salesOrder.inStockAmount | currency}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.businessTime | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.businessRemark}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{getStatus(salesOrder.status)}}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{getPayType(salesOrder.payType)}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" title="{{salesOrder.reason}}">{{salesOrder.reason|limitTo:\'10\'}}</td><td style="text-align: center;width: 150px;max-width: 150px;min-width: 150px">{{salesOrder.outStockTime | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center;width: 100px;max-width: 100px;min-width: 100px">{{salesOrder.operator}}</td><td style="width: 100px; max-width: 100px; min-width: 100px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="outBoundDetails({\n                            id:salesOrder.id,\n                            page: vm.tableData.page,\n                            state:vm.tableData.state,\n                            stockOrderNumber:vm.tableData.stockOrderNumber,\n                            startDate:vm.tableData.startDate,\n                            endDate:vm.tableData.endDate,\n                            back:vm.tableData.back,\n                            number:vm.tableData.number,\n                            storeName:vm.tableData.storeName\n                    })">\u8BE6\u60C5</button> <button type="button" class="c-minBtn c-minBtn3" ui-sref="outBoundPreview({id:salesOrder.id})">\u67E5\u770B</button> <button type="button" class="c-minBtn c-minBtn3" ng-if="(salesOrder.outStockNum - salesOrder.inStockNum  > 0) && salesOrder.status == \'ShippedIn\' && !salesOrder.checkDiff" ng-click="handleDifference(salesOrder)">\u5904\u7406\u5DEE\u5F02</button></td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><style>.out-bound-table{\n    tr td:last-child, th:last-child {\n            position: sticky;\n            right: 0px;\n            background: #fff;\n        }\n    }</style>');
$templateCache.put('app/inventoryManagement/store-refund-goods-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u9000\u8D27\u5355\u8BE6\u60C5</span></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u9000\u8D27\u5355\u53F7</span><div class="orderDetails-text">{{vm.data.number}}</div></li><!-- <li class="col-xs-3 p0">\n                                <span class="orderDetails-title outBoundDetail-title">\u62A5\u8D27\u5355\u53F7</span>\n                                <p class="orderDetails-text">{{vm.data.inventoryStockNumber}}</p>\n                            </li> --><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u9000\u8D27\u65E5\u671F</span><p class="orderDetails-text">{{vm.data.applyTime | date:\'yyyy-MM-dd HH:mm\'}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u72B6\u6001</span><p class="orderDetails-text">{{getStatus(vm.data.status)}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u7F16\u53F7</span><p class="orderDetails-text">{{vm.data.storeNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u540D\u79F0</span><p class="orderDetails-text">{{vm.data.storeName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u6765\u6E90\u6E20\u9053</span><p class="orderDetails-text">{{vm.data.channelName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u95E8\u5E97\u5730\u5740</span><p class="orderDetails-text">{{vm.data.address}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u64CD\u4F5C\u5458</span><p class="orderDetails-text">{{vm.data.operator}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u5904\u7406\u65E5\u671F</span><p class="orderDetails-text">{{vm.data.confirmTime | date:\'yyyy-MM-dd HH:mm\' }}</p></li></ul><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title outBoundDetail-title">\u5907\u6CE8</span><div class="orderDetails-text">{{vm.data.remark}}</div></li></ul></div></div></div></div></div><div class="bgc-fff p30" style="padding-top: 0"><div><div class="c-table1"><table><thead><tr><th></th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>\u578B\u53F7\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th>\u9000\u8D27\u6570\u91CF</th><th>\u9000\u8D27\u5165\u5E93\u4ED3\u5E93</th><th>\u5B9E\u6536\u6570\u91CF</th><th>\u5B9E\u6536\u5355\u4EF7</th><th>\u5E93\u5B58\u8BF4\u660E</th></tr></thead><tbody><tr ng-repeat="data in vm.data.lines track by $index"><td>{{$index+1}}</td><td>{{data.productNumber}}</td><td>{{data.productName}}</td><td>{{data.sku}}</td><td>{{data.measurement && data.measurement.name || \'\'}}</td><td><span>{{data.price | currency}}</span></td><td>{{data.quantity}}</td><td><select ng-if="vm.data.status ==\'ToConfirm\'" name="" class="c-select1" style="width: 100%" ng-model="data.warehouseId" ng-options="category.id as category.name for category in data.warehouses" ng-change="vm.searchWarehouse(data,$index)"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select><span ng-if="vm.data.status !==\'ToConfirm\'">{{data.warehouseName}}</span></td><td><!-- <span >{{data.refundQuantity}}</span> --> <input ng-if="vm.data.status ==\'ToConfirm\'" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.refundQuantity"> <span ng-if="vm.data.status !==\'ToConfirm\'">{{data.refundQuantity}}</span></td><td><input ng-if="vm.data.status ==\'ToConfirm\'" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.refundPrice"> <span ng-if="vm.data.status !==\'ToConfirm\'">{{data.refundPrice | currency}}</span></td><td><span ng-if="data.inventoryDesc !== null && data.inventoryDesc !== \'\'">\u73B0\u6709\u5E93\u5B58: </span>{{data.inventoryDesc}}</td></tr></tbody></table></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'ToConfirm\'" ng-click="save()">\u786E\u8BA4\u9000\u8D27</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-if="vm.data.status === \'ToConfirm\'" ng-click="close()">\u5173\u95ED</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div><style>.outBoundDetail-title{\n        font-size: 12px!important\n    }</style>');
$templateCache.put('app/inventoryManagement/store-refund-goods.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u9000\u8D27\u7BA1\u7406</span></div><div class="mtop20 clearfix"><div class="pull-left wid-800"><label class="c-form-label">\u9000\u8D27\u65E5\u671F\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u5F00\u59CB\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u7ED3\u675F\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u6765\u6E90\u95E8\u5E97\uFF1A</label><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.storeName"></div><div class="pull-left" style="padding-left: 20px"><label class="c-form-label">\u9000\u8D27\u5355\u53F7\uFF1A</label><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.number"></div><div class="pull-right" style="padding-right: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2 mr10" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" ng-click="orderExportDetails()">\u5BFC\u51FA\u660E\u7EC6</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state }">{{data.name}}</li></ul><div class="p30"><div class="c-table mtop20 scrollbar-main"><table style="overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th>\u9000\u8D27\u5355\u53F7</th><th style="text-align: center">\u9000\u8D27\u95E8\u5E97</th><th style="text-align: center">\u9000\u8D27\u6570\u91CF</th><th style="text-align: center">\u9000\u8D27\u603B\u989D</th><th style="text-align: center">\u72B6\u6001</th><th style="text-align: center">\u9000\u8D27\u65E5\u671F</th><th style="text-align: center">\u9000\u8D27\u5907\u6CE8</th><th style="text-align: center">\u5B9E\u6536\u6570\u91CF</th><th style="text-align: center">\u5B9E\u6536\u603B\u989D</th><th style="text-align: center">\u5904\u7406\u65E5\u671F</th><th style="text-align: center">\u64CD\u4F5C\u4EBA</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.salesOrders track by $index" ng-click="tableTr(item)" ng-if="vm.salesOrders.length > 0"><td>{{item.number}}</td><td style="text-align: center">{{item.storeName}}</td><td style="text-align: center">{{item.quantity}}</td><td style="text-align: center">{{item.amount | currency }}</td><td style="text-align: center">{{getStatus(item.status)}}</td><td style="text-align: center">{{item.applyTime | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center">{{item.remark}}</td><td style="text-align: center">{{item.refundQuantity}}</td><td style="text-align: center">{{item.refundAmount | currency }}</td><td style="text-align: center">{{item.confirmTime | date:\'yyyy-MM-dd HH:mm\' }}</td><td style="text-align: center">{{item.operator}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="storeRefundGoodsDetails({\n                            id:item.id,\n                            page: vm.tableData.page,\n                            state:vm.tableData.state,\n                            stockOrderNumber:vm.tableData.stockOrderNumber,\n                            startDate:vm.tableData.startDate,\n                            endDate:vm.tableData.endDate,\n                            back:vm.tableData.back,\n                            number:vm.tableData.number,\n                            storeName:vm.tableData.storeName\n                    })">\u8BE6\u60C5</button></td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/invoice/invoice-detail.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53D1\u8D27\u8BE6\u60C5</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u516C\u53F8\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.logisticsCompany" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.logisticsNumber" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u53D1\u8D27\u65F6\u95F4\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.deliveryDate" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.contact" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" value="{{vm.invoice.phone|limitTo:\'7\'}}****" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u6536\u8D27\u5730\u5740\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.address" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div wid-800 deliver_form"><table><thead><tr><th>\u8BA2\u5355\u7F16\u53F7</th><th>\u5546\u6237\u539F\u5355\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u8BA2\u8D2D\u4EFD\u6570</th><th>\u5546\u54C1\u5355\u4F4D</th></tr></thead><tbody><tr ng-repeat="data in vm.invoice.salesOrders track by $index" ng-if="vm.invoice.salesOrders.length > 0"><td>{{data.number}}</td><td>{{data.sourceOrderNumber}}</td><td>{{data.propertySku}}</td><td>{{data.propertyNumber}}</td><td>{{data.quantity}}</td><td>{{data.unit}}</td></tr><tr class="noData" ng-if="!vm.invoice.salesOrders || vm.invoice.salesOrders.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u8DDF\u8E2A\uFF1A</label><div class="table-responsive expressInfo scrollbar-main" style="padding-left: 80px"><div ng-repeat="trace in vm.tracesList | orderBy: track.AcceptTime:\'desc\' track by $index" class="col-sm-12" ng-if="vm.tracesList.length > 0" style="padding-top: 10px"><div class="col-sm-1 left_width" style="padding-left: 20px; width: 200px">{{trace.AcceptTime}}</div><div class="col-sm-10 no-padding"><div class="circle_line" ng-style="{\'marginLeft\':-(vm.b+15)+\'px\'}"><div class="circle" ng-style="{\'background\':$parent.$index == 0 ?\'orange\':\'#f0f0f0\'}"></div><div class="line-1" ng-hide="$parent.$index == vm.tracesList.length-1 && $last"></div></div><span class="col-sm-10">{{trace.acceptStation}}</span></div></div><div class="c-form-div text-center wid-800 font" ng-if="vm.tracesList.length == 0">\u6682\u65E0\u7269\u6D41\u4FE1\u606F</div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/invoice/invoice.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53D1\u8D27\u5217\u8868</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u53D1\u8D27\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.deliveryStart" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.deliveryEnd" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u7269\u6D41\u516C\u53F8</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.expressSettingId" ng-options="data.id as data.name for data in vm.expressCompanies" ng-change="deliverChange()"><option value="">\u8BF7\u9009\u62E9\u7269\u6D41\u516C\u53F8</option></select></div></li><li><div class="form-search2-term" style="padding-top: 10px; padding-left: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2 mr10" ng-click="reset()">\u91CD\u7F6E</button> <button type="button" class="c-btn c-btn2" ng-click="orderExport()">\u5BFC\u51FA</button></div></li></ul></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value === vm.tableData.deliveryStatus}">{{data.name}}</li></ul><div class="c-table mtop20 p30"><table><thead><tr><th style="text-align: center">\u8BA2\u5355\u7F16\u53F7</th><th style="text-align: center">\u5546\u6237\u539F\u5355\u53F7</th><th style="text-align: center">\u5FEB\u9012\u516C\u53F8</th><th style="text-align: center">\u5FEB\u9012\u7F16\u53F7</th><th style="text-align: center">\u6536\u8D27\u4EBA</th><th style="text-align: center">\u8054\u7CFB\u7535\u8BDD</th><th style="text-align: center">\u53D1\u8D27\u65F6\u95F4</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{data.number}}</td><td style="text-align: center">{{data.orderNumber}}</td><td style="text-align: center">{{data.logisticsCompany}}</td><td style="text-align: center">{{data.logisticsNumber}}</td><td style="text-align: center">{{data.contact}}</td><td style="text-align: center">{{data.phone|limitTo:\'7\'}}****</td><td style="text-align: center">{{data.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="invoiceDetail({id:data.id, page: vm.tableData.page})">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/invoice/supplier-delivery-detail.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53D1\u8D27\u8BE6\u60C5</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u516C\u53F8\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.deliveryCompany" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.deliveryNumber" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u53D1\u8D27\u65F6\u95F4\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.deliveryTime" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.contact" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" value="{{vm.invoice.phone|limitTo:\'7\'}}****" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u6536\u8D27\u5730\u5740\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.invoice.address" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div wid-800 deliver_form"><table><thead><tr><th>\u8BA2\u5355\u7F16\u53F7</th><th>\u5546\u6237\u539F\u5355\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u8BA2\u8D2D\u4EFD\u6570</th><th>\u5546\u54C1\u5355\u4F4D</th></tr></thead><tbody><tr ng-repeat="data in vm.invoice.lines track by $index" ng-if="vm.invoice.lines.length > 0"><td>{{data.salesOrder.number}}</td><td>{{data.salesOrder.sourceOrderNumber}}</td><td>{{data.salesOrder.propertySku}}</td><td>{{data.salesOrder.propertyNumber}}</td><td>{{data.salesOrder.quantity}}</td><td>{{data.salesOrder.unit}}</td></tr><tr class="noData" ng-if="!vm.invoice.lines || vm.invoice.lines.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u8DDF\u8E2A\uFF1A</label><div class="table-responsive expressInfo scrollbar-main" style="padding-left: 80px"><div ng-repeat="trace in vm.tracesList | orderBy: track.AcceptTime:\'desc\' track by $index" class="col-sm-12" ng-if="vm.tracesList.length > 0" style="padding-top: 10px"><div class="col-sm-1 left_width" style="padding-left: 20px; width: 200px">{{trace.AcceptTime}}</div><div class="col-sm-10 no-padding"><div class="circle_line" ng-style="{\'marginLeft\':-(vm.b+15)+\'px\'}"><div class="circle" ng-style="{\'background\':$parent.$index == 0 ?\'orange\':\'#f0f0f0\'}"></div><div class="line-1" ng-hide="$parent.$index == vm.tracesList.length-1 && $last"></div></div><span class="col-sm-10">{{trace.acceptStation}}</span></div></div><div class="c-form-div text-center wid-800 font" ng-if="vm.tracesList.length == 0">\u6682\u65E0\u7269\u6D41\u4FE1\u606F</div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/invoice/supplier-delivery.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4F9B\u5E94\u5546\u53D1\u8D27\u8BB0\u5F55</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u53D1\u8D27\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.deliveryStart" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.deliveryEnd" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u7269\u6D41\u516C\u53F8</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.expressSettingId" ng-options="data.id as data.name for data in vm.expressCompanies" ng-change="deliverChange()"><option value="">\u8BF7\u9009\u62E9\u7269\u6D41\u516C\u53F8</option></select></div></li><li><div class="form-search2-term" style="padding-top: 10px; padding-left: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2 mr10" ng-click="reset()">\u91CD\u7F6E</button> <button type="button" class="c-btn c-btn2" ng-click="orderExport()">\u5BFC\u51FA</button></div></li></ul></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value === vm.tableData.deliveryStatus}">{{data.name}}</li></ul><div class="c-table mtop20 p30"><table><thead><tr><th style="text-align: center">\u7F16\u53F7</th><!-- <th style="text-align: center;">\u5546\u6237\u539F\u5355\u53F7</th> --><th style="text-align: center">\u5FEB\u9012\u516C\u53F8</th><th style="text-align: center">\u5FEB\u9012\u7F16\u53F7</th><th style="text-align: center">\u6536\u8D27\u4EBA</th><th style="text-align: center">\u8054\u7CFB\u7535\u8BDD</th><th style="text-align: center">\u53D1\u8D27\u65F6\u95F4</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{data.number}}</td><!-- <td style="text-align: center;">{{data.orderNumber}}</td> --><td style="text-align: center">{{data.deliveryCompany}}</td><td style="text-align: center">{{data.deliveryNumber}}</td><td style="text-align: center">{{data.contact}}</td><td style="text-align: center">{{data.phone|limitTo:\'7\'}}****</td><td style="text-align: center">{{data.deliveryTime | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="supplier-delivery-detail({id:data.id, page: vm.tableData.page})">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/login/login.html','<div class="bg-cover2"><div class="main_login"><div class="login_content"><div class="login_title">\u767B\u5F55</div><form ng-submit="vm.login($event)"><div class="input-content"><label for="username"><img src="content/images/logUser.png" alt=""> <input type="text" id="username" class="login-control ng-pristine ng-invalid ng-invalid-required" ng-model="vm.username" placeholder="\u8BF7\u8F93\u5165\u7528\u6237\u540D" required autocomplete="off"></label></div><div class="input-content"><label for="password"><img src="content/images/log_lock.png" alt=""> <input type="password" id="password" class="login-control ng-pristine ng-invalid ng-invalid-required" ng-model="vm.password" placeholder="\u8BF7\u8F93\u5165\u5BC6\u7801" required></label></div><div class="input-content border-none"><label for="password"><img src="content/images/logbox.png" alt="" ng-if="!vm.rememberMe" ng-click="vm.remember()"> <img src="content/images/logbox_hit.png" alt="" ng-if="vm.rememberMe" ng-click="vm.remember()"> <span class="login-control font-999">\u8BB0\u4F4F\u5BC6\u7801</span></label></div><div class="login_btn"><button type="submit" class="btn btn-primary" style="outline: none" data-translate="login.form.button">Sign in</button></div><!--<div class="input-group login-input">--><!--<input type="text" class="form-control ng-pristine ng-invalid ng-invalid-required" ng-model="vm.username" name="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" required style="height: 40px; width: 320px; border-radius: 0 2px 2px 0; background: url(\'content/images/lginman.png\') no-repeat 10px; padding-left: 40px; color: #999999; font-size: 14px; border: 1px solid #E6E6E6;" autocomplete="off">--><!--</div>--><!--<div class="input-group login-input">--><!--<input type="password" class="form-control ng-pristine ng-invalid ng-invalid-required" ng-model="vm.password" name="username" placeholder="{{\'login.form.password.placeholder\' | translate}}" required style="height: 40px; width: 320px;border-radius: 0 2px 2px 0; background: url(\'content/images/lginlck.png\') no-repeat 10px; padding-left: 40px; color: #262626; font-size: 14px; border: 1px solid #E6E6E6;">--><!--</div>--><!--<div style="margin-left: 11px; font-size: 8px; display: inline-flex; display: -webkit-inline-box;" class="login-input">--><!--<label class="my_protocol">--><!--<input class="input_agreement_protocol" type="checkbox" id="remember" name="remember" ng-model="vm.rememberMe"/>--><!--<span></span>--><!--</label>--><!--<div style="color: #999999; margin-top: 2px; margin-left: 10px; font-size: 10px;" data-translate="login.form.rememberme"></div>--><!--</div>--><!--<div class="login-btn">--><!--<button style="width: 320px; height: 50px; font-size: 16px; color: #FFFFFF; background-color: #07AEFC; border-radius: 25px; margin-top: 50px; outline: none;" type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button>--><!--</div>--></form></div></div></div><!--<div style="width: 100%;" class="login-background-color2">--><!--<div class="login-style2">--><!--<div class="login-box2" style=" width: 320px;margin: 50px auto; text-align: center;">--><!--<div class="login-logo2" style="padding-top: 50px;">--><!--<b><span data-translate="login.title" style="color: #004f97; font-size: 40px;"></span></b>--><!--</div>--><!--<form ng-submit="vm.login($event)">--><!--<div class="input-group login-input">--><!--<input type="text" class="form-control ng-pristine ng-invalid ng-invalid-required" ng-model="vm.username" name="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" required style="height: 40px; width: 320px; border-radius: 0 2px 2px 0; background: url(\'content/images/lginman.png\') no-repeat 10px; padding-left: 40px; color: #999999; font-size: 14px; border: 1px solid #E6E6E6;" autocomplete="off">--><!--</div>--><!--<div class="input-group login-input">--><!--<input type="password" class="form-control ng-pristine ng-invalid ng-invalid-required" ng-model="vm.password" name="username" placeholder="{{\'login.form.password.placeholder\' | translate}}" required style="height: 40px; width: 320px;border-radius: 0 2px 2px 0; background: url(\'content/images/lginlck.png\') no-repeat 10px; padding-left: 40px; color: #262626; font-size: 14px; border: 1px solid #E6E6E6;">--><!--</div>--><!--<div style="margin-left: 11px; font-size: 8px; display: inline-flex; display: -webkit-inline-box;" class="login-input">--><!--&lt;!&ndash; <input type="checkbox" ng-model="vm.rememberMe" name="remember"> &ndash;&gt;--><!--<label class="my_protocol">--><!--<input class="input_agreement_protocol" type="checkbox" id="remember" name="remember" ng-model="vm.rememberMe"/>--><!--<span></span>--><!--</label>--><!--<div style="color: #999999; margin-top: 2px; margin-left: 10px; font-size: 10px;" data-translate="login.form.rememberme">\u8BB0\u4F4F\u5BC6\u7801</div>--><!--</div>--><!--<div class="login-btn">--><!--<button style="width: 320px; height: 50px; font-size: 16px; color: #FFFFFF; background-color: #07AEFC; border-radius: 25px; margin-top: 50px; outline: none;" type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button>--><!--</div>--><!--</form>--><!--</div>--><!--</div>--><!--</div>--><!--<div style="border-top: solid #ddd 1px;width: 100%; padding: 30px 0; text-align: center;" ng-cloak>--><!--<p style="font-size: 14px; color: #808080;">\u7248\u6743\u4FE1\u606F\uFF1A\u4E0A\u6D77\u5E1B\u817E\u4FE1\u606F\u79D1\u6280\u6709\u9650\u516C\u53F8</p>--><!--<div style="font-size: 14px; color: #808080; line-height: 30px; margin-top: 12px;">--><!--<span>\u516C\u53F8\u5730\u5740\uFF1A\u4E0A\u6D77\u5E02\u6D66\u4E1C\u65B0\u533A\u5CE8\u5C71\u8DEF77\u53F7\u52A0\u548C\u5927\u53A6</span><span style="padding-left: 40px;">\u8054\u7CFB\u7535\u8BDD\uFF1A021-2025-0163</span>--><!--&lt;!&ndash;<br>&ndash;&gt;--><!--&lt;!&ndash;<span>\u5907\u6848\u53F7\uFF1A\u6CAAICP\u590722200\u53F7</span>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class="login-header bgc-fff" ng-cloak>--><!--&lt;!&ndash; \u5DE6\u4E0A\u89D2LOGO &ndash;&gt;--><!--<div class="logo-login2"></div>--><!--</div>-->');
$templateCache.put('app/module/module.html','<div class="shell"><div class="shell-head" style="min-width: 1140px"><div class="shell-head-logo" style="padding-left: 0px" ui-sref="home"><img src="content/images/logo1.png" style="width: 240px" alt=""></div><div class="shell-head-operation"><div class="shell-head-operation-user" style="cursor: pointer"><span>{{!!vm.user.fullname ? vm.user.fullname : vm.user.username}}</span></div><ul class="shell-head-operation-ul"><li ng-click="modifyContent()">\u4FEE\u6539\u5BC6\u7801</li><li ng-click="vm.logout()">\u9000\u51FA</li></ul></div><div class="shell-head-inform" ng-mouseenter="jzMessageOver($event)" ng-mouseleave="jzMessageLeave()"><div class="shell-head-inform-icon"><span ng-if="vm.unReadCount > 0">{{vm.unReadCount}}</span></div><div class="jz-message" ng-show="vm.jzMessageShow"><div class="jz-message-head"><span class="title">\u901A\u77E5</span> <span class="jz-message-head-btn" ng-click="readBatch()">\u5168\u90E8\u5DF2\u8BFB</span></div><div class="jz-message-body"><div class="jz-message-body-li" ng-repeat="item in vm.jzMessage" ng-click="read(item)" ng-if="vm.jzMessage.length>0"><div class="jz-message-body-li-title"><span></span><h3>{{item.title}}</h3></div><p title="{{item.content}}">{{item.content}}</p></div><div ng-if="vm.jzMessage.length === 0" style="padding: 30px 0; text-align: center">\u6682\u65E0\u901A\u77E5...</div></div><div class="jz-message-font"><a ui-sref="inform">\u524D\u5F80\u901A\u77E5\u4E2D\u5FC3</a></div></div></div></div><div class="shell-nav scrollbar-main" style="padding-bottom: 20px"><ul><li ng-repeat="module in vm.modules track by $index" ng-init="outerIndex = $index" ng-if="module.visiable"><div class="shell-nav-head clearfix list-menu" id="z{{$index}}"><div class="shell-nav-head-fl"><img ng-src="{{\'content/images/\' + module.icon}}" alt=""></div><div class="shell-nav-head-title">{{ module.name }}</div><div class="shell-nav-head-fr shell-nav-head-fr-show"></div></div><div class="shell-nav-body"><a ng-repeat="nav in module.menus" ng-if="nav.visiable" class="sub_menu" ng-click="navSelect(nav,outerIndex)" id="{{nav.id}}" ng-class="{\'navOn\' : vm.navId == nav.id}">{{nav.name}}</a></div></li></ul></div><div class="shell-content scrollbar-main" style="min-width: 900px"><div ui-view="content" style="padding: 30px"></div></div></div>');
$templateCache.put('app/module/reset-password.html','<form class="form-horizontal" name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="modal-header"><h4 class="modal-title" id="myUserLabel" data-translate="user.password.resetpassword" style="margin-left: 2%;font-size: 22px">ResetPassword</h4><div class="alert alert-success" ng-show="vm.success" data-translate="user.password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="user.password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="modal-body"><div class="form-group"><label class="col-sm-2 control-label" for="password" data-translate="global.form.newpassword">New Password</label><div class="col-sm-4"><input type="password" class="form-control" name="password" id="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required></div><div ng-show="form.password.    $dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="global.form.confirmpassword" for="confirmPassword">New password confirmation</label><div class="col-sm-4"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required></div><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><div style="text-align: end"><button type="submit" class="btn btn-primary" data-translate="user.password.form.save" ng-disabled="form.$invalid">Save</button> <button type="button" data-dismiss="modal" class="btn btn-default" ng-click="vm.cancel()" data-translate="user.password.form.back">cancel</button></div></div></form>');
$templateCache.put('app/order/delivery-dialog.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u53D1\u8D27</span></div></div></div></div><div class="bgc-fff p30"><div class="c-form"><label class="c-form-label" style="width: 80px">\u5FEB\u9012\u516C\u53F8\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><select class="c-select1" ng-model="vm.deliveryComp" ng-options="data.name as data.name for data in vm.expressCompanies"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 80px">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.logisticsNumber"></div></div><div class="c-form"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving">\u63D0\u4EA4</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/order/delivery-track.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7269\u6D41\u8F68\u8FF9</span></div><div class="mt10"><!-- \u7269\u6D41\u8F68\u8FF9 --><div class="timeline" ng-if="vm.trackData && vm.trackData.length"><div ng-repeat="item in vm.trackData" class="timeline-item" ng-class="{ \'timeline-item-last\': $last }"><div class="timeline-node" ng-class="{ \'timeline-node-active\': true }"></div><div class="timeline-line"></div><div class="timeline-content"><div class="timeline-content-title">{{item.acceptStation}}</div><div class="timeline-content-time">{{item.acceptTime}}</div></div></div></div><div ng-if="!vm.trackData.length" style="display: flex;align-items: center;justify-content: center;height: 100px;font-size: 20px">\u6682\u65E0\u5185\u5BB9</div></div><div style="padding-top: 20px;text-align: center"><button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u5173\u95ED</button></div></div><style>.timeline {\n        position: relative;\n        padding: 20px 0;\n    }\n    .timeline-item {\n        position: relative;\n        padding-left: 36px;\n        margin-bottom: 24px;\n        display: flex;\n        align-items: flex-start;\n    }\n    .timeline-item-last {\n        margin-bottom: 0;\n    }\n    .timeline-item-last .timeline-line {\n        display: none;\n    }\n    .timeline-node {\n        position: absolute;\n        left: 0;\n        top: 4px;\n        width: 16px;\n        height: 16px;\n        border-radius: 50%;\n        background-color: #F0F2F5;\n        border: 2px solid #E4E7ED;\n        box-sizing: border-box;\n        z-index: 1;\n    }\n    .timeline-node-active {\n        background-color: #409EFF;\n        border-color: #409EFF;\n        box-shadow: 0 0 0 4px rgba(64, 158, 255, 0.1);\n    }\n    .timeline-line {\n        position: absolute;\n        left: 7px;\n        top: 16px;\n        bottom: -24px;\n        width: 2px;\n        background-color: #E4E7ED;\n    }\n    .timeline-content {\n        flex: 1;\n        min-height: 48px;\n        padding: 4px 0;\n    }\n    .timeline-content-title {\n        font-size: 14px;\n        font-weight: 500;\n        color: #303133;\n        margin-bottom: 6px;\n        line-height: 20px;\n    }\n    .timeline-content-time {\n        font-size: 12px;\n        color: #909399;\n        line-height: 16px;\n    }</style>');
$templateCache.put('app/order/order-address.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4FEE\u6539\u8BA2\u5355\u5730\u5740</span></div><div class="mt10"><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.orderPack.orderLocation.contact" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.orderPack.orderLocation.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" maxlength="11"></div></div><!-- <div class="c-form">\n            <label class="c-form-label">\u8054\u7CFB\u5730\u5740\uFF1A</label>\n            <div class="c-form-div wid-1000">\n                <input type="text" class="c-input1" ng-model="vm.data.address" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u5730\u5740">\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label" style="padding-right: 20px">\u8054\u7CFB\u5730\u5740\uFF1A</label><div class="c-form-div wid-1000"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-1000"><textarea type="text" class="form-control-edit" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" style="resize: none" ng-model="vm.address"></textarea></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="padding-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" style="padding-left: 20px" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/order/order-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u8BA2\u5355\u8BE6\u60C5</span> <a target="_blank" ng-if="vm.salesOrder.orderType != \'General\'" ng-href="{{vm.fileUrl}}"><button type="button" class="c-btn c-btn1">\u7EC4\u7248\u6587\u4EF6</button> </a><a target="_blank" ng-if="vm.salesOrder.outpaintRequired" ng-href="{{vm.salesOrder.outpaintPath}}"><button type="button" class="c-btn c-btn1">\u6269\u8FB9\u6587\u4EF6</button></a></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u53F7</span><p class="orderDetails-text">{{vm.salesOrder.number}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u5546\u54C1</span><p class="orderDetails-text">{{vm.salesOrder.productName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u6765\u6E90</span><p class="orderDetails-text">{{vm.salesOrder.orderSource ==\'self\'?\'\u81EA\u8425\u8BA2\u5355\':\'\u7B2C\u4E09\u65B9\u8BA2\u5355\'}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u72B6\u6001</span><p class="orderDetails-text" data-translate="mainEndApp.orderStatus.{{vm.salesOrder.status}}">{{vm.salesOrder.status}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u6570\u91CF</span><p class="orderDetails-text">{{vm.salesOrder.quantity}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u5546\u6237\u5355\u53F7</span><p class="orderDetails-text">{{vm.salesOrder.sourceOrderNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u6307\u5B9A\u7269\u6D41</span><p class="orderDetails-text">{{vm.salesOrder.expressSetting.name}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u91D1\u989D</span><p class="orderDetails-text">{{vm.salesOrder.amount}}</p></li><li class="col-xs-12 p0"><span class="orderDetails-title">\u5B9A\u5236\u5907\u6CE8</span><p class="orderDetails-text">{{vm.salesOrder.remarks}}</p></li></ul></div><!--<div class="orderDetails2">--><!--<div class="pull-left" style="margin-right: 15px;">--><!--<img src="content/images/bk-min.png" alt="">--><!--</div>--><!--<div class="pull-left">--><!--<p>\u626B\u7801\u6EAF\u6E90</p>--><!--<img src="content/images/bk-min.png" alt="">--><!--</div>--><!--</div>--></div></div></div></div><div class="bgc-fff p30 mtop20"><div><div class="clearfix"><span class="title1">\u5546\u54C1\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u5546\u54C1\u540D\u79F0</th><th>\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5F20\u6570</th><th ng-if="vm.salesOrder.orderType == \'Standard\'">\u4ED3\u5E93</th><th>\u8BA1\u5212\u4EA4\u671F</th><th>\u7ED3\u7B97\u4EF7</th></tr></thead><tbody><tr><td>{{vm.salesOrder.propertySku}}</td><td>{{vm.salesOrder.propertyNumber}}</td><td>{{vm.salesOrder.unit}}</td><td>{{vm.salesOrder.quantity}}</td><td>{{vm.salesOrder.pageCount == null ? "" : vm.salesOrder.pageCount}}</td><td ng-if="vm.salesOrder.orderType == \'Standard\'">{{vm.salesOrder.warehouseName}}</td><td>{{vm.salesOrder.expectedDate | date:\'yyyy-MM-dd\'}}</td><td>{{vm.salesOrder.settleAmount}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u4FC3\u9500\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u4FC3\u9500\u5546\u54C1\u540D\u79F0</th><th>\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u6570\u91CF</th></tr></thead><tbody><tr ng-repeat="data in vm.salesOrder.promoteProducts"><td>{{data.name}}</td><td>{{data.number}}</td><td>{{data.unit}}</td><td>{{data.quantity}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u751F\u4EA7\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u751F\u4EA7\u5546</th><th>\u62FC\u7248\u72B6\u6001</th><th>\u62FC\u7248\u6587\u4EF6</th><th>\u5206\u914D\u65F6\u95F4</th><!-- <th>\u662F\u5426\u56DE\u4EF6</th> --><th>\u4E0B\u8F7D\u6570</th><th>\u4E0B\u8F7D\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="orderToMakeupFile in vm.salesOrder.orderToMakeupFiles |orderBy: \'-createdDate\' track by $index"><td>{{vm.salesOrder.supplierName}}</td><td>{{vm.salesOrder.makeupStatus == \'NoMakeup\' ? \'\u672A\u62FC\u7248\' : vm.salesOrder.makeupStatus == \'InMakeup\'? \'\u62FC\u7248\u4E2D\': vm.salesOrder.makeupStatus == \'Makeuped\'? \'\u5DF2\u62FC\u7248\':\'\'}}</td><td><span ng-if="!!orderToMakeupFile.orderMakeupFile.filePath"><a ng-href="{{orderToMakeupFile.orderMakeupFile.filePath}}" target="_blank">{{orderToMakeupFile.orderMakeupFile.groupKey}}.pdf</a></span></td><td>{{vm.salesOrder.admeasureDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{orderToMakeupFile.orderMakeupFile.downloadNum}}</td><td>{{orderToMakeupFile.orderMakeupFile.dowmloadDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr ng-if="vm.salesOrder.orderToMakeupFiles.length==0"><td>{{vm.salesOrder.supplierName}}</td><td>{{vm.salesOrder.makeupStatus == \'NoMakeup\' ? \'\u672A\u62FC\u7248\' : vm.salesOrder.makeupStatus == \'InMakeup\' ? \'\u62FC\u7248\u4E2D\' :vm.salesOrder.makeupStatus == \'Makeuped\' ? \'\u5DF2\u62FC\u7248\': vm.salesOrder.makeupStatus == \'NotRequiredMakeup\' ? \'\u4E0D\u62FC\u677F\':\'\'}}</td><td>--</td><td>{{vm.salesOrder.admeasureDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{vm.salesOrder.downLoadNum}}</td><td>{{vm.salesOrder.downLoadDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u7269\u6D41\u4FE1\u606F</span> <button type="button" class="c-btn c-btn1" ng-click="editAddress()" ng-if="vm.salesOrder.status != \'Delivered\' && vm.salesOrder.orderSource == \'Project\'" style="margin-bottom: 5px">\u4FEE\u6539\u5730\u5740</button></div><div style="margin:10px 0 10px;color: #000;font-size: 16px">\u4F9B\u5E94\u5546\u7269\u6D41</div><div class="c-table1"><table><thead><tr><th>\u6536\u4EF6\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th><th>\u53D1\u8D27\u65F6\u95F4</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5FEB\u9012\u5355\u53F7</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="logisticsOrder in vm.SupplierOrderPack"><td>{{logisticsOrder.contact}}</td><td>{{logisticsOrder.phone}}</td><td>{{logisticsOrder.address || ""}}</td><td>{{logisticsOrder.salesOrder.supplierDeliveredTime | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{logisticsOrder.salesOrder.supplierLogisticsCompany}}</td><td>{{logisticsOrder.salesOrder.supplierLogisticsNumber}}</td><td><button type="button" ng-if="logisticsOrder.salesOrder.supplierLogisticsNumber" class="c-btn c-btn1 printHide" ng-click="viewDeliveryTrack(\'supplier\')">\u67E5\u770B</button></td></tr></tbody></table></div><div style="margin:20px 0 10px;color: #000;font-size: 16px">\u5546\u57CE\u7269\u6D41</div><div class="c-table1"><table><thead><tr><th>\u6536\u4EF6\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th><th>\u53D1\u8D27\u65F6\u95F4</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5FEB\u9012\u5355\u53F7</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="logisticsOrder in vm.orderPack"><td>{{logisticsOrder.contact}}</td><td>{{logisticsOrder.phone}}</td><td>{{logisticsOrder.address || ""}}</td><td>{{logisticsOrder.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{logisticsOrder.logisticsCompany}}</td><td>{{logisticsOrder.logisticsNumber}}</td><td><button type="button" ng-if="vm.salesOrder.status == \'Delivered\' || vm.salesOrder.status == \'Receiving\' || vm.salesOrder.status == \'Received\' || vm.salesOrder.status == \'Abnormal\'" class="c-btn c-btn1 printHide" ng-click="viewDeliveryTrack(\'store\')">\u67E5\u770B</button></td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u8865\u8D27\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u662F\u5426\u8865\u8D27</th><th>\u8865\u8D27\u6570\u91CF</th><th>\u8865\u8D27\u539F\u56E0</th><th>\u539F\u8BA2\u5355\u7F16\u53F7</th><th>\u5907\u6CE8\u4FE1\u606F</th></tr></thead><tbody><tr ng-repeat="replenishmentOrder in vm.salesOrder.replenishmentOrders"><td>{{vm.salesOrder.replenishment ?\'\u662F\':\'\u5426\'}}</td><td>{{replenishmentOrder.quantity}}</td><td>{{replenishmentOrder.reason}}</td><td>{{vm.salesOrder.sourceOrderNumber}}</td><td>{{replenishmentOrder.remarks}}</td></tr></tbody></table></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/order/order-express.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6307\u5B9A\u8BA2\u5355\u7684\u7269\u6D41\u516C\u53F8</span></div><div class="mt10"><div class="c-form" style="margin-bottom: 10px"><div style="color: #000;font-size: 15px">\u5DF2\u9009\u4E2D <span ng-if="$index <2" ng-repeat="ids in vm.order_expressIds">{{ids}} <span ng-hide="$last || $index ==1">,</span> </span>\u7B49{{vm.order_expressIds.length}}\u6761\u8BA2\u5355</div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u7269\u6D41\u516C\u53F8\uFF1A</label><div class="c-form-div" style="width: 400px"><select name="" class="c-select1" ng-model="vm.code" ng-options="data.id as data.name for data in vm.express"><option value="">\u8BF7\u9009\u62E9</option></select></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="padding-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" style="padding-left: 20px" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/order/order-extemal-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u8BA2\u5355\u8BE6\u60C5</span> <button type="button" class="c-btn c-btn1" ng-click="printpageBtn()">\u4E0B\u8F7D\u7EC4\u7248\u6587\u4EF6</button></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u53F7</span><p class="orderDetails-text">{{vm.salesOrder.number}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u5546\u54C1</span><p class="orderDetails-text">{{vm.salesOrder.productName}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u6765\u6E90</span><p class="orderDetails-text">{{vm.salesOrder.orderSource ==\'self\'?\'\u81EA\u8425\u8BA2\u5355\':\'\u7B2C\u4E09\u65B9\u8BA2\u5355\'}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u72B6\u6001</span><p class="orderDetails-text" data-translate="mainEndApp.orderStatus.{{vm.salesOrder.status}}">{{vm.salesOrder.status}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u6570\u91CF</span><p class="orderDetails-text">{{vm.salesOrder.quantity}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u5546\u6237\u5355\u53F7</span><p class="orderDetails-text">{{vm.salesOrder.sourceOrderNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u6307\u5B9A\u7269\u6D41</span><p class="orderDetails-text">{{vm.salesOrder.expressSetting.name}}</p></li></ul></div><!--<div class="orderDetails2">--><!--<div class="pull-left" style="margin-right: 15px;">--><!--<img src="content/images/bk-min.png" alt="">--><!--</div>--><!--<div class="pull-left">--><!--<p>\u626B\u7801\u6EAF\u6E90</p>--><!--<img src="content/images/bk-min.png" alt="">--><!--</div>--><!--</div>--></div></div></div></div><div class="bgc-fff p30 mtop20"><div><div class="clearfix"><span class="title1">\u5546\u54C1\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u5546\u54C1\u540D\u79F0</th><th>\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5F20\u6570</th><th ng-if="vm.salesOrder.orderType == \'Standard\'">\u4ED3\u5E93</th><th>\u8BA1\u5212\u4EA4\u671F</th><th>\u7ED3\u7B97\u4EF7</th></tr></thead><tbody><tr><td>{{vm.salesOrder.propertySku}}</td><td>{{vm.salesOrder.propertyNumber}}</td><td>{{vm.salesOrder.unit}}</td><td>{{vm.salesOrder.quantity}}</td><td>{{vm.salesOrder.pageCount == null ? "" : vm.salesOrder.pageCount}}</td><td ng-if="vm.salesOrder.orderType == \'Standard\'">{{vm.salesOrder.warehouseName}}</td><td>{{vm.salesOrder.expectedDate | date:\'yyyy-MM-dd\'}}</td><td>{{vm.salesOrder.settleAmount}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u4FC3\u9500\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u4FC3\u9500\u5546\u54C1\u540D\u79F0</th><th>\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u6570\u91CF</th></tr></thead><tbody><tr ng-repeat="data in vm.salesOrder.promoteProducts"><td>{{data.name}}</td><td>{{data.number}}</td><td>{{data.unit}}</td><td>{{data.quantity}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u751F\u4EA7\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u751F\u4EA7\u5546</th><th>\u62FC\u7248\u72B6\u6001</th><th>\u62FC\u7248\u6587\u4EF6</th><th>\u5206\u914D\u65F6\u95F4</th><th>\u662F\u5426\u56DE\u4EF6</th><th>\u56DE\u4EF6\u6570</th><th>\u56DE\u4EF6\u65F6\u95F4</th></tr></thead><tbody><tr><td>{{vm.salesOrder.supplierName}}</td><td>{{vm.salesOrder.makeupStatus == \'NoMakeup\' ? \'\u672A\u62FC\u7248\' : \'\u5DF2\u62FC\u7248\'}}</td><td>{{vm.salesOrder.makeupFile}}</td><td>{{vm.salesOrder.admeasureDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{vm.salesOrder.returnPiece ?\'\u662F\':\'\u5426\'}}</td><td>{{vm.salesOrder.returnPieceNum}}</td><td>{{vm.salesOrder.returnPieceDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u7269\u6D41\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u6536\u4EF6\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th><th>\u53D1\u8D27\u65F6\u95F4</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5FEB\u9012\u5355\u53F7</th></tr></thead><tbody><tr ng-repeat="logisticsOrder in vm.salesOrder.logisticsOrders"><td>{{logisticsOrder.contact}}</td><td>{{logisticsOrder.phone}}</td><td>{{logisticsOrder.address}}</td><td>{{logisticsOrder.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{logisticsOrder.logisticsCompany}}</td><td>{{logisticsOrder.number}}</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u8865\u8D27\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u662F\u5426\u8865\u8D27</th><th>\u8865\u8D27\u6570\u91CF</th><th>\u8865\u8D27\u539F\u56E0</th><th>\u539F\u8BA2\u5355\u7F16\u53F7</th><th>\u5907\u6CE8\u4FE1\u606F</th></tr></thead><tbody><tr ng-repeat="replenishmentOrder in vm.salesOrder.replenishmentOrders"><td>{{vm.salesOrder.replenishment ?\'\u662F\':\'\u5426\'}}</td><td>{{replenishmentOrder.quantity}}</td><td>{{replenishmentOrder.reason}}</td><td>{{vm.salesOrder.sourceOrderNumber}}</td><td>{{replenishmentOrder.remarks}}</td></tr></tbody></table></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/order/order-external.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5916\u90E8\u8BA2\u5355</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u5206\u914D\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u5546\u6237\u540D</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.merchants" ng-options="data.value as data.name for data in vm.merchantsList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u5546\u54C1\u540D\u79F0</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.product" ng-options="data.name for data in vm.productList" ng-change="selectProduct(vm.product)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>SKU</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.sku" ng-options="data.sku as data.sku for data in vm.skuList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul><p class="form-search2-screen" ng-click="filter()">{{!vm.isFilter ? \'\u5C55\u5F00\u9AD8\u7EA7\u7B5B\u9009\' : \'\u6536\u8D77\u9AD8\u7EA7\u7B5B\u9009\'}}</p><ul class="clearfix" ng-if="vm.isFilter"><li><p>\u662F\u5426\u56DE\u4EF6</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.back" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u662F\u5426\u8865\u8D27</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.replenishment" ng-options="data.value as data.name for data in vm.replenishmentList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderLook()">\u67E5\u770B\u8BA2\u5355</button> <button type="button" class="c-btn c-btn1" ng-click="orderUploadCsv()">\u5BFC\u5165</button> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button></div><div class="c-table mtop20"><table><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><!-- <th><input type="checkbox" ng-click="tableCbox()"></th> --><th style="text-align: center">\u5E8F\u53F7</th><!-- <th style="text-align: center;">\u8BA2\u5355\u53F7</th> --><th style="text-align: center">\u5546\u6237\u539F\u5355\u53F7</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u8BA2\u8D2D\u5546\u54C1SKU</th><th style="text-align: center">\u8BA2\u8D2D\u6570\u91CF</th><th style="text-align: center">\u4F9B\u5E94\u5546</th><th style="text-align: center" jh-sort-by="expectedDate">\u5F55\u5165\u65F6\u95F4 <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center" jh-sort-by="expectedDate">\u8BA1\u5212\u4EA4\u671F <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center">\u53D1\u8D27\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-click="tableTr(data)" ng-class="{\'pitchOn\':data.id == vm.tablePitch.id}" ng-if="vm.tableList.length > 0"><!-- <td style="width: 40px; max-width: 40px; min-width: 40px;">\n                        <input type="checkbox" ng-model="data.pitchOn">\n                    </td> --><td style="width: 50px; max-width: 50px; min-width: 50px; text-align: center">{{$index + 1}}</td><td style="color: #0F6AB4; text-align: center"><a ui-sref="orderExtemalDetails({\n                        id:data.id,\n                        page: vm.tableData.page,\n                        state:vm.tableData.state,\n                        source:vm.tableData.source,\n                        startDate:vm.tableData.startDate,\n                        endDate:vm.tableData.endDate,\n                        back:vm.tableData.back,\n                        timeWarning:vm.tableData.timeWarning,\n                        replenishment:vm.tableData.replenishment,\n                        refund:vm.tableData.refund,\n                        supplierId:vm.tableData.supplierId,\n                        productId:vm.tableData.productId,\n                        keyword:vm.tableData.keyword\n                })">{{data.sourceOrderNumber}}</a></td><!-- <td>{{data.sourceOrderNumber}}</td> --><td data-translate="mainEndApp.orderStatus.{{data.status}}" style="text-align: center">{{data.status}}</td><td style="text-align: center">{{data.propertySku}}</td><td style="text-align: center">{{data.quantity}}</td><td style="text-align: center">{{data.supplierName}}</td><td style="text-align: center">{{data.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center">{{data.expectedDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{data.logisticsOrders[0].deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/order/order-general-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u8BA2\u5355\u8BE6\u60C5</span><!-- <button type="button" class="c-btn c-btn1" ng-click="printpageBtn()">\u4E0B\u8F7D\u7EC4\u7248\u6587\u4EF6</button> --></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u53F7</span><p class="orderDetails-text">{{vm.data.number}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u72B6\u6001</span><p class="orderDetails-text">{{getStatus(vm.data.status)}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u6570\u91CF</span><p class="orderDetails-text">{{vm.data.quantity}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u5546\u6237\u5355\u53F7</span><p class="orderDetails-text">{{vm.data.sourceOrderNumber}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title">\u8BA2\u5355\u91D1\u989D</span><p class="orderDetails-text">{{vm.data.settleAmount}}</p></li></ul></div><!--<div class="orderDetails2">--><!--<div class="pull-left" style="margin-right: 15px;">--><!--<img src="content/images/bk-min.png" alt="">--><!--</div>--><!--<div class="pull-left">--><!--<p>\u626B\u7801\u6EAF\u6E90</p>--><!--<img src="content/images/bk-min.png" alt="">--><!--</div>--><!--</div>--></div></div></div></div><div class="bgc-fff p30 mtop20"><div><div class="clearfix"><span class="title1">\u5546\u54C1\u4FE1\u606F</span></div><div class="c-table1"><table ng-if="vm.data.status ==\'ToDelivery\'"><thead><tr><th>\u5546\u54C1\u540D\u79F0</th><th>\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u5355\u4EF7</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u7ED3\u7B97\u4EF7</th><th>\u4ED3\u5E93</th><th>\u5E93\u5B58\u8BF4\u660E</th></tr></thead><tbody><tr ng-repeat="product in vm.data.salesOrders"><td>{{product.productName}}</td><td>{{product.number}}</td><td>{{product.unit}}</td><td>{{product.price}}</td><td>{{product.quantity}}</td><td>{{product.settleAmount}}</td><!-- <td>{{product.warehouseName}}</td> --><td><select name="" class="c-select1" style="width: 100%" ng-model="product.warehouseId" ng-options="item.warehouseId as item.warehouseName for item in product.reserves" ng-change="vm.changehWarehouse(product,$index)"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></td><td>\u73B0\u6709\u5E93\u5B58\uFF1A{{product.warehouseQuantity}}</td></tr></tbody></table><table ng-if="vm.data.status !==\'ToDelivery\'"><thead><tr><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>sku\u7F16\u53F7</th><th>\u89C4\u683C\u578B\u53F7</th><th>\u5355\u4F4D</th><th>\u5355\u4EF7</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u7ED3\u7B97\u4EF7</th><th>\u4ED3\u5E93</th><th>\u5E93\u5B58\u6210\u672C</th></tr></thead><tbody><tr ng-repeat="product in vm.data.salesOrders"><td>{{product.number}}</td><td>{{product.productName}}</td><td>{{product.propertyNumber}}</td><td>{{product.propertySku}}</td><td>{{product.unit}}</td><td>{{product.price}}</td><td>{{product.quantity}}</td><td>{{product.settleAmount}}</td><td><span>{{product.warehouseName}}</span></td><!-- <td>{{product.warehouseQuantity}}</td> --><td>{{product.supSettleAmount | currency}}</td></tr></tbody></table></div></div><!-- <div class="mtop20">\n            <div class="clearfix">\n                <span class="title1">\u4FC3\u9500\u4FE1\u606F</span>\n            </div>\n            <div class="c-table1">\n                <table>\n                    <thead>\n                    <tr>\n                        <th>\u4FC3\u9500\u5546\u54C1\u540D\u79F0</th>\n                        <th>\u7F16\u53F7</th>\n                        <th>\u5355\u4F4D</th>\n                        <th>\u6570\u91CF</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="data in vm.salesOrder.promoteProducts">\n                        <td>{{data.name}}</td>\n                        <td>{{data.number}}</td>\n                        <td>{{data.unit}}</td>\n                        <td>{{data.quantity}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div> --><!-- <div class="mtop20">\n            <div class="clearfix">\n                <span class="title1">\u751F\u4EA7\u4FE1\u606F</span>\n            </div>\n            <div class="c-table1">\n                <table>\n                    <thead>\n                    <tr>\n                        <th>\u751F\u4EA7\u5546</th>\n                        <th>\u62FC\u7248\u72B6\u6001</th>\n                        <th>\u62FC\u7248\u6587\u4EF6</th>\n                        <th>\u5206\u914D\u65F6\u95F4</th>\n                        <th>\u662F\u5426\u56DE\u4EF6</th>\n                        <th>\u56DE\u4EF6\u6570</th>\n                        <th>\u56DE\u4EF6\u65F6\u95F4</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr>\n                        <td>{{vm.salesOrder.supplierName}}</td>\n                        <td>{{vm.salesOrder.makeupStatus == \'NoMakeup\' ? \'\u672A\u62FC\u7248\' : \'\u5DF2\u62FC\u7248\'}}</td>\n                        <td>{{vm.salesOrder.makeupFile}}</td>\n                        <td>{{vm.salesOrder.admeasureDate | date:\'yyyy-MM-dd HH:mm\'}}</td>\n                        <td>{{vm.salesOrder.returnPiece ?\'\u662F\':\'\u5426\'}}</td>\n                        <td>{{vm.salesOrder.returnPieceNum}}</td>\n                        <td>{{vm.salesOrder.returnPieceDate | date:\'yyyy-MM-dd HH:mm\'}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div> --><div class="mtop20"><div class="clearfix"><span class="title1">\u7269\u6D41\u4FE1\u606F</span><!-- <button type="button" class="c-btn c-btn1" ng-click="editAddress()" ng-if="vm.salesOrder.status != \'Delivered\' && vm.salesOrder.orderSource == \'Project\'" style="margin-bottom: 5px;">\u4FEE\u6539\u5730\u5740</button> --> <button type="button" class="c-btn c-btn1" ng-click="editAddress()" ng-if="vm.data.status == \'ToDelivery\'" style="margin-bottom: 5px">\u4FEE\u6539\u5730\u5740</button></div><div class="c-table1"><table><thead><tr><th>\u6536\u4EF6\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th><th>\u53D1\u8D27\u65F6\u95F4</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5FEB\u9012\u5355\u53F7</th></tr></thead><tbody><tr><td>{{vm.data.orderLocation.contact}}</td><td>{{vm.data.orderLocation.phone}}</td><td>{{vm.data.orderLocation.address}}</td><td>{{vm.data.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{vm.data.deliveryComp}}</td><td>{{vm.data.logisticsNumber}}</td></tr></tbody></table></div></div><!-- <div class="mtop20">\n            <div class="clearfix">\n                <span class="title1">\u8865\u8D27\u4FE1\u606F</span>\n            </div>\n            <div class="c-table1">\n                <table>\n                    <thead>\n                    <tr>\n                        <th>\u662F\u5426\u8865\u8D27</th>\n                        <th>\u8865\u8D27\u6570\u91CF</th>\n                        <th>\u8865\u8D27\u539F\u56E0</th>\n                        <th>\u539F\u8BA2\u5355\u7F16\u53F7</th>\n                        <th>\u5907\u6CE8\u4FE1\u606F</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="replenishmentOrder in vm.salesOrder.replenishmentOrders">\n                        <td>{{vm.salesOrder.replenishment ?\'\u662F\':\'\u5426\'}}</td>\n                        <td>{{replenishmentOrder.quantity}}</td>\n                        <td>{{replenishmentOrder.reason}}</td>\n                        <td>{{vm.salesOrder.sourceOrderNumber}}</td>\n                        <td>{{replenishmentOrder.remarks}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div> --><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-click="goBack()">\u8FD4\u56DE</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status === \'ToDelivery\'" ng-click="delivery()">\u53D1\u8D27</button></div></div></div>');
$templateCache.put('app/order/order-general-preview.html','<div class="bgc-fff p30" style="position: relative"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u53D1\u8D27\u5355\u9884\u89C8</span> <button type="button" class="c-btn c-btn1" ng-click="preview()">\u6253\u5370\u9884\u89C8</button> <button type="button" class="c-btn c-btn2" ng-click="goback()">\u8FD4\u56DE</button> <button type="button" class="c-btn c-btn1" ng-click="export()" style="position: absolute;left: 36px;top: 96px">\u5BFC\u51FA</button></div><div class="mtop20" id="previewId" style="box-shadow: 0 0 24px 0 rgba(0, 0, 0, .2); padding: 50px"><div style="font-size: 30px;font-weight: bold; height: 80px; border-bottom: 1px solid #ddd; text-align: center; color: #333; margin-bottom: 40px">MOMENTSGO\u53D1\u8D27\u5355</div><div style="display: flex;flex-wrap: wrap"><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u8BA2\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.number}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u5546\u6237\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.sourceOrderNumber}}</div></div><div class="c-form" style="width: 33%"><label class="c-form-label control-label font-style">\u8BA2\u8D2D\u6570\u91CF:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.data.quantity}}</div></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u6536\u4EF6\u4FE1\u606F:</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th>\u6536\u4EF6\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th></tr></thead><tbody><tr><td>{{vm.data.orderLocation.contact}}</td><td>{{vm.data.orderLocation.phone}}</td><td>{{vm.data.orderLocation.address}}</td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u5546\u54C1\u4FE1\u606F:</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>sku\u7F16\u53F7</th><th>\u578B\u53F7\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u51FA\u5E93\u4ED3\u5E93</th></tr></thead><tbody><tr ng-repeat="product in vm.data.salesOrders track by $index"><td>{{product.number}}</td><td>{{product.productName}}</td><td>{{product.propertyNumber}}</td><td>{{product.propertySku}}</td><td>{{product.unit}}</td><td>{{product.price | currency}}</td><td>{{product.quantity}}</td><td>{{product.warehouseName}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/order/order-general.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u901A\u54C1\u8BA2\u5355</span></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u5F55\u5165\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u5546\u6237\u5355\u53F7</p><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.number"></li><li><p>\u7269\u6D41\u5355\u53F7</p><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.logisticsNumber"></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li><!-- <li ng-class="{\'pitchOn\': vm.tableData.state == \'\' && vm.tableData.timeWarning == 1}"\n            ng-click="warningSelect()">\u9884\u8B66</li> --></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button><div class="pull-right hei_36">\u5171\u6709{{vm.queryCount}}\u6761\u8BA2\u5355,\u5171{{pageCountTotal}}\u5408\u6210\u9875</div></div><div class="c-table mtop20"><table><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5546\u6237\u5355\u53F7</th><th style="text-align: center">\u8BA2\u5355\u53F7</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u8BA2\u8D2D\u5546\u54C1</th><th style="text-align: center">\u8BA2\u8D2D\u6570\u91CF</th><th style="text-align: center">\u7ED3\u7B97\u91D1\u989D</th><!-- <th style="text-align: center;">\u4ED3\u5E93</th> --><th style="text-align: center">\u521B\u5EFA\u65F6\u95F4</th><th style="text-align: center">\u53D1\u8D27\u65F6\u95F4</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="width: 60px; max-width: 60px; text-align: center">{{$index+1}}</td><td style="width: 200px; max-width: 200px; text-align: center"><a ui-sref="ordergGeneralDetails({\n                        id:salesOrder.id,\n                        page: vm.tableData.page,\n                        state:vm.tableData.state,\n                        source:vm.tableData.source,\n                        startDate:vm.tableData.startDate,\n                        endDate:vm.tableData.endDate,\n                        back:vm.tableData.back,\n                        timeWarning:vm.tableData.timeWarning,\n                        replenishment:vm.tableData.replenishment,\n                        refund:vm.tableData.refund,\n                        supplierId:vm.tableData.supplierId,\n                        productId:vm.tableData.productId,\n                        number:vm.tableData.number,\n                        logisticsNumber:vm.tableData.logisticsNumber,\n                        keyword:vm.tableData.keyword\n                })" style="color: #0F6AB4">{{salesOrder.sourceOrderNumber}}</a></td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{salesOrder.number}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{getStatus(salesOrder.status)}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{salesOrder.productStr}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{salesOrder.quantity}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{salesOrder.settleAmount}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{salesOrder.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="width: 120px; max-width: 120px; min-width: 120px; text-align: center">{{salesOrder.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center"><!-- <button class="c-minBtn c-minBtn1" ng-click="delivery(salesOrder)" ng-if="salesOrder.status=== \'ToDelivery\'">\u53D1\u8D27</button> --> <button class="c-minBtn c-minBtn1" ng-click="delivery(salesOrder)" ng-if="salesOrder.status === \'ToDelivery\'">\u53D1\u8D27</button> <button class="c-minBtn c-minBtn1" ui-sref="ordergGeneralDetails({\n                            id:salesOrder.id,\n                            page: vm.tableData.page,\n                            state:vm.tableData.state,\n                            source:vm.tableData.source,\n                            startDate:vm.tableData.startDate,\n                            endDate:vm.tableData.endDate,\n                            back:vm.tableData.back,\n                            timeWarning:vm.tableData.timeWarning,\n                            replenishment:vm.tableData.replenishment,\n                            refund:vm.tableData.refund,\n                            supplierId:vm.tableData.supplierId,\n                            productId:vm.tableData.productId,\n                            keyword:vm.tableData.keyword\n                    })">\u8BE6\u60C5</button> <button class="c-minBtn c-minBtn3" ui-sref="ordergGeneralPreview({id:salesOrder.id})">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/order/order-modification.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u4FEE\u6539</span></div><div class="mt10"><div class="c-form" ng-if="!vm.isDelivery"><label class="c-form-label">\u72B6\u6001\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.data.status" ng-change="statusChange()" ng-options="data.id as data.name for data in vm.statusList"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" ng-if="vm.data.status == \'Producing\'"><label class="c-form-label">\u4E0B\u8F7D\u65F6\u95F4\uFF1A</label><div class="c-form-div"><div class="form-time" style="width: 200px"><input type="text" class="c-input1" ng-model="vm.data.downLoadDate" id="downLoadDate" placeholder="\u4E0B\u8F7D\u65F6\u95F4" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div></div><div class="c-form" ng-if="vm.isDelivery"><label class="c-form-label">\u914D\u9001\u65B9\u5F0F\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.data.deliveryType" ng-options="data.id as data.name for data in vm.deliveryMethodList"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" ng-if="vm.data.status == \'Delivered\' || (vm.isDelivery && vm.data.deliveryType == \'Delivery\')"><label class="c-form-label">\u5FEB\u9012\u516C\u53F8\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.data.deliveryComp" ng-options="data.name as data.name for data in vm.expressCompanies"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" ng-if="vm.data.status == \'Delivered\' || (vm.isDelivery && vm.data.deliveryType == \'Delivery\')"><label class="c-form-label">\u53D1\u8D27\u65E5\u671F\uFF1A</label><div class="c-form-div"><div class="form-time" style="width: 200px"><input type="text" class="c-input1" ng-model="vm.data.deliveryDate" id="deliveryDate" placeholder="\u53D1\u8D27\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd HH:mm:ss\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div></div><div class="c-form" ng-if="vm.data.status == \'Delivered\' || (vm.isDelivery && vm.data.deliveryType == \'Delivery\')"><label class="c-form-label">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" placeholder="\u5FEB\u9012\u5355\u53F7" ng-model="vm.data.logisticsNumber"></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="padding-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" style="padding-left: 20px" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/order/order-remark.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5BA2\u6237\u5907\u6CE8</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5907\u6CE8\uFF1A</label><div class="c-form-div" style="width: 400px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="hide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/order/order-replenish.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8865\u8D27\u8BA2\u5355</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u5F55\u5165\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u8BA2\u5355\u6765\u6E90</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.source" ng-options="data.value as data.name for data in vm.sourceList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul><p class="form-search2-screen" ng-click="filter()">{{!vm.isFilter ? \'\u5C55\u5F00\u9AD8\u7EA7\u7B5B\u9009\' : \'\u6536\u8D77\u9AD8\u7EA7\u7B5B\u9009\'}}</p><ul class="clearfix" ng-if="vm.isFilter"><li><p>\u662F\u5426\u56DE\u4EF6</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.back" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u8865\u8D27\u539F\u56E0</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.reasonStr" ng-options="data.reason as data.reason for data in vm.replenishmentReasons"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderLook()">\u67E5\u770B\u8BA2\u5355</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderReplenishment()">\u53D6\u6D88\u8865\u8D27</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderExpress()">\u7269\u6D41</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="modification()">\u4FEE\u6539</button><!--<button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderRemark()">\u5907\u6CE8</button>--></div><div class="c-table mtop20 scrollbar-main"><table style="min-width: 1600px; overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center"><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u8BA2\u5355\u53F7</th><th style="text-align: center">\u6E90\u8BA2\u5355\u53F7</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u8865\u8D27\u539F\u56E0</th><th style="text-align: center">\u91CD\u4F20\u6587\u4EF6</th><th style="text-align: center">\u5546\u54C1SKU</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u7ED3\u7B97\u91D1\u989D</th><th style="text-align: center">\u4F9B\u5E94\u5546</th><th style="text-align: center" jh-sort-by="createdDate">\u8865\u8D27\u65F6\u95F4 <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center">\u4E0B\u8F7D\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="width: 20px; max-width: 20px; min-width: 20px; text-align: center"><input type="checkbox" ng-model="salesOrder.checked"></td><td style="width: auto; text-align: center">{{$index + 1}}</td><td style="width: auto; text-align: center; color: #0F6AB4"><a ui-sref="orderDetails({\n                        id:salesOrder.id,\n                        page: vm.tableData.page,\n                        state:vm.tableData.state,\n                        source:vm.tableData.source,\n                        startDate:vm.tableData.startDate,\n                        endDate:vm.tableData.endDate,\n                        back:vm.tableData.back,\n                        condition:vm.tableData.condition,\n                        keyword:vm.tableData.keyword})">{{salesOrder.number}}</a></td><td style="text-align: center; width: auto">{{salesOrder.sourceOrderNumber}}</td><td data-translate="mainEndApp.orderStatus.{{salesOrder.status}}" style="width: auto; text-align: center">{{salesOrder.status}}</td><td style="text-align: center; width: auto">{{!salesOrder.replenishmentReason ? salesOrder.replenishmentOrders[0].reason : salesOrder.replenishmentReason}}</td><td style="text-align: center; width: auto">{{salesOrder.reupload ? \'\u662F\' : \'\u5426\'}}</td><td style="text-align: center; width: auto">{{salesOrder.propertySku}}</td><td style="text-align: center; width: auto">{{salesOrder.quantity}}</td><td style="text-align: center; width: auto">{{salesOrder.settleAmount}}</td><td style="text-align: center; width: auto">{{salesOrder.supplierName}}</td><td style="text-align: center; width: auto">{{salesOrder.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center; width: auto">{{salesOrder.downLoadDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="12" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/order/order-replenishment.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u8865\u5355</span></div><div class="mt10"><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u6E90\u8BA2\u5355\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="text" class="c-input1" ng-model="vm.sourceOrderNumber" maxlength="20" disabled="disabled"></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u8865\u8D27\u539F\u56E0\uFF1A</label><div class="c-form-div" style="width: 400px"><select name="" class="c-select1" ng-model="vm.replenishmentReasonId" ng-options="data.id as data.reason for data in vm.reasonList"><option value="">\u8BF7\u9009\u62E9</option></select></div></div></div><div class="clearfix"><span class="title1">\u8865\u8D27\u4EFD\u6570</span></div><div class="mt10"><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u8865\u8D27\u6570\u91CF\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="number" class="c-input1" ng-model="vm.quantity" min="1"></div></div></div><div class="clearfix"><span class="title1">\u6536\u8D27\u5730\u5740</span></div><div class="mt10"><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u59D3\u540D\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="text" class="c-input1" ng-model="vm.orderData.orderLocation.contact" maxlength="20"></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u8054\u7CFB\u7535\u8BDD\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="text" class="c-input1" ng-model="vm.orderData.orderLocation.phone" maxlength="11"></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u6536\u8D27\u5730\u5740\uFF1A</label><div class="c-form-div" style="width: 400px"><select class="c-select1" style="width: 30%" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="c-select1" style="width: 30%" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="c-select1" style="width: 30%" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u8BE6\u7EC6\u5730\u5740\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="text" class="c-input1" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" ng-model="vm.address" maxlength="50"></div></div></div><div class="clearfix"><span class="title1">\u8BA2\u5355\u6587\u4EF6</span></div><div class="mt10"><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u662F\u5426\u91CD\u65B0\u4E0A\u4F20\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="checkbox" ng-model="vm.reupload" class="checkOrIf"></div></div><div class="c-form" style="margin-bottom: 10px" ng-if="vm.reupload"><label class="c-form-label" style="text-align: left"></label><div class="c-form-div" style="width: 400px; position: relative; background-color: #ebebe4"><div style="width: 100%; height: 100%"><button type="button" class="c-btn c-btn1">\u4E0A\u4F20\u6587\u4EF6</button> <input type="file" id="file" name="myfile" onchange="uploadFile(event)" accept="application/pdf" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 1; opacity :0; width: 96px"><div style="float: right; height: 38px; line-height: 38px; width: 300px" title="{{vm.justifyFile}}">{{vm.justifyFile|limitTo:\'35\'}}</div><div style="height: 2px; width:"></div></div><div id="progress-bar" style="height: 5px; width: 0%; background-color: #ff9601"></div></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u6587\u4EF6\u662F\u5426\u62FC\u7248\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="checkbox" ng-model="vm.makeup" class="checkOrIf"></div></div></div><div class="clearfix"><span class="title1">\u5907\u6CE8</span></div><div class="mt10"><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label" style="text-align: left">\u5907\u6CE8\uFF1A</label><div class="c-form-div" style="width: 400px"><textarea placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8\u4FE1\u606F" class="c-textarea1" ng-model="vm.remarks" aria-invalid="false" maxlength="50"></textarea></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/order/order-self.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5B9A\u5236\u8BA2\u5355</span></div><!-- <div class="form-search1 clearfix mt10">\n        <input type="text" style="width: 400px;" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.keyword">\n        <button type="button" ng-click="search()"></button>\n    </div> --><div class="form-search2"><ul class="clearfix"><li><p>\u8BA2\u5355\u53F7</p><div class="form-search2-term"><input type="text" style="width: 400px" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.keyword"></div></li><li><p>\u6536\u4EF6\u4EBA\u7535\u8BDD</p><div class="form-search2-term"><input type="text" style="width: 300px" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.phone"></div></li><li><p>\u7269\u6D41\u5355\u53F7</p><div class="form-search2-term"><input type="text" style="width: 300px" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.logisticsNumber"></div></li><li><p>\u8BA2\u5355\u6765\u6E90</p><div class="form-search2-term"><input type="text" style="width: 200px" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.tableData.storeName"></div></li></ul></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u5F55\u5165\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u751F\u4EA7\u5546</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.supplier" ng-options="data.name for data in vm.suppliers" ng-change="selectSupplier(vm.supplier)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u5546\u54C1\u540D\u79F0</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.product" ng-options="data.name for data in vm.productList" ng-change="selectProduct(vm.product)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>SKU</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.sku" ng-options="data.sku as data.sku for data in vm.skuList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u914D\u9001\u65B9\u5F0F</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.deliveryType" ng-options="data.value as data.name for data in vm.deliveryMethodList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul><p class="form-search2-screen" ng-click="filter()">{{!vm.isFilter ? \'\u5C55\u5F00\u9AD8\u7EA7\u7B5B\u9009\' : \'\u6536\u8D77\u9AD8\u7EA7\u7B5B\u9009\'}}</p><ul class="clearfix" ng-if="vm.isFilter"><li><p>\u662F\u5426\u56DE\u4EF6</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.back" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u662F\u5426\u8865\u8D27</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.replenishment" ng-options="data.value as data.name for data in vm.replenishmentList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><!--            <li>--><!--                <p>\u9000\u6B3E\u8BA2\u5355</p>--><!--                <div class="form-search2-term">--><!--                    <select name="" class="c-select1" ng-model="vm.tableData.refund"--><!--                            ng-options="data.value as data.name for data in vm.refundList">--><!--                        <option value="">\u8BF7\u9009\u62E9</option>--><!--                    </select>--><!--                </div>--><!--            </li>--><li><p>\u5546\u54C1\u4E00\u7EA7\u54C1\u7C7B</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.productCategoryId" ng-options="data.id as data.name for data in vm.promoteProducts" ng-change="promoteProductsSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u5546\u54C1\u4E8C\u7EA7\u54C1\u7C7B</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.productCategorySecondId" ng-options="data.id as data.name for data in vm.promoteProductsSecond" ng-change="promoteProductsSecondSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state && vm.tableData.timeWarning == \'\'}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderLook()">\u67E5\u770B\u8BA2\u5355</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderReplenishment()">\u8865\u8D27</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderExpress()">\u7269\u6D41</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="modification()">\u4FEE\u6539</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderClose()">\u64A4\u56DE</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch&&vm.tableData.state == \'Collect\'" ng-click="handleDelivery()">\u53D1\u8D27</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="handlePrint()">\u6253\u5370</button><!--<button type="button" class="c-btn c-btn1" ng-click="orderRemark()">\u5BA2\u6237\u5907\u6CE8</button>--><div class="pull-right hei_36">\u603B\u5171\u6709{{vm.queryCount}}\u6761\u8BA2\u5355,\u603B\u5171{{pageCountTotal}}\u5408\u6210\u9875</div></div><div class="c-table mtop20 scrollbar-main"><table style="min-width: 1600px; overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center"><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5546\u6237\u539F\u5355\u53F7</th><th style="text-align: center">\u8BA2\u5355\u6765\u6E90</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u914D\u9001\u65B9\u5F0F</th><th style="text-align: center">\u8BA2\u8D2D\u5546\u54C1SKU</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u7ED3\u7B97\u91D1\u989D</th><!-- <th style="text-align: center;">\u6765\u6E90\u95E8\u5E97</th> --><th style="text-align: center">\u4F9B\u5E94\u5546</th><th style="text-align: center" jh-sort-by="expectedDate">\u8BA1\u5212\u4EA4\u671F <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center" jh-sort-by="createdDate">\u5F55\u5165\u65F6\u95F4 <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center" jh-sort-by="downLoadDate">\u4E0B\u8F7D\u65F6\u95F4 <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center">\u53D1\u8D27\u65F6\u95F4</th><!--                    <th style="text-align: center;">\u53D1\u8D27\u65F6\u95F4</th>--></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="text-align: center"><input type="checkbox" ng-model="salesOrder.checked"></td><td style="text-align: center">{{$index + 1}}</td><td style="color: #0F6AB4; text-align: center"><a ui-sref="orderDetails({\n                        id:salesOrder.id,\n                        page: vm.tableData.page,\n                        state:vm.tableData.state,\n                        source:vm.tableData.source,\n                        startDate:vm.tableData.startDate,\n                        endDate:vm.tableData.endDate,\n                        back:vm.tableData.back,\n                        timeWarning:vm.tableData.timeWarning,\n                        replenishment:vm.tableData.replenishment,\n                        refund:vm.tableData.refund,\n                        supplierId:vm.tableData.supplierId,\n                        productId:vm.tableData.productId,\n                        keyword:vm.tableData.keyword,\n                        phone:vm.tableData.phone,\n                        logisticsNumber:vm.tableData.logisticsNumber,\n                        deliveryType:vm.tableData.deliveryType,\n                })">{{salesOrder.sourceOrderNumber}}</a></td><td style="text-align: center">{{salesOrder.sourceType == \'online_mi\' ? \'MI\u5546\u57CE\' :salesOrder.storeName}}</td><td data-translate="mainEndApp.orderStatus.{{salesOrder.status}}" style="text-align: center">{{salesOrder.status}}</td><td style="text-align: center">{{salesOrder.deliveryType == \'Self\'? \'\u81EA\u63D0\' : salesOrder.deliveryType == \'Delivery\' ? \'\u5FEB\u9012\':salesOrder.deliveryType}}</td><td style="text-align: center">{{salesOrder.propertySku}}</td><td style="text-align: center">{{salesOrder.quantity}}</td><td style="text-align: center">{{salesOrder.settleAmount}}</td><!-- <td style="text-align: center;">{{salesOrder.storeName}}</td> --><td style="text-align: center">{{salesOrder.supplierName}}</td><td style="text-align: center">{{salesOrder.expectedDate | date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{salesOrder.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center">{{salesOrder.downLoadDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="text-align: center">{{salesOrder.deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td><!--                    <td style="text-align: center;">{{salesOrder.logisticsOrders[0].deliveryDate | date:\'yyyy-MM-dd HH:mm\'}}</td>--></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><div class="mtop20" id="previewId" style="background-color: #fff; display: none"><div style="padding: 20px"><div style="font-size: 24px;font-weight: bold; height: 60px; border-bottom: 1px solid #ddd; text-align: center; color: #333; margin-bottom: 15px">MOMENTSGO\u9001\u8D27\u5355</div><div style="display: flex;justify-content: space-between;margin-bottom: 15px; font-size: 12px"><div style="display: flex"><div>\u8BA2\u5355\u884C\u6570\uFF1A{{vm.selectedList.length}}</div><div style="margin-left: 20px">\u8BA2\u5355\u4EFD\u6570\uFF1A{{vm.calculateTotalQuantity()}}</div></div><div>\u6253\u5370\u65F6\u95F4:{{vm.getCurrentTime()}}</div></div><div style="width:auto"><div style="width: 100%; overflow: auto; font-size: 11px"><table style="width: 100%; border-collapse: collapse"><thead><tr style="border: 1px solid #ddd; background: #f3f3f3"><th style="padding: 3px 8px; height: 25px; text-align: left; border: 1px solid #ddd">\u95E8\u5E97</th><th style="padding: 3px 8px; height: 25px; text-align: left; border: 1px solid #ddd">\u8BA2\u5355\u53F7</th><th style="padding: 3px 8px; height: 25px; text-align: left; border: 1px solid #ddd">\u5546\u54C1\u4FE1\u606F</th><th style="padding: 3px 8px; height: 25px; text-align: left; border: 1px solid #ddd">\u4EFD\u6570</th><th style="padding: 3px 8px; height: 25px; text-align: left; border: 1px solid #ddd">\u6761\u7801</th></tr></thead><tbody><tr ng-repeat="item in vm.selectedList track by $index" style="border: 1px solid #ddd"><td style="padding: 3px 8px; border: 1px solid #ddd">{{item.storeName}}--{{item.sourceOrderNumber}}</td><td style="padding: 3px 8px; border: 1px solid #ddd">{{item.number}}</td><td style="padding: 3px 8px; border: 1px solid #ddd">{{item.propertySku}}</td><td style="padding: 3px 8px; border: 1px solid #ddd">{{item.quantity}}</td><td style="padding: 3px 8px; border: 1px solid #ddd"><ng-barcode text="item.sourceOrderNumber" width="120" height="50"></ng-barcode></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/order/order-upload-scv.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4E0A\u4F20\u6587\u4EF6-CSV</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u6E20\u9053\u540D\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.channel" ng-options="data.id as data.name for data in vm.channels" ng-change="changeChannel(data)"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u5546\u6237\u540D\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.merchant" ng-options="data.id as data.name for data in vm.merchants"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u6587\u4EF6\u4E0A\u4F20\uFF1A</label><div class="c-form-div wid-800"><img src="../content/images/upload-file.png" style="width: 50px"> <input type="file" id="file" name="myfile" onchange="upladFile(event)" accept=".csv" style="position: relative; left: 0; top: -50px; z-index: 1; opacity :0; height: 50px"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="hide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/order/order-warn.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u9884\u8B66\u8BA2\u5355</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u652F\u4ED8\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u8BA2\u5355\u72B6\u6001</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.state" ng-options="data.value as data.name for data in vm.stateList"></select></div></li><li><p>\u751F\u4EA7\u5546</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.supplier" ng-options="data.name for data in vm.suppliers" ng-change="selectSupplier(vm.supplier)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data.value)" ng-class="{\'pitchOn\': data.value == vm.condition}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderLook()">\u67E5\u770B\u8BA2\u5355</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderReplenishment()">\u8865\u8D27</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="orderExpress()">\u7269\u6D41</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tablePitch" ng-click="modification()">\u4FEE\u6539</button><div class="pull-right hei_36">\u5171\u6709{{vm.queryCount}}\u6761\u8BA2\u5355,\u5171{{pageCountTotal}}\u5408\u6210\u9875</div></div><div class="c-table mtop20"><table><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center"><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th style="text-align: center">\u5546\u6237\u539F\u5355\u53F7</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u7ED3\u7B97\u91D1\u989D</th><th style="text-align: center">\u8BA2\u8D2D\u5546\u54C1SKU</th><th style="text-align: center">\u4F9B\u5E94\u5546</th><th style="text-align: center">\u8BA2\u5355\u7C7B\u578B</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u62FC\u7248\u72B6\u6001</th><th style="text-align: center" jh-sort-by="expectedDate">\u8BA1\u5212\u4EA4\u671F <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center" jh-sort-by="createdDate">\u5F55\u5165\u65F6\u95F4 <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center">\u5206\u914D\u65F6\u95F4</th><th style="text-align: center">\u4E0B\u8F7D\u65F6\u95F4</th><!-- <th>\u6765\u6E90\u5546\u6237</th> --></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by $index" ng-click="tableTr(salesOrder)" ng-if="vm.salesOrders.length > 0"><td style="width: 20px; max-width: 20px; text-align: center"><input type="checkbox" ng-model="salesOrder.checked"></td><td style="width: 100px; max-width: 100px; min-width: 100px; text-align: center"><a ui-sref="orderDetails({\n                            id:salesOrder.id,\n                            page: vm.tableData.page,\n                            state:vm.tableData.state,\n                            source:vm.tableData.source,\n                            startDate:vm.tableData.startDate,\n                            endDate:vm.tableData.endDate,\n                            back:vm.tableData.back,\n                            timeWarning:vm.tableData.timeWarning,\n                            replenishment:vm.tableData.replenishment,\n                            refund:vm.tableData.refund,\n                            supplierId:vm.tableData.supplierId,\n                            productId:vm.tableData.productId,\n                            keyword:vm.tableData.keyword\n                        })" style="color: #0F6AB4">{{salesOrder.sourceOrderNumber}}</a></td><td style="width: 20px; max-width: 20px; min-width: 20px; text-align: center">{{salesOrder.quantity}}</td><td style="width: 20px; max-width: 20px; min-width: 20px; text-align: center">{{salesOrder.settleAmount}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center">{{salesOrder.propertySku}}</td><td style="width: 60px; max-width: 60px; min-width: 60px; text-align: center">{{salesOrder.supplierName}}</td><td style="width: 60px; max-width: 60px; min-width: 60px; text-align: center">{{salesOrder.replenishment ? \'\u8865\u8D27\u8BA2\u5355\' : (salesOrder.orderSource == \'self\' ? \'\u81EA\u8425\u8BA2\u5355\' : (salesOrder.orderSource == \'Project\' ? \'\u9879\u76EE\u8BA2\u5355\' : \'\u5916\u90E8\u8BA2\u5355\'))}}</td><td data-translate="mainEndApp.orderStatus.{{salesOrder.status}}" style="width: 50px; max-width: 50px; min-width: 50px; text-align: center">{{salesOrder.status}}</td><td style="width: 50px; max-width: 50px; min-width: 50px; text-align: center">{{vm.makeupStatus(salesOrder.makeupStatus)}}</td><td style="width: 60px; max-width: 60px; min-width: 60px; text-align: center">{{salesOrder.expectedDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 90px; max-width: 90px; min-width: 90px; text-align: center">{{salesOrder.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="width: 90px; max-width: 90px; min-width: 90px; text-align: center">{{salesOrder.admeasureDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="width: 90px; max-width: 90px; min-width: 90px; text-align: center">{{salesOrder.downLoadDate | date:\'yyyy-MM-dd HH:mm\'}}</td><!-- <td style="width: 150px; max-width: 150px; min-width: 150px;">{{salesOrder.orderSource ==\'self\'?\'\u81EA\u8425\u8BA2\u5355\':\'\u7B2C\u4E09\u65B9\u6765\u6E90\'}}</td> --></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="12" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/order/orderVip-details.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u7B5B\u9009\u8BA2\u5355</span> <button type="button" class="c-btn c-btn1 printHide" ng-click="printpage()">\u6253\u5370</button></div><div class="row" style="margin: 10px 0 0"><div class="col-xs-8 orderDetails1"><ul class="row"><li class="col-xs-4 p0"><span class="orderDetails-title">\u8BA2\u5355\u53F7</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u8BA2\u5355\u6765\u6E90</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u5546\u6237</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u8BA2\u5355\u72B6\u6001</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u63A5\u5355\u7AEF\u53E3</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u63A5\u5355\u65F6\u95F4</span><p class="orderDetails-text">2019\u5E741\u670810\u65E517:42:15</p></li></ul></div><div class="col-xs-4 orderDetails2"><span>\u626B\u7801\u6EAF\u6E90</span> <img src="content/images/bk-min.png" alt=""></div></div></div></div><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u5546\u54C1\u8BE6\u60C5</span></div><div class="row" style="margin: 10px 0 0"><div class="col-xs-8 orderDetails1"><ul class="row"><li class="col-xs-4 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u5546\u54C1</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u8BA2\u8D2D\u6570\u91CF</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u4FC3\u9500\u5546\u54C1\u4FE1\u606F</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u5546\u54C1\u6A21\u677F</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u5546\u54C1\u5C5E\u6027</span><p class="orderDetails-text">B000001</p></li><li class="col-xs-4 p0"><span class="orderDetails-title">\u5BA2\u670D\u5907\u6CE8</span><p class="orderDetails-text"></p></li></ul></div><div class="col-xs-4 orderDetails2"><img src="content/images/bk-min.png" alt=""></div></div></div></div></div><div class="bgc-fff p30 mtop20"><div><div class="clearfix"><span class="title1">\u652F\u4ED8</span></div><div class="c-table1"><table><thead><tr><th>\u652F\u4ED8\u65B9\u5F0F</th><th>\u652F\u4ED8\u5361\u5BC6\u7801</th><th>\u652F\u4ED8\u91D1\u989D</th><th>\u652F\u4ED8\u65F6\u95F4</th></tr></thead><tbody><tr><td>\u5FAE\u4FE1\u652F\u4ED8</td><td>3581</td><td>10000</td><td>2019\u5E741\u670810\u65E517:51:06</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u8C03\u8272\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u662F\u5426\u8C03\u8272</th><th>\u8C03\u8272\u72B6\u6001</th><th>\u8C03\u8272\u65F6\u95F4</th><th>VIP\u8BA2\u5355</th></tr></thead><tbody><tr><td>\u5FAE\u4FE1\u652F\u4ED8</td><td>3581</td><td>10000</td><td>2019\u5E741\u670810\u65E517:51:06</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u4EE3\u6392\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u4EE3\u6392\u72B6\u6001</th><th>\u5206\u914D\u4EBA</th><th>\u4EE3\u6392\u5458\u5DE5</th><th>\u4EE3\u6392\u5206\u914D\u65F6\u95F4</th><th>\u4EE3\u6392\u56DE\u4F20\u65F6\u95F4</th></tr></thead><tbody><tr><td></td><td></td><td></td><td></td><td>2019\u5E741\u670810\u65E517:51:06</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u751F\u4EA7\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u751F\u4EA7\u5546</th><th>\u62FC\u7248\u72B6\u6001</th><th>\u62FC\u7248\u6587\u4EF6</th><th>\u8BA2\u5355\u5206\u914D\u65F6\u95F4</th><th>\u662F\u5426\u56DE\u4EF6</th><th>\u56DE\u4EF6\u6570</th><th>\u56DE\u4EF6\u65F6\u95F4</th></tr></thead><tbody><tr><td>\u5FAE\u4FE1\u652F\u4ED8</td><td>3581</td><td>10000</td><td>2019\u5E741\u670810\u65E517:51:06</td><td>\u662F</td><td>6</td><td>2019\u5E741\u670810\u65E517:51:06</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u7269\u6D41\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u6536\u4EF6\u4EBA</th><th>\u8054\u7CFB\u7535\u8BDD</th><th>\u6536\u8D27\u5730\u5740</th><th>\u5FEB\u9012\u516C\u53F8</th><th>\u5FEB\u9012\u5355\u53F7</th></tr></thead><tbody><tr><td>\u5FAE\u4FE1\u652F\u4ED8</td><td>3581</td><td>10000</td><td>2019\u5E741\u670810\u65E517:51:06</td><td>\u662F</td></tr></tbody></table></div></div><div class="mtop20"><div class="clearfix"><span class="title1">\u8865\u8D27\u4FE1\u606F</span></div><div class="c-table1"><table><thead><tr><th>\u662F\u5426\u8865\u8D27</th><th>\u8865\u8D27\u6570\u91CF</th><th>\u8865\u8D27\u539F\u56E0</th><th>\u8865\u8D27\u8BA2\u5355\u7F16\u53F7</th><th>\u5907\u6CE8\u4FE1\u606F</th></tr></thead><tbody><tr><td>\u5FAE\u4FE1\u652F\u4ED8</td><td>3581</td><td>10000</td><td>2019\u5E741\u670810\u65E517:51:06</td><td>\u662F</td></tr></tbody></table></div></div></div></div><style>@media print {\n        .printHide {display: none}\n\n        #printPage {\n            display: block;\n            width: 100%\n        }\n    }</style>');
$templateCache.put('app/outsourcing/distribute.html','<div class="bg-content"><!--\u5206\u914D--><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u751F\u4EA7\u914D\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u751F\u4EA7\u5546</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.supplier" ng-options="supplier.name for supplier in vm.suppliers" ng-change="selectSupplier(vm.supplier)"><option value="">\u8BF7\u9009\u62E9\u751F\u4EA7\u5546</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u62FC\u7248\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" ng-if="!vm.makeupOrNot" class="form-control ng-pristine ng-valid ng-not-empty ng-touched" value="\u6682\u65E0\u62FC\u7248" disabled="disabled"><select ng-if="vm.makeupOrNot" class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.makeup" ng-options="data.name for data in vm.productionManages2"><option value="">\u8BF7\u9009\u62E9\u62FC\u7248</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><span><span style="color: red">*</span> \u6240\u9009\u4F9B\u5E94\u5546\u4F59\u989D\u4E0D\u8DB3\u65F6\uFF0C\u4F1A\u5BFC\u81F4\u8BA2\u5355\u5206\u914D\u5931\u8D25\u3002</span><br><br><br><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/outsourcing/expand-task.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7B5B\u9009\u4EFB\u52A1</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u4EFB\u52A1\u521B\u5EFA\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u4EA7\u54C1\u540D\u79F0</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.product" ng-options="data.name for data in vm.productList" ng-change="selectProduct(vm.product)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u6269\u8FB9\u4EFB\u52A1\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u5BFC\u51FA</button></div><div class="c-table mtop20 scrollbar-main"><table style="min-width: 1400px; overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center"><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th style="text-align: center">\u8BA2\u5355\u53F7</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u8BA2\u8D2D\u5546\u54C1SKU</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u8BA2\u5355\u7C7B\u578B</th><th style="text-align: center">\u6587\u4EF6P\u6570</th><th style="text-align: center">\u521B\u5EFA\u65F6\u95F4</th><th style="text-align: center">\u5B8C\u6210\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders  track by $index" ng-if="vm.salesOrders.length > 0"><td style="width: 20px; max-width: 20px; min-width: 20px; text-align: center"><input type="checkbox" ng-model="salesOrder.checked" ng-click="selectOne()"></td><td style="width: 180px; max-width: 180px; min-width: 180px; text-align: center">{{salesOrder.salesOrderNumber}}</td><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{salesOrder.quantity}}</td><td style="min-width: 100px; text-align: center">{{salesOrder.propertySku}}</td><td style="width: 100px; max-width: 100px; min-width: 100px; text-align: center">{{ status(salesOrder.status) }}</td><td ng-if="!salesOrder.replenishmentBeforeNumber" data-translate="mainEndApp.orderSource.{{salesOrder.salesOrderSource}}" style="min-width: 100px; text-align: center">{{salesOrder.orderSource}}</td><td ng-if="!!salesOrder.replenishmentBeforeNumber" style="min-width: 100px; text-align: center">\u8865\u8D27\u8BA2\u5355</td><td style="min-width: 60px; text-align: center">{{salesOrder.pageCount}}</td><td style="min-width: 80px; text-align: center">{{salesOrder.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td style="min-width: 80px; text-align: center">{{salesOrder.finishedAt | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/outsourcing/make-up.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4EFB\u52A1\u67E5\u8BE2</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u62FC\u7248\u540D\u79F0\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u751F\u4EA7\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u751F\u4EA7\u5546</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.supplier" ng-options="data.name for data in vm.suppliers" ng-change="selectSupplier(vm.supplier)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u62FC\u7248\u65B9\u5F0F</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.makeupStatus" ng-options="data.id as data.name for data in vm.makeups"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u62FC\u7248\u72B6\u6001</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.makeupStatus" ng-options="data.id as data.name for data in vm.makeupStatusMap"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.id == vm.tableData.makeupStatus}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="revoke()">\u64A4\u9500</button> <button type="button" class="c-btn c-btn1" ng-click="view()">\u67E5\u770B</button></div><div class="c-table mtop20 scrollbar-main" style="text-align: center"><table style="overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="width: 20px; text-align: center"></th><th style="width: 80px; text-align: center">\u62FC\u7248\u6587\u4EF6</th><th style="width: 60px; text-align: center">\u62FC\u7248\u65F6\u95F4</th><th style="width: 60px; text-align: center">\u62FC\u7248\u65B9\u5F0F</th><th style="width: 60px; text-align: center">\u4F9B\u5E94\u5546</th><th style="width: 60px; text-align: center">\u62FC\u7248\u72B6\u6001</th><th style="width: 60px; text-align: center">\u4E0B\u8F7D\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="order in vm.orderMakeupFiles  track by $index" ng-if="vm.orderMakeupFiles.length > 0"><td><input type="checkbox" ng-model="order.checked" ng-click="selectOne()"></td><td title="{{order.filePath}}"><a ng-href="{{order.filePath}}" target="_blank">{{order.groupKey}}<!-- {{order.filePathStr|limitTo:\'20\'}} --></a></td><td>{{order.createdDate| date:\'yyyy-MM-dd HH:mm\' }}</td><td>{{order.makeupType}}</td><td>{{order.supplierName}}</td><td>{{vm.makeupStatus(order.makeupStatus)}}</td><td>{{order.dowmloadDate| date:\'yyyy-MM-dd HH:mm\' }}</td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/outsourcing/order-list.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u751F\u4EA7\u914D\u7F6E</span></div></div></div></div><div class="bgc-fff p30 scrollbar-main" style="padding-top: 0px; max-height: 550px; overflow-y: auto"><div class="c-table1"><table><thead><tr><th>\u8BA2\u5355\u7F16\u53F7</th><th>\u62FC\u7248\u4EFD\u6570</th></tr></thead><tbody><tr ng-repeat="data in vm.orderList track by $index"><td>{{data.sourceOrderNumber}}</td><td>{{getQuantity(data)}}</td></tr></tbody></table></div></div><div class="c-form"><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn2" ng-click="back()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/outsourcing/outsourcing-task.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7B5B\u9009\u8BA2\u5355</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u751F\u4EA7\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u8BA2\u5355\u72B6\u6001</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.state" ng-options="data.value as data.name for data in vm.stateList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u4EA7\u54C1\u540D\u79F0</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.product" ng-options="data.name for data in vm.productList" ng-change="selectProduct(vm.product)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul><p class="form-search2-screen" ng-click="vm.isFilter = !vm.isFilter">{{!vm.isFilter ? \'\u5C55\u5F00\u9AD8\u7EA7\u7B5B\u9009\' : \'\u6536\u8D77\u9AD8\u7EA7\u7B5B\u9009\'}}</p><ul class="clearfix" ng-if="vm.isFilter"><li><p>\u751F\u4EA7\u5546</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.supplier" ng-options="data.name for data in vm.suppliers" ng-change="selectSupplier(vm.supplier)"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u62FC\u7248\u72B6\u6001</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.makeupStatus" ng-options="data.id as data.name for data in vm.makeups"><option value="">\u8BF7\u9009\u62E9</option></select></div></li><li><p>\u662F\u5426\u56DE\u4EF6</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.back" ng-options="data.value as data.name for data in vm.backList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8BA2\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="orderExport()">\u4E0B\u8F7D</button> <button type="button" class="c-btn c-btn1" ng-click="revoke()">\u64A4\u9500</button> <button type="button" class="c-btn c-btn1" ng-click="distributeTask()">\u5206\u914D</button><!--<button type="button" class="c-btn c-btn1">\u5907\u6CE8</button>--></div><div class="c-table mtop20 scrollbar-main"><table style="min-width: 1400px; overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="text-align: center"><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th style="text-align: center">\u8BA2\u5355\u53F7</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u8BA2\u8D2D\u5546\u54C1SKU</th><th style="text-align: center">\u8BA2\u5355\u72B6\u6001</th><th style="text-align: center">\u8BA2\u5355\u7C7B\u578B</th><th style="text-align: center">\u751F\u4EA7\u5546</th><th style="text-align: center">\u5370\u524D\u65B9\u5F0F</th><th style="text-align: center">\u5370\u524D\u72B6\u6001</th><th style="text-align: center">\u62FC\u7248\u65B9\u5F0F</th><th style="text-align: center">\u62FC\u7248\u72B6\u6001</th><th style="text-align: center">\u62FC\u7248\u6587\u4EF6</th><th style="text-align: center" jh-sort-by="admeasureDate">\u8BA2\u5355\u5206\u914D\u65F6\u95F4 <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders  track by $index" ng-if="vm.salesOrders.length > 0"><td style="width: 20px; max-width: 20px; min-width: 20px; text-align: center"><input type="checkbox" ng-model="salesOrder.checked" ng-click="selectOne()"></td><td style="width: 180px; max-width: 180px; min-width: 180px; text-align: center">{{salesOrder.sourceOrderNumber}}</td><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{salesOrder.quantity}}</td><td style="min-width: 100px; text-align: center">{{salesOrder.propertySku}}</td><td data-translate="mainEndApp.orderStatus.{{salesOrder.status}}" style="width: 100px; max-width: 100px; min-width: 100px; text-align: center">{{salesOrder.status}}</td><td ng-if="!salesOrder.replenishmentBeforeNumber" data-translate="mainEndApp.orderSource.{{salesOrder.orderSource}}" style="min-width: 100px; text-align: center">{{salesOrder.orderSource}}</td><td ng-if="!!salesOrder.replenishmentBeforeNumber" style="min-width: 100px; text-align: center">\u8865\u8D27\u8BA2\u5355</td><td style="min-width: 60px; text-align: center">{{salesOrder.supplierName || \'--\'}}</td><td style="min-width: 60px; text-align: center">{{!salesOrder.prePressFlowName ? \'\' : salesOrder.prePressFlowName}}</td><td style="min-width: 60px; text-align: center">{{getPrePressStatus(salesOrder.prePressStatus)}}</td><td style="min-width: 60px; text-align: center">{{!salesOrder.makeupName ? \'\' : salesOrder.makeupName}}</td><td style="min-width: 60px; text-align: center">{{vm.makeupStatus(salesOrder.makeupStatus)}}</td><td style="min-width: 100px; text-align: center" title="{{salesOrder.groupKey}}">{{salesOrder.groupKey|limitTo:\'20\'}}</td><td style="min-width: 80px; text-align: center">{{salesOrder.admeasureDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/outsourcing/pre-press.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4EFB\u52A1\u67E5\u8BE2</span></div><div class="form-search1 clearfix mt10"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div><div class="form-search2 mt10"><ul class="clearfix"><li><p>\u8BA2\u5355\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u5370\u524D\u65B9\u5F0F</p><div class="form-search2-term"><select name="" class="c-select1" ng-model="vm.tableData.prePressId" ng-options="data.id as data.name for data in vm.prePressList"><option value="">\u8BF7\u9009\u62E9</option></select></div></li></ul></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()" ng-disabled="vm.isSaving">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff mtop20"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.id == vm.tableData.makeupStatus}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u5370\u524D\u5217\u8868</span></div><div class="c-table mtop20 scrollbar-main" style="text-align: center"><table style="overflow-x: auto"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="sort()"><th style="width: 180px; text-align: center">\u8BA2\u5355\u7F16\u53F7</th><th style="width: 180px; text-align: center">\u8BA2\u5355\u65F6\u95F4</th><th style="width: 150px; text-align: center">\u5370\u524D\u5904\u7406\u65B9\u5F0F</th><th style="width: 150px;text-align: center">\u5370\u524D\u72B6\u6001</th></tr></thead><tbody><tr ng-repeat="order in vm.orderMakeupFiles  track by $index" ng-if="vm.orderMakeupFiles.length > 0"><td title="{{order.prePressFileUrl}}"><span ng-show="!!order.prePressFileUrl"><a ng-href="{{order.prePressFileUrl}}" target="_blank">{{order.sourceOrderNumber}} </a></span><span ng-show="!order.prePressFileUrl">{{order.sourceOrderNumber}}</span></td><td>{{order.createdDate| date:\'yyyy-MM-dd HH:mm\' }}</td><td>{{order.prePressFlowName}}</td><td>{{vm.getStatus(order.prePressStatus)}}</td></tr><tr class="noData" ng-if="vm.salesOrders.length == 0"><td colspan="4" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/product/classify-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">{{vm.title}}</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5206\u7C7B\u540D\u79F0\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.saveData.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div" style="width: 375px"><select name="" class="c-select1" ng-model="vm.saveData.sort" ng-options="data.value as data.name for data in vm.typeList" ng-change="vm.getPcgs()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u7F16\u7801\u89C4\u5219\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.saveData.categoryCode" maxlength="4"></div></div><div class="c-form"><label class="c-form-label">\u662F\u5426\u5B50\u5206\u7C7B\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="checkbox" ng-model="vm.saveData.subordinate" class="checkOrIf" ng-change="subordinateCb()"></div></div><div class="c-form" ng-if="vm.saveData.subordinate"><label class="c-form-label">\u4E0A\u7EA7\u5206\u7C7B\uFF1A</label><div class="c-form-div" style="width: 375px"><select name="" class="c-select1" ng-model="vm.pcg" ng-options="data as data.name for data in vm.pcgs" ng-change="vm.getPcg2(vm.pcg)"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="checkbox" ng-model="vm.saveData.enable" class="checkOrIf"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="width: 375px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving" ng-if="vm.data.state">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1 mr10" ng-click="saveEdit()" ng-disabled="vm.isSavingEdit" ng-if="!vm.data.state">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/product/classify.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5206\u7C7B\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ng-click="classifyAdd()">\u65B0\u5EFA\u5206\u7C7B</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u5206\u7C7B\u7C7B\u578B</th><th style="text-align: center">\u4E0A\u7EA7\u5206\u7C7B</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="width: 300px; max-width: 300px; min-width: 300px; text-align: center"><p title="{{data.name}}">{{data.name}}</p></td><td style="text-align: center">{{data.sort ==\'product\' ?\'\u5546\u54C1\u7C7B\':data.sort ==\'accessories\'?\'\u8F85\u6750\u7C7B\':\'\'}}</td><td style="text-align: center">{{data.superiorName ? data.superiorName : \'-\'}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 170px; max-width: 170px; min-width: 170px; text-align: center"><button class="c-minBtn c-minBtn1" ng-click="classifyEdit(data)">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="roleDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/product/commodity-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">{{vm.data.id ? \'\u7F16\u8F91\' : \'\u65B0\u5EFA\'}}{{categoryInfo(vm.data.category)}}</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5546\u54C1\u540D\uFF1A</label><div class="c-form-div wid-800 lh30"><input type="text" class="c-input1" id="nameId" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u540D" maxlength="20" ng-focus="nameFocus()" ng-blur="nameBlur()" ng-keypress="nameKeypress($event)"></div></div><div class="c-form"><label class="c-form-label">\u7269\u6599\u6A21\u677F\uFF1A</label><div class="c-form-div wid-800" ng-if="!vm.data.id"><select name="" class="c-select1" ng-model="vm.data.templateId" ng-options="data.id as data.name for data in vm.materialTemplatesList" ng-change="productCategorySelect()"></select></div><div class="c-form-div wid-800 lh30" ng-if="vm.data.id">{{vm.data.templateName}}</div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-800 lh30"><!--                <select name="" class="c-select1" ng-model="vm.data.category"--><!--                        ng-options="data.id as data.name for data in vm.commodityTypes"--><!--                        ng-if="vm.data.category != \'GeneralProduct\'"--><!--                        ng-change="commodityTypeSelect()">--><!--                </select>--> <span>{{categoryInfo(vm.data.category)}}</span></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u54C1\u7C7B\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.productCategoryName" placeholder="\u8BF7\u9009\u62E9\u5546\u54C1\u54C1\u7C7B" disabled="disabled"></div></div><div class="c-form" ng-if="vm.superiorName"><label class="c-form-label">\u5546\u54C1\u54C1\u7C7B\u4E00\u7EA7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.superiorName" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u7F16\u53F7\uFF1A</label><div class="c-form-div wid-800 lh30"><input type="text" class="c-input1" ng-model="vm.data.number" disabled="disabled" ng-if="!vm.data.id"> <span ng-if="vm.data.id">{{vm.data.number}}</span></div></div><div class="c-form"><label class="c-form-label">\u8BA1\u91CF\u5355\u4F4D\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.measurementId" ng-options="data.id as data.name for data in vm.unitList" ng-change="measurementSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><!-- <div class="c-form">\n            <label class="c-form-label">DPI\uFF1A</label>\n            <div class="c-form-div wid-800">\n                <input type="text" class="c-input1" ng-model="vm.data.imgDpi" min="1">\n            </div>\n        </div> --><div class="c-form" ng-if="vm.data.category != \'MaterialProduct\'"><label class="c-form-label">\u9884\u8B66\u65F6\u95F4(h)\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" ng-model="vm.data.warningTime" min="1"></div></div><div class="c-form" ng-if="vm.data.category != \'MaterialProduct\'"><label class="c-form-label">\u91CD\u91CF(g)\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" ng-model="vm.data.weight" min="0" step="0.01"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.data.enable" class="checkOrIf"></div></div><div ng-if="vm.data.category != \'MaterialProduct\'"><div class="c-form" ng-if="vm.data.category != \'GeneralProduct\'"><label class="c-form-label">\u6807\u7B7E\u6253\u5370\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.data.tag" class="checkOrIf"></div></div><div class="c-form" ng-if="vm.data.category != \'GeneralProduct\'"><label class="c-form-label">\u8C03\u8272\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.data.toning" class="checkOrIf"></div></div><div class="c-form" ng-if="vm.data.category==\'OrderingProduct\'"><label class="c-form-label">\u6269\u8FB9\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.data.fileOutpaintRequired" class="checkOrIf"></div></div><div class="c-form" ng-if="vm.data.category==\'OrderingProduct\' && vm.data.fileOutpaintRequired" style="margin-left: 50px"><label class="c-form-label">\u6269\u8FB9\u5C3A\u5BF8\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" style="width: 200px" ng-model="vm.data.fileOutpaintSize" min="0" step="0.1">&nbsp;mm</div></div><div class="c-form"><label class="c-form-label">\u4EA7\u54C1\u9884\u89C8\u56FE\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px"><input ng-if="!vm.data.previewImg" type="file" name="file" class="form-control border-radius" type="file" accept="image/jpeg, image/png" onchange="updateImg(event)" ng-model-options="{debounce : 500}"> <span ng-if="vm.data.previewImg"><img ng-src="{{vm.data.previewImg}}?imageMogr2/auto-orient" style="width: 100px; height: 100px; border: 1px dashed red"> <i class="glyphicon glyphicon-remove" ng-click="removeFile()" style="color: red"></i></span><div class="mar-top-10" style="color:#b3a8a8; font-size: 12px">\u5EFA\u8BAE\u5C3A\u5BF8\uFF1A750*380px\u30011080*540px</div></div></div><!--\u5B9A\u5236\u54C1  start--><div ng-if="vm.isCustomization"><!--<div class="c-form">--><!--<label class="c-form-label">\u53EF\u751F\u4EA7\uFF1A</label>--><!--<div class="c-form-div wid-800">--><!--<input type="checkbox" ng-model="vm.data.producible" class="checkOrIf" ng-click="productionCb()">--><!--</div>--><!--</div>--><div class="c-form" ng-if="vm.data.producible"><label class="c-form-label">\u9884\u8B66\u65F6\u95F4\uFF1A</label><div class="c-form-div wid-800" style="position: relative"><input type="text" ng-model="vm.data.warningTime" class="c-input1"> <span style="position: absolute; left: 100%; top: 0; display: inline-block; height: 30px; line-height: 30px; margin-left: 10px; width: 100px">\u5C0F\u65F6</span></div></div><div class="c-form" ng-if="vm.data.category != \'GeneralProduct\'"><label class="c-form-label">\u81EA\u52A8\u6D41\u8F6C\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.data.autoOutsourcing" class="checkOrIf" ng-click="autoOutsourcingCb()"></div></div><div class="c-form" ng-if="vm.data.autoOutsourcing"><label class="c-form-label">\u6D41\u8F6C\u914D\u7F6E\uFF1A</label><div class="c-form-div" style="width: auto"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u751F\u4EA7\u5546</th><th>\u9ED8\u8BA4\u914D\u7F6E</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.productCirculations track by $index"><td style="max-width: 80px; min-width: 80px; width: 80px">{{$index + 1}}</td><td style="padding: 0 10px"><select name="" class="c-select2" ng-model="data.supplierId" ng-options="data.id as data.name for data in vm.supplierList" ng-change="supplierSelect(data)"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="width: 120px; max-width: 120px; min-width: 120px"><span class="deploy-default ng-scope" ng-if="data.defaulted">\u9ED8\u8BA4\u914D\u7F6E</span> <button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="defaultFn($index)" ng-if="!data.defaulted">\u8BBE\u4E3A\u9ED8\u8BA4</button></td><td style="width: 120px; max-width: 120px; min-width: 120px"><button type="button" class="c-minBtn c-minBtn3" ng-click="defaultDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="4"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="productCirculationAdd()"><i></i>\u65B0\u5EFA</button></td></tr></tbody></table></div></div></div></div></div><!--\u5B9A\u5236\u54C1 end --><div class="c-form"><label class="c-form-label">\u5C5E\u6027\uFF1A</label><div class="c-form-div" style="width: auto"><div class="btn-view c-minBtn1" ng-repeat="data in vm.data.items">{{data.name}}</div><div class="btn-view c-minBtn4" style="cursor: pointer" ng-click="itemEdit()" ng-if="!vm.data.id">\u7F16\u8F91</div></div></div><div style="margin-bottom: 20px"><div class="c-form"><label class="c-form-label">\u751F\u6210SKU\uFF1A</label><div class="c-form-div" style="width: auto"><div style="border: 1px solid #ddd; border-bottom: 0; padding: 0 10px; height: 40px; line-height: 40px;overflow: hidden"><button class="btn-flow" ng-click="rapidGenerating()">\u5FEB\u901F\u751F\u6210</button></div><div class="c-table1" ng-if="vm.data.category != \'MaterialProduct\'"><table><thead><tr><th>\u5E8F\u53F7</th><th>SKU\u540D\u79F0</th><th>SKU\u7F16\u53F7</th><th>\u521B\u5EFA\u65E5\u671F</th><th>scm\u7F16\u53F7</th><th>\u522B\u540D</th><th>\u91CD\u91CF</th><th ng-if="vm.data.category != \'GeneralProduct\'">\u6807\u51C6\u9875\u6570</th><th ng-if="vm.data.category != \'GeneralProduct\'">\u9644\u4EF6PDF\u6821\u9A8C\u8BBE\u7F6E</th><th>\u6700\u5C0F\u5E93\u5B58\u9884\u8B66</th><th>\u8F85\u6599\u8BBE\u7F6E</th><th>\u4EA7\u54C1\u9884\u89C8\u56FE</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.propertyConfigs track by $index" ng-show="!data.cancelled"><td style="max-width: 80px; min-width: 80px; width: 80px">{{$index + 1}}</td><td>{{data.sku}}</td><td><input type="text" class="c-input1" placeholder="sku\u7F16\u53F7" ng-model="data.skuNumber" ng-blur="skuNumberChange($event,data,$index)"></td><td>{{data.createdDate | date:\'yyyy-MM-dd\'}}</td><td style="max-width: 150px; min-width: 150px; width: 150px">{{data.number}}</td><td style="padding: 0px"><input type="text" class="commodity_input" ng-model="data.alias"></td><td style="padding: 0px"><input type="number" class="commodity_input" ng-model="data.weight"></td><td style="padding: 0px" ng-if="vm.data.category != \'GeneralProduct\'"><input type="number" class="commodity_input" ng-model="data.normalPages"></td><td style="padding: 0 10px; max-width: 150px; min-width: 150px; width: 150px" ng-if="vm.data.category != \'GeneralProduct\'"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="pdfFileEdit(data, $index)">\u8BBE\u7F6E</button></td><td style="padding: 0 10px; max-width: 120px; min-width: 120px; width: 120px"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="warningSet($index)" ng-if="!data.warehouseConfigs">\u8BBE\u7F6E</button> <button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="warningEdit(data, $index)" ng-if="data.warehouseConfigs">\u7F16\u8F91\u8BBE\u7F6E</button></td><td style="padding: 0 10px; max-width: 100px; min-width: 100px; width: 100px"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="ingredientsSet($index)" ng-if="!data.materialConfigs || data.materialConfigs.length == 0">\u8BBE\u7F6E</button> <button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="ingredientsEdit(data, $index)" ng-if="data.materialConfigs.length > 0">\u7F16\u8F91\u8BBE\u7F6E</button></td><td style="padding: 0 10px; max-width: 100px; min-width: 100px; width: 150px"><input ng-if="!data.previewImg" type="file" name="file" class="form-control border-radius" type="file" id="{{data.id}}" index="{{$index}}" accept="image/jpeg, image/png" onchange="updateSkuImg(event)" ng-model-options="{debounce : 500}"><div class="image-view" ng-if="data.previewImg"><img ng-src="{{data.previewImg}}?imageMogr2/auto-orient" style="width: 100px; height: 100px; border: 1px dashed red"> <i class="glyphicon glyphicon-remove delete-btn" ng-click="removeSkuFile(data)" style="color: red"></i></div></td><td style="max-width: 60px; min-width: 60px; width: 60px"><button class="c-minBtn c-minBtn3" ng-click="propertyDelete(data, $index)">\u5220\u9664</button></td></tr></tbody></table></div><div class="c-table1" ng-if="vm.data.category == \'MaterialProduct\'"><table><thead><tr><th>\u5E8F\u53F7</th><th>SKU\u540D\u79F0</th><th>SKU\u7F16\u53F7</th><th>\u7F16\u53F7</th><th>\u6700\u5C0F\u5E93\u5B58\u9884\u8B66</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.propertyConfigs track by $index" ng-show="!data.cancelled"><td style="max-width: 80px; min-width: 80px; width: 80px">{{$index + 1}}</td><td>{{data.sku}}</td><td><input type="text" class="c-input1" placeholder="sku\u7F16\u53F7" ng-model="data.skuNumber" ng-blur="skuNumberChange($event,data,$index)"></td><td style="max-width: 150px; min-width: 150px; width: 150px">{{data.number}}</td><td style="padding: 0 10px; max-width: 120px; min-width: 120px; width: 120px"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="warningSet($index)" ng-if="!data.warehouseConfigs">\u8BBE\u7F6E</button> <button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="warningEdit(data, $index)" ng-if="data.warehouseConfigs">\u7F16\u8F91\u8BBE\u7F6E</button></td><td style="width: 120px; max-width: 120px; min-width: 120px"><button class="c-minBtn c-minBtn3" ng-click="propertyDelete(data,$index)">\u5220\u9664</button></td></tr></tbody></table></div></div></div></div><div class="mtop20"><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/product/commodity.html','<div class="bgc-fff"><div class="p30"><div class="clearfix"><span class="title1">{{productTypeInfo(vm.productType)}}\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ui-sref="commodityAdd({productType:vm.productType})">\u65B0\u5EFA</button><div class="pull-right"><div style="padding-top: 20px;   display: flex;  flex-wrap: wrap"><div class="c-form form-search"><label class="c-form-label">\u4E00\u7EA7\u5206\u7C7B</label><div class="c-form-div" style="width: 150px"><select class="c-input1" ng-model="vm.tableData.parentCategoryId" ng-options="data.id as data.name for data in vm.productCategoryFirst" ng-change="changeSearchCategoryFirst()"><option value="">\u8BF7\u9009\u62E9\u4E00\u7EA7\u5206\u7C7B</option></select></div></div><div class="c-form form-search"><label class="c-form-label">\u4E8C\u7EA7\u5206\u7C7B</label><div class="c-form-div" style="width: 150px"><select class="c-input1" ng-model="vm.tableData.categoryId" ng-options="data.id as data.name for data in vm.productCategorySecond" ng-change="changeSearchCategorySecond()"><option value="">\u8BF7\u9009\u62E9\u4E8C\u7EA7\u5206\u7C7B</option></select></div></div><div class="c-form form-search"><label class="c-form-label">sku\u7F16\u53F7</label><div class="c-form-div" style="width: 150px"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165sku\u7F16\u53F7" ng-model="vm.tableData.skuNumber"></div></div><div class="c-form form-search"><label class="c-form-label">\u5546\u54C1\u540D\u79F0</label><div class="c-form-div" style="width: 150px"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u540D\u79F0" ng-model="vm.tableData.keyword"></div></div><div class="form-search clearfix" style="float: left; margin-left: 15px"><!-- <input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22" ng-model="vm.tableData.keyword"> --> <button style="background: #ff9601;color: #fff; margin-left: 15px" type="button" ng-click="search()">\u67E5\u8BE2</button> <button style="background: #c8c8c8;  margin-left: 15px" type="button" ng-click="clear()">\u91CD\u7F6E</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5546\u54C1\u540D\u79F0</th><th style="text-align: center">\u5B9A\u5236/\u6807\u51C6</th><th style="text-align: center">\u5546\u54C1\u5206\u7C7B</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u9884\u8B66\u65F6\u95F4</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u6253\u5370\u6807\u7B7E</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList" ng-if="vm.tableList.length > 0"><td style="text-align: center">{{data.name}}</td><td style="text-align: center">{{data.category ==\'GeneralProduct\'?\'\u6807\u51C6\u901A\u54C1\':data.category ==\'OrderingProduct\'?\'\u5B9A\u5236\u5546\u54C1\':data.category ==\'StandardProduct\'?\'\u6807\u51C6\u5370\u54C1\':\'\'}}</td><td style="text-align: center">{{data.productCategoryName}}</td><td style="text-align: center">{{data.number}}</td><td style="text-align: center">{{data.warningTime}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="text-align: center">{{data.tag ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 150px; max-width: 150px; min-width: 150px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="commodityEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="roleDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div></div>');
$templateCache.put('app/product/file-check.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u9644\u4EF6PDF\u68C0\u67E5\u53C2\u6570</span></div><div class="mt10"><div class="c-form"><label class="c-form-label">PDF\u9AD8\u5EA6(mm)\uFF1A</label><div class="c-form-div"><input type="number" class="c-input1" ng-model="vm.flowData.fileHeight" min="0"></div></div><div class="c-form"><label class="c-form-label">PDF\u5BBD\u5EA6(mm)\uFF1A</label><div class="c-form-div"><input type="number" class="c-input1" ng-model="vm.flowData.fileWidth" min="0"></div></div><div class="c-form"><label class="c-form-label">PDF\u603B\u9875\u6570\uFF1A</label><div class="c-form-div"><input type="number" class="c-input1" ng-model="vm.flowData.filePageCount" min="0"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="flowSave()">{{vm.type ? \'\u4FDD\u5B58\' : \'\u786E\u5B9A\'}}</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/product/modal-flow.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">{{ vm.type ? \'\u65B0\u5EFA\u6D41\u8F6C\' : \'\u7F16\u8F91\u6D41\u8F6C\'}}</span></div><div class="mt10"><div class="c-form"><label class="c-form-label">\u751F\u4EA7\u5546\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.supplierName" ng-options="data.name for data in vm.supplierList" ng-change="supplierSelect(data)"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u62FC\u7248\u65B9\u5F0F\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.makeup" ng-options="data.name for data in vm.makeupTypeList" ng-change="makeupSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u6253\u5305\u6570\uFF1A</label><div class="c-form-div"><input type="number" class="c-input1" ng-model="vm.flowData.packings"></div></div><div class="c-form"><label class="c-form-label">\u65E5\u4EA7\u989D\uFF1A</label><div class="c-form-div"><input type="number" class="c-input1" ng-model="vm.flowData.dailyOutput"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="flowSave()">{{ vm.type ? \'\u4FDD\u5B58\' : \'\u786E\u5B9A\'}}</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/project/chooseProduct.html','<div class="bg-content"><div class="bg-center" style="min-height: 500px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u9009\u62E9\u5546\u54C1</span><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22\u3002" ng-model="vm.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="mtop20 clearfix"><div class="pull-left width_20_percent" style="padding: 0px; overflow: hidden"><div class="centent"><div class="treebox scrollsXY" style="overflow-x: auto"><div class="tree"><ul><li ng-repeat="(key, value) in vm.productList"><div class="open_menu"><span></span>{{key}}</div><ul ng-repeat="(key2, value2) in value track by $index"><li ng-repeat="(key2_, value2_) in value2 track by $index"><div class="open_menu"><span></span>{{key2_}}</div><ul ng-repeat="(key3, value3) in value2_ track by $index"><li ng-repeat="(key3_, value3_) in value3 track by $index"><a ng-class="{\'ontree\' : vm.navKey == key3_}" ng-click="getProduct(key3_, value3_)">{{key3_}}</a></li></ul></li></ul></li></ul></div></div></div></div><div class="pull-left c-table width_80_percent pad-left-10"><table><thead><tr style="border-bottom: 1px solid #000"><th>\u5546\u54C1\u540D\u79F0</th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u5546\u54C1\u7C7B\u578B</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0" ng-class="{\'activeBg\' : vm.selectIndex == $index}" ng-click="productChoice(data,$index)"><td>{{data.sku}}</td><td>{{data.number}}</td><td>{{data.unit}}</td><td>{{data.category == \'OrderingProduct\' ? \'\u5B9A\u5236\u5546\u54C1\' : (data.category == \'GeneralProduct\' ? \'\u6807\u51C6\u901A\u54C1\' : (data.category == \'StandardProduct\' ? \'\u6807\u51C6\u5370\u54C1\' : \'\u672A\u77E5\'))}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="4" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9,\u8BF7\u9009\u62E9\u6570\u636E</span></td></tr></tbody></table></div></div><div class="c-form mtop20"><div class="wid_100"><button type="button" class="c-btn c-btn1" style="width: 130px" ng-click="confirm()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancel()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/project/project-add.html','<div class="bgc-fff p30"><div><span class="title1">\u65B0\u5EFA\u9879\u76EE</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5546\u6237\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-model="vm.data.merchant" ng-options="data.name for data in vm.merchants"><option value="">\u8BF7\u9009\u62E9\u5546\u6237</option></select></div></div><div class="c-form"><label class="c-form-label">\u9879\u76EE\u7F16\u53F7\uFF1A</label><div class="c-form-div wid-1000 lh30"><input type="text" class="c-input1" style="width: 80%" placeholder="\u8BF7\u8F93\u5165\u9879\u76EE\u7F16\u53F7" ng-model="vm.data.number" maxlength="20"> <button type="button" class="c-btn c-btn2 mr10" style="height: 30px" ng-click="vm.getOrder()">\u67E5\u8BE2</button></div></div><div class="c-form"><label class="c-form-label">\u9879\u76EE\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-model="vm.data.type" ng-options="data.id as data.name for data in vm.projectTypes"><option value="">\u8BF7\u9009\u62E9\u9879\u76EE\u7C7B\u578B</option></select></div></div><div class="c-form"><label class="c-form-label">\u8BA1\u5212\u4EA4\u671F\uFF1A</label><div class="c-form-div wid-1000 lh30"><div class="form-time" style="width: 100%"><input type="text" class="c-input1" ng-model="vm.expectedDate" id="startDate" placeholder="\u8BA1\u5212\u4EA4\u8D27\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\', readOnly:true, lang:\'zh-cn\', minDate:\'%y-%M-%d\'})"><div class="form-timeIcon"></div></div></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.contact" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" oninput="value=value.replace(/[^\\d]/g,\'\')" maxlength="11"></div></div><!-- <div class="c-form">\n            <label class="c-form-label">\u8054\u7CFB\u5730\u5740\uFF1A</label>\n            <div class="c-form-div wid-1000">\n                <input type="text" class="c-input1" ng-model="vm.data.address" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u5730\u5740">\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label" style="padding-right: 20px">\u8054\u7CFB\u5730\u5740\uFF1A</label><div class="c-form-div wid-1000"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-1000"><textarea type="text" class="form-control-edit" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" style="resize: none" ng-model="vm.address"></textarea></div></div><div class="c-form"><label class="c-form-label">\u8FD0\u8D39\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39"></div></div><div class="c-form"><label class="c-form-label">\u5907\u6CE8\uFF1A</label><div class="c-form-div wid-1000"><textarea class="c-input1" ng-model="vm.data.remarks" style="outline: none;resize: none" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div" style="width: auto"><div class="c-table1"><table><thead><tr><th>\u8BA2\u8D2D\u5546\u54C1</th><th>SKU\u7F16\u53F7</th><!-- <th>\u5546\u6237\u7F16\u53F7</th> --><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5355\u4EF7</th><th>\u5408\u8BA1</th><!-- <th>\u7A0E\u7387(%)</th> --><!-- <th>\u542B\u7A0E\u5355\u4EF7</th> --><!-- <th>\u52A0\u7A0E\u5408\u8BA1</th> --><th>\u6587\u4EF6\u4E0A\u4F20</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="productLine in vm.data.productLines track by $index"><td ng-style="{\'color\': !productLine.productNumber?\'#26B8FC\':\'\'}" ng-click="!productLine.productNumber?chooseProduct($index):\'\'" style="width: auto; outline: none">{{productLine.productName}}</td><td style="width: auto">{{productLine.productNumber}}</td><!-- <td style="width: auto;"><input type="text" class="c-input1" ng-model="productLine.lineNumber" style="border: 0;" min="0" maxlength="20"></td> --><td style="width: auto">{{productLine.unit}}</td><td style="width: auto"><input type="number" class="c-input1" ng-model="productLine.quantity" style="border: 0" min="0"></td><td style="width: auto"><input type="number" class="c-input1" ng-model="productLine.price" style="border: 0" min="0"></td><td style="width: auto"><span ng-if="!!productLine.quantity && !!productLine.price">\uFFE5{{productLine.quantity * productLine.price |number:2}}</span></td><!-- <td style="width: auto;">\n                                    <input type="number" class="c-input1" ng-model="productLine.taxRate" style="border: 0;" min="0" max="100">\n                                </td> --><!-- <td style="width: auto;">\n                                    <span ng-if="!!productLine.price && !!productLine.taxRate">\n                                        {{(productLine.price * productLine.taxRate / 100) + productLine.price}}\n                                    </span>\n                                </td> --><!-- <td style="width: auto;">\n                                    <span ng-if="!!productLine.price && !!productLine.quantity && !!productLine.taxRate">\n                                    \uFFE5{{(((productLine.price * productLine.taxRate / 100) + productLine.price) * productLine.quantity) | number : 2}}\n                                    </span>\n                                </td> --><td style="width: auto"><div style="width: 100%; height: 100%; z-index: 10"><div title="{{productLine.filePath}}">{{productLine.filePath|limitTo:\'20\'}}</div><div style="position: relative;width: 70px;display: inline-block"><button type="button" class="btn-flow" style="position: absolute;top: 3px"><a>{{!productLine.filePath?\'\u4E0A\u4F20\u6587\u4EF6\':\'\u91CD\u65B0\u4E0A\u4F20\'}}</a></button> <input type="file" id="file" name="myfile" data-target="{{$index}}" onchange="uploadFile(event)" accept="application/pdf, application/zip" style="width:80px;opacity: 0"></div><!-- <button type="button" class="btn-flow" style="cursor: pointer;border: 0;" ng-if="productLine.filePath" ng-click="downLoadFile(productLine)">\u4E0B\u8F7D\u6587\u4EF6</button> --></div><div id="progress-bar" style="height: 5px; width: 0%; border-radius: 1px; background-color: #FF9A24"></div></td><td style="width: 80px"><button class="c-minBtn c-minBtn3" ng-click="productLineDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="8"><span ng-click="productLineNew()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u751F\u4EA7</span></td></tr></tbody></table></div></div></div><div class="mtop20"><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-1000"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/project/project-detail.html','<div class="bgc-fff p30"><div><span class="title1">\u67E5\u770B\u9879\u76EE</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5546\u6237\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.merchant.name" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u9879\u76EE\u7F16\u53F7\uFF1A</label><div class="c-form-div wid-1000 lh30"><input type="text" class="c-input1" ng-model="vm.data.number" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u9879\u76EE\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-1000"><div class="c-input1" style="background: #EBEBE4">{{vm.data.type==\'Proofing\'?\'\u6253\u6837\':vm.data.type ==\'Standard\'?\'\u6807\u51C6\':\'\'}}</div></div></div><div class="c-form"><label class="c-form-label">\u8BA1\u5212\u4EA4\u671F\uFF1A</label><div class="c-form-div wid-1000 lh30"><div class="c-input1" style="background: #EBEBE4">{{vm.data.expectedDate| date:\'yyyy-MM-dd\'}}</div></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.contact" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u5730\u5740\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.address" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u5730\u5740" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8FD0\u8D39\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5907\u6CE8\uFF1A</label><div class="c-form-div wid-1000"><textarea class="c-input1" ng-model="vm.data.remarks" style="outline: none;resize: none" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8" disabled="disabled"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div" style="width: auto"><div class="c-table1"><table><thead><tr><th>\u8BA2\u8D2D\u5546\u54C1</th><th>SKU\u7F16\u53F7</th><!-- <th>\u5546\u6237\u7F16\u53F7</th> --><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5355\u4EF7</th><th>\u542B\u7A0E\u5355\u4EF7</th><th>\u91D1\u989D</th><!-- <th>\u7A0E\u7387(%)</th> --><th>\u52A0\u7A0E\u5408\u8BA1</th><th>\u6587\u4EF6\u4E0A\u4F20</th></tr></thead><tbody><tr ng-repeat="productLine in vm.data.productLines track by $index"><td>{{productLine.productName}}</td><td>{{productLine.productNumber}}</td><!-- <td>{{productLine.lineNumber}}</td> --><td>{{productLine.unit}}</td><td>{{productLine.quantity}}</td><td>{{productLine.price}}</td><td>{{productLine.taxPrice}}</td><td>{{productLine.amount}}</td><!-- <td>{{productLine.taxRate}}</td> --><td>{{productLine.taxAmount}}</td><td>{{productLine.filePath}}</td></tr><tr class="noData" ng-if="vm.data.productLines.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5546\u54C1\u4FE1\u606F</span></td></tr></tbody></table></div></div></div><div class="mtop20"><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><button type="button" class="c-btn c-btn2" ng-click="cancel()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/project/project-edit.html','<div class="bgc-fff p30"><div><span class="title1">\u7F16\u8F91\u9879\u76EE</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5546\u6237\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-model="vm.merchant" ng-options="data.name for data in vm.merchants"><option value="">\u8BF7\u9009\u62E9\u5546\u6237</option></select></div></div><div class="c-form"><label class="c-form-label">\u9879\u76EE\u7F16\u53F7\uFF1A</label><div class="c-form-div wid-1000 lh30"><input type="text" class="c-input1" style="width: 80%" placeholder="\u8BF7\u8F93\u5165\u9879\u76EE\u7F16\u53F7" ng-model="vm.data.number" maxlength="20"> <button type="button" class="c-btn c-btn2 mr10" style="height: 30px" ng-click="vm.getOrder()">\u67E5\u8BE2</button></div></div><div class="c-form"><label class="c-form-label">\u9879\u76EE\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-model="vm.data.type" ng-options="data.id as data.name for data in vm.projectTypes"><option value="">\u8BF7\u9009\u62E9\u9879\u76EE\u7C7B\u578B</option></select></div></div><div class="c-form"><label class="c-form-label">\u8BA1\u5212\u4EA4\u671F\uFF1A</label><div class="c-form-div wid-1000 lh30"><div class="form-time" style="width: 100%"><input type="text" class="c-input1" ng-model="vm.expectedDate" id="startDate" placeholder="\u8BA1\u5212\u4EA4\u8D27\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\', readOnly:true, lang:\'zh-cn\', minDate:\'%y-%M-%d\'})"><div class="form-timeIcon"></div></div></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.contact" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F"></div></div><!-- <div class="c-form">\n            <label class="c-form-label">\u8054\u7CFB\u5730\u5740\uFF1A</label>\n            <div class="c-form-div wid-1000">\n                <input type="text" class="c-input1" ng-model="vm.data.address" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u5730\u5740">\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u5730\u5740:</label><div class="c-form-div wid-1000"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-1000"><textarea type="text" class="form-control-edit" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" style="resize: none" ng-model="vm.address"></textarea></div></div><div class="c-form"><label class="c-form-label">\u8FD0\u8D39\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" ng-model="vm.data.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" min="0"></div></div><div class="c-form"><label class="c-form-label">\u5907\u6CE8\uFF1A</label><div class="c-form-div wid-1000"><textarea class="c-input1" ng-model="vm.data.remarks" style="outline: none;resize: none" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div" style="width: auto"><div class="c-table1"><table><thead><tr><th>\u8BA2\u8D2D\u5546\u54C1</th><th>SKU\u7F16\u53F7</th><!-- <th>\u5546\u6237\u7F16\u53F7</th> --><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5355\u4EF7</th><th>\u5408\u8BA1</th><!-- <th>\u7A0E\u7387(%)</th> --><!-- <th>\u542B\u7A0E\u5355\u4EF7</th> --><!-- <th>\u52A0\u7A0E\u5408\u8BA1</th> --><th>\u6587\u4EF6\u4E0A\u4F20</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="productLine in vm.data.productLines track by $index"><td ng-style="{\'color\': !productLine.productNumber?\'#26B8FC\':\'\'}" ng-click="!productLine.productNumber?chooseProduct($index):\'\'" style="width: auto; outline: none">{{productLine.productName}}</td><td style="width: auto">{{productLine.productNumber}}</td><!-- <td style="width: auto;"><input type="text" class="c-input1" ng-model="productLine.lineNumber" style="border: 0;" min="0" maxlength="20"></td> --><td style="width: auto">{{productLine.unit}}</td><td style="width: auto"><input type="number" class="c-input1" ng-model="productLine.quantity" style="border: 0" min="0"></td><td style="width: auto"><input type="number" class="c-input1" ng-model="productLine.price" style="border: 0" min="0"></td><td style="width: auto"><span ng-if="!!productLine.quantity && !!productLine.price">\uFFE5{{productLine.quantity * productLine.price}}</span></td><!-- <td style="width: auto;">\n                                <input type="number" class="c-input1" ng-model="productLine.taxRate" style="border: 0;" min="0" max="100">\n                            </td> --><!-- <td style="width: auto;">\n                                <span ng-if="!!productLine.price && !!productLine.taxRate">\n                                    {{(productLine.price * productLine.taxRate / 100) + productLine.price}}\n                                </span>\n                            </td> --><!--  <td style="width: auto;">\n                                <span ng-if="!!productLine.price && !!productLine.quantity && !!productLine.taxRate">\n                                    \uFFE5{{(((productLine.price * productLine.taxRate / 100) + productLine.price) * productLine.quantity) | number : 2}}\n                                </span>\n                            </td> --><td style="width: auto"><div title="{{productLine.filePath}}">{{productLine.filePath|limitTo:\'20\'}}</div><div style="position: relative;width: 70px;display: inline-block"><button type="button" class="btn-flow" style="position: absolute;top: 3px">{{!productLine.filePath?\'\u4E0A\u4F20\u6587\u4EF6\':\'\u91CD\u65B0\u4E0A\u4F20\'}}</button> <input type="file" id="file" name="myfile" data-target="{{$index}}" onchange="uploadFile(event)" accept="application/pdf, application/zip" style="width:80px;opacity: 0"></div><div id="progress-bar" style="height: 5px; width: 0%; border-radius: 1px; background-color: #FF9A24"></div><!-- <button type="button" class="btn-flow" style="cursor: pointer;border: 0;" ng-if="productLine.filePath" ng-click="downLoadFile(productLine)">\u4E0B\u8F7D\u6587\u4EF6</button> --></td><td style="width: 80px"><button class="c-minBtn c-minBtn3" ng-click="productLineDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="8"><span ng-click="productLineNew()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u751F\u4EA7</span></td></tr></tbody></table></div></div></div><div class="mtop20"><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/project/project-order.html','<div class="bgc-fff p30"><div><span class="title1">\u8BA2\u8D2D</span></div><div class="mtop20"><!-- <div class="c-form">\n            <label class="c-form-label">\u9879\u76EE\u540D\u79F0\uFF1A</label>\n            <div class="c-form-div wid-800 lh30">\n                <input type="text" class="c-input1"ng-model="vm.data.name" disabled>\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label">\u5546\u6237\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.merchant.name" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8BA1\u5212\u4EA4\u8D27\u65E5\u671F\uFF1A</label><div class="c-form-div wid-800 lh30"><div class="c-input1" style="background: #EBEBE4">{{vm.data.expectedDate| date:\'yyyy-MM-dd\'}}</div></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.contact" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u5730\u5740\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.address" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u5730\u5740"></div></div><div class="c-form"><label class="c-form-label">\u8FD0\u8D39\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" min="0"></div></div><div class="c-form"><label class="c-form-label">\u5907\u6CE8\uFF1A</label><div class="c-form-div wid-800"><textarea class="c-input1" ng-model="vm.data.remarks" style="outline: none;resize: none" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div wid-800"><div class="c-table1"><table><thead><tr><th>\u8BA2\u8D2D\u5546\u54C1</th><th>\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5355\u4EF7</th><th>\u542B\u7A0E\u5355\u4EF7</th><th>\u91D1\u989D</th><th>\u7A0E\u7387(%)</th><th>\u52A0\u7A0E\u5408\u8BA1</th></tr></thead><tbody><tr ng-repeat="productLine in vm.data.productLines track by $index"><td>{{productLine.productName}}</td><td>{{productLine.productNumber}}</td><td>{{productLine.unit}}</td><td>{{productLine.quantity}}</td><td>{{productLine.price}}</td><td>{{productLine.taxPrice}}</td><td>{{productLine.amount}}</td><td>{{productLine.taxRate}}</td><td>{{productLine.taxAmount}}</td></tr><tr class="noData" ng-if="vm.data.productLines.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5546\u54C1\u4FE1\u606F</span></td></tr></tbody></table></div></div></div><div class="mtop20"><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="canccel()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/project/project.html','<div class="bgc-fff"><div class="table-top clearfix"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.id == vm.tableData.status}">{{data.name}}</li></ul><div class="table-state-btn" ng-click="tableStateBtn()" ng-if="vm.isTableState"><img src="content/images/arrdp.png" alt=""></div></div><div class="p30"><div class="clearfix"><span class="title1">\u9879\u76EE\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="projectAdd">\u65B0\u5EFA\u9879\u76EE</button> <button type="button" class="c-btn c-btn1" ng-click="projectEdit()">\u7F16\u8F91</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tableData.status ==\'CREATED\' ||vm.tableData.status ==\'\'" ng-click="projectSubmit()">\u63D0\u4EA4</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tableData.status ==\'SUBMITTED\' ||vm.tableData.status ==\'\'" ng-click="projectExam()">\u5BA1\u6838</button> <button type="button" class="c-btn c-btn1" ng-if="vm.tableData.status ==\'APPROVED\'||vm.tableData.status ==\'\'" ng-click="projectWithdraw()">\u64A4\u56DE</button> <button type="button" class="c-btn c-btn1" ng-click="projectClose()">\u5173\u95ED</button> <button type="button" class="c-btn c-btn1" ng-click="projectOrder()">\u8BA2\u8D2D</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22\u3002" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center"><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th style="text-align: center">\u9879\u76EE\u7F16\u53F7</th><!-- <th style="text-align: center;">\u9879\u76EE\u540D\u79F0</th> --><th style="text-align: center">\u9879\u76EE\u72B6\u6001</th><th style="text-align: center">\u9879\u76EE\u7C7B\u578B</th><th style="text-align: center">\u5546\u6237</th><th style="text-align: center">\u521B\u5EFA\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="data in vm.projects" ng-if="vm.projects.length > 0"><td style="text-align: center"><input type="checkbox" ng-model="data.checked" ng-click="selectOne(data)"></td><td ui-sref="projectDetail({\n                        id:data.id,\n                        page: vm.tableData.page,\n                        keyword:vm.tableData.keyword})" style="cursor: pointer; text-align: center"><a>{{data.number}}</a></td><!-- <td style="text-align: center;">{{data.name}}</td> --><td style="text-align: center">{{data.status == \'CREATED\'?\'\u672A\u63D0\u4EA4\':data.status == \'SUBMITTED\'?\'\u5F85\u5BA1\u6838\':data.status == \'APPROVED\'?\'\u5BA1\u6838\u901A\u8FC7\':data.status == \'CANCELLED\'?\'\u5DF2\u64A4\u9500\':data.status == \'CLOSED\'?\'\u9879\u76EE\u5173\u95ED\':data.status == \'REJECTED\'?\'\u5DF2\u9A73\u56DE\':data.status == \'ORDERED\'?\'\u5DF2\u8BA2\u8D2D\':\'\'}}</td><td style="text-align: center">{{data.type ==\'Proofing\'?\'\u6253\u6837\':data.type ==\'Standard\'?\'\u6807\u51C6\':\'\'}}</td><td style="text-align: center">{{data.merchant.name}}</td><td style="text-align: center">{{data.lastModifiedDate| date:\'yyyy-MM-dd\'}}</td></tr><tr class="noData" ng-if="vm.projects.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><!--\u786E\u8BA4\u63D0\u4EA4--><div class="modal fade" id="submitModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog" style="width: 400px"><div class="modal-content"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="width: 30px;height: 30px">&times;</button> <span class="title1" style="margin: 20px">\u786E\u8BA4\u63D0\u4EA4</span><div class="mtop20"><div class="c-form mtop20"><div class="wid_100%"><button type="button" class="c-btn c-btn1 wid-130" style="margin-left: 20px" ng-disabled="vm.isSaving" ng-click="confirmSubmit()">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancelModal()">\u53D6\u6D88</button></div></div></div></div></div></div><!--\u8BA2\u5355\u5BA1\u6838--><div class="modal fade" id="examModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog" style="width: 400px"><div class="modal-content"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="width: 30px;height: 30px">&times;</button> <span class="title1" style="margin: 20px">\u8BA2\u5355\u5BA1\u6838</span><div class="mtop20"><div class="c-form mtop20"><div class="wid_100%"><button type="button" class="c-btn c-btn1 wid-130" style="margin-left: 20px" ng-disabled="vm.isSaving" ng-click="confirmExam()">\u901A\u8FC7</button> <button type="button" class="c-btn c-btn2" ng-click="rejectExam()">\u9A73\u56DE</button></div></div></div></div></div></div><!--\u8BA2\u5355\u64A4\u56DE--><div class="modal fade" id="withdrawModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog" style="width: 400px"><div class="modal-content"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="width: 30px;height: 30px">&times;</button> <span class="title1" style="margin: 20px">\u8BA2\u5355\u64A4\u56DE</span><div class="mtop20"><div class="c-form mtop20"><div class="wid_100%"><button type="button" class="c-btn c-btn1 wid-130" style="margin-left: 20px" ng-disabled="vm.isSaving" ng-click="confirmWithdraw()">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancelModal()">\u53D6\u6D88</button></div></div></div></div></div></div><!--\u8BA2\u5355\u5173\u95ED--><div class="modal fade" id="closeModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog" style="width: 400px"><div class="modal-content"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="width: 30px;height: 30px">&times;</button> <span class="title1" style="margin: 20px">\u8BA2\u5355\u5173\u95ED</span><div class="mtop20"><div class="c-form mtop20"><div class="wid_100%"><button type="button" class="c-btn c-btn1 wid-130" style="margin-left: 20px" ng-disabled="vm.isSaving" ng-click="confirmClose()">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancelModal()">\u53D6\u6D88</button></div></div></div></div></div></div>');
$templateCache.put('app/purchase/purchaseOrder-edit.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1" ng-if="!vm.purchaseOrder.id">\u65B0\u5EFA\u91C7\u8D2D\u5355</span> <span class="title1" ng-if="vm.purchaseOrder.id">\u91C7\u8D2D\u5355\u8BE6\u60C5</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label control-label font-style">\u4F9B\u5E94\u5546</label><div class="c-form-div" style="width: 900px"><select id="supplier" class="c-select1" ng-model="vm.purchaseOrder.supplierId" ng-options="supplier.id as supplier.name for supplier in vm.suppliers" ng-change="getSupplier()" ng-if="vm.update"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select><span ng-if="!vm.update">{{vm.purchaseOrder.supplierName}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u7C7B\u578B</label><div class="c-form-div" style="width: 900px"><select class="c-select1" ng-model="vm.purchaseOrder.type" ng-options="type.value as type.name for type in vm.types" ng-change="selectStatus()" ng-if="vm.update"><option value="">\u8BF7\u9009\u62E9\u91C7\u8D2D\u7C7B\u578B</option></select><span ng-if="!vm.update">{{vm.purchaseOrder.type == \'Outsourcing\' ? \'\u6210\u54C1\u91C7\u8D2D\' : (vm.purchaseOrder.type == \'RawMaterial\' ? \'\u6750\u6599\u91C7\u8D2D\' : \'\u672A\u77E5\')}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8BA1\u5212\u4EA4\u671F</label><div class="c-form-div" style="width: 900px"><div class="form-time" style="width: 900px" ng-if="vm.update"><input type="text" class="c-input1" ng-model="vm.deliveryDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u8BA1\u5212\u4EA4\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\', readOnly:true, lang:\'zh-cn\', minDate:\'%y-%M-%d\'})"><div class="form-timeIcon"></div></div><span ng-if="!vm.update">{{vm.deliveryDate | date:\'yyyy-MM-dd\'}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9ED8\u8BA4\u5165\u5E93</label><div class="c-form-div" style="width: 900px"><select class="c-select1" ng-model="vm.purchaseOrder.warehouseId" ng-options="warehouse.id as warehouse.name for warehouse in vm.warehousis" ng-change="vm.getWarehouse(purchaseProductLine)" ng-if="vm.update"><option value="">\u8BF7\u9009\u62E9\u9ED8\u8BA4\u5165\u5E93</option></select><span ng-if="!vm.update">{{vm.purchaseOrder.warehouseName}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8054\u7CFB\u4EBA</label><div class="c-form-div" style="width: 900px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.contacts" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.contacts}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8054\u7CFB\u65B9\u5F0F</label><div class="c-form-div" style="width: 900px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.phone}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u6536\u8D27\u5730\u5740</label><div class="c-form-div" style="width: 900px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.address" placeholder="\u8BF7\u8F93\u5165\u6536\u8D27\u5730\u5740" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.address}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8FD0\u8D39</label><div class="c-form-div" style="width: 900px"><input type="number" class="c-input1" ng-model="vm.purchaseOrder.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" min="0" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.freight | currency}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u4FE1\u606F</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th style="min-width: 120px">\u91C7\u8D2D\u5546\u54C1</th><th>\u5546\u54C1SKU</th><th>scm\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u6570\u91CF</th><th>\u5355\u4EF7</th><th>\u5408\u8BA1</th><th>\u7A0E\u7387(%)</th><th>\u542B\u7A0E\u5355\u4EF7</th><th>\u52A0\u7A0E\u5408\u8BA1</th><th ng-if="vm.purchaseOrder.status != \'New\' && vm.purchaseOrder.status != \'ToBeAudited\'">\u5165\u5E93\u6570\u91CF</th><th ng-if="vm.update">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.purchaseProductLines track by $index" ng-if="vm.update && !purchaseProductLine.cancelled"><td style="padding: 0"><select-view ng-if="vm.products" ng-model="purchaseProductLine.productId" label-key="name" value-key="id" ng-change="selectPurchaseProduct(purchaseProductLine)" options="vm.products" is-search="true"></select-view></td><td style="padding: 0"><select-view ng-if="purchaseProductLine.propertyConfigs" ng-model="purchaseProductLine.propertyConfigId" label-key="sku" value-key="id" ng-change="selectPurchaseProductSku(purchaseProductLine,$index)" options="purchaseProductLine.propertyConfigs" is-search="true"></select-view></td><td>{{purchaseProductLine.propertyConfigNumber}}</td><td style="padding: 0; width: 80px">{{purchaseProductLine.measurementName}}</td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.num" style="border: 0" min="0" ng-change="numChange(purchaseProductLine)"></td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.price" ng-change="currentItemChange(purchaseProductLine)" style="border: 0" min="0"></td><td style="padding: 0; width: 80px">{{purchaseProductLine.num * purchaseProductLine.price | currency}}</td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-change="currentItemChange(purchaseProductLine)" ng-model="purchaseProductLine.tax" style="border: 0" min="0"></td><td style="padding: 0; width: 80px">\uFFE5{{purchaseProductLine.taxPrice}}</td><td style="padding: 0; width: 100px">{{purchaseProductLine.taxTotal | currency}}</td><td style="padding: 0; width: 80px" ng-if="vm.purchaseOrder.status != \'New\' && vm.purchaseOrder.status != \'ToBeAudited\'"><input type="number" class="c-input1" ng-model="purchaseProductLine.warehousingNum" style="border: 0" min="0"></td><td style="width: 100px; max-width: 100px; min-width: 100px"><button type="button" class="btn-flow" ng-click="vm.productDelete(purchaseProductLine,$index)">\u5220\u9664</button></td></tr><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.purchaseProductLines track by $index" ng-if="!vm.update && !purchaseProductLine.cancelled"><td>{{purchaseProductLine.productName}}</td><td>{{purchaseProductLine.propertyConfigSku}}</td><td>{{purchaseProductLine.propertyConfigNumber}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.measurementName}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.num}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">\uFFE5{{purchaseProductLine.price}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.total | currency}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.tax}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">\uFFE5{{purchaseProductLine.taxPrice }}</td><td style="width: 100px;min-width: 100px;max-width: 100px">{{purchaseProductLine.taxTotal | currency}}</td><td style="width: 200px; max-width: 200px; min-width: 200px" ng-if="vm.purchaseOrder.status != \'New\' && vm.purchaseOrder.status != \'ToBeAudited\'"><input type="number" class="c-input1" ng-model="purchaseProductLine.warehousingNum" style="border: 0" min="0" ng-if="vm.purchaseOrder.status == \'AlreadyIssued\'"> <span ng-if="vm.purchaseOrder.status == \'Finished\' || vm.purchaseOrder.status == \'Close\'">{{purchaseProductLine.warehousingNum || 0}}</span></td></tr><tr ng-if="vm.update"><td colspan="11"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="vm.productAdd()"><i></i>\u65B0\u5EFA\u5546\u54C1</button></td></tr></tbody></table></div></div></div><div class="c-form" ng-if="vm.returnLines.length > 0"><label class="c-form-label control-label font-style">\u9000\u8D27\u6C47\u603B</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table style="width: 50%"><thead><tr><th style="min-width: 40px">\u5E8F\u53F7</th><th>\u9000\u8D27\u6570\u91CF</th><th>\u9000\u8D27\u5408\u8BA1</th><th>\u5173\u8054\u9000\u8D27\u5355</th></tr></thead><tbody><tr ng-repeat="data in vm.returnLines track by $index" ng-if="!vm.update && !data.cancelled"><td>{{$index + 1}}</td><td>{{data.quantity}}</td><td>{{data.amount}}</td><td ng-if="vm.hasReturnBtnAuth"><span style="color: blue;cursor: pointer" ui-sref="purchaseReturnOrderEdit({id:data.id})">{{data.number}}</span></td><td ng-if="!vm.hasReturnBtnAuth"><span style="color: blue;cursor: pointer">{{data.number}}</span></td></tr><tr><td>\u603B\u8BA1</td><td>{{vm.returnTotalCount}}</td><td>{{vm.returnTotalAmount}}</td><td></td></tr></tbody></table></div></div></div><div class="c-form"><div class="c-form-div" style="width: auto"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'New\' || vm.purchaseOrder.status == \'AlreadyIssued\'">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1" ng-click="save(true)" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'New\'">\u4FDD\u5B58\u5E76\u63D0\u4EA4</button> <button type="button" class="c-btn c-btn1" ng-click="close()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'New\' && vm.purchaseOrder.id">\u5173\u95ED\u91C7\u8D2D</button> <button type="button" class="c-btn c-btn1" ng-click="audit(true)" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'ToBeAudited\'">\u901A\u8FC7</button> <button type="button" class="c-btn c-btn1" ng-click="audit()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'ToBeAudited\'">\u62D2\u7EDD</button> <button type="button" class="c-btn c-btn1" ng-click="constraint()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'AlreadyIssued\' || vm.purchaseOrder.status == \'Store\'">\u5B8C\u6210\u5165\u5E93</button> <button type="button" class="c-btn c-btn1" ui-sref="purchaseReturnOrderAdd({purchaseOrderId:vm.purchaseOrder.id})" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'Finished\' && vm.hasReturnBtnAuth">\u751F\u6210\u9000\u8D27\u5355</button> <button type="button" class="c-btn c-btn1" ng-click="export()" ng-if="vm.purchaseOrder.id">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn2" ng-click="cancelSave()">\u8FD4\u56DE</button></div></div></div></div><style>.c-form-div{\n        line-height: 30px;\n    }</style>');
$templateCache.put('app/purchase/purchaseOrder-preview.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u91C7\u8D2D\u5355\u9884\u89C8</span> <button type="button" class="c-btn c-btn1" ng-click="preview()">\u6253\u5370\u9884\u89C8</button> <button type="button" class="c-btn c-btn2" ng-click="goback()">\u8FD4\u56DE</button></div><div class="mtop20" id="previewId" style="box-shadow: 0 0 24px 0 rgba(0, 0, 0, .2); padding: 50px"><div style="font-size: 30px;font-weight: bold; height: 80px; border-bottom: 1px solid #ddd; text-align: center; color: #333; margin-bottom: 40px">MOMENTSGO\u91C7\u8D2D\u5355</div><div style="display: flex;flex-wrap: wrap"><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u4F9B\u5E94\u5546:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.supplierName}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u7C7B\u578B:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.type == \'Outsourcing\' ? \'\u6210\u54C1\u91C7\u8D2D\' : (vm.purchaseOrder.type == \'RawMaterial\' ? \'\u6750\u6599\u91C7\u8D2D\' : \'\u672A\u77E5\')}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u5165\u5E93\u65E5\u671F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.storedDate | date:\'yyyy-MM-dd\'}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.number}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u5B58\u5165\u4ED3\u5E93:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.warehouseName}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u8054\u7CFB\u4EBA:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.contacts}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u8BA1\u5212\u4EA4\u671F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.deliveryDate | date:\'yyyy-MM-dd\'}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u8054\u7CFB\u65B9\u5F0F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.phone}}</div></div><div class="c-form" style="width: 100%"><label class="c-form-label control-label font-style">\u6536\u8D27\u5730\u5740:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.address}}</div></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u5546\u54C1\u4FE1\u606F:</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th>\u91C7\u8D2D\u5546\u54C1</th><th>\u5546\u54C1SKU</th><th>scm\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u5355\u4EF7</th><th>\u5408\u8BA1</th><th>\u542B\u7A0E\u5355\u4EF7</th><th>\u7A0E\u7387(%)</th><th>\u52A0\u7A0E\u5408\u8BA1</th></tr></thead><tbody><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.purchaseProductLines track by $index" ng-if="!purchaseProductLine.cancelled"><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.productName}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.propertyConfigSku}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.propertyConfigNumber}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.measurementName}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.num}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">\uFFE5{{purchaseProductLine.price || 0}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.total | currency}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">\uFFE5{{purchaseProductLine.taxPrice || 0}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.tax}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.taxTotal| currency}}</td></tr></tbody></table></div></div></div><div style="text-align: right; font-size: 18px; color: #333; line-height: 30px"><div style="width: 200px; display: inline-block;text-align: left">\u5546\u54C1\u5408\u8BA1\uFF1A{{(vm.purchaseOrder.amount - vm.purchaseOrder.freight) | currency}}</div><br><div style="width: 200px; display: inline-block;text-align: left">\u8FD0\u8D39\u5408\u8BA1\uFF1A{{vm.purchaseOrder.freight | currency}}</div></div><div style="text-align: right; font-size: 18px; color: #000; border-top: 1px solid #ddd; margin-top: 30px; padding-top: 30px"><div style="width: 200px; display: inline-block;text-align: left">\u91C7\u8D2D\u603B\u989D\uFF1A{{vm.purchaseOrder.amount | currency}}</div></div></div></div>');
$templateCache.put('app/purchase/purchaseOrder.html','<div class="bgc-fff"><div class="bgc-fff"><div class="table-top clearfix"><ul class="clearfix table-state"><li ng-repeat="data in vm.selection track by $index" ng-click="conditionSelect(data)" ng-class="data.value == vm.tableData.status ?\'pitchOn\':\'\'">{{data.name}}</li></ul><div class="table-state-btn" ng-click="tableStateBtn()" ng-if="vm.isTableState"><img src="content/images/arrdp.png" alt=""></div></div><div class="p30"><div class="clearfix"><span class="title1">\u91C7\u8D2D\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="purchaseProductLineAdd">\u65B0\u5EFA\u91C7\u8D2D</button> <button type="button" class="c-btn c-btn1" ng-click="export()">\u5BFC\u51FA\u7EDF\u8BA1\u8868</button> <button type="button" class="c-btn c-btn1" ng-click="exportDetails()">\u5BFC\u51FA\u660E\u7EC6\u8868</button></div><div class="form-search2 mtop20"><ul class="clearfix"><li><p>\u91C7\u8D2D\u5355\u53F7</p><div class="form-search2-term"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.number"></div></li><li><p>\u65E5\u671F\u7C7B\u578B</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.dateType"><option value="purchase">\u91C7\u8D2D\u65E5\u671F</option><option value="store">\u5165\u5E93\u65E5\u671F</option></select></div></li><li><p>\u9009\u62E9\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u5168\u90E8</option></select></div></li><li><p>\u9ED8\u8BA4\u5165\u5E93</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="data.id as data.name for data in vm.warehouses"><option value="">\u5168\u90E8</option></select></div></li><li><p></p><div class="form-search2-term"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></li></ul></div><div class="c-table mtop20 scrollbar-main"><table style="width: 2300px; overflow-x: auto" class="purchaseProductLine-table"><thead><tr><th>\u91C7\u8D2D\u5355\u53F7</th><th>\u91C7\u8D2D\u7C7B\u578B</th><th>\u91C7\u8D2D\u603B\u4EF7</th><th>\u91C7\u8D2D\u603B\u91CF</th><th>\u5165\u5E93\u6570\u91CF</th><th style="width: 130px;max-width: 130px;min-width: 130px">\u5B9E\u9645\u5165\u5E93\u91D1\u989D</th><th>\u9ED8\u8BA4\u5165\u5E93</th><th>\u4F9B\u5E94\u5546</th><th>\u72B6\u6001</th><th>\u5907\u6CE8</th><th>\u64CD\u4F5C\u5458</th><th>\u91C7\u8D2D\u65F6\u95F4</th><th>\u8BA1\u5212\u4EA4\u671F</th><th>\u6700\u540E\u4FEE\u6539</th><th>\u5165\u5E93\u65E5\u671F</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 150px;max-width: 150px;min-width: 150px">{{data.number}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.type == \'Outsourcing\' ? \'\u6210\u54C1\u91C7\u8D2D\' : (data.type == \'RawMaterial\' ? \'\u6750\u6599\u91C7\u8D2D\' : \'\u672A\u77E5\')}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.amount | currency}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.num}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.warehouseNum}}</td><td style="width: 130px;max-width: 130px;min-width: 130px">{{data.warehouseAmount | currency}}</td><td style="width: 200px;max-width: 200px;min-width: 200px">{{data.warehouseName}}</td><td style="width: 200px;max-width: 200px;min-width: 200px">{{data.supplierName}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" ng-style="purchaseOrderType(data.status)" ng-if="!data.cancelled">{{purchaseOrderType(data.status).text}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" ng-if="data.cancelled">\u5DF2\u5173\u95ED</td><td style="width: 200px;max-width: 200px;min-width: 200px">{{data.remark}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.operator}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.createdDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.deliveryDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.lastModifiedDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.storedDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px"><button class="c-minBtn c-minBtn1" ui-sref="purchaseProductLineEdit1({id:data.id})" ng-if="data.status == \'New\' && !data.cancelled">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ui-sref="purchaseProductLineEdit1({id:data.id})" ng-if="data.status != \'New\' && !data.cancelled">\u8BE6\u60C5</button> <button class="c-minBtn c-minBtn3" ui-sref="purchasePreview({id:data.id})" ng-if="!data.cancelled">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="20" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table><!--            <table style="width: 2300px; overflow-x: auto;">--><!--                <thead>--><!--                <tr>--><!--                    <th>\u91C7\u8D2D\u8BA2\u5355</th>--><!--                    <th>\u91C7\u8D2D\u5546\u54C1</th>--><!--                    <th>\u91C7\u8D2D\u7C7B\u578B</th>--><!--                    <th>\u91C7\u8D2D\u72B6\u6001</th>--><!--                    <th>\u4F9B\u5E94\u5546</th>--><!--                    <th>\u91C7\u8D2D\u65F6\u95F4</th>--><!--                    <th>\u8BA1\u5212\u4EA4\u671F</th>--><!--                    <th>\u5355\u4F4D</th>--><!--                    <th>\u8BA2\u8D2D\u6570\u91CF</th>--><!--                    <th>\u5165\u5E93\u6570\u91CF</th>--><!--                    <th>\u5355\u4EF7</th>--><!--                    <th>\u5408\u8BA1</th>--><!--                    <th>\u542B\u7A0E\u5355\u4EF7</th>--><!--                    <th>\u7A0E\u7387\uFF08%\uFF09</th>--><!--                    <th>\u7A0E\u989D</th>--><!--                    <th>\u52A0\u7A0E\u5408\u8BA1</th>--><!--                    <th>\u8FD0\u8D39</th>--><!--                    <th>\u91C7\u8D2D\u603B\u4EF7</th>--><!--&lt;!&ndash;                    <th>\u9ED8\u8BA4\u5165\u5E93</th>&ndash;&gt;--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0">--><!--                    <td style="width: 150px;max-width: 150px;min-width: 150px;">{{data.purchaseOrderNumber}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.propertyConfig.sku}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.status == \'Outsourcing\' ? \'\u6210\u54C1\u91C7\u8D2D\' : (data.status == \'RawMaterial\' ? \'\u6750\u6599\u91C7\u8D2D\' : \'\u672A\u77E5\')}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.state == \'Finished\' ? \'\u5B8C\u6210\' : (data.state == \'New\' ? \'\u65B0\u5EFA\' : (data.state == \'ToBeAudited\' ? \'\u5F85\u5BA1\u6838\' : (data.state == \'ToBeRevised\' ? \'\u5F85\u4FEE\u8BA2\' : (data.state == \'AlreadyIssued\' ? \'\u5DF2\u4E0B\u8FBE\' : \'\u672A\u77E5\'))))}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.supplierName}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.createdDate | date:\'yyyy-MM-dd\'}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.deliveryDate | date:\'yyyy-MM-dd\'}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.measurement.name}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.num}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.warehousingNum}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.price | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.total | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.taxPrice | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.tax}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.num * data.taxPrice | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.taxTotal | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.freight | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.taxTotal + data.freight | currency}}</td>--><!--&lt;!&ndash;                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.warehouseName}}</td>&ndash;&gt;--><!--                </tr>--><!--                <tr class="noData" ng-if="vm.tableList.length == 0">--><!--                    <td colspan="20" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td>--><!--                </tr>--><!--                </tbody>--><!--            </table>--></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><style>.purchaseProductLine-table{\n        tr td:last-child, th:last-child {\n            position: sticky;\n            right: 0px;\n            background: #fff;\n        }\n    }</style></div>');
$templateCache.put('app/purchase/purchasingApplication.html','<div class="bgc-fff"><div class="p30"><div class="clearfix"><span class="title1">\u91C7\u8D2D\u9700\u6C42\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="toExamine()">\u5BA1\u6838</button> <button type="button" class="c-btn c-btn1" ng-click="submission()">\u8F6C\u91C7\u8D2D\u5355</button> <button type="button" class="c-btn c-btn1" ng-click="cancelledBtn()">\u53D6\u6D88\u9700\u6C42</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><div class="pull-left"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select1" style="width: 100%" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()"><option value="">\u5168\u90E8</option></select></div></div><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22\u3002" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20 scrollbar-main"><table style="overflow-x: auto"><thead><tr><th><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th>\u91C7\u8D2D\u9700\u6C42\u7F16\u53F7</th><th>\u91C7\u8D2D\u7C7B\u578B</th><th>\u5546\u54C1\u540D\u79F0</th><th>sku\u540D\u79F0</th><th>\u9ED8\u8BA4\u5165\u5E93</th><th>\u5E93\u5B58</th><th>\u9700\u6C42\u72B6\u6001</th><th>\u521B\u5EFA\u65F6\u95F4</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0" ng-click="selectOne1($event,data)"><td><input type="checkbox" ng-model="data.checked" ng-click="selectOne($event,data)"></td><td>{{data.number}}</td><td>{{data.status == \'Outsourcing\' ? \'\u6210\u54C1\u9700\u6C42\' : (data.status == \'RawMaterial\' ? \'\u6750\u6599\u9700\u6C42\' : \'\u672A\u77E5\')}}</td><td>{{data.productName}}</td><td>{{data.propertyConfigSku}}</td><td>{{data.warehouseName}}</td><td>{{data.warehouseNum}}</td><td>{{stateInfo(data.state)}}</td><td>{{data.createdDate | date:\'medium\'}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="20" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><!--\u5BA1\u6838\u5F39\u7A97--><div class="modal fade" id="submitModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog" style="width: 400px"><div class="modal-content"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="width: 30px;height: 30px">&times;</button> <span class="title1" style="margin: 20px">{{vm.messageStr}}</span><div class="mtop20"><div class="c-form mtop20"><div class="wid_100%"><button type="button" class="c-btn c-btn1 wid-130" style="margin-left: 20px" ng-click="confirmSubmit()">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancelModal()">\u53D6\u6D88</button></div></div></div></div></div></div>');
$templateCache.put('app/purchase/purchasingApplicationPage.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u91C7\u8D2D\u9700\u6C42\u8BE6\u60C5</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label control-label font-style">\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div lh30">{{vm.purchaseOrder.supplierName}}</div></div><div class="c-form"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u7C7B\u578B\uFF1A</label><div class="c-form-div lh30">{{vm.purchaseOrder.status == \'Outsourcing\' ? \'\u6210\u54C1\u91C7\u8D2D\' : \'\u6750\u6599\u91C7\u8D2D\'}}</div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9ED8\u8BA4\u5165\u5E93\uFF1A</label><div class="c-form-div lh30">{{vm.purchaseOrder.warehouseName}}</div></div><div class="c-form"><label class="c-form-label control-label font-style">\u5546\u54C1\u4FE1\u606F\uFF1A</label><div class="c-form-div" style="width: 900px"><div class="c-table1"><table><thead><tr><th>\u91C7\u8D2D\u5546\u54C1</th><th>\u5546\u54C1SKU</th><th>\u5355\u4F4D</th></tr></thead><tbody><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.purchaseProductLines track by $index"><td>{{purchaseProductLine.product.name}}</td><td>{{purchaseProductLine.propertyConfig.sku}}</td><td>{{purchaseProductLine.product.measurementName}}</td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label control-label font-style"></label><div class="c-form-div" style="width: 900px"><button type="button" class="c-btn c-btn2" ng-click="cancelSave()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/purchase/toExamine.html','<div class="bg-content"><div class="bg-center" style="width: 600px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u91C7\u8D2D\u5BA1\u6838</span> <span style="float: right" ng-click="cancelTask()" title="\u5173\u95ED">X</span></div><div class="mtop20"><div class="c-form"><div class="c-form-div" style="width: 400px">\u8BF7\u786E\u8BA4\u662F\u5426\u5BA1\u6838 {{vm.purchaseOrderList.length}} \u4E2A\u8BA2\u5355\uFF1F</div></div><div class="c-form"><div class="wid_100" style="padding-left: 10px; margin-bottom: 20px"><button type="button" class="c-btn c-btn1 wid-130" ng-click="confirmBtn()">\u901A\u8FC7</button> <button type="button" class="c-btn c-btn1 wid-130" ng-click="refuse()">\u62D2\u7EDD</button></div></div></div></div></div>');
$templateCache.put('app/purchase/warehousing.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u91C7\u8D2D\u5165\u5E93</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u91C7\u8D2D\u5546\u54C1\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="text" class="c-input1" ng-model="vm.purchaseOrderList.propertyConfigSku" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B58\u5165\u4ED3\u5E93\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.warehouseName" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B58\u5165\u6570\u91CF\uFF1A</label><div class="c-form-div" style="width: 400px"><input type="number" class="c-input1" ng-model="vm.warehousingNum" value="0"><div ng-if="vm.purchaseOrderList.num < (vm.purchaseOrderList.warehousingNum + vm.warehousingNum)" style="color: #d92424">*\u586B\u5199\u7684\u5B58\u5165\u6570\u91CF\u8D85\u8FC7\u672A\u5165\u5E93\u6570\u91CF\uFF0C\u5982\u786E\u8BA4\u65E0\u8BEF\u53EF\u7EE7\u7EED\u767B\u8BB0\u5165\u5E93\u3002</div></div></div><div class="c-form mtop20"><div class="wid_100" style="padding-left: 10px"><button type="button" class="c-btn c-btn1 mr10 wid-130" ng-click="saveNum()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelTask()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/reserveUpload/importStock-upload-list.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u5E93\u5B58\u5BFC\u5165</span></div><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"></div><span class="input-group-btn width-min btn-clear"><button class="c-btn c-btn1" style="margin: 20px 0 10px" ng-click="vm.loadAll()"><span>\u6279\u91CF\u5BFC\u5165</span></button></span></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.reverse" ascending="vm.reverse" callback="vm.transition()"><th><span>\u5546\u54C1\u7F16\u53F7</span></th><th><span>\u5546\u54C1\u540D\u79F0</span></th><th><span>SKU\u7F16\u53F7</span></th><th><span>\u6570\u91CF</span></th><!-- <th><span>\u6700\u5C0F\u5E93\u5B58\u91CF</span></th> --><th><span>\u72B6\u6001</span></th><th><span>\u4FE1\u606F</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="branchStore in vm.branchStores"><td style="display: table-cell; vertical-align: middle">{{ branchStore.productNumber }}</td><td style="display: table-cell; vertical-align: middle">{{branchStore.productName}}</td><td style="display: table-cell; vertical-align: middle">{{branchStore.skuNumber}}</td><td style="display: table-cell; vertical-align: middle">{{branchStore.quantity}}</td><!-- <td style="display: table-cell; vertical-align: middle;">{{branchStore.minQuantity}}</td> --><td style="display: table-cell; vertical-align: middle"><span ng-style="{color: branchStore.success ? \'green\' : \'red\'}">{{branchStore.success?\'\u4E0A\u4F20\u6210\u529F\':\'\u4E0A\u4F20\u5931\u8D25\' }}</span></td><td style="display: table-cell; vertical-align: middle"><span ng-style="{color: branchStore.success ? \'green\' : \'red\'}">{{branchStore.message }}</span></td></tr></tbody></table></div></div><div style="padding-top: 10px"><button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div>');
$templateCache.put('app/reserveUpload/importStock-upload.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1 pull-left">\u4E0A\u4F20\u5E93\u5B58\u4FE1\u606F\u6587\u4EF6</span></div><div class="c-model-body"><div class="c-form width-100p"><div class="c-form-label">\u6570\u636E\u6587\u4EF6:</div><div class="c-form-div" style="width: auto"><input type="file" id="fileId" name="file" class="form-control border-radius" type="file" accept=".xlsx, .xls" ng-model-options="{debounce : 500}"></div></div></div><div class="c-model-foot" style="padding: 20px;border-top: 1px solid #ddd"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn1 mr10" ng-click="vm.clear()" ng-disabled="vm.isSaving">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/stockManagement/stock-edit.html','<div id="printPage" style="position: relative"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div"><div class="clearfix"><span class="title1">\u76D8\u70B9\u5355\u8BE6\u60C5</span></div><div class="orderDetailsRow mtop20"><div class="orderDetails1"><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title stock-detail-title">\u4ED3\u5E93</span><!-- <div class="orderDetails-text">{{vm.data.warehouseName}}</div> --><div class="orderDetails-text">{{vm.warehouse.name}}</div></li><li class="col-xs-3 p0"><span class="orderDetails-title stock-detail-title">\u4ED3\u5E93\u7C7B\u578B</span><!-- <p class="orderDetails-text">{{vm.data.warehouseType == \'product\' ? \'\u6210\u54C1\u5E93\' : (vm.data.warehouseType == \'accessories\' ? \'\u539F\u8F85\u6750\u6599\u5E93\' : \'\u672A\u77E5\')}}</p> --><p class="orderDetails-text">{{vm.warehouse.type == \'product\' ? \'\u6210\u54C1\u5E93\' : (vm.warehouse.type == \'accessories\' ? \'\u539F\u8F85\u6750\u6599\u5E93\' : \'\u672A\u77E5\')}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title stock-detail-title">\u64CD\u4F5C\u5458</span><p class="orderDetails-text">{{vm.data.operator}}</p></li><li class="col-xs-3 p0"><span class="orderDetails-title stock-detail-title">\u72B6\u6001</span><p class="orderDetails-text">{{getStatus(vm.data.status)}}</p></li><ul class="row" style="margin: 0"><li class="col-xs-3 p0"><span class="orderDetails-title stock-detail-title">\u5907\u6CE8</span><div ng-if="vm.data.status != \'INPROGRESS\'" class="orderDetails-text">{{vm.data.remarks}}</div><textarea ng-if="vm.data.status == \'INPROGRESS\'" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8" ng-model="vm.data.remarks" max="100" min="0" style="height: 60px!important;resize: none;width: 700px"></textarea></li></ul></ul></div></div></div></div></div><div style="background-color: #fff;display: flex;justify-content: space-between;padding: 0 30px 10px"><button type="button" ng-if="vm.data.status == \'INPROGRESS\'" class="c-btn c-btn1 printHide stock-detail-btn" id="printHide1" ng-click="productAdd()">\u6DFB\u52A0\u5546\u54C1</button><div ng-if="vm.data.status != \'INPROGRESS\'"><button type="button" class="c-btn c-btn1" ng-click="export()">\u5BFC\u51FA</button></div><div style="display: flex;align-items: center"><input type="text" ng-model="vm.keyword" placeholder="\u8F93\u5165SKU\u7F16\u53F7\u67E5\u627E" class="stock-detail-searchInput"> <button type="button" class="c-btn c-btn1 printHide stock-detail-btn" id="printHide1" ng-click="search()">\u641C\u7D22</button> <button type="button" class="c-btn c-btn2 printHide stock-detail-btn" id="printHide1" ng-click="reset()">\u91CD\u7F6E</button></div></div><div class="bgc-fff p30" style="padding-top: 0"><div><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>SKU</th><th>SKU\u7F16\u53F7</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th ng-if="vm.data.status == \'FINISHED\'">\u76D8\u70B9\u524D</th><th>\u5B9E\u9645\u6570\u91CF</th><th ng-if="vm.data.status == \'FINISHED\'">\u5DEE\u91CF</th><th>\u5907\u6CE8</th><th ng-if="vm.data.status == \'INPROGRESS\'">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.lines track by $index" ng-class="[\'productItem-{{$index}}\']"><td ng-class="vm.searchSkuNumer == $index ? \'stock-product-item-active\'  : \'\' ">{{$index+1}}</td><td>{{data.productName}}</td><td>{{data.sku}}</td><td>{{data.skuNumber}}</td><td>{{data.unit}}</td><td>{{data.price | currency}}</td><td ng-if="vm.data.status == \'FINISHED\'">{{data.beforeQuantity}}</td><td><input ng-if="vm.data.status == \'INPROGRESS\'" maxlength="50" placeholder="\u8BF7\u8F93\u5165" type="number" class="c-input1" ng-model="data.quantity"> <span ng-if="vm.data.status !==\'INPROGRESS\'">{{data.quantity}}</span></td><td ng-if="vm.data.status == \'FINISHED\'">{{data.quantity - data.beforeQuantity}}</td><td><input ng-if="vm.data.status == \'INPROGRESS\'" maxlength="50" placeholder="\u8BF7\u8F93\u5165" type="text" class="c-input1" ng-model="data.remarks"> <span ng-if="vm.data.status !== \'INPROGRESS\'">{{data.remarks}}</span></td><td ng-if="vm.data.status == \'INPROGRESS\'" style="width: 100px; max-width: 100px; min-width: 100px"><button type="button" class="btn-flow" ng-click="productDelete($index)">\u79FB\u9664</button></td></tr></tbody></table></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status == \'INPROGRESS\'" ng-click="save()">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-if="vm.data.status == \'INPROGRESS\'" ng-click="save(true)">\u76D8\u70B9\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-if="vm.data.status == \'INPROGRESS\' && vm.data.id" ng-click="close()">\u5173\u95ED</button> <button type="button" class="c-btn c-btn2 printHide" id="printHide1" ng-click="clear()">\u8FD4\u56DE</button></div></div></div><style>.stock-detail-title{\n        font-size: 12px!important\n    }\n    .stock-detail-btn{\n        padding: 0 16px !important;\n        color: #000 !important;\n        height: 30px !important;\n        margin-left: 10px;\n    }\n    .stock-detail-searchInput{\n        width: 200px;\n        height: 30px;\n        border: 1px solid #ddd;\n    }\n    .stock-product-item-active{\n        background-color: #ff9601;\n    }</style>');
$templateCache.put('app/stockManagement/stock.html','<div class="bgc-fff"><div class="bgc-fff"><div class="table-top clearfix"><ul class="clearfix table-state"><li ng-repeat="data in vm.selection track by $index" ng-click="conditionSelect(data)" ng-class="data.value == vm.tableData.type ?\'pitchOn\':\'\'">{{data.name}}</li></ul></div><div class="p30"><div class="clearfix"><span class="title1">\u76D8\u70B9\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="openChooseWarehouseDialog()">\u65B0\u5EFA\u76D8\u70B9</button></div><div class="form-search2 mtop20"><ul class="clearfix"><li><p>\u76D8\u70B9\u65E5\u671F</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u76D8\u70B9\u5355\u53F7</p><div class="form-search2-term"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u76D8\u70B9\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.number"></div></li><li><p>\u4ED3\u5E93</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="data.id as data.name for data in vm.warehouses"><option value="">\u5168\u90E8</option></select></div></li><li><p></p><div class="form-search2-term"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></li></ul></div><div class="c-table mtop20 scrollbar-main"><table style="width: 2300px; overflow-x: auto"><thead><tr><th>\u76D8\u70B9\u5355\u53F7</th><th>\u4ED3\u5E93</th><th>\u4ED3\u5E93\u7C7B\u578B</th><th>\u72B6\u6001</th><th>\u5907\u6CE8</th><th>\u64CD\u4F5C\u5458</th><th>\u76D8\u70B9\u65F6\u95F4</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 150px;max-width: 150px;min-width: 150px">{{data.number}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.warehouseName}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.warehouseType == \'product\' ? \'\u6210\u54C1\u5E93\' : (data.warehouseType == \'accessories\' ? \'\u539F\u8F85\u6750\u6599\u5E93\' : \'\u672A\u77E5\')}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" ng-style="purchaseOrderType(data.status)" ng-if="!data.cancelled">{{purchaseOrderType(data.status).text}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" ng-if="data.cancelled">\u5DF2\u5173\u95ED</td><td style="width: 100px;max-width: 100px;min-width: 100px" title="{{data.remarks}}">{{data.remarks|limitTo:\'10\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.operator}}</td><td style="width: 150px;max-width: 150px;min-width: 150px">{{data.lastModifiedDate | date:\'medium\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px"><button class="c-minBtn c-minBtn1" ui-sref="stockEdit({id:data.id})" ng-if="data.status == \'INPROGRESS\'">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ui-sref="stockEdit({id:data.id})" ng-if="data.status != \'INPROGRESS\'">\u8BE6\u60C5</button><!-- <button class="c-minBtn c-minBtn3" ui-sref="purchasePreview({id:data.id})" ng-if="!data.cancelled">\u67E5\u770B</button> --></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="20" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div></div>');
$templateCache.put('app/supply/address-new.html','<div class="bg-content"><!--\u65B0\u589E\u5730\u5740--><div class="user-modal bg-center" style="height: 370px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">{{addressTitle}}</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" ng-model="vm.supply.address"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u8054\u7CFB\u4EBA</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u59D3\u540D" ng-model="vm.supply.contact"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u624B\u673A\u53F7</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" ng-model="vm.supply.phone"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/create-user.html','<div class="bg-content" ng-style="{height:vm.isCustomerHub?\'450px\':\'\'}"><!--\u8BBE\u7F6E\u7528\u6237\u540D--><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">{{userTitle}}</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u7528\u6237\u540D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" id="user-set" placeholder="\u8BF7\u8F93\u5165\u7528\u6237\u540D" ng-model="vm.user.name"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u5BC6\u7801</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="password" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5BC6\u7801" ng-model="vm.user.password"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u786E\u8BA4\u5BC6\u7801</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="password" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u786E\u8BA4\u5BC6\u7801" ng-model="vm.user.confirmPassword"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.isCustomerHub"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u59D3\u540D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u59D3\u540D" ng-model="vm.user.fullname"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.isCustomerHub"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u8054\u7CFB\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="number" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" ng-model="vm.user.phone"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/supply/out-id-select.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">\u9009\u62E9\u5BF9\u5E94\u5546\u54C1</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-table th-35"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.suplierProductsSearchQuery" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u540D\u79F0\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="suplierProductsSearch(vm.suplierProductsSearchQuery)"></button></span></div></form><!-- <input type="text" class="form-control" ng-model="vm.suplierProductsSearchQuery" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u540D\u79F0\u641C\u7D22" style="margin: 0 10px;">\n                    <button class="btn btn-primary btn-save btn-info" ng-click="suplierProductsSearch(vm.suplierProductsSearchQuery)" style="width: 64px;height: 32px;">\u67E5 \u8BE2</button> --></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="col-lg-3 col-sm-3" style="overflow-y:scroll; height: 440px"><div class="col-lg-12 col-sm-12 no-padding"><div class="col-lg-12 col-sm-12 text-left form-group no-padding" ng-repeat="tree in vm.supplierProductsTree track by $index"><div ng-click="showTree(tree)" class="outline"><i class="choose-li-close" ng-if="!tree.show "></i> <i class="choose-li-open" ng-if="tree.show"></i> {{tree.categoryName}}</div><div class="col-lg-12 col-sm-12" style="padding-top: 10px" ng-repeat="l in tree.categories track by $index" ng-if="tree.show"><div ng-click="showLeft(l)" class="outline"><i class="choose-li-close" ng-if="!l.show "></i> <i class="choose-li-open" ng-if="l.show"></i> {{l.categoryName}}</div><div class="col-lg-12 col-sm-12" style="padding-top: 10px" ng-click="selectApex(apex)" ng-repeat="apex in l.products track by $index" ng-if="l.show">{{apex.productName}}</div></div></div></div></div><div class="col-lg-9 col-sm-9" style="overflow-y:scroll; height: 440px"><table class="table-fw"><thead class="table-head"><tr style="height: 54px;background: #fafafa"><th style="width: 50px">\u9009\u62E9</th><th style="width: 500px">\u5546\u54C1\u540D\u79F0</th><th style="width: 150px">\u7F16\u53F7</th><th style="width: 80px">\u5355\u4F4D</th><th style="width: 80px">\u7C7B\u578B</th></tr></thead><tbody class="table-body" ng-repeat="apex in vm.suplierProductsApex  track by $index" ng-if="!apex.hide"><tr ng-repeat="product in apex.specs track by $index" style="height: 70px" ng-click="productChooseOne(product)"><td><i class="choose-li-close" ng-if="!product.selected "></i> <i class="choose-li-open" ng-if="product.selected"></i><!-- <input type="checkbox"  ng-model="product.selected"  ng-click="productChooseOne(product)"> --></td><td>{{product.specName}}</td><td class="position-relative">{{product.skuNumber}}</td><td>{{apex.unit}}</td><!--0 - \u5B9A\u5236\u5546\u54C1--><!--1 - \u6807\u51C6\u5370\u54C1--><!--2 - \u6807\u51C6\u901A\u54C1--><td>{{apex.productType == 0?\'\u8BA2\u5236\u54C1\': apex.productType ==2?\'\u6807\u51C6\u901A\u54C1\': apex.productType ==1?\'\u6807\u51C6\u5370\u54C1\':\'\'}}</td></tr></tbody></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/recharge-amount.html','<div class="bg-content"><div class="user-modal bg-center" style="min-height: 180px!important"><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u5145\u503C\u91D1\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="number" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5145\u503C\u91D1\u989D" ng-model="vm.balance"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/supply/set-imposition.html','<div class="bg-content"><!--\u8BBE\u7F6E\u62FC\u7248\u6570--><div class="user-modal bg-center row"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u62FC\u7248\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u62FC\u7248\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><ul><li ng-repeat="item in vm.items" ng-if="vm.items.length>0" class="pin-info" ng-click="chooseItem(item)" title="{{item.name}}"><img src="content/images/unselect.png" alt="" ng-if="!item.selected"> <img src="content/images/selected.png" alt="" ng-if="item.selected"> <span style="display: inline-block; width: 60%;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;line-height: 13px;font-size: 14px">{{item.name}}</span></li><li class="pin-info" style="width: 100%" ng-if="vm.items.length ==0">\u6682\u65E0\u62FC\u7248\u65B9\u5F0F \u8BF7\u6DFB\u52A0</li></ul></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" style="margin-top: 30px"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/sku-file-detail.html','<div class="bg-content"><div class="user-modal bg-center" style="height: 370px"><!--    <div class="user-modal bg-center clearfix" style="width:1200px;">--><div style="margin-bottom: 20px"><span class="title1">\u6587\u4EF6\u683C\u5F0F</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8F93\u5165\u6587\u4EF6\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.data.inputFileFormat}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8F93\u51FA\u6587\u4EF6\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><!--                <span style="font-size: 16px;">{{vm.data.outFileFormat==\'PNGREVEAL\'?\'PNG(\u900F\u660E\u5316)\':vm.data.outFileFormat}}</span>--> <span style="font-size: 16px">{{vm.data.outFileFormat}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileFormat == \'PNG\'||vm.data.outFileFormat == \'JPG\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u56FE\u7247\u6587\u4EF6\u6837\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.data.outFileType==\'Only\'?\'\u5355\u9875\':\'\u8DE8\u9875\'}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileFormat == \'PNG\'||vm.data.outFileFormat == \'JPG\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u56FE\u7247dpi</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.data.imgDpi}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileType == \'Page\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8DE8\u9875\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.data.crossPageType==\'SuoXian\'?\'\u9501\u7EBF\':vm.data.crossPageType==\'DuiBiao\'?\'\u5BF9\u88F1\uFF08\u4E0D\u542B\u5C01\u9762\u5C01\u5E95\uFF09\':\'\u5BF9\u88F1\uFF08\u542B\u5C01\u9762\u5C01\u5E95\uFF09\'}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileFormat == \'PDF\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u5C55\u5E73\u900F\u660E\u5BF9\u8C61</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.data.flatten?\'\u662F\':\'\u5426\'}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/sku-file.html','<div class="bg-content"><div class="user-modal bg-center" style="height: 420px"><div style="margin-bottom: 20px"><span class="title1">\u6587\u4EF6\u683C\u5F0F</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8F93\u5165\u6587\u4EF6\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><span ng-repeat="data in vm.inputFileFormats track by $index"><label><input type="checkbox" ng-model="data.selected"> <span title="{{data.name}}">{{data.name}}</span></label></span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8F93\u51FA\u6587\u4EF6\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control border-radius" name="outFileFormat" ng-model="vm.data.outFileFormat" id="outFileFormat" ng-change="fileFormatChange()"><option value="">\u8BF7\u9009\u62E9\u8F93\u51FA\u6587\u4EF6\u7C7B\u578B</option><option value="PNG">PNG</option><option value="PDF">PDF</option><option value="JPG">JPG</option><!--                    <option value="PNGREVEAL">PNG(\u900F\u660E\u5316)</option>--></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileFormat == \'PNG\'||vm.data.outFileFormat == \'JPG\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u56FE\u7247\u6587\u4EF6\u6837\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control border-radius" name="outFileType" ng-model="vm.data.outFileType" id="outFileType" ng-change="outFileTypeChange()"><option value="">\u8BF7\u9009\u62E9\u6587\u4EF6\u6837\u5F0F</option><option value="Only">\u5355\u9875</option><option value="Page">\u8DE8\u9875</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileFormat == \'PNG\'||vm.data.outFileFormat == \'JPG\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u56FE\u7247dpi</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control border-radius" ng-model="vm.data.imgDpi" placeholder="\u8BF7\u8F93\u5165\u56FE\u7247DPI"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileType == \'Page\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u8DE8\u9875\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control border-radius" name="crossPageType" ng-model="vm.data.crossPageType" id="crossPageType"><option value="">\u8BF7\u9009\u62E9\u8DE8\u9875\u65B9\u5F0F</option><option value="SuoXian">\u9501\u7EBF</option><option value="DuiBiao">\u5BF9\u88F1\uFF08\u4E0D\u542B\u5C01\u9762\u5C01\u5E95\uFF09</option><option value="DuiBiao2">\u5BF9\u88F1\uFF08\u542B\u5C01\u9762\u5C01\u5E95\uFF09</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.data.outFileFormat == \'PDF\'"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u5C55\u5E73\u900F\u660E\u5BF9\u8C61</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.data.flatten" style="outline: none"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/sku-makeup-detail.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">\u751F\u4EA7\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-table mtop20 th-35" style="max-height: 500px"><table><thead><tr><th style="text-align: center;width: 170px">SKU</th><th style="text-align: center">\u673A\u578B</th><th style="text-align: center;width: 60px">\u4EA7\u80FD</th><th style="text-align: center;width: 90px">\u6700\u5927\u6253\u5305\u6570</th><th style="text-align: center;width: 60px">\u5370\u524D</th><th style="text-align: center">\u5370\u524D\u8BBE\u7F6E</th><th style="text-align: center">\u62FC\u7248\u8BBE\u7F6E</th><th style="text-align: center;width: 60px">\u5355\u4EF7</th><th style="text-align: center;width: 150px">\u5916\u90E8\u5173\u8054id</th></tr></thead><tbody><tr ng-repeat="skuManage in vm.skuManages track by $index" style="text-align: center"><td>{{skuManage.sku}}</td><td>{{skuManage.deviceType}}</td><td>{{skuManage.capacity}}</td><td>{{skuManage.maxBoxing}}</td><td>{{skuManage.prePress ? "\u5F00\u542F":"\u5173\u95ED"}}</td><td>{{skuManage.prePressFlowName}}</td><td>{{skuManage.makeup.name}}</td><td>{{skuManage.price|currency}}</td><td>{{skuManage.outId}}</td></tr></tbody></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/sku-makeup.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">\u751F\u4EA7\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-table mtop20 th-35" style="max-height: 500px"><table><thead><tr><th style="text-align: center;width: 170px">SKU</th><th style="text-align: center">\u673A\u578B</th><th style="text-align: center;width: 60px">\u4EA7\u80FD</th><th style="text-align: center;width: 90px">\u6700\u5927\u6253\u5305\u6570</th><th style="text-align: center;width: 60px">\u5370\u524D</th><th style="text-align: center">\u5370\u524D\u8BBE\u7F6E</th><th style="text-align: center">\u62FC\u7248\u8BBE\u7F6E</th><th style="text-align: center;width: 60px">\u5355\u4EF7</th><th style="text-align: center;width: 150px">\u5916\u90E8\u5173\u8054id</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="skuManage in vm.skuManages track by $index" style="text-align: center"><td>{{skuManage.sku}}<!-- <select class="c-select2 radius-5 special" ng-model="skuManage.propertyId" ng-options="property.id as property.sku for property in vm.propertyList">\n                                    <option value="">\u8BF7\u9009\u62E9SKU</option>\n                                </select> --></td><td><select class="c-select2 radius-5 special" ng-model="skuManage.deviceId" ng-options="machine.id as machine.type for machine in vm.machineList" ng-change="chooseMachine(skuManage)"><option value="">\u8BF7\u9009\u62E9\u673A\u578B</option></select></td><td>{{skuManage.capacity}}</td><td><input type="number" min="0" style="width: 75px" class="c-input1" ng-model="skuManage.maxBoxing" placeholder="\u8BF7\u8F93\u5165\u6700\u5927\u6253\u5305\u6570"></td><td><input type="checkbox" class="checkOrIf" ng-model="skuManage.prePress" style="outline: none;width: 57px"></td><td><select class="c-select2 radius-5 special" ng-model="skuManage.prePressFlowId" ng-options="prePressFlow.id as prePressFlow.name for prePressFlow in vm.prePressFlowList"><option value="">\u8BF7\u9009\u62E9\u5370\u524D</option></select></td><td><select class="c-select2 radius-5 special" ng-model="skuManage.makeupId" ng-options="makeup.id as makeup.name for makeup in skuManage.makeupList"><option value="">\u8BF7\u9009\u62E9\u6392\u7248\u65B9\u5F0F</option></select></td><td><input type="text" style="width: 50px" class="c-input1" ng-model="skuManage.price" placeholder="\u8BF7\u8F93\u5165\u5355\u4EF7" min="0.00"></td><td><input type="text" style="width: 80px" class="c-input1" ng-model="skuManage.outId" placeholder="\u8BF7\u8F93\u5165\u5173\u8054id"> <button style="width: 35px" class="btn-yellow-common btn-edit" ng-show="vm.abutType ==\'GOFLOW\' &&vm.supplierAbutSettingId" ng-click="selectOutId(skuManage)">\u9009\u62E9</button></td><td><button class="btn-yellow-common btn-edit" ng-click="skuDelete($index)">\u5220\u9664</button></td></tr><tr ng-show="vm.skuManages.length < vm.propertyList.length"><td colspan="6"><span ng-click="addSkuManage()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFASKU\u7BA1\u7406</span></td></tr></tbody></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/sku-price-page.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">SKU\u5355\u4EF7\u9884\u89C8</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">SKU</th><th style="text-align: center">\u5355\u4EF7</th></tr></thead><tbody><tr ng-repeat="propertyPrice in vm.propertyPriceList track by $index"><td style="text-align: center">{{propertyPrice.propertyConfigSku}}</td><td style="text-align: center"><input type="text" class="c-input1" ng-model="propertyPrice.price" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" min="0.00" disabled="disabled"></td></tr></tbody></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><!-- <button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> --> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/sku-price.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">SKU\u5355\u4EF7\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">SKU</th><th style="text-align: center">\u5355\u4EF7</th></tr></thead><tbody><tr ng-repeat="propertyPrice in vm.propertyPriceList track by $index"><td style="text-align: center">{{propertyPrice.propertyConfigSku}}</td><td style="text-align: center"><input type="text" class="c-input1" ng-model="propertyPrice.price" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" min="0.00"></td></tr></tbody></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/supply-detail.html','<div class="bgc-fff p30 clearfix"><div style="margin-bottom: 20px"><span class="title1">\u4F9B\u5E94\u5546\u8BE6\u60C5</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F9B\u5E94\u5546\u7B80\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.name" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F9B\u5E94\u5546\u5168\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.fullname" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8D26\u6237\u4F59\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><span style="font-size: 16px;margin-right: 30px">{{vm.supply.balance}}</span> <button type="button" class="btn-yellow-common btn-edit" ng-click="recharge()">\u5145\u503C</button> <button type="button" ng-if="!!vm.supply.balance" class="btn-yellow-common btn-edit" ng-click="transactionDetail()">\u4EA4\u6613\u660E\u7EC6</button></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u9884\u8B66\u91D1\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.warnBalance" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5206\u7C7B</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.category == \'SourceMaterials\'?\'\u539F\u8F85\u6750\u6599\':\'\u59D4\u5916\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7528\u6237\u540D</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.supply.username == null || vm.supply.username == \'\' ?\'\u65E0\':vm.supply.username}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u662F\u5426\u6709\u6548</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.supply.enable" style="outline: none" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u662F\u5426\u5916\u53D1</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.supply.outward" style="outline: none" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.outward"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5916\u53D1\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px" data-translate="{{\'supplier.outwardType.\' + vm.supply.outwardType}}"></span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.outward"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5916\u53D1\u5BF9\u63A5\u65B9</label><div class="col-md-9 col-sm-9 col-xs-8 line-35"><span style="font-size: 16px">{{vm.supply.supplierAbutSettingName}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7A0E\u7387\uFF08%\uFF09</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.taxRate" disabled="disabled"></div></div><!--<div class="col-lg-12 col-sm-12 form-group no-padding">--><!--<label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u62FC\u7248\u7BA1\u7406</label>--><!--<div class="col-md-9 col-sm-9 col-xs-8 line-35">--><!--<span ng-if="vm.supply.makeups.length >0" ng-repeat="makeup in vm.supply.makeups">{{makeup.name}};</span>--><!--</div>--><!--</div>--><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7ED3\u7B97\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.settlementMethod == \'CashSettlement\'?\'\u73B0\u7ED3\':\'\u6708\u7ED3\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7ED3\u7B97\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.settlementType == \'DownLoad\'?\'\u4E0B\u8F7D\u7ED3\u7B97\':\'\u53D1\u8D27\u7ED3\u7B97\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4ED8\u6B3E\u6761\u4EF6</label><div class="col-md-9 col-sm-9 col-xs-8"><div class="form-control-edit" style="line-height: 35px">{{vm.supply.paymentTerm == \'InvoicePayment\'?\'\u5F00\u7968\u4ED8\u6B3E\':\'\u8D27\u5230\u4ED8\u6B3E\'}}</div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7EB3\u7A0E\u767B\u8BB0\u7F16\u7801</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.taxCode" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u6CE8\u518C\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" ng-model="vm.supply.registeredAddress" disabled="disabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5907\u6CE8</label><div class="col-md-9 col-sm-9 col-xs-8"><textarea class="form-control-edit" style="height: 60px!important;resize: none" ng-model="vm.supply.remarks" disabled="disabled"></textarea></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5E8F\u53F7</th><th>\u8054\u7CFB\u5730\u5740</th><th>\u8054\u7CFB\u4EBA</th><th>\u8054\u7CFB\u65B9\u5F0F</th></tr><tr ng-repeat="location in vm.supply.locations track by $index"><td style="width: 80px">{{$index+1}}</td><td title="{{location.province+location.city+location.district+location.address}}">{{location.province+location.city+location.district+location.address.substr(0,15)+\'...\'}}</td><td title="{{location.contact}}">{{location.contact.length >15 ?location.contact.substr(0,15)+\'...\':location.contact}}</td><td>{{location.phone}}</td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.productionManages.length >0"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u751F\u4EA7\u7BA1\u7406</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5546\u54C1</th><!-- <th>\u673A\u578B</th> --><th>\u751F\u4EA7\u8BBE\u7F6E</th><th>\u6587\u4EF6\u683C\u5F0F</th><!-- <th>\u4EA7\u80FD</th> --><th>\u8986\u76D6\u533A\u57DF</th><!-- <th>\u4EF7\u683C\u8BBE\u7F6E</th> --></tr><tr ng-repeat="productionManage in vm.supply.productionManages track by $index"><td>{{productionManage.productName}}</td><!-- <td>{{productionManage.deviceType}}</td> --><td><button class="btn-yellow-common btn-edit" ng-click="skuMakeupDetail(productionManage)">\u67E5\u770B</button></td><td><button class="btn-yellow-common btn-edit" ng-click="skuFileDetail(productionManage)">\u67E5\u770B</button></td><!-- <td>{{productionManage.capacity}}</td> --><td><button class="btn-yellow-common btn-edit" ng-click="productionDetail(productionManage)">\u67E5\u770B</button></td><!-- <td>\n                        <button class="btn-yellow-common btn-edit" ng-click="propertyPrice(productionManage)">\u67E5\u770B</button>\n                    </td> --></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53D1\u8D27\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5E8F\u53F7</th><th>\u53D1\u8D27\u5730\u5740</th><th>\u8054\u7CFB\u4EBA</th><th>\u8054\u7CFB\u65B9\u5F0F</th></tr><tr ng-if="vm.supply.shipperInfo.province || vm.supply.shipperInfo.city || vm.supply.shipperInfo.district || vm.supply.shipperInfo.address || vm.supply.shipperInfo.contact || vm.supply.shipperInfo.phone"><td style="width: 80px">1</td><td title="{{vm.supply.shipperInfo.province+vm.supply.shipperInfo.city+vm.supply.shipperInfo.district+vm.supply.shipperInfo.address}}">{{vm.supply.shipperInfo.province+vm.supply.shipperInfo.city+vm.supply.shipperInfo.district+((vm.supply.shipperInfo.address || \'\').substr(0,15))}}{{(vm.supply.shipperInfo.address || \'\').length > 15 ? \'...\' : \'\'}}</td><td title="{{vm.supply.shipperInfo.contact}}">{{(vm.supply.shipperInfo.contact || \'\').length >15 ?(vm.supply.shipperInfo.contact || \'\').substr(0,15)+\'...\':(vm.supply.shipperInfo.contact || \'\')}}</td><td>{{vm.supply.shipperInfo.phone}}</td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53D1\u8D27\u5907\u6CE8</label><div class="col-md-9 col-sm-9 col-xs-8"><textarea class="form-control-edit" style="height: 60px!important;resize: none" ng-model="vm.supply.shipperInfo.remarks" disabled="disabled"></textarea></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/supply/supply-dialog.html','<div class="bgc-fff p30 clearfix"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">{{titleContent}}</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F9B\u5E94\u5546\u7B80\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u4F9B\u5E94\u5546\u7B80\u79F0" ng-model="vm.supply.name"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4F9B\u5E94\u5546\u5168\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u4F9B\u5E94\u5546\u5168\u79F0" ng-model="vm.supply.fullname"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u9884\u8B66\u91D1\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="number" class="form-control-edit" ng-model="vm.supply.warnBalance" min="0"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control-edit radius-5 special" ng-model="vm.category" ng-options="multimediaGroup as multimediaGroup.value for multimediaGroup in vm.multimediaGroups"><option value="">\u8BF7\u9009\u62E9\u5206\u7C7B</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7528\u6237\u540D</label><div class="col-md-9 col-sm-9 col-xs-8 line-35 special2"><span style="font-size: 16px">{{vm.supply.username}}</span> <span ng-if="vm.supply.username == null || supply.username == \'\'" class="c-3A88E4" ng-click="modifyContent(vm.user)">\u521B\u5EFA\u7528\u6237\u540D</span> <span ng-if="vm.supply.username!=null && supply.username != \'\'" class="c-3A88E4" ng-click="modifyContent(vm.user)">\u91CD\u7F6E\u5BC6\u7801</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u662F\u5426\u6709\u6548</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.supply.enable" style="outline: none"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u662F\u5426\u5916\u53D1</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" ng-model="vm.supply.outward" style="outline: none"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.outward"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5916\u53D1\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control border-radius" name="outwardType" ng-model="vm.supply.outwardType" id="outwardType"><option value="">\u8BF7\u9009\u62E9\u5916\u53D1\u65B9\u5F0F</option><option value="Data">\u6570\u636E\u5916\u53D1</option><option value="Produce">\u751F\u4EA7\u5916\u53D1</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" ng-if="vm.supply.outward"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5916\u53D1\u5BF9\u63A5\u65B9</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="c-select2 radius-5 special" ng-model="vm.supply.supplierAbutSettingId" ng-options="abut.id as abut.name for abut in vm.supplierAbutSettings"><option value="">\u8BF7\u9009\u62E9\u5916\u53D1\u5BF9\u63A5\u65B9</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7A0E\u7387\uFF08%\uFF09</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="number" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u7A0E\u7387" ng-model="vm.supply.taxRate" max="100" min="0"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7ED3\u7B97\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control-edit radius-5 special" ng-model="vm.supply.settlementMethod" ng-options="cashier.name as cashier.value for cashier in vm.cashiers"><option value="">\u8BF7\u9009\u62E9\u7ED3\u7B97\u65B9\u5F0F</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7ED3\u7B97\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control-edit radius-5 special" ng-model="vm.supply.settlementType" ng-options="type.name as type.value for type in vm.settlementTypes"><option value="">\u8BF7\u9009\u62E9\u7ED3\u7B97\u8282\u70B9</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u4ED8\u6B3E\u6761\u4EF6</label><div class="col-md-9 col-sm-9 col-xs-8"><select class="form-control-edit radius-5 special" ng-model="vm.supply.paymentTerm" ng-options="payType.name as payType.value for payType in vm.payTypes"><option value="">\u8BF7\u9009\u62E9\u4ED8\u6B3E\u6761\u4EF6</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u7EB3\u7A0E\u767B\u8BB0\u7F16\u7801</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u7EB3\u7A0E\u767B\u8BB0\u7F16\u7801" ng-model="vm.supply.taxCode" max="100" min="0"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u6CE8\u518C\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u6CE8\u518C\u5730\u5740" ng-model="vm.supply.registeredAddress" max="100" min="0"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5907\u6CE8</label><div class="col-md-9 col-sm-9 col-xs-8"><textarea class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5907\u6CE8" ng-model="vm.supply.remarks" max="100" min="0" style="height: 60px!important;resize: none"></textarea></div></div><!--<div class="col-lg-12 col-sm-12 form-group no-padding">--><!--<label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u62FC\u7248\u7BA1\u7406</label>--><!--<div class="col-md-9 col-sm-9 col-xs-8 line-35">--><!--<span ng-if="vm.supply.makeups.length >0" ng-repeat="makeup in vm.supply.makeups">{{makeup.name}};</span>--><!--<span ng-click="setImposition(vm.supply.makeups)" class="c-3A88E4">\u8BBE\u7F6E\u62FC\u7248\u6570</span>--><!--</div>--><!--</div>--><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u8054\u7CFB\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5E8F\u53F7</th><th>\u8054\u7CFB\u5730\u5740</th><th>\u8054\u7CFB\u4EBA</th><th>\u8054\u7CFB\u65B9\u5F0F</th><th>\u64CD\u4F5C</th></tr><tr ng-repeat="location in vm.supply.locations track by $index"><td style="width: 80px">{{$index+1}}</td><td title="{{location.province+location.city+location.district+location.address}}">{{location.province+location.city+location.district+location.address.substr(0,15)+\'...\'}}</td><td title="{{location.contact}}">{{location.contact.length >15 ?location.contact.substr(0,15)+\'...\':location.contact}}</td><td>{{location.phone}}</td><td style="width: 200px"><button class="btn-yellow-common btn-edit" ng-click="addressEdit(location,$index)">\u7F16\u8F91</button> <button class="btn-yellow-common btn-edit" ng-click="addressDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="5"><span ng-click="addAddress(\'\')" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u5730\u5740</span></td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u751F\u4EA7\u7BA1\u7406</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5546\u54C1</th><!-- <th>\u673A\u578B</th> --><!-- <th>\u4EA7\u80FD</th> --><th>\u751F\u4EA7\u8BBE\u7F6E</th><th>\u6587\u4EF6\u683C\u5F0F</th><th>\u8986\u76D6\u533A\u57DF</th><!-- <th>\u4EF7\u683C\u8BBE\u7F6E</th> --><th>\u64CD\u4F5C</th></tr><tr ng-repeat="productionManage in vm.supply.productionManages track by $index"><td><!-- <select class="c-select2 radius-5 special" ng-model="productionManage.productId" ng-options="product.id as product.name for product in vm.products">\n                            <option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option>\n                        </select> --><select-view ng-if="vm.products" ng-model="productionManage.productId" label-key="name" value-key="id" options="vm.products" is-search="true"></select-view></td><!-- <td>\n                        <select class="c-select2 radius-5 special" ng-model="productionManage.deviceId" ng-options="machine.id as machine.type for machine in vm.machines" ng-change="chooseMachine(productionManage)">\n                            <option value="">\u8BF7\u9009\u62E9\u673A\u578B</option>\n                        </select>\n                    </td> --><!-- <td>{{productionManage.capacity}}</td> --><td><button class="btn-yellow-common btn-edit" ng-click="skuMakeupDetail(productionManage)">\u7F16\u8F91</button></td><td><button class="btn-yellow-common btn-edit" ng-click="skuFileDetail(productionManage)">\u7F16\u8F91</button></td><td><button class="btn-yellow-common btn-edit" ng-click="productionEdit(productionManage)">\u7F16\u8F91</button></td><!-- <td>\n                        <button class="btn-yellow-common btn-edit" ng-click="priceEdit(productionManage)">\u7F16\u8F91</button>\n                    </td> --><td style="width: 200px"><button class="btn-yellow-common btn-edit" ng-click="productionDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="6"><span ng-click="addproduction()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u5EFA\u751F\u4EA7\u7BA1\u7406</span></td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53D1\u8D27\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th>\u5E8F\u53F7</th><th>\u53D1\u8D27\u5730\u5740</th><th>\u8054\u7CFB\u4EBA</th><th>\u8054\u7CFB\u65B9\u5F0F</th><th>\u64CD\u4F5C</th></tr><tr ng-if="vm.supply.shipperInfo && (vm.supply.shipperInfo.province || vm.supply.shipperInfo.city || vm.supply.shipperInfo.district || vm.supply.shipperInfo.address || vm.supply.shipperInfo.contact || vm.supply.shipperInfo.phone)"><td style="width: 80px">1</td><td title="{{vm.supply.shipperInfo.province+vm.supply.shipperInfo.city+vm.supply.shipperInfo.district+vm.supply.shipperInfo.address}}">{{vm.supply.shipperInfo.province+vm.supply.shipperInfo.city+vm.supply.shipperInfo.district+((vm.supply.shipperInfo.address || \'\').substr(0,15))}}...</td><td title="{{vm.supply.shipperInfo.contact}}">{{(vm.supply.shipperInfo.contact || \'\').length >15 ?(vm.supply.shipperInfo.contact || \'\').substr(0,15)+\'...\':(vm.supply.shipperInfo.contact || \'\')}}</td><td>{{vm.supply.shipperInfo.phone}}</td><td style="width: 200px"><button class="btn-yellow-common btn-edit" ng-click="addressEdit(vm.supply.shipperInfo,0,\'shipperInfo\')">\u7F16\u8F91</button></td></tr><tr ng-if="!vm.supply.shipperInfo || !(vm.supply.shipperInfo.province || vm.supply.shipperInfo.city || vm.supply.shipperInfo.district || vm.supply.shipperInfo.address || vm.supply.shipperInfo.contact || vm.supply.shipperInfo.phone)"><td colspan="5"><span ng-click="addressEdit({province:\'\',city:\'\',district:\'\',address:\'\',contact:\'\',phone:\'\'},0,\'shipperInfo\')" class="addblu"><img src="content/images/addblu.png" alt="">\u7F16\u8F91\u53D1\u8D27\u5730\u5740</span></td></tr></table></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u53D1\u8D27\u5907\u6CE8</label><div class="col-md-9 col-sm-9 col-xs-8"><textarea class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u53D1\u8D27\u5907\u6CE8" ng-model="vm.supply.shipperInfo.remarks" max="500" min="0" style="height: 60px!important;resize: none"></textarea></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/supply/supply.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1" data-translate="supplier.home.title"></span> <button type="button" class="c-btn c-btn1" ui-sref="supplyNew">\u65B0\u5EFA\u4F9B\u5E94\u5546</button><div class="pull-right"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.keyword"><button type="button" class="hei_35 clear-search" ng-click="vm.clear()"><span>\u6E05\u9664</span></button></span></div></form></div></div></div></div><div class="pull-right wid-200"><div class="form-search clearfix"><select class="form-control radius-5" ng-model="vm.tableData.category" ng-options="category.name as category.value for category in vm.categories" ng-change="search()"><option value="">\u8BF7\u9009\u62E9\u7C7B\u578B</option></select></div></div></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u516C\u53F8\u7B80\u79F0</th><th style="text-align: center">\u516C\u53F8\u5168\u79F0</th><th style="text-align: center">\u7C7B\u578B</th><th style="text-align: center">\u7528\u6237\u540D</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="supplier in vm.suppliers track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{supplier.name}}">{{supplier.name.length >10 ?supplier.name.substr(0,10)+\'...\':supplier.name}}</td><td style="text-align: center" title="{{supplier.fullname}}">{{supplier.fullname.length >10 ? supplier.fullname.substr(0,10)+\'...\':supplier.fullname}}</td><td style="text-align: center">{{supplier.category == \'SourceMaterials\'?\'\u539F\u8F85\u6750\u6599\':\'\u59D4\u5916\'}}</td><td style="text-align: center">{{supplier.username}}</td><td style="text-align: center">{{supplier.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 300px; text-align: center"><button class="btn-yellow-common btn-detail" ui-sref="supplyDetail({id:supplier.id, page: vm.tableData.page})">\u67E5\u770B\u8BE6\u60C5</button> <button class="btn-yellow-common btn-edit" style="margin-right: 0" ui-sref="supplyEdit({id:supplier.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="btn-yellow-common btn-edit" ng-click="deleteSupplier(supplier.id)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.suppliers.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/supply/transaction-detail.html','<div class="bg-content"><div class="user-modal bg-center" style="width: 100%!important"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u4EA4\u6613\u8BB0\u5F55</span></div><div class="mtop20"><div class="c-form" style="margin: 0"><label class="c-form-label">\u4EA4\u6613\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" style="width: 150px" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" style="width: 150px" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="clearfix" style="margin: 10px 0 0 0"><div class="c-form" style="float: left"><label class="c-form-label">\u4EA4\u6613\u7C7B\u578B\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.type" style="width: 150px" ng-options="type.name as type.value for type in vm.types" ng-change="search()"><option value="">\u4EA4\u6613\u7C7B\u578B</option></select></div></div><div style="float: left"><button type="button" class="c-btn c-btn1 hei_30" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn1 hei_30" ng-click="export()">\u4E0B\u8F7D</button></div></div></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="width: 190px" class="no-padding">\u4EA4\u6613\u65F6\u95F4</th><th style="width: 160px" class="no-padding">\u4EA4\u6613\u7C7B\u578B</th><th style="width: 160px" class="no-padding">\u4EA4\u6613\u91D1\u989D</th><th style="width: 150px" class="no-padding">\u4EA4\u6613\u540E\u91D1\u989D</th><th style="width: 150px" class="no-padding">\u5546\u6237\u6E90\u5355\u53F7</th><th style="width: 150px" class="no-padding">\u64CD\u4F5C\u8005</th></tr></thead></table></div><div class="c-table th-35" style="height: 250px"><table><tr ng-repeat="record in vm.records |orderBy:\'-createdDate\' track by $index"><td style="width: 190px">{{record.createdDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td style="width: 160px">{{record.type == \'plus\' ? \'\u5145\u503C\' : record.type == \'minus\' ? \'\u6D88\u8D39\' : record.type == \'refund\' ? \'\u9000\u6B3E\' : \'--\'}}{{record.num}}</td><td style="width: 160px">{{record.amount}}</td><td style="width: 150px">{{record.afterAmount}}</td><td style="width: 150px">{{record.sourceOrderNumber}}</td><td style="width: 150px">{{record.createdBy ==\'anonymousUser\' ? \'\u7CFB\u7EDF\u64CD\u4F5C\':record.createdBy}}</td></tr><tr class="noData" ng-if="vm.records.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div><div class="c-paging" style="margin-bottom: 20px;text-align: center!important"><button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/supply/zone-detail.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">\u67E5\u770B\u533A\u57DF</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-1 no-padding control-label">\u5DF2\u9009\u533A\u57DF</label><div class="col-md-11 col-sm-11 col-xs-11" style="overflow: hidden"><div class="area-wrap no-padding mar-right-10" ng-repeat="area in vm.areas" ng-show="area.provinces.length>0"><div class="area-head pad-left-10"><img src="content/images/unselect.png" alt="" ng-if="!area.selected"> <img src="content/images/selected.png" alt="" ng-if="area.selected"> {{area.area}}</div><div ng-repeat="province in area.provinces" class="mar-tb-8 pad-lr-10"><div><img src="content/images/unselect.png" alt="" ng-if="!province.selected"> <img src="content/images/selected.png" alt="" ng-if="province.selected"> {{province.name}}</div></div></div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supply/zone.html','<div class="bg-content"><div class="user-modal bg-center clearfix" style="width:1200px"><div style="margin-bottom: 20px"><span class="title1">\u8BBE\u7F6E\u533A\u57DF</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-1 col-sm-1 col-xs-1 no-padding control-label">\u9009\u62E9\u533A\u57DF</label><div class="col-md-11 col-sm-11 col-xs-11" style="overflow: hidden"><div class="area-wrap no-padding mar-right-10" ng-repeat="area in vm.areas" ng-show="area.provinces.length>0"><div class="area-head pad-left-10"><img src="content/images/unselect.png" alt="" ng-click="isSelectedAll(area)" ng-if="!area.selected"> <img src="content/images/selected.png" alt="" ng-click="isSelectedAll(area)" ng-if="area.selected"> {{area.area}}</div><div ng-repeat="province in area.provinces" class="mar-tb-8 pad-lr-10"><div><img src="content/images/unselect.png" alt="" ng-click="isSelected(province,area)" ng-if="!province.selected"> <img src="content/images/selected.png" alt="" ng-click="isSelected(province,area)" ng-if="province.selected"> {{province.name}}</div></div></div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/supplyApi/supplyApi-details.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" ng-model="vm.data.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u63A5\u53E3\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.outwardMerchant" ng-options="data.id as data.name for data in vm.outwardMerchants"><option value="">\u8BF7\u9009\u62E9\u63A5\u53E3</option></select></div></div><div class="c-form"><label class="c-form-label">appid\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165appid" ng-model="vm.data.factoryId"></div></div><div class="c-form"><label class="c-form-label">appSecret\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165appSecret" ng-model="vm.data.factorySecret"></div></div><div class="c-form"><label class="c-form-label">\u7B2C\u4E09\u65B9\u57DF\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7B2C\u4E09\u65B9\u57DF\u540D" ng-model="vm.data.domain"></div></div><div class="c-form"><label class="c-form-label">\u4E0B\u5355\u901A\u77E5\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4E0B\u5355\u901A\u77E5\u63A5\u53E3\u914D\u7F6E" ng-model="vm.data.orderMethod"></div></div><div class="c-form"><label class="c-form-label">\u53D1\u8D27\u901A\u77E5\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u53D1\u8D27\u901A\u77E5\u63A5\u53E3\u914D\u7F6E" ng-model="vm.data.deliveryMethod"></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u6E05\u5355\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u53D1\u7B2C\u4E09\u65B9\u5546\u54C1\u6E05\u5355\u63A5\u53E3" ng-model="vm.data.skuMethod"></div></div><div class="c-form"><label class="c-form-label">\u8BA2\u5355\u5730\u5740\u66F4\u65B0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4FEE\u6539\u8BA2\u5355\u5730\u5740\u901A\u77E5\u63A5\u53E3" ng-model="vm.data.receiverMethod"></div></div><!-- <div class="c-form">\n            <label class="c-form-label">\u8BA2\u5355\u53D6\u6D88\u63A5\u53E3\uFF1A</label>\n            <div class="c-form-div wid-800">\n                <input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53D6\u6D88\u63A5\u53E3" ng-model="vm.data.cancelMethod">\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="supplyApi">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/supplyApi/supplyApi.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4F9B\u5E94\u5546api</span> <button type="button" class="c-btn c-btn1" ui-sref="supplyApiAdd">\u65B0\u5EFA</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u540D\u79F0</th><th>\u63A5\u53E3</th><th>appid</th><th>appSecret</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px">{{$index+1}}</td><td title="{{data.name}}">{{data.name.length >20?data.name.substr(0,20)+\'...\':data.name}}</td><td>{{vm.outwardMerchantInfo(data.outwardMerchant)}}</td><td title="{{data.supplierName}}">{{data.factoryId}}</td><td>{{data.factorySecret}}</td><td style="width: 130px; max-width: 130px; min-width: 130px"><button class="c-minBtn c-minBtn1" ui-sref="supplyApiEdit({id:data.id})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="delete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/task/myTask.html','<div class="bgc-fff"><div class="table-top clearfix"><ul class="clearfix table-state"><li ng-repeat="data in vm.selection track by $index" ng-click="conditionSelect(data)" ng-class="data.value == vm.tableData.status ?\'pitchOn\':\'\'">{{data.name}}</li></ul><div class="table-state-btn" ng-click="tableStateBtn()" ng-if="vm.isTableState"><img src="content/images/arrdp.png" alt=""></div></div><div class="p30"><div class="clearfix"><span class="title1">\u6211\u7684\u4EFB\u52A1</span> <button type="button" class="c-btn c-btn1" ng-click="reloadUp()">\u56DE\u4F20</button> <button type="button" class="c-btn c-btn1" ng-click="downloadFile()">\u4E0B\u8F7D</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th>\u8BA2\u5355\u53F7</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u8BA2\u8D2D\u5546\u54C1</th><th>VIP\u8BA2\u5355</th><th>\u4EE3\u6392\u72B6\u6001</th><th>\u5206\u914D\u4EBA</th><th>\u4EE3\u6392\u5458\u5DE5</th><th>\u5206\u914D\u65F6\u95F4</th><th>\u56DE\u4F20\u65F6\u95F4</th><th>\u5907\u6CE8</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" data-toggle="model" ng-if="vm.tableList.length > 0"><td><input type="checkbox" ng-model="data.checked" ng-click="selectOne(data)"></td><td>{{data.number}}</td><td>{{data.quantity}}</td><td>{{data.productName}}</td><td>{{data.vipOrder}}</td><td>{{data.composingStatus ==\'ToAssigned\'?\'\u5F85\u5206\u914D\':data.composingStatus ==\'Assigned\'?\'\u5DF2\u5206\u914D\':data.composingStatus ==\'Uploaded\'?\'\u5DF2\u56DE\u4F20\':\'\'}}</td><td>{{data.assigner}}</td><td>{{data.employeeName}}</td><td>{{data.assignDate | date:\'yyyy-MM-dd\'}}</td><td>{{data.postbackDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 150px; max-width: 150px; min-width: 150px" title="{{data.serviceRemarks}}">{{data.serviceRemarks.length >10 ? data.serviceRemarks.substr(0,10)+\'...\':data.serviceRemarks}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><!--\u56DE\u4F20--><div class="modal fade" id="uploads" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-body"><button type="button" class="close" ng-click="uploadHide()" style="outline: none">&times;</button><div class="clearfix"><span class="title1">\u56DE\u4F20\u6587\u4EF6</span></div><div class="mtop20"><div class="c-form"><div class="c-form-div" style="width: 400px;position: relative"><span style="font-size: 20px">{{vm.fileName}}</span> <button type="button" class="c-btn c-btn1">\u4E0A\u4F20\u6587\u4EF6</button> <input type="file" id="file" name="myfile" onchange="upladFile(event)" accept="application/zip" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 1; opacity :0; width: 96px"></div></div><div class="c-form" style="text-align: right"><button type="button" class="c-btn c-btn2" ng-click="uploadHide()">\u5173\u95ED</button></div></div></div></div></div></div>');
$templateCache.put('app/task/remark.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u589E\u52A0\u5907\u6CE8</span></div><div class="mtop20"><textarea class="textarea_style" ng-model="vm.remark"></textarea><div class="c-form mtop20"><div class="wid_100%" style="padding-left: 50px"><button type="button" class="c-btn c-btn1 mr10 wid-130" ng-click="assignRemark()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRemark()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/task/task-distribute.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u4EE3\u6392\u4EFB\u52A1\u5206\u914D</span></div><div class="mtop20 c-table"><table><thead><tr><th></th><th>\u5458\u5DE5\u59D3\u540D</th><th>\u7528\u6237\u540D</th><th>\u4ECA\u65E5\u5206\u914D\u4EFB\u52A1\u6570</th><th>\u5F85\u56DE\u4F20</th><th>\u5DF2\u56DE\u4F20</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td><input type="checkbox" ng-model="data.selected" ng-click="taskOne(data)"></td><td>{{data.fullname}}</td><td>{{data.username}}</td><td>{{data.taskNum}}</td><td>{{data.toUpload}}</td><td>{{data.uploaded}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table><div class="c-form mtop20"><div class="wid_100"><button type="button" class="c-btn c-btn1 mr10 wid-130" ng-click="assignTask()" ng-disabled="vm.isSaving">\u5206\u914D</button> <button type="button" class="c-btn c-btn2" ng-click="cancelTask()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/task/taskAllocation.html','<div class="bgc-fff"><div class="table-top clearfix"><ul class="clearfix table-state"><li ng-repeat="data in vm.selection track by $index" ng-click="conditionSelect(data)" ng-class="data.value == vm.tableData.status ?\'pitchOn\':\'\'">{{data.name}}</li></ul><div class="table-state-btn" ng-click="tableStateBtn()" ng-if="vm.isTableState"><img src="content/images/arrdp.png" alt=""></div></div><div class="p30"><div class="clearfix"><span class="title1">\u4EFB\u52A1\u5206\u914D</span> <button type="button" class="c-btn c-btn1" ng-click="distribute()">\u5206\u914D</button> <button type="button" class="c-btn c-btn1" ng-click="addRemark()">\u5907\u6CE8</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002" ng-model="vm.tableData.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th><input type="checkbox" ng-model="select_all" ng-click="selectAll()"></th><th>\u8BA2\u5355\u53F7</th><th>\u8BA2\u8D2D\u6570\u91CF</th><th>\u8BA2\u8D2D\u5546\u54C1</th><th>VIP\u8BA2\u5355</th><th>\u4EE3\u6392\u72B6\u6001</th><th>\u5206\u914D\u4EBA</th><th>\u4EE3\u6392\u5458\u5DE5</th><th>\u5206\u914D\u65F6\u95F4</th><th>\u56DE\u4F20\u65F6\u95F4</th><th>\u5907\u6CE8</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td><input type="checkbox" ng-model="data.checked" ng-click="selectOne(data)"></td><td>{{data.number}}</td><td>{{data.quantity}}</td><td>{{data.productName}}</td><td>{{data.vipOrder}}</td><td>{{data.composingStatus ==\'ToAssigned\'?\'\u5F85\u5206\u914D\':data.composingStatus ==\'Assigned\'?\'\u5DF2\u5206\u914D\':data.composingStatus ==\'Uploaded\'?\'\u5DF2\u56DE\u4F20\':\'\u5F85\u5206\u914D\'}}</td><td>{{data.assigner}}</td><td>{{data.employeeName}}</td><td>{{data.assignDate | date:\'yyyy-MM-dd\'}}</td><td>{{data.postbackDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 150px; max-width: 150px; min-width: 150px" title="{{data.serviceRemarks}}">{{data.serviceRemarks.length >10 ? data.serviceRemarks.substr(0,10)+\'...\':data.serviceRemarks}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/user/role-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u89D2\u8272</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u89D2\u8272\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.role.name"></div></div><!--        <div class="c-form">--><!--            <label class="c-form-label">\u7C7B\u578B\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <select name="" class="c-select1" ng-model="vm.role.type"--><!--                        ng-options="data.value as data.name for data in vm.typeList">--><!--                    <option value="">\u8BF7\u9009\u62E9</option>--><!--                </select>--><!--            </div>--><!--        </div>--><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.role.enabled" class="checkOrIf"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800" style="width: 500px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.role.description"></textarea></div></div><div class="c-form"><label class="c-form-label">\u6743\u9650\uFF1A</label><div class="c-form-div wid-800"><div class="permissions clearfix"><table><tr ng-repeat="data in vm.finalList track by $index"><td style="width: 150px;max-width: 150px; min-width: 150px; padding-left: 30px"><label><input type="checkbox" ng-model="data.selected" ng-click="permissionsSelect(data)"> <span>{{data.module}}</span></label></td><td style="width: 700px; max-width: 700px; min-width: 700px"><label ng-repeat="datas in data.names track by $index"><input type="checkbox" ng-model="datas.selected" ng-click="permissionsRoleSelect(data)"> <span>{{datas.name}}</span></label></td></tr></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="role">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/user/role-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u89D2\u8272</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u89D2\u8272\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.role.name"></div></div><div class="c-form"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.role.type" ng-options="data.value as data.name for data in vm.typeList"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" ng-model="vm.role.enabled" class="checkOrIf"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.role.description"></textarea></div></div><div class="c-form"><label class="c-form-label">\u6743\u9650\uFF1A</label><div class="c-form-div wid-800"><div class="permissions clearfix"><table><tr ng-repeat="data in vm.finalList track by $index"><td style="width: 150px;max-width: 150px;min-width: 150px; padding-left: 30px"><label><input type="checkbox" ng-model="data.selected" ng-click="permissionsSelect(data)" ng-disabled="data.module == \'\u7528\u6237\u4E2D\u5FC3\' && vm.role.id == 1"> <span>{{data.module}}</span></label></td><td style="width: 650px; max-width: 650px; min-width: 650px"><label ng-repeat="datas in data.names track by $index"><input type="checkbox" ng-model="datas.selected" ng-click="permissionsRoleSelect(data)" ng-disabled="(datas.authority == \'ROLE_ROLE\' || datas.authority == \'ROLE_USER\') && vm.role.id == 1"> <span>{{datas.name}}</span></label></td></tr></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/user/role.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u89D2\u8272\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="roleAdd">\u65B0\u5EFA\u89D2\u8272</button><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002" ng-model="vm.tableData.key"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u89D2\u8272\u540D\u79F0</th><th>\u63CF\u8FF0</th><!--                <th>\u7C7B\u578B</th>--><th>\u6709\u6548</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td>{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td>{{data.name}}</td><td style="width: 300px; max-width: 300px; min-width: 300px"><p title="{{data.description}}">{{data.description}}</p></td><!--                <td>{{data.type}}</td>--><td>{{data.enabled ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 170px; max-width: 170px; min-width: 170px"><button class="c-minBtn c-minBtn1" ui-sref="roleEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="roleDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/user/user-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u7528\u6237</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u7528\u6237\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.user.username"></div></div><div class="c-form"><label class="c-form-label">\u89D2\u8272\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.user.role" ng-options="role.id as role.name for role in vm.role"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u5BC6\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="password" class="c-input1" ng-model="vm.user.password"></div></div><div class="c-form"><label class="c-form-label">\u786E\u8BA4\u5BC6\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="password" class="c-input1" ng-model="vm.user.confirmpassword"></div></div><div class="c-form"><label class="c-form-label">\u59D3\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.user.fullname"></div></div><div class="c-form"><label class="c-form-label">\u624B\u673A\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.user.phone" maxlength="11"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.user.activated"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.user.description"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="user">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/user/user-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u7528\u6237</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u7528\u6237\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.user.username" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u89D2\u8272\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.user.role" ng-options="role.id as role.name for role in vm.role"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u59D3\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.user.fullname"></div></div><div class="c-form"><label class="c-form-label">\u624B\u673A\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.user.phone" maxlength="11"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.user.activated"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.user.description"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/user/user-password.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u91CD\u7F6E\u5BC6\u7801</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u7528\u6237\u540D\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="text" class="c-input1" ng-model="vm.user.username" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u539F\u5BC6\u7801\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="password" class="c-input1" ng-model="vm.user.password"></div></div><div class="c-form"><label class="c-form-label">\u65B0\u5BC6\u7801\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="password" class="c-input1" ng-model="vm.user.password2"></div></div><div class="c-form"><label class="c-form-label">\u786E\u8BA4\u5BC6\u7801\uFF1A</label><div class="c-form-div" style="width: 375px"><input type="password" class="c-input1" ng-model="vm.user.confirmPassword"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="width: 375px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/user/user.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7528\u6237\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="userAdd">\u65B0\u5EFA\u7528\u6237</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002" ng-model="vm.tableData.key"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u7528\u6237\u540D</th><th>\u59D3\u540D</th><th>\u8054\u7CFB\u65B9\u5F0F</th><th>\u89D2\u8272</th><th>\u63CF\u8FF0</th><th>\u6709\u6548</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td>{{data.username}}</td><td style="width: 150px; max-width: 150px; min-width: 150px">{{data.fullname}}</td><td style="width: 150px; max-width: 150px; min-width: 150px">{{data.phone}}</td><td style="width: 200px; max-width: 200px; min-width: 200px">{{data.roleName}}</td><td style="width: 300px; max-width: 300px; min-width: 300px"><p title="{{data.description}}">{{data.description}}</p></td><td style="width: 150px; max-width: 150px; min-width: 150px">{{data.activated ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 250px; max-width: 250px; min-width: 250px"><button class="c-minBtn c-minBtn1" ui-sref="userEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn2" ng-click="modifyContent(data)">\u91CD\u7F6E\u5BC6\u7801</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="8" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/accessories/allocation/allocation-add.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u8F85\u6599\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.material" ng-options="material as material.name for material in vm.materials" ng-change="selectProduct(vm.material)"><option value="">\u8BF7\u9009\u62E9\u8F85\u6599</option></select><div ng-if="vm.material!=undefined" style="margin-top: 10px">\u5546\u54C1\u7F16\u53F7:{{vm.material.number}};\u5355\u4F4D:{{vm.material.measurementName}}</div></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.propertyConfig" ng-options="propertyConfig as propertyConfig.sku for propertyConfig in vm.material.propertyConfigs" ng-change="getUseQuantity(vm.outWarehouse,vm.propertyConfig)"><!--<option value="">\u8BF7\u9009\u62E9SKU</option>--></select></div></div><div class="c-form"><label class="c-form-label">\u8C03\u51FA\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.outWarehouse" ng-options="depository as depository.name for depository in vm.depositories" ng-change="getUseQuantity(vm.outWarehouse,vm.propertyConfig)"><option value="">\u8BF7\u9009\u62E9\u8C03\u51FA\u4ED3\u5E93</option></select><div ng-if="vm.reserveQuantity!=undefined && vm.reserveQuantity!=-1" style="margin-top: 10px">\u5E93\u5B58\u91CF:{{vm.reserveQuantity}}</div></div></div><div class="c-form"><label class="c-form-label">\u8C03\u5165\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.inWarehouse" ng-options="depository as depository.name for depository in vm.depositories"><option value="">\u8BF7\u9009\u62E9\u8C03\u5165\u4ED3\u5E93</option></select></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20" min="1"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveAllocation()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/accessories/allocation/allocation.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8C03\u62E8\u8BB0\u5F55</span> <button type="button" class="c-btn c-btn1" ng-click="newAllocation()">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</button></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u8C03\u62E8\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u8C03\u51FA\u4ED3\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.outWarehouseId" ng-options="category.id as category.name for category in vm.categories"><option value="">\u8BF7\u9009\u62E9\u8C03\u51FA\u4ED3\u5E93</option></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 80px"><input type="text" class="c-input1 pull-left" style="width: 200px" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u53F7"> <button type="button" ng-click="search()"></button></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u8C03\u5165\u4ED3\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.inWarehouseId" ng-options="category.id as category.name for category in vm.categories"><option value="">\u8BF7\u9009\u62E9\u8C03\u5165\u4ED3\u5E93</option></select></div></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u8C03\u62E8\u5546\u54C1</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u8C03\u62E8\u65F6\u95F4</th><th style="text-align: center">\u8C03\u51FA\u4ED3\u5E93</th><th style="text-align: center">\u8C03\u5165\u4ED3\u5E93</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u64CD\u4F5C\u8005</th><th style="text-align: center">\u539F\u56E0</th></tr></thead><tbody><tr ng-repeat="allocation in vm.allocations track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center">{{allocation.propertyConfig.sku}}</td><td style="text-align: center">{{allocation.propertyConfig.number}}</td><td style="text-align: center">{{allocation.createdDate| date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{allocation.outWarehouse.name}}</td><td style="text-align: center">{{allocation.inWarehouse.name}}</td><td style="text-align: center">{{allocation.measurement.name}}</td><td style="text-align: center">{{allocation.num}}</td><td style="text-align: center">{{allocation.createdBy}}</td><td style="text-align: center" title="{{allocation.reason}}">{{allocation.reason|limitTo:\'10\'}}</td></tr><tr class="noData" ng-if="vm.allocations.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/accessories/inventory/inventory-add.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u76D8\u70B9\u8C03\u6574</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.warehouse" ng-options="reserve as reserve.warehouse.name for reserve in vm.reserves"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9\u8F85\u6599\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.material" ng-options="material as material.name for material in vm.warehouse.materialList"><option value="">\u8BF7\u9009\u62E9\u8F85\u6599</option></select></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.propertyConfig" ng-options="propertyConfig as propertyConfig.sku for propertyConfig in vm.material.propertyConfigs" ng-change="getRecordNum(vm.propertyConfig)"><option value="">\u8BF7\u9009\u62E9SKU</option></select><div ng-if="vm.flag" style="color: red">\u6240\u9009\u8F85\u6599\u65E0\u5E93\u5B58\u8BB0\u5F55</div></div></div><div class="c-form"><label class="c-form-label">\u8BB0\u5F55\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BB0\u5F55\u6570\u91CF" ng-model="vm.quantity" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B9E\u9645\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20" min="1"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveInventory()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/accessories/inventory/inventory-detail.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u67E5\u770B\u76D8\u70B9\u8C03\u6574</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.warehouse.name" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9\u5546\u54C1\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.skuName" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8BB0\u5F55\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.quantity" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B9E\u9645\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.num" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.inventory.reason" style="resize: none;height: 50px" disabled="disabled"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/accessories/inventory/inventory.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u76D8\u70B9\u8C03\u6574\u8BB0\u5F55</span> <button type="button" class="c-btn c-btn1" ng-click="newInventory()">\u65B0\u5EFA\u76D8\u70B9\u8C03\u6574\u8BB0\u5F55</button></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u76D8\u70B9\u8C03\u6574\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 150px"><input type="text" class="c-input1 pull-left" style="width: 200px" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165SKU\u6216\u8005\u4ED3\u5E93\u540D\u79F0\u67E5\u8BE2"> <button type="button" ng-click="search()"></button></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u4ED3\u5E93\u540D\u79F0</th><th style="text-align: center">\u8C03\u6574\u65F6\u95F4</th><th style="text-align: center">\u8C03\u6574\u5546\u54C1</th><th style="text-align: center">\u8C03\u6574\u524D\u6570\u91CF</th><th style="text-align: center">\u8C03\u6574\u6570\u91CF</th><th style="text-align: center">\u8C03\u6574\u540E\u6570\u91CF</th><th style="text-align: center">\u64CD\u4F5C\u8005</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="inventory in vm.inventories track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{inventory.warehouse.name}}">{{inventory.warehouse.name |limitTo:\'10\'}}</td><td style="text-align: center">{{inventory.createdDate | date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{inventory.skuName}}</td><td style="text-align: center">{{inventory.quantity}}</td><td style="text-align: center">{{inventory.type ==\'in\'?\'+\':\'-\'}}{{inventory.num}}</td><td style="text-align: center">{{inventory.type ==\'in\'? inventory.quantity + inventory.num : inventory.quantity - inventory.num}}</td><td style="text-align: center">{{inventory.createdBy}}</td><td style="width: 200px; text-align: center"><button class="btn-yellow-common btn-edit" ng-click="viewInventory(inventory)">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.inventories.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/accessories/outgoingAndWarehousing/outgoingAndWarehousing.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u51FA\u5165\u5E93\u8BB0\u5F55</span><!--<button type="button" class="c-btn c-btn1" data-toggle="modal" data-target="#myModal">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</button>--></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u64CD\u4F5C\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startTime" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endTime" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 150px"><input type="text" class="c-input1 pull-left" style="width: 200px" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165SKU\u540D\u79F0\u67E5\u8BE2"> <button type="button" ng-click="search()"></button></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5546\u54C1\u540D\u79F0</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u4E1A\u52A1\u7C7B\u578B</th><th style="text-align: center">\u4ED3\u5E93</th><th style="text-align: center">\u65F6\u95F4</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u5BF9\u5E94\u5355\u53F7</th><th style="text-align: center">\u64CD\u4F5C\u8005</th></tr></thead><tbody><tr ng-repeat="warehouseRecord in vm.warehouseRecords track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{warehouseRecord.propertyConfig.sku}}">{{warehouseRecord.propertyConfig.sku |limitTo:\'20\'}}</td><td style="text-align: center">{{warehouseRecord.propertyConfig.number}}</td><td style="text-align: center">{{warehouseRecord.state}}</td><td style="text-align: center">{{warehouseRecord.warehouse.name}}</td><td style="text-align: center">{{warehouseRecord.createdDate| date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{warehouseRecord.measurement.name}}</td><td style="text-align: center">{{warehouseRecord.num}}</td><td style="text-align: center">{{warehouseRecord.orderNumber}}</td><td style="text-align: center">{{warehouseRecord.createdBy}}</td></tr><tr class="noData" ng-if="vm.warehouseRecords.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/accessories/reserve/allocateTask.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</span></div><div class="mtop20 c-table"><!--<div class="c-form">--><!--<label class="c-form-label">\u9009\u62E9\u5546\u54C1\uFF1A</label>--><!--<div class="c-form-div wid-400">--><!--<input type="text" class="c-input1" ng-model="vm.allocation.propertyConfig.sku" maxlength="20" disabled>--><!--</div>--><!--</div>--><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.allocation.propertyConfig.sku" maxlength="20" disabled="disabled"><div style="margin-top: 10px">\u5546\u54C1\u7F16\u53F7:{{vm.allocation.productNumber}};\u5355\u4F4D:{{vm.allocation.measurement.name}}</div></div></div><div class="c-form"><label class="c-form-label">\u8C03\u51FA\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.allocation.warehouse.name" maxlength="20" disabled="disabled"><div style="margin-top: 10px">\u5E93\u5B58\u91CF:{{vm.allocation.usableQuantity}}</div></div></div><div class="c-form"><label class="c-form-label">\u8C03\u5165\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.inWarehouse" ng-options="depository as depository.name for depository in vm.depositories"><option value="">\u8BF7\u9009\u62E9\u8C03\u5165\u4ED3\u5E93</option></select></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20" min="1"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveAllocation()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/accessories/reserve/inventoryTask.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u76D8\u70B9\u8C03\u6574</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.warehouse.name" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.propertyConfig.sku" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8BB0\u5F55\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BB0\u5F55\u6570\u91CF" ng-model="vm.inventory.availableQuantity" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B9E\u9645\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveInventory()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/accessories/reserve/reserve.html','<div class="bgc-fff"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u8F85\u6599\u4ED3\u5E93\u5217\u8868</span><!--<button type="button" class="c-btn c-btn1" ui-sref="supplyNew">\u65B0\u5EFA\u4F9B\u5E94\u5546</button>--></div><div class="mtop20 clearfix"><div class="pull-right"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline" style="display: flex;align-items: center"><div><label class="c-form-label">\u4E00\u7EA7\u5206\u7C7B\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select2" ng-model="vm.tableData.categoryOneId" ng-options="data.id as data.name for data in vm.productCategoryFirst" ng-change="changeSearchCategoryFirst()"><option value="">\u8BF7\u9009\u62E9\u4E00\u7EA7\u5206\u7C7B</option></select></div></div><div><label class="c-form-label">\u4E8C\u7EA7\u5206\u7C7B\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select2" ng-model="vm.tableData.categoryTwoId" ng-options="data.id as data.name for data in vm.productCategorySecond" ng-change="changeSearchCategorySecond()"><option value="">\u8BF7\u9009\u62E9\u4E8C\u7EA7\u5206\u7C7B</option></select></div></div><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165\u4EA7\u54C1\u7F16\u53F7\u6216\u8005\u4ED3\u5E93\u540D\u79F0\u67E5\u8BE2"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.key"><button type="button" class="hei_35 clear-search" ng-click="vm.clear()"><span>\u6E05\u9664</span></button></span></div></form></div></div></div></div><div class="pull-left"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select1" style="width: 100%" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()">--><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="pull-left"><button type="button" class="c-btn c-btn1" style="height: 30px" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" style="height: 30px" ui-sref="importStockUploadList({type:\'accessories\'})">\u5BFC\u5165</button></div></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u4ED3\u5E93\u540D\u79F0</th><th style="text-align: center">SKU</th><th style="text-align: center">\u5546\u54C1\u5206\u7C7B</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u73B0\u6709\u6570\u91CF</th><th style="text-align: center">\u9501\u5B9A\u91CF</th><th style="text-align: center">\u91C7\u8D2D\u4E2D\u6570\u91CF</th><th style="text-align: center">\u6700\u5C0F\u5E93\u5B58\u91CF</th><th style="text-align: center">\u53EF\u7528\u91CF</th><th style="text-align: center">\u5355\u4EF7</th><th style="text-align: center">\u5E93\u5B58\u603B\u989D</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="inventory in vm.inventories track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{inventory.warehouse.name}}">{{inventory.warehouse.name |limitTo:\'10\'}}</td><td style="text-align: center">{{inventory.propertyConfig.sku}}</td><td style="text-align: center">{{inventory.productCategory}}</td><td style="text-align: center">{{inventory.productNumber}}</td><td style="text-align: center">{{inventory.measurement.name}}</td><td style="text-align: center">{{inventory.availableQuantity}}</td><td style="text-align: center">{{inventory.preparationQuantity}}</td><td style="text-align: center">{{inventory.inProcurementQuantity}}</td><td style="text-align: center">{{inventory.minStorage}}</td><td style="text-align: center">{{inventory.availableQuantity-inventory.preparationQuantity}}</td><td style="text-align: center">{{inventory.price | currency}}</td><!-- \u540E\u7AEF\u4E0D\u5B58\u5E93\u5B58\u603B\u989D  \u9700\u7528\u5355\u4EF7 * \u73B0\u6709\u6570\u91CF --><td style="text-align: center">{{inventory.price * inventory.availableQuantity | currency}}</td><td style="width: 200px; text-align: center"><button class="btn-yellow-common btn-detail" ng-click="inventoryTask(inventory)">\u76D8\u70B9\u8C03\u6574</button> <button class="btn-yellow-common btn-edit" ng-click="allocateTask(inventory)">\u8C03\u62E8</button></td></tr><tr class="noData" ng-if="vm.inventories.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gateway/gateway.html','<div><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes == false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length == 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status == \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status == \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination style="float: right" class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination><jhi-item-count style="float: right;margin: 34px 20px 0 0" page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div>');
$templateCache.put('app/components/barcode/ng-barcode.html','<svg id="barcodeId" ng-style="{\n    \'width\':vm.width+vm.unit,\n    \'height\':vm.height+vm.unit,\n}"></svg>');
$templateCache.put('app/components/c-select/c-select.html','<div class="modele-select" ng-click="clickInput()" ng-style="{\'width\': vm.width ? vm.width : \'\'}" ng-class="{\'open\' : vm.showOption}"><div class="prefix" ng-if="vm.prefix">{{ vm.prefix }}</div><input value="{{vm.getShowName()}}" class="modele-select-input" type="text" readonly="readonly" placeholder="{{vm.placeholder}}"> <img src="content/images/iconDownArrow.png" alt=""></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h3 data-translate="login.title">Sign in</h3></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p></div></div></div>');
$templateCache.put('app/entities/permission/permission-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.permission.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gwApp.permission.delete.question" translate-values="{id: \'{{vm.permission.id}}\'}">Are you sure you want to delete this Permission?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/permission/permission-detail.html','<div><h2><span data-translate="gwApp.permission.detail.title">Permission</span> {{vm.permission.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gwApp.permission.name">Name</span></dt><dd><span>{{vm.permission.name}}</span></dd><dt><span data-translate="gwApp.permission.module">Module</span></dt><dd><span>{{vm.permission.module}}</span></dd><dt><span data-translate="gwApp.permission.authority">Authority</span></dt><dd><span>{{vm.permission.authority}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="permission-detail.edit({id:vm.permission.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/permission/permission-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPermissionLabel" data-translate="gwApp.permission.home.createOrEditLabel">Create or edit a Permission</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.permission.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.permission.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gwApp.permission.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.permission.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="gwApp.permission.module" for="field_module">Module</label><input type="text" class="form-control" name="module" id="field_module" ng-model="vm.permission.module" required><div ng-show="editForm.module.$invalid"><p class="help-block" ng-show="editForm.module.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="gwApp.permission.authority" for="field_authority">Authority</label><input type="text" class="form-control" name="authority" id="field_authority" ng-model="vm.permission.authority" required><div ng-show="editForm.authority.$invalid"><p class="help-block" ng-show="editForm.authority.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/permission/permissions.html','<div><h2 data-translate="gwApp.permission.home.title">Permissions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="permission.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gwApp.permission.home.createLabel">Create new Permission</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gwApp.permission.name">Name</span></th><th><span data-translate="gwApp.permission.module">Module</span></th><th><span data-translate="gwApp.permission.authority">Authority</span></th><th></th></tr></thead><tbody><tr ng-repeat="permission in vm.permissions track by permission.id"><td><a ui-sref="permission-detail({id:permission.id})">{{permission.id}}</a></td><td>{{permission.name}}</td><td>{{permission.module}}</td><td>{{permission.authority}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="permission-detail({id:permission.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="permission.edit({id:permission.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="permission.delete({id:permission.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/finishedWarehouse/allocation/allocation-add.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u5546\u54C1\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.product" ng-options="product as product.name for product in vm.products" ng-change="selectProduct(vm.product)"><option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option></select><div ng-if="vm.product!=undefined" style="margin-top: 10px">\u5546\u54C1\u7F16\u53F7:{{vm.product.number}};\u5355\u4F4D:{{vm.product.measurementName}}</div></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.propertyConfig" ng-options="propertyConfig as propertyConfig.sku for propertyConfig in vm.product.propertyConfigs" ng-change="getUseQuantity(vm.outWarehouse, vm.propertyConfig)"><!--<option value="">\u8BF7\u9009\u62E9SKU</option>--></select></div></div><div class="c-form"><label class="c-form-label">\u8C03\u51FA\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.outWarehouse" ng-options="depository as depository.name for depository in vm.depositories" ng-change="getUseQuantity(vm.outWarehouse, vm.propertyConfig)"><option value="">\u8BF7\u9009\u62E9\u8C03\u51FA\u4ED3\u5E93</option></select><div ng-if="vm.reserveQuantity!=undefined && vm.reserveQuantity!=-1" style="margin-top: 10px">\u5E93\u5B58\u91CF:{{vm.reserveQuantity}}</div></div></div><div class="c-form"><label class="c-form-label">\u8C03\u5165\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.inWarehouse" ng-options="depository as depository.name for depository in vm.depositories"><option value="">\u8BF7\u9009\u62E9\u8C03\u5165\u4ED3\u5E93</option></select></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20" min="1"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveAllocation()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/finishedWarehouse/allocation/allocation.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8C03\u62E8\u8BB0\u5F55</span> <button type="button" class="c-btn c-btn1" ng-click="newAllocation()">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</button></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u8C03\u62E8\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u8C03\u51FA\u4ED3\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.outWarehouseId" ng-options="category.id as category.name for category in vm.categories"><option value="">\u8BF7\u9009\u62E9\u8C03\u51FA\u4ED3\u5E93</option></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 80px"><input type="text" class="c-input1 pull-left" style="width: 200px" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u53F7"> <button type="button" ng-click="search()"></button></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u8C03\u5165\u4ED3\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.inWarehouseId" ng-options="category.id as category.name for category in vm.categories"><option value="">\u8BF7\u9009\u62E9\u8C03\u5165\u4ED3\u5E93</option></select></div></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u8C03\u62E8\u5546\u54C1</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u8C03\u62E8\u65F6\u95F4</th><th style="text-align: center">\u8C03\u51FA\u4ED3\u5E93</th><th style="text-align: center">\u8C03\u5165\u4ED3\u5E93</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u64CD\u4F5C\u8005</th><th style="text-align: center">\u539F\u56E0</th></tr></thead><tbody><tr ng-repeat="allocation in vm.allocations track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{allocation.propertyConfig.sku}}">{{allocation.propertyConfig.sku |limitTo:\'10\'}}</td><td style="text-align: center">{{allocation.propertyConfig.number}}</td><td style="text-align: center">{{allocation.createdDate| date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{allocation.outWarehouse.name}}</td><td style="text-align: center">{{allocation.inWarehouse.name}}</td><td style="text-align: center">{{allocation.measurement.name}}</td><td style="text-align: center">{{allocation.num}}</td><td style="text-align: center">{{allocation.createdBy}}</td><td style="text-align: center" title="{{allocation.reason}}">{{allocation.reason|limitTo:\'10\'}}</td></tr><tr class="noData" ng-if="vm.allocations.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/finishedWarehouse/inventory/inventory-add.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u76D8\u70B9\u8C03\u6574</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.warehouse" ng-options="reserve as reserve.warehouse.name for reserve in vm.reserves"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9\u5546\u54C1\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.product" ng-options="product as product.name for product in vm.warehouse.productList"><option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option></select></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.propertyConfig" ng-options="propertyConfig as propertyConfig.sku for propertyConfig in vm.product.propertyConfigs" ng-change="getRecordNum(vm.propertyConfig)"><option value="">\u8BF7\u9009\u62E9SKU</option></select><div ng-if="vm.flag" style="color: red">\u6240\u9009\u5546\u54C1\u65E0\u5E93\u5B58\u8BB0\u5F55</div></div></div><div class="c-form"><label class="c-form-label">\u8BB0\u5F55\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BB0\u5F55\u6570\u91CF" ng-model="vm.quantity" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B9E\u9645\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20" min="1"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveInventory()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/finishedWarehouse/inventory/inventory-detail.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u67E5\u770B\u76D8\u70B9\u8C03\u6574</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.warehouse.name" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9\u5546\u54C1\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.skuName" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8BB0\u5F55\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.quantity" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B9E\u9645\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.num" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.inventory.reason" style="resize: none;height: 50px" disabled="disabled"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/finishedWarehouse/inventory/inventory.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u76D8\u70B9\u8C03\u6574\u8BB0\u5F55</span> <button type="button" class="c-btn c-btn1" ng-click="newInventory()">\u65B0\u5EFA\u76D8\u70B9\u8C03\u6574\u8BB0\u5F55</button></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u76D8\u70B9\u8C03\u6574\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 150px"><input type="text" class="c-input1 pull-left" style="width: 200px" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165SKU\u6216\u8005\u4ED3\u5E93\u540D\u79F0\u67E5\u8BE2"> <button type="button" ng-click="search()"></button></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u4ED3\u5E93\u540D\u79F0</th><th style="text-align: center">\u8C03\u6574\u65F6\u95F4</th><th style="text-align: center">\u8C03\u6574\u5546\u54C1</th><th style="text-align: center">\u8C03\u6574\u524D\u6570\u91CF</th><th style="text-align: center">\u8C03\u6574\u6570\u91CF</th><th style="text-align: center">\u8C03\u6574\u540E\u6570\u91CF</th><th style="text-align: center">\u64CD\u4F5C\u8005</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="inventory in vm.inventories track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{inventory.warehouse.name}}">{{inventory.warehouse.name |limitTo:\'10\'}}</td><td style="text-align: center">{{inventory.createdDate | date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{inventory.skuName}}</td><td style="text-align: center">{{inventory.quantity}}</td><td style="text-align: center">{{inventory.type ==\'in\'?\'+\':\'-\'}}{{inventory.num}}</td><td style="text-align: center">{{inventory.type ==\'in\'? inventory.quantity + inventory.num : inventory.quantity - inventory.num}}</td><td style="text-align: center">{{inventory.createdBy}}</td><td style="width: 200px; text-align: center"><button class="btn-yellow-common btn-edit" ng-click="viewInventory(inventory)">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.inventories.length == 0"><td colspan="9" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/finishedWarehouse/reserve/allocateTask.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</span></div><div class="mtop20 c-table"><!--<div class="c-form">--><!--<label class="c-form-label">\u9009\u62E9\u5546\u54C1\uFF1A</label>--><!--<div class="c-form-div wid-400">--><!--<input type="text" class="c-input1" ng-model="vm.allocation.propertyConfig.sku" maxlength="20" disabled>--><!--</div>--><!--</div>--><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.allocation.propertyConfig.sku" maxlength="20" disabled="disabled"><div style="margin-top: 10px">\u5546\u54C1\u7F16\u53F7:{{vm.allocation.productNumber}};\u5355\u4F4D:{{vm.allocation.measurement.name}}</div></div></div><div class="c-form"><label class="c-form-label">\u8C03\u51FA\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.allocation.warehouse.name" maxlength="20" disabled="disabled"><div style="margin-top: 10px">\u5E93\u5B58\u91CF:{{vm.allocation.usableQuantity}}</div></div></div><div class="c-form"><label class="c-form-label">\u8C03\u5165\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><select name="" class="c-select1" ng-model="vm.inWarehouse" ng-options="depository as depository.name for depository in vm.depositories"><option value="">\u8BF7\u9009\u62E9\u8C03\u5165\u4ED3\u5E93</option></select></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20" min="1"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveAllocation()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/finishedWarehouse/reserve/inventoryTask.html','<div class="bg-content"><div class="user-modal bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u65B0\u5EFA\u76D8\u70B9\u8C03\u6574</span></div><div class="mtop20 c-table"><div class="c-form"><label class="c-form-label">\u9009\u62E9\u4ED3\u5E93\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.warehouse.name" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u9009\u62E9SKU\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" ng-model="vm.inventory.propertyConfig.sku" maxlength="20" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u8BB0\u5F55\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BB0\u5F55\u6570\u91CF" ng-model="vm.inventory.availableQuantity" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u5B9E\u9645\u6570\u91CF\uFF1A</label><div class="c-form-div wid-400"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u6570\u91CF" ng-model="vm.num" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u8C03\u6574\u539F\u56E0\uFF1A</label><div class="c-form-div wid-400"><textarea class="c-input1" ng-model="vm.reason" placeholder="\u8BF7\u8F93\u5165\u8C03\u6574\u539F\u56E0" style="resize: none;height: 50px"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveInventory()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/finishedWarehouse/reserve/reserve.html','<div class="bgc-fff"><ul class="clearfix table-state"><li ng-repeat="data in vm.conditionList track by $index" ng-click="conditionSelect(data)" ng-class="{\'pitchOn\': data.value == vm.tableData.state}">{{data.name}}</li></ul><div class="p30"><div class="clearfix"><span class="title1">\u6210\u54C1\u4ED3\u5E93\u8BB0\u5F55</span></div><div class="mtop20 clearfix"><div class="pull-right"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline" style="display: flex;align-items: center"><div><label class="c-form-label">\u4E00\u7EA7\u5206\u7C7B\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select2" ng-model="vm.tableData.categoryOneId" ng-options="data.id as data.name for data in vm.productCategoryFirst" ng-change="changeSearchCategoryFirst()"><option value="">\u8BF7\u9009\u62E9\u4E00\u7EA7\u5206\u7C7B</option></select></div></div><div><label class="c-form-label">\u4E8C\u7EA7\u5206\u7C7B\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select2" ng-model="vm.tableData.categoryTwoId" ng-options="data.id as data.name for data in vm.productCategorySecond" ng-change="changeSearchCategorySecond()"><option value="">\u8BF7\u9009\u62E9\u4E8C\u7EA7\u5206\u7C7B</option></select></div></div><div class="input-group" id="test"><input type="text" class="form-control" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165\u4EA7\u54C1\u7F16\u53F7\u6216\u8005\u4ED3\u5E93\u540D\u79F0\u67E5\u8BE2"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.key"><button type="button" class="hei_35 clear-search" ng-click="vm.clear()"><span>\u6E05\u9664</span></button></span></div></form></div></div></div></div><div class="pull-left"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="form-time wid-200"><select name="" class="c-select1" style="width: 100%" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="pull-left"><button type="button" class="c-btn c-btn1" style="height: 30px" ng-click="orderExport()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn1" style="height: 30px" ui-sref="importStockUploadList({type:\'product\'})">\u5BFC\u5165</button></div></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u4ED3\u5E93\u540D\u79F0</th><th style="text-align: center">SKU</th><th style="text-align: center">\u5546\u54C1\u5206\u7C7B</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u73B0\u6709\u6570\u91CF</th><th style="text-align: center">\u9501\u5B9A\u91CF</th><th style="text-align: center">\u91C7\u8D2D\u4E2D\u6570\u91CF</th><th style="text-align: center">\u6700\u5C0F\u5E93\u5B58\u91CF</th><th style="text-align: center">\u53EF\u7528\u91CF</th><th style="text-align: center">\u5355\u4EF7</th><th style="text-align: center">\u5E93\u5B58\u603B\u989D</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="inventory in vm.inventories track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{inventory.warehouse.name}}">{{inventory.warehouse.name |limitTo:\'10\'}}</td><td style="text-align: center" title="{{inventory.propertyConfig.sku}}">{{inventory.propertyConfig.sku|limitTo:\'10\'}}</td><td style="text-align: center">{{inventory.productCategory}}</td><td style="text-align: center">{{inventory.productNumber}}</td><td style="text-align: center">{{inventory.measurement.name}}</td><td style="text-align: center">{{inventory.availableQuantity}}</td><td style="text-align: center">{{inventory.preparationQuantity}}</td><td style="text-align: center">{{inventory.inProcurementQuantity}}</td><td style="text-align: center">{{inventory.minStorage}}</td><td style="text-align: center">{{inventory.availableQuantity -inventory.preparationQuantity}}</td><td style="text-align: center">{{inventory.price | currency}}</td><!-- \u540E\u7AEF\u4E0D\u5B58\u5E93\u5B58\u603B\u989D  \u9700\u7528\u5355\u4EF7 * \u73B0\u6709\u6570\u91CF --><td style="text-align: center">{{inventory.price * inventory.availableQuantity | currency}}</td><td style="width: 200px; text-align: center"><button class="btn-yellow-common btn-detail" ng-click="inventoryTask(inventory)">\u76D8\u70B9\u8C03\u6574</button> <button class="btn-yellow-common btn-edit" ng-click="allocateTask(inventory)">\u8C03\u62E8</button></td></tr><tr class="noData" ng-if="vm.inventories.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div>');
$templateCache.put('app/finishedWarehouse/outgoingAndWarehousing/outgoingAndWarehousing.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u51FA\u5165\u5E93\u8BB0\u5F55</span><!--<button type="button" class="c-btn c-btn1" data-toggle="modal" data-target="#myModal">\u65B0\u5EFA\u8C03\u62E8\u8BB0\u5F55</button>--></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u64CD\u4F5C\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.startTime" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.endTime" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u4ED3\u5E93\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="category.id as category.name for category in vm.categories" ng-change="search()"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93</option></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 150px"><input type="text" class="c-input1 pull-left" style="width: 200px" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165SKU\u540D\u79F0\u67E5\u8BE2"> <button type="button" ng-click="search()"></button></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5546\u54C1\u540D\u79F0</th><th style="text-align: center">\u5546\u54C1\u7F16\u53F7</th><th style="text-align: center">\u4E1A\u52A1\u7C7B\u578B</th><th style="text-align: center">\u4ED3\u5E93</th><th style="text-align: center">\u65F6\u95F4</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u6570\u91CF</th><th style="text-align: center">\u5BF9\u5E94\u5355\u53F7</th><th style="text-align: center">\u64CD\u4F5C\u8005</th></tr></thead><tbody><tr ng-repeat="warehouseRecord in vm.warehouseRecords track by $index"><td style="width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{warehouseRecord.propertyConfig.sku}}">{{warehouseRecord.propertyConfig.sku |limitTo:\'20\'}}</td><td style="text-align: center">{{warehouseRecord.propertyConfig.number}}</td><td style="text-align: center">{{warehouseRecord.state}}</td><td style="text-align: center">{{warehouseRecord.warehouse.name}}</td><td style="text-align: center">{{warehouseRecord.createdDate| date:\'yyyy-MM-dd\'}}</td><td style="text-align: center">{{warehouseRecord.measurement.name}}</td><td style="text-align: center">{{warehouseRecord.num}}</td><td style="text-align: center">{{warehouseRecord.orderNumber}}</td><td style="text-align: center">{{warehouseRecord.createdBy}}</td></tr><tr class="noData" ng-if="vm.warehouseRecords.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/inventoryManagement/components/choose-product-sku.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u9009\u62E9\u5546\u54C1SKU</div><span class="iconfont icon-guanbi" ng-click="cancel()"></span></div><div class="c-model-body chooseProduct1-view" style="padding: 0"><div class="chooseProduct1-view1"><div class="chooseProduct1-view-fl scrollbar-main"><div class="categorie-view" ng-repeat="item in vm.categories" ng-if="item.show"><div ng-if="!item.categories"><div class="categorie-title" ng-class="{\'selectCate\':vm.productType2 == item.type2}" ng-click="categorieClick1(item)"><span>{{item.name}}</span></div></div><div ng-if="item.categories"><div class="categorie-title" ng-click="item.selected = !item.selected"><span>{{item.name}}</span> <i class="iconfont icon-jiantouyou" ng-if="!item.selected">> </i><i class="iconfont icon-jiantouxia" ng-if="item.selected">^</i></div><ul ng-if="item.selected"><li class="categorie-li slh" ng-repeat="categorie in item.categories track by $index" ng-class="{\'selectCate\' : vm.categorieId == categorie.id}" ng-click="categorieClick(categorie)">{{categorie.name}}</li></ul></div></div></div><div class="chooseProduct1-view-fr"><div class="chooseProduct1-view-fr-title"><div class="clearfix"><div class="pull-left"><input type="text" class="c-input1" ng-model="vm.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22"></div><button type="button" class="c-btn c-btn1 mr10" style="height: 30px" ng-click="search()"><span>\u67E5\u8BE2</span></button></div></div><div class="mar-top-10"><div class="c-table scrollbar-main" style="max-height: 370px"><table><thead><tr><th>\u5546\u54C1\u540D\u79F0</th><th>\u5546\u54C1SKU</th><th>sku\u7F16\u53F7</th><th>\u5355\u4F4D</th></tr></thead><tbody><tr ng-repeat="data in vm.products track by $index" ng-if="vm.products.length>0" ng-class="{\'selectedTr\':getExist(data)}" ng-click="productChoice(data)"><td style="width: 280px">{{data.productName}}</td><td>{{data.sku}}</td><td>{{data.number}}</td><td>{{data.unit}}</td></tr><tr ng-if="vm.products.length == 0"><td colspan="3" style="text-align: center">\u6682\u65E0\u5546\u54C1~</td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination></div></div></div></div><div class="c-model-foot" style="padding: 20px;border-top: 1px solid #ddd"><button type="button" class="btn btn-primary btn-save btn-info" ng-click="save()"><span>\u786E\u5B9A</span></button> <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="cancel()"><span>\u53D6\u6D88</span></button></div></div><style>.c-model {\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    background: #fff;\n    width: 1200px;\n    z-index: 10;\n    border-radius: 12px;\n    .c-model-head {\n      position: relative;\n      width: 100%;\n      border-bottom: 1px solid #ddd;\n      padding: 16px 40px 16px 16px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      .model-search-input{\n        height: 44px;\n        border: none;\n        background: #F7F7FA !important;\n        border-radius: 20px;\n        padding: 0 10px;\n        width: 328px;\n        .el-input__wrapper{\n          background: none;\n          border: 0;\n          box-shadow:none\n        }\n      }\n    }\n}\n\n.c-model-head .cancelicon{\n    position: absolute;\n    right: 5px;\n    top: 0;\n    cursor: pointer;\n    font-size: 22px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    color: #93939C;\n  }\n\n.c-model-head-title {\n    font-size: 18px;\n    color: #0A0A0A;\n    line-height: 35px;\n  }\n\n\n    .chooseProduct1-view{\n        width: 100%;\n    }\n    .chooseProduct1-view-head{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        height: 50px;\n        padding: 0 10px;\n    }\n    .chooseProduct1-view1 {\n        width: 100%;\n        height: 500px;\n        display: flex;\n    }\n    .chooseProduct1-view-fl {\n        width: 180px;\n        min-width: 180px;\n        max-width: 180px;\n        height: 100%;\n        overflow: auto;\n        border-right: 1px solid #ddd;\n    }\n    .chooseProduct1-view-fl ul li{\n        width: 100%;\n    }\n    .chooseProduct1-title1{\n        width: 100%;\n        height: 40px;\n        border-radius: 8px;\n        font-weight: bold;\n        color: #010101;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        padding: 0 15px;\n        cursor: pointer;\n    }\n    .chooseProduct1-menu {\n        width: 100%;\n        padding: 10px 0;\n    }\n\n    .chooseProduct1-title2{\n        width: 100%;\n        height: 35px;\n        color: #989898;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    .chooseProduct1-menu1{\n        width: 100%;\n    }\n    .chooseProduct1-menu1-view{\n        width: 100%;\n        height: 35px;\n        display: flex;\n        align-items: center;\n        transition: .1s;\n        cursor: pointer;\n        padding: 0 20px;\n    }\n    .chooseProduct1-menu1-view:hover, .chooseProduct1-menu1-view-ontree{\n        color: #FF5001;\n        background-color: rgba(58, 124, 255, 0.1);\n    }\n    .chooseProduct1-view-fr {\n        width: 100%;\n        height: 100%;\n        padding: 20px;\n    }\n    .chooseProduct1-view-fr-title{\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    .chooseProduct1-view-fr-title-span{\n        font-size: 20px;\n        font-weight: bold;\n        color: #000;\n    }\n    .selectedTr{\n         background: #c4f6fd !important;\n         color: #fff !important;;\n     }\n\n    .form-search input {\n        border-radius: 3px 0 0 3px;\n        width: 200px;\n    }\n\n    .form-search button {\n        height: 34px;\n        line-height: 34px;\n        float: left;\n        border: 0;\n        border-radius: 0 3px 3px 0;\n    }\n    .categorie-view{\n        padding: 0 16px;\n    }\n    .categorie-title{\n        width: 100%;\n        height: 35px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        cursor: pointer;\n    }\n    .categorie-title .iconfont{\n        font-size: 12px;\n    }\n    .categorie-li{\n        width: 100%;\n        height: 35px;\n        padding: 0 16px;\n        line-height: 35px;\n        cursor: pointer;\n        color: #0A0A0A;\n    }\n    .categorie-li:hover, .selectCate{\n        color: #FF5001;\n    }</style>');
$templateCache.put('app/inventoryManagement/components/close-outBount-dialog.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1" style="font-weight: normal">\u662F\u5426\u786E\u8BA4\u5173\u95ED\u8BE5\u51FA\u5E93\u5355\uFF0C\u5173\u95ED\u540E\u65E0\u6CD5\u64A4\u9500\uFF1F</span></div><div class="mt10"><div style="font-size: 16px; color: #000;margin-bottom: 10px;font-weight: bolder">\u8BF7\u5F55\u5165\u5173\u95ED\u7406\u7531</div><div class="c-form-div"><textarea style="width: 100%" placeholder="\u8BF7\u8F93\u5165" class="c-textarea1" ng-model="vm.reason" aria-invalid="false" maxlength="200"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="padding-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" style="padding-left: 20px" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/inventoryManagement/components/out-bound-detail-tips.html','<div class="bg-content"><div class="bg-center"><div class="clearfix" style="margin-bottom: 20px"><span class="title1" ng-if="vm.amount !== 0 || !vm.flag">\u63D0\u793A</span> <span class="title1" ng-if="vm.amount === 0 && vm.flag">\u662F\u5426\u786E\u8BA4\u51FA\u5E93\uFF1F</span></div><div class="mtop20 c-table"><div class="title-tip" ng-if="vm.amount !== 0">\u786E\u8BA4\u51FA\u5E93\u5C06\u81EA\u52A8\u4E3A\u4EE5\u4E0B\u672A\u51FA\u5E93\u90E8\u5206\u8FDB\u884C\u9000\u6B3E\uFF0C\u662F\u5426\u786E\u8BA4\u51FA\u5E93?</div><div class="title-tip" ng-if="vm.amount !== 0">\u9000\u6B3E\u91D1\u989D\uFF1A<span style="color: #f00">{{ vm.amount | currency}}</span></div><div ng-if="vm.amount !== 0"><div class="c-table1"><table><thead><tr><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5546\u54C1\u540D\u79F0</th><th>sku\u7F16\u53F7</th><th>\u578B\u53F7\u89C4\u683C</th><th>\u5355\u4F4D\u540D\u79F0</th><th>\u5355\u4EF7</th><th>\u62A5\u8D27\u6570\u91CF</th><th>\u51FA\u5E93\u4ED3\u5E93</th><th>\u672A\u51FA\u5E93\u6570\u91CF</th><th>\u9000\u6B3E\u5C0F\u8BA1</th></tr></thead><tbody><tr ng-repeat="data in vm.lines track by $index"><td>{{data.productNumber}}</td><td>{{data.productName}}</td><td>{{data.skuNumber}}</td><td>{{data.skuStr}}</td><td>{{data.unit}}</td><td>{{data.price | currency}}</td><td>{{data.num}}</td><td>{{data.warehouseName}}</td><td>{{data.num - data.outNum}}</td><td>{{(data.num - data.outNum )* data.stockOrderPrice | currency}}</td></tr></tbody></table></div></div><div class="title-tip" style="margin-top: 16px">\u5F55\u5165\u5FEB\u9012\u5355\u53F7\uFF1A<input placeholder="\u8BF7\u8F93\u5165" type="text" class="c-input1" ng-model="vm.expressNumber"></div><div style="float: right"><button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button> <button type="button" class="c-btn c-btn1 printHide" id="printHide1" ng-click="save()">\u51FA\u5E93</button></div></div></div></div><style>/* .{\n        width: 990px !important;\n    } */\n    .title-tip{\n        font-size: 16px;\n        margin-bottom: 10px;\n        color: #000000;\n    }</style>');
$templateCache.put('app/inventoryManagement/components/relation-purchase-dialog.html','<div class="bg-content"><div class="user-modal bg-center" style="width: 800px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1 pull-left">\u5173\u8054\u91C7\u8D2D\u5355</span><div class="pull-right"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u91C7\u8D2D\u5355\u53F7" ng-model="vm.number"> <button type="button" class="c-btn c-btn1 ml10" ng-click="search()">\u67E5\u8BE2</button></div></div><div class="mtop20 c-table" style="max-height: 300px;overflow-y: auto"><table><thead><tr><th>\u9009\u62E9</th><th>\u91C7\u8D2D\u5355\u53F7</th><th>\u91C7\u8D2D\u603B\u91CF</th><th>\u5546\u54C1\u603B\u989D</th><th>\u5907\u6CE8</th><th>\u91C7\u8D2D\u65E5\u671F</th></tr></thead><tbody><tr ng-repeat="item in vm.data" ng-click="vm.pitch = item.number"><td style="width: 60px; max-width: 60px; text-align: center"><input type="checkbox" ng-checked="vm.pitch == item.number"></td><td>{{item.number}}</td><td>{{item.quantity}}</td><td>{{item.amount}}</td><td>{{item.remarks}}</td><td>{{item.createdDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td></tr><tr ng-if="vm.data.length == 0"><td colspan="6" style="text-align: center">\u6682\u65E0\u5546\u54C1~</td></tr></tbody></table></div><div class="c-form" style="text-align: center;margin-top: 40px"><button type="button" class="c-btn c-btn1 mr10" ng-click="saveRecord()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo.png" alt="logo"> <span data-translate="global.title">Gw</span> <span class="navbar-version"></span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="role" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.role">Role</span></a></li><li ui-sref-active="active"><a ui-sref="permission" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.permission">Permission</span></a></li><li ui-sref-active="active"><a ui-sref="uom" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.uom">Uom</span></a></li><li ui-sref-active="active"><a ui-sref="property-config" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.propertyConfig">Property Config</span></a></li><li ui-sref-active="active"><a ui-sref="media-config" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.mediaConfig">Media Config</span></a></li><li ui-sref-active="active"><a ui-sref="service-config" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceConfig">Service Config</span></a></li><li ui-sref-active="active"><a ui-sref="media-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.mediaTemplate">Media Template</span></a></li><li ui-sref-active="active"><a ui-sref="component-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.componentTemplate">Component Template</span></a></li><li ui-sref-active="active"><a ui-sref="product-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.productTemplate">Product Template</span></a></li><li ui-sref-active="active"><a ui-sref="device-model" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.deviceModel">Device Model</span></a></li><li ui-sref-active="active"><a ui-sref="supplier" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.supplier">Supplier</span></a></li><li ui-sref-active="active"><a ui-sref="customer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.customer">Customer</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="gateway" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-road"></span>&nbsp; <span data-translate="global.menu.admin.gateway">Gateway</span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/purchase/purchaseReturnOrder/purchaseReturnOrder-edit.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1" ng-if="!vm.purchaseOrder.id">\u65B0\u5EFA\u9000\u8D27\u5355</span> <span class="title1" ng-if="vm.purchaseOrder.id">\u9000\u8D27\u5355\u8BE6\u60C5</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label control-label font-style">\u9000\u8D27\u5355\u53F7</label><div class="c-form-div" style="width: 900px"><span>{{vm.purchaseOrder.number}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u5355\u53F7</label><div class="c-form-div" style="width: 900px"><span>{{vm.purchaseOrder.orderNumber}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9000\u8D27\u7C7B\u578B</label><div class="c-form-div" style="width: 900px"><span>{{vm.purchaseOrder.type == \'Outsourcing\' ? \'\u6210\u54C1\u9000\u8D27\' : (vm.purchaseOrder.type == \'RawMaterial\' ? \'\u6750\u6599\u9000\u8D27\' : \'\u672A\u77E5\')}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u4F9B\u5E94\u5546</label><div class="c-form-div" style="width: 900px"><span>{{vm.purchaseOrder.supplierName}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9000\u8D27\u4ED3\u5E93</label><div class="c-form-div" style="width: 900px"><span>{{vm.purchaseOrder.warehouseName}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8054\u7CFB\u4EBA</label><div class="c-form-div" style="width: 900px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.contact" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.contact}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8054\u7CFB\u65B9\u5F0F</label><div class="c-form-div" style="width: 900px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.phone" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.phone}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u6536\u8D27\u5730\u5740</label><div class="c-form-div" style="width: 900px"><input type="text" class="c-input1" ng-model="vm.purchaseOrder.address" placeholder="\u8BF7\u8F93\u5165\u6536\u8D27\u5730\u5740" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.address}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u8FD0\u8D39</label><div class="c-form-div" style="width: 900px"><input type="number" class="c-input1" ng-model="vm.purchaseOrder.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" min="0" ng-if="vm.update"> <span ng-if="!vm.update">{{vm.purchaseOrder.freight | currency}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9000\u8D27\u539F\u56E0</label><div class="c-form-div" style="width: 900px"><!-- <input type="number" class="c-input1" ng-model="vm.purchaseOrder.freight" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39"\n                       min="0" ng-if="vm.update"> --><textarea class="c-input1" ng-if="vm.update" ng-model="vm.purchaseOrder.remark" placeholder="\u8BF7\u8F93\u5165\u9000\u8D27\u539F\u56E0" style="resize: none;height: 50px"></textarea><span ng-if="!vm.update">{{vm.purchaseOrder.remark}}</span></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9000\u8D27\u5546\u54C1</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th style="min-width: 120px">\u9000\u8D27\u5546\u54C1</th><th>\u5546\u54C1SKU</th><th>scm\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u53EF\u9000\u6570\u91CF</th><th>\u9000\u8D27\u6570\u91CF</th><th>\u9000\u8D27\u5355\u4EF7</th><th>\u9000\u8D27\u5408\u8BA1</th><th>\u7A0E\u7387(%)</th><th>\u9000\u8D27\u542B\u7A0E\u5355\u4EF7</th><th>\u9000\u8D27\u52A0\u7A0E\u5408\u8BA1</th><th ng-if="vm.update">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.returnLines track by $index" ng-if="vm.update && !purchaseProductLine.cancelled"><td style="padding: 0">{{purchaseProductLine.productName}}</td><td style="padding: 0">{{purchaseProductLine.propertyConfigSku}}</td><td>{{purchaseProductLine.propertyConfigNumber}}</td><td style="padding: 0; width: 80px">{{purchaseProductLine.measurementName}}</td><td style="padding: 0; width: 80px">{{purchaseProductLine.returnableNum}}</td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.num" style="border: 0" min="0" ng-change="numChange(purchaseProductLine)"></td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-model="purchaseProductLine.price" ng-change="currentItemChange(purchaseProductLine)" style="border: 0" min="0"></td><td style="padding: 0; width: 80px">{{purchaseProductLine.num * purchaseProductLine.price | currency}}</td><td style="padding: 0; width: 80px"><input type="number" class="c-input1" ng-change="currentItemChange(purchaseProductLine)" ng-model="purchaseProductLine.tax" style="border: 0" min="0"></td><td style="padding: 0; width: 120px">\uFFE5{{purchaseProductLine.taxPrice}}</td><td style="padding: 0; width: 120px">{{purchaseProductLine.taxTotal | currency}}</td><td style="width: 60px; max-width: 60px; min-width: 60px"><button type="button" class="btn-flow" ng-click="vm.productDelete(purchaseProductLine,$index)">\u79FB\u9664</button></td></tr><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.returnLines track by $index" ng-if="!vm.update && !purchaseProductLine.cancelled"><td>{{purchaseProductLine.productName}}</td><td>{{purchaseProductLine.propertyConfigSku}}</td><td>{{purchaseProductLine.propertyConfigNumber}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.measurementName}}</td><td style="padding: 0; width: 80px">{{purchaseProductLine.returnableNum}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.num}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">\uFFE5{{purchaseProductLine.price}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.total | currency}}</td><td style="width: 80px;min-width: 80px;max-width: 80px">{{purchaseProductLine.tax}}</td><td style="width: 120px;min-width: 120px;max-width: 120px">\uFFE5{{purchaseProductLine.taxPrice }}</td><td style="width: 120px;min-width: 120px;max-width: 100px">{{purchaseProductLine.taxTotal | currency}}</td></tr><!-- <tr ng-if="vm.update">\n                            <td colspan="11">\n                                <button type="button" class="btn-flow" style="cursor: pointer;border: 0;"\n                                        ng-click="vm.productAdd()"><i></i>\u65B0\u5EFA\u5546\u54C1\n                                </button>\n                            </td>\n                        </tr> --></tbody></table></div></div></div><div class="c-form"><div class="c-form-div" style="width: auto"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'New\' || vm.purchaseOrder.status == \'AlreadyIssued\'">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1" ng-click="save(true)" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'New\'">\u4FDD\u5B58\u5E76\u63D0\u4EA4</button> <button type="button" class="c-btn c-btn1" ng-click="audit(true)" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'ToBeAudited\'">\u901A\u8FC7</button> <button type="button" class="c-btn c-btn1" ng-click="audit()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'ToBeAudited\'">\u62D2\u7EDD</button> <button type="button" class="c-btn c-btn1" ng-click="export()" ng-if="vm.purchaseOrder.id">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn2" ng-click="close()" ng-disabled="vm.isSaving" ng-if="vm.purchaseOrder.status == \'New\' && vm.purchaseOrder.id">\u5173\u95ED</button> <button type="button" class="c-btn c-btn2" ng-click="cancelSave()">\u8FD4\u56DE</button></div></div></div></div><style>.c-form-div{\n        line-height: 30px;\n    }</style>');
$templateCache.put('app/purchase/purchaseReturnOrder/purchaseReturnOrder-preview.html','<div class="bgc-fff p30"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u9000\u8D27\u5355\u9884\u89C8</span> <button type="button" class="c-btn c-btn1" ng-click="preview()">\u6253\u5370\u9884\u89C8</button> <button type="button" class="c-btn c-btn2" ng-click="goback()">\u8FD4\u56DE</button></div><div class="mtop20" id="previewId" style="box-shadow: 0 0 24px 0 rgba(0, 0, 0, .2); padding: 50px"><div style="font-size: 30px;font-weight: bold; height: 80px; border-bottom: 1px solid #ddd; text-align: center; color: #333; margin-bottom: 40px">MOMENTSGO\u9000\u8D27\u5355</div><div style="display: flex;flex-wrap: wrap"><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u4F9B\u5E94\u5546:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.supplierName}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u9000\u8D27\u7C7B\u578B:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.type == \'Outsourcing\' ? \'\u6210\u54C1\u9000\u8D27\' : (vm.purchaseOrder.type == \'RawMaterial\' ? \'\u6750\u6599\u9000\u8D27\' : \'\u672A\u77E5\')}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u9000\u8D27\u65E5\u671F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.approveDate | date:\'yyyy-MM-dd\'}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u9000\u8D27\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.number}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u91C7\u8D2D\u5355\u53F7:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.orderNumber}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u9000\u8D27\u4ED3\u5E93:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.warehouseName}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u8054\u7CFB\u4EBA:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.contact}}</div></div><div class="c-form" style="width: 25%"><label class="c-form-label control-label font-style">\u8054\u7CFB\u65B9\u5F0F:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.phone}}</div></div><div class="c-form" style="width: 100%"><label class="c-form-label control-label font-style">\u6536\u8D27\u5730\u5740:</label><div class="c-form-div" style="color: #333; width: 100%; line-height: 30px">{{vm.purchaseOrder.address}}</div></div></div><div class="c-form"><label class="c-form-label control-label font-style">\u9000\u8D27\u5546\u54C1:</label><div class="c-form-div" style="width:auto"><div class="c-table1"><table><thead><tr><th>\u9000\u8D27\u5546\u54C1</th><th>\u5546\u54C1SKU</th><th>scm\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u9000\u8D27\u6570\u91CF</th><th>\u9000\u8D27\u5355\u4EF7</th><th>\u5408\u8BA1</th><th>\u9000\u8D27\u542B\u7A0E\u5355\u4EF7</th><th>\u7A0E\u7387(%)</th><th>\u52A0\u7A0E\u5408\u8BA1</th></tr></thead><tbody><tr ng-repeat="purchaseProductLine in vm.purchaseOrder.returnLines track by $index" ng-if="!purchaseProductLine.cancelled"><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.productName}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.propertyConfigSku}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.propertyConfigNumber}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.measurementName}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.num}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">\uFFE5{{purchaseProductLine.price || 0}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.total | currency}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">\uFFE5{{purchaseProductLine.taxPrice || 0}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.tax}}</td><td style="width: 90px;min-width: 90px;max-width: 90px">{{purchaseProductLine.taxTotal| currency}}</td></tr></tbody></table></div></div></div><div style="text-align: right; font-size: 18px; color: #333; line-height: 30px"><div style="width: 200px; display: inline-block;text-align: left">\u9000\u8D27\u5408\u8BA1\uFF1A{{vm.purchaseOrder.amount | currency}}</div><br><div style="width: 200px; display: inline-block;text-align: left">\u8FD0\u8D39\u5408\u8BA1\uFF1A{{vm.purchaseOrder.freight | currency}}</div></div><div style="text-align: right; font-size: 18px; color: #000; border-top: 1px solid #ddd; margin-top: 30px; padding-top: 30px"><div style="width: 200px; display: inline-block;text-align: left">\u9000\u8D27\u603B\u989D\uFF1A{{(vm.purchaseOrder.amount + vm.purchaseOrder.freight) | currency}}</div></div></div></div>');
$templateCache.put('app/purchase/purchaseReturnOrder/purchaseReturnOrder.html','<div class="bgc-fff"><div class="bgc-fff"><div class="table-top clearfix"><ul class="clearfix table-state"><li ng-repeat="data in vm.selection track by $index" ng-click="conditionSelect(data)" ng-class="data.value == vm.tableData.status ?\'pitchOn\':\'\'">{{data.name}}</li></ul><div class="table-state-btn" ng-click="tableStateBtn()" ng-if="vm.isTableState"><img src="content/images/arrdp.png" alt=""></div></div><div class="p30"><div class="clearfix"><span class="title1">\u9000\u8D27\u5355\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ng-click="exportDetails()">\u5BFC\u51FA\u660E\u7EC6\u8868</button></div><div class="form-search2 mtop20"><ul class="clearfix"><li><p>\u9000\u8D27\u5355\u53F7</p><div class="form-search2-term"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.number"></div></li><li><p>\u91C7\u8D2D\u5355\u53F7</p><div class="form-search2-term"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7\u641C\u7D22" ng-model="vm.tableData.orderNumber"></div></li><!-- <li>\n                    <p>\u65E5\u671F\u7C7B\u578B</p>\n                    <div class="form-search2-term">\n                        <select class="c-select1" ng-model="vm.dateType">\n                            <option value="purchase">\u9000\u8D27\u65E5\u671F</option>\n                            <option value="store">\u5165\u5E93\u65E5\u671F</option>\n                        </select>\n                    </div>\n                </li> --><li><p>\u9009\u62E9\u65F6\u95F4</p><div class="form-search2-term"><div class="form-time"><input type="text" class="c-input1" id="startDate" ng-model="vm.tableData.startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" id="endDate" ng-model="vm.tableData.endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div></li><li><p>\u4F9B\u5E94\u5546</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u5168\u90E8</option></select></div></li><li><p>\u9000\u8D27\u4ED3\u5E93</p><div class="form-search2-term"><select class="c-select1" ng-model="vm.tableData.warehouseId" ng-options="data.id as data.name for data in vm.warehouses"><option value="">\u5168\u90E8</option></select></div></li><li><p></p><div class="form-search2-term"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div></li></ul></div><div class="c-table mtop20 scrollbar-main"><table style="width: 2300px; overflow-x: auto" class="purchaseProductLine-table"><thead><tr><th>\u9000\u8D27\u5355\u53F7</th><th>\u91C7\u8D2D\u5355\u53F7</th><th>\u9000\u8D27\u7C7B\u578B</th><th>\u9000\u8D27\u603B\u91CF</th><th>\u9000\u8D27\u603B\u4EF7</th><th>\u9000\u8D27\u4ED3\u5E93</th><th>\u4F9B\u5E94\u5546</th><th>\u72B6\u6001</th><th>\u9000\u8D27\u65E5\u671F</th><th>\u6700\u540E\u4FEE\u6539</th><th>\u64CD\u4F5C\u5458</th><th>\u9000\u8D27\u539F\u56E0</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 150px;max-width: 150px;min-width: 150px">{{data.number}}</td><td style="width: 150px;max-width: 150px;min-width: 150px">{{data.orderNumber}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.type == \'Outsourcing\' ? \'\u6210\u54C1\u9000\u8D27\' : (data.type == \'RawMaterial\' ? \'\u6750\u6599\u9000\u8D27\' : \'\u672A\u77E5\')}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.quantity}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.amount | currency}}</td><td style="width: 200px;max-width: 200px;min-width: 200px">{{data.warehouseName}}</td><td style="width: 200px;max-width: 200px;min-width: 200px">{{data.supplierName}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" ng-style="purchaseOrderType(data.status)" ng-if="!data.cancelled">{{purchaseOrderType(data.status).text}}</td><td style="width: 100px;max-width: 100px;min-width: 100px" ng-if="data.cancelled">\u5DF2\u5173\u95ED</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.approveDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.lastModifiedDate | date:\'yyyy-MM-dd\'}}</td><td style="width: 100px;max-width: 100px;min-width: 100px">{{data.operator}}</td><td style="width: 200px;max-width: 200px;min-width: 200px">{{data.remark}}</td><td style="width: 100px;max-width: 100px;min-width: 100px"><button class="c-minBtn c-minBtn1" ui-sref="purchaseReturnOrderEdit({id:data.id})" ng-if="data.status == \'New\' && !data.cancelled">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ui-sref="purchaseReturnOrderEdit({id:data.id})" ng-if="data.status != \'New\' && !data.cancelled">\u8BE6\u60C5</button> <button class="c-minBtn c-minBtn3" ui-sref="purchaseReturnOrderPreview({id:data.id})" ng-if="!data.cancelled">\u67E5\u770B</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="20" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table><!--            <table style="width: 2300px; overflow-x: auto;">--><!--                <thead>--><!--                <tr>--><!--                    <th>\u9000\u8D27\u8BA2\u5355</th>--><!--                    <th>\u9000\u8D27\u5546\u54C1</th>--><!--                    <th>\u9000\u8D27\u7C7B\u578B</th>--><!--                    <th>\u9000\u8D27\u72B6\u6001</th>--><!--                    <th>\u4F9B\u5E94\u5546</th>--><!--                    <th>\u9000\u8D27\u65F6\u95F4</th>--><!--                    <th>\u8BA1\u5212\u4EA4\u671F</th>--><!--                    <th>\u5355\u4F4D</th>--><!--                    <th>\u8BA2\u8D2D\u6570\u91CF</th>--><!--                    <th>\u5165\u5E93\u6570\u91CF</th>--><!--                    <th>\u5355\u4EF7</th>--><!--                    <th>\u5408\u8BA1</th>--><!--                    <th>\u542B\u7A0E\u5355\u4EF7</th>--><!--                    <th>\u7A0E\u7387\uFF08%\uFF09</th>--><!--                    <th>\u7A0E\u989D</th>--><!--                    <th>\u52A0\u7A0E\u5408\u8BA1</th>--><!--                    <th>\u8FD0\u8D39</th>--><!--                    <th>\u9000\u8D27\u603B\u4EF7</th>--><!--&lt;!&ndash;                    <th>\u9ED8\u8BA4\u5165\u5E93</th>&ndash;&gt;--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0">--><!--                    <td style="width: 150px;max-width: 150px;min-width: 150px;">{{data.purchaseOrderNumber}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.propertyConfig.sku}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.status == \'Outsourcing\' ? \'\u6210\u54C1\u9000\u8D27\' : (data.status == \'RawMaterial\' ? \'\u6750\u6599\u9000\u8D27\' : \'\u672A\u77E5\')}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.state == \'Finished\' ? \'\u5B8C\u6210\' : (data.state == \'New\' ? \'\u65B0\u5EFA\' : (data.state == \'ToBeAudited\' ? \'\u5F85\u5BA1\u6838\' : (data.state == \'ToBeRevised\' ? \'\u5F85\u4FEE\u8BA2\' : (data.state == \'AlreadyIssued\' ? \'\u5DF2\u4E0B\u8FBE\' : \'\u672A\u77E5\'))))}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.supplierName}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.createdDate | date:\'yyyy-MM-dd\'}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.deliveryDate | date:\'yyyy-MM-dd\'}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.measurement.name}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.num}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.warehousingNum}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.price | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.total | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.taxPrice | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.tax}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.num * data.taxPrice | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.taxTotal | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.freight | currency}}</td>--><!--                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.taxTotal + data.freight | currency}}</td>--><!--&lt;!&ndash;                    <td style="width: 100px;max-width: 100px;min-width: 100px;">{{data.warehouseName}}</td>&ndash;&gt;--><!--                </tr>--><!--                <tr class="noData" ng-if="vm.tableList.length == 0">--><!--                    <td colspan="20" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td>--><!--                </tr>--><!--                </tbody>--><!--            </table>--></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div></div><style>.purchaseProductLine-table{\n        tr td:last-child, th:last-child {\n            position: sticky;\n            right: 0px;\n            background: #fff;\n        }\n    }</style></div>');
$templateCache.put('app/setting/channel/channel-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u6E20\u9053</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9884\u8B66\u91D1\u989D\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="0" class="c-input1" ng-model="vm.data.warnBalance"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7EC4\u7248\u6587\u4EF6url\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.url" minlength="1"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u62FC\u7248\u6587\u4EF6url\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.makeupUrl" minlength="1"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u4F1A\u5458\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.vipEnable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u652F\u6301\u54C1\u7C7B\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><button type="button" class="btn-yellow-common btn-edit" ng-click="chooseProduct()">\u67E5\u770B</button></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u504F\u8FDC\u5730\u533A\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><button class="btn-yellow-common btn-edit" ng-click="productionSet()">\u8BBE\u7F6E</button></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u57DF\u540D\u8BBE\u7F6E\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.domain"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u901A\u77E5\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.logisticsInformApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u8F68\u8FF9\u66F4\u65B0\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.orderTracesApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5B9A\u5236\u8BA2\u5355\u64A4\u56DE\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.orderCloseApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px; padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/channel/channel-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u6E20\u9053</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u8D26\u6237\u4F59\u989D\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><span style="font-size: 16px;margin-right: 30px">{{vm.data.balance}}</span> <button type="button" class="btn-yellow-common btn-edit" ng-click="recharge()">\u5145\u503C</button> <button type="button" ng-if="!!vm.data.balance" class="btn-yellow-common btn-edit" ng-click="transactionDetail()">\u4EA4\u6613\u660E\u7EC6</button></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9884\u8B66\u91D1\u989D\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="0" class="c-input1" ng-model="vm.data.warnBalance"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7EC4\u7248\u6587\u4EF6url\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.url" minlength="1"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u62FC\u7248\u6587\u4EF6url\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.makeupUrl" minlength="1"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u4F1A\u5458\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.vipEnable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u652F\u6301\u54C1\u7C7B\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><button type="button" class="btn-yellow-common btn-edit" ng-click="chooseProduct()">\u67E5\u770B</button></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u504F\u8FDC\u5730\u533A\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><button class="btn-yellow-common btn-edit" ng-click="productionSet()">\u8BBE\u7F6E</button></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u57DF\u540D\u8BBE\u7F6E\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.domain"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u901A\u77E5\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.logisticsInformApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u8F68\u8FF9\u66F4\u65B0\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.orderTracesApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5B9A\u5236\u8BA2\u5355\u64A4\u56DE\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.orderCloseApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px; padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/channel/channel.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6E20\u9053\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ui-sref="channelAdd">\u65B0\u5EFA\u6E20\u9053</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u6E20\u9053\u540D\u79F0</th><th style="text-align: center">\u8D26\u6237\u4F59\u989D</th><th style="text-align: center">\u9884\u8B66\u91D1\u989D</th><!-- <th style="text-align: center;">secretKey</th> --><th style="text-align: center">appid</th><th style="text-align: center">appSecret</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u662F\u5426\u4F1A\u5458</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="text-align: center">{{data.name}}</td><td style="text-align: center">{{data.balance}}</td><td style="text-align: center">{{data.warnBalance}}</td><!-- <th style="text-align: center;">{{data.secretKey}}</th> --><th style="text-align: center">{{data.appId}}</th><th style="text-align: center">{{data.appSecret}}</th><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="text-align: center">{{data.vipEnable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="channelEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="10" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/channel/chooseProduct.html','<div class="bg-content"><div class="bg-center" style="min-height: 500px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u9009\u62E9\u5546\u54C1</span><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22\u3002" ng-model="vm.keyword"> <button type="button" ng-click="search()"></button></div></div></div><div class="mtop20 clearfix"><div class="pull-left width_20_percent" style="padding: 0px; overflow: hidden"><div class="centent"><div class="treebox scrollsXY" style="overflow-x: auto"><div class="tree"><ul><li ng-repeat="(key, value) in vm.productList"><div class="open_menu"><span></span>{{key}}</div><ul ng-repeat="(key2, value2) in value track by $index"><li ng-repeat="(key2_, value2_) in value2 track by $index"><div class="open_menu"><span></span>{{key2_}}</div><ul ng-repeat="(key3, value3) in value2_ track by $index"><li ng-repeat="(key3_, value3_) in value3 track by $index"><input type="checkbox" ng-model="value3_.select_all" ng-click="selectAll(key3_, value3_)"> <a ng-class="{\'ontree\' : vm.navKey == key3_}" ng-click="getProduct(key3_, value3_)">{{key3_}}</a></li></ul></li></ul></li></ul></div></div></div></div><div class="pull-left c-table width_80_percent pad-left-10"><table><thead><tr style="border-bottom: 1px solid #000"><th>\u9009\u62E9</th><th>\u5546\u54C1\u540D\u79F0</th><th>\u5546\u54C1\u7F16\u53F7</th><th>\u5355\u4F4D</th><th>\u5546\u54C1\u7C7B\u578B</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0" ng-class="{\'activeBg\' : vm.selectIndex == $index}"><td><input type="checkbox" ng-model="data.checked" ng-click="productChoice(data, vm.tableList)"></td><td>{{data.sku}}</td><td>{{data.number}}</td><td>{{data.unit}}</td><td>{{data.category == \'OrderingProduct\' ? \'\u5B9A\u5236\u5546\u54C1\' : (data.category == \'GeneralProduct\' ? \'\u6807\u51C6\u901A\u54C1\' : (data.category == \'StandardProduct\' ? \'\u6807\u51C6\u5370\u54C1\' : \'\u672A\u77E5\'))}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="4" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9,\u8BF7\u9009\u62E9\u6570\u636E</span></td></tr></tbody></table></div></div><div class="c-form mtop20"><div class="wid_100"><button type="button" class="c-btn c-btn1" style="width: 130px" ng-click="confirm()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancel()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/channel/recharge-amount.html','<div class="bg-content"><div class="user-modal bg-center" style="min-height: 180px!important"><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u5145\u503C\u91D1\u989D</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="number" class="form-control-edit" placeholder="\u8BF7\u8F93\u5165\u5145\u503C\u91D1\u989D" ng-model="vm.balance"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/channel/transaction-detail.html','<div class="bg-content"><div class="user-modal bg-center" style="width: 100%!important"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u4EA4\u6613\u8BB0\u5F55</span></div><div class="mtop20 clearfix"><div class="c-form" style="margin: 0"><label class="c-form-label">\u4EA4\u6613\u65F6\u95F4\uFF1A</label><div class="form-time"><!--                    <input type="text" class="c-input1" style="width: 150px;" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',minDate:\'#F{$dp.$D(\\\'endDate\\\',{d:-31})}\',maxDate:\'#F{$dp.$D(\\\'endDate\\\')}\'})">--> <input type="text" class="c-input1" style="width: 150px" ng-model="vm.tableData.startDate" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" style="width: 150px" ng-model="vm.tableData.endDate" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="clearfix" style="margin: 10px 0 0 0"><div class="c-form clearfix" style="float: left; margin: 0"><label class="c-form-label">\u4EA4\u6613\u7C7B\u578B\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.tableData.type" style="width: 150px" ng-options="type.name as type.value for type in vm.types" ng-change="search()"><option value="">\u4EA4\u6613\u7C7B\u578B</option></select></div></div><div style="float: left"><button type="button" class="c-btn c-btn1 hei_30" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn1 hei_30" ng-click="export()">\u4E0B\u8F7D</button></div></div></div><div class="c-table mtop20 th-35"><table><thead><tr><th style="width: 190px" class="no-padding">\u4EA4\u6613\u65F6\u95F4</th><th style="width: 160px" class="no-padding">\u4EA4\u6613\u7C7B\u578B</th><th style="width: 160px" class="no-padding">\u4EA4\u6613\u91D1\u989D</th><th style="width: 150px" class="no-padding">\u4EA4\u6613\u540E\u91D1\u989D</th><th style="width: 150px" class="no-padding">\u5546\u6237\u6E90\u5355\u53F7</th><th style="width: 150px" class="no-padding">\u64CD\u4F5C\u8005</th></tr></thead></table></div><div class="c-table th-35" style="height: 250px"><table><!--                <thead>--><!--                <tr>--><!--                    <th>\u4EA4\u6613\u65F6\u95F4</th>--><!--                    <th>\u4EA4\u6613\u7C7B\u578B</th>--><!--                    <th>\u4EA4\u6613\u91D1\u989D</th>--><!--                    <th>\u4EA4\u6613\u540E\u91D1\u989D</th>--><!--                    <th>\u64CD\u4F5C\u8005</th>--><!--                </tr>--><!--                </thead>--><tbody><tr ng-repeat="record in vm.records |orderBy:\'-createdDate\' track by $index"><td style="width: 190px">{{record.createdDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td style="width: 160px">{{record.type == \'plus\' ? \'\u5145\u503C\' : record.type == \'minus\' ? \'\u6D88\u8D39\' : record.type == \'refund\' ? \'\u9000\u6B3E\' : \'--\'}}{{record.num}}</td><td style="width: 160px">{{record.amount}}</td><td style="width: 150px">{{record.afterAmount}}</td><td style="width: 150px">{{record.sourceOrderNumber}}</td><td style="width: 150px">{{record.createdBy ==\'anonymousUser\' ? \'\u7CFB\u7EDF\u64CD\u4F5C\':record.createdBy}}</td></tr><tr class="noData" ng-if="vm.records.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div><div class="c-paging" style="margin-bottom: 20px;text-align: center!important"><button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/setting/client/client.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5BA2\u6237\u7AEF\u8BBE\u7F6E</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u6700\u65B0\u5BA2\u6237\u7AEF\u7248\u672C\u53F7\uFF1A</label><div class="c-form-div" style="width: 400px; padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.jhiKey.value" placeholder="\u6700\u65B0\u5BA2\u6237\u7AEF\u7248\u672C\u53F7"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6700\u65B0\u5BA2\u6237\u7AEF\u6587\u4EF6\u5305\uFF1A</label><div class="c-form-div" style="width: 400px;padding-left:50px;position: relative"><span style="font-size: 16px;display: inline-block;width: 150px">{{vm.flag ?\'\u6587\u4EF6\u5DF2\u5B58\u5728\':\'\u6587\u4EF6\u4E0D\u5B58\u5728\'}}</span> <button type="button" class="c-btn c-btn1">\u4E0A\u4F20exe\u6587\u4EF6</button> <input type="file" id="file" name="myfile" onchange="uploadExe(event)" accept=".exe" style="position: absolute; width:120px;left: 200px; top: 0; right: 0; bottom: 0; z-index: 1; opacity :0"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button></div></div></div></div>');
$templateCache.put('app/setting/deliveryConfig/deliveryConfig.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53D1\u8D27\u4FE1\u606F\u914D\u7F6E</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 250px">\u53D1\u8D27\u4EBA\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.username" placeholder="\u53D1\u8D27\u4EBA"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.phone" placeholder="\u8054\u7CFB\u65B9\u5F0F"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u7701\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5E02\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u533A\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5730\u5740\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.address" placeholder="\u5730\u5740"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5907\u6CE8\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.remarks" placeholder="\u5907\u6CE8"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u9762\u5355\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.templateSize" placeholder="\u9762\u5355\u5C3A\u5BF8"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mtop20 mr10" ng-click="saveExpress()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button></div></div></div></div>');
$templateCache.put('app/setting/deliveryConfig/receiptConfig.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6536\u8D27\u4FE1\u606F\u914D\u7F6E</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 250px">\u6536\u8D27\u4EBA\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.username" placeholder="\u53D1\u8D27\u4EBA"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u8054\u7CFB\u65B9\u5F0F\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.phone" placeholder="\u8054\u7CFB\u65B9\u5F0F"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u7701\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5E02\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u533A\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5730\u5740\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.address" placeholder="\u5730\u5740"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5907\u6CE8\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.remarks" placeholder="\u5907\u6CE8"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u9762\u5355\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.deliveryConfig.templateSize" placeholder="\u9762\u5355\u5C3A\u5BF8"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mtop20 mr10" ng-click="saveExpress()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button></div></div></div></div>');
$templateCache.put('app/setting/depository/depository-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u4ED3\u5E93</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u4ED3\u5E93\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4ED3\u5E93\u540D\u79F0\uFF0820\u5B57\u4EE5\u5185\uFF09" ng-model="vm.data.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u4ED3\u5E93\u5C5E\u6027\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.houseSource" ng-options="data.value as data.name for data in vm.houseSourceList" ng-change="houseSourceType()"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93\u5C5E\u6027</option></select></div></div><div class="c-form"><label class="c-form-label">\u4ED3\u5E93\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.type" ng-options="data.value as data.name for data in vm.typeList"><option value="">\u8BF7\u9009\u62E9\u4ED3\u5E93\u7C7B\u578B</option></select></div></div><div class="c-form"><label class="c-form-label">\u4ED3\u5E93\u7F16\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4ED3\u5E93\u7F16\u53F7" ng-model="vm.data.number"></div></div><div class="c-form" ng-if="vm.data.houseSource == \'External\'"><label class="c-form-label">\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.supplier" ng-options="data.name for data in vm.supplierList track by data.id"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA" ng-model="vm.data.contacts"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u7535\u8BDD\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u7535\u8BDD" ng-model="vm.data.phone"></div></div><div class="c-form"><label class="c-form-label" style="padding-right: 20px">\u5730\u5740:</label><div class="c-form-div wid-800"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><textarea type="text" class="form-control-edit" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" style="resize: none" ng-model="vm.data.address"></textarea></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.data.defaulted"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="depository">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/depository/depository.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4ED3\u5E93\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="depositoryAdd">\u65B0\u5EFA\u4ED3\u5E93</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.keyword" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u4ED3\u5E93\u540D\u79F0</th><th style="text-align: center">\u4ED3\u5E93\u7C7B\u578B</th><th style="text-align: center">\u4ED3\u5E93\u7F16\u53F7</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.type}}">{{data.type == \'product\' ? \'\u6210\u54C1\u5E93\' : (data.type == \'accessories\' ? \'\u539F\u8F85\u6750\u6599\u5E93\' : \'\u672A\u77E5\') |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.number}}">{{data.number|limitTo:\'10\'}}</td><td style="text-align: center">{{data.defaulted ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="depositoryEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="depositoryDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/express/express-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u5FEB\u9012</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" ng-model="vm.express.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u522B\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u522B\u540D" ng-model="vm.express.alias" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u9E1F\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F16\u7801" ng-model="vm.express.code" maxlength="50"></div></div><div class="c-form"><label class="c-form-label">\u83DC\u9E1F\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F16\u7801" ng-model="vm.express.cainiaoCode" maxlength="50"></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.supplier" ng-options="data.name for data in vm.suppliers" ng-change="selectSup(vm.supplier)"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label">\u542F\u7528\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.express.enable"></div></div><div class="c-form"><label class="c-form-label">\u5BA2\u6237\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u5BA2\u6237\u53F7" ng-model="vm.express.customerId" maxlength="50"></div></div><div class="c-form"><label class="c-form-label">\u5BA2\u6237\u5BC6\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u5BA2\u6237\u7F16\u7801" ng-model="vm.express.customerPassword" maxlength="60"></div></div><div class="c-form"><label class="c-form-label">\u7F51\u70B9\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F51\u70B9\u540D\u79F0" ng-model="vm.express.site" maxlength="60"></div></div><div class="c-form"><label class="c-form-label">\u7F51\u70B9\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F51\u70B9\u7F16\u7801" ng-model="vm.express.siteNumber" maxlength="60"></div></div><div class="c-form"><label class="c-form-label">\u8D85\u91CD\u9608\u503C(kg)\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D85\u91CD\u9608\u503C" ng-model="vm.express.overweight" max="99999"></div></div><div class="c-form"><label class="c-form-label">\u504F\u8FDC\u5730\u533A\uFF1A</label><div class="c-form-div wid-800"><button class="btn-yellow-common btn-edit" ng-click="productionSet()">\u8BBE\u7F6E</button></div></div><div class="c-form"><label class="c-form-label">\u4F18\u5148\u7EA7\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D85\u91CD\u9608\u503C" ng-model="vm.express.seq"></div></div><div class="c-form"><label class="c-form-label">\u53EF\u53D1\u8D27\u5730\u533A\uFF1A</label><div class="c-form-div wid-800"><button class="btn-yellow-common btn-edit" ng-click="shipments()">\u8BBE\u7F6E</button></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="express">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/express/express-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u5FEB\u9012</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" ng-model="vm.express.name" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u522B\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u522B\u540D" ng-model="vm.express.alias" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u5FEB\u9012\u9E1F\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F16\u7801" ng-model="vm.express.code" maxlength="50"></div></div><div class="c-form"><label class="c-form-label">\u83DC\u9E1F\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F16\u7801" ng-model="vm.express.cainiaoCode" maxlength="50"></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.supplier" ng-options="data.name for data in vm.suppliers" ng-change="selectSup(vm.supplier)"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label">\u542F\u7528\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.express.enable"></div></div><div class="c-form"><label class="c-form-label">\u5BA2\u6237\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u5BA2\u6237\u53F7" ng-model="vm.express.customerId" maxlength="50"></div></div><div class="c-form"><label class="c-form-label">\u5BA2\u6237\u5BC6\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u5BA2\u6237\u7F16\u7801" ng-model="vm.express.customerPassword" maxlength="60"></div></div><div class="c-form"><label class="c-form-label">\u7F51\u70B9\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F51\u70B9\u540D\u79F0" ng-model="vm.express.site" maxlength="60"></div></div><div class="c-form"><label class="c-form-label">\u7F51\u70B9\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F51\u70B9\u7F16\u7801" ng-model="vm.express.siteNumber" maxlength="60"></div></div><div class="c-form"><label class="c-form-label">\u8D85\u91CD\u9608\u503C(kg)\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D85\u91CD\u9608\u503C" ng-model="vm.express.overweight" max="99999"></div></div><div class="c-form"><label class="c-form-label">\u504F\u8FDC\u5730\u533A\uFF1A</label><div class="c-form-div wid-800"><button class="btn-yellow-common btn-edit" ng-click="productionSet()">\u8BBE\u7F6E</button></div></div><div class="c-form"><label class="c-form-label">\u4F18\u5148\u7EA7\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D85\u91CD\u9608\u503C" ng-model="vm.express.seq"></div></div><div class="c-form"><label class="c-form-label">\u53EF\u53D1\u8D27\u5730\u533A\uFF1A</label><div class="c-form-div wid-800"><button class="btn-yellow-common btn-edit" ng-click="shipments()">\u8BBE\u7F6E</button></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="express">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/express/express.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5FEB\u9012\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="expressAdd">\u65B0\u5EFA\u5FEB\u9012</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u7F51\u70B9\u540D\u79F0\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.keyword" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5FEB\u9012\u9E1F\u7F16\u7801</th><th style="text-align: center">\u83DC\u9E1F\u7F16\u7801</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u6240\u5C5E\u4F9B\u5E94\u5546</th><th style="text-align: center">\u542F\u7528</th><th style="text-align: center">\u5BA2\u6237\u53F7</th><th style="text-align: center">\u5BA2\u6237\u5BC6\u7801</th><th style="text-align: center">\u7F51\u70B9\u540D\u79F0</th><th style="text-align: center">\u7F51\u70B9\u7F16\u7801</th><th style="text-align: center">\u8D85\u91CD\u9608\u503C(kg)</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.code}}">{{data.code |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.cainiaoCode}}">{{data.cainiaoCode |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.name}}">{{data.name |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.supplierName}}">{{data.supplierName |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.enable}}">{{data.enable ?\'\u662F\' : \'\u5426\'}}</td><td style="text-align: center" title="{{data.customerId}}">{{data.customerId|limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.customerPassword |limitTo:\'10\'}}">{{data.customerPassword }}</td><td style="text-align: center" title="{{data.site}}">{{data.site |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.siteNumber}}">{{data.siteNumber |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.overweight}}">{{data.overweight}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="expressEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="expressDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="11" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/expressApiConfig/expressApiConfig.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5FEB\u9012\u9E1F\u6E20\u9053\u8BBE\u7F6E</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 250px">appId\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.expressApiSettings.appId" placeholder="appId"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">appSecret\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.expressApiSettings.appSecret" placeholder="appSecret"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">domain\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.expressApiSettings.domain" placeholder="domain"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">expressOrderApi\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.expressApiSettings.expressOrderApi" placeholder="expressOrderApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">expressTraceApi\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.expressApiSettings.expressTraceApi" placeholder="expressTraceApi"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mtop20 mr10" ng-click="saveExpress()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button></div></div></div></div>');
$templateCache.put('app/setting/inform/inform.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6D88\u606F\u901A\u77E5</span><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.filter" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table style="text-align: center"><tr><th style="text-align: center"></th><th style="text-align: center; width: 300px">\u6807\u9898</th><th style="text-align: center">\u5185\u5BB9</th><th style="text-align: center">\u901A\u77E5\u65F6\u95F4</th><th style="text-align: center">\u64CD\u4F5C</th></tr><tr ng-repeat="data in vm.tableList track by $index" on-finish-render ng-if="vm.tableList.length > 0"><td><img src="../content/images/gs1_u_read.png" ng-click="read(data)" ng-if="!data.read"> <img src="../content/images/gs1_read.png" ng-if="!!data.read"></td><td title="{{data.title}}">{{data.title}}</td><td title="{{data.content}}">{{data.content}}</td><td title="{{data.content}}">{{data.createdDate | date:\'yyyy-MM-dd HH:mm\' }}</td><td><button class="c-minBtn c-minBtn3" ng-click="read(data)" ng-if="!data.read">\u5DF2\u8BFB</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="4" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/interface/interface-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u63A5\u53E3</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.name"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6240\u5C5E\u6E20\u9053\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><select name="" class="c-select1" ng-model="vm.interface.channelId" ng-options="data.id as data.name for data in vm.channelList"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.interface.enabled" style="outline: none"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u57DF\u540D\u8BBE\u7F6E\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.domain"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9879\u76EE\u8BA2\u5355\u53D1\u8D27\u901A\u77E5\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.deliveryChangeApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u901A\u77E5\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.logisticsInformApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u8F68\u8FF9\u66F4\u65B0\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.orderTracesApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9879\u76EE\u83B7\u53D6\u8BA2\u5355\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.oneOrderApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px; padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.interface.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="interface">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/interface/interface-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u63A5\u53E3</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.name"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6240\u5C5E\u6E20\u9053\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><select name="" class="c-select1" ng-model="vm.interface.channelId" ng-options="data.id as data.name for data in vm.channelList"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.interface.enabled"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u57DF\u540D\u8BBE\u7F6E\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.domain"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9879\u76EE\u8BA2\u5355\u53D1\u8D27\u901A\u77E5\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.deliveryChangeApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u901A\u77E5\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.logisticsInformApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7269\u6D41\u8F68\u8FF9\u66F4\u65B0\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.orderTracesApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9879\u76EE\u83B7\u53D6\u8BA2\u5355\u63A5\u53E3\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.interface.oneOrderApi"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div" style="width: 800px; padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.interface.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="interface">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/interface/interface.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u63A5\u53E3\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="interfaceAdd">\u65B0\u5EFA\u63A5\u53E3</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u6240\u5C5E\u6E20\u9053</th><th style="text-align: center">\u63CF\u8FF0</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name.length >10 ? data.name.substr(0,10)+\'...\':data.name}}</td><td style="text-align: center">{{data.channelName}}</td><td style="text-align: center" title="{{data.description}}">{{data.description.length >10 ? data.description.substr(0,10)+\'...\':data.description}}</td><td style="text-align: center">{{data.enabled ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="interfaceEdit({id:data.id})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="interfaceDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/item/item-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.name" maxlength="20"></div></div><!--<div class="c-form">--><!--<label class="c-form-label">\u7C7B\u578B\uFF1A</label>--><!--<div class="c-form-div">--><!--<select name="" class="c-select1" ng-model="vm.data.type"--><!--ng-options="data.value as data.name for data in vm.typeList"--><!--ng-change="typeSelect()">--><!--<option value="">\u8BF7\u9009\u62E9</option>--><!--</select>--><!--</div>--><!--</div>--><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description" maxlength="50"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5C5E\u6027\uFF1A</label><div class="c-form-div wid-800"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u5C5E\u6027</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.itemValues track by $index"><td style="width: 80px; max-width: 80px; min-width: 80px; padding: 5px 10px">{{$index + 1}}</td><td style="padding: 0"><input type="text" class="c-input1" ng-model="data.name" style="border: 0"></td><td style="width: 130px; max-width: 130px; min-width: 130px; padding: 5px 10px; text-align: center"><button type="button" class="c-minBtn c-minBtn1" ng-click="itemDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="3"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="itemAdd()"><i></i>\u65B0\u5EFA\u5C5E\u6027\u503C</button></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="item">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/item/item-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.name" maxlength="20"></div></div><!--<div class="c-form">--><!--<label class="c-form-label">\u7C7B\u578B\uFF1A</label>--><!--<div class="c-form-div">--><!--<select name="" class="c-select1" ng-model="vm.data.type"--><!--ng-options="data.value as data.name for data in vm.typeList">--><!--<option value="">\u8BF7\u9009\u62E9</option>--><!--</select>--><!--</div>--><!--</div>--><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description" maxlength="50"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5C5E\u6027\uFF1A</label><div class="c-form-div wid-800"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u5C5E\u6027</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.itemValues track by $index"><td style="width: 80px; max-width: 80px; min-width: 80px; padding: 5px 10px">{{$index + 1}}</td><td style="padding: 0"><input type="text" class="c-input1" ng-model="data.name" style="border: 0"></td><td style="width: 130px; max-width: 130px; min-width: 130px; padding: 5px 10px; text-align: center"><button type="button" class="c-minBtn c-minBtn1" ng-click="itemDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="3"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="itemAdd()"><i></i>\u65B0\u5EFA\u5C5E\u6027\u503C</button></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/item/item.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5C5E\u6027\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ui-sref="itemAdd">\u65B0\u5EFA\u5C5E\u6027</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u63CF\u8FF0</th><!--<th>\u7C7B\u578B</th>--><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name.length >10?data.name.substr(0,10)+\'...\':data.name}}</td><td style="text-align: center" title="{{data.description}}">{{data.description.length >10? data.description.substr(0,10)+\'...\':data.description}}</td><!--<td>{{data.type}}</td>--><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="itemEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/machineTypes/machine-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u673A\u578B</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u673A\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u673A\u578B\u540D\u79F0" ng-model="vm.machine.type"></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.machine.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label">\u62FC\u7248\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-800 line_30"><span ng-if="vm.machine.makeups.length ==0" class="c-3A88E4" ng-click="setImposition()">\u8BBE\u7F6E</span> <span ng-repeat="makeup in vm.machine.makeups" ng-if="vm.machine.makeups.length >0">{{makeup.name}};</span> <span ng-if="vm.machine.makeups.length >0" class="c-3A88E4" ng-click="setImposition()">\u4FEE\u6539</span></div></div><div class="c-form"><label class="c-form-label">\u4EA7\u80FD\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4EA7\u80FD" ng-model="vm.machine.capacity"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.machine.enable"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="machine">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/machineTypes/machine-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u673A\u578B</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u673A\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u673A\u578B\u540D\u79F0" ng-model="vm.machine.type"></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.machine.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label">\u62FC\u7248\u65B9\u5F0F\uFF1A</label><div class="c-form-div wid-800 line_30"><span ng-if="vm.machine.makeups.length ==0" class="c-3A88E4" ng-click="setImposition()">\u8BBE\u7F6E</span> <span ng-repeat="makeup in vm.machine.makeups" ng-if="vm.machine.makeups.length >0">{{makeup.name}};</span> <span ng-if="vm.machine.makeups.length >0" class="c-3A88E4" ng-click="setImposition()">\u4FEE\u6539</span></div></div><div class="c-form"><label class="c-form-label">\u4EA7\u80FD\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4EA7\u80FD" ng-model="vm.machine.capacity"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.machine.enable"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="machine">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/machineTypes/machine.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u673A\u578B\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ui-sref="machineAdd">\u65B0\u5EFA\u673A\u578B</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.keyword" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u673A\u578B\u540D\u79F0</th><th style="text-align: center">\u6240\u5C5E\u4F9B\u5E94\u5546</th><th style="text-align: center">\u4EA7\u80FD</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.type}}">{{data.type |limitTo:\'20\'}}</td><td style="text-align: center" title="{{data.supplierName}}">{{data.supplierName|limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.capacity}}">{{data.capacity|limitTo:\'10\'}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="machineEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="machineDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/machineTypes/set-pin.html','<div class="bg-content"><div class="user-modal bg-center row"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u62FC\u7248\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding">\u62FC\u7248\u65B9\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-8"><ul><li ng-repeat="item in vm.items" ng-if="vm.items.length>0" class="pin-info" ng-click="chooseItem(item)" title="{{item.name}}"><img src="content/images/unselect.png" alt="" ng-if="!item.selected"> <img src="content/images/selected.png" alt="" ng-if="item.selected"> <span style="display: inline-block; width: 60%;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;line-height: 13px;font-size: 14px">{{item.name}}</span></li><li class="pin-info" style="width: 100%" ng-if="vm.items.length ==0">\u6682\u65E0\u62FC\u7248\u65B9\u5F0F \u8BF7\u6DFB\u52A0</li></ul></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" style="margin-top: 30px"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/makeup/makeup-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.makeup.name"></div></div><!--<div class="c-form">--><!--<label class="c-form-label">FFC\u62FC\u7248\u6587\u4EF6\uFF1A</label>--><!--<div class="c-form-div">--><!--<select name="" class="c-select1" ng-model="vm.makeup.ffcFile"--><!--ng-options="data.value as data.name for data in vm.ffcFileList">--><!--<option value="">\u8BF7\u9009\u62E9</option>--><!--</select>--><!--</div>--><!--</div>--><div class="c-form"><label class="c-form-label" style="width: 150px">\u62FC\u7248\u901A\u9053\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.makeup.channel" maxlength="50"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6536\u96C6\u6570\u91CF\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" placeholder="\u8BF7\u8F93\u5165\u6536\u96C6\u6570\u91CF\uFF0C\u5982\u679C\u4E0D\u62FC\u677F\u5219\u4E3A0" class="c-input1" ng-model="vm.makeup.collectionNum" min="0"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.makeup.enable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.makeup.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="makeup">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/makeup/makeup-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.makeup.name"></div></div><!--<div class="c-form">--><!--<label class="c-form-label">FFC\u62FC\u7248\u6587\u4EF6\uFF1A</label>--><!--<div class="c-form-div">--><!--<select name="" class="c-select1" ng-model="vm.makeup.ffcFile"--><!--ng-options="data.value as data.name for data in vm.ffcFileList">--><!--<option value="">\u8BF7\u9009\u62E9</option>--><!--</select>--><!--</div>--><!--</div>--><div class="c-form"><label class="c-form-label" style="width: 150px">\u62FC\u7248\u901A\u9053\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.makeup.channel" maxlength="50"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6536\u96C6\u6570\u91CF\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" placeholder="\u8BF7\u8F93\u5165\u6536\u96C6\u6570\u91CF\uFF0C\u5982\u679C\u4E0D\u62FC\u677F\u5219\u4E3A0" class="c-input1" ng-model="vm.makeup.collectionNum" min="0"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.makeup.enable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.makeup.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/makeup/makeup.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u62FC\u7248\u65B9\u5F0F\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="makeupAdd">\u65B0\u5EFA\u62FC\u7248\u65B9\u5F0F</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u62FC\u7248\u901A\u9053\u540D\u79F0</th><th style="text-align: center">\u6536\u96C6\u6570\u91CF</th><th style="text-align: center">\u63CF\u8FF0</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name.length >10?data.name.substr(0,10)+\'...\':data.name}}</td><td style="text-align: center" title="{{data.channel}}">{{data.channel >10?data.channel.substr(0,10)+\'...\':data.channel}}</td><td style="text-align: center">{{data.collectionNum}}</td><td style="text-align: center" title="{{data.description}}">{{data.description.length >10? data.description.substr(0,10)+\'...\':data.description}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="makeupEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/materials/materials-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u7269\u6599\u6A21\u677F</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165\u6A21\u677F\u540D\u79F0" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.type" ng-options="data.value as data.name for data in vm.typeList" ng-change="typeSelect(vm.data.type)"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u54C1\u7C7B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.productCategoryId" ng-options="data.id as data.name for data in vm.productCategoryList" ng-change="productCategorySelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" ng-if="vm.superiorName"><label class="c-form-label">\u5546\u54C1\u54C1\u7C7B\u4E00\u7EA7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.superiorName" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description" maxlength="50"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5C5E\u6027\uFF1A</label><div class="c-form-div wid-800"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u5C5E\u6027</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.propertyList track by $index"><td style="width: 80px; max-width: 80px; min-width: 80px; padding: 5px 10px">{{$index + 1}}</td><td style="padding: 0"><select-view ng-if="vm.itemsList" ng-model="data.property" label-key="name" value-key="id" options="vm.itemsList" is-search="true"></select-view></td><td style="width: 130px; max-width: 130px; min-width: 130px; padding: 5px 10px; text-align: center"><button type="button" class="c-minBtn c-minBtn1" ng-click="propertyDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="3"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="propertyAdd()"><i></i>\u65B0\u5EFA\u5C5E\u6027</button></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="materials">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/materials/materials-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u7269\u6599\u6A21\u677F</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165\u6750\u6599\u6A21\u677F\u540D\u79F0" maxlength="20"></div></div><div class="c-form"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.type" ng-options="data.value as data.name for data in vm.typeList" ng-change="typeSelect(vm.data.type)"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label">\u5546\u54C1\u54C1\u7C7B\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.productCategoryId" ng-options="data.id as data.name for data in vm.productCategoryList" ng-change="productCategorySelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" ng-if="vm.superiorName"><label class="c-form-label">\u5546\u54C1\u54C1\u7C7B\u4E00\u7EA7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.superiorName" disabled="disabled"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.data.description" maxlength="50"></textarea></div></div><div class="c-form"><label class="c-form-label">\u5C5E\u6027\uFF1A</label><div class="c-form-div wid-800"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u5C5E\u6027</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="datas in vm.data.items track by $index"><td style="width: 80px; max-width: 80px; min-width: 80px; padding: 5px 10px">{{$index + 1}}</td><td style="padding: 0"><!-- <select name="" class="c-select1" ng-model="datas.id"\n                                        ng-options="i.id as i.name for i in vm.itemsList"\n                                        ng-change="itemSelect(datas, $index)"\n                                        style="border: 0;">\n                                    <option value="">\u8BF7\u9009\u62E9</option>\n                                </select> --><select-view ng-if="true" ng-model="datas.id" label-key="name" value-key="id" options="vm.itemsList" is-search="true"></select-view></td><td style="width: 130px; max-width: 130px; min-width: 130px; padding: 5px 10px; text-align: center"><button type="button" class="c-minBtn c-minBtn1" ng-click="propertyDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="3"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="propertyAdd()"><i></i>\u65B0\u5EFA\u5C5E\u6027</button></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/materials/materials.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7269\u6599\u6A21\u7248</span> <button type="button" class="c-btn c-btn1" ui-sref="materialsAdd">\u65B0\u5EFA\u6A21\u7248</button><div class="pull-right"><div class="c-form clearfix" style="padding-top: 3px; float: left; margin: 0"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div" style="width: 150px"><select name="" class="c-select1" ng-model="vm.tableData.type" ng-options="data.value as data.name for data in vm.typeList"></select></div></div><div class="form-search clearfix" style="float: left; margin-left: 15px"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u63CF\u8FF0</th><th style="text-align: center">\u7C7B\u578B</th><th style="text-align: center">\u5206\u7C7B</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name.length > 10 ? data.name.substr(0,10) + \'...\' : data.name}}</td><td style="text-align: center" title="{{data.description}}">{{data.description.length > 10 ? data.description.substr(0,10) + \'...\' : data.description}}</td><td style="text-align: center">{{data.type ==\'product\' ? \'\u5546\u54C1\u7C7B\' : data.type == \'accessories\' ? \'\u8F85\u6750\u7C7B\' : \'\'}}</td><td style="text-align: center">{{data.productCategoryName}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="materialsEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/merchant/merchant-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5546\u6237\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.merchant.name"></div></div><div class="c-form"><label class="c-form-label">\u5546\u6237\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.merchant.number"></div></div><div class="c-form"><label class="c-form-label">\u5206\u62E3\u63D0\u793A\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.merchant.sortingTips"></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u6E20\u9053\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.merchant.channelId" ng-options="data.id as data.name for data in vm.channelList"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u5BA2\u6237\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.merchant.customerHubId" ng-options="data.id as data.name for data in vm.customerHubList"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u5BA2\u6237</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.merchant.enable"></div></div><div class="c-form"><label class="c-form-label">\u6307\u5B9A\u5730\u5740</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.merchant.shipment"></div></div><div ng-show="vm.merchant.shipment"><div class="c-form"><label class="c-form-label">\u5730\u5740</label><div class="c-form-div wid-800"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" ng-model="vm.merchant.address"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u59D3\u540D" ng-model="vm.merchant.contact"></div></div><div class="c-form"><label class="c-form-label">\u624B\u673A\u53F7</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" ng-model="vm.merchant.phone"></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="merchant">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/merchant/merchant-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u5546\u6237\u540D\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.merchant.name"></div></div><div class="c-form"><label class="c-form-label">\u5546\u6237\u53F7\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.merchant.number"></div></div><div class="c-form"><label class="c-form-label">\u5206\u62E3\u63D0\u793A\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" ng-model="vm.merchant.sortingTips"></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u6E20\u9053\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.merchant.channelId" ng-options="data.id as data.name for data in vm.channelList"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u5BA2\u6237\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.merchant.customerHubId" ng-options="data.id as data.name for data in vm.customerHubList"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u5BA2\u6237</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.merchant.enable"></div></div><div class="c-form"><label class="c-form-label">\u6307\u5B9A\u5730\u5740</label><div class="c-form-div wid-800"><input type="checkbox" class="checkOrIf" ng-model="vm.merchant.shipment"></div></div><div ng-show="vm.merchant.shipment"><div class="c-form"><label class="c-form-label">\u5730\u5740</label><div class="c-form-div wid-800"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 33.3%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8F93\u5165\u8BE6\u7EC6\u5730\u5740" ng-model="vm.merchant.address"></div></div><div class="c-form"><label class="c-form-label">\u8054\u7CFB\u4EBA</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u59D3\u540D" ng-model="vm.merchant.contact"></div></div><div class="c-form"><label class="c-form-label">\u624B\u673A\u53F7</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F" ng-model="vm.merchant.phone"></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/merchant/merchant.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5546\u6237\u5217\u8868</span><div style="position: relative; display: inline-block"><button type="button" class="c-btn c-btn1">\u6279\u91CF\u5BFC\u5165</button> <input type="file" id="file" name="myfile" onchange="upladFile(event)" accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 1; opacity :0; width: 100%"></div><button type="button" class="c-btn c-btn1" ui-sref="merchantAdd">\u65B0\u589E\u5546\u6237</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5546\u6237\u540D</th><th style="text-align: center">\u5546\u6237\u53F7</th><th style="text-align: center">\u5206\u62E3\u63D0\u793A</th><th style="text-align: center">\u6240\u5C5E\u5BF9\u8C61</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name.length >10 ?data.name.substr(0,10)+\'...\':data.name}}</td><td style="text-align: center">{{data.number}}</td><td style="text-align: center" title="{{data.sortingTips}}">{{data.sortingTips.length >10 ?data.sortingTips.substr(0,10)+\'...\':data.sortingTips}}</td><td style="text-align: center">{{data.channelName ? data.channelName : data.customerHubName }}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="merchantEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/payment-settings/payment-settings-detail.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u652F\u4ED8\u8BBE\u7F6E</span></div><div class="modal-body" style="background-color: white;border-radius: 5px;min-height: 530px"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u5FAE\u4FE1\u79D8\u94A5</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.weChatKey}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u5FAE\u4FE1\u5546\u6237appid</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.weChatAppid}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u5FAE\u4FE1\u5546\u6237id</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.weChatMchid}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u5FAE\u4FE1\u652F\u4ED8\u56DE\u8C03url</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.weChatNotifyUrl}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u5FAE\u4FE1\u8BC1\u4E66\u5B58\u50A8</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.weChatCertificatePath}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u652F\u4ED8\u5B9D\u516C\u94A5</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.aliPayKey}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u652F\u4ED8\u5B9Dappid</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.aliPayAppid}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u652F\u4ED8\u5B9D\u79C1\u94A5</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.aliPayMchid}}</textarea></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-4 col-xs-4 control-label readLabel">\u652F\u4ED8\u5B9D\u56DE\u8C03url</label><div class="col-md-5 col-sm-6 col-xs-6"><textarea disabled="disabled" class="textArea" style="height: 32px;width: 100%;border-color: #e9e9e9">{{vm.paymentSettings.aliPayNotifyUrl}}</textarea></div></div></div></div><div style="padding-top:20px; text-align:left"><button type="button" ui-sref="payment-settings.edit({id:vm.paymentSettings.id})" ng-if="vm.paymentSettings.id" class="c-btn c-btn1 mr10"><span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="button" ui-sref="payment-settings.new()" ng-if="!vm.paymentSettings.id" class="c-btn c-btn1 mr10"><span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div></div>');
$templateCache.put('app/setting/payment-settings/payment-settings-dialog.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u652F\u4ED8\u8BBE\u7F6E</span></div><div class="modal-body" style="background-color: white;min-height: 530px;padding-left: 100px"><div class="panel-body"><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right">\u5FAE\u4FE1\u79D8\u94A5</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" id="field_weChatKey" name="weChatKey" ng-model="vm.paymentSettings.weChatKey"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right">\u5FAE\u4FE1\u5546\u6237appid</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="weChatAppid" id="field_weChatAppid" ng-model="vm.paymentSettings.weChatAppid"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="field_weChatMchid">\u5FAE\u4FE1\u5546\u6237id</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="weChatMchid" id="field_weChatMchid" ng-model="vm.paymentSettings.weChatMchid"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="weChatNotifyUrl">\u5FAE\u4FE1\u652F\u4ED8\u56DE\u8C03url</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="weChatNotifyUrl" id="weChatNotifyUrl" ng-model="vm.paymentSettings.weChatNotifyUrl"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="weChatCertificatePath">\u5FAE\u4FE1\u8BC1\u4E66\u5B58\u50A8</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="weChatCertificatePath" id="weChatCertificatePath" ng-model="vm.paymentSettings.weChatCertificatePath"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="aliPayKey">\u652F\u4ED8\u5B9D\u516C\u94A5</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" id="aliPayKey" name="aliPayKey" ng-model="vm.paymentSettings.aliPayKey"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="aliPayAppid">\u652F\u4ED8\u5B9Dappid</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="aliPayAppid" id="aliPayAppid" ng-model="vm.paymentSettings.aliPayAppid"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="aliPayMchid">\u652F\u4ED8\u5B9D\u79C1\u94A5</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="aliPayMchid" id="aliPayMchid" ng-model="vm.paymentSettings.aliPayMchid"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group" style="overflow: hidden"><label class="col-md-2 col-sm-3 col-xs-4 control-label pad-0 text-right" for="aliPayNotifyUrl">\u652F\u4ED8\u5B9D\u56DE\u8C03url</label><div class="col-md-5 col-sm-6 col-xs-6"><input type="text" class="form-control border-radius" name="aliPayNotifyUrl" id="aliPayNotifyUrl" ng-model="vm.paymentSettings.aliPayNotifyUrl"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div></div>');
$templateCache.put('app/setting/prepressflow/prepressflow-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA/\u7F16\u8F91</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.prePressFlow.name"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5370\u524D\u6D41\u7A0B\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.prePressFlow.codeName" maxlength="50"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.prePressFlow.enable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u662F\u5426\u7FFB\u8F6C\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.prePressFlow.flip"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.prePressFlow.description" style="resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/prepressflow/prepressflow.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5370\u524D\u7BA1\u7406\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="prePressFlowAdd">\u65B0\u5EFA\u5370\u524D\u7BA1\u7406</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u5370\u524D\u6D41\u7A0B\u540D\u79F0</th><th style="text-align: center">\u63CF\u8FF0</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="text-align: center" title="{{data.name}}">{{data.name.length >10?data.name.substr(0,10)+\'...\':data.name}}</td><td style="text-align: center" title="{{data.codeName}}">{{data.channel >10?data.codeName.substr(0,10)+\'...\':data.codeName}}</td><td style="text-align: center" title="{{data.description}}">{{data.description.length >10? data.description.substr(0,10)+\'...\':data.description}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="prePressFlowEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/priceList/priceList-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u4EF7\u76EE\u8868</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u4EF7\u76EE\u8868\u540D\u79F0\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4EF7\u76EE\u8868\u540D\u79F0" ng-model="vm.price.name"></div></div><div class="c-form"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-model="vm.price.priceType" ng-change="choosePriceType()" ng-options="data.value as data.name for data in vm.priceTypes"><option value="">\u8BF7\u9009\u62E9\u7C7B\u578B</option></select></div></div><div class="c-form"><label class="c-form-label">\u5BF9\u8C61\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-if="vm.price.priceType==\'supplier\'" ng-model="vm.price.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u4F9B\u5E94\u5546</option></select><select name="" class="c-select1" ng-if="vm.price.priceType==\'customer\'" ng-model="vm.price.customerHubId" ng-options="data.id as data.name for data in vm.customerHubs"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u5BA2\u6237</option></select><select name="" class="c-select1" ng-if="vm.price.priceType==\'channel\'" ng-model="vm.price.channelId" ng-options="data.id as data.name for data in vm.channels"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.price.enabled"></div></div><div class="c-form"><label class="c-form-label">\u4EF7\u76EE\u89C4\u5219\uFF1A</label><div class="c-form-div" style="width: auto"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u4E00\u7EA7\u5206\u7C7B</th><th>\u4E8C\u7EA7\u5206\u7C7B</th><th>\u5546\u54C1</th><th>\u662F\u5426\u52A0\u9875</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="priceLine in vm.price.priceLines track by $index"><td style="max-width: 70px; min-width: 70px; width: 70px;text-align: center">{{$index + 1}}</td><td style="padding: 0 10px"><!-- <select name="" class="c-select2" ng-model="priceLine.productCategoryFirstId"\n                                        ng-options="data.id as data.name for data in vm.productCategoryFirst" ng-change="changeCategoryFirst(priceLine,$index)">\n                                    <option value="">\u8BF7\u9009\u62E9\u4E00\u7EA7\u5206\u7C7B</option>\n                                </select> --><select-view ng-if="vm.productCategoryFirst" ng-model="priceLine.productCategoryFirstId" label-key="name" value-key="id" options="vm.productCategoryFirst" is-search="true"></select-view></td><td><select name="" class="c-select2" ng-model="priceLine.productCategorySecondId" ng-options="data.id as data.name for data in priceLine.productCategorySecond" ng-change="changeCategorySecond(priceLine,data)"><option value="">\u8BF7\u9009\u62E9\u4E8C\u7EA7\u5206\u7C7B</option></select></td><td style="padding: 0 10px"><select name="" class="c-select2" ng-model="priceLine.productId" ng-change="changeProduct(priceLine)" ng-options="data.id as data.name for data in priceLine.products"><option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option></select></td><td style="text-align: center"><input type="checkbox" class="checkOrIf" ng-model="priceLine.addPage" style="outline: none"></td><td><button type="button" class="c-minBtn c-minBtn3" ng-click="defaultSet(priceLine)">\u8BBE\u7F6E</button> <button type="button" class="c-minBtn c-minBtn3" ng-click="defaultDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="7"><span ng-click="priceLineNew()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u589E</span></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="priceList">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/priceList/priceList-copy.html','<div class="bg-content"><div class="user-modal bg-center" style="height: 370px"><div style="margin-bottom: 20px"><span class="title1">\u590D\u5236\u4EF7\u76EE\u8868</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u4EF7\u76EE\u8868\u540D\u79F0</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4EF7\u76EE\u8868\u540D\u79F0" ng-model="vm.data.name"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-8"><select name="" class="form-control border-radius" ng-model="vm.data.priceType" ng-change="choosePriceType()" ng-options="data.value as data.name for data in vm.priceTypes"><option value="">\u8BF7\u9009\u62E9\u7C7B\u578B</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u5BF9\u8C61</label><div class="col-md-9 col-sm-9 col-xs-8"><select name="" class="form-control border-radius" ng-if="vm.data.priceType==\'supplier\'" ng-model="vm.data.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u4F9B\u5E94\u5546</option></select><select name="" class="form-control border-radius" ng-if="vm.data.priceType==\'customer\'" ng-model="vm.data.customerHubId" ng-options="data.id as data.name for data in vm.customerHubs"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u5BA2\u6237</option></select><select name="" class="form-control border-radius" ng-if="vm.data.priceType==\'channel\'" ng-model="vm.data.channelId" ng-options="data.id as data.name for data in vm.channels"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label font-style no-padding">\u6709\u6548</label><div class="col-md-9 col-sm-9 col-xs-8"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.data.enabled"></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-3 control-label font-style no-padding"></label><div class="col-md-9 col-sm-9 col-xs-8"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/priceList/priceList-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA/\u7F16\u8F91\u4EF7\u76EE\u8868</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u4EF7\u76EE\u8868\u540D\u79F0\uFF1A</label><div class="c-form-div wid-1000"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u4EF7\u76EE\u8868\u540D\u79F0" ng-model="vm.price.name"></div></div><div class="c-form"><label class="c-form-label">\u7C7B\u578B\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-model="vm.price.priceType" ng-change="choosePriceType()" ng-options="data.value as data.name for data in vm.priceTypes"><option value="">\u8BF7\u9009\u62E9\u7C7B\u578B</option></select></div></div><div class="c-form"><label class="c-form-label">\u5BF9\u8C61\uFF1A</label><div class="c-form-div wid-1000"><select name="" class="c-select1" ng-if="vm.price.priceType==\'supplier\'" ng-model="vm.price.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u4F9B\u5E94\u5546</option></select><select name="" class="c-select1" ng-if="vm.price.priceType==\'customer\'" ng-model="vm.price.customerHubId" ng-options="data.id as data.name for data in vm.customerHubs"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u5BA2\u6237</option></select><select name="" class="c-select1" ng-if="vm.price.priceType==\'channel\'" ng-model="vm.price.channelId" ng-options="data.id as data.name for data in vm.channels"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E\u6E20\u9053</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.price.enabled"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div wid-1000"><div class="col-lg-3 col-sm-3 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding">\u4E00\u7EA7\u5206\u7C7B</label><div class="col-md-9 col-sm-9 col-xs-8 no-padding"><select name="" class="c-select2" ng-model="vm.productCategoryFirstId" ng-options="data.id as data.name for data in vm.productCategoryFirst" ng-change="changeSearchCategoryFirst()"><option value="">\u8BF7\u9009\u62E9\u4E00\u7EA7\u5206\u7C7B</option></select></div></div><div class="col-lg-3 col-sm-3 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding">\u4E8C\u7EA7\u5206\u7C7B</label><div class="col-md-9 col-sm-9 col-xs-8 no-padding"><select name="" class="c-select2" ng-model="vm.productCategorySecondId" ng-options="data.id as data.name for data in vm.productCategorySecond" ng-change="changeSearchCategorySecond()"><option value="">\u8BF7\u9009\u62E9\u4E8C\u7EA7\u5206\u7C7B</option></select></div></div><div class="col-lg-3 col-sm-3 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding">\u5546\u54C1</label><div class="col-md-9 col-sm-9 col-xs-8 no-padding"><!-- <select name="" class="c-select2" ng-model="vm.productId" ng-change="changeProduct(priceLine)"  ng-options="data.id as data.name for data in vm.products">\n                            <option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option>\n                        </select> --> <input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22" ng-model="vm.productName"></div></div><div class="col-lg-3 col-sm-3 form-group no-padding"><label class="col-md-12 col-sm-12 col-xs-12 control-label font-style no-padding"></label><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="cancelSearch()">\u91CD\u7F6E</button></div></div></div></div><div class="c-form"><label class="c-form-label">\u4EF7\u76EE\u89C4\u5219\uFF1A</label><div class="c-form-div" style="width: auto"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u4E00\u7EA7\u5206\u7C7B</th><th>\u4E8C\u7EA7\u5206\u7C7B</th><th>\u5546\u54C1</th><th>\u662F\u5426\u52A0\u9875</th><th style="width: 100px">\u72B6\u6001</th><th style="text-align: center;width: 110px">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="priceLine in vm.price.priceLines track by $index  " ng-show="!priceLine.hide&& !priceLine.cancelled"><td style="max-width: 70px; min-width: 70px; width: 70px;text-align: center">{{$index + 1}}</td><td style="padding: 0 10px"><!-- <select ng-show= "!priceLine.id" name="" class="c-select2" ng-model="priceLine.productCategoryFirstId"\n                                        ng-options="data.id as data.name for data in vm.productCategoryFirst" ng-change="changeCategoryFirst(priceLine)">\n                                    <option value="">\u8BF7\u9009\u62E9\u4E00\u7EA7\u5206\u7C7B</option>\n                                </select> --><select-view ng-show="!priceLine.id" ng-model="priceLine.productCategoryFirstId" label-key="name" value-key="id" ng-change="changeCategoryFirst(priceLine)" options="vm.productCategoryFirst" is-search="true"></select-view><span ng-show="priceLine.id">{{priceLine.productCategoryFirstName}}</span></td><td><!-- <select ng-show= "!priceLine.id"  name="" class="c-select2" ng-model="priceLine.productCategorySecondId"\n                                        ng-options="data.id as data.name for data in priceLine.productCategorySecond" ng-change="changeCategorySecond(priceLine)">\n                                    <option value="">\u8BF7\u9009\u62E9\u4E8C\u7EA7\u5206\u7C7B</option>\n                                </select> --><select-view ng-show="!priceLine.id" ng-model="priceLine.productCategorySecondId" label-key="name" value-key="id" ng-change="changeCategorySecond(priceLine)" options="priceLine.productCategorySecond" is-search="true"></select-view><span ng-show="priceLine.id">{{priceLine.productCategorySecondName}}</span></td><td style="padding: 0 10px"><!-- <select ng-show= "!priceLine.id" name="" class="c-select2" ng-model="priceLine.productId" ng-change="changeProduct(priceLine,$index)"\n                                        ng-options="data.id as data.name for data in priceLine.products">\n                                    <option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option>\n                                </select> --><select-view ng-show="!priceLine.id" ng-model="priceLine.productId" label-key="name" value-key="id" ng-change="changeProduct(priceLine,$index)" options="priceLine.products" is-search="true"></select-view><span ng-show="priceLine.id">{{priceLine.productName}}</span></td><td style="text-align: center;;width: 80px"><input type="checkbox" class="checkOrIf" ng-model="priceLine.addPage" style="outline: none" ng-disabled="priceLine.category!=\'OrderingProduct\'"></td><td style="text-align: center"><span style="color: #ff1600; padding: 3px 10px; background-color: #f3e8df; font-size: 12px; border-radius: 3px" ng-if="!priceLine.productCancelled && priceLine.productSkuCount > (priceLine.priceSkuCount - priceLine.deadSkuCount)">\u6709\u65B0\u589E</span> <span style="color: #896789; padding: 3px 10px; background-color: #f3edf3; font-size: 12px; border-radius: 3px" ng-if="!priceLine.productCancelled && priceLine.deadSkuCount > 0">\u6709\u65E0\u6548</span> <span style="color: #ff0000; padding: 3px 10px; background-color: #f7ebf4; font-size: 12px; border-radius: 3px" ng-if="priceLine.productCancelled">\u4EA7\u54C1\u5220\u9664</span></td><td style="text-align: center"><button type="button" class="c-minBtn c-minBtn3" ng-click="defaultSet(priceLine)">\u8BBE\u7F6E</button> <button type="button" class="c-minBtn c-minBtn3" ng-click="defaultDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="7"><span ng-click="priceLineNew()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u589E</span></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div" style="width: 100%"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn1 mr10" ng-click="export()">\u5BFC\u51FA</button> <button type="button" class="c-btn c-btn2" ui-sref="priceList">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/priceList/priceList-sku.html','<div class="bg-content" style="width: 900px;max-height: 70vh"><div class="user-modal bg-center row" style="width: 900px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u4EF7\u683C\u68AF\u5EA6\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-form"><div class="c-form-div wid-1000"><div class="col-lg-6 col-sm-6 form-group no-padding"></div><div class="col-lg-3 col-sm-3"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0\u641C\u7D22" ng-model="vm.name"></div><div class="col-lg-3 col-sm-3"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="cancelSearch()">\u91CD\u7F6E</button></div></div></div><div class="c-form-div"><div class="c-table1" style="padding-bottom: 1px"><table><thead><tr><th>\u9009\u62E9\u9500\u552E\u5546\u54C1</th><th>\u72B6\u6001</th><th>\u5B9A\u4EF7\u7B56\u7565</th><th>\u57FA\u4E8E</th><th>\u9636\u68AF\u8BBE\u7F6E</th><th>\u6807\u51C6\u4EF7\u683C</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="skuManage in vm.skuManages track by $index" ng-hide="skuManage.cancelled|| skuManage.hide"><!-- <td>\n                                <select class="c-select2 radius-5 special" ng-model="skuManage.propertyConfigId" ng-change="changePropertyConfig(skuManage)"\n                                        ng-options="property.id as property.sku for property in vm.propertyList">\n                                    <option value="">\u8BF7\u9009\u62E9</option>\n                                </select>\n                            </td> --><td><div>{{skuManage.propertyConfigNumber}}</div><div>{{skuManage.propertyConfigSku}}</div></td><td><span style="color: #896789; padding: 3px 10px; background-color: #f3edf3; font-size: 12px; border-radius: 3px" ng-if="skuManage.propertyConfigCancelled">\u65E0\u6548</span></td><td style="padding: 5px"><select name="" class="c-select2" ng-model="skuManage.type" ng-change="changeType(skuManage)" ng-options="data.value as data.name for data in vm.pricingStrategy"><option value="">\u8BF7\u9009\u62E9\u5B9A\u4EF7\u7B56\u7565</option></select></td><td><select name="" class="c-select2" ng-model="skuManage.baseOn" ng-options="data.value as data.name for data in vm.choices"><option value="">\u8BF7\u9009\u62E9</option></select></td><td><button class="btn-yellow-common btn-edit" ng-click="setLadderSetups(skuManage)" ng-if="skuManage.type!=\'STANDARD\'">\u8BBE\u7F6E</button></td><td><button class="btn-yellow-common btn-edit" ng-click="setStandardPrice(skuManage)" ng-if="skuManage.type==\'STANDARD\'">\u8BBE\u7F6E</button></td><td><button type="button" class="c-minBtn c-minBtn3" ng-click="skuCopy(skuManage)">\u590D\u5236</button> <button type="button" class="c-minBtn c-minBtn3" ng-click="skuDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="7" ng-if="vm.delSku.length"><span ng-click="addSkuManage()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u589E</span></td></tr></tbody></table></div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" style="margin-top: 30px"><button type="button" class="c-btn wid-130 c-btn1 mr10" style="margin-left: 0" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancel()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/setting/priceList/priceList.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4EF7\u76EE\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="priceListAdd">\u65B0\u5EFA</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.key" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.filter" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u4EF7\u76EE\u8868\u540D\u79F0</th><th style="text-align: center">\u7C7B\u578B</th><th style="text-align: center">\u5BF9\u8C61</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" on-finish-render ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name |limitTo:\'15\'}}</td><!--                supplier,channel,customer--><td style="text-align: center" title="{{data.priceType}}">{{data.priceType==\'supplier\'?\'\u4F9B\u5E94\u5546\u4EF7\u76EE\u8868\':data.priceType==\'customer\'?\'\u5BA2\u6237\u4EF7\u76EE\u8868\':\'\u6E20\u9053\u4EF7\u76EE\u8868\'|limitTo:\'15\'}}</td><td style="text-align: center" title="{{data.channelName}}"><span ng-if="data.priceType==\'supplier\'">{{data.supplierName|limitTo:\'15\'}}</span> <span ng-if="data.priceType==\'customer\'">{{data.customerHubName|limitTo:\'15\'}}</span> <span ng-if="data.priceType==\'channel\'">{{data.channelName|limitTo:\'15\'}}</span></td><td style="text-align: center">{{data.enabled ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="priceListEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="priceDelete(data)">\u5220\u9664</button> <button class="c-minBtn c-minBtn1" ng-click="priceCopy(data)">\u590D\u5236</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/priceList/set-price.html','<div class="bg-content"><div class="user-modal bg-center row" style="width: 900px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u9636\u68AF\u4EF7\u683C\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-form-div wid-1000"><div class="c-table1"><table><thead><tr><th style="width: 60px">\u5E8F\u53F7</th><th>\u4EF7\u683C\u9636\u68AF</th><th>\u6807\u51C6\u4EF7\u683C</th><th>\u6BCF\u52A01P\uFF08\u6807\u51C6\u4EF7\uFF09</th><th>\u4F1A\u5458\u4EF7</th><th>\u6BCF\u52A01P\uFF08\u4F1A\u5458\u4EF7\uFF09</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="ladderSetup in vm.ladderSetups track by $index"><td>{{$index + 1}}</td><td style="padding: 5px"><input type="number" class="c-input1" ng-model="ladderSetup.quantityMin" style="width: 65px" placeholder="\u8BF7\u8F93\u5165" min="0"> <input type="number" class="c-input1" ng-model="ladderSetup.quantityMax" style="width: 65px" placeholder="\u8BF7\u8F93\u5165" min="0"></td><td><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="ladderSetup.price" min="0" style="width: 60px"></td><td><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="ladderSetup.piecePrice" min="0" style="width: 130px" ng-disabled="!vm.addPage"></td><td><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="ladderSetup.vipPrice" min="0" style="width: 60px"></td><td><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165" ng-model="ladderSetup.vipPiecePrice" min="0" style="width: 130px" ng-disabled="!vm.addPage"></td><td><button type="button" class="c-minBtn c-minBtn3" ng-click="defaultDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="8"><span ng-click="priceNew()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u589E</span></td></tr></tbody></table></div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" style="margin-top: 30px"><button type="button" class="c-btn wid-130 c-btn1 mr10" style="margin-left: 0" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancel()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/setting/priceList/set-standard-price.html','<div class="bg-content" style="width: 900px"><div class="user-modal bg-center row" style="width: 900px"><div class="clearfix" style="margin-bottom: 20px"><span class="title1">\u6807\u51C6\u4EF7\u683C\u8BBE\u7F6E</span></div><div class="col-lg-12 col-sm-12 form-group no-padding"><div class="c-form-div wid-1000"><div class="c-table1"><table><thead><tr><th style="width: 60px">\u6807\u51C6\u4EF7\u683C</th><th style="width: 150px">\u6BCF\u52A01P\uFF08\u6807\u51C6\u4EF7\uFF09</th><th style="width: 100px">\u4F1A\u5458\u4EF7</th><th>\u6BCF\u52A01P\uFF08\u4F1A\u5458\u4EF7\uFF09</th></tr></thead><tbody><tr><td style="padding: 5px"><input type="number" class="c-input1" ng-model="vm.price.priceNum" placeholder="\u8BF7\u8F93\u5165" min="0"></td><td><input type="number" class="c-input1" ng-model="vm.price.piecePrice" placeholder="\u8BF7\u8F93\u5165" min="0" ng-disabled="!vm.addPage"></td><td><input type="number" class="c-input1" ng-model="vm.price.vipPrice" placeholder="\u8BF7\u8F93\u5165" min="0"></td><td><input type="number" class="c-input1" ng-model="vm.price.vipPiecePrice" placeholder="\u8BF7\u8F93\u5165" min="0" ng-disabled="!vm.addPage"></td></tr></tbody></table></div></div></div><div class="col-lg-12 col-sm-12 form-group no-padding" style="margin-top: 30px"><button type="button" class="c-btn wid-130 c-btn1 mr10" style="margin-left: 0" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="cancel()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/setting/proofRule/proofRule-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA/\u7F16\u8F91</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.proofRule.name" style="width: 40%"></div></div><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u56FE\u7247\u6821\u9A8C</label></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u56FE\u7247\u6821\u9A8CDPI\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.proofRule.dpi" style="width: 40%"></div></div><hr><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u9875\u6570\u6821\u9A8C</label></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9875\u9762\u8303\u56F4\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.proofRule.pageStart" style="width: 18%">p ---- <input type="number" min="1" class="c-input1" ng-model="vm.proofRule.pageEnd" style="width: 17%">p</div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6700\u5C0F\u52A0\u9875\u5355\u5143</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.proofRule.minAddUnit" style="width: 40%">p</div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6BCF\u9875p\u6570</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.proofRule.pQuantity" style="width: 40%">p</div></div><hr><div class="col-lg-12 col-sm-12 no-padding"><label class="col-md-1 col-sm-1 col-xs-2 control-label font-style no-padding">\u5C3A\u5BF8\u6821\u9A8C</label></div><div class="c-form"><div class="col-md-9 col-sm-9 col-xs-8"><table class="address-list"><tr><th style="width: 30%">\u9002\u7528\u8303\u56F4</th><th style="width: 30%">\u9875\u9762\u8303\u56F4</th><th>\u64CD\u4F5C</th></tr><tr ng-repeat="proof in vm.proofRule.sizeProofs track by $index" ng-if="!proof.cancelled"><td>{{proof.applyAllPage?"\u6240\u6709\u9875":"\u90E8\u5206\u9875"}}</td><td>{{proof.applyPages}}</td><td style="width: 200px"><button class="btn-yellow-common btn-edit" ng-click="proofCopy(proof)">\u590D\u5236</button> <button class="btn-yellow-common btn-edit" ng-click="proofEdit(proof)">\u7F16\u8F91</button> <button class="btn-yellow-common btn-edit" ng-click="proofDelete(proof, $index)">\u5220\u9664</button></td></tr><tr><td colspan="3"><span ng-click="proofAdd()" class="addblu"><img src="content/images/addblu.png" alt="">\u65B0\u589E</span></td></tr></table></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.proofRule.enable"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" class="c-textarea1" ng-model="vm.proofRule.description" style="width: 40%; resize: none"></textarea></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/proofRule/proofRule.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6821\u9A8C\u89C4\u5219\u5217\u8868</span> <button type="button" class="c-btn c-btn1" ui-sref="proofRuleAdd">\u65B0\u5EFA\u6821\u9A8C\u89C4\u5219</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u63CF\u8FF0</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="text-align: center" title="{{data.name}}">{{data.name.length >10?data.name.substr(0,10)+\'...\':data.name}}</td><td style="text-align: center" title="{{data.description}}">{{data.description.length >10? data.description.substr(0,10)+\'...\':data.description}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="proofRuleEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/proofRule/sizeProof-edit.html','<div class="bg-content"><div class="user-modal bg-center"><div class="c-form"><label class="c-form-label" style="width: 150px">\u6210\u54C1\u5C3A\u5BF8</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageSizeW" style="width: 40%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageSizeH" style="width: 40%">mm</div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6700\u5C0F\u51FA\u8840\u5C3A\u5BF8</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodMinT" style="width: 15%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodMinR" style="width: 15%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodMinB" style="width: 15%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodMinL" style="width: 15%">mm</div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9ED8\u8BA4\u51FA\u8840\u5C3A\u5BF8</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodT" style="width: 15%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodR" style="width: 15%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodB" style="width: 15%">mm x <input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.pageBloodL" style="width: 15%">mm</div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u8BEF\u5DEE\u8303\u56F4</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="number" min="1" class="c-input1" ng-model="vm.sizeProof.limitRange" style="width: 18%">mm</div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9002\u7528\u8303\u56F4</label><div class="c-form-div wid-800" style="padding-left: 50px"><select name="" class="c-select1" ng-model="vm.sizeProof.applyAllPage" ng-options="data.value as data.name for data in vm.applyAllPages"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" ng-if="vm.sizeProof.applyAllPage == false "><label class="c-form-label" style="width: 150px">\u9875\u9762\u8303\u56F4</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.sizeProof.applyPages" placeholder="\u4F8B\uFF1A 1,2    1,3-6    1,3-6,8     1--1    2--2"> <span>\u652F\u6301\u6B63\u6570\u548C\u8D1F\u6570\uFF0C\u8D1F\u6570\u8868\u793A\u4ECE\u6587\u6863\u6700\u540E\u4E00\u9875\u7B97\u8D77\uFF0C\u7B2C-1\u8868\u793A\u6700\u540E\u4E00\u9875\u3002\u4F8B\u59821,2-11,-1</span></div></div><div class="c-form"><button type="button" class="c-btn c-btn1 mr10" ng-click="vm.save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="vm.clear()">\u8FD4\u56DE</button></div></div></div>');
$templateCache.put('app/setting/replenishment/replenishmentReason-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8865\u8D27\u539F\u56E0</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u539F\u56E0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0\uFF0815\u5B57\u4EE5\u5185\uFF09" ng-model="vm.replenishmentReason.reason"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" style="resize: none;outline: none" class="c-textarea1" ng-model="vm.replenishmentReason.remarks"></textarea></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.replenishmentReason.type" ng-options="data.value as data.name for data in vm.belongs"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.replenishmentReason.enable"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="replenishmentReason">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/replenishment/replenishmentReason-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u8865\u8D27\u539F\u56E0</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u539F\u56E0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0\uFF0815\u5B57\u4EE5\u5185\uFF09" ng-model="vm.replenishmentReason.reason"></div></div><div class="c-form"><label class="c-form-label">\u63CF\u8FF0\uFF1A</label><div class="c-form-div wid-800"><textarea placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0" style="resize: none;outline: none" class="c-textarea1" ng-model="vm.replenishmentReason.remarks"></textarea></div></div><div class="c-form"><label class="c-form-label">\u6240\u5C5E\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.replenishmentReason.type" ng-options="data.value as data.name for data in vm.belongs"><option value="">\u8BF7\u9009\u62E9\u6240\u5C5E</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.replenishmentReason.enable"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u8FD4\u56DE</button></div></div></div></div>');
$templateCache.put('app/setting/replenishment/replenishmentReason.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8865\u8D27\u539F\u56E0</span> <button type="button" class="c-btn c-btn1" ui-sref="replenishmentReasonAdd">\u65B0\u5EFA</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.keyword" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u539F\u56E0</th><th style="text-align: center">\u63CF\u8FF0</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.reason}}">{{data.reason |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.remarks}}">{{data.remarks|limitTo:\'10\'}}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="replenishmentReasonEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="replenishmentReasonDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/shelfManagement/shelfManagement-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u8D27\u67B6</span></div><div class="mtop20"><!--        <div class="c-form">--><!--            <label class="c-form-label">\u8D27\u67B6\u540D\u79F0\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D27\u67B6\u540D\u79F0" ng-model="vm.data.name" maxlength="20">--><!--            </div>--><!--        </div>--><!--        <div class="c-form">--><!--            <label class="c-form-label">\u4EA7\u54C1\u7C7B\u578B\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <select name="" class="c-select1" ng-model="vm.data.productCategoryId"--><!--                        ng-options="data.id as data.name for data in vm.typeList">--><!--                    <option value="">\u8BF7\u9009\u62E9\u4EA7\u54C1\u7C7B\u578B</option>--><!--                </select>--><!--            </div>--><!--        </div>--><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="shelfManagement">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/shelfManagement/shelfManagement-adds.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6279\u91CF\u65B0\u5EFA\u8D27\u67B6</span></div><div class="mtop20"><!--        <div class="c-form">--><!--            <label class="c-form-label">\u8D27\u67B6\u524D\u7F00\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D27\u67B6\u524D\u7F00" ng-model="vm.data.prefix">--><!--            </div>--><!--        </div>--><!--        <div class="c-form">--><!--            <label class="c-form-label">\u8D77\u59CB\u7F16\u53F7\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8D77\u59CB\u7F16\u53F7" min="0" ng-model="vm.data.beginNumber">--><!--            </div>--><!--        </div>--><div class="c-form"><label class="c-form-label">\u8D27\u67B6\u6570\u91CF\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8D27\u67B6\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7999" min="1" ng-model="vm.data.quantity"></div></div><!--        <div class="c-form">--><!--            <label class="c-form-label">\u4EA7\u54C1\u7C7B\u578B\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <select name="" class="c-select1" ng-model="vm.data.productCategoryId"--><!--                        ng-options="data.id as data.name for data in vm.typeList">--><!--                    <option value="">\u8BF7\u9009\u62E9\u4EA7\u54C1\u7C7B\u578B</option>--><!--                </select>--><!--            </div>--><!--        </div>--><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="shelfManagement">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/shelfManagement/shelfManagement-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u8D27\u67B6</span></div><div class="mtop20"><!--        <div class="c-form">--><!--            <label class="c-form-label">\u8D27\u67B6\u540D\u79F0\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <input type="text" class="c-input1" ng-model="vm.data.name" maxlength="20">--><!--            </div>--><!--        </div>--><!--        <div class="c-form">--><!--            <label class="c-form-label">\u8D27\u67B6\u7C7B\u578B\uFF1A</label>--><!--            <div class="c-form-div wid-800">--><!--                <select name="" class="c-select1" ng-model="vm.data.productCategoryId"--><!--                        ng-options="data.id as data.name for data in vm.typeList">--><!--                    <option value="">\u8BF7\u9009\u62E9</option>--><!--                </select>--><!--            </div>--><!--        </div>--><div class="c-form"><label class="c-form-label">\u6240\u5C5E\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div wid-800"><select name="" class="c-select1" ng-model="vm.data.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><!-- <div class="c-form">\n            <label class="c-form-label">\u6709\u6548\uFF1A</label>\n            <div class="c-form-div wid-500">\n                <input type="checkbox" class="checkOrIf" ng-model="vm.data.used">\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/shelfManagement/shelfManagement.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8D27\u67B6\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ui-sref="shelfManagementAdd">\u65B0\u5EFA\u8D27\u67B6</button> <button type="button" class="c-btn c-btn1" ui-sref="shelfManagementAdds">\u6279\u91CF\u65B0\u5EFA\u8D27\u67B6</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u8D27\u67B6\u540D\u79F0</th><th>\u4F9B\u5E94\u5546</th><th>\u4F7F\u7528\u72B6\u6001</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px">{{$index+1}}</td><td title="{{data.name}}">{{data.name.length >10?data.name.substr(0,10)+\'...\':data.name}}</td><td title="{{data.supplierName}}">{{data.supplierName.length >10? data.supplierName.substr(0,10)+\'...\':data.supplierName}}</td><td>{{data.used ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px"><!--                    <button class="c-minBtn c-minBtn1" ui-sref="shelfManagementEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button>--> <button class="c-minBtn c-minBtn3" ng-click="shelfDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/sorting/sorting-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u5206\u62E3</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u6240\u5C5E\u6E20\u9053\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><select name="" class="c-select1" ng-model="vm.channel" ng-options="data.name for data in vm.channelList" ng-change="channelSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5546\u6237\u552F\u4E00\u6807\u8BC6\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.merchantId" maxlength="20"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="sorting">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/sorting/sorting-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u5C5E\u6027</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label" style="width: 150px">\u6240\u5C5E\u6E20\u9053\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><select name="" class="c-select1" ng-model="vm.channel" ng-options="data.name for data in vm.channelList" ng-change="channelSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5546\u6237\u552F\u4E00\u6807\u8BC6\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="text" class="c-input1" ng-model="vm.data.merchantId" maxlength="20"></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6709\u6548\uFF1A</label><div class="c-form-div wid-800" style="padding-left: 50px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/sorting/sorting.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5206\u62E3\u7BA1\u7406</span> <button type="button" class="c-btn c-btn1" ui-sref="sortingAdd">\u65B0\u5EFA\u5206\u62E3</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002"> <button type="button" ng-click="search()"></button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u5546\u6237\u552F\u4E00\u6807\u8BC6</th><th style="text-align: center">\u6240\u5C5E\u6E20\u9053</th><th style="text-align: center">\u662F\u5426\u6709\u6548</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center">{{data.merchantId}}</td><td style="text-align: center">{{data.channelName }}</td><td style="text-align: center">{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="sortingEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="userDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875<!--<select name="" class="c-paging1-select" ng-model="vm.tableData.size"--><!--ng-options="data.value as data.name for data in vm.pageSize"--><!--ng-change="search()">--><!--</select>--> <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/system/system.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7CFB\u7EDF\u8BBE\u7F6E</span></div><div class="mtop20"><!--        <div class="c-form">--><!--            <label class="c-form-label" style="width: 150px;">\u8BA2\u5355\u9884\u8B66\u65F6\u95F4\uFF1A</label>--><!--            <div class="c-form-div" style="position: relative;width: 400px; padding-left: 50px;">--><!--                <input type="text" class="c-input1" ng-model="vm.warningTime.value" placeholder="\u8BF7\u8F93\u5165\u65B0\u8BA2\u5355\u5904\u7406\u9884\u8B66\u65F6\u95F4\u3002\u6BD4\u59821\u5C0F\u65F6\uFF0C\u8F93\u51651" >--><!--                <span style="position: absolute; left: 100%; top: 0; display: inline-block; height: 30px; line-height: 30px; margin-left: 10px; width: 100px;">\u5C0F\u65F6</span>--><!--            </div>--><!--        </div>--><!-- \u5FEB\u9012\u9E1F\u8BBE\u7F6E --><div class="c-form"><label class="c-form-label" style="width: 250px">\u5FEB\u9012\u9E1F\u5BA2\u6237\u53F7\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.kdnUserid.value" placeholder="\u8BF7\u8F93\u5165\u5FEB\u9012\u9E1F\u5BA2\u6237\u53F7" minlength="1"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5FEB\u9012\u9E1F\u5BC6\u7801\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.kdnAppkey.value" placeholder="\u8BF7\u8F93\u5165\u5FEB\u9012\u9E1F\u5BC6\u7801" minlength="1"></div></div><!-- \u8BA2\u5355\u7684\u663E\u793A\u8303\u56F4 --><div class="c-form"><label class="c-form-label" style="width: 250px">\u8BA2\u5355\u663E\u793A\u5929\u6570\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.orderDays.value" placeholder="\u8BF7\u8F93\u5165\u8BA2\u5355\u5217\u8868\u663E\u793A\u8303\u56F4\u3002\u6BD4\u59821\u4E2A\u6708\uFF0C\u8F93\u51651" minlength="1"> <span style="position: absolute; left: 100%; top: 0; display: inline-block; height: 30px; line-height: 30px; margin-left: 10px; width: 100px">\u6708</span></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u91C7\u8D2D\u9884\u8B66\u65F6\u95F4\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.procurementWarning.value" placeholder="\u8BF7\u8F93\u5165\u91C7\u8D2D\u9884\u8B66\u65F6\u95F4\u3002\u6BD4\u59821\u5929\uFF0C\u8F93\u51651" minlength="1"> <span style="position: absolute; left: 100%; top: 0; display: inline-block; height: 30px; line-height: 30px; margin-left: 10px; width: 100px">\u5929</span></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u4E0B\u8F7D\u9884\u8B66\u65F6\u95F4\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.downloadWarning.value" placeholder="\u8BF7\u8F93\u5165\u4E0B\u8F7D\u9884\u8B66\u65F6\u95F4\u3002\u6BD4\u59821\u5C0F\u65F6\uFF0C\u8F93\u51651" minlength="1"> <span style="position: absolute; left: 100%; top: 0; display: inline-block; height: 30px; line-height: 30px; margin-left: 10px; width: 100px">\u5C0F\u65F6</span></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u62FC\u7248\u63A5\u53E3url\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.ffc_url.value" placeholder="\u8BF7\u8F93\u5165\u62FC\u7248\u63A5\u53E3url" minlength="1"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u6587\u4EF6\u5B58\u50A8\u8DEF\u5F84\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.projectFileUrlPrefix.value" placeholder="\u8BF7\u8F93\u5165\u6587\u4EF6\u5B58\u50A8\u8DEF\u5F84"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u5370\u524D\u63A5\u53E3\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="text" class="c-input1" ng-model="vm.prePressFlowUrl.value" placeholder="\u5370\u524D\u63A5\u53E3"></div></div><div class="c-form"><label class="c-form-label" style="width: 250px">\u9ED8\u8BA4\u4EA7\u54C1\u56FE\u7247\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><!-- <input type="text" class="c-input1" ng-model="vm.defaultProductImg.value" placeholder="\u9ED8\u8BA4\u4EA7\u54C1\u56FE\u7247"> --> <input ng-if="!vm.defaultProductImg.value" type="file" name="file" class="form-control border-radius" type="file" accept="image/jpeg, image/png" onchange="updateImgFile1(event)" ng-model-options="{debounce : 500}"> <span ng-if="vm.defaultProductImg.value"><img ng-src="{{vm.defaultProductImg.value}}?imageMogr2/auto-orient" style="width: 100px; height: 100px; border: 1px dashed red"> <i class="glyphicon glyphicon-remove" ng-click="removeFile()" style="color: red"></i></span><div class="mar-top-10" style="color:#b3a8a8; font-size: 12px">\u5EFA\u8BAE\u5C3A\u5BF8\uFF1A750*380px\u30011080*540px</div></div></div><!-- <div class="c-form">\n            <label class="c-form-label" style="width: 250px;">\u9879\u76EE\u662F\u5426\u81EA\u52A8\u5BA1\u6838\uFF1A</label>\n            <div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px;">\n                <input type="checkbox" style="width: 20px;" ng-model="vm.projectExamineSwitch.value">\n            </div>\n        </div> --><div class="c-form"><label class="c-form-label" style="width: 250px">\u662F\u5426\u81EA\u52A8\u6253\u5305\uFF1A</label><div class="c-form-div" style="position: relative;width: 400px; padding-left: 150px"><input type="checkbox" style="width: 20px" ng-model="vm.autoBoxing.value"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button></div></div></div></div>');
$templateCache.put('app/setting/systemLog/systemLog.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7CFB\u7EDF\u65E5\u5FD7</span></div><div class="mtop20 clearfix"><div class="pull-left"><label class="c-form-label">\u65E5\u5FD7\u65F6\u95F4\uFF1A</label><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.start" id="startDate" placeholder="\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\'})"><div class="form-timeIcon"></div></div><span style="display: inline-block;line-height: 30px;margin: 0 5px">\u81F3</span><div class="form-time"><input type="text" class="c-input1" ng-model="vm.tableData.end" id="endDate" placeholder="\u8BF7\u9009\u62E9\u7ED3\u675F\u65E5\u671F" onclick="WdatePicker({dateFmt:\'yyyy-MM-dd\',readOnly:true,lang:\'zh-cn\',startDate:\'#F{$dp.$D(\\\'startDate\\\',{d:+1})}\'})"><div class="form-timeIcon"></div></div></div><div class="pull-right wid-300"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button type="button" class="hei_35" ng-click="search()"></button> </span><!-- <span class="input-group-btn width-min btn-clear" ng-if="vm.tableData.keyword">\n                                    <button type="button" class="hei_35 clear-search" ng-click="vm.clear()">\n                                        <span>\u6E05\u9664</span>\n                                    </button>\n                                </span> --></div></form></div></div></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="search()">\u67E5\u8BE2</button> <button type="button" class="c-btn c-btn2" ng-click="reset()">\u91CD\u7F6E</button></div><div class="c-table mtop20"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u65F6\u95F4</th><th>\u64CD\u4F5C\u4EBA</th><th>\u64CD\u4F5C\u5185\u5BB9</th><th>IP\u5730\u5740</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td>{{data.createdDate ? (data.createdDate |date:\'yyyy-MM-dd\'):\'---\'}}</td><td title="{{data.operator}}">{{data.operator|limitTo:\'10\'}}</td><td title="{{data.operation}}">{{data.operation|limitTo:\'50\'}}</td><td title="{{data.ipAddress}}">{{data.ipAddress}}</td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="5" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/tag/tag-detail.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6807\u7B7E\u89C4\u683C</span></div><div class="mtop20" style="position: relative; min-height: 530px"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" ng-model="vm.data.name"></div></div><div class="c-form"><label class="c-form-label">\u4F9B\u5E94\u5546\uFF1A</label><div class="c-form-div"><select name="" class="c-select1" ng-model="vm.data.supplierId" ng-options="data.id as data.name for data in vm.suppliers"><option value="">\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546</option></select></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.data.enable"></div></div><div class="c-form"><label class="c-form-label">\u5C3A\u5BF8\uFF1A</label><div class="c-form-div tag-view2"><input type="number" class="c-input1" placeholder="\u5BBD" ng-model="vm.data.width" style="width: 80px"> <span>mm</span> <span style="margin: 0 10px">*</span> <input type="number" class="c-input1" placeholder="\u9AD8" ng-model="vm.data.height" style="width: 80px"> <span>mm</span></div></div><div class="c-form"><label class="c-form-label">\u5185\u5BB9\uFF1A</label><div class="c-form-div" style="width: 700px"><div class="c-table1"><table><thead><tr><th>\u540D\u79F0</th><th>\u542F\u7528</th><th>\u5B57\u6BB5\u5BBD</th><th>\u5B57\u6BB5\u9AD8</th><th>\u5B57\u4F53\u5927\u5C0F</th><th>\u52A0\u7C97</th></tr></thead><tbody><tr ng-repeat="item in vm.data.tags track by $index"><td>{{item.name}}</td><td><input type="checkbox" class="checkOrIf" style="outline: none;margin: 0" ng-model="item.enabled"></td><td><input class="c-input1" type="text" ng-model="item.width" style="width: 80px;margin-right: 3px">mm</td><td><input class="c-input1" type="text" ng-model="item.height" style="width: 80px;margin-right: 3px">mm</td><td><input class="c-input1" type="text" ng-model="item.fontsize" style="width: 80px;margin-right: 3px" ng-if="item.type != \'barCode\'" ng-change="fongsizeChange(item)"><span ng-if="item.type != \'barCode\'">pt</span></td><td><input type="checkbox" class="checkOrIf" style="outline: none;margin: 0" ng-model="item.bold" ng-if="item.type != \'barCode\'"></td></tr></tbody></table></div></div></div><div class="tag-view1"><div class="tag-view1-body" ng-style="{\n                    width: vm.data.width * vm.ratio,\n                    height: vm.data.height * vm.ratio\n                }"><div class="tag-view1-text" style="position: absolute" ng-repeat="item in vm.data.tags track by $index" ng-if="item.enabled" ng-mousedown="tagdown($event,item)" ng-style="{\n                        width: item.width * vm.ratio,\n                        height: item.height * vm.ratio,\n                        left: item.x * vm.ratio,\n                        top: item.y * vm.ratio,\n                     }"><div class="slh" ng-if="item.type != \'barCode\'" ng-style="{\n                        \'font-size\': item.fontsize + \'pt\',\n                        \'font-weight\': item.bold ? \'bold\' : \'normal\',\n                        \'line-height\': item.height * vm.ratio + \'px\',\n                        \'color\':item.fontColor}" style="display: flex; align-items: center"><span>{{getName(item.type)}}</span></div><img src="content/images/icon-tag4.png" alt="" ng-if="item.type == \'barCode\'"></div></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ng-click="goBack()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/tag/tag.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6807\u7B7E\u89C4\u683C</span> <button type="button" class="c-btn c-btn1" ui-sref="tagAdd">\u65B0\u5EFA\u89C4\u683C</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.keyword" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u89C4\u683C\u540D\u79F0</th><th>\u5C3A\u5BF8(cm)</th><th>\u4F9B\u5E94\u5546</th><th>\u6709\u6548</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td>{{data.name}}</td><td>{{data.width}} * {{data.height}}</td><td>{{data.supplierName}}</td><td>{{data.enable ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 130px; max-width: 130px; min-width: 130px"><button class="c-minBtn c-minBtn1" ui-sref="tagEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="depositoryDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="6" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/setting/unitMeasurement/unitMeasurement-add.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u65B0\u5EFA\u8BA1\u91CF\u5355\u4F4D</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BA1\u91CF\u5355\u4F4D\u540D\u79F0" ng-model="vm.unitMeasurement.name"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.unitMeasurement.defaulted"></div></div><div class="c-form"><label class="c-form-label">\u5355\u4F4D\u7C7B\u522B\uFF1A</label><div class="c-form-div" style="width: 800px"><select name="" class="c-select1" ng-model="vm.unitMeasurement.type" ng-options="data for data in vm.typeList"><option value="">\u8BF7\u9009\u62E9\u5355\u4F4D\u7C7B\u522B</option></select></div></div><div class="c-form"><label class="c-form-label">\u5C0F\u6570\u7CBE\u5EA6\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7CBE\u5EA6" min="0" ng-model="vm.unitMeasurement.accuracy"></div></div><div class="c-form"><label class="c-form-label">\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F16\u7801" ng-model="vm.unitMeasurement.number"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="unitMeasurement">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/unitMeasurement/unitMeasurement-edit.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u7F16\u8F91\u8BA1\u91CF\u5355\u4F4D</span></div><div class="mtop20"><div class="c-form"><label class="c-form-label">\u540D\u79F0\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u8BA1\u91CF\u5355\u4F4D\u540D\u79F0" ng-model="vm.unitMeasurement.name"></div></div><div class="c-form"><label class="c-form-label">\u6709\u6548\uFF1A</label><div class="c-form-div"><input type="checkbox" class="checkOrIf" style="outline: none" ng-model="vm.unitMeasurement.defaulted"></div></div><div class="c-form"><label class="c-form-label">\u5355\u4F4D\u7C7B\u522B\uFF1A</label><div class="c-form-div" style="width: 800px"><select name="" class="c-select1" ng-model="vm.unitMeasurement.type" ng-options="data for data in vm.typeList"><option value="">\u8BF7\u9009\u62E9\u5355\u4F4D\u7C7B\u522B</option></select></div></div><div class="c-form"><label class="c-form-label">\u5C0F\u6570\u7CBE\u5EA6\uFF1A</label><div class="c-form-div wid-800"><input type="number" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7CBE\u5EA6" min="0" ng-model="vm.unitMeasurement.accuracy"></div></div><div class="c-form"><label class="c-form-label">\u7F16\u7801\uFF1A</label><div class="c-form-div wid-800"><input type="text" class="c-input1" placeholder="\u8BF7\u8F93\u5165\u7F16\u7801" ng-model="vm.unitMeasurement.number"></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSaving">\u4FDD\u5B58</button> <button type="button" class="c-btn c-btn2" ui-sref="unitMeasurement">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/unitMeasurement/unitMeasurement.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8BA1\u91CF\u5355\u4F4D</span> <button type="button" class="c-btn c-btn1" ui-sref="unitMeasurementAdd">\u65B0\u5EFA\u8BA1\u91CF\u5355\u4F4D</button><div class="pull-right"><div class="form-search clearfix"><input type="text" class="c-input1 pull-left" ng-model="vm.tableData.keyword" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <button type="button" ng-click="search()"></button> <button type="button" class="clear-search" ng-if="vm.tableData.keyword" ng-click="vm.clear()">\u6E05\u9664</button></div></div></div><div class="c-table mtop20"><table><thead><tr><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u540D\u79F0</th><th style="text-align: center">\u7C7B\u522B</th><th style="text-align: center">\u5C0F\u6570\u7CBE\u5EA6</th><th style="text-align: center">\u6709\u6548</th><th style="text-align: center">\u7F16\u7801</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-if="vm.tableList.length > 0"><td style="width: 80px; max-width: 80px; min-width: 80px; text-align: center">{{(vm.tableData.page * vm.tableData.size) + $index+1}}</td><td style="text-align: center" title="{{data.name}}">{{data.name |limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.type}}">{{data.type|limitTo:\'10\'}}</td><td style="text-align: center" title="{{data.accuracy}}">{{data.accuracy|limitTo:\'10\'}}</td><td style="text-align: center">{{data.defaulted ? \'\u662F\' : \'\u5426\'}}</td><td style="text-align: center">{{data.number}}</td><td style="width: 130px; max-width: 130px; min-width: 130px; text-align: center"><button class="c-minBtn c-minBtn1" ui-sref="unitMeasurementEdit({id:data.id, page: vm.tableData.page})">\u7F16\u8F91</button> <button class="c-minBtn c-minBtn3" ng-click="unitMeasurementDelete(data)">\u5220\u9664</button></td></tr><tr class="noData" ng-if="vm.tableList.length == 0"><td colspan="7" class="bgc-f0f0f2"><span>\u6682\u65E0\u5185\u5BB9</span></td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span> <span>\u6BCF\u9875 <b>{{vm.tableData.size}}</b> \u6761\u6570\u636E</span></div><div id="paging" class="c-paging2"></div></div></div>');
$templateCache.put('app/stockManagement/components/choose-warehouse-dialog.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div" style="padding-bottom: 20px"><div class="clearfix"><span class="title1">\u9009\u62E9\u4ED3\u5E93</span></div></div></div></div><div class="bgc-fff p30" style="padding-top: 0"><div class="c-form"><label class="c-form-label" style="width: 80px">\u4ED3\u5E93\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><select style="width: 300px" class="c-select1" ng-model="vm.warehouseId" ng-options="data.id as data.name for data in vm.warehouseList"><option value="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form" style="margin-top: 40px"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" style="margin-left: 20px" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/stockManagement/components/product-add-dialog.html','<div id="printPage"><div class="clearfix orderDetails"><div class="orderDetails-li"><div class="bgc-fff orderDetails-div" style="padding: 15px"><div class="clearfix"><span class="title1">\u6DFB\u52A0\u76D8\u70B9\u5546\u54C1</span></div></div></div></div><div class="bgc-fff p30"><div class="c-form"><div class="c-form-div" style="width:auto;margin-left: 0"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u5546\u54C1</th><th>\u5546\u54C1SKU</th><th>\u5355\u4F4D</th><th>\u5355\u4EF7</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.data track by $index"><td style="padding: 0; width: 80px">{{$index + 1}}</td><td style="padding: 0"><select class="c-select1" ng-model="item.productId" ng-options="product.id as product.name for product in vm.products" ng-change="selectPurchaseProduct(item)"><option value="">\u8BF7\u9009\u62E9\u5546\u54C1</option></select></td><td style="padding: 0"><select class="c-select1" ng-model="item.propertyConfigId" ng-options="propertyConfig.id as propertyConfig.sku for propertyConfig in item.propertyConfigs" ng-change="selectPurchaseProductSku(item,$index)"><option value="">\u8BF7\u9009\u62E9SKU</option></select></td><td style="padding: 0; width: 80px">{{item.measurementName}}</td><td style="padding: 0; width: 80px"><input type="number" placeholder="\u8BF7\u8F93\u5165" class="c-input1" ng-model="item.price" style="border: 0" min="0"></td><td style="width: 200px; max-width: 200px; min-width: 200px"><button type="button" class="btn-flow" ng-click="productDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="7"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="productAdd()"><i></i>\u6DFB\u52A0\u5546\u54C1</button></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn1" ng-click="save()" ng-disabled="vm.isSaving">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="cancelRecord()">\u53D6\u6D88</button></div></div></div></div><style>.modal-content{\n        width: 1200px;\n        left: 50%;\n        margin-left: -600px;\n    }</style>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/product/finished/modal/ingredients.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u8F85\u6750\u5217\u8868</span></div><div class="mt10"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u6750\u6599SKU\u540D\u79F0</th><!-- <th>\u5206\u62E3\u89C4\u5219</th> --><th>\u8BA1\u91CF\u5355\u4F4D</th><th>\u4F7F\u7528\u89C4\u5219</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data track by $index"><td style="width: 60px; max-width: 60px; min-width: 60px">{{$index + 1}}</td><td style="padding: 0 10px; max-width: 200px; min-width: 200px; width: 200px"><span>{{data.materialSettingSku}}</span> <button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="materiaSet(data, $index)">\u8BBE\u7F6E</button></td><!-- <td style="text-align: center;">\n                        <button type="button" class="btn-flow" style="cursor: pointer;border: 0;" ng-click="merchantsSet($index)" ng-if="!data.merchants||!data.merchants.length">\u8BBE\u7F6E</button>\n                        <button type="button" class="btn-flow" style="cursor: pointer;border: 0;" ng-click="merchantsEdit(data, $index)" ng-if="data.merchants&&data.merchants.length">\u7F16\u8F91\u8BBE\u7F6E</button>\n                    </td> --><td style="max-width: 100px; min-width: 100px; width: 100px"><select name="" class="c-select2" ng-model="data.measurementId" ng-options="data.id as data.name for data in vm.unitList" ng-change="measurementSelect1(data)"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="width: 90px; max-width: 90px; min-width: 90px"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="regulationsSet($index)" ng-if="!data.usingRule.key">\u8BBE\u7F6E</button> <button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="regulationsEdit(data, $index)" ng-if="data.usingRule.key">\u7F16\u8F91\u8BBE\u7F6E</button></td><td style="width: 60px; max-width: 60px; min-width: 60px"><button type="button" class="c-minBtn c-minBtn3" ng-click="ingredientDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="6"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="ingredientAdd()"><i></i>\u65B0\u5EFA</button></td></tr></tbody></table></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/product/finished/modal/merchants.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u5546\u6237\u9009\u62E9</span></div><div class="mt10"><div><div><input type="checkbox" ng-model="vm.selectAll" ng-change="chooseAll()"><!--                <i class="choose-li" ng-click="chooseAll()" ng-show="!vm.selectAll"></i>--><!--                <i class="choose-sel" ng-click="chooseAll()" ng-show="vm.selectAll"></i>--> \u5168\u90E8</div><div ng-repeat="data in vm.merchantList track by $index" style="margin-top: 16px"><div><input type="checkbox" ng-model="data.select" ng-change="chooseOne(data)"><!--                    <i class="choose-li" ng-click="chooseOne(data)" ng-show="!data.select"></i>--><!--                    <i class="choose-sel" ng-click="chooseOne(data)" ng-show="data.select"></i>--> {{data.name}}</div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/product/finished/modal/minWarning.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u6700\u5C0F\u5E93\u5B58\u9884\u8B66</span></div><div class="mt10"><div class="c-form"><label class="c-form-label" style="width: 80px">\u5206\u5E93\u9884\u8B66\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="checkbox" ng-model="vm.data.depotsWarning" class="checkOrIf" ng-click="depotsWarningCb()"></div></div><div class="c-form" ng-if="!vm.data.depotsWarning"><label class="c-form-label" style="width: 80px">\u6700\u5C0F\u5E93\u5B58\uFF1A</label><div class="c-form-div" style="width: auto; margin-left: 80px"><input type="text" class="c-input1" ng-model="vm.data.minStorage"></div></div><div class="c-form" ng-if="!!vm.data.depotsWarning"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><div class="c-table1"><table><thead><tr><th>\u5E8F\u53F7</th><th>\u4ED3\u5E93</th><th>\u6700\u4F4E\u5E93\u5B58\u91CF</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.warehouseConfigs track by $index"><td style="max-width: 60px; min-width: 60px; width:60px">{{$index + 1}}</td><td style="text-align: center"><select name="" class="c-select2" ng-model="data.warehouseId" ng-options="data.id as data.name for data in vm.warehouseList" ng-change="warehouseSelect(data)"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="text-align: center; max-width: 100px; min-width: 100px; width: 100px"><input type="text" class="c-input2" ng-model="data.minStorage" placeholder="\u8BF7\u8F93\u5165"></td><td style="text-align: center;max-width: 80px; min-width: 80px; width: 80px"><button type="button" class="c-minBtn c-minBtn3" ng-click="delete($index)">\u5220\u9664</button></td></tr><tr><td colspan="4"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="add()"><i></i>\u65B0\u5EFA</button></td></tr></tbody></table></div></div></div><div class="c-form"><label class="c-form-label" style="width: 80px"></label><div class="c-form-div" style="width: auto; margin-left: 80px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/product/finished/modal/price.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4EF7\u683C\u8BBE\u7F6E</span></div><div class="mt10"><div class="c-form"><label class="c-form-label" style="width: 80px">\u9009\u62E9\u6E20\u9053\uFF1A</label><div class="c-form-div" style="margin-left: 80px"><select name="" class="c-select1" ng-model="vm.data.channel" ng-options="data.name for data in vm.channelList" ng-change="channelSelect(data)"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-table1"><table><thead><tr><th>\u91C7\u8D2D\u6570\u91CF</th><th>\u5B9A\u4EF7\u7B56\u7565</th><th>\u57FA\u4E8E</th><th>\u9636\u68AF\u8BBE\u7F6E</th><th>\u4EF7\u683C</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="data in vm.data.price track by $index"><td style="padding: 0; text-align: center"><input type="text" class="c-input1" ng-model="data.minPurchaseQuantity" style="width: 50px"> <span>\u81F3</span> <input type="text" class="c-input1" ng-model="data.maxPurchaseQuantity" style="width: 50px"></td><td style="padding: 0; text-align: center"><select name="" class="c-select1" ng-model="data.pricing" ng-options="data.id as data.name for data in vm.pricingList"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="padding: 0; text-align: center"><select name="" class="c-select1" ng-model="data.base" ng-options="data.id as data.name for data in vm.baseList"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="padding: 0; text-align: center"><button type="button" class="c-minBtn" ng-click="ladderSet(data)">\u8BBE\u7F6E</button></td><td style="padding: 0; text-align: center"><input type="text" class="c-input1" ng-model="data.price" style="border: 0; width: 80px"></td><td style="padding: 0; text-align: center"><button type="button" class="c-minBtn c-minBtn3" ng-click="delete($index)">\u5220\u9664</button></td></tr><tr><td colspan="6"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="priceAdd()"><i></i>\u65B0\u5EFA</button></td></tr></tbody></table></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">{{ vm.type ? \'\u4FDD\u5B58\' : \'\u786E\u5B9A\'}}</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/product/finished/modal/product-itmes.html','<div class="bgc-fff p30"><div style="display: flex;justify-content: space-between;align-items: center"><span class="title1">\u9009\u62E9\u5C5E\u6027</span></div><div class="mt10"><div class="c-table1" style="max-height: 500px"><table><thead><tr><th>\u5C5E\u6027</th><th>\u53EF\u7528\u89C4\u683C</th><th style="text-align: center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.items track by $index"><td style="padding: 0"><!-- <select name="" class="c-select1" ng-model="item.id"\n                                ng-options="i.id as i.name for i in vm.itemsList"\n                                ng-change="itemSelect(item, $index)"\n                                style="border: 0;width: 100%;">\n                            <option value="">\u8BF7\u9009\u62E9</option>\n                        </select> --><select-view ng-if="vm.itemsList" ng-model="item.id" label-key="name" value-key="id" ng-change="itemSelect(item, $index)" options="vm.itemsList" is-search="true"></select-view></td><td><span ng-repeat="itemValue in item.itemValues track by $index">{{itemValue.name}}<span ng-if="$index<item.itemValues.length-1">\uFF0C</span></span></td><td style="width: 130px; max-width: 130px; min-width: 130px; padding: 5px 10px; text-align: center"><button type="button" class="c-minBtn c-minBtn1" ng-click="propertyDelete($index)">\u5220\u9664</button></td></tr><tr><td colspan="3"><button type="button" class="btn-flow" style="cursor: pointer;border: 0" ng-click="propertyAdd()"><i></i>\u6DFB\u52A0</button></td></tr></tbody></table></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/product/finished/modal/property.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u751F\u6210SKU</span></div><div class="mt10"><div class="scrollbar-main" style="max-height: 500px; overflow: auto"><div class="c-form" style="margin-bottom: 10px" ng-repeat="property in vm.property"><label class="c-form-label" style="width: 120px" title="{{property.name}}">{{property.name.length > 5 ? property.name.substr(0, 5) + \'...\' : property.name}}\uFF1A</label><div class="c-form-div" style="margin-left: 120px; width: auto"><label style="margin: 0 10px 0 10px; line-height: 30px" ng-repeat="item in property.itemValues"><input type="checkbox" ng-model="item.checked"> {{item.name}}</label></div></div></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u751F\u6210</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/product/finished/modal/regulations.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u4F7F\u7528\u89C4\u5219</span></div><div class="mt10"><div class="c-table1"><table><thead><tr><th>\u57FA\u4E8E</th><th>\u8FD0\u7B97\u7B26</th><th>\u6570\u503C</th><th>\u4F7F\u7528\u6570\u91CF</th></tr></thead><tbody><tr><td style="text-align: center"><select name="" class="c-select2" ng-model="vm.data.key" ng-options="data.id as data.name for data in vm.baseOnList"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="text-align: center"><select name="" class="c-select2" ng-model="vm.data.op" ng-options="data.id as data.name for data in vm.operatorList" ng-change="operatorSelect()"><option value="">\u8BF7\u9009\u62E9</option></select></td><td style="text-align: center"><input type="text" class="c-input2" ng-model="vm.minValue" style="width: 80px"> <span ng-if="vm.isOperator">\u81F3</span> <input type="text" class="c-input2" ng-model="vm.maxValue" style="width: 80px" ng-if="vm.isOperator"></td><td style="text-align: center"><input type="text" class="c-input2" ng-model="vm.data.quantity" style="width: 80px"></td></tr></tbody></table></div><div class="mtop20"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/product/finished/modal/supplies.html','<div class="bgc-fff p30" style="padding-bottom: 0"><div class="clearfix"><span class="title1">\u9009\u62E9{{categoryInfo(vm.category)}}</span><div class="pull-right"><div class="form-search clearfix" style="float: left; margin-left: 15px"><!-- <input type="text" class="c-input1 pull-left" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u3002" ng-model="vm.tableData.keyword">\n                <button type="button" ng-click="search()"></button> --></div></div></div><div class="mtop20"><div class="c-form" style="position: relative"><div class="c-form-label" style="width: 200px; height: 500px; text-align: left"><ul class="category scrollbar-main"><li><div class="category-title" ng-class="{\'categoryOn\': \'\' == vm.tableData.categoryId}" ng-click="categoryOne(\'\')"><span>\u5168\u90E8</span></div></li><li ng-repeat="data in vm.categoryList track by $index" ng-if="data.sort == \'accessories\'"><div class="category-title" ng-class="{\'categoryOn\': data.id == vm.tableData.categoryId}" ng-click="categoryOne(data)"><span title="{{data.name}}">{{data.name}}</span><div class="category-title-fr" ng-class="{\'rotateIcon\': !data.open}" ng-click="categoryTitle(data, $event)" ng-if="data.productCategoryVMS.length > 0"></div></div><div class="category-child" ng-if="!data.open"><div class="category-child-span" ng-repeat="itemChild in data.productCategoryVMS" ng-class="{\'categoryOn\': itemChild.id == vm.tableData.categoryId}" ng-click="categoryChild(itemChild)" title="{{itemChild.name}}">{{itemChild.name}}</div></div></li></ul></div><div class="c-form-div scrollbar-main" style="width: auto; height: 500px;overflow:auto;margin-left: 200px"><div class="c-table1"><table><thead><tr><th style="text-align: center">{{categoryInfo(vm.category)}}\u540D\u79F0</th><th style="text-align: center">\u7F16\u53F7</th><th style="text-align: center">\u5355\u4F4D</th><th style="text-align: center">\u521B\u5EFA\u65E5\u671F</th></tr></thead><tbody><tr ng-repeat="data in vm.tableList track by $index" ng-click="tableCb(data)" ng-class="{\'tableOn\': data.id == vm.data.id}"><td style="text-align: center">{{data.sku}}</td><td style="text-align: center">{{data.number}}</td><td style="text-align: center">{{data.measurementName}}</td><td style="text-align: center">{{data.createdDate | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div><div class="c-paging"><div class="c-paging1"><span>\u6709{{vm.queryCount}}\u6761\u8BB0\u5F55</span> <span>\u5171{{vm.pagecount}}\u9875</span><!--                        <span>\u6BCF\u9875<b>{{vm.tableData.size}}</b>\u6761\u6570\u636E</span>--></div><div id="paging" class="c-paging2"></div></div></div><div class="mtop20 text-center"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()">\u786E\u8BA4</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div></div>');
$templateCache.put('app/setting/channel/province/province.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u504F\u8FDC\u5730\u533A</span></div><div class="mtop20"><div><ul class="clearfix"><li ng-repeat="data in vm.provinces track by $index" style="float: left; width: 120px; height: 35px; line-height: 35px; text-align: left; margin: 0 15px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"><label><input type="checkbox" ng-model="data.selected" ng-click="permissionsSelect(data)"> <span title="{{data.name}}">{{data.name}}</span></label></li></ul><div class="c-form" style="padding-top: 20px"><label class="c-form-label">\u504F\u8FDC\u5730\u533A\u8FD0\u8D39\uFF1A</label><div class="c-form-div wid-800"><input type="number" maxlength="10" min="0" class="c-input1" style="width: 150px" placeholder="\u8BF7\u8F93\u5165\u8FD0\u8D39" ng-model="vm.freight"> \u5143</div></div></div><div style="text-align: center; margin-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSavingEdit" ng-if="!vm.data.state">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/setting/express/province/province.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u504F\u8FDC\u5730\u533A</span></div><div class="mtop20"><div><ul class="clearfix"><li ng-repeat="data in vm.provinces track by $index" style="float: left; width: 120px; height: 35px; line-height: 35px; text-align: left; margin: 0 15px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"><label><input type="checkbox" ng-model="data.selected" ng-click="permissionsSelect(data)"> <span title="{{data.name}}">{{data.name}}</span></label></li></ul></div><div style="text-align: center; margin-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSavingEdit" ng-if="!vm.data.state">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');
$templateCache.put('app/setting/express/province/province1.html','<div class="bgc-fff p30"><div class="clearfix"><span class="title1">\u53EF\u53D1\u8D27\u5730\u533A</span></div><div class="mtop20"><div style="height: 400px; overflow: auto"><table class="c-province"><tr ng-repeat="data in vm.provinces track by $index"><td style="width: 150px"><label><input type="checkbox" ng-model="data.selected" ng-click="provinceSelect(data,$event)"> <span title="{{data.name}}">{{data.name}}</span></label></td><td><label ng-repeat="city in data.cities" style="margin: 0 5px"><input type="checkbox" ng-model="city.selected" ng-click="citySelect(data,city,$event)"> <span title="{{city.name}}">{{city.name}}</span></label></td></tr></table></div><div style="text-align: center; margin-top: 20px"><button type="button" class="c-btn c-btn1 mr10" ng-click="save()" ng-disabled="vm.isSavingEdit" ng-if="!vm.data.state">\u786E\u5B9A</button> <button type="button" class="c-btn c-btn2" ng-click="modalHide()">\u53D6\u6D88</button></div></div></div>');}]);})();